const VillagesDummyData = [
  {
    bridge_name: 'Bukinga',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1009317',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: -2.760833,
    bridge_opportunity_gps_longitude: 29.488056,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: null,
    bridge_opportunity_individuals_directly_served: null,
    bridge_opportunity_comments: 'Steep slopes to deal with for anchors',
    form_form_name: 'Project Assessment - 2018.10.10',
    form_created_by: 'aimablengirabakunzi taroworks',
    proposed_bridge_location_gps_latitude: -2.760833,
    proposed_bridge_location_gps_longitude: 29.488056,
    current_crossing_method: null,
    nearest_all_weather_crossing_point: null,
    days_per_year_river_is_flooded: null,
    flood_duration_during_rainy_season: null,
    market_access_blocked_by_river: null,
    education_access_blocked_by_river: null,
    health_access_blocked_by_river: null,
    other_access_blocked_by_river: null,
    primary_occupations: null,
    primary_crops_grown: null,
    river_crossing_deaths_in_last_3_years: null,
    river_crossing_injuries_in_last_3_years: null,
    incident_descriptions: null,
    notes_on_social_information: null,
    cell_service_quality: null,
    'four_wd _accessibility': null,
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: null,
    bridge_classification: null,
    flag_for_rejection: 'Yes',
    rejection_reason:
      'There is a planned vehicular road with a vehicular bridge on this site',
    bridge_type: null,
    estimated_span_m: null,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: null,
    bridge_opportunity_casesafeid: '006f100000asFErAAM',
    country: 'Rwanda',
    good_site: 0,
  },
  {
    bridge_name: 'Kagarama',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1007325',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Western Province',
    bridge_opportunity_level2_government: 'Nyamasheke',
    bridge_opportunity_gps_latitude: -2.322534,
    bridge_opportunity_gps_longitude: 29.141944,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 48,
    bridge_opportunity_individuals_directly_served: 4000,
    bridge_opportunity_comments: null,
    form_form_name: 'Project Assessment - 2017.7.12',
    form_created_by: 'Stephanie May',
    proposed_bridge_location_gps_latitude: -2.322534,
    proposed_bridge_location_gps_longitude: 29.141944,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: '2 km',
    days_per_year_river_is_flooded: 120,
    flood_duration_during_rainy_season: '12hours',
    market_access_blocked_by_river:
      'Schools, hospital, markets and government services',
    education_access_blocked_by_river: null,
    health_access_blocked_by_river: null,
    other_access_blocked_by_river: null,
    primary_occupations: 'farming',
    primary_crops_grown: 'banana',
    river_crossing_deaths_in_last_3_years: 2,
    river_crossing_injuries_in_last_3_years: 15,
    incident_descriptions:
      'the injuries and deaths are caused by trying fording the river on foot when the timber bridge is washed away and sometimes fall off from the timber bridge.',
    notes_on_social_information:
      'Most of the facilities locate at the left side of the river and this shows how the right side community is in the need of the safe bridge',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Kibogora-Kabuga',
    name_of_nearest_paved_or_sealed_road: 'Karongi-Nyamasheke',
    bridge_classification: null,
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: null,
    estimated_span_m: 10,
    height_differential_between_banks: 0.7,
    bridge_opportunity_general_project_photos: 'https://flic.kr/s/aHskvedfPB',
    bridge_opportunity_casesafeid: '006f100000a82QzAAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Karambi',
    bridge_opportunity_stage: 'Complete',
    bridge_opportunity_project_code: '1007374',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Huye',
    bridge_opportunity_gps_latitude: -2.513333,
    bridge_opportunity_gps_longitude: 29.612778,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 50,
    bridge_opportunity_individuals_directly_served: 12500,
    bridge_opportunity_comments:
      'Likely piloting steel decking on this bridge. 6000-10000 people directly served, Elevation:1630m, Cell:Karambi-Gasumba, Injuries/Death-many peoples injured while trying to cross the river/ 2 peoples died while trying to cross the river Cross river on a normal day->600 people, Nearby city centers--Karambi -Nyamagabe, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.06m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.',
    form_form_name: 'Project Assessment - 2018.7.27',
    form_created_by: 'etiennemutebutsi taroworks',
    proposed_bridge_location_gps_latitude: null,
    proposed_bridge_location_gps_longitude: null,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: '5 km',
    days_per_year_river_is_flooded: 60,
    flood_duration_during_rainy_season: '1day',
    market_access_blocked_by_river:
      'Markets,farms blocked by this river both sides',
    education_access_blocked_by_river:
      'Education blocked by this river both sides',
    health_access_blocked_by_river:
      'Health services blocked by this river both sides',
    other_access_blocked_by_river:
      'Potable water, places of worship ,places for recreation blocked by this river both sides',
    primary_occupations: 'Farming and small business',
    primary_crops_grown: 'banana, bean, corn',
    river_crossing_deaths_in_last_3_years: 3,
    river_crossing_injuries_in_last_3_years: 15,
    incident_descriptions:
      'Peoples dead when coming from the church, health center and markets',
    notes_on_social_information:
      '5 cells (kabuye,gasumba,kanyinya, buremera and shanga) as the directly served comminity. Community from Nyaruguru district coming to the market.',
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Never',
    name_of_nearest_city: 'Nyamagabe',
    name_of_nearest_paved_or_sealed_road: 'Huye-Nyamagabe',
    bridge_classification: 'Standard',
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: 'Suspension',
    estimated_span_m: 45,
    height_differential_between_banks: 1,
    bridge_opportunity_general_project_photos: 'https://flic.kr/s/aHskbMF1Kr',
    bridge_opportunity_casesafeid: '006f100000a86DaAAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Rugeti',
    bridge_opportunity_stage: 'Complete',
    bridge_opportunity_project_code: '1007466',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyamagabe',
    bridge_opportunity_gps_latitude: -2.47640667,
    bridge_opportunity_gps_longitude: 29.4208,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 68,
    bridge_opportunity_individuals_directly_served: 4363,
    bridge_opportunity_comments:
      '3000-6000 people directly served, Elevation:2101m, Cell:Rugogwe, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Kizimyamuriro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is hard rock for one side and silt for the other side.',
    form_form_name: 'Project Assessment - 2018.9.1',
    form_created_by: 'aimablengirabakunzi taroworks',
    proposed_bridge_location_gps_latitude: -2.47640667,
    proposed_bridge_location_gps_longitude: 29.4208,
    current_crossing_method: 'Timber',
    nearest_all_weather_crossing_point: 'None',
    days_per_year_river_is_flooded: 60,
    flood_duration_during_rainy_season:
      'All time in April and May and it is rarely to see the river down during these months',
    market_access_blocked_by_river: 'Markets',
    education_access_blocked_by_river: 'Primary and Secondary schools',
    health_access_blocked_by_river: 'Health Center',
    other_access_blocked_by_river: 'Churches and Government offices',
    primary_occupations: 'Farming of large tea plantation, wheat farms',
    primary_crops_grown: 'bean, cow pea, sweet potato, tea, wheat',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 2,
    incident_descriptions: 'They slipped on trees and fall down in the river',
    notes_on_social_information:
      'Market 1( Minaga, Gishwati, Mujerenge, Gikungu, Tantamara, Kagano) Market 2 (Rugeti, Mwishyogwe, ) Secondary schools ( Gishwati, ) Primary school (Rugeti) Health Center (Minaga, Gishwati, Mujerenge, Gikungu, Tantamara, Kagano) This social survey is conducted with the help of local people and their leaders And the numbers given were based on the monthly census which is done in every cell The village of Tantamara, Mujerenge, Kagano, Gikungu are using this crossing regularly and their people were included in the total population',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Nyamagabe-Rusizi',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 47.4,
    height_differential_between_banks: 1.1,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157712369263133',
    bridge_opportunity_casesafeid: '006f100000a86F4AAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Nyakabuye - Nkomane',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1007495',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyamagabe',
    bridge_opportunity_gps_latitude: -2.233022,
    bridge_opportunity_gps_longitude: 29.57513,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 78,
    bridge_opportunity_individuals_directly_served: 2790,
    bridge_opportunity_comments:
      'Not Duplicate 500-1000 people directly served, Elevation:1522m, Cell:Gasave, Injuries/Death-Many peoples injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Rwesero -Giti -Butare, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.',
    form_form_name: 'Project Assessment - 2018.9.4',
    form_created_by: 'dominiquehabimana taroworks',
    proposed_bridge_location_gps_latitude: -2.233574,
    proposed_bridge_location_gps_longitude: 29.575366,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: '5 kilometers',
    days_per_year_river_is_flooded: 35,
    flood_duration_during_rainy_season:
      'April To May, September to December, 12 hours after rain they can cross',
    market_access_blocked_by_river:
      'Birambo market, Gasura market, kirinda market( villages 1,2), farms(1,2,3,4,5)',
    education_access_blocked_by_river: 'Groupe scholar Gasave( 1,2)',
    health_access_blocked_by_river: 'Kirinda Hospital(villages 1,2)',
    other_access_blocked_by_river: 'None',
    primary_occupations: 'Farming',
    primary_crops_grown: 'bean, cassava, maiz, sorghum, sweet potato',
    river_crossing_deaths_in_last_3_years: 4,
    river_crossing_injuries_in_last_3_years: 4,
    incident_descriptions: 'Fell down and drowned',
    notes_on_social_information:
      "The population information of all adjacent communities member was given by the villages' leader, though call made by Nyakabuye village leader.",
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Never',
    name_of_nearest_city: 'Nyanza',
    name_of_nearest_paved_or_sealed_road: 'Nyamagabe',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 90,
    height_differential_between_banks: 1.1,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157715088236617/page2',
    bridge_opportunity_casesafeid: '006f100000a86FXAAY',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Nyakabuye - Mwogo',
    bridge_opportunity_stage: 'Complete',
    bridge_opportunity_project_code: '1007507',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyamagabe',
    bridge_opportunity_gps_latitude: -2.233278,
    bridge_opportunity_gps_longitude: 29.576407,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 118,
    bridge_opportunity_individuals_directly_served: 2725,
    bridge_opportunity_comments:
      'Not Duplicate 3000-6000 people directly served, Elevation:1523m, Cell:Gasave-Rwesero, Bridge would connecting Nyamagabe-Ruhango, Injuries/Death-Many peoples injured while trying to cross the river/ More than 4peoples died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Masizi -Buhanda, Crossing River now-Swim / BarogaBoat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 20m.-The proposed bridge span is approximately 100m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides. <<On 25th March, 2019 _In the beginning of scaling, this site was rejected by the assessor thinking that it will be a very long span bridge out of B2P standard but having the plan to survey Nyakabuye - Nkomane over a joining river"Nkomane", this Nyakabuye - Mwogo site over Mwogo river was surveyed and found to be technically feasible. >>>',
    form_form_name: 'Project Assessment - 2018.9.4',
    form_created_by: 'dominiquehabimana taroworks',
    proposed_bridge_location_gps_latitude: -2.2333694,
    proposed_bridge_location_gps_longitude: 29.575727,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point: 'vehicular is in two hours walk away',
    days_per_year_river_is_flooded: 365,
    flood_duration_during_rainy_season: '2day',
    market_access_blocked_by_river:
      'People from Musange Sector particularly from Gasave cell are blocked by Mwogo river when going to Buhanda main market located in Ruhango District',
    education_access_blocked_by_river:
      'Students from Nyamagabe District/ Gasave cell would prefer studying to Rwesero primary and Secondary school if there is means of crossing since it is nearer than other school that they went to in their District',
    health_access_blocked_by_river:
      'there is no healthy access blocked by this river since there are healthy centers and hospitals for every side of the river',
    other_access_blocked_by_river:
      'social access is blocked because people for either side are not able to visit others live in different side',
    primary_occupations: 'Farming',
    primary_crops_grown: ', banana, bean, cassava, maiz, sweet potato',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 0,
    incident_descriptions:
      "Actually there is no reported incident or death for this site in last 3 years just because people could't try crossing in the rain season ; they prefer staying at their sides.",
    notes_on_social_information: null,
    cell_service_quality: 'Good',
    'four_wd _accessibility': null,
    name_of_nearest_city: 'Nyanza',
    name_of_nearest_paved_or_sealed_road: 'Nyanza - Kigali road',
    bridge_classification: 'Outside of current engineering scope',
    flag_for_rejection: 'Yes',
    rejection_reason:
      'There is river confluence 20m away that will block the people to use the bridge, in upstream there is stagnant of water as lake, it is beyond current engineering a scope (span 150m suspension bridge).',
    bridge_type: 'Suspension',
    estimated_span_m: 108,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157715088179852',
    bridge_opportunity_casesafeid: '006f100000a86FjAAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Rugwa',
    bridge_opportunity_stage: 'Confirmed',
    bridge_opportunity_project_code: '1007525',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyanza',
    bridge_opportunity_gps_latitude: -2.329779,
    bridge_opportunity_gps_longitude: 29.668688,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 48,
    bridge_opportunity_individuals_directly_served: 2015,
    bridge_opportunity_comments:
      '500-1000 people directly served, Elevation:1557m, Cell:Nyabinyenga, Injuries/Death--No person injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Cyabakamyi -Cyarwa, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.',
    form_form_name: 'Project Assessment - 2018.6.28',
    form_created_by: 'clementinemukashyaka taroworks',
    proposed_bridge_location_gps_latitude: -2.329779,
    proposed_bridge_location_gps_longitude: 29.668688,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point: '45 minutes',
    days_per_year_river_is_flooded: 24,
    flood_duration_during_rainy_season: '12 hours',
    market_access_blocked_by_river:
      'Rurangazi market and Mucubira Market ;these markets are in opposite directions',
    education_access_blocked_by_river:
      'There is Nyabinyenga primary schools and Secondary school on right side and Nyarusange primary school',
    health_access_blocked_by_river:
      'On both sides there are healthy posts so none is blocked by this river when going there',
    other_access_blocked_by_river:
      'There are Catholic and Adventist churches blocked by this river both are on right side',
    primary_occupations: 'Farming and animal keeping',
    primary_crops_grown: 'cassava, sorghum',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 0,
    incident_descriptions:
      'More than 10years 4 people died during rainy season and people have been fearing to cross there',
    notes_on_social_information:
      'Students and people who will be accessing to markets',
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Never',
    name_of_nearest_city: 'Nyarusange',
    name_of_nearest_paved_or_sealed_road: null,
    bridge_classification: 'Standard',
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 60,
    height_differential_between_banks: 0.4,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157669522087507',
    bridge_opportunity_casesafeid: '006f100000a86G1AAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Gatare',
    bridge_opportunity_stage: 'Under Construction',
    bridge_opportunity_project_code: '1007530',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Kigali',
    bridge_opportunity_level2_government: 'Nyarugenge',
    bridge_opportunity_gps_latitude: -1.94142,
    bridge_opportunity_gps_longitude: 30.034608,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 37,
    bridge_opportunity_individuals_directly_served: 2704,
    bridge_opportunity_comments:
      '6000-10000 people directly served, Elevation:1363m, Cell:Gatare-Nyamabuye, Bridge connects Nyarugenge-Gasabo, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Nyabugogo -Yanza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Timber-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 32m.-The level difference between two banks is 0.04m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.-The bridge site was formerly called Yanza.',
    form_form_name: 'Project Assessment - 2018.6.11',
    form_created_by: 'clementinemukashyaka taroworks',
    proposed_bridge_location_gps_latitude: -1.94142,
    proposed_bridge_location_gps_longitude: 30.034608,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: '40 minutes',
    days_per_year_river_is_flooded: 120,
    flood_duration_during_rainy_season: '3_7days',
    market_access_blocked_by_river: 'Nyabugogo market',
    education_access_blocked_by_river: 'Nzove primary school',
    health_access_blocked_by_river: 'Gatsata health center',
    other_access_blocked_by_river: null,
    primary_occupations: 'Commerce',
    primary_crops_grown: 'banana, cassava',
    river_crossing_deaths_in_last_3_years: 4,
    river_crossing_injuries_in_last_3_years: 3,
    incident_descriptions:
      'People loose stability while crossing and fall down in the river it does not matter on the flooding its because of destruction of the existing bridge',
    notes_on_social_information:
      "There 4 village in Gatsata tha use Yanza Bridge in their daily life and also students of Nzove Primary school , the community say that usually in rainy season Yanza river is impassable due to high flooding in that time the existing bridge don't serve them",
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Kigali',
    name_of_nearest_paved_or_sealed_road: 'Nyabugogo_Cyinyoni',
    bridge_classification: 'Standard',
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 4,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/gp/bridgestoprosperity/0uMG24',
    bridge_opportunity_casesafeid: '006f100000a86G6AAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Rukarakara',
    bridge_opportunity_stage: 'Under Construction',
    bridge_opportunity_project_code: '1007535',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: -2.7761,
    bridge_opportunity_gps_longitude: 29.464528,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 58,
    bridge_opportunity_individuals_directly_served: 11283,
    bridge_opportunity_comments:
      'Span in Needs Assessment: 57m; 3000-6000 people directly served, Elevation:2153m, Cell:Remera-Ruyenzi, Injuries/Death-Many peoples injured while trying to cross the river/ One person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Gisanze -Remera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 30m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for one side and hard rock for other side',
    form_form_name: 'Project Assessment - 2018.10.10',
    form_created_by: 'aimablengirabakunzi taroworks',
    proposed_bridge_location_gps_latitude: -2.7761,
    proposed_bridge_location_gps_longitude: 29.464528,
    current_crossing_method: 'Timber',
    nearest_all_weather_crossing_point: '6 km',
    days_per_year_river_is_flooded: 40,
    flood_duration_during_rainy_season:
      '40 times in April, May, October November and December and it lasts for 1day after rainfall',
    market_access_blocked_by_river:
      "Rukarakara, Rugote, Ruvuru, Yanze villages don't have access to Gatunda market Cyivugiza, Gitwa, Mutumba, Uwinyana villages don't have access to Gisanze market Cyivugiza, Gitwa, Mutumba, Uwinyana villages don't have access to Ruheru market",
    education_access_blocked_by_river:
      "Rukarakara, Rugote villages don't have access to Remera secondary school",
    health_access_blocked_by_river:
      "Cyivugiza, Gitwa, Mutumba, Uwinyana villages don't have access to Ruheru health center",
    other_access_blocked_by_river: 'Sector office',
    primary_occupations:
      'Farming of potatoes, maize, beans, sweet potatoes, wheat',
    primary_crops_grown: 'bean, maiz, potato, sweet potato, wheat',
    river_crossing_deaths_in_last_3_years: 4,
    river_crossing_injuries_in_last_3_years: 1,
    incident_descriptions: 'They slipped on trees and fall down in the river',
    notes_on_social_information:
      'The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell',
    cell_service_quality: 'Nonexistent',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Huye-Akanyaru',
    bridge_classification: null,
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: null,
    estimated_span_m: null,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: 'https://flic.kr/s/aHskNBGBNY',
    bridge_opportunity_casesafeid: '006f100000a86GBAAY',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Kabere',
    bridge_opportunity_stage: 'Under Construction',
    bridge_opportunity_project_code: '1007539',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: -2.697944,
    bridge_opportunity_gps_longitude: 29.446917,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 63,
    bridge_opportunity_individuals_directly_served: 6335,
    bridge_opportunity_comments:
      'Span in Needs Assessment: 13m; 1000-3000 people directly served, Elevation:1951m, Cell:Kabere-Nyabimata, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Mpuza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 28m.-The level difference between two banks is 2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is hard rock for both sides.',
    form_form_name: 'Project Assessment - 2018.9.28',
    form_created_by: 'theodornishimwe taroworks',
    proposed_bridge_location_gps_latitude: -2.697944,
    proposed_bridge_location_gps_longitude: 29.446917,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point: '3 hours',
    days_per_year_river_is_flooded: 180,
    flood_duration_during_rainy_season: '2 days',
    market_access_blocked_by_river:
      "Communities 1don't have access to Kamirabagenzi, communities 2,3,4,5 don't have access to Tea plantation farms",
    education_access_blocked_by_river:
      "Communities 1 don't have access to Nyabimata primary and secondary school",
    health_access_blocked_by_river:
      "Communities don't have access to Nyabimata Health center",
    other_access_blocked_by_river:
      "Communitie 1 s don't have access to Nyabimata Parish",
    primary_occupations:
      'Tea plantation workers of Nshili_Kivu tea factory, traders at Kamirabagenzi market and daily farmers on both sides',
    primary_crops_grown: 'maiz, tea plantation, wheat',
    river_crossing_deaths_in_last_3_years: 5,
    river_crossing_injuries_in_last_3_years: 24,
    incident_descriptions:
      'From last three 3 years, 5 died trying to cross the river and drowned and around 24 or more fell into the river, some lost their shoes and luggage but no serious injuries happened',
    notes_on_social_information:
      'Kamirabagenzi market which is open twice a week (Community 1); Tea plantation farms ( Community2,3,4 );Nyabimata health center ( Community 1), Nyabimata primary and secondary school, Nyabimata Parish ( Community 1), Nyabimata SACCO office(Community1 ), Nyabimata Sector office( community1 ).',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': 'Year Round',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Kigali-Huye',
    bridge_classification: null,
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: null,
    estimated_span_m: null,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: null,
    bridge_opportunity_casesafeid: '006f100000a86GFAAY',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Runyani',
    bridge_opportunity_stage: 'Under Construction',
    bridge_opportunity_project_code: '1007544',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: -2.71578,
    bridge_opportunity_gps_longitude: 29.67607,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 85,
    bridge_opportunity_individuals_directly_served: 5421,
    bridge_opportunity_comments:
      '500-1000 people directly served, Elevation:1591m, Cell:Yaramba, Injuries/Death-More peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Yaramba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.',
    form_form_name: 'Project Assessment - 2018.10.29',
    form_created_by: 'theodornishimwe taroworks',
    proposed_bridge_location_gps_latitude: -2.71578,
    proposed_bridge_location_gps_longitude: 29.67607,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point: '0.6 km',
    days_per_year_river_is_flooded: 121,
    flood_duration_during_rainy_season: '6 hours',
    market_access_blocked_by_river:
      "Communities 2,4,5 don't have access to Busoro market",
    education_access_blocked_by_river:
      "Communities 2,4,5 don't have access to Runyami Primary school and Murama secondary schools and communities 1,3 don't have access to Yaramba school",
    health_access_blocked_by_river:
      "Communities 2,4,5 don't have access to Ngera Health center",
    other_access_blocked_by_river:
      "Communities 2,4,5 don't have access to Ngera sector office",
    primary_occupations: 'Daily farmers of coffee and traders at Busoro market',
    primary_crops_grown: 'bean, coffe, maiz, sweet potato',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 0,
    incident_descriptions: null,
    notes_on_social_information:
      'Busoro market which is open twice a week ( village 2,4,5); Ngera Health center ( village 2,4,5), Murama and Runyami school( village ) ;Yaramba school( village 1,3) , Ngera sector office ( village 2,4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in June',
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Never',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Huye - Akanyaru',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspension',
    estimated_span_m: 50,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157712688008003',
    bridge_opportunity_casesafeid: '006f100000a86GKAAY',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Agatare',
    bridge_opportunity_stage: 'Under Construction',
    bridge_opportunity_project_code: '1007563',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: -2.69808,
    bridge_opportunity_gps_longitude: 29.54557,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 96,
    bridge_opportunity_individuals_directly_served: 4515,
    bridge_opportunity_comments:
      '6000-10000 people directly served, Elevation:1773m, Cell:Ngarurira-Nyange, Injuries/Death-Many peoples injured while trying to cross the river/ 2 peoples died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Ndago, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 25m.-The proposed bridge span is approximately 100m.-The level difference between two banks is 1.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for both sides.',
    form_form_name: 'Project Assessment - 2018.9.28',
    form_created_by: 'theodornishimwe taroworks',
    proposed_bridge_location_gps_latitude: -2.69808,
    proposed_bridge_location_gps_longitude: 29.54557,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: '750 m',
    days_per_year_river_is_flooded: 120,
    flood_duration_during_rainy_season: '5 days',
    market_access_blocked_by_river:
      "Communities 2 don't have access to Ndago, Kamirabagenzi markets",
    education_access_blocked_by_river:
      "Communities2 don't have access to Nyarushishi school",
    health_access_blocked_by_river:
      "Communities 1don't have access to Munini Hospital and Health center,",
    other_access_blocked_by_river:
      "Communities 2don't have access to Kibeho Parish and Holy place",
    primary_occupations:
      'Tea plantation workers, farmers on both sides and traders at',
    primary_crops_grown: 'bean, potato, tea plantation',
    river_crossing_deaths_in_last_3_years: 1,
    river_crossing_injuries_in_last_3_years: 5,
    incident_descriptions:
      'Five people were injured when trying to cross the river and unfortunately, one died.',
    notes_on_social_information:
      'Munini Hospital ( Community1 ), Munini health center ( community 2), Nyarushishi school ( Community2 ), Tea plantations farms ( Community 2 ), Kibeho Holy place and Parish( community2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018',
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Year Round',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Kigali_Huye',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspension',
    estimated_span_m: 67.5,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157712686927146',
    bridge_opportunity_casesafeid: '006f100000a86GdAAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Gisoro',
    bridge_opportunity_stage: 'Prospecting',
    bridge_opportunity_project_code: '1007572',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: -2.7891,
    bridge_opportunity_gps_longitude: 29.56721,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 82,
    bridge_opportunity_individuals_directly_served: 17400,
    bridge_opportunity_comments:
      '3000-6000 people directly served, Elevation:1676m, Cell:Muhambara-Nteko, Injuries/Death--Many peoples injured while trying to cross/ Two peples died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Kubitiro -Rebero, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.',
    form_form_name: 'Project Assessment - 2018.10.10',
    form_created_by: 'aimablengirabakunzi taroworks',
    proposed_bridge_location_gps_latitude: -2.7891,
    proposed_bridge_location_gps_longitude: 29.56721,
    current_crossing_method: 'Timber',
    nearest_all_weather_crossing_point: '10',
    days_per_year_river_is_flooded: 60,
    flood_duration_during_rainy_season:
      '30 times in April, May, October, November and December and it lasts for 2days',
    market_access_blocked_by_river:
      "Nteko and Kirarangombe cells don't have access to Viro market nkakwa cell doesn't have access to Gatunda market",
    education_access_blocked_by_river:
      "Kirarangombe and Nteko cells don't have access to Cyahinda Secondary school",
    health_access_blocked_by_river: null,
    other_access_blocked_by_river: null,
    primary_occupations: 'Farming of sweet potatoes, cassava, beans, sorghum',
    primary_crops_grown: 'bean, cassava, sorghum, sweet potato',
    river_crossing_deaths_in_last_3_years: 6,
    river_crossing_injuries_in_last_3_years: 20,
    incident_descriptions: 'They slipped on trees and fall down in the river',
    notes_on_social_information:
      'The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell.',
    cell_service_quality: 'Nonexistent',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Huye-Akanyaru',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 87,
    height_differential_between_banks: 0.1,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157712686321187/with/49390764808/',
    bridge_opportunity_casesafeid: '006f100000a86GmAAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Ryakanyamiganda',
    bridge_opportunity_stage: 'Prospecting',
    bridge_opportunity_project_code: '1007580',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: 2.79415,
    bridge_opportunity_gps_longitude: 29.6986,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 35,
    bridge_opportunity_individuals_directly_served: 4295,
    bridge_opportunity_comments:
      'Not a duplicate 3000-6000 people directly served, Elevation:1506m, Cell:Nyamirama, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Gihembe -Kabuga -Rwamiko, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas-The soil from the site is silt for both sides.',
    form_form_name: 'Project Assessment - 2018.10.10',
    form_created_by: 'aimablengirabakunzi taroworks',
    proposed_bridge_location_gps_latitude: 2.79415,
    proposed_bridge_location_gps_longitude: 29.6986,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point: '2 km',
    days_per_year_river_is_flooded: 35,
    flood_duration_during_rainy_season:
      '35times in April,May, October November and December and it lasts 8hours after rainfall',
    market_access_blocked_by_river:
      "Sare, urugogwe, Cyumba, Rwamiko and Urutoye villages don't have access to Viro market Akabuye, Ryakanyamiganda and Bihembe villages don't have access to Nyaruteja market",
    education_access_blocked_by_river:
      "Sare, urugogwe, Cyumba, Rwamiko and Urutoye villages don't have access to Bihembe primary school Sare, urugogwe, Cyumba, Rwamiko and Urutoye villages don't have access to Fugi Secondary school Akabuye, Ryakanyamiganda and Bihembe villages don't have access to Higiro Secondary school",
    health_access_blocked_by_river:
      "Akabuye, Ryakanyamiganda and Bihembe villages don't have access to Rwamiko Health post Sare, urugogwe, Cyumba, Rwamiko and Urutoye villages don't have access to Ngoma Health Center",
    other_access_blocked_by_river: null,
    primary_occupations: 'Farming of maize, beans, sweet potatoes, coffee',
    primary_crops_grown: 'bean, coffe, maiz, sweet potato',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 40,
    incident_descriptions:
      'They are drawn while trying to walk in the river for crossing',
    notes_on_social_information:
      'The villages of Cyumba, Urutoye, and Urugogwe are using this crossing regularly and their people were included in the total population to be served The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Huye-Akanyaru',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 45.8,
    height_differential_between_banks: 0.3,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157712687924773/with/49391314056/',
    bridge_opportunity_casesafeid: '006f100000a86GuAAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Mutugezi',
    bridge_opportunity_stage: 'Prospecting',
    bridge_opportunity_project_code: '1010425',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Ruhango',
    bridge_opportunity_gps_latitude: -2.12013889,
    bridge_opportunity_gps_longitude: 29.66583333,
    bridge_opportunity_bridge_type: null,
    bridge_opportunity_span_m: null,
    bridge_opportunity_individuals_directly_served: 0,
    bridge_opportunity_comments:
      'It is a ditch which is deeper on a vehicular road',
    form_form_name: 'Project Pre-Assessment - 2018.8.24',
    form_created_by: 'Kyle Shirley',
    proposed_bridge_location_gps_latitude: null,
    proposed_bridge_location_gps_longitude: null,
    current_crossing_method: null,
    nearest_all_weather_crossing_point: null,
    days_per_year_river_is_flooded: null,
    flood_duration_during_rainy_season: null,
    market_access_blocked_by_river: null,
    education_access_blocked_by_river: null,
    health_access_blocked_by_river: null,
    other_access_blocked_by_river: null,
    primary_occupations: null,
    primary_crops_grown: null,
    river_crossing_deaths_in_last_3_years: null,
    river_crossing_injuries_in_last_3_years: null,
    incident_descriptions: null,
    notes_on_social_information: null,
    cell_service_quality: null,
    'four_wd _accessibility': null,
    name_of_nearest_city: null,
    name_of_nearest_paved_or_sealed_road: null,
    bridge_classification: null,
    flag_for_rejection: 'Yes',
    rejection_reason:
      'Community is requesting a vehicle bridge over a ditch crossing the road',
    bridge_type: null,
    estimated_span_m: null,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: null,
    bridge_opportunity_casesafeid: '006f100000bgzlZAAQ',
    country: 'Rwanda',
    good_site: -1,
  },
  {
    bridge_name: 'Ruganza',
    bridge_opportunity_stage: 'Prospecting',
    bridge_opportunity_project_code: '1007590',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: -2.63522167,
    bridge_opportunity_gps_longitude: 29.45740167,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 44,
    bridge_opportunity_individuals_directly_served: 2183,
    bridge_opportunity_comments:
      '3000-6000 people directly served, Elevation:1961m, Cell:Cyanyirankora, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--kaganza -Kajwanga, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is hard rock for both sides.',
    form_form_name: 'Project Assessment - 2018.9.26',
    form_created_by: 'aimablengirabakunzi taroworks',
    proposed_bridge_location_gps_latitude: -2.63522167,
    proposed_bridge_location_gps_longitude: 29.45740167,
    current_crossing_method: 'Timber',
    nearest_all_weather_crossing_point: 'None',
    days_per_year_river_is_flooded: 60,
    flood_duration_during_rainy_season:
      '60 times in April, May, October, November and December and it lasts for 8hours after rainfall',
    market_access_blocked_by_river: 'Farms for potatoes',
    education_access_blocked_by_river:
      "Gakuta doesn't have access to Ruganza primary school",
    health_access_blocked_by_river: 'None',
    other_access_blocked_by_river: 'Cell office, church',
    primary_occupations: 'Forestation, charcoal production',
    primary_crops_grown: 'tre',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 6,
    incident_descriptions: 'When it is flooded the people are drawn',
    notes_on_social_information:
      'The people who uses this crossing are those Ruganza and Gakuta Villages and it is the only way the children can pass to access the Primary school in Ruganza cell. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Huye-Akanyaru',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspension',
    estimated_span_m: 60,
    height_differential_between_banks: 0.1,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157712686829556',
    bridge_opportunity_casesafeid: '006f100000a86H4AAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Gasyogogo',
    bridge_opportunity_stage: 'Identified',
    bridge_opportunity_project_code: '1007609',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Ruhango',
    bridge_opportunity_gps_latitude: -2.161944,
    bridge_opportunity_gps_longitude: 29.665556,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 31,
    bridge_opportunity_individuals_directly_served: 2685,
    bridge_opportunity_comments:
      "1000-3000 people directly served, Elevation:1575m, Cell:Kubutare, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Gafunzo -Karambo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between a flat areas.-The soil from the site is silt for both sides.During sites visit done in December 2017,Gashogogo bridge changed the name to Gasyogogo,50m of span and also the GPS has changed to 2° 9' 41.4''S ,29° 39' 56.2''E",
    form_form_name: 'Project Assessment - 2018.7.26',
    form_created_by: 'Solange Yandereye',
    proposed_bridge_location_gps_latitude: null,
    proposed_bridge_location_gps_longitude: null,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point: '20 minutes',
    days_per_year_river_is_flooded: null,
    flood_duration_during_rainy_season: '2 days',
    market_access_blocked_by_river:
      'People from Muyunzwe are blocked by this river when going to Umutara Market',
    education_access_blocked_by_river:
      "Primary students from Kubutare cell cross the river everyday when going to Muyunzwe Primary School, there is no school nearby on left side of the river also many students from Kinihira sectors they don't have 12 years basic Education nearby they cross the Kiryango river when going to Secondary school in Mwendo Sector",
    health_access_blocked_by_river: null,
    other_access_blocked_by_river:
      'People from Kubutare cell are blocked by the river when going to Rice collection Center',
    primary_occupations: 'Farming',
    primary_crops_grown: ', banana, ric',
    river_crossing_deaths_in_last_3_years: 10,
    river_crossing_injuries_in_last_3_years: 0,
    incident_descriptions:
      'some people tried crossing and finally became unable to cross',
    notes_on_social_information: null,
    cell_service_quality: null,
    'four_wd _accessibility': 'Year Round',
    name_of_nearest_city: 'Ruhango',
    name_of_nearest_paved_or_sealed_road: 'Road Kigali - Ruhango',
    bridge_classification: 'Standard',
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 31,
    height_differential_between_banks: 1.2,
    bridge_opportunity_general_project_photos: 'https://flic.kr/s/aHsmuZhNAP',
    bridge_opportunity_casesafeid: '006f100000a86HNAAY',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Minigo',
    bridge_opportunity_stage: 'Identified',
    bridge_opportunity_project_code: '1009064',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Western Province',
    bridge_opportunity_level2_government: 'Rubavu',
    bridge_opportunity_gps_latitude: -1.692028,
    bridge_opportunity_gps_longitude: 29.294444,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 36,
    bridge_opportunity_individuals_directly_served: 4300,
    bridge_opportunity_comments:
      'Bridge connecting Rugerero-Nyundo Sectors & Gisa-Kabilizi-Terimbere Cells',
    form_form_name: 'Project Assessment - 2017.9.27',
    form_created_by: 'Abbie Noriega',
    proposed_bridge_location_gps_latitude: -1.692028,
    proposed_bridge_location_gps_longitude: 29.294444,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: 'NYAMYIRI timber bridge',
    days_per_year_river_is_flooded: 90,
    flood_duration_during_rainy_season: '2hrs',
    market_access_blocked_by_river: null,
    education_access_blocked_by_river: null,
    health_access_blocked_by_river:
      'it is impossible to access medical services and police station during rain season',
    other_access_blocked_by_river: null,
    primary_occupations: 'commerce and agriculture and human-powered transport',
    primary_crops_grown: ', , bean, maiz, vegetabl',
    river_crossing_deaths_in_last_3_years: 1,
    river_crossing_injuries_in_last_3_years: 8,
    incident_descriptions:
      "there are empty spaces is the bridge's deck and some spared parts of the deck ,people should hit on that and then falls down",
    notes_on_social_information:
      'this bridge will serve two sectors NYUNDO &RUGERERO',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': null,
    name_of_nearest_city: 'RUGERERO',
    name_of_nearest_paved_or_sealed_road: 'RUBAVU-MUSANZE',
    bridge_classification: null,
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: null,
    estimated_span_m: null,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/gp/bridgestoprosperity/hUM83D',
    bridge_opportunity_casesafeid: '006f100000aSNCPAA4',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Rukore',
    bridge_opportunity_stage: 'Identified',
    bridge_opportunity_project_code: '1009067',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Western Province',
    bridge_opportunity_level2_government: 'Rubavu',
    bridge_opportunity_gps_latitude: -1.746972,
    bridge_opportunity_gps_longitude: 29.370611,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 61.5,
    bridge_opportunity_individuals_directly_served: 170,
    bridge_opportunity_comments: null,
    form_form_name: 'Project Assessment - 2017.9.27',
    form_created_by: 'Abbie Noriega',
    proposed_bridge_location_gps_latitude: -1.746972,
    proposed_bridge_location_gps_longitude: 29.370611,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: null,
    days_per_year_river_is_flooded: 30,
    flood_duration_during_rainy_season: '8 hours',
    market_access_blocked_by_river: null,
    education_access_blocked_by_river: null,
    health_access_blocked_by_river: null,
    other_access_blocked_by_river:
      'the population travel for a long when they want collecting milk this leads to higly expensive milk',
    primary_occupations: 'commerce, agriculture and Human-Powered Transport',
    primary_crops_grown: ', , bean, maiz, pea, sweet potato',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 2,
    incident_descriptions:
      'as the citizens cross the river on one timber, these 2 peoples slide on them and get injoured',
    notes_on_social_information:
      'this bridge is locarted around GISHWATI national forest ,many citizens keep cows and milk production is avalable',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': null,
    name_of_nearest_city: 'MAHOKO',
    name_of_nearest_paved_or_sealed_road: 'RUBAVU-MUSANZE',
    bridge_classification: null,
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: null,
    estimated_span_m: null,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: 'https://flic.kr/s/aHsmeZ7tpn',
    bridge_opportunity_casesafeid: '006f100000aSNCSAA4',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Kazabe',
    bridge_opportunity_stage: 'Identified',
    bridge_opportunity_project_code: '1009068',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Western Province',
    bridge_opportunity_level2_government: 'Rubavu',
    bridge_opportunity_gps_latitude: -1.723639,
    bridge_opportunity_gps_longitude: 29.366194,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 46,
    bridge_opportunity_individuals_directly_served: 4100,
    bridge_opportunity_comments:
      'Previously called Kutangi; Bridge connecting Nyundo-Kanama Sectors & Kigarama-Musabike Cells',
    form_form_name: 'Project Assessment - 2017.9.30',
    form_created_by: 'Abbie Noriega',
    proposed_bridge_location_gps_latitude: null,
    proposed_bridge_location_gps_longitude: null,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: null,
    days_per_year_river_is_flooded: 45,
    flood_duration_during_rainy_season: '12 hours',
    market_access_blocked_by_river: null,
    education_access_blocked_by_river:
      'many students cross the river for accessing MUSABIKE Primay and secondary school; students don?t reach their schools especially when SEBEYA is flooded',
    health_access_blocked_by_river: null,
    other_access_blocked_by_river:
      'this brigde is between two hills with tea plantation and is around PFUNDA tea preparation Industry; and it is difficult for the population to access that industry',
    primary_occupations: 'commerce, agriculture and Human-Powered Transport',
    primary_crops_grown: ', , bean, maiz, sweet potato, tea',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 2,
    incident_descriptions:
      'as there timbers are so small, these 2 peoples slide on them and get injoured',
    notes_on_social_information: null,
    cell_service_quality: 'Fair',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'MAHOKO',
    name_of_nearest_paved_or_sealed_road: 'RUBAVU-MUSANZE',
    bridge_classification: null,
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: null,
    estimated_span_m: 46,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157694178832944',
    bridge_opportunity_casesafeid: '006f100000aSNCTAA4',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Ruharazi',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1009311',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Nyaruguru',
    bridge_opportunity_gps_latitude: -2.77676167,
    bridge_opportunity_gps_longitude: 29.62627167,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 45,
    bridge_opportunity_individuals_directly_served: 4959,
    bridge_opportunity_comments: null,
    form_form_name: 'Project Assessment - 2018.9.27',
    form_created_by: 'aimablengirabakunzi taroworks',
    proposed_bridge_location_gps_latitude: -2.77676167,
    proposed_bridge_location_gps_longitude: 29.62627167,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point: '10 km',
    days_per_year_river_is_flooded: 40,
    flood_duration_during_rainy_season:
      'Every time the rain falls, it is impossible to cross, at least 40times in April, May, October, November and December and it lasts for 3hours after rainfall',
    market_access_blocked_by_river:
      "Nkomero, Mwoya villages don't have access to Viro market",
    education_access_blocked_by_river:
      "Mwoya, Bwerankori, Nyagashubi, Agatovu, Muhombo and Nkomero villages don't have access to Nkakwe secondary school and Goal we primary school",
    health_access_blocked_by_river:
      "Mwoya, Bwerankori, Nyagashubi, Agatovu, Muhombo and Nkomero villages don't have access to Nkakwa Health Center",
    other_access_blocked_by_river: null,
    primary_occupations: 'Farming of cassava beans, banana, and Animal keeping',
    primary_crops_grown: 'banana, bean, cassava',
    river_crossing_deaths_in_last_3_years: 3,
    river_crossing_injuries_in_last_3_years: 5,
    incident_descriptions:
      'They were drawn in the river while it was flooded because there is no current crossing',
    notes_on_social_information:
      'The villages of Muhombo, Nkomero, Nyagashubi, Rarire, Bihembe, Nyarubuye, Rubuga are using the crossing regularly and their people were included in the total population to be served. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell.',
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Huye',
    name_of_nearest_paved_or_sealed_road: 'Huye-Akanyaru',
    bridge_classification: null,
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: null,
    estimated_span_m: null,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: 'https://flic.kr/s/aHsmxbtZ4b',
    bridge_opportunity_casesafeid: '006f100000asEzNAAU',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Rukurazo',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1009445',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Muhanga',
    bridge_opportunity_gps_latitude: -2.115072,
    bridge_opportunity_gps_longitude: 29.700843,
    bridge_opportunity_bridge_type: 'Suspension Bridge',
    bridge_opportunity_span_m: 49,
    bridge_opportunity_individuals_directly_served: 1210,
    bridge_opportunity_comments:
      'Unrejected by BAJ on 10-30-18. Rejected by Etienne Mutebutsi on 30-11-18 because all Muhanga Bridges (Cyuzu and Rukurazo) were replaced by Huye ones (Gahororo and Karambi)',
    form_form_name: 'Project Assessment - 2018.12.13',
    form_created_by: 'dominiquehabimana taroworks',
    proposed_bridge_location_gps_latitude: -2.115072,
    proposed_bridge_location_gps_longitude: 29.700843,
    current_crossing_method: 'Timber',
    nearest_all_weather_crossing_point:
      'Kanyarira suspended bridge constructed in 2016(-2.113596, 29.705712)',
    days_per_year_river_is_flooded: 30,
    flood_duration_during_rainy_season: 'April,May, 2 days',
    market_access_blocked_by_river:
      'Mutara market ( 1),ESE Cyusa mining activities( 1), farms ( 1).',
    education_access_blocked_by_river: 'Bisika primary school ( 1).',
    health_access_blocked_by_river: 'Kigarama health center ( 1)',
    other_access_blocked_by_river: 'Churches ( 1), bus stop ( 2).',
    primary_occupations: 'Farming and livestock',
    primary_crops_grown: 'cassava, sweet poatao',
    river_crossing_deaths_in_last_3_years: 2,
    river_crossing_injuries_in_last_3_years: 3,
    incident_descriptions: 'Fell down and drowned',
    notes_on_social_information:
      'The population information of each village was provided by village leader.',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': null,
    name_of_nearest_city: 'Muhanga',
    name_of_nearest_paved_or_sealed_road: 'Muhanga',
    bridge_classification: 'Requires additional engineering',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 44,
    height_differential_between_banks: 0.1,
    bridge_opportunity_general_project_photos:
      'https://www.flickr.com/photos/bridgestoprosperity/albums/72157711046357258',
    bridge_opportunity_casesafeid: '006f100000atwPzAAI',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Rwamamara',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1010941',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Western Province',
    bridge_opportunity_level2_government: 'Ngororero',
    bridge_opportunity_gps_latitude: -1.83113,
    bridge_opportunity_gps_longitude: 29.62303,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 58,
    bridge_opportunity_individuals_directly_served: 4200,
    bridge_opportunity_comments: null,
    form_form_name: 'Project Assessment - 2018.12.8',
    form_created_by: 'edouardumwanzuro taroworks',
    proposed_bridge_location_gps_latitude: -1.83113,
    proposed_bridge_location_gps_longitude: 29.62303,
    current_crossing_method: 'Timber',
    nearest_all_weather_crossing_point: 'None',
    days_per_year_river_is_flooded: 120,
    flood_duration_during_rainy_season: '4 days of flood',
    market_access_blocked_by_river:
      "Kageyo sector don't have access to Ngororero market",
    education_access_blocked_by_river:
      "Kageyo sector don't have access to GS Rususa , whereas Ngororero sector don't have access to GS Rurimba",
    health_access_blocked_by_river:
      "Kageyo sector don't have access to Rususa health center",
    other_access_blocked_by_river:
      "Some people from Ngororero sector don't have access to Kageyo sector services and also Kageyo population don't have acess to Ngororero District. At Ngororero side there are many churches blocked by this river",
    primary_occupations: 'Farming',
    primary_crops_grown: 'cassava, potato',
    river_crossing_deaths_in_last_3_years: 2,
    river_crossing_injuries_in_last_3_years: 5,
    incident_descriptions:
      'Timbers were not enough and two people were crossing and died here , other 5 injured',
    notes_on_social_information:
      'Gisiza village leader is the one who provided information about directly individual served by refering to the population census of 2018',
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Seasonally',
    name_of_nearest_city: 'Ngororero',
    name_of_nearest_paved_or_sealed_road: 'Ngororero - Kabaya',
    bridge_classification: 'Requires additional engineering',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspension',
    estimated_span_m: 80,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: 'https://flic.kr/s/aHsmEYpqEn',
    bridge_opportunity_casesafeid: '006f100000c5pcIAAQ',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Kazo',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1011307',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Western Province',
    bridge_opportunity_level2_government: 'Rutsiro',
    bridge_opportunity_gps_latitude: -1.77286,
    bridge_opportunity_gps_longitude: 29.37514,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 58,
    bridge_opportunity_individuals_directly_served: 12145,
    bridge_opportunity_comments: null,
    form_form_name: 'Project Assessment - 2018.12.10',
    form_created_by: 'cesarngenzi taroworks',
    proposed_bridge_location_gps_latitude: -1.77286,
    proposed_bridge_location_gps_longitude: 29.37514,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: 'None',
    days_per_year_river_is_flooded: 365,
    flood_duration_during_rainy_season: '365',
    market_access_blocked_by_river: 'Terimbere and mahoko',
    education_access_blocked_by_river: 'Kazo high school',
    health_access_blocked_by_river: 'Terimbere health center',
    other_access_blocked_by_river: 'None',
    primary_occupations: 'Farming',
    primary_crops_grown: 'maiz',
    river_crossing_deaths_in_last_3_years: 3,
    river_crossing_injuries_in_last_3_years: 4,
    incident_descriptions:
      'Community members are likely to fall in the river when it is flooded because the current bridge is dangerous',
    notes_on_social_information:
      "Gashihe village don't have access to kazo high school while kazo village don't have access to mahoko market Information gathered from local people",
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Never',
    name_of_nearest_city: 'Rubavu',
    name_of_nearest_paved_or_sealed_road: 'Rubavu-rubengera',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 53,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: null,
    bridge_opportunity_casesafeid: '006f100000cME57AAG',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Nkuna',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1011309',
    bridge_opportunity_needs_assessment: 'Rwanda Needs Assessment 2018',
    bridge_opportunity_level1_government: 'Western Province',
    bridge_opportunity_level2_government: 'Rutsiro',
    bridge_opportunity_gps_latitude: -1.763,
    bridge_opportunity_gps_longitude: 29.37679,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 78,
    bridge_opportunity_individuals_directly_served: 2699,
    bridge_opportunity_comments: null,
    form_form_name: 'Project Assessment - 2018.12.10',
    form_created_by: 'cesarngenzi taroworks',
    proposed_bridge_location_gps_latitude: -1.763,
    proposed_bridge_location_gps_longitude: 29.37679,
    current_crossing_method: 'Timber Bridge',
    nearest_all_weather_crossing_point: 'None',
    days_per_year_river_is_flooded: 365,
    flood_duration_during_rainy_season: null,
    market_access_blocked_by_river: 'Mahoko market',
    education_access_blocked_by_river: 'Kazo high school',
    health_access_blocked_by_river: 'Nyabirasi health center',
    other_access_blocked_by_river: 'None',
    primary_occupations: 'Farming',
    primary_crops_grown: 'maiz',
    river_crossing_deaths_in_last_3_years: 0,
    river_crossing_injuries_in_last_3_years: 5,
    incident_descriptions: 'People fall in tne wehn ot is flooded',
    notes_on_social_information:
      "Nkuna village don't have access to kazo school and rubavu market information gathered from local people",
    cell_service_quality: 'Good',
    'four_wd _accessibility': 'Never',
    name_of_nearest_city: 'Rubavu',
    name_of_nearest_paved_or_sealed_road: 'Rubavu-rubengera',
    bridge_classification: 'Standard',
    flag_for_rejection: 'No',
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 87,
    height_differential_between_banks: null,
    bridge_opportunity_general_project_photos: null,
    bridge_opportunity_casesafeid: '006f100000cME5HAAW',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Mugeri',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1012457',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Western Province',
    bridge_opportunity_level2_government: 'Rutsiro',
    bridge_opportunity_gps_latitude: -2.02408333,
    bridge_opportunity_gps_longitude: 29.41472222,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 63,
    bridge_opportunity_individuals_directly_served: 2734,
    bridge_opportunity_comments:
      'Galvanisation of fencing installed was questionnable. Fencing should be replaced as soon as an alternative supply has been sourced',
    form_form_name: 'Project Assessment - 2018.7.11',
    form_created_by: 'etiennemutebutsi taroworks',
    proposed_bridge_location_gps_latitude: -2.02408333,
    proposed_bridge_location_gps_longitude: 29.41472222,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point: '4 km',
    days_per_year_river_is_flooded: 120,
    flood_duration_during_rainy_season: '5 days',
    market_access_blocked_by_river: 'Rubengera market',
    education_access_blocked_by_river:
      'Miraramo students are blocked by this river when coming to Mushubati Secondary school, ther is no other secondary schoo which is close to them.',
    health_access_blocked_by_river:
      'People from Mushubati prefer going to Kibuye Hospital which is the closest one than Rutsiro District Hospital, so they get blocked especially in the rainy season',
    other_access_blocked_by_river:
      "People from Mukura sector cross this river when they are coming to Church, they currently don't have other places of worship",
    primary_occupations: 'Farming',
    primary_crops_grown: 'banana, potato, sorghum',
    river_crossing_deaths_in_last_3_years: 1,
    river_crossing_injuries_in_last_3_years: null,
    incident_descriptions:
      'A passenger slipped on the timber bridge and fall down and got drowned; this happens in 300 m upstream since there no safe bridge people cross anywhere.',
    notes_on_social_information: null,
    cell_service_quality: 'Fair',
    'four_wd _accessibility': 'Never',
    name_of_nearest_city: 'Rubengera',
    name_of_nearest_paved_or_sealed_road: 'Rubengera-Rubavu',
    bridge_classification: 'Standard',
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 63,
    height_differential_between_banks: 0.2,
    bridge_opportunity_general_project_photos: null,
    bridge_opportunity_casesafeid: '006f100000cPXEEAA4',
    country: 'Rwanda',
    good_site: 1,
  },
  {
    bridge_name: 'Serugeme',
    bridge_opportunity_stage: 'Rejected',
    bridge_opportunity_project_code: '1012480',
    bridge_opportunity_needs_assessment: null,
    bridge_opportunity_level1_government: 'Southern Province',
    bridge_opportunity_level2_government: 'Ruhango',
    bridge_opportunity_gps_latitude: -2.2280555556,
    bridge_opportunity_gps_longitude: 29.5733333333,
    bridge_opportunity_bridge_type: 'Suspended Bridge',
    bridge_opportunity_span_m: 87,
    bridge_opportunity_individuals_directly_served: 4111,
    bridge_opportunity_comments: null,
    form_form_name: 'Project Assessment - 2018.7.26',
    form_created_by: 'Solange Yandereye',
    proposed_bridge_location_gps_latitude: null,
    proposed_bridge_location_gps_longitude: null,
    current_crossing_method: 'None',
    nearest_all_weather_crossing_point:
      'the vehicular bridge is in 2 hr walk away',
    days_per_year_river_is_flooded: 330,
    flood_duration_during_rainy_season:
      "after analyzing how the site was during the middle of the dry season and how the community don't have anyhow to cross this river unless they swim it was not so easy for them to know how long the river takes to have its initial level since some who don't fear they swim when the river floods or not",
    market_access_blocked_by_river:
      'People from Nyakabuye village in Nyamagabe District their nearest main market is Buhanda one ,so mostly it is impossible to attend this market',
    education_access_blocked_by_river:
      'some students take the extra 1.5 hr. when going to study in high school and most people once arrived at the river they also travel a long journey seeking where they can be able to ford on foot may be where the river is having a little depth but on the other hand here the river became so wide',
    health_access_blocked_by_river:
      'Left side community is too isolated about health access since they travel ~2.5 hr on foot when going to healthy center contrary when they get a means of crossing they will have to walk for only 1.5 hr.',
    other_access_blocked_by_river: null,
    primary_occupations: null,
    primary_crops_grown: null,
    river_crossing_deaths_in_last_3_years: 8,
    river_crossing_injuries_in_last_3_years: 2,
    incident_descriptions:
      'some people try swimming and finally be unable to proceed mostly during the rainy season',
    notes_on_social_information:
      'this river prevents the collaboration between two families on both sides so once this bridge will be built the residents will be then able to visit others',
    cell_service_quality: 'Fair',
    'four_wd _accessibility': 'Never',
    name_of_nearest_city: 'Ruhango',
    name_of_nearest_paved_or_sealed_road: 'Road Kigali - Ruhango',
    bridge_classification: 'Standard',
    flag_for_rejection: null,
    rejection_reason: null,
    bridge_type: 'Suspended',
    estimated_span_m: 95,
    height_differential_between_banks: 0.7,
    bridge_opportunity_general_project_photos: 'https://flic.kr/s/aHsmsgP6qj',
    bridge_opportunity_casesafeid: '006f100000cPnOGAA0',
    country: 'Rwanda',
    good_site: 1,
  },
  //     {
  //       "bridge_name": "Gahororo",
  //       "bridge_opportunity_project_code": "1012501",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.621482,
  //       "bridge_opportunity_gps_longitude": 29.649033,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 72.3,
  //       "bridge_opportunity_individuals_directly_served": 7000,
  //       "bridge_opportunity_comments": "no bridge,people cross the river by a traditional boat <<< the coordinates were formerly -2,12113889, 29,61083333 latitude and longitude successively, they were showing other site over Nyabarongo river ,on 24th OCT,201>>>>",
  //       "form_form_name": "Project Assessment - 2018.7.27",
  //       "form_created_by": "etiennemutebutsi taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "There is no big market available in the closest villages to the bridge. People from the left side buy basic stuff from Karama Center on the right. The big market,Busoro is located further in the Gishamvu sector at the left side of the bridge.",
  //       "education_access_blocked_by_river": "At the left side there is GS Muhembe with 9-years basic education and GS Karama which has 12-years basic education. This means that the students from GS Muhembe who finalizes 3rd year of secondary is required to pursue his/her studies at GS Karama at the right side of the bridge.",
  //       "health_access_blocked_by_river": "Most people from the left side of the bridge attend regularly the Gahororo Health Center which is at the right side.",
  //       "other_access_blocked_by_river": "The bank and sector office are located at the right side of the bridge.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru border",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": "https://flic.kr/s/aHsmxtbVCB",
  //       "bridge_opportunity_casesafeid": "006f100000cPuuaAAC",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kiruri",
  //       "bridge_opportunity_project_code": "1012813",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.985833,
  //       "bridge_opportunity_gps_longitude": 29.40916,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 3290,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.985833,
  //       "proposed_bridge_location_gps_longitude": 29.40916,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 34,
  //       "flood_duration_during_rainy_season": "When it rains it takes three days flooded",
  //       "market_access_blocked_by_river": "Congo nile",
  //       "education_access_blocked_by_river": "Bisyo primary school and kabeza high school",
  //       "health_access_blocked_by_river": "Congo Nile health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "People fall while trying to cross",
  //       "notes_on_social_information": "Information gathered from bisyo village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rutsiro-kibuye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157711719811293",
  //       "bridge_opportunity_casesafeid": "006f100000d6kvTAAQ",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Gitikirema-kigarama",
  //       "bridge_opportunity_project_code": "1012817",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.304674,
  //       "bridge_opportunity_gps_longitude": 29.472585,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 68,
  //       "bridge_opportunity_individuals_directly_served": 2805,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.304674,
  //       "proposed_bridge_location_gps_longitude": 29.472585,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3hours after rainfall people can cross the river, flood season is April, May, September to november,",
  //       "market_access_blocked_by_river": "Mushubi market is blocked to the community from the RHS of river, Ruganda animals market is blocked to the RHS people, farming on both side.",
  //       "education_access_blocked_by_river": "Nyarusazi primary school in kaduha is blocked to the students from LHS of river, gasenyi primary school blocked to the students from Nyarusazi, Mushubi secondary school is blocked for students from kaduha on The RHS.",
  //       "health_access_blocked_by_river": "Yonde health center I in kaduha sector is blocked to the communities from LHS.",
  //       "other_access_blocked_by_river": "EAR church located on LHS is blocked, Catholic church in Mushubi is also blocked to the RHS PEOPLE, district services is also blocked.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "She was trying to cross the river and drowned",
  //       "notes_on_social_information": "Yonde Cell leader and people near the bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157712367690322",
  //       "bridge_opportunity_casesafeid": "006f100000d6kxFAAQ",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Nombe",
  //       "bridge_opportunity_project_code": "1009071",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.7056,
  //       "bridge_opportunity_gps_longitude": 29.30982,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": null,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2017.9.29",
  //       "form_created_by": "Abbie Noriega",
  //       "proposed_bridge_location_gps_latitude": -1.7056,
  //       "proposed_bridge_location_gps_longitude": 29.30982,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Pfunda bridge",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "there is a big community that crosses over this river for accesssing primary needs",
  //       "primary_occupations": "Agrobusiness and commerce",
  //       "primary_crops_grown": ", banana tre, bean, maiz, sugar can, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "due to rot timbers that are made the brigde, timbers break down and people falls in water. some get injured and one person died within this 3 years",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "PFUNDA",
  //       "name_of_nearest_paved_or_sealed_road": "RUBAVU-MUSANZE",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000aSNCWAA4",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gashyushya",
  //       "bridge_opportunity_project_code": "1012953",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.01211492,
  //       "bridge_opportunity_gps_longitude": 29.76212259,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 42,
  //       "bridge_opportunity_individuals_directly_served": 2200,
  //       "bridge_opportunity_comments": "Year-2 Site_Rejected because a vehicular Bridge planned to be constructed in the same site",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01211492,
  //       "proposed_bridge_location_gps_longitude": 29.76212259,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "3 days of flood",
  //       "market_access_blocked_by_river": "Gashyushya market",
  //       "education_access_blocked_by_river": "Murama ps and biringaga ps",
  //       "health_access_blocked_by_river": "Mata health center , kivumu health center",
  //       "other_access_blocked_by_river": "Muhanga district office , biringaga church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Some people fall in when they are crossing",
  //       "notes_on_social_information": "Mata health center ( Murama village ), Gashyushya market ( munini village ) , murama ps (munini village ) , population census of 2018 is the latest collection of these information for individual served the village leader of murama is the main source of info .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga-Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157711041916097/with/48875624238/",
  //       "bridge_opportunity_casesafeid": "006f100000d6wByAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kirumbi",
  //       "bridge_opportunity_project_code": "1012986",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.94833,
  //       "bridge_opportunity_gps_longitude": 29.493611,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 56,
  //       "bridge_opportunity_individuals_directly_served": 3294,
  //       "bridge_opportunity_comments": "Not Duplicate",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94833,
  //       "proposed_bridge_location_gps_longitude": 29.493611,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "It is always difficult to cross the river even in summer season people don't cross easily the river is always flooded",
  //       "market_access_blocked_by_river": "Birembo market",
  //       "education_access_blocked_by_river": "Ruronde primary school",
  //       "health_access_blocked_by_river": "Gakeri hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Mining and farming",
  //       "primary_crops_grown": "ibinyomoro",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They fell in when it was flooded but it due to people died when it is flooded no one now is allowed to cross",
  //       "notes_on_social_information": "Market (community 1,2,3). Sec school (none), health center (community 1). Farms (community 1,2 and 3). Population information for each village was provided by each village leader and they got data from census in 2017 July. [Ntegekurora Manuel kirumbi leader, nyiramanywa cell leader of kanyana ] Population of all adjacent communities includes the following villages: Mugobate, kirumbi, nyamubambwe and kanyana cell. Sometimes kanyana people do cross to visit their relatives twice a month or visit kabona market once a month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-rutsiro",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157711084230467",
  //       "bridge_opportunity_casesafeid": "006f100000d6wJrAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Uwumugeti-Kigusa",
  //       "bridge_opportunity_project_code": "1012997",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.540715,
  //       "bridge_opportunity_gps_longitude": 29.503838,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 55,
  //       "bridge_opportunity_individuals_directly_served": 2762,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.540715,
  //       "proposed_bridge_location_gps_longitude": 29.503838,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "60 times in March, April, May, October, November and December, it lasts for 1hour after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health post",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming, Commerce",
  //       "primary_crops_grown": "bean, maiz, sweet potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market(Biraro, Uwumugeti, Kigusa, Rukereko, Muhumo, Kigali, Ruhanga, Uwurunazi, Kibwije, Ryarubondo) Primary and Secondary schools(Kigusa, Gasenge, Kanserege) These values are given by the local people and their leaders based on monthly report given by each village leader. There are more villages which use this crossing to access the market and schools (Kibwije, Muhumo, Kigari, Ruhanga, Uwurunazi, Kanserege, Ryarubondo) but due to lack of space they are not mentioned in the form but their people were taken into consideration in the total population",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 81,
  //       "height_differential_between_banks": 4.3,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157715087855338",
  //       "bridge_opportunity_casesafeid": "006f100000d6wNyAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Rweru",
  //       "bridge_opportunity_project_code": "1013218",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.52565,
  //       "bridge_opportunity_gps_longitude": 29.568185,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 46,
  //       "bridge_opportunity_individuals_directly_served": 2670,
  //       "bridge_opportunity_comments": "BAJ Follow up with assessor.",
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.52565,
  //       "proposed_bridge_location_gps_longitude": 29.568185,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "50 times in April, May, October, November and December and it lasts 3 days after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices, churches",
  //       "primary_occupations": "Farming of maize, beans, coffee, banana,",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 8,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They walk through the river when they are trying to cross, and every time someone fails to reach the other side he dies.",
  //       "notes_on_social_information": "Market Karambi(Kigarama of Rususa, Baro, Bahina, Muhembe) Market Kamiro(Kigarama of Rususa, Baro, Bahina, Muhembe) Market Baro(Rweru, Gitwa, Kagarama, Kamiro) Primary ( Rweru) Secondary school (Kigarama of Rususa, Baro, Bahina, Muhembe) Health Center (Rweru, Gitwa, Kagarama, Kamiro) The numbers of the survey were given by the local people and their leaders based on the monthly census which is done in every cell. There are other villages(Kagarama, Kamiro, Muhembe) which uses this crossing regularly, they are not mentioned in the form but their population are included in the total population to be served",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": "The river is meandering and is creating zig zag curves all along its sides, you can check the site using aerial map, but I was able to set the tower location behind the meandering area",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 74.8,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157712652736878",
  //       "bridge_opportunity_casesafeid": "006f100000d75v6AAA",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kiciro",
  //       "bridge_opportunity_project_code": "1013351",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.05545934,
  //       "bridge_opportunity_gps_longitude": 29.64411986,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 33,
  //       "bridge_opportunity_individuals_directly_served": 5167,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05545934,
  //       "proposed_bridge_location_gps_longitude": 29.64411986,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "2hours of flood occurs during heavy rain",
  //       "market_access_blocked_by_river": "Rwigerero market , Rutaka market , Kabadaha market",
  //       "education_access_blocked_by_river": "GS Kiciro",
  //       "health_access_blocked_by_river": "Gikomero health center , kiciro Poste De Sante",
  //       "other_access_blocked_by_river": "Kiciro Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "People want to go to the other side , then they got catched and fall in,...",
  //       "notes_on_social_information": "Poste de Sante kiciro ( Gasharu village , Karucura village) , Kiciro Catholic church ( Gasharu village , Karucura village), Rutaka market ( Murambi village , kamanga village , Kiciro village ), kabadaha market( Murambi village , kamanga village , Kiciro village ), Rwigerero market ( Murambi village , kamanga village , Kiciro village ), Gikomero health center( Murambi village , kamanga village , Kiciro village ). Information of directly individual served were given by Musongati cell leader and she referred to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157711042969586/page1",
  //       "bridge_opportunity_casesafeid": "006f100000d7EZRAA2",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kivomo",
  //       "bridge_opportunity_project_code": "1013353",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -2.026616,
  //       "bridge_opportunity_gps_longitude": 29.57632,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 86,
  //       "bridge_opportunity_individuals_directly_served": 1768,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.10",
  //       "form_created_by": "kyleshirley taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.026616,
  //       "proposed_bridge_location_gps_longitude": 29.57632,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 Km",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "4 days",
  //       "market_access_blocked_by_river": "People from Ndaro sector are blocked by this river when going to Nyange market",
  //       "education_access_blocked_by_river": "Students from Bitabajye and kibanda cells are blocked by this river when going to Vuganyana primary and secondary school",
  //       "health_access_blocked_by_river": "People from Bitabajye and Kibanda cells need to cross this river when going to Nyange health center and Karongi Hospital",
  //       "other_access_blocked_by_river": "People from left side(Ndaro) of the river blocked by this river when coming to Nyange Catholic parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": ", banana, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "KARONGI",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 90,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157709557919546",
  //       "bridge_opportunity_casesafeid": "006f100000d7EatAAE",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Mutugezi",
  //       "bridge_opportunity_project_code": "1010426",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.11994444,
  //       "bridge_opportunity_gps_longitude": 29.66611111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "It is a ditch on a vehicular road, when they were constructing that road, they faced with an obstacle of a big rock. On top of that ditch there is simple timber that help the community to pass.",
  //       "form_form_name": "Project Pre-Assessment - 2018.8.24",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community is requesting a vehicle bridge over a ditch crossing the road",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bh0EZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivugiza",
  //       "bridge_opportunity_project_code": "1013457",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.94955,
  //       "bridge_opportunity_gps_longitude": 29.56793,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 53,
  //       "bridge_opportunity_individuals_directly_served": 2656,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94955,
  //       "proposed_bridge_location_gps_longitude": 29.56793,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 82,
  //       "flood_duration_during_rainy_season": "7 hours of flood",
  //       "market_access_blocked_by_river": "Gitonde village, gasasa village, rutembo village and Mukingi village don't have access to KAYEBE MARKET while gitarama village ,kurushishi village and bereshi village don't have access to BIREMBO MARKET",
  //       "education_access_blocked_by_river": "Gitonde village, gasasa village, rutembo village and Mukingi village don't have access to GS RUSEBEYA, while gitarama village ,kurushishi village and bereshi village don't have access to BIREMBO MARKET",
  //       "health_access_blocked_by_river": "Gitonde village, gasasa village, rutembo village and Mukingi village don't have access to FOSSACOM BUNGWE",
  //       "other_access_blocked_by_river": "Gitonde village, gasasa village, rutembo village and Mukingi village don't have access to BWIRA SECTOR OFFICE",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "A kid of 7 years",
  //       "notes_on_social_information": "Kabarondo cell leader is the one who gave me information about directly individual served as he is a cell leader many of his villages are using the bridge , he made calls for all village leaders to confirm their population, they referred to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157712686144892",
  //       "bridge_opportunity_casesafeid": "006f100000d7PrBAAU",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Buhito",
  //       "bridge_opportunity_project_code": "1013541",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.81792,
  //       "bridge_opportunity_gps_longitude": 29.54411,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 33,
  //       "bridge_opportunity_individuals_directly_served": 2335,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.81792,
  //       "proposed_bridge_location_gps_longitude": 29.54411,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Rubambiro and kabeza village don't have access to Gasiza",
  //       "education_access_blocked_by_river": "Gisebeya and Ntaruko village don't have access to GS mwendo ,rubambiro village don't have access to GS gasiza",
  //       "health_access_blocked_by_river": "Ntaruko village don't have access to kabaya hospital",
  //       "other_access_blocked_by_river": "Kabeza and rubambiro dont have acess to Muhanda sector office , ntaruko village don't have access to kabaya sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Old men",
  //       "notes_on_social_information": "Mwendo cell leader has given me information about individual served by calling village leaders to confirm their population they referred to the population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira _ Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157712686806667",
  //       "bridge_opportunity_casesafeid": "006f100000d7aygAAA",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Rwinyoni",
  //       "bridge_opportunity_project_code": "1013641",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.80169,
  //       "bridge_opportunity_gps_longitude": 29.29776,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 1641,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.80169,
  //       "proposed_bridge_location_gps_longitude": 29.29776,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Rwinyoni market",
  //       "education_access_blocked_by_river": "Rwinyoni primary schools and gahondo secondary school",
  //       "health_access_blocked_by_river": "Karambi health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "sugarcan",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "A women fell in the river when it was flooded as there is no bridge she passed through the river and river took him",
  //       "notes_on_social_information": "Kamwimba village don't have access to rwinyoni market and rwinyoni village don't have access to farms. Information gathered from rwinyoni leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157712689610103/page1/",
  //       "bridge_opportunity_casesafeid": "006f100000d7iUrAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Butana",
  //       "bridge_opportunity_project_code": "1013652",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.86777,
  //       "bridge_opportunity_gps_longitude": 29.289722,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 27,
  //       "bridge_opportunity_individuals_directly_served": 2141,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.86777,
  //       "proposed_bridge_location_gps_longitude": 29.289722,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nkora market",
  //       "education_access_blocked_by_river": "Vumbi primary and secondary school on left hand side and maziba",
  //       "health_access_blocked_by_river": "Kinunu hospital",
  //       "other_access_blocked_by_river": "Adventist church on left hand side",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He fell in the river when it was flooded",
  //       "notes_on_social_information": "Market(Rwabisururu village), Sec school (gakenke village and maziba villabe). Health center (gakenke and maziba). Farms(rwabisururu village, gakenke village and maziba villabe6).Population information for each village was provided by kaguriro cell vice leader and population of all adjacent communities including kaguriro cell. Population of all adjacent communities includes the following villages: rwabisururu, gakenke, and maziba and kaguriro cell . Kaguriro .cell community members sometimes cross to visit relatives twice amonth .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkomero",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157711084277291",
  //       "bridge_opportunity_casesafeid": "006f100000d7iX7AAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Nkora",
  //       "bridge_opportunity_project_code": "1013658",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.8675,
  //       "bridge_opportunity_gps_longitude": 29.324166,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 1348,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8675,
  //       "proposed_bridge_location_gps_longitude": 29.324166,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Nkomera and nkora market",
  //       "education_access_blocked_by_river": "Groupe scolaire karugarugarika and groupe scolaire rugaragara",
  //       "health_access_blocked_by_river": "Biruyi health center and murunda hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "When it is flooded people fall in the river always",
  //       "notes_on_social_information": "Market(bushunga village), Sec school (bushunga village ). Health center (kariba ).farms(bushunga and kariba) .Population information for each village was provided by biruyi cell leader ndagijimana frodourd and magaba cell leader uwamahoro beathe who got the data from the census that collected in July 2017. Population of all adjacent communities includes the following villages: bushunga ,kariba , magaba and biruyi community members sometimes cross to visit market twice amonth.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 69,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157711717160441",
  //       "bridge_opportunity_casesafeid": "006f100000d7iYeAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kagogo",
  //       "bridge_opportunity_project_code": "1013662",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.90122,
  //       "bridge_opportunity_gps_longitude": 29.37049,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 49,
  //       "bridge_opportunity_individuals_directly_served": 1468,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.90122,
  //       "proposed_bridge_location_gps_longitude": 29.37049,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nkomero market , mburamazi market",
  //       "education_access_blocked_by_river": "Murunda secondary and primary school",
  //       "health_access_blocked_by_river": "Murunda hospital",
  //       "other_access_blocked_by_river": "Church at murunda",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "There is no injury or death",
  //       "notes_on_social_information": "Kagogo don't have access to mburamazi market, gatoki don't have access to nkomero market . Information gathered from gatoki village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkomero",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 101,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157711084080652",
  //       "bridge_opportunity_casesafeid": "006f100000d7iZwAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Rufuha",
  //       "bridge_opportunity_project_code": "1017673",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.012167,
  //       "bridge_opportunity_gps_longitude": 29.763889,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 33.7,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.5.29",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.012167,
  //       "proposed_bridge_location_gps_longitude": 29.763889,
  //       "current_crossing_method": "Fording",
  //       "nearest_all_weather_crossing_point": "7 km",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "People from sholi cell Cyeza ,Shyanda village of Nyarunyinya cell cross this river when coming gashyushya market in Muhanga Sector",
  //       "education_access_blocked_by_river": "Students from Sholi and Biringaga cells need crossing both kagaga and Makurungwe rivers when coming to Murama Primary school",
  //       "health_access_blocked_by_river": "People from Muhanga Sector cross all rivers when going to Health Center",
  //       "other_access_blocked_by_river": "People from Nyabinoni sector , kiyumba and kabacuzi sectors need crossing this river when going to kibeho Holly Place on foot",
  //       "primary_occupations": "Agruiculture",
  //       "primary_crops_grown": ", bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "In 2016 one citizen who was called Haabimana died, in 2017 other two people died",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga -kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157711041483051/page1",
  //       "bridge_opportunity_casesafeid": "0063Z00000gLr35QAC",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Gasura",
  //       "bridge_opportunity_project_code": "RW104",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.820833,
  //       "bridge_opportunity_gps_longitude": 30.113889,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 44,
  //       "bridge_opportunity_individuals_directly_served": 7000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Inspection Form - Suspension - 2018.2.7",
  //       "form_created_by": "Lauren Walter",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://flic.kr/s/aHsk19sn5p",
  //       "bridge_opportunity_casesafeid": "006f100000ZQRq3AAH",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kucyaruseke",
  //       "bridge_opportunity_project_code": "RW127",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.711764,
  //       "bridge_opportunity_gps_longitude": 29.557267,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 79,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2017.9.5",
  //       "form_created_by": "Stephanie May",
  //       "proposed_bridge_location_gps_latitude": -2.711764,
  //       "proposed_bridge_location_gps_longitude": 29.557267,
  //       "current_crossing_method": "Log timber bridge",
  //       "nearest_all_weather_crossing_point": "23 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "The river can flood 24 hours. No one crossing and if it rains hard 3 times per week",
  //       "market_access_blocked_by_river": "On both sides there are markets and when the river floods the communities are required to use the road which makes the way very long (6km more) than using the log timber bridge",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming, teaching, masons",
  //       "primary_crops_grown": "bean, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The bridge is very used because it's the shortcut way to markets and government facilities at the sector level",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Butare-Burundi (NR19)",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 6,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": "https://flic.kr/s/aHsm4qDGEk",
  //       "bridge_opportunity_casesafeid": "006f100000Zs7KqAAJ",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "G.s Mugunga",
  //       "bridge_opportunity_project_code": "1007342",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6938888889,
  //       "bridge_opportunity_gps_longitude": 29.6486111111,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 115.5,
  //       "bridge_opportunity_individuals_directly_served": 4000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1441m, Cell:Nkomane-Rwamambe, Injuries/Death--Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Cyagara, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 28m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient.-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing sign of erosion and it is located between two flat areas.-The soil from the site is silt soil for both sides. 2500 people and 1200 people from Mutego and Rutenderi villages respectively that use GS mugunga Bridge monthly to access their plot for farming at Nkomane Cell and others go to Kabukanya EAR church every sunday at Nkomane cell also . Adjacent community in total is 3700..",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6938888889,
  //       "proposed_bridge_location_gps_longitude": 29.6486111111,
  //       "current_crossing_method": "Two logs",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in one kilometer of cyagara",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Vunga market in about 2 kilometer",
  //       "education_access_blocked_by_river": "Gs mugunga nursery primary and secondary",
  //       "health_access_blocked_by_river": "Mugunga post health center and shila hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Education purpose worship and farming and marketing to vunga",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Student slipped trying to cross",
  //       "notes_on_social_information": "Gathered from Dean of studies of gs mugunga",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze-nyakinama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86D4AAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Ntaruka",
  //       "bridge_opportunity_project_code": "1007347",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.781111111,
  //       "bridge_opportunity_gps_longitude": 29.8791666667,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 32,
  //       "bridge_opportunity_individuals_directly_served": null,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1551m, Cell:Rwinkuba, Injuries/Death-Many peoples injured while crossing the river./ One person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Muhondo, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two hills.-The soil from the site is silt for both sides. 420 people fro Bukwera village,200 people from Bumba Villlage and 250 people from Businde village in total they are 870 community that use Ntaruka Bridge on Market day. this number of community uses Ntaruka Bridge to access Ruli Hospital. The nearest crossing point is in7 km from Ntaruka bridge wchicis a vehicular timber bridge that links Munyongwe and Muhondo sector.",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.781111111,
  //       "proposed_bridge_location_gps_longitude": 29.8791666667,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "30",
  //       "market_access_blocked_by_river": "Muhondo marjet",
  //       "education_access_blocked_by_river": "Bumba secondary and primary school",
  //       "health_access_blocked_by_river": "Rwankuba health center",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Education purpose marketing and farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 40,
  //       "incident_descriptions": "There are others who died recently in about 30 years",
  //       "notes_on_social_information": "Information gathered from old man who stays in community",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali - musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86D9AAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kwiterambere",
  //       "bridge_opportunity_project_code": "1013678",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.66344,
  //       "bridge_opportunity_gps_longitude": 29.83439,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 57,
  //       "bridge_opportunity_individuals_directly_served": null,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66344,
  //       "proposed_bridge_location_gps_longitude": 29.83439,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Murandi primary and secondary",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "When base river floods people are likely to be drawn because it covers the current bridge",
  //       "notes_on_social_information": "Murandi don't have access to gakenke market. Bushita don't have access to farms. Information gathered from taba leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7icgAAA",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kabutimbo",
  //       "bridge_opportunity_project_code": "1015693",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.621187,
  //       "bridge_opportunity_gps_longitude": 29.660569,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 55,
  //       "bridge_opportunity_individuals_directly_served": 1280,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.2.22",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.621187,
  //       "proposed_bridge_location_gps_longitude": 29.660569,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Gaseke vehicular bridge",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "People from Rumbi, kamonyi and Murambi blocked by this river when going to Mashya ,kinkware and Musanze",
  //       "education_access_blocked_by_river": "Students from Murambi and Rumbi need to go to ES Nyundo",
  //       "health_access_blocked_by_river": "People from Rumbi, Kamonyi and Murambi need medical services on right side of the river",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": "banana, cassava, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Number of communities was given by Bukingo and Batindo Village leaders",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000fHqCoAAK",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Gitwa",
  //       "bridge_opportunity_project_code": "1007340",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.738888,
  //       "bridge_opportunity_gps_longitude": 29.755277,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 2860,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1403m, Cell:Munyana, Injuries/Death-Many peoples injured while crossing the river./ One person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers-Minazi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 38m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for one side and silt for the other side.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.738888,
  //       "proposed_bridge_location_gps_longitude": 29.755277,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "21",
  //       "market_access_blocked_by_river": "Mataba market, gikokee market, gakenke market and murambo market",
  //       "education_access_blocked_by_river": "Marana primary and secondary school",
  //       "health_access_blocked_by_river": "Mataba health center",
  //       "other_access_blocked_by_river": "Abakunda kawa coffee industry in munyani/kivuba",
  //       "primary_occupations": "Farming and agribusiness",
  //       "primary_crops_grown": "pineappl, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "There is women who died trying to cross the river before constructing the current timber bridge",
  //       "notes_on_social_information": "Information gathered from gatwa leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 20,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86D2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusovu",
  //       "bridge_opportunity_project_code": "1007387",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.14783,
  //       "bridge_opportunity_gps_longitude": 29.535028,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 10405,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1621m, Cell:Muhororo, Injuries/Death-Many people were injured while trying crossing the river./ No person died while crossing the river Cross river on a normal day->600 people, Nearby city centers--Birambo -Nyakabuye, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 4 m-The proposed bridge span is 100 m-The level difference between two banks is approximately 0.3m (Approximately the same)-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the site-The river bed at the site is stable, there is no possibility of erosion.-The bank profile of the site is approximately partially smooth-The river bank of the site is showing sign of erosion and it is located between two flat areas-The soil from the site is silt for both sides-The site is located between two flat areas with silt soil for both sides",
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14783,
  //       "proposed_bridge_location_gps_longitude": 29.535028,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "30times in April, May, October November and December and it lasts 3days after rainfall",
  //       "market_access_blocked_by_river": "Nzaratsi cell doesn't have access to Birambo market",
  //       "education_access_blocked_by_river": "Muhororo Cell doesn't have access to Nyamabuye primary school Nzaratsi cell doesn't have access to Nyakabuye Primary school Nzaratsi cell doesn't have access to Muhororo secondary school",
  //       "health_access_blocked_by_river": "Nzaratsi cell doesn't have access to Birambo health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, banana, cassava",
  //       "primary_crops_grown": "banana, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 79.4,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DnAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyarusanga 1",
  //       "bridge_opportunity_project_code": "1007391",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.15350833,
  //       "bridge_opportunity_gps_longitude": 29.356425,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 72,
  //       "bridge_opportunity_individuals_directly_served": 5748,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1867m, Cell:Nyarusanga, Injuries/Death-2 people were injured while trying crossing the river./ No person died while crossing the river Cross river on a normal day-50-150 people, Nearby city centers--Kamina -Nyarusanga, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 2m-The proposed bridge span is 25m-The level difference between two banks is approximately 0.1m (Approximately the same)-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level sufficient-There is no confluence area near the site-The river bed at the site is stable, there is no possibility of erosion.-The bank profile of the site is approximately partially cut out-The river bank of the site is not showing any sign of erosion and it is located between two hills-The soil from the site is hard rock for both sides-The site is located between two hills with a rock for both sides",
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.15350833,
  //       "proposed_bridge_location_gps_longitude": 29.356425,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 140,
  //       "flood_duration_during_rainy_season": "20times in April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Rubazo cell doesn't have access to Kivuruga market Gasata cell doesn't have access to Mubuga market",
  //       "education_access_blocked_by_river": "Gasata cell doesn't have access to Rubazo primary and secondary school",
  //       "health_access_blocked_by_river": "Rubazo cell doesn't have access to Bisesero health center Gasata cell doesn't have access to Rubazo health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, cassava, banana",
  //       "primary_crops_grown": "banana, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitinda",
  //       "bridge_opportunity_project_code": "1007453",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.70215,
  //       "bridge_opportunity_gps_longitude": 29.51309,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 9,
  //       "bridge_opportunity_individuals_directly_served": 1051,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2392m, Cell:Rwantobo, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Gasiza, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 15m.-The proposed bridge span is approximately 25m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two hills.-The soil from the site is clay soil for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70215,
  //       "proposed_bridge_location_gps_longitude": 29.51309,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "The river floods mostly in April and December. It last 1 day",
  //       "market_access_blocked_by_river": "Gasiza market",
  //       "education_access_blocked_by_river": "Mulinga school and Rambura secondary school",
  //       "health_access_blocked_by_river": "Birembo health center",
  //       "other_access_blocked_by_river": "Protestants church",
  //       "primary_occupations": "Students and teachers, farmers on both sides and traders in Gasiza market",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira_Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ErAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mabare 1",
  //       "bridge_opportunity_project_code": "1013672",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.62126,
  //       "bridge_opportunity_gps_longitude": 29.78084,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1700,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62126,
  //       "proposed_bridge_location_gps_longitude": 29.78084,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "30 minutes",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Nemba secondary school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "Church at nemba",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "One person has died when the river was flooded",
  //       "notes_on_social_information": "Buranga don't have access to kiruhura farms and kiruhura village don't have access to Nemba hospital and gakenke market. Information gathered from kiruhura leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 83,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ibsAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kukasedurugu",
  //       "bridge_opportunity_project_code": "1007412",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.536111111,
  //       "bridge_opportunity_gps_longitude": 29.679166666,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 60,
  //       "bridge_opportunity_individuals_directly_served": 1600,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1660m, Cell:Kabushinge, Injuries/Death--Many peoples injured while crossing the river./ 1 person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Buseke -Mukungwa, Crossing River now-Nearby bridge / Bakoresha iteme rihegereye, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-marsh (papyrus, marsh grasses, etc.) / igishanga,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 170m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient.-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.536111111,
  //       "proposed_bridge_location_gps_longitude": 29.679166666,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No where",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "It is always flooded",
  //       "market_access_blocked_by_river": "Musanze market",
  //       "education_access_blocked_by_river": "Rwaza primary and secondary school",
  //       "health_access_blocked_by_river": "Rwaza health center",
  //       "other_access_blocked_by_river": "Mukungwa dam upstream",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information gathered from local people in the meeting",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali - musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ECAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kuribushoka",
  //       "bridge_opportunity_project_code": "1007423",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.80202,
  //       "bridge_opportunity_gps_longitude": 29.64597,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 23,
  //       "bridge_opportunity_individuals_directly_served": 1325,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1484m, Cell:Kaseke, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Rwamiko -Mugano, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 3m.-The proposed bridge span is approximately 50m.-The level difference between two banks is approximately 0.02m.-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient (>Span/25).-There is no confluence area near the place.-The river bed at this site is stable, there is no possibility of erosion.-The bank profile of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.80202,
  //       "proposed_bridge_location_gps_longitude": 29.64597,
  //       "current_crossing_method": "Existing bridge was gone",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 1,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Ngororero Market",
  //       "education_access_blocked_by_river": "GS Munini",
  //       "health_access_blocked_by_river": "Fossacom hospital",
  //       "other_access_blocked_by_river": "Ngororero district",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 7,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Unknown people",
  //       "notes_on_social_information": "People from two villages cross this satinsyi river",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero _Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ENAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murambi",
  //       "bridge_opportunity_project_code": "1007424",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.85605607,
  //       "bridge_opportunity_gps_longitude": 29.62150397,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "Same site as Rwanda - Kabuga - 1007421 Was rejected for local contribution. BAJ unrejected that site but then rejected it again as a duplicate of this site since the most appropriate assessment for is attached to this record. There is a design already for Kabuga. 1000-3000 people directly served, Elevation:1615m, Cell:kazabe-Nyamata, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Muhororo -Ngororero, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 4m.-The proposed bridge span is approximately 38m.-The level difference between two banks is approximately 0.1m.-The space for foundation is sufficient.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient (>Span/25).-There is no confluence area near the place.-The river bed at this site is stable, there is no possibility of erosion.-The bank profile of the site is not showing sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85605607,
  //       "proposed_bridge_location_gps_longitude": 29.62150397,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "200 m",
  //       "days_per_year_river_is_flooded": 2,
  //       "flood_duration_during_rainy_season": "Flood takes hours like 4",
  //       "market_access_blocked_by_river": "Ngororero market",
  //       "education_access_blocked_by_river": "Gs Rurimba",
  //       "health_access_blocked_by_river": "Rususu health center",
  //       "other_access_blocked_by_river": "Ngororero District",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, bean, mak, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Drunk men",
  //       "notes_on_social_information": "The farmers who were cultivating around the river told me that the bridges is crossed by thousand of people who are going to markets and churches",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero-kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 93.8,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EOAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muacyabahinja",
  //       "bridge_opportunity_project_code": "1007426",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.819809,
  //       "bridge_opportunity_gps_longitude": 29.6066111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 20,
  //       "bridge_opportunity_individuals_directly_served": 3587,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1630m, Cell:Gatare-Giseke, Injuries/Death-Many peoples injured while crossing the river./ 2Peoples died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Nyagasozi -Mburamazi -Tetero -Maranimpa -Muvugangoma, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 2m.-The proposed bridge span is approximately 45m.-The level difference between two banks is approximately 0.03m(almost the same).-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient (>Span/25).-There is no confluence area near the place.-The river bed at this site is stable, there is no possibility of erosion.-The bank profile of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.819809,
  //       "proposed_bridge_location_gps_longitude": 29.6066111,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 7,
  //       "flood_duration_during_rainy_season": "A week of flood people are not able to cross",
  //       "market_access_blocked_by_river": "Ngororero Market",
  //       "education_access_blocked_by_river": "GS Hindiro",
  //       "health_access_blocked_by_river": "Buyungu health center",
  //       "other_access_blocked_by_river": "Kageyo sector and Hindiro sector",
  //       "primary_occupations": null,
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "People get scared while crossing then they fall down and there are stones within the river",
  //       "notes_on_social_information": "I met with 4 village leaders and they told me the number of their people who crossing the river , and they told ,e that the bridge is so needed in this area",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero-kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 67,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukamira",
  //       "bridge_opportunity_project_code": "1007439",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.6198,
  //       "bridge_opportunity_gps_longitude": 29.50244,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 3006,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:2327m, Cell:Jaba, Injuries/Death-3 peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day->600 people, Nearby city centers--Mukamira -Jenda, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 1.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a hill and an elevated area.-The soil from the site is volcanic rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6198,
  //       "proposed_bridge_location_gps_longitude": 29.50244,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "300 m",
  //       "days_per_year_river_is_flooded": 8,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Mukamira market, mukamira maize flour factory, teachers plantation workers",
  //       "education_access_blocked_by_river": "Nyabihu training center, kazuba secondary school",
  //       "health_access_blocked_by_river": "Kora health canter",
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Students and teachers, traders to Mukamira market",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Injuries are due to slipping on timber and fall in the river",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the population number of communities and facilities that are in their destination. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamiro",
  //       "bridge_opportunity_project_code": "1007444",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.681,
  //       "bridge_opportunity_gps_longitude": 29.50024,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 58,
  //       "bridge_opportunity_individuals_directly_served": 3805,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2528m, Cell:Mutaho, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Bugonde -Kamiro, Crossing River now-Walking through river / Banyura mumaziSimple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 22m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two elevated areas.-The soil from the site is silt soil for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.681,
  //       "proposed_bridge_location_gps_longitude": 29.50024,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 6,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Gasiza market, farms on both side in villages",
  //       "education_access_blocked_by_river": "Kanyaru primary school, kibisabo secondary school",
  //       "health_access_blocked_by_river": "Birembo health center and Rambura hospital",
  //       "other_access_blocked_by_river": "Rambura Parish and Rambura sector office",
  //       "primary_occupations": "Students and teachers, farmers and traders at Gisiza market",
  //       "primary_crops_grown": "potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Deaths were due to Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river.Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira_Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 73,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakaruru",
  //       "bridge_opportunity_project_code": "1013673",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.65647,
  //       "bridge_opportunity_gps_longitude": 29.79743,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1518,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65647,
  //       "proposed_bridge_location_gps_longitude": 29.79743,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Gakenke",
  //       "education_access_blocked_by_river": "Nemba primary and secondary school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "Nemba cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Because the current timber bridge is at high elevation people slip and fell down",
  //       "notes_on_social_information": "Kivumu village don't have access to gakenke market. Museke village don't have access to farms. Information gathered from rusagara leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ic2AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Isangano",
  //       "bridge_opportunity_project_code": "1007455",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.334487,
  //       "bridge_opportunity_gps_longitude": 30.250622,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 55,
  //       "bridge_opportunity_individuals_directly_served": 17237,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1360m, Cell:Rurenge-Nkoma, Injuries/Death-Many peoples injured while trying to cross the river/ More than 3 peoples died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Ibare -Rurenge, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 80m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.334487,
  //       "proposed_bridge_location_gps_longitude": 30.250622,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "7.5 km",
  //       "days_per_year_river_is_flooded": 154,
  //       "flood_duration_during_rainy_season": "1 week",
  //       "market_access_blocked_by_river": "Communities 1 don't have access to Rukomo market and communities 2 don't have access to Nyabitekeri market, communities on both sides don't have access to Farms and burnt clay bricks site ,",
  //       "education_access_blocked_by_river": "Communities1 don't have access to Rurenge primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Rurenge health center and Nyakagarama health Post",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Burnt clay brick markers, farmers on both side and traders at Rukomo and Nyabitekeri markets",
  //       "primary_crops_grown": "bean, maiz, sorghum, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "More than four people fell into the river but fortunately none died",
  //       "notes_on_social_information": "Rukomo market which is open weekly( community 1); Nyabitekeri market which is open weekly( community 2); Rurenge primary and secondary school ( Community 1); Rurenge health center and Nyakagarama health Post ( Community 1). Population information for each cell was provided by Ntambara Umuhumuza Vincent; cell leader of Nkoma and Donacien Rurategereje ; Nyakagarama cell leader. Population information was sourced from village census data collected in 2017",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 61,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nshuri",
  //       "bridge_opportunity_project_code": "1007458",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.308813,
  //       "bridge_opportunity_gps_longitude": 30.314539,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 7453,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1338m, Cell:Gitengure-Mirama, Injuries/Death-Many peoples injured while trying to cross the river/ one person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Nyagatare -Mirama, Crossing River now-Walking through river / Banyura mumaziSwim / Baroga, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 50m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.308813,
  //       "proposed_bridge_location_gps_longitude": 30.314539,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "4 days",
  //       "market_access_blocked_by_river": "Communities 2don't have access to Rice plantation farms, communities 1 don't have access to Rukomo and Mimuli markets",
  //       "education_access_blocked_by_river": "Communities 1don't have access to Mary hills school and Nyagatare Parents school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers ( Rice ) and Traders at Mimuli markets",
  //       "primary_crops_grown": "bean, livestock ( cattle ), maiz, rice plantation farms on large scal",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Three people were drowned and two fell into the river",
  //       "notes_on_social_information": "Rice plantation farms ( Community 2), Rukomo and Mimuli markets ( Community1 ), Mary hills school ( Community 1), Nyagatare Parents school ( Community 1). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 72,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mujerenge",
  //       "bridge_opportunity_project_code": "1007463",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.45195667,
  //       "bridge_opportunity_gps_longitude": 29.427665,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 70,
  //       "bridge_opportunity_individuals_directly_served": 995,
  //       "bridge_opportunity_comments": "Merged with Bishigishi - 1009315, a duplicate confirmed by Alan Kreisa, on 2020.10.09. 1000-3000 people directly served, Elevation:2130m, Cell:Bushigishigi, Injuries/Death-Many peoples injured while trying to cross the river/ One person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kizimyamuriro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 9m.-The proposed bridge span is approximately 65m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a hill and an elevated area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45195667,
  //       "proposed_bridge_location_gps_longitude": 29.427665,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "15 times in April and September",
  //       "market_access_blocked_by_river": "Markets, farming,",
  //       "education_access_blocked_by_river": "Primary school, Secondary school",
  //       "health_access_blocked_by_river": "Poste de sante",
  //       "other_access_blocked_by_river": "Government offices, church,",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, meal, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The estimated figures were given by local people together with their leaders, based on their daily activities",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65.8,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86F1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwangambibi",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007465",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.345116,
  //       "bridge_opportunity_gps_longitude": 29.43387,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 3475,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1979m, Cell:Ruganda-Bakopfu, Injuries/Death--Many peoples were injured while trying to cross/ -No person died while trying to cross Cross river on a normal day-50-150 people, Nearby city centers--Ruganda -Kiyovu, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately10m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.3m.-The space for foundation is sufficient for both sides. -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between an elevated area and a flat area.-The soil from the site is silt for both sides",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.345116,
  //       "proposed_bridge_location_gps_longitude": 29.43387,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "Heavy flood start from April to May, from September to November, 3 hours",
  //       "market_access_blocked_by_river": "Market ( communities 2 ,3), farms (communities 1,2,3,4,5), factory-mushubi tea factory ( communities 4,5)",
  //       "education_access_blocked_by_river": "Secondary school ( commnity 1,2,3,4,5), primary school( villages 1,2,3,4,5)",
  //       "health_access_blocked_by_river": "Health center (villages 1,2,3,4,5)",
  //       "other_access_blocked_by_river": "Churches(1,2,3), government services(1,2,3), football tterrain(1,2,3)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Tried to cross and drowned due to heavy flood.",
  //       "notes_on_social_information": "The population data from which the villages directly served by the bridge was given by the shyeru cell leader, Pascal NTIBANDETSE and Gashwati cell leader. The population from communities 1,2,3,4,5,they always cross the river to the health center, to the market and farms. They are another group of people who come in nkomane sector and far community in Gatare sector who sometimes cross the river every wensday to visit the market(Mushubi ).",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86F3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Remera",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007469",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.213863,
  //       "bridge_opportunity_gps_longitude": 29.563708,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 58,
  //       "bridge_opportunity_individuals_directly_served": 2714,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1524m, Cell:Nyagisozi, Injuries/Death-Many peoples injured while trying to cross the river/ More than 2peoples died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Masizi -Kabageni, Crossing River now-Walking through river / Banyura mumaziSwim / Baroga, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 65m.-The level difference between two banks is 0.04m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.213863,
  //       "proposed_bridge_location_gps_longitude": 29.563708,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "April to May, September to December, 1week without crossing, in April the whole month they do not cross",
  //       "market_access_blocked_by_river": "Buhanda market(villages 1,2,3), farms (1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Nyagisozi primary school ( 4,5)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, maiz, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population of information of each village was provided by the remera cell leader, Josue Uwimana.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 74,
  //       "height_differential_between_banks": 5.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86F7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyabazungo",
  //       "bridge_opportunity_project_code": "1007471",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.4243,
  //       "bridge_opportunity_gps_longitude": 29.5426533,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 8150,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1729m, Cell:Gashiha, Injuries/Death-Many peoples injured while trying to cross the river/ 2 peoples died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Gataba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 48m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is silt for one side and hard rock for the other side.",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4243,
  //       "proposed_bridge_location_gps_longitude": 29.5426533,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "70 times around the year and it lasts for 3 hours after rainfall",
  //       "market_access_blocked_by_river": "Gashiha cell doesn't have access to Kibumbwe and Kaduha markets Muganza cell doesn't have access to Gataba, Nyamagabe and Miko markets",
  //       "education_access_blocked_by_river": "Gashiha cell doesn't have access to Kibumbwe primary and secondary school Muganza cell doesn't have access to Kiraro primary and secondary school",
  //       "health_access_blocked_by_river": "Gashiha cell doesn't have access to Kibumbwe Health Center Muganza cell doesn't have access to Kibirizi health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, coffe, eucalyptu",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They slipped on trees and fall down in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 69.5,
  //       "height_differential_between_banks": 2.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86F9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sabake",
  //       "bridge_opportunity_project_code": "1007472",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.47291333,
  //       "bridge_opportunity_gps_longitude": 29.42335667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 4469,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2102m, Cell:Kibyagira-Kizimyamuriro, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Kizimyamuriro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 3825m.-The level difference between two banks is 0.07m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.47291333,
  //       "proposed_bridge_location_gps_longitude": 29.42335667,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "All time in April and May",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of tea,",
  //       "primary_crops_grown": "bean, cow pea, tea, wheat",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "KaganoMarket 1( Minaga, Gishwati, Mujerenge, Gikungu, Tantamara, Kagano) Market 2 (Rugeti, Mwishyogwe, ) Secondary schools ( Gishwati, ) Primary school (Rugeti) Health Center (Minaga, Gishwati, Mujerenge, Gikungu, Tantamara, Kagano) This social survey is conducted with the help of local people and their leaders And the numbers given were based on the monthly census which is done in every cell The village of Tantamara, Mujerenge, Sabake, Kagano, Gikungu are using this crossing regularly and their people were included in the total population",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 58.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mu rubuye",
  //       "bridge_opportunity_project_code": "1013330",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.5145,
  //       "bridge_opportunity_gps_longitude": 29.79785,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 526,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.5145,
  //       "proposed_bridge_location_gps_longitude": 29.79785,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by cell leader of Runoga",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They people want vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 11,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EStAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwabarashi",
  //       "bridge_opportunity_project_code": "1007473",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.21156,
  //       "bridge_opportunity_gps_longitude": 29.544015,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 83,
  //       "bridge_opportunity_individuals_directly_served": 2613,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1539m, Cell:Nyagisozi-Mwendo, Injuries/Death-Many peoples injured while trying to cross the river/ More than 3 peoples died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Masizi -Kabageni, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 100m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is sandy for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.21156,
  //       "proposed_bridge_location_gps_longitude": 29.544015,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "April to May, September to December, 48 hours",
  //       "market_access_blocked_by_river": "Birambo market(villages, 1,2,3)",
  //       "education_access_blocked_by_river": "Nyagisozi primary school(villages 3,4)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maaiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population information of each village was provided by Nyagisozi cell leader, Matride Mujamarariya who sourced the population from cell register in 2015. The population of all adjacent communities includes the following villages: Ruhuga, uwabarashi, Kibaga, Dusenyj and Kayogoro.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugote",
  //       "bridge_opportunity_project_code": "1007477",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.4477333,
  //       "bridge_opportunity_gps_longitude": 29.41455333,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 60,
  //       "bridge_opportunity_individuals_directly_served": 1720,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2190m, Cell:Bushigishigi-Kizimyamuriro, Injuries/Death-Many peoples injured while trying to cross the river/ 2 peoples died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kizimyamuriro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4477333,
  //       "proposed_bridge_location_gps_longitude": 29.41455333,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "10 times in April, May and September",
  //       "market_access_blocked_by_river": "Farms",
  //       "education_access_blocked_by_river": "Secondary school,",
  //       "health_access_blocked_by_river": "Health post",
  //       "other_access_blocked_by_river": "Office building, church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, meal, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "She slipped on the trees when the river was flooded and she has fallen down in the river",
  //       "notes_on_social_information": "The number estimated on this site were based on the local people views, and based on the current population of the concerned village",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60.3,
  //       "height_differential_between_banks": 4.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FFAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muduha",
  //       "bridge_opportunity_project_code": "1007491",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.436162,
  //       "bridge_opportunity_gps_longitude": 29.52308,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 17,
  //       "bridge_opportunity_individuals_directly_served": 4530,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1858m, Cell:Gashiha, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Gasharu -muduha -Kibirizi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 38m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between Flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.436162,
  //       "proposed_bridge_location_gps_longitude": 29.52308,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "All the Times in April and May",
  //       "market_access_blocked_by_river": "Market of Musebeya and Nyamagabe",
  //       "education_access_blocked_by_river": "Primary school",
  //       "health_access_blocked_by_river": "No Health Center in this location",
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Farming of sweet potatoes, beans, coffee, forest",
  //       "primary_crops_grown": "bean, coffe, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They slipped on trees and fall down in the river and All the incidents that happened on this crossing resulted into deaths",
  //       "notes_on_social_information": "Market Musebeya(Muduha, Gasharu, Rukamiro, Nyabubare and Muganza) Market Nyamagabe(Nyarubuye, Byintare) The villages of Nyarubuye and Byintare are using this crossing regularly for reaching the market of Nyamagabe and their people were included in the total population. This social survey was conducted within the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75.4,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FTAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murehe",
  //       "bridge_opportunity_project_code": "1007497",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.265518,
  //       "bridge_opportunity_gps_longitude": 29.585978,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 2383,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1540m, Cell:Masizi, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Masizi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.265518,
  //       "proposed_bridge_location_gps_longitude": 29.585978,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 48hours after rain they can cross",
  //       "market_access_blocked_by_river": "Masizi markert (villages 3,4), kaduha market (villages 3,4), farms (villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "Nyaruzi primary school (villages 3,4),",
  //       "health_access_blocked_by_river": "Nyaruzi health center (villages 3,4), kaduha hospital (villages 3,4)",
  //       "other_access_blocked_by_river": "Government services such as sector office, police station, district (villages 3,4), Masizi Sacco bank (villages 3,4), churches (villages 3,4), potable water (villages 3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information of population was provided by Masizi cell leader, Jean Mugwizambaraga who sourced the information from the the cell data register done 2016. Population of all adjacent communities includes: Kirehe, bwama, Rwankango and Rwina. Community members in those villages use this crossing to go to the market, to visit relatives.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibiraro",
  //       "bridge_opportunity_project_code": "1007499",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.294523,
  //       "bridge_opportunity_gps_longitude": 29.55516,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 2492,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1614m, Cell:Murambi, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Kaduha, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-1-2 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 24m.-The level difference between two banks is 0.07m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.294523,
  //       "proposed_bridge_location_gps_longitude": 29.55516,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "From March to April, and sometime in September to December, 3 hours people can cross",
  //       "market_access_blocked_by_river": "Market(villages 1,2,3,4) , farms(villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "Primary school (villages 1,4)",
  //       "health_access_blocked_by_river": "Health center(villages 1,2,3,4)",
  //       "other_access_blocked_by_river": "Churches(villages1,2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, sorghum, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Drowned during crossing",
  //       "notes_on_social_information": "The population information of each community was given by the cell leader, Aimable Nsengimana who sourced the population information from the Ubudehe cell record done in June, 2018. Population of all adjacent communities includes the following villages: kibiraro, Kinzira, cyabagomba and Rebero. Community members in all villages given above use the bridge to travel to the market, student to schools, to do farming, or for the government service.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": 3.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bisheke",
  //       "bridge_opportunity_project_code": "1007508",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.280762,
  //       "bridge_opportunity_gps_longitude": 29.206295,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 20,
  //       "bridge_opportunity_individuals_directly_served": 2338,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1484m, Cell:Gatare, Injuries/Death-Many peoples injured while crossing the river./ 1 person died while trying to cross the river. Cross river on a normal day->600 people, Nearby city centers--Macuba -Bisheke, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 20m.-The proposed bridge span is approximately 60m.-The level difference between two banks is approximately 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient (",
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.280762,
  //       "proposed_bridge_location_gps_longitude": 29.206295,
  //       "current_crossing_method": "Log of timber.",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometers away.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "February, March, april to May and october to December, 1 week without crossing. In april, It is all most the whole month without crossing.",
  //       "market_access_blocked_by_river": "Communities 1&2 do not have access to karengera market. Communities 1&2 do not have access to kirimbi rice factory. Communities 1&2 do not have access to farms in kirimbi sector, communities 3&4 do not access to Rugari market. Communities 3&4 are blocked to farms in mutongo.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to karengera secondary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to karengera health center.",
  //       "other_access_blocked_by_river": "Communities 1& 2 do not have access to churches in kirimbi. Communities 3&4 do not have access to district office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, ric, sugar can",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population data for each village was provided by Muhororo cell leader And Rugari cell leader, who sourced population from the cell register done in 2017. The population of all adjacent communities includes the following villages; Nyakabingo, Gabiro and Mutongo. Communities members from villages Nyakabingo and Gabiro sometimes cross the river to visit market and relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamsheke ~ Karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 59,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagafunzo",
  //       "bridge_opportunity_project_code": "1007515",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.19761,
  //       "bridge_opportunity_gps_longitude": 29.277965,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 9,
  //       "bridge_opportunity_individuals_directly_served": 2995,
  //       "bridge_opportunity_comments": "Not Duplicate 3000-6000 people directly served, Elevation:1474m, Cell:Kagarama, Injuries/Death-Many peoples were injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Mugonero -Mahembe -Gabiro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 15m.-The proposed bridge span is approximately 18m.-The level difference between two banks is approximately 0.07m(almost the same)-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient (",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.19761,
  //       "proposed_bridge_location_gps_longitude": 29.277965,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away.",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Communities 3&4 do not have access to Mugonero market, communities 1,2 3, &4 do not have access to farm in mugonero.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to mugonero primary school and secondary school.",
  //       "health_access_blocked_by_river": "Communities 3&4 do not have access to mugonero health center.",
  //       "other_access_blocked_by_river": "Communities 3&4 do not have access to mahembe sector office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by kagarama cell leader, Hategekimana Francois who sourced the population data from cell record from which census done in 2017. The population of all adjacent communities includes the following villages: Gabiro, Rukaragata, Gasharu and Giti. Community members from Gasharu and Giti use the bridge to visit bank in mugonero center and market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi ~ Nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mweya",
  //       "bridge_opportunity_project_code": "1007522",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.32999,
  //       "bridge_opportunity_gps_longitude": 29.64216,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 2992,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1544m, Cell:Cyabakamyi-Gahunga, Injuries/Death--Many peoples injured while trying to cross/ more than two peoples died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Mweya -Gahunga, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.7m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.32999,
  //       "proposed_bridge_location_gps_longitude": 29.64216,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Karangazi vehicular bridge",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "48 hours; from April to May, September to December; 90 days",
  //       "market_access_blocked_by_river": "The people from LHS are blocked mainly on the farms; the markets( buhanda in Ruhango district)on the other side of river.",
  //       "education_access_blocked_by_river": "The RHS of river's student could not access the schools( Groupe scolaire Mweya one half of kilometers from the bridge and ).",
  //       "health_access_blocked_by_river": "Mweya health center located at the LHS.",
  //       "other_access_blocked_by_river": "The RHS community's population could not be able to access churches (Catholic church and ADPR Church 0.5 km from the bridge on The LHS).",
  //       "primary_occupations": "Farming, livestock",
  //       "primary_crops_grown": "banana, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Individuals",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyanza-huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyarera",
  //       "bridge_opportunity_project_code": "1007528",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.29248,
  //       "bridge_opportunity_gps_longitude": 29.61608,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 133,
  //       "bridge_opportunity_individuals_directly_served": 1967,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1532m, Cell:Karama-Masangano, Bridge would connecting Nyanza-Nyamagabe, Injuries/Death--Many peoples injured while trying to cross/ More than 2 peoples died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--karama, Crossing River now-Walking through river / Banyura mumaziSwim / Baroga, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 130m.-The level difference between two banks is 0.03m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.29248,
  //       "proposed_bridge_location_gps_longitude": 29.61608,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "From March to May and from September to December, the river flood last for a day.",
  //       "market_access_blocked_by_river": "Kaduha Market and Masizi Market blocked for people on the RHS and Buhanda Market blocked for people on the LHS",
  //       "education_access_blocked_by_river": "No community is blocked from any school as every sector has its own school.",
  //       "health_access_blocked_by_river": "Each community use its health center",
  //       "other_access_blocked_by_river": "Gatongati Adventist church blocked for people on the LHS",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "maiz, potato, ric, soybean",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Number not known but many times they find dead bodies brought by the river downstream. They have saved many people who were drowning at the current crossing point",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 72,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86G4AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabimata",
  //       "bridge_opportunity_project_code": "1007538",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.69445,
  //       "bridge_opportunity_gps_longitude": 29.45532,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 6365,
  //       "bridge_opportunity_comments": "Not Duplicate 3000-6000 people directly served, Elevation:1941m, Cell:Kabere-Nyabimata, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Mpuza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.69445,
  //       "proposed_bridge_location_gps_longitude": 29.45532,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Communities2 don't have access to G.S. Bigugu schooland Nyabimata primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 2don't have access to Nyabimata Health center",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to to Nyabimata Parish , sector office and Bus Stop heading Ndago market and Huye city",
  //       "primary_occupations": "Nshili_Kivu tea factory workers, farmers on both sides and traders at Kamirabagenzi market",
  //       "primary_crops_grown": "bean, charcoal, maiz, sweet potato, tea, tomato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Five people were injured when trying to cross the river and three died drowned when the river is flooded",
  //       "notes_on_social_information": "Nyabimata Health center ( Community 2), Nyabimata primary and secondary school ( Community2 ), Nyabimata Sector office ( Community2 ), Nyabimata Parish ( community2 ), G.S.Bigugu school ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Migendo",
  //       "bridge_opportunity_project_code": "1007548",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.667,
  //       "bridge_opportunity_gps_longitude": 29.4581,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 3711,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1916m, Cell:Uwacyiza-Samiyonga, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Nsekera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.667,
  //       "proposed_bridge_location_gps_longitude": 29.4581,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40times in April, May, October, November and December and it lasts for 1day after rainfall",
  //       "market_access_blocked_by_river": "Mazimeru village doesn't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Mazimeru, Kigwene, Murambi, Bigugu, Tangabo, Cyurukore villages don't have access to Sekera secondary school",
  //       "health_access_blocked_by_river": "Mazimeru, Kigwene, Murambi, Bigugu, Tangabo, Cyurukore villages don't have access to Muganza health center",
  //       "other_access_blocked_by_river": "Sector office",
  //       "primary_occupations": "Farming of sweet potatoes, tea, beans, banana",
  //       "primary_crops_grown": "bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The villages of Tangabo and Bigugu are using this crossing regularly and their people were included in the total population to be served. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 88,
  //       "height_differential_between_banks": 2.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GOAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Munanira",
  //       "bridge_opportunity_project_code": "1007556",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.73581,
  //       "bridge_opportunity_gps_longitude": 29.56682,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 1137,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1735m, Cell:Nyarure, Injuries/Death-Many peoples injured while trying to cross the river/ 3 peoples died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Ndago -Munini, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 90m.-The level difference between two banks is 7m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.73581,
  //       "proposed_bridge_location_gps_longitude": 29.56682,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Communities 3 don't have access to Bunyagiro market ,both sides don't have access to farms that are being prepared for tea plantation",
  //       "education_access_blocked_by_river": "Communities3 don't have access to Munanira school",
  //       "health_access_blocked_by_river": "Communities 3 don't have access to Munini Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers, and traders at Bunyagiro market, currently the land is being taken by the government in partnership with stakeholders preparing to plant Tea. Workers will be the ones to use this crossing mostl",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Bunyagiro market which is open twice a week ( Community 3), Munanira school ( Community 3), Tea plantations farms on both sides, Munini Hospital ( Community 3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 84,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murambi",
  //       "bridge_opportunity_project_code": "1007557",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.68572,
  //       "bridge_opportunity_gps_longitude": 29.47124,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 4382,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1841m, Cell:Murambi, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Mumpuza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.68572,
  //       "proposed_bridge_location_gps_longitude": 29.47124,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities3,4,5 don't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Communities 3,4,5don't have access to ES Mutovu school",
  //       "health_access_blocked_by_river": "Communities 3,4,5don't have access to Nyabimata Health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea plantation workers, daily farmers on both sides",
  //       "primary_crops_grown": "maiz, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kamirabagenzi market which is open twice a week ( Community3,4,5 ), Tea plantations farms ( Community 1,2), ESMutovu school (Community3,4,5 )",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GXAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagisenyi",
  //       "bridge_opportunity_project_code": "1007562",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.654561,
  //       "bridge_opportunity_gps_longitude": 29.439786,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 2757,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2019m, Cell:Rukore, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Rwishwa, Crossing River now-Walking through river / Banyura mumaziSimple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.03m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.654561,
  //       "proposed_bridge_location_gps_longitude": 29.439786,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "35times in April, May, October, November and December and it lasts for 1hour after rainfall",
  //       "market_access_blocked_by_river": "Nyagisenyi, Kanazi villages don't have access to Kamirabagenzi market Rwishywa and Remera villages don't have access to their farms on the other side",
  //       "education_access_blocked_by_river": "Nyagisenyi, Kanazi villages don't have access to Rwishywa Primary school",
  //       "health_access_blocked_by_river": "Nyagisenyi, Kanazi villages don't have access to Muganza health center",
  //       "other_access_blocked_by_river": "Sector office",
  //       "primary_occupations": "Farming of beans, tea, charcoal production",
  //       "primary_crops_grown": "banana, bean, cassava, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The people will be displaced because on the RHS is a high risk zone but all of their farms are there, and they need to cross to reach them for agricultural issues. The information of the social survey were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 48.4,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasugi",
  //       "bridge_opportunity_project_code": "1007570",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.69743,
  //       "bridge_opportunity_gps_longitude": 29.43339,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 5413,
  //       "bridge_opportunity_comments": "Not Duplicate 1000-3000 people directly served, Elevation:2058m, Cell:Ruhinga, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Gasugi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 28m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.69743,
  //       "proposed_bridge_location_gps_longitude": 29.43339,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "780 m",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities1,3,4 don't have access to to Kamirabagenzi market, communities 2,5don't have access to Ruheru market",
  //       "education_access_blocked_by_river": "Communities 1,3,4 don't have access to to Nyabimata primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,3,4 don't have access to Nyabimata Health center",
  //       "other_access_blocked_by_river": "Communities 1,3,4 don't have access to Nyabimata Health center",
  //       "primary_occupations": "Tea plantation workers, daily farmers on both sides and traders at Kamirabagenzi market",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Five people were injured when trying to cross the river but fortunately none died",
  //       "notes_on_social_information": "Nshili-Kivu tea factory ( Community2,5), Nyabimata primary and secondary school ( Community1,3,4) Nyabimata Health center,( communities 1,3,4), Kamirabagenzi market which is open twice a week ( Community1,3,4), Nyabimata Parish ( Community1,3,4 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruyenzi",
  //       "bridge_opportunity_project_code": "1007582",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7557222,
  //       "bridge_opportunity_gps_longitude": 29.4549167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 4903,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2121m, Cell:Ruyenzi-Mishungero, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Ruheru, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 1.3m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7557222,
  //       "proposed_bridge_location_gps_longitude": 29.4549167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "50times in April, May, October, November and December and it lasts for 1day after rainfall",
  //       "market_access_blocked_by_river": "Ruyenzi, Ruvuru, Tambananga, Gakaranka, Yanza, Uwimbogo, Mubuga, Rukarakara, Rugote, Gitwa villages don't have access to Kabere market Uwigisura, Nyacyonga, Shenyi, Gambiriro, Murambi villages don't have access to Gisanze market",
  //       "education_access_blocked_by_river": "Ruyenzi, Ruvuru, Tambananga, Gakaranka, Yanza, Uwimbogo, Mubuga, Rukarakara, Rugote, Gitwa villages don't have access to Ruheru Secondary school",
  //       "health_access_blocked_by_river": "Ruyenzi, Ruvuru, Tambananga, Gakaranka, Yanza, Uwimbogo, Mubuga, Rukarakara, Rugote, Gitwa villages don't have access to Ruheru health center",
  //       "other_access_blocked_by_river": "Sector office, Umurenge Sacco",
  //       "primary_occupations": "Farming of sweet potatoes, wheat, potatoes, beans, tea",
  //       "primary_crops_grown": "bean, potato, tea, wheat",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The villages of Uwimbogo, Mubuga, Rukarakara, Rugote, Gitwa, are using thiscrossing regularly and their people were included in the total population to be served. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45.2,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kintare",
  //       "bridge_opportunity_project_code": "1007593",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.633202,
  //       "bridge_opportunity_gps_longitude": 29.454371,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 80,
  //       "bridge_opportunity_individuals_directly_served": 4382,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1994m, Cell:Gahurizo-Rugerero, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers-Gahurizo, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.63333889,
  //       "proposed_bridge_location_gps_longitude": 29.454444,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 65,
  //       "flood_duration_during_rainy_season": "65 times in April, May, October, November and December and it lasts for 4hours after rainfall",
  //       "market_access_blocked_by_river": "Kanazi, Rwishywa, Remera, Gakuta, Rukore, Bigugu, Karanka, Samiyonga, Uwakiza, Cyumuzi villages don't have access to Gasarenda and Kajwangari markets",
  //       "education_access_blocked_by_river": "Rwishywa, Gakuta, Samiyonga villages don't have access to Rugerero Secondary school",
  //       "health_access_blocked_by_river": "Gakuta and Uwakiza villages don't have access to Kivu Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of wheat, charcoal production",
  //       "primary_crops_grown": "wheat",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "They are many villages which uses this crossing regularly and their people were included in the total population to be served(Bigugu, Karanka, samiyonga,Uwakiza, Misundwe, Kivumu, Kintare, Rugerero, Gasezo, Uwamizirikano). The survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 63.4,
  //       "height_differential_between_banks": 4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86H7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bugizi",
  //       "bridge_opportunity_project_code": "1007599",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.53305556,
  //       "bridge_opportunity_gps_longitude": 29.53638889,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 4789,
  //       "bridge_opportunity_comments": "Not Duplicate 3000-6000 people directly served, Elevation:1771m, Cell:Ruramba-Buhoro, Bridge would connecting Nyaruguru-Nyamagabe, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Ruramba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 85m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.53305556,
  //       "proposed_bridge_location_gps_longitude": 29.53638889,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 hour",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 3,4 don't have access to Ruramba Market Communities 1,2,5don't have access to Ryarubondo market",
  //       "education_access_blocked_by_river": "Communities 3,4 don't have access to Ruramba Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 3,4 don't have access to Ruramba Health center.",
  //       "other_access_blocked_by_river": "Communities 3,4 don't have access to Churches services",
  //       "primary_occupations": "Tea plantation workers, daily farmers on both sides and traders at Ruramba market in Nyaruguru and Ryarubondo in Nyamagabe district",
  //       "primary_crops_grown": "bean, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Five people were injured when trying to cross the river and 3 people were drawn and died",
  //       "notes_on_social_information": "Ruramba Market ( Community3,4 ), Ruramba Primary and secondary school ( Community 3,4), Ruramba Health center ( Community3,4 ), Ryarubondo Market ( Community1,2,5 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in June 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gashasho",
  //       "bridge_opportunity_project_code": "1007600",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.71333,
  //       "bridge_opportunity_gps_longitude": 29.3925,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 62,
  //       "bridge_opportunity_individuals_directly_served": 1013,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2255m, Cell:Nkomane, Injuries/Death-1 person injured while crossing the bridge/ No person died while trying to cross the river. Cross river on a normal day->600 people, Nearby city centers--Gashasho -Mahoko, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 50m.-The level difference between two banks is 0.05m(Almost the same).-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two hills.-The soil from the site is clay for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.71333,
  //       "proposed_bridge_location_gps_longitude": 29.3925,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "They use whole roadway",
  //       "days_per_year_river_is_flooded": 18,
  //       "flood_duration_during_rainy_season": "It is likely to flood in April and September but when happens it takes hours",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Karambo primary",
  //       "health_access_blocked_by_river": "Nteranya health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Due to improper current bridge they slipped over it and fell down",
  //       "notes_on_social_information": "Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze - rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirwa",
  //       "bridge_opportunity_project_code": "1013683",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.61152,
  //       "bridge_opportunity_gps_longitude": 29.70026,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1240,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61152,
  //       "proposed_bridge_location_gps_longitude": 29.70026,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gaseke market",
  //       "education_access_blocked_by_river": "Rubaga primary and secondary school",
  //       "health_access_blocked_by_river": "Busengo health center",
  //       "other_access_blocked_by_river": "Busengo Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "People slipped when it was flooded",
  //       "notes_on_social_information": "Karaba village don't have access to rubaga school Korea village don't have access to Gaseke market. Information gathered from Kirwa leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 91,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ieSAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muriba",
  //       "bridge_opportunity_project_code": "1007604",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.7091666,
  //       "bridge_opportunity_gps_longitude": 29.3777,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 20,
  //       "bridge_opportunity_individuals_directly_served": 800,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2027m, Cell:Rusongati, Injuries/Death-Many peoples injured while crossing the bridge./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Gashasho -Mahoko, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 65m.-The level difference between two banks is 2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between a hill and an elevated area.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.7091666,
  //       "proposed_bridge_location_gps_longitude": 29.3777,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Songate primary and secondary school",
  //       "health_access_blocked_by_river": "Nteranya",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Information gathered from neighborhood people",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muduha",
  //       "bridge_opportunity_project_code": "1007617",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.72441,
  //       "bridge_opportunity_gps_longitude": 30.0589,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 52,
  //       "bridge_opportunity_individuals_directly_served": 800,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1515m, Cell:Rutangamundu-Gahororo, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while crossing the river Cross river on a normal day-300-600 people, Nearby city centers--Burega -Muyanza -Kiyanza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Not abvailable / Ntibihaboneka.,Timber-Not abvailable / Ntibihaboneka.,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 30m.-The proposed bridge span is approximately 110m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.72441,
  //       "proposed_bridge_location_gps_longitude": 30.0589,
  //       "current_crossing_method": "Bridge in timber with two logs",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 8,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Kiyanza market, kisigiro coffee factory, gatenderi business center",
  //       "education_access_blocked_by_river": "Gipfundo and Butangampundu primary and secondary school",
  //       "health_access_blocked_by_river": "Burega hospital and Muyanza health center",
  //       "other_access_blocked_by_river": "Catholic and ADPR church",
  //       "primary_occupations": "Daily workers at coffee factory Kisigiro, farmers on both sides , students in Primary and secondary school",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 25,
  //       "incident_descriptions": "Slide and fall in the river. Some had they arms or legs broken and one had been paralyzed due to falling and knocking the head on the rock in river",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna Gaseke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamugari",
  //       "bridge_opportunity_project_code": "1007620",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.66139,
  //       "bridge_opportunity_gps_longitude": 29.88583,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 14,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1717m, Cell:Gitare, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Base, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 12m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 4m.-The space for foundation is sufficient for one side.-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hill and flat area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.7.26",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66139,
  //       "proposed_bridge_location_gps_longitude": 29.88583,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "2 weeks",
  //       "market_access_blocked_by_river": "Sina Gérard factory, Base market",
  //       "education_access_blocked_by_river": "Tare primary and secondary school, Sina Gérard training center",
  //       "health_access_blocked_by_river": "Tare health center",
  //       "other_access_blocked_by_river": "Church services",
  //       "primary_occupations": "Tare health center, Base market",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Up to now no incident has occurred yet, but on the are some got injured and one dead crossing the same river on the other crossing",
  //       "notes_on_social_information": "Data come from community leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HYAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyiri",
  //       "bridge_opportunity_project_code": "1007629",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.68333,
  //       "bridge_opportunity_gps_longitude": 29.89917,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 65,
  //       "bridge_opportunity_individuals_directly_served": 800,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1741m, Cell:Giko, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers- Tare secondary school ), Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 85m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.7.27",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.68333,
  //       "proposed_bridge_location_gps_longitude": 29.89917,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "0.8 km",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Base market, Banana bear factory, farms",
  //       "education_access_blocked_by_river": "No",
  //       "health_access_blocked_by_river": "No",
  //       "other_access_blocked_by_river": "Sector office, churches services",
  //       "primary_occupations": "Market downstream of river, center of business Gashushura-Bubiro on left side, banana bear factor on right side,",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Person died when he was crossing the bridge and that time the river was flooded, two people died beyond of last three years",
  //       "notes_on_social_information": "Person who was in charge of censur of sector Giko",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gakenye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarurama",
  //       "bridge_opportunity_project_code": "1007630",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.75497,
  //       "bridge_opportunity_gps_longitude": 30.08422,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 85,
  //       "bridge_opportunity_individuals_directly_served": 2556,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1472m, Cell:Kiyanza-Kabeza, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while crossing the river Cross river on a normal day-150-300 people, Nearby city centers--Kamahoro -Gaseke, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Not abvailable / Ntibihaboneka.,Timber-Not abvailable / Ntibihaboneka.,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 9m.-The proposed bridge span is approximately 110m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.75497,
  //       "proposed_bridge_location_gps_longitude": 30.08422,
  //       "current_crossing_method": "None, only two stones that are in the river used to crossing",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "kiyanza market and Gaseke major market",
  //       "education_access_blocked_by_river": "Kiyanza secondary and primary school",
  //       "health_access_blocked_by_river": "Kiyanza health center, Remera hospital at district level",
  //       "other_access_blocked_by_river": "Actually, no other way of crossing the river in this location, except stepping on two small stones and jump. Accessing roads on both side is not possible and on both side there are church services",
  //       "primary_occupations": "Students, gaseker market",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 7,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Almost every year took away 1 person , while it is flooded",
  //       "notes_on_social_information": "Population to be served by the bridge is determined based on facilities and destinations people are looking for ,community leaders adjacent to the bridge help giving the number of people who use the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisiza",
  //       "bridge_opportunity_project_code": "1007635",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.76842,
  //       "bridge_opportunity_gps_longitude": 30.06324,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 6898,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1511m, Cell:Kabuga-Kiyanzi, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Musizi -Kiyanzi, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 28m.-The level difference between two banks is 0.04m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat area and an elevated area.-The soil from the site is hard silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.76842,
  //       "proposed_bridge_location_gps_longitude": 30.06324,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3.5 km",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Rusine, Kiyanza and Gasiza markets, crushing stones along side of the river",
  //       "education_access_blocked_by_river": "Karambo primary school in the right side and Kiyanza primary and secondary school to the left side of the river",
  //       "health_access_blocked_by_river": "Kiyanza health center",
  //       "other_access_blocked_by_river": "Football playground on the right side of the river and church services",
  //       "primary_occupations": "Buyers and sellers at Rusine, Kiyanza and Gasiza markets",
  //       "primary_crops_grown": "maiz, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "The river flow with a high speed when it is flooded, the person died trying to cross the river on the existing timber bridge and slide into the river.",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river . Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 83,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HnAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyivugiza",
  //       "bridge_opportunity_project_code": "1007636",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.80183,
  //       "bridge_opportunity_gps_longitude": 30.07574,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 3989,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1462m, Cell:Cyivugiza, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Rusine, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.08m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is n0t sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat area and an elevated area.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.31",
  //       "form_created_by": "kyleshirley taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.80183,
  //       "proposed_bridge_location_gps_longitude": 30.07574,
  //       "current_crossing_method": "There is an existing log bridge",
  //       "nearest_all_weather_crossing_point": "10 minutes",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Peru center (Nyaninyana, Gasharu)",
  //       "education_access_blocked_by_river": "Gasharu Primary and Secondary School (Museum, Mutagata, Gasenga)",
  //       "health_access_blocked_by_river": "Masoro Health Center (Musega, Mutagata, Gasenga)",
  //       "other_access_blocked_by_river": "Mining jobs on both sides of the river. Church. Fetching water.",
  //       "primary_occupations": "Mining. Quarry. Agriculture.",
  //       "primary_crops_grown": "subsistence. beans. maize. sweet potatoes. irish potatoes. bananas. charcoal. goats. cows. pigs.",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "Trying to cross and fell of the existing crossing into the river, got scratches and bruises. Many people have difficulty crossing especially pregnant women",
  //       "notes_on_social_information": "All included villages are villages that cross the bridge daily or weekly for work schools or market access. Population numbers from the villages were unkown so we need to call village of leaders later to obtain the information",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 87,
  //       "height_differential_between_banks": 1.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HoAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihinga",
  //       "bridge_opportunity_project_code": "1007637",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.75328,
  //       "bridge_opportunity_gps_longitude": 30.01969,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 17,
  //       "bridge_opportunity_individuals_directly_served": 4230,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1631m, Cell:Budakiranya, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kirambo, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 26m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.3m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.2",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.75328,
  //       "proposed_bridge_location_gps_longitude": 30.01969,
  //       "current_crossing_method": "No existing bridge",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "1 week",
  //       "market_access_blocked_by_river": "Major market in this area is Remera market and kirambo center",
  //       "education_access_blocked_by_river": "Gihinga secondary school O' level, Remera secondary school A' level and Cyinzuzi Primary",
  //       "health_access_blocked_by_river": "Kinihira Hospital and Kirambo health center",
  //       "other_access_blocked_by_river": "Football playground in Kirambo",
  //       "primary_occupations": "Students, health care at kinihira hospital, farmers on both sides of the river",
  //       "primary_crops_grown": ", maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "One person died, and 3 goats were taken away by the river",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali _Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirambo",
  //       "bridge_opportunity_project_code": "1007642",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.75152,
  //       "bridge_opportunity_gps_longitude": 30.00904,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1100,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1755m, Cell:Rudogo, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kirambo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 20m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.3m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.75152,
  //       "proposed_bridge_location_gps_longitude": 30.00904,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "2hours",
  //       "market_access_blocked_by_river": "Remera market,farmers on both sides",
  //       "education_access_blocked_by_river": "Nursary and Primary of Cyinzuzi, Remera secondary school",
  //       "health_access_blocked_by_river": "Rodogo health center",
  //       "other_access_blocked_by_river": "ADPR churches,",
  //       "primary_occupations": "Sellers and buyers at Remera market",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which requires them to cross the river. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mitabi",
  //       "bridge_opportunity_project_code": "1007647",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.74817,
  //       "bridge_opportunity_gps_longitude": 30.03081,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 2832,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1605m, Cell:Karengeri, Injuries/Death-No person injured while trying to cross the river/ No person died while crossing the river Cross river on a normal day-150-300 people, Nearby city centers--Gasango, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Not abvailable / Ntibihaboneka.,Timber-Not abvailable / Ntibihaboneka.,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.74817,
  //       "proposed_bridge_location_gps_longitude": 30.03081,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 41,
  //       "flood_duration_during_rainy_season": "3 weeks",
  //       "market_access_blocked_by_river": "Kiyanza market and stone crushing",
  //       "education_access_blocked_by_river": "Kiyanza primary school , Gihinga nursary, primary and secondary school",
  //       "health_access_blocked_by_river": "Burega and kirambo health center",
  //       "other_access_blocked_by_river": "Playground and potable water",
  //       "primary_occupations": "Farmers on both side, students at Gihinga Primary and secondary school, buyers and sellers at Rusine and Kiyanza markets",
  //       "primary_crops_grown": "banana, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "2 people died trying to cross the river, they slipped into the river and drowned",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 62.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HzAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitovu",
  //       "bridge_opportunity_project_code": "1007649",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.622647,
  //       "bridge_opportunity_gps_longitude": 29.890423,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 75,
  //       "bridge_opportunity_individuals_directly_served": 2155,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1793m, Cell:Rwamahwa, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Gashushura -Kiruri, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 48m.-The level difference between two banks is 0.8m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a flat and an elevated area.-The soil from the site is silt for both sides. Site Visit November 2017 --> Catholic Church, Secondary School and Feeder Road locate nearly the bridge site at the left side. Despite the high floods which occur in the rainy season, the community usually replace the washed away log timber with the new ones in order to keep the river passable. Any existence of the new safe bridge may benefit more the left side community than the right side one. In November,2017>>>>There are Catholic Church, Secondary School and Feeder Road nearly the bridge site at the left side. Despite the high floods which occur in the rainy season, the community usually replace the washed away log timber with the new ones in order to keep the river passable. Any existence of the new safe bridge may benefit more the left side community than the right side one.",
  //       "form_form_name": "Project Assessment - 2018.8.2",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62269,
  //       "proposed_bridge_location_gps_longitude": 29.89036,
  //       "current_crossing_method": "Bridge in timber(Three logs)",
  //       "nearest_all_weather_crossing_point": "Kiruri/ cellure",
  //       "days_per_year_river_is_flooded": 4,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Base market and Gashushura business center ,",
  //       "education_access_blocked_by_river": "Kiruri primary and secondary school",
  //       "health_access_blocked_by_river": "Mushongi and Marembo health centers",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Accessing Base market, schools, farming on either side of the river",
  //       "primary_crops_grown": "bean, flower, fruit, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Up today no significant incident that happened",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86I1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabamba",
  //       "bridge_opportunity_project_code": "1007660",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.68722,
  //       "bridge_opportunity_gps_longitude": 29.02778,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 22815,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:973m, Cell:Nyange, Injuries/Death-no person known was injured while crossing the river/ no person injured while crossing the river. Cross river on a normal day->600 people, Nearby city centers--Bugarama, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 8 m-The proposed bridge span is 60 m-The level difference between two banks is approximately the same.-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the site-The river bed at the site is unstable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas-The soil from the site is clay for both sides-The site is located between flat areas.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.68722,
  //       "proposed_bridge_location_gps_longitude": 29.02778,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Bugarama market",
  //       "education_access_blocked_by_river": "Kizura primary school",
  //       "health_access_blocked_by_river": "Kizura dispensary",
  //       "other_access_blocked_by_river": "ADPR kizura and churches in city",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "The women who was pregnant and had kid both died trying to cross when The river was flooded",
  //       "notes_on_social_information": "Gikundamvura sector don't have access to bugarama market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Bugarama city",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ICAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mwurire-gatoki",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007670",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.89155,
  //       "bridge_opportunity_gps_longitude": 29.38262,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 1539,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1789m, Cell:Kavumu-Gatare, Injuries/Death-Many peoples injured while crossing the river./ two peoples died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Gakeri -Gasoyo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 34m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.89155,
  //       "proposed_bridge_location_gps_longitude": 29.38262,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Gakeri market and gisiza market",
  //       "education_access_blocked_by_river": "Murunda primary and secondary school",
  //       "health_access_blocked_by_river": "Murunda hospital",
  //       "other_access_blocked_by_river": "There is Catholic church at murunda",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "There are other two people who died in past five years",
  //       "notes_on_social_information": "Mwurire village don't have access to gakeri market and gatoki village dont have access to their farms. Information gathered from gatoki village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 63,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutanzogera",
  //       "bridge_opportunity_project_code": "1007672",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.957,
  //       "bridge_opportunity_gps_longitude": 29.531833,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 82,
  //       "bridge_opportunity_individuals_directly_served": 3437,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2045m, Cell:Ruronde, Injuries/Death-Many peoples injured while crossing the river./ No person known was died while tying to cross the river. Cross river on a normal day->600 people, Nearby city centers--Gashubi -Nturo -Mubano -Kanyana, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at the distance of 2m.-The proposed bridge span is approximately 28m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient -The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.95555,
  //       "proposed_bridge_location_gps_longitude": 29.95166,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 240,
  //       "flood_duration_during_rainy_season": "Four days",
  //       "market_access_blocked_by_river": "Gashubi,birembo and nyangasambu",
  //       "education_access_blocked_by_river": "Ruganda primary school",
  //       "health_access_blocked_by_river": "Kanyana health center",
  //       "other_access_blocked_by_river": "Churches at ruganda and epr karambo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "They fell trying to cross through the river",
  //       "notes_on_social_information": "Market(community 1,2,3). Sec school (none) . Health center (community 2). Farms (community 1,2 and 3). Population information for each village was provided by each village leader and they got data from villagecensus data collected in July 2017.[Dusabe JMV rugesha leader, spriyani sebeza Gasasa leader, Nkurendengane anastase rukeri leader, Ahimana felecien ruganda leader, Ntabareshya J Baptist mubuga leader, ndamyabazungu J Damascene Gisozi leader and ntegekuroro Manuel kirumbi leader.] Population of all adjacent communities includes the following: Rugesha, Gisozi, Gasasa, Rukeri, Ruganda,mubuga and kirumbi Community members inRukeri, Ruganda,mubuga and kirumbi sometimes use this crossing to visit relatives once a month",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Birambo",
  //       "name_of_nearest_paved_or_sealed_road": "Nyange-ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IOAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugarama/mbonwa",
  //       "bridge_opportunity_project_code": "1014596",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.22306,
  //       "bridge_opportunity_gps_longitude": 30.056,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2125,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.22306,
  //       "proposed_bridge_location_gps_longitude": 30.056,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nyagihunima",
  //       "education_access_blocked_by_river": "Nyagihunika",
  //       "health_access_blocked_by_river": "Mareba",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information gathered from local people a",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-kugahembe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHARAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murunda",
  //       "bridge_opportunity_project_code": "1007673",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.915,
  //       "bridge_opportunity_gps_longitude": 29.37083,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 23,
  //       "bridge_opportunity_individuals_directly_served": 3200,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1646m, Cell:Mburamazi, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Gisiza -Murunda, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.915,
  //       "proposed_bridge_location_gps_longitude": 29.37083,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "One day when the river is flooded",
  //       "market_access_blocked_by_river": "Gisiza market",
  //       "education_access_blocked_by_river": "Ecole secondary murunda",
  //       "health_access_blocked_by_river": "Murunda health center",
  //       "other_access_blocked_by_river": "Church at murunda",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Because the current timber bridge is at high elevation people slip and fell over",
  //       "notes_on_social_information": "Information gathered from local people and murunda village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rutsiro",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-rutsiro",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IPAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatomvu",
  //       "bridge_opportunity_project_code": "1007676",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.96638,
  //       "bridge_opportunity_gps_longitude": 29.35777,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 1250,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1527m, Cell:Murambi, Injuries/Death-Many peoples injured while crossing the river./ one person died while trying to cross the river. Cross river on a normal day-< 50 people, Nearby city centers--Congo-Nil, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.96638,
  //       "proposed_bridge_location_gps_longitude": 29.35777,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Congo Nile market",
  //       "education_access_blocked_by_river": "Murama secondary school",
  //       "health_access_blocked_by_river": "Muses health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They drawn trying to cross through the river",
  //       "notes_on_social_information": "Information gathered from gatomvu leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rutsiro",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-rutsiro",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 74,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ISAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatembe",
  //       "bridge_opportunity_project_code": "1007898",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.65575,
  //       "bridge_opportunity_gps_longitude": 29.8198,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 48,
  //       "bridge_opportunity_individuals_directly_served": 8000,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65575,
  //       "proposed_bridge_location_gps_longitude": 29.8198,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Gakenke",
  //       "education_access_blocked_by_river": "Kirebe high school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "The fell in the river when it is flooded and its always dangerous to cross",
  //       "notes_on_social_information": "Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5VbqAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyaruvumu",
  //       "bridge_opportunity_project_code": "1007899",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.3381,
  //       "bridge_opportunity_gps_longitude": 29.6548,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 95,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3381,
  //       "proposed_bridge_location_gps_longitude": 29.6548,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza town",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": "Not feasible: span longer than 100m for suspension bridge and the valley floods for 4 months",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000aA0hfAAC",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karengo",
  //       "bridge_opportunity_project_code": "1008002",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.78583333,
  //       "bridge_opportunity_gps_longitude": 30.0825,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 48,
  //       "bridge_opportunity_individuals_directly_served": 7767,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 9-26-18",
  //       "form_form_name": "Project Assessment - 2017.8.16",
  //       "form_created_by": "Stephanie May",
  //       "proposed_bridge_location_gps_latitude": -1.78583333,
  //       "proposed_bridge_location_gps_longitude": 30.0825,
  //       "current_crossing_method": "Fjording by foot",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "Depends on the rain intensity; many times the flood lasts 2 days",
  //       "market_access_blocked_by_river": "As the citizens fjord across, during the rainy season there is no access to school and markets",
  //       "education_access_blocked_by_river": "Primary and secondary schools are not accessible especially during rainy season",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Access to the sugar cane field is difficult to harvest. Both citizens of Karengo cell use Kiyanza and Ntarabana markets so this river has blocked them to access market during the rainy season",
  //       "primary_occupations": "Quarrying",
  //       "primary_crops_grown": "sugar can",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "When that citizen was fjording by foot across the river he was carried for 30m and he was injured",
  //       "notes_on_social_information": "Normally Karengo Community's daily life is crushing stones and workin g in the sugar cane field",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rusine",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": 1.59,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000aATjCAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarurembo",
  //       "bridge_opportunity_project_code": "1009066",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": null,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2017.9.29",
  //       "form_created_by": "Abbie Noriega",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "NYAMYIRI Timber bridge",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "8 hours",
  //       "market_access_blocked_by_river": "this bridges will facilitate the exchange of goods from TERIMBERE and KABILIZI cell",
  //       "education_access_blocked_by_river": "sometimes,students don?t attend the class or spend nights not at their homes in rain season",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "commerce, agriculture and Human-Powered Transport",
  //       "primary_crops_grown": ", , bean, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "these peoples were passing on moto , timber deck broke out so the passengers fell down",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Rugerero Centre",
  //       "name_of_nearest_paved_or_sealed_road": "RUBAVU-MUSANZE",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000aSNCRAA4",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyaruhombo",
  //       "bridge_opportunity_project_code": "1009280",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.41201,
  //       "bridge_opportunity_gps_longitude": 29.67439,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2373,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.41201,
  //       "proposed_bridge_location_gps_longitude": 29.67439,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Ruhondo market (Community 1,2), Rugogwe Market (3,4), Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Kirambi Primary and Secondary School (Community 1,2)",
  //       "health_access_blocked_by_river": "No health access blocked by river",
  //       "other_access_blocked_by_river": "Kirambi Catholic Parish (Community 1,2)",
  //       "primary_occupations": "Agriculture and Brick making",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "2 people died trying to cross the river and both were children",
  //       "notes_on_social_information": "Bweru, Mpaza, Gasharu and Kamwambi villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and farms. The population information for each village was provided by the Nyaruhombo Cell Leader, Spéciose Umutesi, from the population data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000aWV5fAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buyoga",
  //       "bridge_opportunity_project_code": "1009296",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.930371,
  //       "bridge_opportunity_gps_longitude": 29.779313,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1550,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.13",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.930371,
  //       "proposed_bridge_location_gps_longitude": 29.779313,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "700 m",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "April , May , 8 hours",
  //       "market_access_blocked_by_river": "Rutongo market ( 1), nyabikenke ( 1), ruhimbi ( 2), farming ( 1,2).",
  //       "education_access_blocked_by_river": "Butare secondary & primary school ( 1), ngoma primary school ( 1)",
  //       "health_access_blocked_by_river": "Poste de Santa ngoma( 1), buramba health center ( 1)",
  //       "other_access_blocked_by_river": "Ngoma church ( 1l",
  //       "primary_occupations": "Farming and mining activities",
  //       "primary_crops_grown": "banana, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by village leader , Anselme who sourced the data from village book monthly record.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65,
  //       "height_differential_between_banks": 3.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ary6hAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Runyombya",
  //       "bridge_opportunity_project_code": "1009313",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.77142,
  //       "bridge_opportunity_gps_longitude": 29.529766,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5579,
  //       "bridge_opportunity_comments": "Need to check river meandering and more on right side before pursuing",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.77142,
  //       "proposed_bridge_location_gps_longitude": 29.529766,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "50 times in April, May, October, November and December and it lasts for 4hours after rainfall",
  //       "market_access_blocked_by_river": "Murambi, Mirindi villages as well some villages of Munini sector don't have access to Gatunda market",
  //       "education_access_blocked_by_river": "Mirindi, Murambi, Runyami villages don't have access to Runyombyi Primary and Secondary school",
  //       "health_access_blocked_by_river": "Mirindi, Murambi, Uwinteko,Runyami villages don't have access to Runyombyi Health Center",
  //       "other_access_blocked_by_river": "Sector office",
  //       "primary_occupations": "Farming of sweet potatoes, beans, banana",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44.8,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000asF27AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyuzu",
  //       "bridge_opportunity_project_code": "1009426",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.85109,
  //       "bridge_opportunity_gps_longitude": 29.666005,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 81,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18. Rejected for FY19 construction by Etienne Mutebutsi on 30-11-18 because all Muhanga Bridges (Cyuzu and Rukurazo) were replaced by Huye ones (Gahororo and Karambi)",
  //       "form_form_name": "Project Assessment - 2018.12.13",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85109,
  //       "proposed_bridge_location_gps_longitude": 29.666005,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The span will longer than existing engineering scope . In addition to that the flood take one or two week. Over two hundred meters.",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000atGB5AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagakizi",
  //       "bridge_opportunity_project_code": "1009714",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.533333,
  //       "bridge_opportunity_gps_longitude": 30.173611,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1216,
  //       "bridge_opportunity_comments": "Health Center of Nyagihanga, Nyagihanga Primary School are the social services people are looking for by the use of Nyagakizi Bridge at Gatsibo District. Nyagakizi Bridge is made of non strong timber. When Rwashambura floods, the alternative crossing point is 2 km downstream",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.53328,
  //       "proposed_bridge_location_gps_longitude": 30.1727,
  //       "current_crossing_method": "Timber?",
  //       "nearest_all_weather_crossing_point": "0.800 km",
  //       "days_per_year_river_is_flooded": 24,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Markert on right side, farms on both side",
  //       "education_access_blocked_by_river": "Primary and secondary school on left side",
  //       "health_access_blocked_by_river": "Health center on left side",
  //       "other_access_blocked_by_river": "Churches on both side,",
  //       "primary_occupations": "Health center, school on right side, Market on left side, farms,",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and from different communities",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMK1XAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyahafi",
  //       "bridge_opportunity_project_code": "1010422",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.14156,
  //       "bridge_opportunity_gps_longitude": 29.63501,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 1221,
  //       "bridge_opportunity_comments": "There exist a sipmle timber bridge,sometimes it flooded and water goes beyond the river bank up to1 m. The last flooding took arround 7 days to reach the normal level.The bridge is passable by the people only. Materials can be transported on site easily by the vehicle",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14156,
  //       "proposed_bridge_location_gps_longitude": 29.63501,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge Seven kilometers away",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 week",
  //       "market_access_blocked_by_river": "MUTARA Market",
  //       "education_access_blocked_by_river": "MUTARA and Muremure Primary School",
  //       "health_access_blocked_by_river": "Mutara Health Center",
  //       "other_access_blocked_by_river": "MUTARA Catholic church",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "NR7 (Kigali - Karongi)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 102,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bgzEaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihororo",
  //       "bridge_opportunity_project_code": "1010427",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.12117,
  //       "bridge_opportunity_gps_longitude": 29.6109,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 120,
  //       "bridge_opportunity_individuals_directly_served": 1408,
  //       "bridge_opportunity_comments": "There was ever a bridge,people cross the river by a traditional boat",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12117,
  //       "proposed_bridge_location_gps_longitude": 29.6109,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "20 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "1 month",
  //       "market_access_blocked_by_river": "Nyange Market",
  //       "education_access_blocked_by_river": "Munzanga School",
  //       "health_access_blocked_by_river": "Munzanga Health Center",
  //       "other_access_blocked_by_river": "Mujyojyo Catholic Church",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, potato",
  //       "river_crossing_deaths_in_last_3_years": 14,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": "People have been drowning when they were trying to cross the river by swimmingor by boat.",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "RN7 (Kigali - Karongi)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 108,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bh0JKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karama_Muhengeri",
  //       "bridge_opportunity_project_code": "1010917",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.671847,
  //       "bridge_opportunity_gps_longitude": 30.057339,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 1619,
  //       "bridge_opportunity_comments": "There is no longer an existence of timbers to Karama Bridge, the commuinty just pass through the water Karama bridge . Gitumba Secondary School and Mutete health center are social services needed by the community while crossing the river.In case of flooding,the nearest crossing point is at 7km from Karama Bridge.",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66992,
  //       "proposed_bridge_location_gps_longitude": 30.05585,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Market,church, school, health center on both side, maize factor(Isaro) right side of the river,",
  //       "education_access_blocked_by_river": "Both side primary and secondary school",
  //       "health_access_blocked_by_river": "Health center both side but the closer one is on right side, and on left side there is post of health",
  //       "other_access_blocked_by_river": "Churches on both sides",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "soghrom",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They was died when they are trying to cross the river and it was flooded",
  //       "notes_on_social_information": "Information given by people who were cultivating near to the proposed site, one of them was in charge of security of Karama community and the team was compose of different communities which used the crossing existing even they don't have bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Base_Kisaro_ nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5ivZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhondo",
  //       "bridge_opportunity_project_code": "1010919",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.693048,
  //       "bridge_opportunity_gps_longitude": 30.06977,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1177,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.693048,
  //       "proposed_bridge_location_gps_longitude": 30.06977,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Kavumu Market (Gahororo) Gatumba (Karambi)",
  //       "education_access_blocked_by_river": "Musenyi secondary school, Mutandi primary school (Gahororo), Gatumba secondary school (Karambi)",
  //       "health_access_blocked_by_river": "Musenyi Health center (Gahororo)",
  //       "other_access_blocked_by_river": "All churches are on side Mutandi (Gahororo)",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was trying to cross the bridge when it was flooded and fell into river and found died",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Byumba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5jCGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rebero",
  //       "bridge_opportunity_project_code": "1013680",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.94498,
  //       "bridge_opportunity_gps_longitude": 29.34985,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2720,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94498,
  //       "proposed_bridge_location_gps_longitude": 29.34985,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gisozi market at Gisozi cell",
  //       "education_access_blocked_by_river": "Muhororo primary school in muhororo village",
  //       "health_access_blocked_by_river": "Gataka hospital in gataka village",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "The people fell in the river in usual days because the river is always dangerous to cross",
  //       "notes_on_social_information": "Rebero don't have access to farms. Gasharu village don't have access to gataka hospital.information gathered from gasharu leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gisiza",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57.2,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ideAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruganda",
  //       "bridge_opportunity_project_code": "1011301",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.91924,
  //       "bridge_opportunity_gps_longitude": 29.47704,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1756,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2271m, Cell:Remera, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-< 50 people, Nearby city centers--Rusebeya, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.91924,
  //       "proposed_bridge_location_gps_longitude": 29.47704,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nyagasambu",
  //       "education_access_blocked_by_river": "Mberi primary and secondary school",
  //       "health_access_blocked_by_river": "Remera health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Ruganda village don't have access to remera health center and nturo village don't have access to nyagasambu market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Congonile",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME4TAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisozi",
  //       "bridge_opportunity_project_code": "1011310",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9536111,
  //       "bridge_opportunity_gps_longitude": 29.53222,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 3230,
  //       "bridge_opportunity_comments": "Not a Duplicate. 3000-6000 people directly served, Elevation:2042m, Cell:Kanyana-Ruronde, Bridge would connecting Ngororero-Rutsiro, Injuries/Death-Many peoples injured while crossing the river./ No person known was died while tying to cross the river. Cross river on a normal day->600 people, Nearby city centers--Gashubi -Nturo -Mubano -Kanyana, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at the distance of 4m.-The proposed bridge span is approximately 32m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient -The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9536111,
  //       "proposed_bridge_location_gps_longitude": 29.53222,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Rusumo market",
  //       "education_access_blocked_by_river": "Ruganda nursery",
  //       "health_access_blocked_by_river": "Kanyana health center",
  //       "other_access_blocked_by_river": "Churches at both sides",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "sorghum",
  //       "river_crossing_deaths_in_last_3_years": 17,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They fell when the river was flooded",
  //       "notes_on_social_information": "Market(community 2). Sec school (None ). Healthy center (community 1 and 3). Farms (community 1,2,and 3).Population information for each village was provided by each village leader [ndamyabazungu J Damascene Gisozi leader, Dusabe JMV Rugesha leader, kirumbi leader ntegekuroro Manuel and kanyana cell leader nyiramanywa Donatile] Population of all adjacent communities includes the following: kirumbi, mubuga , ruganda,Gisozi and rugesha. Community members in kirumbi and mubuga and some of kanyana cell members do cross to visit their relatives twice amonth",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Birembo",
  //       "name_of_nearest_paved_or_sealed_road": "Kibuye-nyange",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 100,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME5MAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusayo",
  //       "bridge_opportunity_project_code": "1012004",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.96222,
  //       "bridge_opportunity_gps_longitude": 29.461388,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 108,
  //       "bridge_opportunity_individuals_directly_served": 2200,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.96222,
  //       "proposed_bridge_location_gps_longitude": 29.461388,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Yagasambu",
  //       "education_access_blocked_by_river": "Gs mukore secondary and primary school",
  //       "health_access_blocked_by_river": "Kabona health center in kamberi cell",
  //       "other_access_blocked_by_river": "Church at mukore",
  //       "primary_occupations": "Students and marketing services",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Before constructing timber bridge people used to fall and when it rained student failed to cross and make holiday",
  //       "notes_on_social_information": "Information gathered from local people sent by cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rutsiro",
  //       "name_of_nearest_paved_or_sealed_road": "Rutsiro-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cx4bNAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinyanja",
  //       "bridge_opportunity_project_code": "1012433",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.790933,
  //       "bridge_opportunity_gps_longitude": 29.381622,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 73,
  //       "bridge_opportunity_individuals_directly_served": 1852,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.8.6",
  //       "form_created_by": "Solange Yandereye",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Fording",
  //       "nearest_all_weather_crossing_point": "none",
  //       "days_per_year_river_is_flooded": 112,
  //       "flood_duration_during_rainy_season": "2.5days",
  //       "market_access_blocked_by_river": "no market access is blocked by this river",
  //       "education_access_blocked_by_river": "No blocked education since there the left side of the river is only zoo beyond that zoo there Gishwati natural forest",
  //       "health_access_blocked_by_river": "no health access blocked by this river here at this site ,only people uses this site when going to collect milk",
  //       "other_access_blocked_by_river": "none other than accessing the animals(cows ,sheep and goat ) as well as milk production",
  //       "primary_occupations": "animal keeping",
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 73,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cPRfwAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buterana",
  //       "bridge_opportunity_project_code": "1012548",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.18748,
  //       "bridge_opportunity_gps_longitude": 29.81693,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3241,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.20",
  //       "form_created_by": "kyleshirley taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18748,
  //       "proposed_bridge_location_gps_longitude": 29.81693,
  //       "current_crossing_method": "Wading/fording",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Farms (1,2,3,4,5); Ruhango market (2,3), Vunga market (1,4,5),",
  //       "education_access_blocked_by_river": "Cyizibere Sec School & primary school (1,4,5)",
  //       "health_access_blocked_by_river": "Cyizibere Health center (1,4,5)",
  //       "other_access_blocked_by_river": "Cyizibere Church (1,4,5) weekly",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, casava, corn, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": "Could be the same three deaths as Nyangandika site",
  //       "notes_on_social_information": "Population data provided by the cell leader. Data is adjusted from last census.",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gitarama",
  //       "name_of_nearest_paved_or_sealed_road": "Ruhango - Gitarama rd",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhpDeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Banga",
  //       "bridge_opportunity_project_code": "1012550",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6897222,
  //       "bridge_opportunity_gps_longitude": 29.80888,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 600,
  //       "bridge_opportunity_comments": "Adjacent community is 540 ;400 people fro Murambi cell,100 students from Mbataba Sector and 40 people from Mutara Sector that go to pray in ADEPER to Ndora cell.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6897222,
  //       "proposed_bridge_location_gps_longitude": 29.80888,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "30 minutes",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "60",
  //       "market_access_blocked_by_river": "Rukura market and gakenke",
  //       "education_access_blocked_by_river": "Rukura nursery primary secondary school",
  //       "health_access_blocked_by_river": "Kirambo health center and post health center in buheta",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Going to church , farming and marketing",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "In about 13 years there is a man who died while crossing",
  //       "notes_on_social_information": "Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhpEmAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukaka",
  //       "bridge_opportunity_project_code": "1012800",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.62147,
  //       "bridge_opportunity_gps_longitude": 29.96712,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 95,
  //       "bridge_opportunity_individuals_directly_served": 2456,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62147,
  //       "proposed_bridge_location_gps_longitude": 29.96712,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 8,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Miyove market, kinihira tea factory",
  //       "education_access_blocked_by_river": "Mukaka primary and nursing school, miyove secondary and rukuzo secondary school",
  //       "health_access_blocked_by_river": "Mukaka health center , miyove health center",
  //       "other_access_blocked_by_river": "Catholic church in Mukaka and Protestants church in Kibare/Miyove",
  //       "primary_occupations": "Students and teachers, farmers on both sides, and traders in Miyove market",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 7,
  //       "river_crossing_injuries_in_last_3_years": 14,
  //       "incident_descriptions": "Flooded take them away",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kr4AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nkegete",
  //       "bridge_opportunity_project_code": "1012807",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.91078,
  //       "bridge_opportunity_gps_longitude": 29.77379,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1441,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.91078,
  //       "proposed_bridge_location_gps_longitude": 29.77379,
  //       "current_crossing_method": "Stones",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 3,
  //       "flood_duration_during_rainy_season": "No flood",
  //       "market_access_blocked_by_river": "Remera market",
  //       "education_access_blocked_by_river": "GS Kanyanza ,GS Nyabikenke",
  //       "health_access_blocked_by_river": "Kanyanza poste de Sante and Kiyumba Health center",
  //       "other_access_blocked_by_river": "Kanyanza church",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "People from Two villages are crossing this river to their activities and this bridge is very useful for people who are going to market",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6ksKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwarasita",
  //       "bridge_opportunity_project_code": "1012809",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.92495,
  //       "bridge_opportunity_gps_longitude": 29.78201,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2101,
  //       "bridge_opportunity_comments": "Rwanda - Peru - 1009279, which was technically rejected, was a duplicate. Records merged 2020.10.09.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92495,
  //       "proposed_bridge_location_gps_longitude": 29.78201,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point, they are just walking through the water",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "Flood occurs during heavy rain and takes 2 days",
  //       "market_access_blocked_by_river": "Remera market, Murara market",
  //       "education_access_blocked_by_river": "GS Nyabikenke",
  //       "health_access_blocked_by_river": "GS Nyabikenke",
  //       "other_access_blocked_by_river": "Ngoma church",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": ", banana potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People are not scared about the river but the river is so dangerous , so by crossing the get fall inside",
  //       "notes_on_social_information": "The village leader of Peru told me the number of people from his village who are crossing the bridge and through phone call I asked village leader of Buyoga number of his people who are crossing",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 147,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kstAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamiranzogera",
  //       "bridge_opportunity_project_code": "1012810",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.93662,
  //       "bridge_opportunity_gps_longitude": 29.73471,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 44,
  //       "bridge_opportunity_individuals_directly_served": 3200,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.93662,
  //       "proposed_bridge_location_gps_longitude": 29.73471,
  //       "current_crossing_method": "Stones",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "floods are occurring during the heavy rain",
  //       "market_access_blocked_by_river": "Remera market, and Musasa market",
  //       "education_access_blocked_by_river": "Gs Kibyimba and Kabacuzi ps",
  //       "health_access_blocked_by_river": "Kibyimba health center",
  //       "other_access_blocked_by_river": "Kabacuzi church",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "There was a man who was crossing the river then fall in it.",
  //       "notes_on_social_information": "The chief of security in Kabuga cell was there to tell me some information about people who are crossing the river",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kt3AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mushepari",
  //       "bridge_opportunity_project_code": "1012811",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.696388,
  //       "bridge_opportunity_gps_longitude": 29.273055,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 42,
  //       "bridge_opportunity_individuals_directly_served": 1900,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.696388,
  //       "proposed_bridge_location_gps_longitude": 29.273055,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "They pass along way in ndobogo using a Vehicular bridge in one kilometer and half",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Gisenyi",
  //       "education_access_blocked_by_river": "Ndobogo primary and secondary",
  //       "health_access_blocked_by_river": "Gisenyi hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Doing businesses from rubavu to goma",
  //       "primary_crops_grown": "banana, bean",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "A man passed over the current bridge when it was flooded",
  //       "notes_on_social_information": "Information gathered from local people and cell leader",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kvJAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarusange",
  //       "bridge_opportunity_project_code": "1012815",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9955,
  //       "bridge_opportunity_gps_longitude": 29.3925,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1750,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9955,
  //       "proposed_bridge_location_gps_longitude": 29.3925,
  //       "current_crossing_method": "TwoTree logs",
  //       "nearest_all_weather_crossing_point": "No where",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "One day for river when flooded to allow a kid to cross",
  //       "market_access_blocked_by_river": "Congo nile",
  //       "education_access_blocked_by_river": "Bumba high school",
  //       "health_access_blocked_by_river": "Mushubati health center",
  //       "other_access_blocked_by_river": "Coffee industry in mageragera cell",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They fell in the river trying to cross",
  //       "notes_on_social_information": "Information gathered from local people who stays near bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rutsiro-kibuye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kvdAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rurongora",
  //       "bridge_opportunity_project_code": "1012816",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.34152,
  //       "bridge_opportunity_gps_longitude": 29.466329,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 84,
  //       "bridge_opportunity_individuals_directly_served": 1962,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34152,
  //       "proposed_bridge_location_gps_longitude": 29.466329,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "12hours, April, May, December, November",
  //       "market_access_blocked_by_river": "Kaduha market is blocked to the community from LHS of river, Mushubi market is blocked by river for The RHS ' community",
  //       "education_access_blocked_by_river": "Mushubi secondary school, Mushubi primary school",
  //       "health_access_blocked_by_river": "Mushubi health center",
  //       "other_access_blocked_by_river": "Churches in Mushubi, Gashwati",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": ", sorghum, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on the bridge trying to cross the river and fell down into the river and drown",
  //       "notes_on_social_information": "People from the village near the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kx0AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagisumo",
  //       "bridge_opportunity_project_code": "1012820",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.332691,
  //       "bridge_opportunity_gps_longitude": 29.466929,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2272,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.332691,
  //       "proposed_bridge_location_gps_longitude": 29.466929,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "3 hours after rain fall, it's flood during April, May, September to November.",
  //       "market_access_blocked_by_river": "Farming on both side of river, kaduha market is blocked to the LHS of river, and Mushubi market is blocked to the people from the RHS.",
  //       "education_access_blocked_by_river": "Nyagisumo primary school is blocked for the people from The RHS and secondary school located in musenyi kaduha on the RHS is a also blocked.",
  //       "health_access_blocked_by_river": "Mushubi health center is blocked for The RHS and kaduha hospital is also blocked by river to the LHS of river.",
  //       "other_access_blocked_by_river": "People from Nyagisumo on LHS are blocked to church in kaduha-musenyi",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": ", banana, bean, cassava, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drown while crossing the river",
  //       "notes_on_social_information": "Village leader and the people from the community near the bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": 4.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kxeAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sodoma",
  //       "bridge_opportunity_project_code": "1012823",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -2.014133,
  //       "bridge_opportunity_gps_longitude": 29.614267,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 66,
  //       "bridge_opportunity_individuals_directly_served": 2600,
  //       "bridge_opportunity_comments": "The Sodoma Bridge was rejected because it wasn't deemed most priority by Ngororero District; it was instead replaced by Kivomo.",
  //       "form_form_name": "Project Assessment - 2018.12.8",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.014133,
  //       "proposed_bridge_location_gps_longitude": 29.614267,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Nyange sector don't have access to bambiro market",
  //       "education_access_blocked_by_river": "Nyange sector don't have access to GS Bambiro",
  //       "health_access_blocked_by_river": "Ndaro sector don't have access to Nyange health center",
  //       "other_access_blocked_by_river": "Ndaro sector office is blocked right , whereas Nyange sector is blocked at left",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One person died here",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero - Karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6lDDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamushi",
  //       "bridge_opportunity_project_code": "1012830",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.33542,
  //       "bridge_opportunity_gps_longitude": 29.67251,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 3708,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.18",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.33542,
  //       "proposed_bridge_location_gps_longitude": 29.67251,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May, It last for 3 to 4 hours",
  //       "market_access_blocked_by_river": "Rurangazi market blocked for people on the right side of the river, Mucubira and Kigogo market blocked for people on the Left side of the river",
  //       "education_access_blocked_by_river": "Nyarusange Primary and Secondary school blocked for people on the right side; Nyabinyenga Primary and Secondary school blocked for people on the left side of the river",
  //       "health_access_blocked_by_river": "Nyarusange Health center blocked for people on the right side of the river",
  //       "other_access_blocked_by_river": "Adventist church blocked for people on the right side, Nyabinyenga Catholic Church blocked for people on the left side of the river",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cassava, potato, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders. They have updated numbers of population in their villages",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6mY6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu",
  //       "bridge_opportunity_project_code": "1012831",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.31422,
  //       "bridge_opportunity_gps_longitude": 29.69336,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 3531,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.18",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.31422,
  //       "proposed_bridge_location_gps_longitude": 29.69336,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May it last for 1 day",
  //       "market_access_blocked_by_river": "Kibogo, nyanza market blocked for people on the RHS, rurangazi market blocked for people on the LHS",
  //       "education_access_blocked_by_river": "Nyabinyenga primary school blocked for people on the LHS",
  //       "health_access_blocked_by_river": "Nyabinyenga Health center blocked for people on the LHS",
  //       "other_access_blocked_by_river": "Nyabinyenga Catholic Church blocked for people on the LHS",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "2 deaths, one child was going to school. Many others are rescued and taken to health center.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6mYGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bushyita",
  //       "bridge_opportunity_project_code": "1012947",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.95197033,
  //       "bridge_opportunity_gps_longitude": 29.77510744,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4047,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.95197033,
  //       "proposed_bridge_location_gps_longitude": 29.77510744,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No nearest point, the",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "The river floods during heavy rain in April, 2 hours of flooding",
  //       "market_access_blocked_by_river": "Rutongo market, Kibaya market",
  //       "education_access_blocked_by_river": "Gs Butare , Butare PS",
  //       "health_access_blocked_by_river": "Rutongo health center",
  //       "other_access_blocked_by_river": "Butare cell office",
  //       "primary_occupations": "The Most occupation here the people are farmers they cross the bridge going to their farms",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "As the river flowing the people want to go to the other side then walking in water they fall in.",
  //       "notes_on_social_information": "Gihinga Village people are crossing the river going to the kibaya market,schools and in their farm, Karambo village people are crossing to Rutongo market ,schools and farms while Buyoga are the one who go to Rutongo market ,GS Butare and in their farm. The information are from village leaders of Gihinga ,Buyoga and karambo and they referred to 2016 population census .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga -Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wBUAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuvungwa",
  //       "bridge_opportunity_project_code": "1012948",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.984992,
  //       "bridge_opportunity_gps_longitude": 29.73314,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.20",
  //       "form_created_by": "kyleshirley taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.984992,
  //       "proposed_bridge_location_gps_longitude": 29.73314,
  //       "current_crossing_method": "Wading, fording",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "2 hrs",
  //       "market_access_blocked_by_river": "Musasa market(Gotwa and Munzereri villages), kagarama market(Cyinyoni, Mpanga and Gakondokondo villages), kabuga market(Cyinyoni,Mpanga and Gakondokondo villages)",
  //       "education_access_blocked_by_river": "Kibanda Primary School (Cyinyoni, Mpanga and Gakondokondo villages), Buramba Primary Secondary School (Gotta and Munzereri Villages)",
  //       "health_access_blocked_by_river": "Buramba Health Center(Munzereri and Gitwa Villages)",
  //       "other_access_blocked_by_river": "Mining(Mpanga, Cyinyoni and Buramba Villages), clay tile fabrication(Munzereri, Gitwa Villages), Catholic and ADEPER church ( Cyinyoni, Mpanga, Gakondokondo villages)",
  //       "primary_occupations": "Agriculture, business , fabrication of clay tiles, mining",
  //       "primary_crops_grown": "banana, bean, casava, soja, sweet poteto",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "At night two people were crossing the river and did not realize how strong/high the river was and they were swept away and drowned",
  //       "notes_on_social_information": "Village chairman provided population data for mhanga, chinyoni, gitwa. Numbers are From national census 2012 and being adjusted as someone moved ,born or die. Assessor will call village chairmen for the other 2 villages",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga_Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 3.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wBZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwabagenzi",
  //       "bridge_opportunity_project_code": "1012952",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.04202456,
  //       "bridge_opportunity_gps_longitude": 29.7725994,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 58,
  //       "bridge_opportunity_individuals_directly_served": 4514,
  //       "bridge_opportunity_comments": "Comparing the media taken during Need Assessment Validation , the initial recorded coordinates (-2.04202456,29.7725994)found that they were wrong>>>>>>Jan,2020",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.04202456,
  //       "proposed_bridge_location_gps_longitude": 29.7725994,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": "Muhanga Market",
  //       "education_access_blocked_by_river": "Kitaka ps and ,kivoma ps",
  //       "health_access_blocked_by_river": "Mata health center",
  //       "other_access_blocked_by_river": "Muhanga district office",
  //       "primary_occupations": "Most of people here are farmer they cross the bridge going to cultivate in their farms , potatoes plantation is the common agricultural product here .",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "Muhanga Market ( kiyoro, Muhanga, rwabagenzi ) , Mata health center ( rwabagenzi, Kantonganiye) , kivomo ps(Rwabagenzi village ) . Census 2018 is the main reference I determination of individual served .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga -Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wBtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhunde",
  //       "bridge_opportunity_project_code": "1012956",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.77785489,
  //       "bridge_opportunity_gps_longitude": 29.67587526,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 46,
  //       "bridge_opportunity_individuals_directly_served": 2851,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.77785489,
  //       "proposed_bridge_location_gps_longitude": 29.67587526,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "Flood take 1 hour during heavy rain",
  //       "market_access_blocked_by_river": "Gitega market and Ruhango market",
  //       "education_access_blocked_by_river": "GS Nyabinoni ,ETG- Gitumba",
  //       "health_access_blocked_by_river": "Nyabinoni health center",
  //       "other_access_blocked_by_river": "Nyabinoni sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "Nyarusange primary school ( Gitwa village, Gitega village ),ETG- Gitumba ( Gitwa village, Gitega village ), Ruhango market ( Gitwa village, Gitega village ),GS Nyabinoni ( gitaba village , karengere village ,murama village , nyarusange village ) , Gitega market ( gitaba village , karengere village ,murama village , nyarusange village ) . All info are provided by Murama village leader referred to 2017 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wCDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabavu(ruhanga)",
  //       "bridge_opportunity_project_code": "1012980",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.346276,
  //       "bridge_opportunity_gps_longitude": 29.420032,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2010,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.346276,
  //       "proposed_bridge_location_gps_longitude": 29.420032,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "From April to May, from October to December, after 4 hours they can cross",
  //       "market_access_blocked_by_river": "Market (villages 1,2)",
  //       "education_access_blocked_by_river": "Secondary school (vilages 1,2)",
  //       "health_access_blocked_by_river": "Health center(villages 1,2)",
  //       "other_access_blocked_by_river": "Churches(villages 1,2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, flour, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by gishenge village leader, wellars Bigirimvano who has called every village leader of all adjacent community, which they correct the information from population record done in 2016. Population of all adjacent communities includes the following villages: Gishenge, Kibuga, Ruhanga and Bimba. The community members in Ruhanga and Bimba sometimes they cross river to do farming, to visit relatives",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wI5AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bishenge(Masuma)",
  //       "bridge_opportunity_project_code": "1012983",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.345908,
  //       "bridge_opportunity_gps_longitude": 29.409702,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2818,
  //       "bridge_opportunity_comments": "Not duplicate",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.345908,
  //       "proposed_bridge_location_gps_longitude": 29.409702,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "Flood duration begin from April to May, September to December, and february",
  //       "market_access_blocked_by_river": "Market(villages 4,5), farms ( villages 1,2 3), tee factories(villages 1,2,3)",
  //       "education_access_blocked_by_river": "Primary school(villages 1,2,3), secondary school (villages 1,2,3)",
  //       "health_access_blocked_by_river": "Health center(villages 1,2,3)",
  //       "other_access_blocked_by_river": "Places of worship (villages 1,2,3)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They fell on the timber and fractured",
  //       "notes_on_social_information": "The population information for all included adjacent communities was given by the village's leader of all the villages through the meeting, the numbers of all population was delivered from the record made by the cell in 2016. The community members in Gishenge, Kibuga, Gakomeye, Mutengeli, Tubuye and Ruhinga use the bridge to visit the market, to farm, to go to the churches, or to the health service. Their student also cross the river the school every day.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wIKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusoyo",
  //       "bridge_opportunity_project_code": "1012984",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.276669,
  //       "bridge_opportunity_gps_longitude": 29.411297,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3958,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.276669,
  //       "proposed_bridge_location_gps_longitude": 29.411297,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "15 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "Flood happen from April to May, December and February, 48 hours",
  //       "market_access_blocked_by_river": "Market(villages 1,,2,3,4), farms(1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Primary school(village 1,2,3,4)",
  //       "health_access_blocked_by_river": "Health center(villages 1,2,3,4,5)",
  //       "other_access_blocked_by_river": "Churches(village 1,2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, maiz, potato, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Trying to cross the river and drowned",
  //       "notes_on_social_information": "The information related to the population in the adjacent communities was provided by cell leaders of each villages with the help of Rusoyo village leader, Elias Sebantu. Population of all adjacent communities includes the following: Rusoyo, Musaraba, Rangi, Gihundwe and kavumu, Rugogwe. The people all given villages they cross the river to visit market, to the health center, or to the chuches",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 68,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wIUAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamabuye",
  //       "bridge_opportunity_project_code": "1013011",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.30024,
  //       "bridge_opportunity_gps_longitude": 29.6845,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 4710,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.30024,
  //       "proposed_bridge_location_gps_longitude": 29.6845,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May, it last for 2 hours",
  //       "market_access_blocked_by_river": "Mucubira Market (Community 1,4,5); Rubona and Buhanda Markets (Community 2,3)",
  //       "education_access_blocked_by_river": "Nyabinyenga primary and secondary school (Community 1,4,5)",
  //       "health_access_blocked_by_river": "Nyabinyenga Health Center (Community 1,4,5)",
  //       "other_access_blocked_by_river": "Nyabinyenga Catholic Church and Taba Adventist Church (Community 1,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 24,
  //       "incident_descriptions": "Many people have been falling into the river during rainy season and were rescued.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders from the population data they collect every year.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru )",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muturagara-Gatobo",
  //       "bridge_opportunity_project_code": "1013025",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.67321,
  //       "bridge_opportunity_gps_longitude": 29.57457,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4470,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67321,
  //       "proposed_bridge_location_gps_longitude": 29.57457,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 hours",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day in April",
  //       "market_access_blocked_by_river": "Rurambo market open every Monday and Friday is blocked to communities from right side of the river and mubayu market, terrace makings works that employ many people",
  //       "education_access_blocked_by_river": "Rurambo primary and secondary schools are blocked to communities from right side",
  //       "health_access_blocked_by_river": "Rurambo health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Rurembo sector office, Rurembo Parish(Catholic ) blocked to communities of right side, Protestants church blocked to communities of left",
  //       "primary_occupations": "Rurembo market traders and local farmers on small scale, workers in terrace making",
  //       "primary_crops_grown": "maiz, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "In recent years, none had died or injured but in many years ago, 3 died in 1998 due to slipping on timber and fall in the river",
  //       "notes_on_social_information": "Rurembo Parish (community 1,3,4); Rurembo health center (community 1,3,4); Rurembo sector office(community 1,3,4), Rurembo secondary school (community 1,3,4); Rurembo market (community 1,3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January. Population of adjacent communities include the following villages : Rugote, Gahondo cell and Nyarukangaga. Community members of Nyarukangaga and Rugote sometimes use this crossing to Visit relatives and attending a meeting",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yLHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kavumbu",
  //       "bridge_opportunity_project_code": "1013029",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.67069,
  //       "bridge_opportunity_gps_longitude": 29.46836,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 67,
  //       "bridge_opportunity_individuals_directly_served": 3981,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67069,
  //       "proposed_bridge_location_gps_longitude": 29.46836,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 44,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Kora market blocked to communities of the left side, Nyabihu tea plantation blocked to communities of right side, cattle farmers blocked to communities of right side and Dairy (milk collection zone) blocked to communities of the left side of the river who are coming from pastures",
  //       "education_access_blocked_by_river": "Rutazigurwa secondary school blocked to communities of right side of the river",
  //       "health_access_blocked_by_river": "Nyiragikokora health center blocked to communities of the left side of the river",
  //       "other_access_blocked_by_river": "Adventist of Seven days and Protestants church",
  //       "primary_occupations": "Most common occupations in the communities are farmers on both sides especially potatoes , tea plantations workers, pastures (cattle farmers ) on a large land",
  //       "primary_crops_grown": "livestock (catle), maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river flowing at high speed",
  //       "notes_on_social_information": "Rutazigurwa secondary schools(community 2,3,4), Pastures(community 2,3,4), Kora market(community 1,5) Nyabihu tea plantation,(community 2,3,4 ) Nyiragokokora health center (community 1,5) Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January. Population of adjacent communities is Bihangara village. Community members of Bihangara village sometimes use this crossing to access playground for entertainment",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 59,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yLbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigusa",
  //       "bridge_opportunity_project_code": "1013214",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.55117833,
  //       "bridge_opportunity_gps_longitude": 29.51450333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3450,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.55117833,
  //       "proposed_bridge_location_gps_longitude": 29.51450333,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "15 times March, April, September and it last for 3 days after rainfall",
  //       "market_access_blocked_by_river": "Market,",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming( large forest)",
  //       "primary_crops_grown": ", maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 18,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market(Kigusa, Gasenge, Ruziba, Muhati, Biraro) Primary and Secondary schools(Kigusa, Ruziba, Muhati, Biraro, Gasenge) Health Center(Kigusa, Gasenge, Muhati ,Ruziba, Biraro) These are Ruramba and Muhati village which use the current pathway to access the commercial activities in the market and their people were included in the total population The numbers of the survey were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56.4,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75ucAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ntaruka",
  //       "bridge_opportunity_project_code": "1013220",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.52459333,
  //       "bridge_opportunity_gps_longitude": 29.54972333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3896,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.52459333,
  //       "proposed_bridge_location_gps_longitude": 29.54972333,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "48 times in April, May, September, October and it lasts 4hours after rainfall",
  //       "market_access_blocked_by_river": "Markets, local commercial center",
  //       "education_access_blocked_by_river": "Primary and Secondary school",
  //       "health_access_blocked_by_river": "Health center",
  //       "other_access_blocked_by_river": "Churches, and government offices",
  //       "primary_occupations": "Farming and animal keeping, there is large sweet potatoes and cassava farms on both sides",
  //       "primary_crops_grown": "bean, cassava, cow pea, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 15,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They are flown by the river while they trying to walk in the river because there is no trees for crossing",
  //       "notes_on_social_information": "Market Nyarusiza(Nyabwoma, Kirwa, Gitovu, Gisanze,Maryohe) Market Ryarubondo (Ntaruka, Rususa, Kizi, Kamiro, Rweru) Market Rususa( Nyabwoma, Kirwa, Gitovu, Gisanze and Maryohe) Secondary school( Nyabwoma, Kirwa, Gitovu, Gisanze and Maryohe) Health Center (Nyabwoma, Kirwa, Gitovu, Gisanze and Maryohe) These numbers in the survey were given by the local people and their leaders based on the monthly census which is done in every cell. The villages of Kirwa, Gitovu, Gisanze, Marwohe, Rweru are using this crossing and their people were included in the total population",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50.6,
  //       "height_differential_between_banks": 3.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75z5AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiziba",
  //       "bridge_opportunity_project_code": "1013222",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.55473,
  //       "bridge_opportunity_gps_longitude": 29.83253,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2946,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.55473,
  //       "proposed_bridge_location_gps_longitude": 29.83253,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "10 kilometers",
  //       "days_per_year_river_is_flooded": 84,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "Kiziba and kabukoko are blocked to market and farms are both side",
  //       "education_access_blocked_by_river": "Kiziba and Kabukobo are blocked to primary and secondary school \"Rushara\"",
  //       "health_access_blocked_by_river": "Kiziba and Kabukobo are blocked to Health center",
  //       "other_access_blocked_by_river": "Kiziba and Kabukobo are blocked to district office, churches are both sides,",
  //       "primary_occupations": "School",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "He was trying to cross the bridge when it was flooded and fell into river and found died after 6 hours",
  //       "notes_on_social_information": "Information was given by the people lived in bushings and Kiziba communities with communities leader of Kiziba",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zFAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sovu",
  //       "bridge_opportunity_project_code": "1013225",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.510714,
  //       "bridge_opportunity_gps_longitude": 29.53571,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 43,
  //       "bridge_opportunity_individuals_directly_served": 3540,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.51053167,
  //       "proposed_bridge_location_gps_longitude": 29.53582167,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "6 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "90 times in March, April, May, October, November and December and it lasts for 4 hours after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Secondary school",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices,",
  //       "primary_occupations": "Farming of sweet potatoes, eucalyptus plantation, cassava plantation",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They were taken by water flow when they walked into the river while trying to cross",
  //       "notes_on_social_information": "Market Ryarubondo(Kinyovu, Sovu, Ntaruka, Ryanyirataba) Market Nyamagabe (Maryohe, Nyabwoma, Uwinyana, Kirwa) Secondary school( Kirwa, Nyabwoma) Health Center(Kirwa, Uwinyana, Maryohe, Nyabwoma) The villages of Nyabwoma, Uwinyana and Kirwa are using this crossing regularly but they are not mentioned in the form but their population are included in the total population to be served. This survey was conducted with the help of local people and their leaders and we referred to the monthly census which is done in every cell",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zUAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagarama",
  //       "bridge_opportunity_project_code": "1013226",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.51784,
  //       "bridge_opportunity_gps_longitude": 29.58812833,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 62,
  //       "bridge_opportunity_individuals_directly_served": 3709,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.51784,
  //       "proposed_bridge_location_gps_longitude": 29.58812833,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "50 times in April, May, October, November, December and it lasts for 3 days after rainfall",
  //       "market_access_blocked_by_river": "Markets, commercial center",
  //       "education_access_blocked_by_river": "Primary and Secondary schools,",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices, churh",
  //       "primary_occupations": "Farming of maize, beans, sweet potatoes, cassava, bananas",
  //       "primary_crops_grown": "bean, cassava, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They are drawn while trying to walk in the river",
  //       "notes_on_social_information": "Market Karambi( Nyarusiza, Rususa, Baro, Bahina, Kigarama) Market Nyamagabe(Nyarusiza, Rususa, Baro, Bahina, Kigarama) Market Nyarusiza( Kinyana, Gakomeye, Kagarama) Primary and Secondary schools of St Joseph on LHS( Kinombe, Gitwa) Primary and Secondary schools on RHS( Kagarama, Kinyana, Gakomeye) Health Center ( Kagarama, Kinyana, Gakomeye) These numbers were given by the local people and their leaders based on the monthly census which is done in every cell. The villages of (Gakomeye, Baro, Bahina, Kigarama) are using this crossing regularly and their people were included in the total population to be served.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42.8,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitantu",
  //       "bridge_opportunity_project_code": "1013231",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": 2.495585,
  //       "bridge_opportunity_gps_longitude": 29.58301667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3291,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": 2.495585,
  //       "proposed_bridge_location_gps_longitude": 29.58301667,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and it lasts for 1hour after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, bananas, forest, beans, maize",
  //       "primary_crops_grown": "banana, bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "Market Nyamagabe (Gitwa, Kamiro, Kigarama, Gasharu, Ryanyirataba) Primary and Secondary schools( Gitantu, Nyabivumu) Health Center of Kigeme(Gitwa, Kamiro, Kigarama, Gasharu, Ryanyirataba) The numbers in this survey were given by the local people and their leaders based on the monthly census which is done in every cell. The villages of Gitwa, Kigarama(Kirehe), Nyabivumu are using this crossing regularly but they are not mentioned in the form but their population are included in the total population to be served.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 24.4,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zyAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyabami (Kwa Anamariya)",
  //       "bridge_opportunity_project_code": "1013233",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.608215,
  //       "bridge_opportunity_gps_longitude": 29.890989,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 66,
  //       "bridge_opportunity_individuals_directly_served": 2554,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.60834,
  //       "proposed_bridge_location_gps_longitude": 29.8911,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Kadehoro, butunda and Rugaragara are blocked to the Market and farms on both side",
  //       "education_access_blocked_by_river": "Kadehoro, butunda and Rugaragara are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Kadehoro, butunda and Rugaragara are blocked to Health center",
  //       "other_access_blocked_by_river": "Kadehoro, butunda and Rugaragara are blocked to churches",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Rubona and people who live closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 59,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7608AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Rukeratabaro",
  //       "bridge_opportunity_project_code": "1013256",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.838472,
  //       "bridge_opportunity_gps_longitude": 29.684286,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 57,
  //       "bridge_opportunity_individuals_directly_served": 2764,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.83836538,
  //       "proposed_bridge_location_gps_longitude": 29.68433685,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 days of floods",
  //       "market_access_blocked_by_river": "Nkondo market",
  //       "education_access_blocked_by_river": "GS Gitega and GS Shaki",
  //       "health_access_blocked_by_river": "Gitega health center",
  //       "other_access_blocked_by_river": "Gitega cell office and Kibangu sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "As there no other point to cross people decide to cross and fall into the river",
  //       "notes_on_social_information": "GS Gitega ( Nyaruvumu village , Nyarubuye village , Kinogi village , Mushubaguriko village ) , GS Shaki ( Nkondo village) , Nkondo market ( Nyaruvumu village , Nyarubuye village , Kinogi village , Mushubaguriko village ) , Gitega health center ( Nyaruvumu village , Nyarubuye village , Kinogi village , Mushubaguriko village ) , all of these information are obtained from Nyaruvumu and Nyarubuye village leaders for the other village we contacted them through phone , the population census of 2018 was the main reference in determination of individual served",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761zAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Shyagari",
  //       "bridge_opportunity_project_code": "1013263",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.003951,
  //       "bridge_opportunity_gps_longitude": 29.675447,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 80,
  //       "bridge_opportunity_individuals_directly_served": 2609,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.00393039,
  //       "proposed_bridge_location_gps_longitude": 29.67555126,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "2 days of flood during heavy rain of April and one day of flood during September rain",
  //       "market_access_blocked_by_river": "Kabadaha market",
  //       "education_access_blocked_by_river": "GS Mushishiro",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Mushishiro sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "People jump to the stone and miss it .",
  //       "notes_on_social_information": "Mushishiro health center ( kabare village, kamurekezi village, kivumu village) , GS Mushishiro ( kabare village, kamurekezi village, kivumu village), kabadaha market ( kabare village, kamurekezi village, kivumu village). Kabare village leader is the one who provided the info for directly individual served by refering to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d762YAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahama",
  //       "bridge_opportunity_project_code": "1013364",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.70127,
  //       "bridge_opportunity_gps_longitude": 29.55681,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3575,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70127,
  //       "proposed_bridge_location_gps_longitude": 29.55681,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.5 hour",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Kabaya market which is open every day is blocked to communities of the left side, farms on both side of the river are blocked",
  //       "education_access_blocked_by_river": "Nturo primary and secondary school blocked to communities left side of the river",
  //       "health_access_blocked_by_river": "Kabaya Hospital and Kavumu health center are blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Local farmers and traders at Kabaya market",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "One person died trying to cross the river , when the river was flooded",
  //       "notes_on_social_information": "Kabaya market(village 2,3,4,4), Kabaya Hospital(2,3,4 5), Nturo primary and secondary (2,3,4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Gr0AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mamashenge",
  //       "bridge_opportunity_project_code": "1013273",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.30577,
  //       "bridge_opportunity_gps_longitude": 29.79548,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2147,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.30577,
  //       "proposed_bridge_location_gps_longitude": 29.79548,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Butansinda and Ruhango Markets (Community 1); Kayanza Market (Community 2)",
  //       "education_access_blocked_by_river": "Kigoma primary and secondary school (Community 1); Kayanza primary and secondary school (Community 2)",
  //       "health_access_blocked_by_river": "Butansinda and Gahombo health center (Community 1)",
  //       "other_access_blocked_by_river": "Kigoma sector office, Karama Catholic Church (Community 1); Shori Anglican church (Community 2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, beans., cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "More than 5 people died trying to cross the river and 3 cows that were taken to market also died at the same crossing point.",
  //       "notes_on_social_information": "Kavumu and Mataba villages were included in individuals directly served because community members of these villages use this crossing point to go to churches, markets, schools, health centers, ... The information about the population to be served by the bridge was provided by the Butara cell leader, Octave Ndayisaba from the population data collected in early 2018. Population of adjacent communities includes: Butara, Gasharu, Marongi and Kigoma, they use this crossing point to visit relatives, to go to Kigoma Sector office or to go to market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d766yAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bibumba",
  //       "bridge_opportunity_project_code": "1013275",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.2794,
  //       "bridge_opportunity_gps_longitude": 29.8712,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 69,
  //       "bridge_opportunity_individuals_directly_served": 3152,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2794,
  //       "proposed_bridge_location_gps_longitude": 29.8712,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "9 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In April and May, September to December it last for 3 hours",
  //       "market_access_blocked_by_river": "Busoro market (Community 4,5) Ruhango and Kareba markets ( community 1,2,3), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Ruko primary school and Nyabyugi primary school (community 1,2,3)",
  //       "health_access_blocked_by_river": "Kareba health post and Nyarurama Health center (Community 1,2,3), Busoro health center (Community 4,5)",
  //       "other_access_blocked_by_river": "ADPR Kareba church, Ruko Catholic Church (Community 1,2,3), Busoro catholic parish (Community 4,5); potable water (Community 4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "bean, cassava, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many people have been falling into the river and they got rescued, but one died in the last 3 years . Actually more than 100 people fell trying to cross the river.",
  //       "notes_on_social_information": "Burambe, Muramba, Nyarukurazo, Marimba and Kamakara villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, churches, schools, health centers, ... The information about the population to be served by the bridge was provided by the Murinja cell leader, Eugene Ntambara and Burambe Village leader, Ngendanimana Theogene from the population data collected in late 2017 and early 2018. Population of adjacent communities includes: Cyivuko, Murambi, Gikombe and Kibatsi. They use this crossing point to visit relatives or to go to market in Ruhango or Busoro Markets.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1(Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7678AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyeru",
  //       "bridge_opportunity_project_code": "1013281",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.363741,
  //       "bridge_opportunity_gps_longitude": 29.544103,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2222,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.363741,
  //       "proposed_bridge_location_gps_longitude": 29.544103,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "March to May, September to November, 5hours they can cross",
  //       "market_access_blocked_by_river": "Kaduha market(villages 3,4), farms(villages1,2,3,4)",
  //       "education_access_blocked_by_river": "Kirehe Catholic primary school (villages 3,4), kaduha secondary school 0'level(villages 3,4)",
  //       "health_access_blocked_by_river": "Kaduha health center and hospital (villages 3,4)",
  //       "other_access_blocked_by_river": "Govement services such as nyabisindu cell, kaduha sector, security services (villages 3,4), churches(3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, potato, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "The population data was given by Nyabisindu leader, Chantal Mujawamariya who sourced them from the cell register in Ubudehe 2017. The population of all adjacent communities includes the following: kanege, Korea, Kasemazi and Kabaziro. The community members from those villages was included because they use the crossing to do farming every time, to visit market and the students to school, sometime they cross the river to visit relatives and to get cell services.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78O6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakirambi",
  //       "bridge_opportunity_project_code": "1013289",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.310138,
  //       "bridge_opportunity_gps_longitude": 29.602603,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3456,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.310138,
  //       "proposed_bridge_location_gps_longitude": 29.602603,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "March to May, September to December, 24hours",
  //       "market_access_blocked_by_river": "Rurangazi cattle market(villages 1,2,3), nyanza market ( villages 1,2,3), farms(villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Goverment services such as district office(villages 1,2)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, maiz, ric, som, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population information was provided Jenda cell leader, Christine Mujawamariya who sourced population info from cell register done in 2017. The villages members from those community use the crossing to do farming on both side, to visit market and visit relatives.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyanza",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 115,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78OuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusuzumiro",
  //       "bridge_opportunity_project_code": "1013349",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.98365945,
  //       "bridge_opportunity_gps_longitude": 29.65245312,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4950,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.98365945,
  //       "proposed_bridge_location_gps_longitude": 29.65245312,
  //       "current_crossing_method": "People use one timber to cross the river",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 88,
  //       "flood_duration_during_rainy_season": "1 day of flood people can't go to the other side .",
  //       "market_access_blocked_by_river": "Kabadaha market and cyome market , Kabadaha market is in right side of the the river while cyome market is at left side of the river , but both markets are used by people from both side",
  //       "education_access_blocked_by_river": "Groupe scolaire Kicaro is located at right side of the river",
  //       "health_access_blocked_by_river": "Ndaro health center and Mushishiro health center",
  //       "other_access_blocked_by_river": "Mushishiro sector office , Mushishiro Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "The river if is full it is more dangerous but people think it not dangerous by looking at it and finally they fall down when they are crossing",
  //       "notes_on_social_information": "Kabadaha market ( kabeza village , gitwa village , cyarubambire village) , Mushishiro health center ( kabeza village , gitwa village , cyarubambire village) , GS Kicaro( kabeza village , gitwa village , cyarubambire village) , cyome market ( kabeza village , gitwa village , cyarubambire village) , ndaro health center ( Rugerero village , kamurekezi village ) , Mushishiro Catholic church( kabeza village , gitwa village , cyarubambire village) . Kabeza village leader is the one who provided the information by calling other village leaders to ask them their number of population , they referred to the population census of 2018 to determine individual directly served .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EZHAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Hanika",
  //       "bridge_opportunity_project_code": "1013350",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.97717889,
  //       "bridge_opportunity_gps_longitude": 29.67449787,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4970,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.97717889,
  //       "proposed_bridge_location_gps_longitude": 29.67449787,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Cyome market",
  //       "education_access_blocked_by_river": "GS Mushishiro",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Nyagasozi church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 10,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "People try to jump the river and fall in",
  //       "notes_on_social_information": "Cyome market ( Bitsibo village, Hanika village) , Nyagasozi church ( Bitsibo village and Hanika village) , Mushishiro health center ( bitsibo village, hanika village ) . The village leader of hanika provided the information regarding to individual directly served and she referred to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EZMAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Biseke",
  //       "bridge_opportunity_project_code": "1013374",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.66137,
  //       "bridge_opportunity_gps_longitude": 29.50069,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8766,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66137,
  //       "proposed_bridge_location_gps_longitude": 29.50069,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "15 m",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Gasiza and Mukamira markets which are open weekly are blocked to communities of the left side of the river, Tea plantations blocked to communities of the left side of the river and potatoes farms on both side are blocked too",
  //       "education_access_blocked_by_river": "Gihira and Rugamba primary and secondary school blocked to communities of left side of the river",
  //       "health_access_blocked_by_river": "Mwiyanike health center blocked to communities of left side of the river has",
  //       "other_access_blocked_by_river": "Baptist church blocked to communities of right side of the river and Gihirwa cell office which is blocked to communities of the left side of the river",
  //       "primary_occupations": "Workers in Tea plantations (Owned by Rwanda mountain Tea company); Farmers of potatoes and traders at Gasiza and Mukamira markets",
  //       "primary_crops_grown": "maiz, potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "The traditional crossing method was bridge in timber, before being taken away by the river almost 10 people injured trying to cross the river. They either had fracture on their arms or legs",
  //       "notes_on_social_information": "Mukamira and Gasiza markets which are open weekly (village 1,3,4); Mwiyanike health center ( village1,3,4 ); Rugamba primary and secondary school (village1,3,4 ); Gihira secondary ( village1,3,4 ); Gihirwa cell office (village 1,3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018 Population of adjacent communities include Rurambo communities. Community members in Rurambo sometimes use this crossing to Visit relatives",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GroAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kugasumo",
  //       "bridge_opportunity_project_code": "1013377",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.62689,
  //       "bridge_opportunity_gps_longitude": 29.48884,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 42,
  //       "bridge_opportunity_individuals_directly_served": 2714,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62689,
  //       "proposed_bridge_location_gps_longitude": 29.48884,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 44,
  //       "flood_duration_during_rainy_season": "1 week",
  //       "market_access_blocked_by_river": "Nyabihu Tea plantation blocked to communities of the right side , Kora and Mukamira markets open weekly are blocked to communities of right side of the river and farms on both sides",
  //       "education_access_blocked_by_river": "Jenda Primary and secondary school blocked to communities of right side and Bihira secondary school blocked to communities of left side of the river",
  //       "health_access_blocked_by_river": "Jenda health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "One church on right side is blocked , Adventist on left",
  //       "primary_occupations": "Nyabihu Tea plantation workers, farmers on both sides and traders at Mukamira and Kora market",
  //       "primary_crops_grown": "potato, tea plantation, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river",
  //       "notes_on_social_information": "Kora market (village1,4,4); Jenda health center ( village1,4,5) ;Jenda Primary and Secondary schools ( village1,4,5 ); Tea plantation( village1,4,4), Gihira secondary school (village2,3 ), Cyamabuye primary school (2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018. Population of adjacent communities include Rubare village. Community members of Rubare sometimes use this crossing to Visit relatives",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Gs3AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinamba",
  //       "bridge_opportunity_project_code": "1013378",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.65625,
  //       "bridge_opportunity_gps_longitude": 29.42217,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2133,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65625,
  //       "proposed_bridge_location_gps_longitude": 29.42217,
  //       "current_crossing_method": "Bridge in cement",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Kora market open weekly blocked to communities of the left side of the river potatoes and vegetables farms, pastures blocked to communities on both sides",
  //       "education_access_blocked_by_river": "Rega primary and secondary school blocked to communities of the left side",
  //       "health_access_blocked_by_river": "Kijote health center blocked to communities of the left side and downstream of the river",
  //       "other_access_blocked_by_river": "Churches and potable water on left side",
  //       "primary_occupations": "Farmers on both side ( potatoes and vegetables), traders to Kora market",
  //       "primary_crops_grown": "bean, livestock (cattle ), potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kora market( village2,3,4 ), Kora health center(village 2,3,4), Rega secondary school(village2,3,4), Milk collection zone(village2,3,4 ), cemetery (village 1 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Gs8AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruyebe",
  //       "bridge_opportunity_project_code": "1013392",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.65549,
  //       "bridge_opportunity_gps_longitude": 29.51862,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2624,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65549,
  //       "proposed_bridge_location_gps_longitude": 29.51862,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": "Mukamira market which is open twice a week is blocked to communities of right side of the river, Tea plantations farms and factory are blocked to communities of right side , farms on both side of the river",
  //       "education_access_blocked_by_river": "Ntarama primary and Gihira secondary school blocked to communities of Right side of the river",
  //       "health_access_blocked_by_river": "Mwiyanike health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Ntarama Parish blocked to communities of right side of the river",
  //       "primary_occupations": "Tea plantation workers, local farmers (Potatoes and vegetables ) and traders at Gasiza market",
  //       "primary_crops_grown": "bean, maiz, potato, tea plantation on large scal",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died",
  //       "notes_on_social_information": "Tea plantation ( village 1,3,4,5), Gihira primary and secondary ( village1,3,4,5 ), Mukamira market which is open twice a week ( village1,3,4,5 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GtGAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwasa",
  //       "bridge_opportunity_project_code": "1013422",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.41763333,
  //       "bridge_opportunity_gps_longitude": 29.555675,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 70,
  //       "bridge_opportunity_individuals_directly_served": 3582,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.41763333,
  //       "proposed_bridge_location_gps_longitude": 29.555675,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "25 times April, May, October, November and December, and it lasts 2 days after rainfall",
  //       "market_access_blocked_by_river": "Market,",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, cassava, forest, banana, coffee",
  //       "primary_crops_grown": ", banana, cassava, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down in the river but they are lucky they didn't die",
  //       "notes_on_social_information": "Markets of Nyamagabe and Gataba ( Munyinya, Nyagatovu, Murambi, Nyamirama, Kinyana, Karambo) Market Kaduha(Kirwa, Kavumu, Muyange, Uwinyana) Primary and Secondary schools(Nyagatovu, Munyinya, Murambi) Health Center (Munyinya and Nyagatovu) The following villages: Nyagatovu, Murambi, Nyamirama, Kinyana, and Karambo are using this crossing regularly to attend the markets and their children cross this river heading to schools, Therefore, their population are included in the total population to be served. These numbers were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 69.4,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JDHAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Basesa",
  //       "bridge_opportunity_project_code": "1014046",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.73024,
  //       "bridge_opportunity_gps_longitude": 29.36502,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1440,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.73024,
  //       "proposed_bridge_location_gps_longitude": 29.36502,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "Two month",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Musabike primary school and kibarama primary school",
  //       "health_access_blocked_by_river": "Post de bahimba",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, sugar can",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Kazabe village don't have access to mahoko market Information gathered from kigarama cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Mahoko",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 90,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fOKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivomo",
  //       "bridge_opportunity_project_code": "1013451",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -2.02839,
  //       "bridge_opportunity_gps_longitude": 29.57274,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 81,
  //       "bridge_opportunity_individuals_directly_served": 3549,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.02839,
  //       "proposed_bridge_location_gps_longitude": 29.57274,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Mpanga Village and Mbobo village don't have access to NYANGE MARKET",
  //       "education_access_blocked_by_river": "Mpanga Village and Mbobo village don't have access to GS VUGANYANA",
  //       "health_access_blocked_by_river": "Mpanga Village and Mbobo village don't have access to NYANGE HEALTH CENTER",
  //       "other_access_blocked_by_river": "People from Karambo village , nyagatama village don't have access to gashubi church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They fall on stones with secoko then die immediately",
  //       "notes_on_social_information": "The information of directly individual served are from vuganyana cell leader . Population census 2018 is the main source",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 52,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7PqDAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukombe",
  //       "bridge_opportunity_project_code": "1013452",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.98911,
  //       "bridge_opportunity_gps_longitude": 29.60512,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2601,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.98911,
  //       "proposed_bridge_location_gps_longitude": 29.60512,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Masoro village, Ruhanga village, kabuga village ,kandamira village ,Rusebeya village and Gasharu village don't have access to BIJYOJYO MARKET",
  //       "education_access_blocked_by_river": "Masoro village ,Ruhanga village, kabuga village ,kandamira village ,Rusebeya village and Gasharu village don't have access to GROUPE SCOLAIRE GASAVE",
  //       "health_access_blocked_by_river": "Gasave village , rutonde village ,birima village ,bijyojyo village, gituza village , and kamuyobera village don't have access to NTOBWE HEALTH CENTER",
  //       "other_access_blocked_by_river": "Masoro village, Ruhanga village, kabuga village ,kandamira village ,Rusebeya village and Gasharu village don't have access to NDARO SECTOR OFFICE AND NDARO CATHOLIC CHURCH",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Because of many stones any one fall in river automatically died",
  //       "notes_on_social_information": "The information about individual directly served was provided by Bijyojyo cell leader by calling all village leaders that their people passing on the bridge, they referred to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7PqSAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuhanga",
  //       "bridge_opportunity_project_code": "1013455",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -2.00323,
  //       "bridge_opportunity_gps_longitude": 29.5765,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3935,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.00323,
  //       "proposed_bridge_location_gps_longitude": 29.5765,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "8 hours of flood",
  //       "market_access_blocked_by_river": "Kimirehe village and butambiro village don't have access to GASHUBI MARKET , while gasharu village ,runyoni village , rwamikeri village don't have access to NYANGE MARKET",
  //       "education_access_blocked_by_river": "gasharu village ,runyoni village , rwamikeri village don't have access to GROUPE SCOLAIRE DE KIBANDA",
  //       "health_access_blocked_by_river": "Kimirehe village and butambiro village don't have access to NTOBWE HEALTH CENTER",
  //       "other_access_blocked_by_river": "Kimirehe village and butambiro village don't have access to NDARO SECTOR OFFICE",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Students who were coming from school",
  //       "notes_on_social_information": "The information of directly individual served was provided by Bijyojyo cell leader by referring to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Pr1AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabiyonga",
  //       "bridge_opportunity_project_code": "1013461",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.94216,
  //       "bridge_opportunity_gps_longitude": 29.55835,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4968,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94216,
  //       "proposed_bridge_location_gps_longitude": 29.55835,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "4 days of flood",
  //       "market_access_blocked_by_river": "Rutembo village , gitonde village ,gasasa village, Mukingi village and bereshi village don't have access to BIREMBO MARKET , while gasiza village, ngugu village , rukeri village, and kigusa village don't have access to RUSUMO MARKET",
  //       "education_access_blocked_by_river": "gasiza village, ngugu village , rukeri village, and kigusa village don't have access to GS BUNGWE",
  //       "health_access_blocked_by_river": "gasiza village, ngugu village , rukeri village, and kigusa village don't have access to GASHUBI HEALTH CENTER",
  //       "other_access_blocked_by_river": "gasiza village, ngugu village , rukeri village, and kigusa village don't have access to BUNGWE CHURCH",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 20,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "People who were coming from Wedding",
  //       "notes_on_social_information": "Gitonde village leader has provided the info about directly individual served by refering to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7PrVAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwunga",
  //       "bridge_opportunity_project_code": "1013465",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.492419,
  //       "bridge_opportunity_gps_longitude": 29.573354,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 55,
  //       "bridge_opportunity_individuals_directly_served": 1035,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.492419,
  //       "proposed_bridge_location_gps_longitude": 29.573354,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "April to May, September to December, 12hours",
  //       "market_access_blocked_by_river": "Communities 3,4&5 are blocked to the Gataraga& shingiro market. Communities 1&2 is blocked to Musanze market and kinigi market. Villages 1, 2, 3, 4 & 5 do not have access to farms.",
  //       "education_access_blocked_by_river": "Villages 1&2 do not have access to Tero primary and Tero secondary school, communities 3,4&5 are blocked to shingiro secondary school, communities 3,4&5 are blocked also to Gakingo primary and Gakingo secondary school.",
  //       "health_access_blocked_by_river": "Communities 3,4&5 are blocked to shingiro health center. Villages 1&2 do not have access to Tero dispensary.",
  //       "other_access_blocked_by_river": "Communities 1&2 do not have access to Tero ADPR, ADVENTIST, CATHOLIC CHUCHES. Villages 1&2 are blocked to Ruheneka well(potable water). Villages 1&2 do not have access to district services.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, potato, sorghum, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned during crossing.",
  //       "notes_on_social_information": "Population information of each village was provided by",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q52AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyiragahama",
  //       "bridge_opportunity_project_code": "1013476",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.454949,
  //       "bridge_opportunity_gps_longitude": 29.616916,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4954,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.454949,
  //       "proposed_bridge_location_gps_longitude": 29.616916,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "800 m",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Communities 3, 4 & 5 are blocked to kinigi market and Musanze market, villages 1, 2, 3, 4 & 5 do not have access to farms.",
  //       "education_access_blocked_by_river": "Villages 1&2 do not have access to Nyange primary school, villages 3,4 & 5 do not have access to SOBESI secondary school.",
  //       "health_access_blocked_by_river": "Villages 3, 4 & 5 do not have access to Nyange health center and Ruhengeri hospital",
  //       "other_access_blocked_by_river": "Villages 3, 4 & 5 do not have access to nyange sector office, district office and other officials service such police, justice, etc both located in musanze city.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, flour, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and Drowned while crossing river.",
  //       "notes_on_social_information": "Population information of each village was provided by Kaneza and Ninda cell leader, Epimac Munyamasoko and Justin Ishimwe who sourced the population information from villages leader , which has recorded population in 2017. The population of all adjacent communities includes the following villages: Gahama, kibingo, Nyarubuye, Garuka, Mpiriza, and Rareba. The population from Gahama, kibingo and Nyarubuye communities sometimes cross the river to do farming and visit relatives.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~kinigi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5vAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musange kukibuga",
  //       "bridge_opportunity_project_code": "1013670",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.63647,
  //       "bridge_opportunity_gps_longitude": 29.78962,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1812,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63647,
  //       "proposed_bridge_location_gps_longitude": 29.78962,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 26,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Nemba school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "Nemba church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "When the river floods it takes a week for community to cross because the area is swampy no one allowed to cross they block the way",
  //       "notes_on_social_information": "Cyahafi village don't have access to Apollo school and karukara don't have access to gakenke market. Information gathered from cyahafi leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ibTAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kansoro",
  //       "bridge_opportunity_project_code": "1013477",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.446965,
  //       "bridge_opportunity_gps_longitude": 29.616203,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3467,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.446965,
  //       "proposed_bridge_location_gps_longitude": 29.616203,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 24 hours after rain they can cross.",
  //       "market_access_blocked_by_river": "Communities 3&4 are blocked to Kinigi market and Musanze market, communities 1,2,3&4 are blocked to the farms.",
  //       "education_access_blocked_by_river": "Communities 3&4 do not have access to SIBES secondary school, viillaages 1 &2 are blocked to nyange primary school & secondary.",
  //       "health_access_blocked_by_river": "Village 3&4 do not have access to Nyange health center, Villages 3&4 do not have access to Ruhengeri hospital",
  //       "other_access_blocked_by_river": "Villages 3&4 do not have access to adventist church in kansoro, villages 3&4 are blocked to the kansoro welll(potable water), villages 3&4 do not have access to the Nyange sector office, and other service In district office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, flour, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze ~kinigi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q60AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubira",
  //       "bridge_opportunity_project_code": "1013479",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.475588,
  //       "bridge_opportunity_gps_longitude": 29.531147,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3197,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.475588,
  //       "proposed_bridge_location_gps_longitude": 29.531147,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "April to May October to December, 12 hours after rain they can cross.",
  //       "market_access_blocked_by_river": "Villages 1,2&3 do not have access to Kinigi market. Communities 4&5 are blocked to nyange market. Villages 1,2,3,4&5 do not have access to the farms.",
  //       "education_access_blocked_by_river": "Communities 1,2,&3 are blocked to kukisari primary school in kinigi sector. Communities 4&5 are blocked to Nyamurimirwa primary school. Communities 4&5 are blocked to to shingiro secondary school. Communities 1 ,2,&3 do not have access to Bisate secondary secondary school.",
  //       "health_access_blocked_by_river": "Communities 1,2&3 are blocked to Bisate health center. Communities 4&5 are blocked to shingiro health center.",
  //       "other_access_blocked_by_river": "Communities 1,2&3 are blocked to churches in kidendezi. Communities 4&5 are blocked to churches in kimanzi. Communities 1,2&3 do not have access to district office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "flour, maiz, potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "0",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kinigi~musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q6AAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasagara",
  //       "bridge_opportunity_project_code": "1013491",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.43466,
  //       "bridge_opportunity_gps_longitude": 29.6722,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2352,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.43466,
  //       "proposed_bridge_location_gps_longitude": 29.6722,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gikoro and Gasagara are blocked to the Market",
  //       "education_access_blocked_by_river": "Gikoro and gasagara are blocked to secondary school",
  //       "health_access_blocked_by_river": "Gikoro and gasagara are blocked to Health center",
  //       "other_access_blocked_by_river": "Nyabizi , Kabagabo and Gisizi are blocked to cell office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One of them was a baby child, was in back of mum who was trying to cross the bridge when it was flooded and fell into river and found died, and another one was a man.",
  //       "notes_on_social_information": "Community leaders of Gasagara with people who were crossing the ditch",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9SAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabizi ya 1",
  //       "bridge_opportunity_project_code": "1013496",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.33001,
  //       "bridge_opportunity_gps_longitude": 29.82555,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1854,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.33001,
  //       "proposed_bridge_location_gps_longitude": 29.82555,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Nyabizi 1,3 are blocked to the Market",
  //       "education_access_blocked_by_river": "Nyabizi 1,3 are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Nyabizi 1,3 are blocked to Health center",
  //       "other_access_blocked_by_river": "Nyabizi 1,3 are blocked to churches, sector and cell offices,",
  //       "primary_occupations": "School, Market, farms,...",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Nyabizi 1",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9rAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyanza",
  //       "bridge_opportunity_project_code": "1013539",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.74082,
  //       "bridge_opportunity_gps_longitude": 29.53777,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4066,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.74082,
  //       "proposed_bridge_location_gps_longitude": 29.53777,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "6 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "10 hours of flood",
  //       "market_access_blocked_by_river": "Kamajanga village , gisoro village , muremure village and nkomane village don't have access to kabaya market",
  //       "education_access_blocked_by_river": "Kamajanga village , gisoro village , muremure village and nkomane village don't have access to kabaya secondary school",
  //       "health_access_blocked_by_river": "Kamajanga village , gisoro village , muremure village and nkomane village don't have access to kabaya hospital",
  //       "other_access_blocked_by_river": "Nyanza village and kimisagara village people don't have access to their thee plantation and firms",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, tea",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "People were going back home and into the water of giciye",
  //       "notes_on_social_information": "Nyanza village leader is the one who provided the information about directly individual served by referring to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero - Mukamira",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 100,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ayMAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabununi",
  //       "bridge_opportunity_project_code": "1013542",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.13809,
  //       "bridge_opportunity_gps_longitude": 29.4254,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2923,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.13809,
  //       "proposed_bridge_location_gps_longitude": 29.4254,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 115,
  //       "flood_duration_during_rainy_season": "20 days of flood",
  //       "market_access_blocked_by_river": "Kirambo vilkage , rwintare village ,buye village dont have acess to Rubengera market, Nyaruvumu ,gasharu village dont have acess to kivuruga market",
  //       "education_access_blocked_by_river": "No movements of schools within this area , students are using other paths to go to school",
  //       "health_access_blocked_by_river": "Kirambo vilkage , rwintare village ,buye village dont have acess to Birambo health center ,",
  //       "other_access_blocked_by_river": "Nyaruvumu ,gasharu village dont have acess to Kuwimanzi church and Gitesi sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 15,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Passing people get strucked by stones of the river",
  //       "notes_on_social_information": "Gasharu cell eader is the one who provided all info about individual served , by referring to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7aylAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitaba",
  //       "bridge_opportunity_project_code": "1013547",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.77412,
  //       "bridge_opportunity_gps_longitude": 29.57416,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4606,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.77412,
  //       "proposed_bridge_location_gps_longitude": 29.57416,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "6 hours of flood during heavy rain",
  //       "market_access_blocked_by_river": "Gitaba village , kabere village, kinyamiyaga village ,kabusizi village dont have acess to Gatega market ,",
  //       "education_access_blocked_by_river": "Bukonde village , kirwa village , gashyitsi village dont have access to GS Kinanira",
  //       "health_access_blocked_by_river": "Gitaba village , kabere village, kinyamiyaga village ,kabusizi village dont have acess to Muramba health center , while Bukonde village , kirwa village , gashyitsi village dont have access to kabaya hospital",
  //       "other_access_blocked_by_river": "Bukonde village , kirwa village , gashyitsi village dont have access to Muramba church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato, the",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gitaba village leader provided info about direct individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero _ Mukamira",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamihaho",
  //       "bridge_opportunity_project_code": "1013555",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.09757,
  //       "bridge_opportunity_gps_longitude": 29.4337,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.09757,
  //       "proposed_bridge_location_gps_longitude": 29.4337,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 86,
  //       "flood_duration_during_rainy_season": "15 days of flood",
  //       "market_access_blocked_by_river": "Kamihaho village and Bugobere village don't have access to Rubengera market",
  //       "education_access_blocked_by_river": "Kamihaho village and Bugobere village don't have access to Kirambo secondary school",
  //       "health_access_blocked_by_river": "Kamihaho village and Bugobere village don't have access to Kirambo health center",
  //       "other_access_blocked_by_river": "Kamihaho village and Bugobere village don't have access to muvungu Adventist church , while muvungu village and Nyagasozi village don't have access to Gitega church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "casava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No death as people get scared of crossing",
  //       "notes_on_social_information": "Gitega cell leader is the one who provided information about direct individual served and she referred to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b03AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mubaneri",
  //       "bridge_opportunity_project_code": "1013561",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.293363,
  //       "bridge_opportunity_gps_longitude": 29.238419,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2577,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.293363,
  //       "proposed_bridge_location_gps_longitude": 29.238419,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 48 hours",
  //       "market_access_blocked_by_river": "Communities 4&5 do not have access to Gatare market and Gatare cows market. Communities 1,2&3 do not have access to kagarama market. Communities 1,2,3,4 &5 are blocked to farms in kigarama and Gatare.",
  //       "education_access_blocked_by_river": "Communities 1,2&3 do not have access to Mweya primary school, communities 4&5 are blocked to kabuhoro primary school.",
  //       "health_access_blocked_by_river": "Communities 1,2&3 do not have access to kagarama health center.",
  //       "other_access_blocked_by_river": "Communities 4&5 do not have access to kirehe churc, communities 1,2&3 are blocked to Mugano church, students from Mweya primary school are blocked to Rupango football terrain. Communities 1 are blocked to potable water.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned while crossing.",
  //       "notes_on_social_information": "Population information of each village was provided by Gatare cell and kagarama cell leaders who sourced the population information from cell register in 2018. Population of all adjacent communities includes the following villages; kamagesi, Rugarama, Murama, Gashwi and Giti. The community members from kamagesi and Rugarama sometimes cross river to visit market , do farming in Gatare and students from Mweya primary school to play football at Rupango terrain.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": 1.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b5wAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamuko",
  //       "bridge_opportunity_project_code": "1013576",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.51384,
  //       "bridge_opportunity_gps_longitude": 29.88201,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3373,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.51384,
  //       "proposed_bridge_location_gps_longitude": 29.88201,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 100,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 day",
  //       "market_access_blocked_by_river": "Karama market (Community 4), Musha Market (Community 1,2,3), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Kabeza Primary and Secondary School, Ramba Primary School (Community 4), Rwatano Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Musha Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Musha Adventist and Methodist churches (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, pea, ric, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 20,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries but the number of deaths is more than 20 during the past five years. Of these twenty deaths, 8 people died during rainy season between April and May 2018. Most of them were going or coming to/from the market.",
  //       "notes_on_social_information": "Gatoki, Mukori, Nyirabageni and Rukoni villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms or to visit relatives. The population information for each village was provided by the Ramba Cell Leader, Claude Habimana, who sourced the population information from the cell census data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bARAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Munanira",
  //       "bridge_opportunity_project_code": "1013583",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.396316,
  //       "bridge_opportunity_gps_longitude": 29.577776,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4717,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.24",
  //       "form_created_by": "kyleshirley taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.396316,
  //       "proposed_bridge_location_gps_longitude": 29.577776,
  //       "current_crossing_method": "Fording",
  //       "nearest_all_weather_crossing_point": "Nowhere else",
  //       "days_per_year_river_is_flooded": 270,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Miko market(Nyamirama and Nyirakiraro villages),farming(Nyamirama, Nyirakiraro,Munanira, Maheresho and Kabeza villages)",
  //       "education_access_blocked_by_river": "Maheresho Primary and Secondary School (Nyamirama and Nyirakiraro villages)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Gatugunguru spring water(Nyirakiraro village)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The community that were cultivating around the areas but we should talk with the village leader later about the number of community and other additional informations.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyamagabe",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bIlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bahimba",
  //       "bridge_opportunity_project_code": "1013626",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.7628,
  //       "bridge_opportunity_gps_longitude": 29.30777,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 64,
  //       "bridge_opportunity_individuals_directly_served": 1428,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.7628,
  //       "proposed_bridge_location_gps_longitude": 29.30777,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Kivumu secondary school",
  //       "health_access_blocked_by_river": "Kivumu health center",
  //       "other_access_blocked_by_river": "Kivumu cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A man was fractured hardly when he fell to the current bridge",
  //       "notes_on_social_information": "Gihari village dont have access to kivumu hospital and kivumu secondary school. Burambo don't have access to mahoko and rubavu town . Information gathered from tuyisenge Pierre burambo leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 66.8,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iQBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Shyira",
  //       "bridge_opportunity_project_code": "1013628",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.69922,
  //       "bridge_opportunity_gps_longitude": 29.63391,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4596,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.69922,
  //       "proposed_bridge_location_gps_longitude": 29.63391,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "356",
  //       "market_access_blocked_by_river": "Vunga market",
  //       "education_access_blocked_by_river": "Groupe scolaire vunga",
  //       "health_access_blocked_by_river": "Shyira hospital",
  //       "other_access_blocked_by_river": "Ear church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They is no current way for the community so the bridge will be facilitating the community",
  //       "notes_on_social_information": "Information gathered from hagwirineza Jean rutenderi leader. Rutenderi cell don't have access to vunga market, shyira hospital and vunga school and kazirankora, matabo, don't have access to bereshi center",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Nyikinama-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 69.6,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iQfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihinga",
  //       "bridge_opportunity_project_code": "1013632",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.93229,
  //       "bridge_opportunity_gps_longitude": 29.36963,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3305,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.93229,
  //       "proposed_bridge_location_gps_longitude": 29.36963,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Gisiza market",
  //       "education_access_blocked_by_river": "Rugote primary and secondary school",
  //       "health_access_blocked_by_river": "Murunda health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, pineappl, potato, sugar can",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They fell in the river when the river was flooded",
  //       "notes_on_social_information": "Gihinga village don't have access to rugote primary school and karambo village don't have access to murunda hospital and gisiza market. Information gathered from musabyimana Felix gisiza leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gisiza",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iRdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bukungu",
  //       "bridge_opportunity_project_code": "1013639",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.80495,
  //       "bridge_opportunity_gps_longitude": 29.30452,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 48,
  //       "bridge_opportunity_individuals_directly_served": 6052,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.80495,
  //       "proposed_bridge_location_gps_longitude": 29.30452,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Four hours",
  //       "market_access_blocked_by_river": "Nkora",
  //       "education_access_blocked_by_river": "Trinity secondary school and kigeyo primary and secondary school",
  //       "health_access_blocked_by_river": "Kivumu health center",
  //       "other_access_blocked_by_river": "Adventist church at kigeyo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "sugar can",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "People slips and fall trying to cross the river",
  //       "notes_on_social_information": "Nganzo community members don't have access to trinity school and kivumu health center. Information gathered from yohani habimana nganzo leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkora",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iU8AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bugarishya",
  //       "bridge_opportunity_project_code": "1013642",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.8011,
  //       "bridge_opportunity_gps_longitude": 29.31405,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1750,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8011,
  //       "proposed_bridge_location_gps_longitude": 29.31405,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Nyagaheka market",
  //       "education_access_blocked_by_river": "Kigeyo secondary and primary school",
  //       "health_access_blocked_by_river": "Kivumu health center",
  //       "other_access_blocked_by_river": "Kivumu church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "There is A Man who has died in past ten years",
  //       "notes_on_social_information": "Bugarishya people don't have access to nyagaheneka market and rugabe people don't have access to kivumu hospital",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iV6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugari",
  //       "bridge_opportunity_project_code": "1013645",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.99666,
  //       "bridge_opportunity_gps_longitude": 29.3952777,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1667,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.99666,
  //       "proposed_bridge_location_gps_longitude": 29.3952777,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Congo Nile and kibirizi",
  //       "education_access_blocked_by_river": "Mushubati secondary school",
  //       "health_access_blocked_by_river": "Congo Nile health center and mushubati health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "People fell in the river when it is flooded because water reaches on the top of current bridge people slips and then fell in the river",
  //       "notes_on_social_information": "Market(nyarusange village).secondary school (mushubati).healthy center(mushubati). Market(nyarusange).farms(mushubati and nyarusange). Population information for each village was provided by each village leader and adjacent communities population information was provided by nyiransegiyumva Emima bumba cell leader. Population of all adjacent communities includes the following villages: mushubati, nyarusange and Bumba cell. Community members in bumba sometimes go to the mushubati and rubengera once a month to visit their freinds.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 98,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iVuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabira1",
  //       "bridge_opportunity_project_code": "1013646",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9775,
  //       "bridge_opportunity_gps_longitude": 29.381944,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2794,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9775,
  //       "proposed_bridge_location_gps_longitude": 29.381944,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Thirty minutes",
  //       "market_access_blocked_by_river": "Congo Nile",
  //       "education_access_blocked_by_river": "Groupe scolaire de la paix",
  //       "health_access_blocked_by_river": "Congo Nile health center",
  //       "other_access_blocked_by_river": "ADPR in mucyebera",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Olde women fell in coming from their farms",
  //       "notes_on_social_information": "Market(gishushu, kabiraho,), Sec school (gishushu and kabiraho ). Health center (gishusho and kabiraho ). Farms(gishushu, kabiraho, mucyebera and nkwiro).Population information for each village was provided by each village leader and population of all adjacent communities including gihango sector was got from box. Population of all adjacent communities includes the following villages: gishushu, kabiraho, mucyebera and nkwiro and gihango sector.gihango sector community members sometimes cross to visit market twice amonth.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iVzAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabira 2",
  //       "bridge_opportunity_project_code": "1013647",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9752777,
  //       "bridge_opportunity_gps_longitude": 29.381944,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3042,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9752777,
  //       "proposed_bridge_location_gps_longitude": 29.381944,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Congo Nile",
  //       "education_access_blocked_by_river": "Congo Nile",
  //       "health_access_blocked_by_river": "Congo Nile health center",
  //       "other_access_blocked_by_river": "Cothoric church in Congo Nile",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Students fell while crossing from school when it was flooded",
  //       "notes_on_social_information": "Market(mucyebera, gishushu, kabiraho), Sec school (mucyebera,gishushu and kabiraho ). Health center (gishusho and kabiraho and mucyebera). Farms(gishushu, kabiraho, mucyebera and nkwiro).Population information for each village was provided by each village leader and population of all adjacent communities including gihango sector was got from box. Population of all adjacent communities includes the following villages: gishushu, kabiraho, mucyebera and nkwiro and gihango sector.gihango sector community members sometimes cross to visit market twice amonth.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iWEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamaranzara",
  //       "bridge_opportunity_project_code": "1013648",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.83944,
  //       "bridge_opportunity_gps_longitude": 29.3222,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1131,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.83944,
  //       "proposed_bridge_location_gps_longitude": 29.3222,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nkora and gakeri",
  //       "education_access_blocked_by_river": "Murambi primary school",
  //       "health_access_blocked_by_river": "Biruyi health center",
  //       "other_access_blocked_by_river": "Church at biruyi",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 25,
  //       "incident_descriptions": "They fell in the river when it is flooded and kids when there is no one around the can sink trying to cross",
  //       "notes_on_social_information": "Market(rukaragate cell and murambi village), primary school (kamaranzara village ). Health center (murambi village and rukaragate cell ). Farms(rukaragate cell, murambi village and kamaranzara village).Population information for each village was provided by each village leader and total population of cell was provided by each cell leader. Population of all adjacent communities includes the following villages: rukaragate cell, murambi village, kamaranzara village and biruyi cell.biruyi community members sometimes cross to visit rukaragate people twice amonth.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iWdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakoyi",
  //       "bridge_opportunity_project_code": "1013654",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.85437,
  //       "bridge_opportunity_gps_longitude": 29.28597,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 660,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85437,
  //       "proposed_bridge_location_gps_longitude": 29.28597,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "It is always flooded",
  //       "market_access_blocked_by_river": "None",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Farming activities on island",
  //       "primary_occupations": "Fishing and farming",
  //       "primary_crops_grown": "coffe",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "It's an island close to the maziba village where maziba people do farming at the place and kaguriro leader requested abridge saying it could even attract tourist to lake kivu total population of maziba village was provided by yusufu nyacyobazimaz kaguriro leader and the adjacent community included all total number of kaguriro cell as they do cross there for picnic events.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkora",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 100,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iXbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mucyuho",
  //       "bridge_opportunity_project_code": "1013661",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -2.03972,
  //       "bridge_opportunity_gps_longitude": 29.41906,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.03972,
  //       "proposed_bridge_location_gps_longitude": 29.41906,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Rubengera market",
  //       "education_access_blocked_by_river": "Rubengera technical school, nyarubuye secondary school",
  //       "health_access_blocked_by_river": "Rubengera hospital",
  //       "other_access_blocked_by_river": "Kibirizi chapel cothoric church and ADPR girahara",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people fell in the river but they were saved",
  //       "notes_on_social_information": "Kibande village dont have access to karambo village nine years schools and kibirizi chappel cotholic church. Kabahigi village don't have access to rubengera city which got schools, hospitals and all services provided in town. Information were provided by kabahigi village leader and is the one who called finance village to provide the number of his population",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubengera",
  //       "name_of_nearest_paved_or_sealed_road": "Rubengera-kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iZmAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukenesha-nyundo",
  //       "bridge_opportunity_project_code": "1013663",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.876611,
  //       "bridge_opportunity_gps_longitude": 29.372199,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 64,
  //       "bridge_opportunity_individuals_directly_served": 1412,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": 1.87696,
  //       "proposed_bridge_location_gps_longitude": 29.3724,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Gakeri market",
  //       "education_access_blocked_by_river": "Kavumu secondary school",
  //       "health_access_blocked_by_river": "Kayove health center",
  //       "other_access_blocked_by_river": "Kavumu church (Catholic church )",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They slip usually because the current timber bridge is at high elevation",
  //       "notes_on_social_information": "Rukenesha village don't have access to gakeri market and nyundo village don't have access to farms . Information gathered from sekimonyo rukenesha leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ia1AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musange",
  //       "bridge_opportunity_project_code": "1013668",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.61697,
  //       "bridge_opportunity_gps_longitude": 29.79172,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1610,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61697,
  //       "proposed_bridge_location_gps_longitude": 29.79172,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Six hours",
  //       "market_access_blocked_by_river": "None",
  //       "education_access_blocked_by_river": "none",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "People cross the bridge going to Nemba sector and mucaca cell",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Community fall in the river trying to cross because the current bridge is high",
  //       "notes_on_social_information": "Kanunga village don't have access to Nemba sector office. Kiryamo village don't have access to gakenke market Information gathered from manirafasha Emmanuel",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 90,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ib4AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwungo",
  //       "bridge_opportunity_project_code": "1013687",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.63957,
  //       "bridge_opportunity_gps_longitude": 29.71774,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1440,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63957,
  //       "proposed_bridge_location_gps_longitude": 29.71774,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "25 minutes",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Rwungo market",
  //       "education_access_blocked_by_river": "Ruhanga primary and secondary school",
  //       "health_access_blocked_by_river": "Busengo health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kajereri village don't have access to busengo hospital and ruhanga school. Kabungo village don't have access to murwungo center. Information gathered from community member farming around.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 92,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7if6AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nonwe",
  //       "bridge_opportunity_project_code": "1013717",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.224749,
  //       "bridge_opportunity_gps_longitude": 29.291024,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2133,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.224749,
  //       "proposed_bridge_location_gps_longitude": 29.291024,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in twelve kilometers away.",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 3 hours",
  //       "market_access_blocked_by_river": "Communities 1,2&3 do not have access to mugonero market, communities 4&5 are blocked to Gatare market in karongi district. Communities 1,2&3 do not have access to Murundo coffee factory, communities 4&5 do not have access to Copac Nyabumera factory. Communities 1,2,3,4 &5 are blocked to farms in each side of river.",
  //       "education_access_blocked_by_river": "Communities 4&5 do not have access to G.S. Fumba ( primary and secondary O' level), communities 1,2,&3 do not have access to G.S. Nyagatare ( primary and secondary O' level)",
  //       "health_access_blocked_by_river": "Communities 1,2&3 do not have access to Nyamahembe health center.",
  //       "other_access_blocked_by_river": "Communities 4&5 do not have access to Gikore cell office, communities 4&5 are blocked to potable water in kanyoni.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Slipped on the timber and fell down in the river.",
  //       "notes_on_social_information": "Population information of each village was provided by Gikore cell leader, Bikorimana Nathan who sourced the population information from cell register done in 2018 in Ubudehe every year program.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi~Nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": 4.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jEVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambi",
  //       "bridge_opportunity_project_code": "1013718",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.15214,
  //       "bridge_opportunity_gps_longitude": 29.41315,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 55,
  //       "bridge_opportunity_individuals_directly_served": 4561,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.15214,
  //       "proposed_bridge_location_gps_longitude": 29.41315,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 148,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Gisasa village & rukore village & ryampande village don't have access to Rubengera market while Rwintare village & nzabuhara village & burega village don't have acess to gasenyi market",
  //       "education_access_blocked_by_river": "Rwintare village & nzabuhara village & burega village don't have acess to GS burega",
  //       "health_access_blocked_by_river": "Gisasa village & rukore village & ryampande village don't have access to Kirambo health center , while Rwintare village & nzabuhara village & burega village don't have acess to Musango health center",
  //       "other_access_blocked_by_river": "Rwintare village & nzabuhara village & burega village don't have acess to ADEPR Kimba&EPR Rubumba while Gisasa village & rukore village & ryampande village don't have access to ADEPR GASHUBI",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "One injury , went to hospital after incident but did not make it",
  //       "notes_on_social_information": "Nyamiringa cell leader is the one who provided more details about directly individual served and he referred to the population census of 1028",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi -muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jEaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mburabuturo",
  //       "bridge_opportunity_project_code": "1013719",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.18978,
  //       "bridge_opportunity_gps_longitude": 29.42021,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 37,
  //       "bridge_opportunity_individuals_directly_served": 4684,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18978,
  //       "proposed_bridge_location_gps_longitude": 29.42021,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 79,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Himbo village and gishwati village don't have access to Gasenyi market , while mahembe village, Kigarama village and rucura village don't have access to gakuta market",
  //       "education_access_blocked_by_river": "Himbo village and gishwati village don't have access to GS Musango",
  //       "health_access_blocked_by_river": "Himbo village and gishwati village don't have access to Musango health center",
  //       "other_access_blocked_by_river": "Himbo village and gishwati village don't have access to Nyakamira cell office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "When they fall on stones they die",
  //       "notes_on_social_information": "Mahembe village leader provided info about direct individual served by refering to 2017 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jEfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugaseke",
  //       "bridge_opportunity_project_code": "1013721",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.216836,
  //       "bridge_opportunity_gps_longitude": 29.283703,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 65,
  //       "bridge_opportunity_individuals_directly_served": 2412,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.216938,
  //       "proposed_bridge_location_gps_longitude": 29.283485,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge four kilometers away.",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 2 hours",
  //       "market_access_blocked_by_river": " Communities 1,2&3 do not have access to mugonero market, communities 4&5 are blocked to Gatare market in karongi district. Communities 1,2&3 do not have access to Murundo coffee factory,  communities 4&5 do not have access to Copac Nyabumera factory. Communities 1,2,3,4 &5 are blocked to farms in each side of river.",
  //       "education_access_blocked_by_river": " Communities 4&5 do not have access to G.S. Fumba ( primary and secondary O' level), communities 1,2,&3 do not have access to G.S. Nyagatare ( primary and secondary O' level).",
  //       "health_access_blocked_by_river": " Communities 1,2&3 do not have access to Nyamahembe health center and Mugonero has to center.",
  //       "other_access_blocked_by_river": " Communities 1,2 &3 do not have access to Mahembe sector office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": " Population information of each village was provided by Gikore cell leader, Bikorimana Nathan who sourced the population information from cell register done in 2018 in Ubudehe every year program. Population of all adjacent communities includes the following villages: Kivumu, kanyoni, Muramba, fumba and kamashinge.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi ~ Nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": 3.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jEuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwaninka",
  //       "bridge_opportunity_project_code": "1013736",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.733162,
  //       "bridge_opportunity_gps_longitude": 29.520608,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 108,
  //       "bridge_opportunity_individuals_directly_served": 3580,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.722467,
  //       "proposed_bridge_location_gps_longitude": 29.511496,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 hour",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Community 1,2 don't have access to Ruheru market ,communities 3,4 don't have access to Ndago market",
  //       "education_access_blocked_by_river": "Communities 3,4 don't have access to Munini training center",
  //       "health_access_blocked_by_river": "Communities 3,4 don't have access to Munini Hospital",
  //       "other_access_blocked_by_river": "Communities3,4 don't have access to to District head quarter",
  //       "primary_occupations": "Tea plantation workers",
  //       "primary_crops_grown": "maiz, sorghum, tea",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Munini Hospital ( Community 3,4), Ruheru market which is open twice a week ( Community 1,2), Nshili-Kivu tea factory ( Community 1,2), Ndago market which is open twice a week ( Community 3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jImAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Himbo",
  //       "bridge_opportunity_project_code": "1014064",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.1809,
  //       "bridge_opportunity_gps_longitude": 29.40968,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1922,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1809,
  //       "proposed_bridge_location_gps_longitude": 29.40968,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 98,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Gishwati village & Himbo village don't have access to Kivuruga market",
  //       "education_access_blocked_by_river": "Rukore village don't have access to GS Gishwati",
  //       "health_access_blocked_by_river": "Gishwati village & Himbo village don't have access to Gasenyi health center",
  //       "other_access_blocked_by_river": "Gishwati village & Himbo village don't have access to Rwankuba sector HQ whereas Rukore village don't have access to EPR Gishwati",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Two death across this river",
  //       "notes_on_social_information": "Rukore village security officer provided all info about directly individual served by the bridge after call village leaders , they referred to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fSlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusumo",
  //       "bridge_opportunity_project_code": "1013737",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.65413,
  //       "bridge_opportunity_gps_longitude": 30.01517,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4340,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65413,
  //       "proposed_bridge_location_gps_longitude": 30.01517,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Miyove and Kisaro Markets, communities 4,5 don't have access to Tea plantation farms ,",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to Sayo Primary and secondary school, Communities1,2,3 don't have access to Gakenke secondary schools",
  //       "health_access_blocked_by_river": "Community don't have access to Sayo health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Potable water on the right side of the river",
  //       "primary_occupations": "Tea plantation workers, farmers on both sides, traders at Kisaro and Miyove markets",
  //       "primary_crops_grown": "maiz, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died",
  //       "notes_on_social_information": "Kisaro market which is open every Monday ( community 1,2,3); Miyove Market which is open twice a week ( Community1,2,3 ); Buyoga market which is open twice a week ( Community 4,5); Sayo primary and secondary school ( Community 4,5); Tea plantations farms ( Community4,5 ); Potable water ( Community 1,2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base_Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jMtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gaseke",
  //       "bridge_opportunity_project_code": "1013747",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.66082,
  //       "bridge_opportunity_gps_longitude": 30.05076,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 48,
  //       "bridge_opportunity_individuals_directly_served": 4830,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66082,
  //       "proposed_bridge_location_gps_longitude": 30.05076,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Community 3,4 don't have access to Kisaro market, communities 1,2 don't have access to Buyoga market",
  //       "education_access_blocked_by_river": "Communities 3,4don't have access to Kisaro primary and secondary school; communities 1,2 don't have access to Ndogo primary school",
  //       "health_access_blocked_by_river": "Communities 1,2 don't have access to Gitatsa health center",
  //       "other_access_blocked_by_river": "Communities 3,4 don't have access to Protestant Church",
  //       "primary_occupations": "Farmers and traders at Kisaro and Buyoga markets",
  //       "primary_crops_grown": "bean, cabbages ), maiz, potato, vegetables (carrot",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river",
  //       "notes_on_social_information": "Buyoga market which is open twice a week ( Community 1,2), Ndogo primary school ( Community 1,2), Gitatsa health center ( Community 1,2), Kisaro market which is open twice a week ( Community 3,4), Kisaro Primary and secondary school ( Community 3,4), protestant church( community 3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base_Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kjZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigusa",
  //       "bridge_opportunity_project_code": "1013761",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.7246,
  //       "bridge_opportunity_gps_longitude": 29.54478,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3494,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.7246,
  //       "proposed_bridge_location_gps_longitude": 29.54478,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Kabaya market which is open every day and Gasiza market blocked to communities of left side of the river, Tea plantations farms blocked to communities of right side of the river",
  //       "education_access_blocked_by_river": "Gitebe primary and secondary school blocked to communities of right side of the left side",
  //       "health_access_blocked_by_river": "Mwiyanike health center and Kabaya Hospital blocked to communities of left side of the river",
  //       "other_access_blocked_by_river": "Mulinga sector office",
  //       "primary_occupations": "Tea plantation workers, farmers on both sides and traders at Gasiza and Kabaya markets",
  //       "primary_crops_grown": "bean, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One person died trying to cross the river and drowned and two were injured when trying to cross the river and slided on timber and fall in the river",
  //       "notes_on_social_information": "Communities 1,4,and 5 have no access to Kabaya Hospital ,Communities 1,4,and 5 have no access to Kabaya market which is open every day and Gasiza market open twice a week ; Communities 1,4,and 5 have no access to Mwiyanike health center ; Communities 1,4,and 5 have no access to Gitebe primary and secondary school Communities 2 and 3 have no access to Tea plantation farms Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018. Population of adjacent communities include Muremure village. Community members in Muremure village use this crossing to Visit relatives",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kslAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuga",
  //       "bridge_opportunity_project_code": "1013762",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.820233,
  //       "bridge_opportunity_gps_longitude": 30.013769,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 1462,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8204,
  //       "proposed_bridge_location_gps_longitude": 30.01401,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Mugambazi market, communities 2 don't have access to Rutongo mines,",
  //       "education_access_blocked_by_river": "Communities 1 don't have access to Ngoma primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Rutongo hospital, communities 1 don't have access to Remera Health center",
  //       "other_access_blocked_by_river": "Communities 1 don't have access to Churches",
  //       "primary_occupations": "Workers in Rutongo mines( cassetarite ), daily crushed stones workers , farmers on both sides and traders Mugambazi and Remera market",
  //       "primary_crops_grown": "carrots ), maiz, sweet potato, vegetables ( cabbag",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river and one died trying to cross the river",
  //       "notes_on_social_information": "Mugambazi market which is open twice a week ( Community 2), Rutongo Mines ( Community 2), Rutongo Hospital ( Community 1), Remera Health center ( Community 1),Ngoma school ( Community 1), churches ( Community 1). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018.",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ktAAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Agakomeye",
  //       "bridge_opportunity_project_code": "1013773",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.17593,
  //       "bridge_opportunity_gps_longitude": 29.42192,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3885,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.17593,
  //       "proposed_bridge_location_gps_longitude": 29.42192,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point, they walk through the Water of stay on their side !!",
  //       "days_per_year_river_is_flooded": 133,
  //       "flood_duration_during_rainy_season": "4 days of flood",
  //       "market_access_blocked_by_river": "Nyarushekera village , musango village don't have access to mukungu market, while mahembe village , Rubumba village , rukore village, kivumu village don't have access to kivuruga market",
  //       "education_access_blocked_by_river": "mahembe village , Rubumba village , rukore village, kivumu village don't have access to age Musango",
  //       "health_access_blocked_by_river": "mahembe village , Rubumba village , rukore village, kivumu village don't have access to Musango health center",
  //       "other_access_blocked_by_river": "mahembe village , Rubumba village , rukore village, kivumu village don't have access to Musango church",
  //       "primary_occupations": "Faminrng",
  //       "primary_crops_grown": "bean, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "One kid who was coming from school",
  //       "notes_on_social_information": "Mahembe village leader is the one who provided the information about individual served by calling other village leaders who are using the bridge in their daily activities , they referred to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wXYAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buhunge",
  //       "bridge_opportunity_project_code": "1014158",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.74006,
  //       "bridge_opportunity_gps_longitude": 29.67281,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3960,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.74006,
  //       "proposed_bridge_location_gps_longitude": 29.67281,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Communities don't have access to Farms on both sides, communities 2 don't have access to Busoro market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Ngera Health center",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to Kibeho Parish and Holy place",
  //       "primary_occupations": "Farmers on both side, Traders at Busoro Market",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye_Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hPvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakamira",
  //       "bridge_opportunity_project_code": "1013774",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.17507,
  //       "bridge_opportunity_gps_longitude": 29.42564,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3585,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.17507,
  //       "proposed_bridge_location_gps_longitude": 29.42564,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 111,
  //       "flood_duration_during_rainy_season": "3 days of flood",
  //       "market_access_blocked_by_river": "Mahembe village and Musango village don't have access to kivuruga market , while nyarushekera village, himbo village and rukore village don't have access to Gasenyi market",
  //       "education_access_blocked_by_river": "nyarushekera village, himbo village and rukore village don't have access to GS Musango",
  //       "health_access_blocked_by_river": "nyarushekera village, himbo village and rukore village don't have access to health center of Musango",
  //       "other_access_blocked_by_river": "nyarushekera village, himbo village and rukore village don't have access to Musango Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Two old man died in the and 6 were injured",
  //       "notes_on_social_information": "Nyarushekera village leader is the one who provided all information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi _ Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wXdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Matyazo",
  //       "bridge_opportunity_project_code": "1013776",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.06165,
  //       "bridge_opportunity_gps_longitude": 29.39508,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3816,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06165,
  //       "proposed_bridge_location_gps_longitude": 29.39508,
  //       "current_crossing_method": "Walking through the water",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 81,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Matyazo village, kabuga village , twimbogo village , Majuri village , ruyenzi village , and Nyabikenke village don't have access to kibirizi market",
  //       "education_access_blocked_by_river": "Matyazo village, kabuga village , twimbogo village , Majuri village , ruyenzi village , and Nyabikenke village don't have access to Rubengera secondary school",
  //       "health_access_blocked_by_river": "Matyazo village, kabuga village , twimbogo village , Majuri village , ruyenzi village , and Nyabikenke village don't have access to Rubengera health center",
  //       "other_access_blocked_by_river": "Matyazo village, kabuga village , twimbogo village , Majuri village , ruyenzi village , and Nyabikenke village don't have access to ADEPR kibirizi",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "People who were going to the market",
  //       "notes_on_social_information": "Rubona village leader was there to provide all info and numbers of population directly served , by referring to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wXsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamonyo",
  //       "bridge_opportunity_project_code": "1013786",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.1484,
  //       "bridge_opportunity_gps_longitude": 29.48612,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4218,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1484,
  //       "proposed_bridge_location_gps_longitude": 29.48612,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 65,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Nyabikenke village, rugarama village , kibirizi village, and Gashari village don't have access to",
  //       "education_access_blocked_by_river": "Nyabikenke village, rugarama village , kibirizi village, and Gashari village don't have access to Gasharu primary school",
  //       "health_access_blocked_by_river": "Nyabikenke village, rugarama village , kibirizi village, and Gashari village don't have access to birambo health center",
  //       "other_access_blocked_by_river": "Nyabikenke village, rugarama village , kibirizi village, and Gashari village don't have access to Gasharu church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "An old man who was crossing the river , and the dead disappeared.",
  //       "notes_on_social_information": "Gasharu village leader is the one who provided info about directly individual served , by referring to 2018 population census",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wYqAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarusange",
  //       "bridge_opportunity_project_code": "1013792",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.72848,
  //       "bridge_opportunity_gps_longitude": 29.76589,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 100,
  //       "bridge_opportunity_individuals_directly_served": 2740,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.72848,
  //       "proposed_bridge_location_gps_longitude": 29.76589,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Muremure market",
  //       "education_access_blocked_by_river": "Munyana primary and secondary school",
  //       "health_access_blocked_by_river": "Munyana health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, pineappl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "They fell in the river when it is flooded",
  //       "notes_on_social_information": "Munyana school and munyana hospital and Muremure market[kabuyora, gataba, mwanza]. Gihororo village don't have access to farms. Information gathered from twagizimana village member",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 101,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wv0AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatarinzira",
  //       "bridge_opportunity_project_code": "1013805",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.775531,
  //       "bridge_opportunity_gps_longitude": 29.708728,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 102,
  //       "bridge_opportunity_individuals_directly_served": 4868,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7759,
  //       "proposed_bridge_location_gps_longitude": 29.70875,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April, May, November and December, it last for 8 hours",
  //       "market_access_blocked_by_river": "Rugogwe, Iviro, Bihembe and Duwani markets (Community 1,2,3), Nyaruteja Market (Community 4,5), Farms (Community 1,2,4), Coffee Washing Station (Community 4,5)",
  //       "education_access_blocked_by_river": "Higiro Primary and Secondary School (Community 4,5), Kivuru Primary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Nyamirama Health Post (Community 1,2,3), Kigembe Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Higiro Catholic and ADEPR Churches (Community 4,5), ADEPR church Nyagasozi (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, beans., cassava, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many people fall into the river when they try to cross it. 3 people have died trying to cross the river during rainy season.",
  //       "notes_on_social_information": "Gatarinzira, Kigali, Rama, Cyumba, Agahehe, Urutoyi, Kigembe and Nteko villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Nyamugari Cell Leader, Eric Muhayimana and Gatarinzira village leader, Mukakalisa Albertine, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5FAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sare",
  //       "bridge_opportunity_project_code": "1013806",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.7975,
  //       "bridge_opportunity_gps_longitude": 29.697972,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 88,
  //       "bridge_opportunity_individuals_directly_served": 4509,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.79714,
  //       "proposed_bridge_location_gps_longitude": 29.69812,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April, May, November and December it last for 8 hours",
  //       "market_access_blocked_by_river": "Viru and Duwani markets (Community 1,2,3), Nyaruteja and Mburamazi markets (Community 4,5)",
  //       "education_access_blocked_by_river": "Higiro Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Nyamirama Health Post (Community 1,2,3), Rwamiko health post and Kigembe Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Kibeho holy land and Fungi Catholic Church (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 10,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "Many people fall into the river and they get rescued but so far 10 people have died trying to cross the river during rainy season.",
  //       "notes_on_social_information": "Sare, Rugogwe, Akayange, Rwamiko, Kanyamaganda, Nteko and Bihembe villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Nyamugari Cell Leader, Muhayimana Eric and Save village leader, Ntawondereye Jean Baptiste, from the population data collected in 2018.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5KAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muza",
  //       "bridge_opportunity_project_code": "1014335",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.926511,
  //       "bridge_opportunity_gps_longitude": 29.814264,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 68,
  //       "bridge_opportunity_individuals_directly_served": 10150,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.926209,
  //       "proposed_bridge_location_gps_longitude": 29.8142,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "October to December, April to May, 48 hours",
  //       "market_access_blocked_by_river": "Manyana market ( 1), kayenzi market ( 2,3), ruhimbi market ( 1), farms ( 1,2,3)",
  //       "education_access_blocked_by_river": "Nyamirimbi primary school( 1), kayonza primary ( 2,3).",
  //       "health_access_blocked_by_river": "Kayenzi health center ( 2,3), Murara health center ( 1).",
  //       "other_access_blocked_by_river": "Bunyonga church ( 1), potable water ( 1)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Student was coming from school and Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": 2.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eessFAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gomba",
  //       "bridge_opportunity_project_code": "1013873",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.09219,
  //       "bridge_opportunity_gps_longitude": 29.38608,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4437,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.09219,
  //       "proposed_bridge_location_gps_longitude": 29.38608,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 210,
  //       "flood_duration_during_rainy_season": "3 days of flood",
  //       "market_access_blocked_by_river": "Gomba village, Kirambo village , kivomo village, gitarama village, and nyarugenge village don't have access to Rubengera market",
  //       "education_access_blocked_by_river": "Gomba village, Kirambo village , kivomo village, gitarama village, and nyarugenge village don't have access to GS Ruragwe while Nyamigina village ,kigezi village, ruhande village ,Nyabitare village, Nyabigugu village dotn have access to EP Nemba",
  //       "health_access_blocked_by_river": "Gomba village, Kirambo village , kivomo village, gitarama village, and nyarugenge village don't have access to Nyamuhebe health center",
  //       "other_access_blocked_by_river": "Gomba village, Kirambo village , kivomo village, gitarama village, and nyarugenge village don't have access to Kayenzi Adventist church , and Nyamigina village ,kigezi village, ruhande village ,Nyabitare village, Nyabigugu village dotn have access to EPR Kigezi.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "People die , no injury",
  //       "notes_on_social_information": "EP Nenda Head teacher & Chief of Special court In Gitarama cell gave me all info about directly individual served",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d889ZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo",
  //       "bridge_opportunity_project_code": "1013886",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.221268,
  //       "bridge_opportunity_gps_longitude": 29.256019,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7086,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.221268,
  //       "proposed_bridge_location_gps_longitude": 29.256019,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away.",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "October to May, 3 hours",
  //       "market_access_blocked_by_river": "Mugonero market( village 1), farms ( village 2).",
  //       "education_access_blocked_by_river": "Nyagatare secondary school ( villages 2 & 3), gihombo primary school ( community 1), nyakanyinya secondary school ( community 1), kibingo primary school and secondary school ( 1).",
  //       "health_access_blocked_by_river": "Mahembe health center ( community 3 ), kibingo health center ( 1 ).",
  //       "other_access_blocked_by_river": "Karambo Methodist church, kizenga adventist church( 2 &3), kibingo Catholic church ( 1). Gihombo police station ( 1 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by cell leader, Ntahondereye Modeste who sourced the population from the cell record.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi ~ nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88DlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyirabageni",
  //       "bridge_opportunity_project_code": "1013892",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.401998,
  //       "bridge_opportunity_gps_longitude": 29.204765,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11852,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.401998,
  //       "proposed_bridge_location_gps_longitude": 29.204765,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away.",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "February, March to May, October to December, 24 hours, however sometimes one week without crossing.",
  //       "market_access_blocked_by_river": "Rugari market, Kirambo market and tyazo market ( villages 1, 2 and 3), nyamagabe market ( village 4), farms ( 1,2,3 and 4), pyramid company ( village 1, 2 and 3).",
  //       "education_access_blocked_by_river": "G.S. st Jean bosco yove( secondary school l [ villages from Murambi cell).",
  //       "health_access_blocked_by_river": "Yove health center ( villages 4 ).",
  //       "other_access_blocked_by_river": "Sector office( villages 4 ), yove Catholic church and MRL church ( villages 4), football terain( village 4).",
  //       "primary_occupations": "Farming and ,livestock",
  //       "primary_crops_grown": "bean, cassava, maiz, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned, but before three years two people have died.",
  //       "notes_on_social_information": "Population information of each village was provided by Basekakariyo Xavier, who sourced the population from cell register done in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 83,
  //       "height_differential_between_banks": 5.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88IRAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisiza",
  //       "bridge_opportunity_project_code": "1013898",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.353335,
  //       "bridge_opportunity_gps_longitude": 29.147336,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3100,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.353335,
  //       "proposed_bridge_location_gps_longitude": 29.147336,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to May, September to November, 48 hours",
  //       "market_access_blocked_by_river": "Rwesero market, tyazo market, kirambo market and Buhinaga market and Bunyazi livestock market ( villages 1, 2, and 3); Gisakura thee factory ( villages 1, 2, 3 and kabuye community), Rushonde coffee factory ( villages 1, 2 and 3), gasihe coffee factory ( villages 4 and 5). Farms ( 1, 2, 3, 4 and 5).",
  //       "education_access_blocked_by_river": "Tero secondary school ( villages 4 & 5). Remera primary school( villages 1,2,3)",
  //       "health_access_blocked_by_river": "Kibogora health center and kibogora hospital ( villages 1,3), Gako health center ( villages 1, and 3), Rruheru health center ( villages 4&5).",
  //       "other_access_blocked_by_river": "ADPR Nyagisasa, EAR nyagisasa, EMERERI Rugeyo( villages 4&5), Catholic church, ADPR TYAZO PARISH ( 1 and 3), kanjongo sector office , Nyamasheke district ( village 1 and 3). Potable water ( villages 4).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, coffe, the",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down in river and drowned.",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Tyazo~nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88KhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mucyuzi",
  //       "bridge_opportunity_project_code": "1014006",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.69435,
  //       "bridge_opportunity_gps_longitude": 29.30102,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 42,
  //       "bridge_opportunity_individuals_directly_served": 857,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.26",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.69435,
  //       "proposed_bridge_location_gps_longitude": 29.30102,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 hour",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Mahoko market and rugerero market, rubavu markrt",
  //       "education_access_blocked_by_river": "Rusamaza high school",
  //       "health_access_blocked_by_river": "Nyundo health center",
  //       "other_access_blocked_by_river": "ADEPR nyundo",
  //       "primary_occupations": "Farming and business",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "The community slips on the current bridge because it is on high elevation and fall",
  //       "notes_on_social_information": "Amahoro village don't have access to nyundo hospital and mahoko hospital Rambura village don't have access to farms information gathered from rambura village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1e0iAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabihunyira",
  //       "bridge_opportunity_project_code": "1014011",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.554196,
  //       "bridge_opportunity_gps_longitude": 29.043492,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 78,
  //       "bridge_opportunity_individuals_directly_served": 10588,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.554196,
  //       "proposed_bridge_location_gps_longitude": 29.043492,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in five kilometers",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "March to May, October to December, flood take 12 hours but they still cross the river however the crossing is not safe due to the depth between river and bridge .",
  //       "market_access_blocked_by_river": "Gasumo market, kareba market ( village 1,2 and 4), Nyakabuye market ( village 3 ), farms ( village 1 and 3 ). Nyabintare coffee washing station ( village 1,2).",
  //       "education_access_blocked_by_river": "Groupe scholaire saint paul~ secondary school( village 3 ), nyantomvu primary school( village 3 ).",
  //       "health_access_blocked_by_river": "Nyakabuye health center and Mwezi health ( community 3 ).",
  //       "other_access_blocked_by_river": "Churches in Nyakabuye cell ( village 1 ).",
  //       "primary_occupations": "Farming and livestock",
  //       "primary_crops_grown": "bean, coffe, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Fell down and drowned while crossing river.",
  //       "notes_on_social_information": "Population information of each village was provided by Higiro cell leader, Dusengimana Marlene who sourced the population from cell register. Population of all adjacent communities includes the following villages: mpinga, Muhura, Gitunda, Nyabintare, Rubona and Muganza.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 83,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2TAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyamatare",
  //       "bridge_opportunity_project_code": "1014376",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.162912,
  //       "bridge_opportunity_gps_longitude": 29.574572,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8936,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.162912,
  //       "proposed_bridge_location_gps_longitude": 29.574572,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "45times in April,May, October November and December and it lasts 3hours after rainfall",
  //       "market_access_blocked_by_river": "Mubuga cell doesn't have access to Kirinda market",
  //       "education_access_blocked_by_river": "Nyarunyinya cell doesn't have access to Mubuga primary and secondary school Nyarunyinya cell doesn't have access to Cyamatare Primary school",
  //       "health_access_blocked_by_river": "Mubuga cell doesn't have access to Kirinda hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, banana, cassava",
  //       "primary_crops_grown": "banana, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuy6AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musasa 3A",
  //       "bridge_opportunity_project_code": "1014027",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.19859833,
  //       "bridge_opportunity_gps_longitude": 29.51245167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5332,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.19859833,
  //       "proposed_bridge_location_gps_longitude": 29.51245167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "48times in April, May, October November and December and it lasts 3hours after rainfall",
  //       "market_access_blocked_by_river": "Gataba, Kabaranda, Nyagisozi villages don't have access to Gahunduguru market Kabingo cell doesn't have access to Birambo market",
  //       "education_access_blocked_by_river": "Kabingo cell doesn't have access to Mwendo secondary school Gataba, Kabaranda, Nyagisozi villages don't have access to Ruganda secondary school",
  //       "health_access_blocked_by_river": "Kabingo cell doesn't have access to Mwendo health center Gataba, Kabaranda, Nyagisozi villages don't have access to Ruganda health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, banana, maize, beans",
  //       "primary_crops_grown": "banana, bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders, and the people numbers were based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36.4,
  //       "height_differential_between_banks": 2.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fMTAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuga",
  //       "bridge_opportunity_project_code": "1014038",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.246215,
  //       "bridge_opportunity_gps_longitude": 29.491565,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 21209,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.246215,
  //       "proposed_bridge_location_gps_longitude": 29.491565,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 140,
  //       "flood_duration_during_rainy_season": "20times throughout the year and it lasts for 7days after rainfall",
  //       "market_access_blocked_by_river": "Muremure, Nyagasozi villages don't have access to Kigarama market Mugano sector doesn't have access to Gahunduguru market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Mugano sector doesn't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, Cassava, banana,",
  //       "primary_crops_grown": "banana, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 74.8,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNRAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kaduha",
  //       "bridge_opportunity_project_code": "1014039",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.234305,
  //       "bridge_opportunity_gps_longitude": 29.436305,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 62,
  //       "bridge_opportunity_individuals_directly_served": 5357,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.234305,
  //       "proposed_bridge_location_gps_longitude": 29.436305,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "45times in April, May, October November and December and it lasts for 3hours after rainfall",
  //       "market_access_blocked_by_river": "Nyamugwagwa cell doesn't have access to Mukungu Murengezo cell doesn't have access to Gahunduguru market",
  //       "education_access_blocked_by_river": "Nyamugwagwa cell doesn't have access to Kiraga primary school Murengezo cell doesn't have access to Nyamugwagwa primary and secondary school",
  //       "health_access_blocked_by_river": "Nyamugwagwa cell doesn't have access to Mukungu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, banana, beans",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36.5,
  //       "height_differential_between_banks": 2.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagusa",
  //       "bridge_opportunity_project_code": "1014054",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.20151,
  //       "bridge_opportunity_gps_longitude": 29.3787,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 115,
  //       "bridge_opportunity_individuals_directly_served": 1625,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20151,
  //       "proposed_bridge_location_gps_longitude": 29.3787,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 182,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Muyira village, Gakangaga village ,nyarutagara village and Muhire village don't have Acess to Gakuta market",
  //       "education_access_blocked_by_river": "Muyira village, Gakangaga village ,nyarutagara village and Muhire village don't have Acess to GS Bigugu",
  //       "health_access_blocked_by_river": "Muyira village, Gakangaga village ,nyarutagara village and Muhire village don't have Acess to Gisovu health center",
  //       "other_access_blocked_by_river": "Muyira village, Gakangaga village ,nyarutagara village and Muhire village don't have Acess to kavumu Adventist church, whereas Kagusa village, ruhondo village , uwintobo village don't have access to ADEPR Rwampare",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Two people died here",
  //       "notes_on_social_information": "Bigugu cell leader is the one who provided all info about directly individual served by the bridge , she referred to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fPhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagorora",
  //       "bridge_opportunity_project_code": "1014059",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.231883,
  //       "bridge_opportunity_gps_longitude": 29.517175,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 21645,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.231883,
  //       "proposed_bridge_location_gps_longitude": 29.517175,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 140,
  //       "flood_duration_during_rainy_season": "20times in April, May, October November and December and it lasts for 7days after rainfall",
  //       "market_access_blocked_by_river": "Mugano sector doesn't have access to Gahunduguru market Mugano sector doesn't have access to Birambo market Kagorora, Birambo villages don't have access to Kaduha market",
  //       "education_access_blocked_by_river": "Kagorora, Birambo villages don't have access to Turyango secondary school",
  //       "health_access_blocked_by_river": "Mugano sector doesn't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, cassava, banana, beans",
  //       "primary_crops_grown": "banana, bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 58.4,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fRxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare",
  //       "bridge_opportunity_project_code": "1014061",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.26854,
  //       "bridge_opportunity_gps_longitude": 29.4563,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 130,
  //       "bridge_opportunity_individuals_directly_served": 3574,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.26854,
  //       "proposed_bridge_location_gps_longitude": 29.4563,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "10 days of flood",
  //       "market_access_blocked_by_river": "Nyakibande village, murambi village and other villages from nyamagabe side don't have access to mukungu market, whereas GASHUBI village , gatwa village ryarugango village and other villages from Karongi don't have access to mushubi market",
  //       "education_access_blocked_by_river": "Nyakibande village, murambi village and other villages from nyamagabe side don't have access to GS ngundusi , whereas GASHUBI village , gatwa village ryarugango village and other villages from Karongi don't have access to Kizanganya GS",
  //       "health_access_blocked_by_river": "Nyakibande village, murambi village and other villages from nyamagabe side don't have access to mukungu health center, whereas GASHUBI village , gatwa village ryarugango village and other villages from Karongi don't have access to mushubi health center",
  //       "other_access_blocked_by_river": "gatwa village ryarugango village and other villages from Karongi don't have access to Jimbo Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bana, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 15,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "Mbirurume very dangerous people died there",
  //       "notes_on_social_information": "Mayombo village leader provided all info about direct individual served by the bridge , and he referred to 2018 population census",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi- Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fSWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwantobo",
  //       "bridge_opportunity_project_code": "1014063",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.74047,
  //       "bridge_opportunity_gps_longitude": 29.37229,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1550,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.74047,
  //       "proposed_bridge_location_gps_longitude": 29.37229,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "365",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Gs nyabirasi",
  //       "health_access_blocked_by_river": "Nyabirasi health center",
  //       "other_access_blocked_by_river": "ADPR kigarama",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Because there is no current bridge no one who cross so the bridge will be facilitating the community to provide a short way",
  //       "notes_on_social_information": "Gacaca don't have access to mahoko market And rwantobo don't have access to rutsiro farms Information gathered from kagarama cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Mahoko",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fSgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisesero",
  //       "bridge_opportunity_project_code": "1014089",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.5886,
  //       "bridge_opportunity_gps_longitude": 29.05452,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 850,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Vehicular bridge wanted and the river is too small to warrant a B2P bridge. Looks like the road just gets washed out by a small stream.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.5886,
  //       "proposed_bridge_location_gps_longitude": 29.05452,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Bugarama",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It's a vehicular bridge and there is no space for the bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatorove",
  //       "bridge_opportunity_project_code": "1014065",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.26958,
  //       "bridge_opportunity_gps_longitude": 29.42796,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1240,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.26958,
  //       "proposed_bridge_location_gps_longitude": 29.42796,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "10 hours of flood",
  //       "market_access_blocked_by_river": "Mukongoro village , kanyege village and Nyarubuye village don't have access to mukungu market, whereas GASHUBI village , gatwa village don't have access to nkomane market",
  //       "education_access_blocked_by_river": "Mukongoro village , kanyege village and Nyarubuye village don't have access to GS Gisayura",
  //       "health_access_blocked_by_river": "Mukongoro village , kanyege village and Nyarubuye village don't have access to mukungu health center",
  //       "other_access_blocked_by_river": "GASHUBI village , gatwa village don't have access to mushubi church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "5 people died crossing this river , as they walked to the water to cross the river",
  //       "notes_on_social_information": "Gisayura village leader provided info about directly individual served by the bridge site and called all village leaders to confirm their number of population who are using the bridge. He referred to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi _ Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fSqAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamacaca",
  //       "bridge_opportunity_project_code": "1014066",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.23068,
  //       "bridge_opportunity_gps_longitude": 29.38988,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1754,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.23068,
  //       "proposed_bridge_location_gps_longitude": 29.38988,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 81,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Population from kavumu cell don't have access to Gakuta market",
  //       "education_access_blocked_by_river": "Population from Murehe cell don't have access to GS Nyarutagara",
  //       "health_access_blocked_by_river": "Population from kavumu cell don't have access to Gisovu health center",
  //       "other_access_blocked_by_river": "Population from Murehe cell don't have access to ADEPR Nyarutagara",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "In August 2018 ,one person died and other 2 persons became injured.",
  //       "notes_on_social_information": "Kavumu village leader provided the information about individual served by referring to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fSvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyunyu",
  //       "bridge_opportunity_project_code": "1014067",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.25799,
  //       "bridge_opportunity_gps_longitude": 29.41381,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 70,
  //       "bridge_opportunity_individuals_directly_served": 3838,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.25799,
  //       "proposed_bridge_location_gps_longitude": 29.41381,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 189,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "mukongoro village , Nyarubuye village and kavumu village don't have access to Mukungu market",
  //       "education_access_blocked_by_river": "Gasharu village , gisayura village, mukungu village and Nyabiguri village don't have access to ES Manje whereas mukongoro village , Nyarubuye village and kavumu village don't have access to ES mukungu",
  //       "health_access_blocked_by_river": "mukongoro village , Nyarubuye village and kavumu village don't have access to Mukungu health center whereas Gasharu village , gisayura village, mukungu village and Nyabiguri village don't have access to mushubi health center",
  //       "other_access_blocked_by_river": "Gasharu village , gisayura village, mukungu village and Nyabiguri village don't have access to mushubi church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "3 people died crossing the river",
  //       "notes_on_social_information": "Gasharu village leader is the one who provided info about directly individual by referring to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fT5AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Wamahoro",
  //       "bridge_opportunity_project_code": "1014068",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.143712,
  //       "bridge_opportunity_gps_longitude": 29.352145,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 100,
  //       "bridge_opportunity_individuals_directly_served": 3341,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14383,
  //       "proposed_bridge_location_gps_longitude": 29.35221,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 270,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Wamahoro village & kanyarusanga village &nyaruyaga village don't have access to Kiziba refugee camp market",
  //       "education_access_blocked_by_river": "Wamahoro village, Gasharu village and kinyege village don't have access to GS Rubazo",
  //       "health_access_blocked_by_river": "Wamahoro village & kanyarusanga village &nyaruyaga village don't have access to Kiziba refugees camp health center",
  //       "other_access_blocked_by_river": "Wamahoro village, Gasharu village and kinyege village don't have access to ADEPR Rubazo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Two kids died crossing this river",
  //       "notes_on_social_information": "Two village leaders ( kanyarusanga village & Wamahoro village) , Rubazo cell security officer and SEDO Rubazo cell , all of them were there to provide information about directly individual served by the bridge , they referred to lastest population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fTAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisiza",
  //       "bridge_opportunity_project_code": "1014072",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.25545,
  //       "bridge_opportunity_gps_longitude": 29.47791,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3747,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.25545,
  //       "proposed_bridge_location_gps_longitude": 29.47791,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 231,
  //       "flood_duration_during_rainy_season": "7 days of flood",
  //       "market_access_blocked_by_river": "Rubona village, muremure village ,Nyagasozi village don't have access to mukungu market whereas Nyarutovu village, mayombo village and Ngundusi village don't have access to Gahunduguru market",
  //       "education_access_blocked_by_river": "Rubona village, muremure village ,Nyagasozi village don't have access to EP Ngundusi whereas Nyarutovu village, mayombo village and Ngundusi village don't have access to GS Biguhu",
  //       "health_access_blocked_by_river": "Rubona village, muremure village ,Nyagasozi village don't have access to Mukungu health center whereas Nyarutovu village, mayombo village and Ngundusi village don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": "Rubona village, muremure village ,Nyagasozi village don't have access to mutuntu sector office , whereas Nyarutovu village, mayombo village and Ngundusi village don't have access to Biguhu market",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "On 18th October 2018 , a man died from mukungu market he had 6 children, other 4 persons also died across this river",
  //       "notes_on_social_information": "Nyarutovu village leader provided all info about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fTZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Masumo",
  //       "bridge_opportunity_project_code": "1014076",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.26182,
  //       "bridge_opportunity_gps_longitude": 29.37822,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1522,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.26182,
  //       "proposed_bridge_location_gps_longitude": 29.37822,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 118,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Nyiramirango village don't have access to mukungu market , whereas uwabashi village don't have access to Gakuta market",
  //       "education_access_blocked_by_river": "Nyiramirango village don't have access to ES Manji , whereas uwabashi village don't have access to Gs Gakuta",
  //       "health_access_blocked_by_river": "Nyiramirango village don't have access to mukungu Health center , whereas uwabashi village don't have access to Gakuta Health center",
  //       "other_access_blocked_by_river": "Nyiramirango village don't have access to Rwufe Adventist church , whereas uwabashi village don't have access to Gakuta Gakuta church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two kids were died, 2 people injured",
  //       "notes_on_social_information": "Kadehero village leader provided info about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fU3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burwi",
  //       "bridge_opportunity_project_code": "1014374",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.136568,
  //       "bridge_opportunity_gps_longitude": 29.5995,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9401,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.136568,
  //       "proposed_bridge_location_gps_longitude": 29.5995,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 140,
  //       "flood_duration_during_rainy_season": "20times in April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Kabaya cell doesn't have access to Muremure market Kabaya cell doesn't have access to Buhanda market Bweramvura cell doesn't have access to Nyange market Bweramvura cell doesn't have access to Birambo",
  //       "education_access_blocked_by_river": "Bweramvura cell doesn't have access to Munzanga Secondary school Bweramvura cell doesn't have access to Mubuga primary and secondary school",
  //       "health_access_blocked_by_river": "Bweramvura cell doesn't have access to Munzanga Health Center Bweramvura cell doesn't have access to Kirinda hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "There is farms of sweet potatoes, banana, cassava",
  //       "primary_crops_grown": "banana, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 98.4,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuxrAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Wiraro",
  //       "bridge_opportunity_project_code": "1014083",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.24481167,
  //       "bridge_opportunity_gps_longitude": 29.44779833,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 5156,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.24481167,
  //       "proposed_bridge_location_gps_longitude": 29.44779833,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "50times in April, May, October November and December and it lasts 4hours after rainfall",
  //       "market_access_blocked_by_river": "Nyagasozi, Muremure, KIBARI, Gitwa, Murambi villages don't have access to Mukungu animal market Murengezo cell doesn't have access to Gahunduguru market",
  //       "education_access_blocked_by_river": "Murengezo cell doesn't have access to KIBARI Secondary school Nyagasozi, Muremure, KIBARI, Gitwa, Murambi villages don't have access to Mukungu secondary school",
  //       "health_access_blocked_by_river": "Nyagasozi, Muremure, KIBARI, Gitwa, Murambi villages don't have access to Mukungu health center Murengezo cell doesn't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, cassava, beans,",
  //       "primary_crops_grown": "bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Nyagasozi village uses this crossing regularly and their people were included in the total population to be served. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fUhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gombaniro-mubombo",
  //       "bridge_opportunity_project_code": "1014091",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.72777,
  //       "bridge_opportunity_gps_longitude": 29.03227,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2106,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.72777,
  //       "proposed_bridge_location_gps_longitude": 29.03227,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "They cross along way 3",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two weeks",
  //       "market_access_blocked_by_river": "Bugarama city",
  //       "education_access_blocked_by_river": "Ryankana primary school",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Military camp at gombaniro forces some times loose the opportunity to catch the enemy due to the lack of bridge",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Because the is current bridge community pass through the water and sometimes they likely to be taken by water",
  //       "notes_on_social_information": "Mubombo village don't have access to model village . Military camp at gombaniro don't have access to mubombo village sometimes loose the opportunity to catch enemy. Information gathered from cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Bugarama",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 74,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiyivu-buhanga",
  //       "bridge_opportunity_project_code": "1014094",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.70183,
  //       "bridge_opportunity_gps_longitude": 29.03029,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1259,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.70183,
  //       "proposed_bridge_location_gps_longitude": 29.03029,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three weeks",
  //       "market_access_blocked_by_river": "Bugarama market",
  //       "education_access_blocked_by_river": "Kibangira primary school",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "People flooded trying to cross and died",
  //       "notes_on_social_information": "Buhanga village don't have access to bugarama market Information gathered from locals",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Bugarama city",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 61,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Katabuvuga",
  //       "bridge_opportunity_project_code": "1014095",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.63441,
  //       "bridge_opportunity_gps_longitude": 29.01131,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2490,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.63441,
  //       "proposed_bridge_location_gps_longitude": 29.01131,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Muganza market",
  //       "education_access_blocked_by_river": "Musumba primary school",
  //       "health_access_blocked_by_river": "Muganza health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A drunk man slipped and fell in the river when it was flooded and got injured",
  //       "notes_on_social_information": "Sanganiro village don't have access to muganza high school Gatanga village don't have access to muganza market Information gathered from cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-cimerwa",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabingo1",
  //       "bridge_opportunity_project_code": "1014099",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.58878,
  //       "bridge_opportunity_gps_longitude": 29.09516,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.58878,
  //       "proposed_bridge_location_gps_longitude": 29.09516,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nyakabuye market and muganza market",
  //       "education_access_blocked_by_river": "EP rugeti",
  //       "health_access_blocked_by_river": "Gasumo health center",
  //       "other_access_blocked_by_river": "Churches at rwambongo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Because th e bridge is at high elevation community slip and fall",
  //       "notes_on_social_information": "Nyaruteja village don't have access to nyakabuye market and nyakibanda village don't have access to bweyeye Information gathered from nyakibanda village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakabuye",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fWJAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwengenzi",
  //       "bridge_opportunity_project_code": "1014104",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.58744,
  //       "bridge_opportunity_gps_longitude": 29.10611,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5996,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.58744,
  //       "proposed_bridge_location_gps_longitude": 29.10611,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2,3), Karambo market (Community 4,5), Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Gasumo Primary and Secondary School (Community 4)",
  //       "health_access_blocked_by_river": "Gasumo Health Post (Community 4), Nyakabuye Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Butare Sector Office (Community 1,2,3), Gasumo military camp on the LHS (Military), Gasumo Catholic and Methodist churches (Community 4,5)",
  //       "primary_occupations": "Agriculture and mining",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Two people died trying to cross the river and 5 were seriously injured.",
  //       "notes_on_social_information": "Gasumo, Kenya, Nyaruteja, Ndengerezi, Kirwano and Rushwati villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools and farming. Population information for each village was provided by the Rwambogo Cell Leader, and the Gasumo Village Leader, Ayabino Stephanie from the population data collected in 2018.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Kigali - Rusizi Town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 52,
  //       "height_differential_between_banks": 1.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fjmAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kavumu",
  //       "bridge_opportunity_project_code": "1014119",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.37608,
  //       "bridge_opportunity_gps_longitude": 29.16455,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4871,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37608,
  //       "proposed_bridge_location_gps_longitude": 29.16455,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Communities 5 don't have access to Kirambo market, communities 1,2,3,4 don't have access to Susa Market",
  //       "education_access_blocked_by_river": "Communities 3,4 don't have access to Taro secondary school",
  //       "health_access_blocked_by_river": "Communities 5 don't have access to to Kibogora Hospital and Rangiro health center",
  //       "other_access_blocked_by_river": "Communities 5 don't have access to Catholic Parish and district headquarters",
  //       "primary_occupations": "Farmers and traders Kirambo market and Susa market",
  //       "primary_crops_grown": "beans on large scal, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One person died trying to cross the river and two people fell into the river but fortunately are still alive",
  //       "notes_on_social_information": "Kirambo market which is open twice a week ( Community 5), Susa Market ( Community 1,2,3,4), Rangiro health center ( Community 5), Kibogora Hospital ( Community 5). Population information for each village was provided by Mukamana Tamali Murambi cell leader and population information was sourced from village census data collected in June 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hDLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamugari",
  //       "bridge_opportunity_project_code": "1014375",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.155625,
  //       "bridge_opportunity_gps_longitude": 29.5944,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7580,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.155625,
  //       "proposed_bridge_location_gps_longitude": 29.5944,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 105,
  //       "flood_duration_during_rainy_season": "15times in April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Shyembe cell doesn't have access to Nyange market Shyembe cell doesn't have access to Muremure",
  //       "education_access_blocked_by_river": "Shyembe cell doesn't have access to Muremure secondary school Shyembe cell doesn't have access to Mubuga primary and secondary school Mubuga cell doesn't have access to Nyamugari primary school",
  //       "health_access_blocked_by_river": "Mubuga cell doesn't have access Nyamugari Mid-wifery services Shyembe cell doesn't have access to Muremure health center Shyembe cell doesn't have access to Kirinda hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "There is farm of banana, sweet potatoes, beans,",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35.4,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuy1AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bukoro",
  //       "bridge_opportunity_project_code": "1014129",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.61265,
  //       "bridge_opportunity_gps_longitude": 29.50877,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 55,
  //       "bridge_opportunity_individuals_directly_served": 4359,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.61265,
  //       "proposed_bridge_location_gps_longitude": 29.50877,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 hours",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 5 don't have access to Ryarubondo market and communities 1,2,3,4 don't have access to Kivu market",
  //       "education_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Kivu secondary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Communities 5 don't have access to Kibeho Holy place and don't have access to Ruramba police station services",
  //       "primary_occupations": "Farmers in Tea plantations , Nshili-Kivu tea factory workers, local farmers on small scale",
  //       "primary_crops_grown": "forest, maiz, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Three people fell into the river trying cross the river with existing timber logs flooded and stepped in water instead and drowned while two survived",
  //       "notes_on_social_information": "Kivu market which is open twice a week ( Community 1,2,3,4), Ryarubondo market which is open twice a week ( Community 5), Tea plantations farms on both side, Nshili-Kivu tea factory ( Community 1,2,3,4) , Kivu secondary school ( Community 5), Kibeho Holy place and Parish ( Community 5), Ruramba Police station services ( Community 5). Population information for each village and cell was provided by the village leader of each village respectively and Cell leader of Kivu cell and population information was sourced from village census data collected in July 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hGAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rudehero",
  //       "bridge_opportunity_project_code": "1014134",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.37845,
  //       "bridge_opportunity_gps_longitude": 29.1393,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9782,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37845,
  //       "proposed_bridge_location_gps_longitude": 29.1393,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": "Communities 1 don't have access to Remera coffee washing station, communities 1 don't have access to Rwesero, Kirambo and Tyazo markets, communities 2 don't have access to Rangiro market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Rangiro secondary school",
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Kibogora Hospital",
  //       "other_access_blocked_by_river": "Communities 1 don't have access to District head quarter",
  //       "primary_occupations": "Remera coffee washing station workers and suppliers and farmers, local farmers on small scale on both sides, Traders at Rwesero, Kirambo, Tyazo and Rangiro markets",
  //       "primary_crops_grown": "bean, coffe, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Falling into the river during rain season",
  //       "notes_on_social_information": "Remera coffee washing station ( Community 1), Rwesero, Kirambo, Tyazo markets which are open weekly ( Community 1); Rangiro market which is open twice a week ( Community 2); Rangiro secondary school ( Community 2), Kibogora Hospital ( Community 1); District head quarter ( Community 1). Population information for each village was provided by leader of Mukankundiye Clementine cell leader of Jurwe and Nyirahakizimfura Console cell leader of Gako.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hH3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bizenga",
  //       "bridge_opportunity_project_code": "1014138",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.33616,
  //       "bridge_opportunity_gps_longitude": 29.1422,
  //       "bridge_opportunity_bridge_type": "Simple Span Bridge",
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 6067,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.33616,
  //       "proposed_bridge_location_gps_longitude": 29.1422,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 43,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Communities don't have access to Farms on both sides ,Communities 3,4,5 don't have access Tyazo market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Communities 3,4,5 don't have access to Kibogora Hospital",
  //       "other_access_blocked_by_river": "Communities 3,4,5 don't have access to Churches",
  //       "primary_occupations": "Local farmers and traders at Tyazo market",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Tyazo market which is open twice a week ( Community 3,4,5), Farms on both sides, Kibogora Hospital( communities 3,4,5). Population information for each village was provided by Tuyishime Johnson Kibogora cell leader and Mukankusi Josiane Kigarama cell leader. Population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 86,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hIkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugarama",
  //       "bridge_opportunity_project_code": "1014149",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.71276,
  //       "bridge_opportunity_gps_longitude": 29.46918,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3830,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.71276,
  //       "proposed_bridge_location_gps_longitude": 29.46918,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 1don't have access to Ruheru market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Kabere secondary school",
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Ruheru health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea plantation workers , traders at Ruheru market",
  //       "primary_crops_grown": "bean, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ruheru market which is open twice a ( village 1), Ruheru health center ( village 1), Kabere secondary school ( village 2). Population information for each community was provided by the village leader of each village respectively and population information was sourced from village census data collected in June 2018",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hN1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihemvu",
  //       "bridge_opportunity_project_code": "1014150",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.70081,
  //       "bridge_opportunity_gps_longitude": 29.492137,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 94,
  //       "bridge_opportunity_individuals_directly_served": 3969,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6999,
  //       "proposed_bridge_location_gps_longitude": 29.49195,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Ruheru market, Tea plantations farms and Nshili-Kivu tea factory, communities 1 don't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Bihembe school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Nyabimata Health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea plantation workers, local farmers on small scale and traders at Kamirabagenzi and Ruheru markets",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ruheru market which is open twice a week ( Community 2), Kamirabagenzi market which is open twice a week ( Community 1), Tea plantations farms ( Community 2), Nshili-Kivu tea factory ( Community 2), Bihembe school ( Community 2), Nyabimata Health center ( Community 2), Nyabimata Catholic church to be a Parish soon( community2). Population information for each community was provided by the village leader of each village respectively and population information was sourced from village census data collected in July2018",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hNQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kansi",
  //       "bridge_opportunity_project_code": "1014152",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.60126,
  //       "bridge_opportunity_gps_longitude": 29.52739,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6674,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.60126,
  //       "proposed_bridge_location_gps_longitude": 29.52739,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 110,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 1,2,3,4 don't have access to to Mata Tea factory, and tea plantation farms , communities 5 don't have access to Kivu and Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Communities1,2,3,4 don't have access to Rwamiko school",
  //       "health_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Nyamyumba health center",
  //       "other_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Police station and Kivugiza Parish",
  //       "primary_occupations": "Tea plantation workers, Traders at Kivu and Kamirabagenzi market",
  //       "primary_crops_grown": "bean, coffe, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Mata Tea factory ( Community 1,2,3,4),Tea plantation farms on both sides ,Kivu and Kamirabagenzi market ( Community 5), Rwamiko school ( Community 1,2,3,4), Nyamyumba health center ( Community 1,2,3,4), Kivugiza health center ( Community 1,2,3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hOEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabusunzu",
  //       "bridge_opportunity_project_code": "1014090",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.7023,
  //       "bridge_opportunity_gps_longitude": 29.00658,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 858,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. River too small to warrant B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7023,
  //       "proposed_bridge_location_gps_longitude": 29.00658,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Information gathered from pera cell leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Bugarama",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is no meaningful obstacle and they is no space for the bridge",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 100,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ubumwe I",
  //       "bridge_opportunity_project_code": "1014250",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.43737,
  //       "bridge_opportunity_gps_longitude": 30.2538,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6852,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.43737,
  //       "proposed_bridge_location_gps_longitude": 30.2538,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Rukomo market (Community 1,2,3), Mimuri market (Community 4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Bufunda Primary and Secondary School (Community 1,2,3), Cyabayaga Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Mimuri Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Mimuri Catholic Parish and Adventist church (Community 4,5), Nyagatare town (Community 4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, sugarcan, tomato",
  //       "river_crossing_deaths_in_last_3_years": 7,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "7 people have died trying to cross this river and more than 20 were injured.",
  //       "notes_on_social_information": "Ubumwe, Rebero, Amahoro, Indahemuka, Cyibihanga, Ibitabo and Nyakajeje villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Rugari Cell Leader and the Ubumwe Village Leader, Augustin Kamana from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWTAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mpombori",
  //       "bridge_opportunity_project_code": "1014283",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.0851,
  //       "bridge_opportunity_gps_longitude": 29.80891,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 44,
  //       "bridge_opportunity_individuals_directly_served": 1486,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0851,
  //       "proposed_bridge_location_gps_longitude": 29.80891,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 89,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Musambira market and muhanga market",
  //       "education_access_blocked_by_river": "Ruyanza high school",
  //       "health_access_blocked_by_river": "Kabgayi hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "People died tring to cross when the river was flooded",
  //       "notes_on_social_information": "Gitare dont have access to musambira market Information gathered from neighboring members",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekgRAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugashyushya",
  //       "bridge_opportunity_project_code": "1014290",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.06667,
  //       "bridge_opportunity_gps_longitude": 29.87094,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06667,
  //       "proposed_bridge_location_gps_longitude": 29.87094,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Month",
  //       "market_access_blocked_by_river": "Musambira",
  //       "education_access_blocked_by_river": "Buye high school",
  //       "health_access_blocked_by_river": "Nyamiyaga health center",
  //       "other_access_blocked_by_river": "Nyamiyaga church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People died trying to cross when it was flooded",
  //       "notes_on_social_information": "Kambyeyi don't have access to gashyushya market Informarion gathered from cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 87,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekh0AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuruma",
  //       "bridge_opportunity_project_code": "1014292",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.10672,
  //       "bridge_opportunity_gps_longitude": 29.86075,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8600,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10672,
  //       "proposed_bridge_location_gps_longitude": 29.86075,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Mponda market and gashyushya market",
  //       "education_access_blocked_by_river": "Kabuga high school",
  //       "health_access_blocked_by_river": "Nyagihamba health center",
  //       "other_access_blocked_by_river": "Churches at kintama",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Acyclist has fallen trying to cross",
  //       "notes_on_social_information": "Kintama village dont have access to mpanda market Information gathered from villagers",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 120,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekhAAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugarama1",
  //       "bridge_opportunity_project_code": "1014293",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.109614,
  //       "bridge_opportunity_gps_longitude": 29.84785,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 60,
  //       "bridge_opportunity_individuals_directly_served": 3107,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10933,
  //       "proposed_bridge_location_gps_longitude": 29.84766,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Mponda market",
  //       "education_access_blocked_by_river": "Kigusa high school",
  //       "health_access_blocked_by_river": "Mbuye health center",
  //       "other_access_blocked_by_river": "Gitare parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "The children fall and one died",
  //       "notes_on_social_information": "Kigabiro village dont have access to musambira market Rugarama village don't have access to mponda market Informstion gathered from village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigabiro",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekhFAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muhazi",
  //       "bridge_opportunity_project_code": "1014310",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.873616,
  //       "bridge_opportunity_gps_longitude": 29.852021,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 25000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.873616,
  //       "proposed_bridge_location_gps_longitude": 29.852021,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "March to May, October to December, more than two week",
  //       "market_access_blocked_by_river": "Kayenzi market ( 2), Ruri market ( 1), farms ( 1,2), mining activities ( 2, 1)",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "Ruri hospital ( 1)",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farm in and mining activities",
  //       "primary_crops_grown": "banana, maiz, sugar can",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 120,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeqqSAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kadasaya",
  //       "bridge_opportunity_project_code": "1014312",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.041621,
  //       "bridge_opportunity_gps_longitude": 29.930816,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9848,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.041621,
  //       "proposed_bridge_location_gps_longitude": 29.930816,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "10 kilometers",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "March to May, November , 3 hours no heavy rain and 24 hours during heavy rain season.",
  //       "market_access_blocked_by_river": "Gashyushya market ( 1,2,3), farms ( 1,4,5).",
  //       "education_access_blocked_by_river": "Magu primary school ( 1,2), Rutovu secondary school ( 4,5).",
  //       "health_access_blocked_by_river": "Ruyumba health center ( 1,2).",
  //       "other_access_blocked_by_river": "Magu church ( 1,2), Minagri cemetery ( tombs)( 1,2,3), potable water ( 4,5)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, coffe",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by village leader, Habanabakize Vedaste. Population of all adjacent communities includes Rutovu, Nyakabuye, kadasaya, and Magu.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi ~ kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeqs4AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisizi",
  //       "bridge_opportunity_project_code": "1014318",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.870868,
  //       "bridge_opportunity_gps_longitude": 29.877686,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1542,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.870868,
  //       "proposed_bridge_location_gps_longitude": 29.877686,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Kayenzu market ( 2), kaziraboyi market ( 1), farming (1,2), kirwa mining quarry ( 2)",
  //       "education_access_blocked_by_river": "Gisizi primary school ( 2 )",
  //       "health_access_blocked_by_river": "Kirwa dispensary ( 2)",
  //       "other_access_blocked_by_river": "Churches ( 2)",
  //       "primary_occupations": "Fsrming , tentarium mining",
  //       "primary_crops_grown": "banana, bean, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by village leader, Nkurunziza Antoine who sourced the population from village record book. The student from nyabitare village are blocked to the school every day when the river is flooded.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 2.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eescbAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bunyonga 1",
  //       "bridge_opportunity_project_code": "1014322",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.934919,
  //       "bridge_opportunity_gps_longitude": 29.819397,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 54,
  //       "bridge_opportunity_individuals_directly_served": 2423,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.934919,
  //       "proposed_bridge_location_gps_longitude": 29.819397,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "October to December, April to May, 24 hours",
  //       "market_access_blocked_by_river": "Kayenzi market ( 1,2,4), karambo market ( 3), farms ( 1,2,3).",
  //       "education_access_blocked_by_river": "G.S. ST AGAPE NYAMIREMBO ( 1,2), Bunyonga Primary school and secondary school ( 3).",
  //       "health_access_blocked_by_river": "Karama health center ( 3 ).",
  //       "other_access_blocked_by_river": "Church ( 3 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali ~ kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesd5AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rushikiri",
  //       "bridge_opportunity_project_code": "1014330",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.937733,
  //       "bridge_opportunity_gps_longitude": 29.9489,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6120,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.937733,
  //       "proposed_bridge_location_gps_longitude": 29.9489,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 5 to 6 hours",
  //       "market_access_blocked_by_river": "Kwishusho market ( 1), Rwina market ( 2,3), Masangano Maize manufacturing factory ( 1 ), Gihara beer factory ( 1). Farms ( 1,2,3).",
  //       "education_access_blocked_by_river": "Gihara secondary school ( 1 ).",
  //       "health_access_blocked_by_river": "Gihara dispensary ( 1), Rukoma Hospital ( 2,3)",
  //       "other_access_blocked_by_river": "Gihara church ( 1), potable water ( 2,3).",
  //       "primary_occupations": "Farming and mining",
  //       "primary_crops_grown": "bean, cassava, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi ( RN1)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesiZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasinga",
  //       "bridge_opportunity_project_code": "1014406",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.206567,
  //       "bridge_opportunity_gps_longitude": 30.347849,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4754,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.206567,
  //       "proposed_bridge_location_gps_longitude": 30.347849,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 week",
  //       "market_access_blocked_by_river": "Rice plantation farms on both sides , communities 2 don't have access to Kabare and Rwimiyaga market markets",
  //       "education_access_blocked_by_river": "Communities 1 don't have access to Rwempasha secondary school",
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Rwempasha Health center",
  //       "other_access_blocked_by_river": "Communities 1 don't have access to Churches and Rwempasha sector office",
  //       "primary_occupations": "Farmers ( Rice , pastures )",
  //       "primary_crops_grown": "bean, crops:maiz, pastur, rice plantation farm, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 10,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Almost Ten people fell into the river and drowned trying to cross the river",
  //       "notes_on_social_information": "Rice plantation farms and pastures ; Rwimiyaga and kabare market which are open weekly( community 2); Rwempasha secondary school(community 1); Rwempasha Health center ( Community 1); Rwempasha sector office and SACCO and churches ( Community 1). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0qAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagarama",
  //       "bridge_opportunity_project_code": "1014554",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.19809,
  //       "bridge_opportunity_gps_longitude": 30.32175,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 13438,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.19809,
  //       "proposed_bridge_location_gps_longitude": 30.32175,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "28 days of flood",
  //       "market_access_blocked_by_river": "Sharita cell don't have access to Rubona market",
  //       "education_access_blocked_by_river": "No education is blocked by the river",
  //       "health_access_blocked_by_river": "No health center is blocked by the river",
  //       "other_access_blocked_by_river": "Ngoma district is blocked at left whereas Bugesera district is blocked at right",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One person died",
  //       "notes_on_social_information": "Rubona cell leader is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 100,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEerAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mfune",
  //       "bridge_opportunity_project_code": "1014555",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.20515,
  //       "bridge_opportunity_gps_longitude": 30.28804,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10053,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20515,
  //       "proposed_bridge_location_gps_longitude": 30.28804,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "1 month of flood",
  //       "market_access_blocked_by_river": "Biryogo cell don't have access to Rubona market",
  //       "education_access_blocked_by_river": "No education is blocked by the river",
  //       "health_access_blocked_by_river": "No health center is blocked by the river",
  //       "other_access_blocked_by_river": "Ngoma district office is blocked at left , whereas Bugesera district is blocked at right",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "The boat carried 8 people , two of them died and other 6 injured",
  //       "notes_on_social_information": "Mfune village leader is the one who provided information about directly individual served by the bridge by referring to population census 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEewAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "KwaMunyamahoro",
  //       "bridge_opportunity_project_code": "1014556",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.2041,
  //       "bridge_opportunity_gps_longitude": 30.30697,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 15946,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2041,
  //       "proposed_bridge_location_gps_longitude": 30.30697,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "40 days of flood",
  //       "market_access_blocked_by_river": "Gituza cell don't have access to lilima market, whereas Sharita cell don't have access to Rubona market",
  //       "education_access_blocked_by_river": "No education is blocked by the river",
  //       "health_access_blocked_by_river": "No health center is blocked by the river",
  //       "other_access_blocked_by_river": "Ngoma district office is blocked at left whereas Bugesera district office is blocked at right",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "3 people died here",
  //       "notes_on_social_information": "Gituza cell leader is the one who provided information about directly individual served by refering to the population census 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEf1AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamenge",
  //       "bridge_opportunity_project_code": "1021789",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.947858,
  //       "bridge_opportunity_gps_longitude": 30.00694444,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 100,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.11.14",
  //       "form_created_by": "Solange Yandereye",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": "Kigali - Muhanga",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": "The site has major flooding, there would be a need of conducting geotechnical tests plus a system of drains around the structure. Discussing with Director of One Stop Center of Nyarugenge District about creating an access on both sides to the bridge, he said that it seems be very expensive for them yet there are only a few number of people ; we estimated maximum 100 who use to cross over the pipe",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000huHAMQA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwinyana",
  //       "bridge_opportunity_project_code": "1021923",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.11.26",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000hv15YQAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kajeje",
  //       "bridge_opportunity_project_code": "1022230",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.971735,
  //       "bridge_opportunity_gps_longitude": 29.792433,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 300,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.12.13",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.971735,
  //       "proposed_bridge_location_gps_longitude": 29.792433,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000hvy75QAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mataba",
  //       "bridge_opportunity_project_code": "1022231",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.976608,
  //       "bridge_opportunity_gps_longitude": 29.782109,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.12.13",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.976608,
  //       "proposed_bridge_location_gps_longitude": 29.782109,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000hvy7AQAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sector 4A",
  //       "bridge_opportunity_project_code": "1022387",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.957537,
  //       "bridge_opportunity_gps_longitude": 30.151651,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 77,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.12.23",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.957537,
  //       "proposed_bridge_location_gps_longitude": 30.151651,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000hwQZRQA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sector 4B",
  //       "bridge_opportunity_project_code": "1022388",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.951633,
  //       "bridge_opportunity_gps_longitude": 30.146159,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 99,
  //       "bridge_opportunity_individuals_directly_served": 1500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.12.23",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.951633,
  //       "proposed_bridge_location_gps_longitude": 30.146159,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000hwQZgQAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musarara",
  //       "bridge_opportunity_project_code": "1023609",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.827983,
  //       "bridge_opportunity_gps_longitude": 29.667964,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2364,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2020.5.21",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.827983,
  //       "proposed_bridge_location_gps_longitude": 29.667964,
  //       "current_crossing_method": "Vehicular bridge in 400 m",
  //       "nearest_all_weather_crossing_point": "None , the vehicular bridge becomes impassable in the heavy rain season",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "3weeks",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "All pieces of Information were gathered through villages leaders and Kibangu Sector Land Manager",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000jhEEjQAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Remera",
  //       "bridge_opportunity_project_code": "1007380",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.66052,
  //       "bridge_opportunity_gps_longitude": 29.74644,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 17,
  //       "bridge_opportunity_individuals_directly_served": 3581,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1607m, Cell:Buvumo, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Rango, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.66052,
  //       "proposed_bridge_location_gps_longitude": 29.74644,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Rango Market (Community 1,3,4,5), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Nkubi Primary and Secondary School, Regina Pacis Primary and Secondary School (Community 1,3,4,5)",
  //       "health_access_blocked_by_river": "Rango Health Center (Community 1,3,4)",
  //       "other_access_blocked_by_river": "Mukura Sector office, Rango Catholic Church (Community 1,3,4,5)",
  //       "primary_occupations": "Agriculture and Brick making",
  //       "primary_crops_grown": "banana plantation, bean, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Remera, Gaseke, Taba, Rujumbura, Mpinga and Nyagasambu villages were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. The population information for each village was provided by the Buvumu Cell Leader, Kazungu Emmanuel, from the data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DgAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Muhembe",
  //       "bridge_opportunity_project_code": "1007425",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.82487,
  //       "bridge_opportunity_gps_longitude": 29.61382,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 92,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1596m, Cell:Gatare-Giseke, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Nyagasozi -Mburamazi -Tetero -Maranimpa -Muvugangoma, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 5m.-The proposed bridge span is approximately 38m.-The level difference between two banks is approximately 1m.-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient (>Span/25).-There is no confluence area near the place.-The river bed at this site is stable, there is no possibility of erosion.-The bank profile of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.82487,
  //       "proposed_bridge_location_gps_longitude": 29.61382,
  //       "current_crossing_method": "6 timbers",
  //       "nearest_all_weather_crossing_point": "Walking through water",
  //       "days_per_year_river_is_flooded": 1,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Buyungu Market",
  //       "education_access_blocked_by_river": "GS Hindiro",
  //       "health_access_blocked_by_river": "FOSACOM Hindiro",
  //       "other_access_blocked_by_river": "Hindiro sector and Kageyo sector",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No one falls down",
  //       "notes_on_social_information": "Two village leaders who are Nyagasozi village leader and Gaseke village leader told me their population who are crossing the river, but all population are not using this bridge , a quarter of each village are using it.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EPAAY",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Gipfundo",
  //       "bridge_opportunity_project_code": "1007651",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.720313,
  //       "bridge_opportunity_gps_longitude": 30.081412,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 110,
  //       "bridge_opportunity_individuals_directly_served": 1700,
  //       "bridge_opportunity_comments": "BAJ Follow up with assessor. Looking at historic google earth images, it looks like a vehicular bridge was washed away at this site in 2017. Should be verified that a vehicular bridge is not required.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.72053,
  //       "proposed_bridge_location_gps_longitude": 30.08124,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Farms, Market on both side",
  //       "education_access_blocked_by_river": "Primary, nursery and secondary school on both side",
  //       "health_access_blocked_by_river": "Health center on both side",
  //       "other_access_blocked_by_river": "Potable water on left side, churches on both side",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "She was looking on beef and it flooded in that area",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and one of them are community leader member",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 96,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86I3AAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kanserege",
  //       "bridge_opportunity_project_code": "1013215",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.5265,
  //       "bridge_opportunity_gps_longitude": 29.510023,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 92,
  //       "bridge_opportunity_individuals_directly_served": 3292,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.5265,
  //       "proposed_bridge_location_gps_longitude": 29.510023,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 56,
  //       "flood_duration_during_rainy_season": "8 times April and October and it lasts for 7days",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming( potatoes, maize, cow pea, beans, forest)",
  //       "primary_crops_grown": "bean, cow pea, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market Gasarenda( Kanserege, Rwufe, Ryarubondo) Market Ryarubondo(Gasenge, Kagarama, Mubezi) Primary and Secondary schools (Gasenge) Health post(Gsenge) The numbers given in this survey were given by the local people and their leaders based on the monthly census which is done in every cell. The Kagarama, Gahembe villages use this crossing and their people were included in the total population",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 73.4,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75uhAAA",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Rugerero-Ntaruka",
  //       "bridge_opportunity_project_code": "1013339",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.402212,
  //       "bridge_opportunity_gps_longitude": 29.715983,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3701,
  //       "bridge_opportunity_comments": "The District has the bridge in its IMIHIGO under the name of\"Ntaruka (the river name)\" and they suggested that the name in the contract can be Rugerero (Ntaruka) for the sake of aligning both project name and district's UMUHIGO.",
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.40231,
  //       "proposed_bridge_location_gps_longitude": 29.71602,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Rugogwe Market (Community 4), Mubuga Market (Community 1,2,3), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Mubuga Primary and Secondary school (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Mubuga Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Mubuga Catholic and Protestant churches (Community 1,2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "More than 100 people in the last three years have been injured, most of accidents are from motorcyclists and cyclists who fall into the river tryingto cross. There have been 3 dead among them 2 children who were coming from school.",
  //       "notes_on_social_information": "Rugerero, Birambo, Murehe, and Karugumya were included in Individuals Directly Served because their community members use the crossing point daily to go to markets, health centers, churches, schools,... The population information for each village was provided by the Mwendo Cell Leader, and karugumya village leader. The population information data were collected in 2018. Population of All Adjacent Communities includes Cyarera Village and different villages in mwendo and Kibiraro sectors. These community members sometimes use this crossing to visit relatives, to visit the market once a month. This crossing point is mainly used by children going or coming to school. Children from (Community 1,2,3) go to Mubuga Primary and Secondary School. During rainy season they frequently miss school because they can't cross the river. They even spend night on the other side waiting for river floods so they can cross the river safely.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1(Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ETmAAM",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Rugeshi",
  //       "bridge_opportunity_project_code": "1013459",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.96038,
  //       "bridge_opportunity_gps_longitude": 29.54036,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 110,
  //       "bridge_opportunity_individuals_directly_served": 3678,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.96038,
  //       "proposed_bridge_location_gps_longitude": 29.54036,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 85,
  //       "flood_duration_during_rainy_season": "8 hours of flood",
  //       "market_access_blocked_by_river": "Ngugu village , ruganda village , Kanyanza village don't have access to GASHUBI MARKET , while Rugeshi village , ruhuha village ,kideberi village ,kamina village and cyanjongo village don't have access to BIREMBO MARKET",
  //       "education_access_blocked_by_river": "Rugeshi village , ruhuha village ,kideberi village ,kamina village and cyanjongo village don't have access to GS RUGANDA , while Ngugu village , ruganda village , Kanyanza village don't have access to GS BWIRA",
  //       "health_access_blocked_by_river": "Ngugu village , ruganda village , Kanyanza village don't have access to GASHUBI HEALTH CENER",
  //       "other_access_blocked_by_river": "Ngugu village , ruganda village , Kanyanza village don't have access to BUDEYI ADVANTIST CHURCH",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 7,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "Persons crossing the river",
  //       "notes_on_social_information": "Rugeshi village leader is the one who provided the social information about directly individual served , by xal.ing other village leaders , they referred to 2017 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7PrLAAU",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Gasasa",
  //       "bridge_opportunity_project_code": "1013460",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.95373,
  //       "bridge_opportunity_gps_longitude": 29.54198,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 42,
  //       "bridge_opportunity_individuals_directly_served": 4053,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.95373,
  //       "proposed_bridge_location_gps_longitude": 29.54198,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No points , the whole path is covered by satinsyi river",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "3 days of floods",
  //       "market_access_blocked_by_river": "Gasasa village , ngugu village , gitonde village, rwamakara village don't have access to Rusumo Market while ruganda village, gahombo village, gitaba village, gisozi village don't have access to GASHUBI MARKET",
  //       "education_access_blocked_by_river": "ruganda village, gahombo village, gitaba village, gisozi village don't have access to GS BWIRA",
  //       "health_access_blocked_by_river": "ruganda village, gahombo village, gitaba village, gisozi village don't have access to FOSSACOM BWIRA",
  //       "other_access_blocked_by_river": "Gasasa village , ngugu village , gitonde village, rwamakara village don't have access to rusumo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 8,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Normal persons who were crossing",
  //       "notes_on_social_information": "Ruganda village leader is the one who provided the info about directly individual served by refering to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7PrQAAU",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Nyakabingo",
  //       "bridge_opportunity_project_code": "1013568",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.279466,
  //       "bridge_opportunity_gps_longitude": 29.199971,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 34,
  //       "bridge_opportunity_individuals_directly_served": 1838,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.279466,
  //       "proposed_bridge_location_gps_longitude": 29.199971,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge seven hundred meters away.",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Communities 1&2 do not have access to Rugari market, communities 3 is blocked to karengera market. Communities 1&2 are blocked to farms in Bisheke Marshland.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to Mutongo primary school.",
  //       "health_access_blocked_by_river": "Communities 3 do not have access to karengera health center.",
  //       "other_access_blocked_by_river": "Communities 1&2 do not have access to church in Muhororo.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and Drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by Muhororo cell leader, therese Mukarutera who sourced the population information from cell register done in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi~ Nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": 2.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b6VAAQ",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kigandi",
  //       "bridge_opportunity_project_code": "1013692",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.326002,
  //       "bridge_opportunity_gps_longitude": 29.165331,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 64,
  //       "bridge_opportunity_individuals_directly_served": 2825,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.326002,
  //       "proposed_bridge_location_gps_longitude": 29.165331,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 2 hours",
  //       "market_access_blocked_by_river": "Communities 1&2 do not have access to Kirambo market. Communities 3&4 do not have access to Rugari market. Communities 1&2 are blocked to farms in kigarama , communities 3&4 are blocked to farm in vugangoma.",
  //       "education_access_blocked_by_river": "Communities 3&4 do not have access to cyavuma primary school and secondary school. Communities 1&2 do not have access to kigarama primary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to kibogora hospital, communities 1&2 do not have access to Ruheru health center.",
  //       "other_access_blocked_by_river": "Communities 1&2 do not have access to kigarama church, communities 1&2 are blocked to Nyamasheke district offiice.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by vugangoma cell leader, Patrick, who sourced them from the cell register done in 2018 in Ubudehe program.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ix5AAA",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kucyarwamo",
  //       "bridge_opportunity_project_code": "1013777",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.06358,
  //       "bridge_opportunity_gps_longitude": 29.39742,
  //       "bridge_opportunity_bridge_type": "Other",
  //       "bridge_opportunity_span_m": 82,
  //       "bridge_opportunity_individuals_directly_served": 2524,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06358,
  //       "proposed_bridge_location_gps_longitude": 29.39742,
  //       "current_crossing_method": "None ,",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 76,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Kabeza village and rutabo village don't have access to Kibirizi market",
  //       "education_access_blocked_by_river": "Kabeza village and rutabo village don't have access TTS Rubengera",
  //       "health_access_blocked_by_river": "Kabeza village and rutabo village don't have access Rubengera health center",
  //       "other_access_blocked_by_river": "Kabeza village and rutabo village don't have access Rubona EER church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Student coming from primary schools",
  //       "notes_on_social_information": "Rubona village leader provided information about directly individual served by refering to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wXxAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kagarama",
  //       "bridge_opportunity_project_code": "1013867",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.13838,
  //       "bridge_opportunity_gps_longitude": 29.33504,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 58,
  //       "bridge_opportunity_individuals_directly_served": 3886,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.13838,
  //       "proposed_bridge_location_gps_longitude": 29.33504,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 158,
  //       "flood_duration_during_rainy_season": "3 days of flood",
  //       "market_access_blocked_by_river": "Kagarama village & rubazo village and kinyege village don't have access to Mubuga market whereas jurwe village & gahabwa village don't have access to Kiziba refugees champ market",
  //       "education_access_blocked_by_river": "Kagarama village & rubazo village and kinyege village don't have access to GS Mubuga",
  //       "health_access_blocked_by_river": "Kagarama village & rubazo village and kinyege village don't have access to Mubuga health center",
  //       "other_access_blocked_by_river": "Kagarama village & rubazo village and kinyege village don't have access to Mubuga Catholic church whereas jurwe village & gahabwa village don't have access to ADEPR Kiziba",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Two kids from Kiziba refugees champ were dead by this river , an old man and other two young man were also dead",
  //       "notes_on_social_information": "A volunteer from kagarama village Mugishya center provided all info about the river , people who are directly served",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Rusuzi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8890AAA",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Gasihe",
  //       "bridge_opportunity_project_code": "1013894",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.360876,
  //       "bridge_opportunity_gps_longitude": 29.157374,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 92,
  //       "bridge_opportunity_individuals_directly_served": 2762,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.360876,
  //       "proposed_bridge_location_gps_longitude": 29.157374,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge ten kilometers away.",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 12 hours",
  //       "market_access_blocked_by_river": "Rangiro market and Banda market ( village 1 & 2), farms ( villages 1, 2, 3, &4 ).",
  //       "education_access_blocked_by_river": "Rangiro primary and secondary school( village 1 &2 ).",
  //       "health_access_blocked_by_river": "Ruheru health center ( villages 3&4 ).",
  //       "other_access_blocked_by_river": "ADDPR Nyagisasa( village 3&4), seventh adventist church( village 1&2).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, maiz, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population data was provided by villages leader, who sourced the data in villages record book of every year which is updated in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 90,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88IbAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Nyagisasa",
  //       "bridge_opportunity_project_code": "1013895",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.343073,
  //       "bridge_opportunity_gps_longitude": 29.140422,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 92,
  //       "bridge_opportunity_individuals_directly_served": 7124,
  //       "bridge_opportunity_comments": "Nyasasa site was substituted by Kamatsira Bridge Site, per District's suggestion. Updated by Etienne on August 22, 2019",
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.343073,
  //       "proposed_bridge_location_gps_longitude": 29.140422,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Timber bridge timber bridge three kilometers away.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "April to May and october and September , 24 hours",
  //       "market_access_blocked_by_river": "Tyazo market, kirambo market and Rwesero market( communities 3 ), farms ( villages 1,2 and 3).",
  //       "education_access_blocked_by_river": "Nyagisasa primary school ( villages 1 and ), saint Paul secondary school and p Kibogora primary school( community 3 ), kibingo polythechnic ( community 3 ).",
  //       "health_access_blocked_by_river": "Hospital kibogora and kibogora health center ( community 3 ).",
  //       "other_access_blocked_by_river": "Methodist nyagisasa and ADPR ( villages 1 and 2), ADPR tyazo, Catholic church tyazo ( community 3 ), kanjongo sector office and Nyamasheke district office ( community 3 ), potable water in Gatare( villages 1 and 2).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned while she was going to school.",
  //       "notes_on_social_information": "Population information of each village was provided by Raro cell leader, who sourced the data from cell register updated in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Tyazo~nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88IgAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kamatsira",
  //       "bridge_opportunity_project_code": "1013899",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.407594,
  //       "bridge_opportunity_gps_longitude": 29.163424,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 3221,
  //       "bridge_opportunity_comments": "Kamatsiro was suggested by Nyamasheke District to replace Nyagisasa Bridge Site. Updated by Etienne August 22, 2019",
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.407594,
  //       "proposed_bridge_location_gps_longitude": 29.163424,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away.",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 3 days",
  //       "market_access_blocked_by_river": "Rwesero market ( village 1,2,3), Banda market ( village 4 and 5), kamatsira timber manufacturing factory( village 4 and 5). Farms ( village 1,2,3,4 and 5).",
  //       "education_access_blocked_by_river": "Kamatsira primary school( village 4 and 5), bigeyo primary school ( village 1 ).",
  //       "health_access_blocked_by_river": "Rangiro health center ( village 1 ).",
  //       "other_access_blocked_by_river": "Kamatsira church ( village 4 and 5), bigeyo ( village 1, 2, and 3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88KmAAI",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Munini I",
  //       "bridge_opportunity_project_code": "1014052",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.18836,
  //       "bridge_opportunity_gps_longitude": 29.37793,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 48,
  //       "bridge_opportunity_individuals_directly_served": 2697,
  //       "bridge_opportunity_comments": "Not Duplicate",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18836,
  //       "proposed_bridge_location_gps_longitude": 29.37793,
  //       "current_crossing_method": "No crossing method",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 154,
  //       "flood_duration_during_rainy_season": "10 hours of flood",
  //       "market_access_blocked_by_river": "Byimana village, muyira village, kavumu village and Kinaba village don't have access to kivuruga market",
  //       "education_access_blocked_by_river": "Byimana village, muyira village, kavumu village and Kinaba village don't have access to Gs Bigugu",
  //       "health_access_blocked_by_river": "Byimana village, muyira village, kavumu village and Kinaba village don't have access to Bigugu health center",
  //       "other_access_blocked_by_river": "Byimana village, muyira village, kavumu village and Kinaba village don't have access to Bigugu church, whereas nyantwa village and ruhuha village don't have access to Munini church",
  //       "primary_occupations": "Farming , students going to schools",
  //       "primary_crops_grown": "banana, cassava, tea",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Five people died here ,",
  //       "notes_on_social_information": "Munini cell leader and Bigugu cell leader through phone call were giving me the information about directly served people by the bridge, and one volunteer from nyantwa village was with me on site to tell me about villages which are crossing",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fPNAAY",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Nyarusange",
  //       "bridge_opportunity_project_code": "1014269",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.89484,
  //       "bridge_opportunity_gps_longitude": 29.99693,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 132,
  //       "bridge_opportunity_individuals_directly_served": 4378,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.89484,
  //       "proposed_bridge_location_gps_longitude": 29.99693,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "Shyorongi Market (Jali/Muko)",
  //       "education_access_blocked_by_river": "GS Kanyinya secondary and primary school (Jali/Muko)",
  //       "health_access_blocked_by_river": "Health Center Kanyinya (Jali/Muko)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "School,Market, health center, farms",
  //       "primary_crops_grown": "bean, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "She was trying to cross the bridge when it was flooded and fell into river and found died",
  //       "notes_on_social_information": "SEDO OF Tare",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekYUAAY",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Bushoka",
  //       "bridge_opportunity_project_code": "1022905",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.801579,
  //       "bridge_opportunity_gps_longitude": 29.645831,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 70,
  //       "bridge_opportunity_individuals_directly_served": 1500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2020.2.10",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.801579,
  //       "proposed_bridge_location_gps_longitude": 29.645831,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000ivlv1QAA",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Kanyiramana 2",
  //       "bridge_opportunity_project_code": "1024587",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.480261,
  //       "bridge_opportunity_gps_longitude": 29.66132,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3761,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2020.8.20",
  //       "form_created_by": "oliverbagwiza taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.479682,
  //       "proposed_bridge_location_gps_longitude": 29.660946,
  //       "current_crossing_method": "Walk through the water",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 months meaning it floods throught out the rain season",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Death was due to the strong waves during the dry season Injury was a young child crossing back home after a rainfall the waves were strong she was washed but she was saved by people around",
  //       "notes_on_social_information": "Communities adjacent to the river were selected and information about the population was told by the security leader",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000kdQ8KQAU",
  //       "country": "Rwanda",
  //       "good_site": 1
  //     },
  //     {
  //       "bridge_name": "Gikana",
  //       "bridge_opportunity_project_code": "1007327",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.072628,
  //       "bridge_opportunity_gps_longitude": 30.204381,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 140,
  //       "bridge_opportunity_individuals_directly_served": 1610,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1325m, Cell:Kabukuba, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Kabukuba, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 150m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.5.14",
  //       "form_created_by": "clementinemukashyaka taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.072628,
  //       "proposed_bridge_location_gps_longitude": 30.204381,
  //       "current_crossing_method": "They use a boat",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 360,
  //       "flood_duration_during_rainy_season": "160 days",
  //       "market_access_blocked_by_river": "Kabukuba and kabuga market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Mwogo health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture and fishing",
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kabuga",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyankongi",
  //       "bridge_opportunity_project_code": "1007328",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.048451,
  //       "bridge_opportunity_gps_longitude": 30.191276,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 100,
  //       "bridge_opportunity_individuals_directly_served": 5800,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1329m, Cell:Musovu-Rusheshe, Bridge would connecting Bugesera-Kicukiro, Injuries/Death-Many peoples injured while trying to cross the river/ One person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Musovu, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 100m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.6.11",
  //       "form_created_by": "clementinemukashyaka taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 360,
  //       "flood_duration_during_rainy_season": "120 days",
  //       "market_access_blocked_by_river": "Kabuga market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Masaka hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, sorghum, sweet poteto",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_kabuga",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CqAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mbabe",
  //       "bridge_opportunity_project_code": "1007329",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.028061,
  //       "bridge_opportunity_gps_longitude": 30.173231,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 90,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1333m, Cell:Rugunga-Mbare, Bridge would connecting Bugesera-Kicukiro, Injuries/Death-Many peoples injured while trying to cross the river/ More than 3 peoples died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Masaka -Murindi, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 100m.-The level difference between two banks is 3m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat area and an elevated area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.6.11",
  //       "form_created_by": "clementinemukashyaka taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.028061,
  //       "proposed_bridge_location_gps_longitude": 30.173231,
  //       "current_crossing_method": "The community cross by boat",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 360,
  //       "flood_duration_during_rainy_season": "In a rainy season especially in March, Akagera River flood up to the end of June . The flooding took 120 days",
  //       "market_access_blocked_by_river": "Kabuga and Masaka market",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "Masala hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture and commerce",
  //       "primary_crops_grown": "bean, sorghum, sweet poteto",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "In fact the whole community of Mbabe and others from Bugesera have a problem of increases of tranport cost from 100frw to 300frw that sounds to be high because of flooding, sometimes the local government do not allow people to cross in case the flooding is high, thus stop activities along the two districts like Agriculture and transportation of their crops to the market.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_Masaka",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 2500,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusheshe",
  //       "bridge_opportunity_project_code": "1007330",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.038712,
  //       "bridge_opportunity_gps_longitude": 30.186428,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 135,
  //       "bridge_opportunity_individuals_directly_served": 5800,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1326m, Cell:Musovu-Rusheshe, Bridge would connecting Bugesera-Kicukiro, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Musovu, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 145m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.6.11",
  //       "form_created_by": "clementinemukashyaka taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 360,
  //       "flood_duration_during_rainy_season": "120 days",
  //       "market_access_blocked_by_river": "Kabuga market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Masaka hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, bean, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The community willingly a transportation way that should be used even in a rainy season of high flooding. You may come and find that boat rider is not arround,they stay on one side until the boat rider is back that may take along time or even not come",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_kabuga",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamigende",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007331",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.095311,
  //       "bridge_opportunity_gps_longitude": 30.245678,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 100,
  //       "bridge_opportunity_individuals_directly_served": 6000,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Review behavior has changed at this location over time. After 2018 rainy season the river flooded much higher than ever before and the required span would be 400+ meters. The range finders could not shoot to the other side. Site is rejected based on being Beyond B2P's current engineering scope. 500-1000 people directly served, Elevation:1327m, Cell:Juru-Rwimbogo, Bridge would connecting Bugesera-Rwamagana, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Nduhuye, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 120m.-The level difference between two banks is 0.03m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.5.14",
  //       "form_created_by": "clementinemukashyaka taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.095311,
  //       "proposed_bridge_location_gps_longitude": 30.245678,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "60 days",
  //       "market_access_blocked_by_river": "Karenge and kabukuba market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Juru health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Those people want to cross by the time there wwas no boat in the rive ,they tried to cross and died",
  //       "notes_on_social_information": "They normally use traditional boat that are not safe to cross the river",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kabuga_rwamagana",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 500,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bugambo",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007332",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.377,
  //       "bridge_opportunity_gps_longitude": 29.80729,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 29,
  //       "bridge_opportunity_individuals_directly_served": 1892,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1892m, Cell:Bugambo, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Kinyababa, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 29m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.377,
  //       "proposed_bridge_location_gps_longitude": 29.80729,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 196,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "There is a part of gatare which is blocked to the Market and farms",
  //       "education_access_blocked_by_river": "There is a part of gatare which is blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "There is a part of gatare which is blocked to the health center",
  //       "other_access_blocked_by_river": "There is a part of gatare which is blocked to the bank, business centers, churches, cell and sector office",
  //       "primary_occupations": "School, Market, bank, farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They were trying to cross the bridge when it was flooded and fell into river and 3 found died and 4 are injured",
  //       "notes_on_social_information": "Community leaders of Gatare is the one who give me information and numbers of population was given by the other communities leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambi",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007334",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.39214,
  //       "bridge_opportunity_gps_longitude": 29.81063,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 6,
  //       "bridge_opportunity_individuals_directly_served": 1573,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Vehicular bridge desired and material collection underway. River is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.39214,
  //       "proposed_bridge_location_gps_longitude": 29.81063,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "One part of Cyogo, Gako are blocked to market, farms are both side",
  //       "education_access_blocked_by_river": "One part of Cyogo, Gako are blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "One part of Cyogo, Gako are blocked to Health center",
  //       "other_access_blocked_by_river": "One part of Cyogo, Gako are blocked to churches, water, sector and cell office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was trying to cross the bridge when it was flooded and fell into and died after during the operation",
  //       "notes_on_social_information": "Information was given by the community leader of Cyogo, and numbers was given by community leader of each community",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They are building the foundation and they wish to have vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musangabo",
  //       "bridge_opportunity_project_code": "1007335",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.38223,
  //       "bridge_opportunity_gps_longitude": 29.77727,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 6,
  //       "bridge_opportunity_individuals_directly_served": 1253,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. NPD contract underway to build vehicular bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.38223,
  //       "proposed_bridge_location_gps_longitude": 29.77727,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kiligali is blocked to rugarama market but they can use the unpaved road",
  //       "education_access_blocked_by_river": "Kiligali is blocked to primary and secondary school which is in musangabo",
  //       "health_access_blocked_by_river": "Kiligali is blocked to Health center",
  //       "other_access_blocked_by_river": "Kiligali is blocked to sector office, and musangabo is blocked to the cell office,",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the land manager of Kagogo, numbers of population was given by community leaders",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is near to road and downstream and upstream also are closer to road and land manager said that it will be constructed with NPD cotraco as they are going to build the paved road there",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 7,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugezi",
  //       "bridge_opportunity_project_code": "1007336",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.48563,
  //       "bridge_opportunity_gps_longitude": 29.88871,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 460,
  //       "bridge_opportunity_individuals_directly_served": 432,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Over a 400 meters span would be required. Large flood plain. In rainy season the community crosses with a boat.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.48563,
  //       "proposed_bridge_location_gps_longitude": 29.88871,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "During flooding time they use boat",
  //       "days_per_year_river_is_flooded": 126,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Both side have market but Rugezi used Gatebe Market",
  //       "education_access_blocked_by_river": "Bihita, Gitovu, Kabaya, Akabare(community of Uganda) are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Bihita, Gitovu, Kabaya, Akabare(community of Uganda) are blocked to Health center",
  //       "other_access_blocked_by_river": "Bihita, Gitovu, Kabaya, Akabare(community of Uganda) are blocked to district",
  //       "primary_occupations": "Market of Kirambo from Gitovu or Kivuye from Rugezi, and district office, schools",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Gitovu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is water like a lake and the span is more than 400 meter",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86CyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mazimeru",
  //       "bridge_opportunity_project_code": "1007338",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6905555556,
  //       "bridge_opportunity_gps_longitude": 29.8166666667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 1940,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1622m, Cell:Raba, Injuries/Death--Many peoples injured while crossing the river./ 2 peoples died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Mazimeru -Rukura, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a hill and an elevated area.-The soil from the site is hard rock for one side and silt for other side. 450 people from Mataba,Ndagamiye and Bukonde villages use Mazimeru Bridge daily for farming others go to Rukura secondary School.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6905555556,
  //       "proposed_bridge_location_gps_longitude": 29.8166666667,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Rukura market",
  //       "education_access_blocked_by_river": "Rukura secondary primary school",
  //       "health_access_blocked_by_river": "Rukura health center",
  //       "other_access_blocked_by_river": "Catholic church of Rukura and gataba Adventist church",
  //       "primary_occupations": "Education purpose and worship",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Children fell",
  //       "notes_on_social_information": "I gathered information from neighborhood people and their village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 72,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86D0AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwabarihuta",
  //       "bridge_opportunity_project_code": "1007339",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6983333333,
  //       "bridge_opportunity_gps_longitude": 29.7986111111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 3500,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1611m, Cell:Buyange-Raba, Injuries/Death--Many peoples injured while crossing the river./ 1person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Butorerero -Cyibuga -Rukura, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 58m.-The level difference between two banks is 1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a hill and an elevated area.-The soil from the site is hard rock for one side and silt for other side. Adjacent community is 50 people from Gashenyi and Mataba Sector daily for subsistence Farming(Rwanda National Wide- Needs Assessment-2018)",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6983333333,
  //       "proposed_bridge_location_gps_longitude": 29.7986111111,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No way",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In hours",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Musave combined nursery primary and secondary and Rukura school",
  //       "health_access_blocked_by_river": "Rukura",
  //       "other_access_blocked_by_river": "Teachers",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Motor drivers and cyclists slipped",
  //       "notes_on_social_information": "Information gathered from people stays near base river",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 82.1,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86D1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubaya",
  //       "bridge_opportunity_project_code": "1007366",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.46707,
  //       "bridge_opportunity_gps_longitude": 29.99598,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 4500,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1835m, Cell:Gishari, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Rubaya, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.46707,
  //       "proposed_bridge_location_gps_longitude": 29.99598,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometers",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "7 hours",
  //       "market_access_blocked_by_river": "Market on left side, farms on both side",
  //       "education_access_blocked_by_river": "Primary and secondary school on left side",
  //       "health_access_blocked_by_river": "Health center on left side",
  //       "other_access_blocked_by_river": "Potable water on left side, church on left side",
  //       "primary_occupations": "Market, farms, school, churches, health center",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by someone who is in charge of health for Rubaya center community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 54.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DSAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugari",
  //       "bridge_opportunity_project_code": "1007343",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.603205,
  //       "bridge_opportunity_gps_longitude": 29.719441,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 970,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1704m, Cell:Rugimbu, Injuries/Death--Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Gahama -Rwamabare -Kabana, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 45m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient.-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is silt soil for both sides. 90 people from Busengo and Janja Sectors use Mugari Bridge daily from nearby Sectors, most of the community that use Mugari bridge Carpent and other need to Access Kivuruga Market .",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.603205,
  //       "proposed_bridge_location_gps_longitude": 29.719441,
  //       "current_crossing_method": "Nowhere",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Kivuruga",
  //       "education_access_blocked_by_river": "Kageyo primary and secondary school",
  //       "health_access_blocked_by_river": "Bushoka health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze-kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86D5AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabarashi",
  //       "bridge_opportunity_project_code": "1007344",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6947222222,
  //       "bridge_opportunity_gps_longitude": 29.7977777778,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 3600,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1608m, Cell:Kagoma-Buyange, Injuries/Death--Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Butorerero -Cyibuga -Rukura, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 58m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient.-There is no confluence area near the place.-The river bed at the site is not stable, there is possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides. 1000 people from Raba cell in Minazi sector use Kabarashi Bridge to access Gakenke market.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6947222222,
  //       "proposed_bridge_location_gps_longitude": 29.7977777778,
  //       "current_crossing_method": "Four timber logs with crossing woods over",
  //       "nearest_all_weather_crossing_point": "No where to cross",
  //       "days_per_year_river_is_flooded": 3,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Minazi people go to gakenke market and do cross the kabarashi river",
  //       "education_access_blocked_by_river": "Children do cross to Musave nursery, Primary and Secondary School and Rukura(nursery, primary and secondary)",
  //       "health_access_blocked_by_river": "Nemba health center at left hand side and buyange post health center on right hand side",
  //       "other_access_blocked_by_river": "Transportation of harvested crops",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": ", fruit, maiz, pine appl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "The people accidentally slipped and fell down",
  //       "notes_on_social_information": "Information gathered from neighborhood people and village leader of kamatare",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86D6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutenga",
  //       "bridge_opportunity_project_code": "1007345",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6238888889,
  //       "bridge_opportunity_gps_longitude": 29.7116666667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 1926,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1691m, Cell:Butereri, Injuries/Death--Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Busengo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 62m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient.-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is silt soil for both sides. A number of 600 people from ,Buteteri, Kamena and Mwumba villages that use th bridge weekly to access Rubanga Secondary school others access Rwunge Market (Rwand National Wide Needs Assessment 2018.)",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6238888889,
  //       "proposed_bridge_location_gps_longitude": 29.7116666667,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "No where",
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": "12",
  //       "market_access_blocked_by_river": "Rwungo market",
  //       "education_access_blocked_by_river": "Rubaga primary",
  //       "health_access_blocked_by_river": "Busengo health center",
  //       "other_access_blocked_by_river": "Busengo church",
  //       "primary_occupations": "Marketing and farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped trying to cross the river when it was flooded",
  //       "notes_on_social_information": "I have gathered information from neighborhood people and bunyagezi leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86D7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarutovu",
  //       "bridge_opportunity_project_code": "1007348",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.688888888,
  //       "bridge_opportunity_gps_longitude": 29.668055555,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 1589,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1592m, Cell:Mubuga, Injuries/Death--Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Mubuga, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient.-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is rock for one side and silt for other side.In Rwanda National Wide Needs Assessment-2018, we find that 115 people;15 people from Munanira village ,40 people from Rutabo village ;50 people from Munyana cell and 10 people from Rwamambe cell use Nyarutovu Bridge to access Mugunga Secondary Schooland Rusoro health center.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.688888888,
  //       "proposed_bridge_location_gps_longitude": 29.668055555,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 6,
  //       "flood_duration_during_rainy_season": "6",
  //       "market_access_blocked_by_river": "Vunga market",
  //       "education_access_blocked_by_river": "Mubuga primary and secondary schools",
  //       "health_access_blocked_by_river": "Rusoro healthy center",
  //       "other_access_blocked_by_river": "Going to Church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, potato, yam",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "People slipped and fell over the bridge",
  //       "notes_on_social_information": "Information gathered from neighborhood locals and nyakagezi leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugunga",
  //       "bridge_opportunity_project_code": "1007349",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.623611111,
  //       "bridge_opportunity_gps_longitude": 29.7030555556,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 4,
  //       "bridge_opportunity_individuals_directly_served": 664,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1860m, Cell:Mwumba, Injuries/Death--Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Busengo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 50m.-The level difference between two banks is 0.01m.-The space for foundation is not sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient.-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is silt soil for both sides. In Rwanda National Wide Needs Assessment 2018,we find that 60 poeple from Rwamaramagambo Sector and Bugaragara cell use Mugunga bridge daily as Adjacent community.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.623611111,
  //       "proposed_bridge_location_gps_longitude": 29.7030555556,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "They cross using gaseke vehicular bridge in about 2 hrs away",
  //       "days_per_year_river_is_flooded": 8,
  //       "flood_duration_during_rainy_season": "September and April and it last hours",
  //       "market_access_blocked_by_river": "Tasker market and kivuruga",
  //       "education_access_blocked_by_river": "Rubaga primary and secondary",
  //       "health_access_blocked_by_river": "Hahaha health center",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Seeking administration services of busengo sector and health services and going to rubaga school",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They fell in the river struggling to cross the river in winter",
  //       "notes_on_social_information": "Informations gathered from neiborhood people",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali - musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitongo",
  //       "bridge_opportunity_project_code": "1007350",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.7041666667,
  //       "bridge_opportunity_gps_longitude": 29.8466666667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 1200,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1725m, Cell:Mbogo, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Rushashi -Mbogo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two elevated areas.-The soil from the site is sandy soil for both sides. 20 people from rwankuba Sector use the bridge for visiting relatives daily",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.7041666667,
  //       "proposed_bridge_location_gps_longitude": 29.8466666667,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "They usually cross unless the bridge logs are damaged due to being old",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Never floods",
  //       "market_access_blocked_by_river": "Rushashi market",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "Rushashi",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Visiting relatives and seeking medical care",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Old man feel after attending the party during hus way back",
  //       "notes_on_social_information": "For me according to the information and site observation the bridge could be rejected and I gathered information from rugarama leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinoko",
  //       "bridge_opportunity_project_code": "1007352",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.699722222,
  //       "bridge_opportunity_gps_longitude": 29.6966666667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1773m, Cell:Mubuga, Injuries/Death--Many peoples injured while crossing the river./ 2 peoples died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Mubuga, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 63m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient.-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is rock for one side and silt for other side. There are 2200 people from 7 villages as Adjacent community;200 people from Mwanza village, 400 Buhanga Village,100 people from Murambi village ,600 people from Kanini village,500 people Mwurire village,80 people from Bitaba village,100 people from Nyarubande village and 120 people from Kabere village.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.699722222,
  //       "proposed_bridge_location_gps_longitude": 29.6966666667,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 31,
  //       "flood_duration_during_rainy_season": "Whole april",
  //       "market_access_blocked_by_river": "Murambo market",
  //       "education_access_blocked_by_river": "Giko and janja primary and secondary",
  //       "health_access_blocked_by_river": "Janja health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Sector services muzo sector",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Two girls and one drunken man slipped and fell in past five years the kid drown and died",
  //       "notes_on_social_information": "The information gathered from citizen around the area",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 95,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiyovu center",
  //       "bridge_opportunity_project_code": "1007368",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.59132,
  //       "bridge_opportunity_gps_longitude": 30.01386,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 7,
  //       "bridge_opportunity_individuals_directly_served": 1461,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1873m, Cell:Kigogo, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Kiyovu -Yaramba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 13m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59132,
  //       "proposed_bridge_location_gps_longitude": 30.01386,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in four kilometers away",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Market on left side, farms on both side business center on left side",
  //       "education_access_blocked_by_river": "Nursery, primary and secondary on left side",
  //       "health_access_blocked_by_river": "Health center on left side",
  //       "other_access_blocked_by_river": "Churches on left side, football terrain and potable water on left side",
  //       "primary_occupations": "Farms, Health center, Market, School,",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Kigogo",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": 5.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DUAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Busabira",
  //       "bridge_opportunity_project_code": "1007370",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.72859,
  //       "bridge_opportunity_gps_longitude": 30.07666,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1560,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1513m, Cell:Kabeza, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Busabira, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 65m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing a sign of erosion and it is located between two elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.72859,
  //       "proposed_bridge_location_gps_longitude": 30.07666,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Market on both side, coffee factories in 1 hour from the bridge, farms",
  //       "education_access_blocked_by_river": "School on both side ( secondary and primary)",
  //       "health_access_blocked_by_river": "Health center on both side",
  //       "other_access_blocked_by_river": "Cell office both side and churches",
  //       "primary_occupations": "Market, school and Health center on right side, Market, health center, school and church to the left side",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "All both was students, but one was going to school when she was trying to cross bridge and other he was looking after domestic animals",
  //       "notes_on_social_information": "Information was given by the people who live closer to the site, they were five and one of them are community members",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 59,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuhunge",
  //       "bridge_opportunity_project_code": "1007354",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6025,
  //       "bridge_opportunity_gps_longitude": 29.70666,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 2250,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Cell:Rugimbu, Injuries/Death-/ during rainy season after rain period, it is difult to cross the river Cross river on a normal day->600 people, , Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-District/ Akarere,Reinforcement steel provided by-District/ Akarere,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments. in Rwanda National wide Assessement 2018, we find that 20 people from Rukore cell in Cyabingo Sector use Karuhunge Bridge daily for farming in Kivuruga Sector.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6025,
  //       "proposed_bridge_location_gps_longitude": 29.70666,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "700 m",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "18",
  //       "market_access_blocked_by_river": "Gaseke",
  //       "education_access_blocked_by_river": "Kageyo primary and secondary schools",
  //       "health_access_blocked_by_river": "Bushoka hospital",
  //       "other_access_blocked_by_river": "Anglican church",
  //       "primary_occupations": "Marketing",
  //       "primary_crops_grown": "cabbag",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Women slipped and fell",
  //       "notes_on_social_information": "Information gathered from neighborhood locals",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buranga",
  //       "bridge_opportunity_project_code": "1007356",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.639722,
  //       "bridge_opportunity_gps_longitude": 29.784722,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 32,
  //       "bridge_opportunity_individuals_directly_served": 2958,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Cell:Mucaca,Buranga, Injuries/Death-/ during rainy season after rain period, it is difult to cross the river Cross river on a normal day->600 people, , Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-District/ Akarere,Reinforcement steel provided by-District/ Akarere,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments. A number of1428 people from two nearby villages;Gihororo and Gisovu use Gitwa Bridge once a week and been connected to Gakenke Market , Murambi market that are the main Markwt in this region, other access Muramba Health Center. 50 people fromSitwe and Kabaya Village use Buranga Bridge to access Murambo market twice a week especially on market days",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.639722,
  //       "proposed_bridge_location_gps_longitude": 29.784722,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Passing around in gakenke in about 1.5 kilometer away",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Groupe scolaire Nemba, APREDEFOK, college community nyarutovu all are primary and secondary school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Someone fell down at night trying to cross",
  //       "notes_on_social_information": "Information gathered from mucyahafi village leader",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 57.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyangoga",
  //       "bridge_opportunity_project_code": "1007357",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.619444444,
  //       "bridge_opportunity_gps_longitude": 29.633333333,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 70,
  //       "bridge_opportunity_individuals_directly_served": 1230,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Cell:Gataba, Injuries/Death-/ during rainy season after rain period, it is difult to cross the river Cross river on a normal day-300-600 people, , Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-District/ Akarere,Reinforcement steel provided by-District/ Akarere,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments. In Rwanda National wide Assessment-2018, we find that 241 people;50 people from Janja Sector ,150 people Mugunga Sector,6 Student from Bumonyo Village,30Student from Gahama village and 5 Student from Kebero village use Cyangoga Bridge daily for accessing Nyagenzi Health center,Gasusha Market,Kinkware Market and Gakoro Secondary School.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.619444444,
  //       "proposed_bridge_location_gps_longitude": 29.633333333,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Kucyibuye suspension bridge",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Links are market",
  //       "education_access_blocked_by_river": "Groupe scolaire gakoro",
  //       "health_access_blocked_by_river": "Nyakigezi health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "One died in past seven years",
  //       "notes_on_social_information": "Information gathered from local people and cyibaya village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Nyakinama -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 52.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DJAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasigwe",
  //       "bridge_opportunity_project_code": "1007360",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.627777777,
  //       "bridge_opportunity_gps_longitude": 29.840555555,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 1302,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Cell:Karambo,Kanyanza, Injuries/Death-during rainy season people are jnjured by crossing the river and a great number died/ Cross river on a normal day-150-300 people, , Crossing River now-Walking through river / Banyura mumaziSimple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments. in Rwanda National Wide Needs Assessment-2018, we find that a number of 300 people from Kadehero village and Gashinge village use Gasigwe Bridge daily as Adjacent population. Gasigwe Bridge help those two villages to access Karambo market.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.627777777,
  //       "proposed_bridge_location_gps_longitude": 29.840555555,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 8,
  //       "flood_duration_during_rainy_season": "8",
  //       "market_access_blocked_by_river": "Karambo market",
  //       "education_access_blocked_by_river": "Karambo secondary and primary school",
  //       "health_access_blocked_by_river": "Karambo healthy center",
  //       "other_access_blocked_by_river": "Cothoric church in karambo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "The little kid slipped and fell down",
  //       "notes_on_social_information": "Information gathered from neighborhood people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 83.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihanga",
  //       "bridge_opportunity_project_code": "1007364",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.47241,
  //       "bridge_opportunity_gps_longitude": 29.99602,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 2045,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1848m, Cell:Gihanga, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Rubaya -Kapitali -Gatsata, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 45m.-The level difference between two banks is 3m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides. 3000 people from Gashiru and Nyamabare village access Karujanga market once a week located in Uganda Country.",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.47241,
  //       "proposed_bridge_location_gps_longitude": 29.99602,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Market on left side, business center on left side, farms on both side,",
  //       "education_access_blocked_by_river": "Nursery, primary and secondary on left side",
  //       "health_access_blocked_by_river": "Health center on left side",
  //       "other_access_blocked_by_river": "Cell and sector officer and bank, churches, all on left side",
  //       "primary_occupations": "Market, school, cell office, farms, business center",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was trying to cross the river but that time they was no bridge on the river",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and one of them is in charge of ubudehe",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nkurura",
  //       "bridge_opportunity_project_code": "1007372",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.48547,
  //       "bridge_opportunity_gps_longitude": 29.99506,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 1400,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1884m, Cell:Gishambashayo, Injuries/Death-Some peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Gishambashayo -Gatsata, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.48547,
  //       "proposed_bridge_location_gps_longitude": 29.99506,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Market on both side, farms on both side",
  //       "education_access_blocked_by_river": "Nusery, Primary and secondary school on left side",
  //       "health_access_blocked_by_river": "Health center and post health center on left side",
  //       "other_access_blocked_by_river": "Potable water on left side, churches on both side",
  //       "primary_occupations": "Market, school, to border Gatuna,",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DYAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Buhoro",
  //       "bridge_opportunity_project_code": "1007376",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.62627,
  //       "bridge_opportunity_gps_longitude": 30.6261,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1691m, Cell:Buhoro, Injuries/Death-Two peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Karama, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is Hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.62627,
  //       "proposed_bridge_location_gps_longitude": 30.6261,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "No river and no need for a bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwarugondo",
  //       "bridge_opportunity_project_code": "1007377",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.63101,
  //       "bridge_opportunity_gps_longitude": 29.63617,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 3983,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1675m, Cell:Gahororo, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Karama, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.9m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.63101,
  //       "proposed_bridge_location_gps_longitude": 29.63617,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Busoro, Rugarika and Ndago markets (1,2,3), Karama market (Community 4,5)",
  //       "education_access_blocked_by_river": "Karama Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Karama Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Karama Catholic Parish (Community 4,5), Karama Sector office (Community 4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, beans., cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Uwarugondo, Muyange, Isangano, Raranzige and Cyetete villages were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. The population information for each village was provided by the Gahororo Cell Leader, Jannette Nikuze, from the data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Zaga",
  //       "bridge_opportunity_project_code": "1007378",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.60378,
  //       "bridge_opportunity_gps_longitude": 29.66448,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 3328,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1712m, Cell:Kibingo, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Kibingo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.60378,
  //       "proposed_bridge_location_gps_longitude": 29.66448,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 hours.",
  //       "market_access_blocked_by_river": "Huye, Matyazo, Muyogoro and Karama Markets (Community 1,2,3), Farms (1,2,3)",
  //       "education_access_blocked_by_river": "Karama Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Karama Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Karama ADPR and Adventist Churches, Karama Catholic Parish, Karama Sector (Community 1,2,3); Jehovah Witnesses church (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": ", banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Zaga, Gasharu, Agatovu, Butare, Marimba and Akarambo villages were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. The population information for each village was provided by the Kibingo Cell Leader, Jannette Nikuze and Zaga Village Leader, Nyandwi Bosco from the data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwimpundu",
  //       "bridge_opportunity_project_code": "1007379",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.62437,
  //       "bridge_opportunity_gps_longitude": 30.64553,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 7,
  //       "bridge_opportunity_individuals_directly_served": 1505,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1681m, Cell:Muhembe, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Karama, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.62437,
  //       "proposed_bridge_location_gps_longitude": 30.64553,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Karama market (Community 1), Kabirizi market (Community 2), Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "Karama secondary school (Community 1)",
  //       "health_access_blocked_by_river": "Karama Health Center (Community 1)",
  //       "other_access_blocked_by_river": "Karama Catholic Parish, Karama Sector Office (Community 1)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Uwarugondo and Uwimpundu villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and farms. The population information for each village was provided by the Gahororo Cell Leader, Janette Nikuze and uwarugondo village leader, Vedaste Habimana, from the population data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru.",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Too close to a vehicular road which will be upgraded to a paved road",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rujumbura",
  //       "bridge_opportunity_project_code": "1007381",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.68664,
  //       "bridge_opportunity_gps_longitude": 29.75706,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 4744,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1583m, Cell:Buvumo, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Mburamazi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.68664,
  //       "proposed_bridge_location_gps_longitude": 29.75706,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "In April and May it last for 24 hours.",
  //       "market_access_blocked_by_river": "Mburamazi market (Community 1,2,3) and Busoro Market (Community 4,5), Farms (Community 1,5)",
  //       "education_access_blocked_by_river": "St Francois d'Assise Secondary School, St Bernard Secondary School and Kansi Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Kansi Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Kansi Catholic Parish and ADEPR Church (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation., bean, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "Many people fall into the river at the current crossing point when they try to cross. But no serious injuries.",
  //       "notes_on_social_information": "Rujumbura, Taba, Mpinga, Nyagasambu, Kabeza, Nyarusambu, Remera, Rugarama, Kimirama and Nyagisenyi villages were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. The population information for each village was provided by the Buvumo Cell Leader, Kazungu Emmanuel from the data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabyaza",
  //       "bridge_opportunity_project_code": "1007419",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.82084,
  //       "bridge_opportunity_gps_longitude": 29.54068,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Ground slopes are too steep and there is an alternative crossing 610m away.",
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.82084,
  //       "proposed_bridge_location_gps_longitude": 29.54068,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "All bank sides of bridge are of very high slope, people are using a vehicle bridge in 610 meters from Kabyaza site .",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EJAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryagashaza",
  //       "bridge_opportunity_project_code": "1007383",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.971072,
  //       "bridge_opportunity_gps_longitude": 29.838172,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 4975,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1531m, Cell:Bitare, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Nyenyeri -Remera Rukoma, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 0.03m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.6.11",
  //       "form_created_by": "clementinemukashyaka taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.971072,
  //       "proposed_bridge_location_gps_longitude": 29.838172,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Nowhere else",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "Kuruyenzi center, Gacurabwenge",
  //       "education_access_blocked_by_river": "Rukambura",
  //       "health_access_blocked_by_river": "Poste de Santa Ryagashaza and Rukoma hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, ric, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "It was rained a lot",
  //       "notes_on_social_information": "One of the community member who has a child of 5 years at Rukambura nursery school says that she is worried while her child is at school during rainy season because of flooding that may come and unable to access the bridge. The community says Gatimbazi River wash away timber by now it remains by two timbers. It is not easy to find replacement timbers frequently.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kamonyi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DjAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuga",
  //       "bridge_opportunity_project_code": "1007384",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.972033,
  //       "bridge_opportunity_gps_longitude": 29.84578,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 77.4,
  //       "bridge_opportunity_individuals_directly_served": 1195,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1551m, Cell:Bitare, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Nyenyeri -Remera Rukoma, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.6.11",
  //       "form_created_by": "clementinemukashyaka taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Nowhere else",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Gashyushya market",
  //       "education_access_blocked_by_river": "Kabuga primary school",
  //       "health_access_blocked_by_river": "Bitare health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Those person fell down while crossing in a rainy season, normally the current crossing timber are damaged in fact you do not pay attention you should fall down eveny in sunny season.",
  //       "notes_on_social_information": "The community says that they really need a bridge to connect them with Musambira sector. There are a huge number of students from Mugina cell (in Musambira sector) that stay home in a rainy season due to the lucky of accessible bridge. Patient from Mugina cell also suffer more because of walking a long distance in order to reach the hospital",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kamonyi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 8,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyirahene",
  //       "bridge_opportunity_project_code": "1007388",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.14375,
  //       "bridge_opportunity_gps_longitude": 29.5181389,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 9,
  //       "bridge_opportunity_individuals_directly_served": 6000,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1665m, Cell:Birambo, Injuries/Death-1 person was injured while trying crossing the river./ No person died while crossing the river Cross river on a normal day->600 people, Nearby city centers--Birambo -Nyakabuye, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 6 m-The proposed bridge span is 20 m-The level difference between two banks is approximately 0.9m.-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the site-The river bed at the site is stable, there is no possibility of erosion.-The bank profile of the site is approximately partially cut off-The river bank of the site is not showing any sign of erosion and it is located between a hill for one side and an elevated area for the other side.-The soil from the site is a rock for both sides-The site is located between a hill and an elevated area.with hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14375,
  //       "proposed_bridge_location_gps_longitude": 29.5181389,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 205,
  //       "flood_duration_during_rainy_season": "10 hours of flood",
  //       "market_access_blocked_by_river": "All People from left side of the river including Ntarabana village don't have access to Birambo market , and this is more important market for them",
  //       "education_access_blocked_by_river": "All People from left side of the river including Ntarabana village don't have access to GS Birambo",
  //       "health_access_blocked_by_river": "All People from left side of the river including Ntarabana village don't have access to Birambo health center",
  //       "other_access_blocked_by_river": "All People from left side of the river including Ntarabana village don't have access to Birambo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A goat , and 4 people were died there, one person be came injured",
  //       "notes_on_social_information": "A volunteer from Birambo center provided all info about individual served by the bridge.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DoAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugogo",
  //       "bridge_opportunity_project_code": "1007389",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.207465,
  //       "bridge_opportunity_gps_longitude": 29.4401,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 17,
  //       "bridge_opportunity_individuals_directly_served": 6195,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1954m, Cell:Byogo-Nyamugwagwa, Injuries/Death-1 person was injured while trying crossing the river./ No person died while crossing the river Cross river on a normal day-150-300 people, Nearby city centers--Musango -Mukungu -Gasenyi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 3 m-The proposed bridge span is 38m-The level difference between two banks is approximately 0.1m (Approximately the same)-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level sufficient-There is no confluence area near the site-The river bed at the site is stable, there is no possibility of erosion.-The bank profile of the site is approximately partially cut out-The river bank of the site is not showing any sign of erosion and it is located between two hills-The soil from the site is hard rock for both sides-The site is located between two hills with hard rock for both sides",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.207465,
  //       "proposed_bridge_location_gps_longitude": 29.4401,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 39,
  //       "flood_duration_during_rainy_season": "39times in April, May, October November and December and it lasts 3hours after rainfall",
  //       "market_access_blocked_by_river": "Nyamugwagwa cell doesn't have access to Mukungu animal market Byogo cell doesn't have access to Gasenyi market",
  //       "education_access_blocked_by_river": "Byogo cell doesn't have access to Nyamugwagwa primary school Nyamugwagwa cell doesn't have access to Musango secondary school",
  //       "health_access_blocked_by_river": "Nyamugwagwa cell doesn't have access to Mukungu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, beans, cassava, banana",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongo",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32.4,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kurusumo",
  //       "bridge_opportunity_project_code": "1007390",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.16372,
  //       "bridge_opportunity_gps_longitude": 29.35439,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 13,
  //       "bridge_opportunity_individuals_directly_served": 13740,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1733m, Cell:Gatsata, Injuries/Death-Many people were injured while trying crossing the river./ No person died while crossing the river Cross river on a normal day-50-150 people, Nearby city centers--Bisesero -Gatsata -Kamina, Crossing River now-Walking through river / Banyura mumaziSimple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 7m-The proposed bridge span is 40m-The level difference between two banks is approximately 0.2m (Approximately the same)-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level sufficient-There is no confluence area near the site-The river bed at the site is stable, there is no possibility of erosion.-The bank profile of the site is approximately partially cut out-The river bank of the site is not showing any sign of erosion and it is located between two hills-The soil from the site is clay for both sides-The site is located between two hills with clay for both sides",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.16372,
  //       "proposed_bridge_location_gps_longitude": 29.35439,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 220,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Rubazo cell and Nyarusanga cell don't have access to Mubuga market",
  //       "education_access_blocked_by_river": "Bisesero cell don't have access to GS Gasata",
  //       "health_access_blocked_by_river": "Rubazo cell and Nyarusanga cell don't have access to bisesero health center",
  //       "other_access_blocked_by_river": "Bisesero cell don't have access to Rubazo Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Five injuries across this river",
  //       "notes_on_social_information": "Nyagafumba village leader and cyabahanga village leader provided info about directly individual served by referring to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DqAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinjongo",
  //       "bridge_opportunity_project_code": "1007392",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.14811,
  //       "bridge_opportunity_gps_longitude": 29.52184,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 7,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1635m, Cell:Birambo, Injuries/Death-No person was injured while trying crossing the river./ No person died while crossing the river Cross river on a normal day-50-150 people, Nearby city centers--Birambo -Nyakabuye, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 2 m-The proposed bridge span is 16 m-The level difference between two banks is approximately the same.-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the site-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides-The site is located between two flat areas.",
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14811,
  //       "proposed_bridge_location_gps_longitude": 29.52184,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Kakibereko village , nyarusange village and Rubona village don't have access to birambo market",
  //       "education_access_blocked_by_river": "Kakibereko village , nyarusange village and Rubona village don't have access to GS St lenne Birambo",
  //       "health_access_blocked_by_river": "Kakibereko village , nyarusange village and Rubona village don't have access to birambo health center",
  //       "other_access_blocked_by_river": "Kakibereko village , nyarusange village and Rubona village don't have access to birambo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Kid coming from school",
  //       "notes_on_social_information": "Birambo village security officer is the one who provided information about directly individual served , he referred to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasarabwayi",
  //       "bridge_opportunity_project_code": "1007393",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.90503,
  //       "bridge_opportunity_gps_longitude": 30.60191,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 4255,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1348m, Cell:Gihinga-Nyamugari, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Gasarabwayi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 23m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.90503,
  //       "proposed_bridge_location_gps_longitude": 30.60191,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "Seven days",
  //       "market_access_blocked_by_river": "Rugunga and uburembo are blocked to the Market",
  //       "education_access_blocked_by_river": "Rugunga and uburembo are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Rugunga and uburembo are blocked to Health center",
  //       "other_access_blocked_by_river": "Rugunga is blocked to cell and sector office",
  //       "primary_occupations": "School, market",
  //       "primary_crops_grown": "bean, soghrom",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Gasarabwayi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahushyi",
  //       "bridge_opportunity_project_code": "1007394",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.97849,
  //       "bridge_opportunity_gps_longitude": 30.58137,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 2451,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1377m, Cell:Mbarara, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Mbarara, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 16m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.97849,
  //       "proposed_bridge_location_gps_longitude": 30.58137,
  //       "current_crossing_method": "Timber but old",
  //       "nearest_all_weather_crossing_point": "4 kilometers",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Mbarara 1,2 Murambo are blocked to business center in seresi community",
  //       "education_access_blocked_by_river": "School are on both side but student of Gahushyi are blocked to secondary schools in Gacaca",
  //       "health_access_blocked_by_river": "Mbarara 1,2 Murambo are blocked to Health center",
  //       "other_access_blocked_by_river": "Gahushyi is blocked to cell office",
  //       "primary_occupations": "Farms, school, health center,",
  //       "primary_crops_grown": "banana, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Chief of Security of Mbarara 2",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akayebe",
  //       "bridge_opportunity_project_code": "1007395",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.92998,
  //       "bridge_opportunity_gps_longitude": 30.60766,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 1907,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. There is an alternate crossing ~235 meters away from the site and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92998,
  //       "proposed_bridge_location_gps_longitude": 30.60766,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "235 m",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Akayebe and Gihinga are blocked to the Market and business center, mining factor (wolfam)",
  //       "education_access_blocked_by_river": "Akayebe and Gihinga are blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "Akayebe and Gihinga are blocked to the Hospital",
  //       "other_access_blocked_by_river": "Akayebe and Gihinga are blocked to the sector office and church",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Nkondo",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is closer to the road where they can close river 235 meters away",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mutembo",
  //       "bridge_opportunity_project_code": "1007396",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.96784,
  //       "bridge_opportunity_gps_longitude": 30.58284,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 1799,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1354m, Cell:Mbarara, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Mbarara, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 18m.-The level difference between two banks is 0.3m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.96784,
  //       "proposed_bridge_location_gps_longitude": 30.58284,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 64,
  //       "flood_duration_during_rainy_season": "Four days",
  //       "market_access_blocked_by_river": "Mutembo, mbarara 2 are blocked to business center , farms",
  //       "education_access_blocked_by_river": "Gahushyi is blocked to secondary schools",
  //       "health_access_blocked_by_river": "Mutembo, mbarara 2 are blocked to Health center",
  //       "other_access_blocked_by_river": "Gahushyi is blocked to cell office",
  //       "primary_occupations": "Farms and churches, school",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Chief of Security of Murambo and people who worked closer the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusuma",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabakungu",
  //       "bridge_opportunity_project_code": "1007397",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.8106111,
  //       "bridge_opportunity_gps_longitude": 29.7573333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 4609,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1515m, Cell:Nyamirambo, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Mbuye -Mucyakabiri, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8106111,
  //       "proposed_bridge_location_gps_longitude": 29.7573333,
  //       "current_crossing_method": "Timbers linked together",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 51,
  //       "flood_duration_during_rainy_season": "No flood only soil erosion cause isolation of both sides and it can take like two months for finding other timbers to put they that time none is able to cross .",
  //       "market_access_blocked_by_river": "Mbuye market and Ruhango - Rusuri market",
  //       "education_access_blocked_by_river": "GS Rongi",
  //       "health_access_blocked_by_river": "Rongi health center",
  //       "other_access_blocked_by_river": "Rongi church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "People walking on bridge then bridge fall down",
  //       "notes_on_social_information": "GS Rongi ( Kabakungu village, ntarabana village , masizi village ) , Mbuye market ( Rwamure village , Gisoro village ) , Ruhango _ Rusuri market ( kabakungu village , masizi village , ntarabana village ) . Information about directly individual served provided by kabakungu village leader by calling other village leader using the same bridge on phone , they referred to the population census of 2018 .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutongo",
  //       "bridge_opportunity_project_code": "1007398",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.9643,
  //       "bridge_opportunity_gps_longitude": 29.76213,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 2010,
  //       "bridge_opportunity_comments": "Called Gihinga in the Needs Assessment. 3000-6000 people directly served, Elevation:1598m, Cell:Jandari-Butare, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Rutongo -Murara, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a flat and an elevated area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9643,
  //       "proposed_bridge_location_gps_longitude": 29.76213,
  //       "current_crossing_method": "The people constructed bridge of 5 timbers and they are using it",
  //       "nearest_all_weather_crossing_point": "No other point they just cross",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "No much floods",
  //       "market_access_blocked_by_river": "Gihinga Market",
  //       "education_access_blocked_by_river": "GS Butare and Rutongo ps",
  //       "health_access_blocked_by_river": "Rutongo Post de Sante and Buramba Health center",
  //       "other_access_blocked_by_river": "Kabacuzi sector office at right side",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, cassava, cush plantation, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Drunk men fall in the river while crossing",
  //       "notes_on_social_information": "Two village leader told me their population who are crossing",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_ Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kurugomero",
  //       "bridge_opportunity_project_code": "1007399",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.81295875,
  //       "bridge_opportunity_gps_longitude": 29.77787873,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 4427,
  //       "bridge_opportunity_comments": "During District planning and PPD submission, the District indicated that it was planning on building a vehicle bridge at this site. (BAJ_11-5-18) 500-1000 people directly served, Elevation:1383m, Cell:Nyamirambo, Injuries/Death-Many peoples injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Mbuye -Mucyakabiri, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.81295875,
  //       "proposed_bridge_location_gps_longitude": 29.77787873,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "20 m",
  //       "days_per_year_river_is_flooded": 65,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Mbuye market",
  //       "education_access_blocked_by_river": "ES Rongi",
  //       "health_access_blocked_by_river": "Ruri hospital",
  //       "other_access_blocked_by_river": "Rongi Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 15,
  //       "incident_descriptions": "People fall down as the bridge is at high altitude from the ground",
  //       "notes_on_social_information": "Mbuye market ( Fumbwe village , Gasagara village ) ,Ruri hospital ( rugogwe village , mugwato village), ES Rongi ( Fumbwe village , Gasagara village ) , Rongi catholique church ( Fumbwe village , Gasagara village ) . The security village leader of Mugwato provided the information regarding to direct individual served and he referred to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86DzAAI",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Mataba",
  //       "bridge_opportunity_project_code": "1007401",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.9014444,
  //       "bridge_opportunity_gps_longitude": 29.7639167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 11,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1524m, Cell:Ndago, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Remera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 1.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a flat and an elevated area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": -1.9014444,
  //       "proposed_bridge_location_gps_longitude": 29.7639167,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "To be Rejected because it is very close to the unpaved road of Nyabiheke, right side is 6 meters to the road. There is also a constructed vehicle bridge with coordinates (-1.900034, 29.76380) in 20 meters and people are using the vehicle bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86E1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Matsinsi",
  //       "bridge_opportunity_project_code": "1007402",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.14494,
  //       "bridge_opportunity_gps_longitude": 29.77813,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1698m, Cell:Mubuga, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-< 50 people, Nearby city centers--Ramba -Muhanga -Juyamarize, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.9m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14494,
  //       "proposed_bridge_location_gps_longitude": 29.77813,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "People use constructed Suspended bridge of Gakomeye",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "No flood",
  //       "market_access_blocked_by_river": "Muhanga ,Kinini,Misizi,Ntenyo and Ruhango markets",
  //       "education_access_blocked_by_river": "Gahengeli ps, GS Shyogwe",
  //       "health_access_blocked_by_river": "Shyogwe health center",
  //       "other_access_blocked_by_river": "Shyogwe sector and Byimana Sector",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": ", banana, bean, cassava, coffe",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Village leaders told me that the bridge is used by two districts over 3000 people crossing the bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86E2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kumukenke",
  //       "bridge_opportunity_project_code": "1007403",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.076671,
  //       "bridge_opportunity_gps_longitude": 29.716686,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1753m, Cell:Nganzo-Kanyinya, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Muhanga, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 2m.-The space for foundation is not sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.13",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.076671,
  //       "proposed_bridge_location_gps_longitude": 29.716686,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The nearest crossing is less than 300m. They can use NR 7 during rainy season.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86E3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuga",
  //       "bridge_opportunity_project_code": "1007404",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.750277,
  //       "bridge_opportunity_gps_longitude": 29.745,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 160,
  //       "bridge_opportunity_individuals_directly_served": 1950,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1385m, Cell:Gasharu-Gikombe, Bridge would connecting Muhanga-Gakenke, Injuries/Death-Many peoples injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Gakenke -Gasenyi, Crossing River now-Swim / BarogaBoat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 200m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas-The soil from the site is silt for both sides. there are 60 people from Gakenke Sector that use Kabuga bridge twice a week ( Monday and Thursday) to reach to Gasenyi and Mbuye markets.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.750277,
  //       "proposed_bridge_location_gps_longitude": 29.745,
  //       "current_crossing_method": "They use boat to cross",
  //       "nearest_all_weather_crossing_point": "They use muvumba vehicular bridge",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "Two month but they cross using boat",
  //       "market_access_blocked_by_river": "Mbuye market and gakenke",
  //       "education_access_blocked_by_river": "Muyaga primary , mataba secondary and primary",
  //       "health_access_blocked_by_river": "Mataba health center and birehe post health center",
  //       "other_access_blocked_by_river": "Churches and mataba coffee and minazi industry",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information gathered from people around the area and cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 171,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86E4AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubindi",
  //       "bridge_opportunity_project_code": "1007409",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.5931667,
  //       "bridge_opportunity_gps_longitude": 29.6469167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 90,
  //       "bridge_opportunity_individuals_directly_served": 6000,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1562m, Cell:Bikara, Injuries/Death--Many peoples injured while crossing the river./ More than 2 peoples died while trying to cross the river. Cross river on a normal day->600 people, Nearby city centers--Kampara -Kinkware, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 1.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient.-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is volcanic rock for both sides.",
  //       "form_form_name": "Project Pre-Assessment - 2018.8.24",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community only wants a vehicular bridge. Video to be uploaded to Box by Cesar Ngenzi. Cesar checked the coordinates to confirm it was the same site.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86E9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mubarama",
  //       "bridge_opportunity_project_code": "1007420",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.91351,
  //       "bridge_opportunity_gps_longitude": 29.57821,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 14,
  //       "bridge_opportunity_individuals_directly_served": 12804,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1828m, Cell:Nyamata, Injuries/Death-Many peoples injured while crossing the river./ No person known died while tying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Nyamata -Mubarame, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at the distance of 5m.-The proposed bridge span is approximately 28m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient -The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing sign of erosion and it is located between two flat areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.8",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.91351,
  //       "proposed_bridge_location_gps_longitude": 29.57821,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 88,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Sanza cell don't have access to BIREMBO MARKET, whereas kirwa cell don't have access to Rusumo Market",
  //       "education_access_blocked_by_river": "Kirwa cell don't have access to GS Gitega",
  //       "health_access_blocked_by_river": "kirwa cell don't have access to FOSACOM Gitega",
  //       "other_access_blocked_by_river": "Kirwa cell don't have access to Gitega church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Two injuries",
  //       "notes_on_social_information": "Farmers who were cultivating shared with me some of info about the bridge site",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Tubumba",
  //       "bridge_opportunity_project_code": "1014597",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.22306,
  //       "bridge_opportunity_gps_longitude": 30.0561,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1882,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.22306,
  //       "proposed_bridge_location_gps_longitude": 30.0561,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two month",
  //       "market_access_blocked_by_river": "Kamabare market",
  //       "education_access_blocked_by_river": "Murambi school",
  //       "health_access_blocked_by_river": "Nyarugenge health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Tubumba village dont have access to murambi school and rurama dont have access to kamabare market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-nyamata",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 79,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHAWAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambi",
  //       "bridge_opportunity_project_code": "1007410",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.5738611,
  //       "bridge_opportunity_gps_longitude": 29.6502222,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 6000,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1609m, Cell:Bikara, Injuries/Death--Many peoples injured while crossing the river./ one person died while trying to cross the river. Cross river on a normal day->600 people, Nearby city centers--Kampara -Kinkware, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 24m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient.-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is volcanic rock for both sides.",
  //       "form_form_name": "Project Pre-Assessment - 2018.8.24",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community wants to upgrade the existing vehicle bridge. See photo in Box",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sovu",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007414",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.253768,
  //       "bridge_opportunity_gps_longitude": 30.378498,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 700,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1335m, Cell:hanika-Gafunzo, , Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Gafunzo, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 750m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.253768,
  //       "proposed_bridge_location_gps_longitude": 30.378498,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Too long span over the lake sake more than 500m",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Shyirinyota",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007415",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.228352,
  //       "bridge_opportunity_gps_longitude": 30.335798,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 600,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1335m, Cell:Karenge, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Jarama, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 700m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between a flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.228352,
  //       "proposed_bridge_location_gps_longitude": 30.335798,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Too long span more than 500m to reach the soil of the other side",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EFAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Vunga",
  //       "bridge_opportunity_project_code": "1007416",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.274806,
  //       "bridge_opportunity_gps_longitude": 30.43525,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 600,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1326m, Cell:Kigoma-Karwema, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Gitesanyi, Crossing River now-Walking through river / Banyura mumaziBoat / Bakoresha ubwato, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 650m.-The level difference between two banks is 0.04m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.274806,
  //       "proposed_bridge_location_gps_longitude": 30.43525,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Large wetland of more than 500m long",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bare",
  //       "bridge_opportunity_project_code": "1007417",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.16867,
  //       "bridge_opportunity_gps_longitude": 30.26261,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 250,
  //       "bridge_opportunity_individuals_directly_served": 12348,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1329m, Cell:Rwintashya-Mugorore, Bridge would connecting Ngoma-Bugesera, Injuries/Death-Many peoples injured while trying to cross the river/ More than 2 peoples died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Rukumberi, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 14m.-The proposed bridge span is approximately 350m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.16867,
  //       "proposed_bridge_location_gps_longitude": 30.26261,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "34 days of flood",
  //       "market_access_blocked_by_river": "Rwintashya cell don't have access to kabukuba market , whereas mugororre cell don't have access to Rubona market",
  //       "education_access_blocked_by_river": "Rwintashya cell don't have access to Mwanashuti school",
  //       "health_access_blocked_by_river": "Rwintashya cell don't have access to Juru health center",
  //       "other_access_blocked_by_river": "Ngoma district office is blocked at left whereas Bugesera district offfice is blocked right side",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One person died here",
  //       "notes_on_social_information": "Rwintashya cell leader is the one who provided information about directly individual served by refering to the population census 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Bugesera",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakajuri",
  //       "bridge_opportunity_project_code": "1014598",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.20524,
  //       "bridge_opportunity_gps_longitude": 30.07864,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 960,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20524,
  //       "proposed_bridge_location_gps_longitude": 30.07864,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community always cross",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHAbAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakomo",
  //       "bridge_opportunity_project_code": "1007422",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.93935456,
  //       "bridge_opportunity_gps_longitude": 29.63153625,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 11,
  //       "bridge_opportunity_individuals_directly_served": 6000,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1596m, Cell:Cyome, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Gatumba -Rusumo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 5m.-The proposed bridge span is approximately 55m.-The level difference between two banks is approximately 0.3m(Almost the same).-The space for foundation is sufficient.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient (>Span/25).-There is a confluence area near the place.-The river bed at this site is stable, there is no possibility of erosion.-The bank profile of the site is not showing sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.93935456,
  //       "proposed_bridge_location_gps_longitude": 29.63153625,
  //       "current_crossing_method": "8 timbers",
  //       "nearest_all_weather_crossing_point": "They either use Rwasare or they can even walk through water",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In heavy rain",
  //       "market_access_blocked_by_river": "Rusumo Market",
  //       "education_access_blocked_by_river": "Gs Muhororo,ADEC -Ruhanga",
  //       "health_access_blocked_by_river": "Muhororo",
  //       "other_access_blocked_by_river": "Gatumba Sector",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, potato, soya bean, sugar can",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "This bridges is between many villages people use the bridge in their daily activities",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero- kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Munyegera",
  //       "bridge_opportunity_project_code": "1007427",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.82273,
  //       "bridge_opportunity_gps_longitude": 29.58247,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 1533,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1730m, Cell:Mparantima, Injuries/Death-Many peoples injured while crossing the river./ No person known was injured while tying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Gitwa -Munyegera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 9m.-The proposed bridge span is approximately 32m.-The level difference between two banks is approximately 0.03m(almost the same).-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient -The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is Hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.82273,
  //       "proposed_bridge_location_gps_longitude": 29.58247,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 2,
  //       "flood_duration_during_rainy_season": "3 days of flood",
  //       "market_access_blocked_by_river": "Kabaya market and Ngororero market",
  //       "education_access_blocked_by_river": "GS Hindiro",
  //       "health_access_blocked_by_river": "FOSACOM",
  //       "other_access_blocked_by_river": "Hindiro sector office and Ngororero sector office",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "3 member of same family were dead",
  //       "notes_on_social_information": "Two village leaders told me their number of population who crossing the bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ERAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirombozi",
  //       "bridge_opportunity_project_code": "1007428",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.929636,
  //       "bridge_opportunity_gps_longitude": 29.799125,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 22,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1562m, Cell:Kamasiga, Injuries/Death-No person injured while crossing the river./ No person known died while tying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Muhororo -Kunganzo -Ngororero, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at the distance of 1m.-The proposed bridge span is approximately 40m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient -The river bed at the site is unstable, there is possibility of erosion.-The river bank of the site is showing sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.13",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.929636,
  //       "proposed_bridge_location_gps_longitude": 29.799125,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The days the river is dangerous or impossible to cross is less than one",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ESAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Agnes",
  //       "bridge_opportunity_project_code": "1007429",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.9264167,
  //       "bridge_opportunity_gps_longitude": 29.5062222,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2139m, Cell:Nyamata, Injuries/Death-No person injured while crossing the river./ No person known was injured while tying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers-Kageyo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at the same place.-The proposed bridge span is approximately 12m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient -The river bed at the site is unstable, there is possibility of erosion.-The river bank of the site is showing sign of erosion and it is located between two flat areas.-The soil from the site is clay for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.13",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9264167,
  //       "proposed_bridge_location_gps_longitude": 29.5062222,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 102,
  //       "flood_duration_during_rainy_season": "13 hours of flood",
  //       "market_access_blocked_by_river": "People from Rutsiro District don't have access to BIREMBO MARKET",
  //       "education_access_blocked_by_river": "People from Rutsiro District don't have access to GS Mugega, whereas people Ngororero District don't have access to GS Gakeri",
  //       "health_access_blocked_by_river": "People from Rutsiro District don't have access to Mabuye health center , whereas people Ngororero District don't have access to kabona health center",
  //       "other_access_blocked_by_river": "People from Rutsiro District don't have access to Gatovu Catholic church , whereas people Ngororero District don't have access to Gakeri church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident as bridge is timbers, tiers of cement and concrete bonded with stones , problems here are water overload the bridge and flood occurs, so people get scared and not crossing the river during heavy rain period",
  //       "notes_on_social_information": "Mugobati village leader is the one who gave us some info about the bridge",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero - Muhanga",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ETAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahira",
  //       "bridge_opportunity_project_code": "1007464",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.448025,
  //       "bridge_opportunity_gps_longitude": 29.4665,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 11,
  //       "bridge_opportunity_individuals_directly_served": 2810,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2007m, Cell:Gahira-Runege, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Runege -Gahira, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.448025,
  //       "proposed_bridge_location_gps_longitude": 29.4665,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "8 km",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "5hours",
  //       "market_access_blocked_by_river": "Gasenyi, muduha, mushubi,gasarenda markets; farming in musebeya; health center( Mbuga) kigeme, butare); access to the district officials services",
  //       "education_access_blocked_by_river": "Kigeme secondary school, kaduha secondary, gasenyi primary school",
  //       "health_access_blocked_by_river": "Musebeya people can not go to the kigeme hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming, commerce, livestock",
  //       "primary_crops_grown": "bean, flour, maiz, potato, sweet potato, tea, tre",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Meeting of community near the bridge in Bunyunyu",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-rusizi",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 72,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86F2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakajuri",
  //       "bridge_opportunity_project_code": "1014599",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.22393,
  //       "bridge_opportunity_gps_longitude": 30.07617,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 908,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.22393,
  //       "proposed_bridge_location_gps_longitude": 30.07617,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community needs avehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHAgAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamasiga",
  //       "bridge_opportunity_project_code": "1007430",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.92789109,
  //       "bridge_opportunity_gps_longitude": 29.63116618,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 11,
  //       "bridge_opportunity_individuals_directly_served": 3400,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1565m, Cell:Kamasiga, Injuries/Death-No person injured while crossing the river./ No person known died while tying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Muhororo -Kunganzo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at the distance of 6m.-The proposed bridge span is approximately 20m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient -The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92789109,
  //       "proposed_bridge_location_gps_longitude": 29.63116618,
  //       "current_crossing_method": "9 timbers",
  //       "nearest_all_weather_crossing_point": "People walk on foot through the river",
  //       "days_per_year_river_is_flooded": 2,
  //       "flood_duration_during_rainy_season": "Yes floods occur during heavy season",
  //       "market_access_blocked_by_river": "Rusumo Market",
  //       "education_access_blocked_by_river": "GS Muhororo at right",
  //       "health_access_blocked_by_river": "Muhororo hospital at right side",
  //       "other_access_blocked_by_river": "Gatumba sector",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "No death it just falling and and get injured",
  //       "notes_on_social_information": "People cross the bridge going to hospital from different villages",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero-Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EUAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigufi",
  //       "bridge_opportunity_project_code": "1007431",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.8153056,
  //       "bridge_opportunity_gps_longitude": 29.578056,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 6,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1901m, Cell:Kajindi, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Gitwa -Munyegera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 1m.-The proposed bridge span is approximately 12m.-The level difference between two banks is approximately 0.01m(almost the same).-The space for foundation is sufficient for both sides.-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient (",
  //       "form_form_name": "Project Assessment - 2018.12.8",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8153056,
  //       "proposed_bridge_location_gps_longitude": 29.578056,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero - Kabaya",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicle bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kazabe",
  //       "bridge_opportunity_project_code": "1007432",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.85795617,
  //       "bridge_opportunity_gps_longitude": 29.62374517,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 6,
  //       "bridge_opportunity_individuals_directly_served": 2100,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1612m, Cell:kazabe, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Muhororo -Ngororero, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 1m.-The proposed bridge span is approximately 15m.-The level difference between two banks is approximately 2m.-The space for foundation is sufficient.-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient (",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85795617,
  //       "proposed_bridge_location_gps_longitude": 29.62374517,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "No floods",
  //       "market_access_blocked_by_river": "Ngororero market",
  //       "education_access_blocked_by_river": "GS Rurimba",
  //       "health_access_blocked_by_river": "Rususa health center",
  //       "other_access_blocked_by_river": "Ngororero District &Sector",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Children crossing",
  //       "notes_on_social_information": "Populatio around Ngororero come to cross river to Ngororero market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero-Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibirira",
  //       "bridge_opportunity_project_code": "1007433",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.9307222,
  //       "bridge_opportunity_gps_longitude": 29.6403611,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 7,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1529m, Cell:Rusumo-Cyome, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Gatumba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 2m.-The proposed bridge span is approximately 15m.-The level difference between two banks is approximately 0.1m(Almost the same).-The space for foundation is sufficient for one side and not sufficient for the other side.-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient (",
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9307222,
  //       "proposed_bridge_location_gps_longitude": 29.6403611,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "No back stay distance as the bridge is close to the vehicle road, there are 4 meters between bridge and road .",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EXAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Rusekera",
  //       "bridge_opportunity_project_code": "1007486",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.451815,
  //       "bridge_opportunity_gps_longitude": 29.43508667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 780,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2107m, Cell:Kizimyamuriro-Bushigishigi, Injuries/Death--Many peoples were injured while trying to cross/ -2 peoples died while trying to cross Cross river on a normal day-150-300 people, Nearby city centers--Kizimyamuriro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.3m.-The space for foundation is sufficient for both sides. -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.451815,
  //       "proposed_bridge_location_gps_longitude": 29.43508667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 23,
  //       "flood_duration_during_rainy_season": "23 times In April and September, 3 hours for people to be able to cross again",
  //       "market_access_blocked_by_river": "Markets, farms",
  //       "education_access_blocked_by_river": "Primary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, meal, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The population to be served was estimated by the local people with their village leaders",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58.8,
  //       "height_differential_between_banks": 2.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FOAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabaranga",
  //       "bridge_opportunity_project_code": "1014600",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.29153,
  //       "bridge_opportunity_gps_longitude": 30.05912,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 568,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.29153,
  //       "proposed_bridge_location_gps_longitude": 30.05912,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-nyamata",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community needs avehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHAlAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kidandari",
  //       "bridge_opportunity_project_code": "1007437",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.6695278,
  //       "bridge_opportunity_gps_longitude": 29.5934722,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1775m, Cell:Mutanda, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day->600 people, Nearby city centers--Kidandari -Tubungo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 32m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is a possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6695278,
  //       "proposed_bridge_location_gps_longitude": 29.5934722,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Roads under construction by Giciye hydro power plant project at the exact site needed a bridge. In 400m there is a requested too.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatovu",
  //       "bridge_opportunity_project_code": "1007441",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.6911944,
  //       "bridge_opportunity_gps_longitude": 29.5574167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 14,
  //       "bridge_opportunity_individuals_directly_served": 3065,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2057m, Cell:Nkomane, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Jomba -Kabaya, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 25m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is a possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is sandy soil for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6911944,
  //       "proposed_bridge_location_gps_longitude": 29.5574167,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 6,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Kabaya,gasiza and nyabihu tea factory",
  //       "education_access_blocked_by_river": "Gitebe primary and secondary school",
  //       "health_access_blocked_by_river": "Jomba health center",
  //       "other_access_blocked_by_river": "Protestants and Catholic churches",
  //       "primary_occupations": "Students and teachers, farmers and workers in tea plantation",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze- Mukamira -Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasaso",
  //       "bridge_opportunity_project_code": "1007442",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.6331111,
  //       "bridge_opportunity_gps_longitude": 29.4766111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2363m, Cell:Busoro, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Jenda, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 26m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is a possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two elevated areas.-The soil from the site is sandy soil for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Very short timber bridge with inadequate space for anchors. Existing timber bridge touches the edge of the road. Nearest feasible centerline is 600 & 700 meters upstream within 400 meters of an all weather crossing.",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nama",
  //       "bridge_opportunity_project_code": "1007449",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.6798,
  //       "bridge_opportunity_gps_longitude": 29.51732,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 850,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1852m, Cell:Mutanda, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Kidandari, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 28m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is a possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6798,
  //       "proposed_bridge_location_gps_longitude": 29.51732,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1. km",
  //       "days_per_year_river_is_flooded": 6,
  //       "flood_duration_during_rainy_season": "The river floods in April and can last for 1 day",
  //       "market_access_blocked_by_river": "Gasiza market and kabaya market, farmers and workers in tea plantation",
  //       "education_access_blocked_by_river": "Kibihekane, Rambura primary and secondary school, kibisabo secondary 3",
  //       "health_access_blocked_by_river": "Rambura health center",
  //       "other_access_blocked_by_river": "Parish Rambura, Adventist of Seven days and Protestants church",
  //       "primary_occupations": "Tea plantation, students and teachers and farmers on both sides",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 15,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river . Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze_Mukamira _Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EnAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamutukura",
  //       "bridge_opportunity_project_code": "1007450",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.61806,
  //       "bridge_opportunity_gps_longitude": 29.47252,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 11,
  //       "bridge_opportunity_individuals_directly_served": 1610,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2401m, Cell:Rurengeri, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Jenda, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 35m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between two flat areas.-The soil from the site is volcanic clay for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61806,
  //       "proposed_bridge_location_gps_longitude": 29.47252,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Kora and Mukamira market",
  //       "education_access_blocked_by_river": "Jenda Primary and secondary school",
  //       "health_access_blocked_by_river": "Jenda health center",
  //       "other_access_blocked_by_river": "Adventist of Seven days and Protestants churches",
  //       "primary_occupations": "Students and teachers, traders in kora market",
  //       "primary_crops_grown": "cow, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "1 died in 10 years ego , due to slipping on timber and fall in the river",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require the community to cross the river. Community leaders helped giving the number of the people in their villages",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EoAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinoni",
  //       "bridge_opportunity_project_code": "1007451",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.67984,
  //       "bridge_opportunity_gps_longitude": 29.51707,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 3821,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2201m, Cell:Rurengeri, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Jenda, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 20m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between a hill and a flat area.-The soil from the site is volcanic soil for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67984,
  //       "proposed_bridge_location_gps_longitude": 29.51707,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "800 m",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Byangabo, tea plantation workers,",
  //       "education_access_blocked_by_river": "Rwankeri primary and secondary school,",
  //       "health_access_blocked_by_river": "Rwankeri health center",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Students and teachers, workers in Nyabihu tea plantation and traders at Byangabo market",
  //       "primary_crops_grown": "maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which requires them to cross the river. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 34.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabirundwe",
  //       "bridge_opportunity_project_code": "1014092",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.5886,
  //       "bridge_opportunity_gps_longitude": 29.05452,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1852,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.5886,
  //       "proposed_bridge_location_gps_longitude": 29.05452,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 26,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Rusizi market and kamembe market",
  //       "education_access_blocked_by_river": "TTC mururu",
  //       "health_access_blocked_by_river": "Rusizi health center",
  //       "other_access_blocked_by_river": "ADPR",
  //       "primary_occupations": "Farming and business",
  //       "primary_crops_grown": "tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Bugayi village don't have access to kamembe market and kagarama village don't have access to rusizi market. Information gathered from local",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murambi",
  //       "bridge_opportunity_project_code": "1007452",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.67991,
  //       "bridge_opportunity_gps_longitude": 29.46661,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 14,
  //       "bridge_opportunity_individuals_directly_served": 2290,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2421m, Cell:Mutaho, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-< 50 people, Nearby city centers--Mutaho, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-1-2 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 20m.-The level difference between two banks is approximately the same.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is a possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two elevated areas.-The soil from the site is hard rock for both sides. ?previously recorded GPS Incorrect(-6.6627778, 29.4730278);unable to find the correct precise location of the bridge site,but the approximate location is (-1.69535°,29.46504°) found by adding Rwanda Topographic Map to ArcMap and calculating the value of points x and y of the attribute table\"",
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67991,
  //       "proposed_bridge_location_gps_longitude": 29.46661,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "The river floods in April and December, and it can last 1 day to cross the river safely",
  //       "market_access_blocked_by_river": "Community on right side of the river is blocked to Gasiza market and the left side communities are blocked to Kora market, Nyabihu tea plantations workers",
  //       "education_access_blocked_by_river": "Communities on right side of the river are blocked to primary school of Nyiragakokora which is the only primary school near the communities and Rutazigurwa secondary school .Rugamba secondary school on the right side is blocked as their are students who cross the river to attend that sec.school on their preferences",
  //       "health_access_blocked_by_river": "Communities on right side of the river are blocked to Nyiragikokora health center",
  //       "other_access_blocked_by_river": "Protestants and Adventist church of Seven days are blocked on the communities of the right side of the river ,Accessing Rambura sector office and Playground for entertainment facilities are blocked by the river",
  //       "primary_occupations": "Most common occupations in the communities are farmers (mostly potatoes), tea plantations workers, and cattle farmers",
  //       "primary_crops_grown": "cattl, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Two died trying to cross the river and slided on logs and fell into the river, while 4 were broken a leg or an arm and their luggage were taken away by water",
  //       "notes_on_social_information": "Rambura sector office (community 2,3,4),Rugamba secondary school (community2 ,3,4),Gasiza market (community, 3, 4) ,Rutazigurwa secondary school (community 1), playground (community2, 3,4). Population information for each village was provided by the village leader of the respective villages who sourced the population information from the village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EqAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Biryogo",
  //       "bridge_opportunity_project_code": "1007454",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.367991,
  //       "bridge_opportunity_gps_longitude": 30.288805,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 11718,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1349m, Cell:Rurenge-Gakirage, Injuries/Death-Many peoples injured while trying to cross the river/ More than 5 peoples died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Biryogo -Rukomo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 65m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.367991,
  //       "proposed_bridge_location_gps_longitude": 30.288805,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Communities 1 don't have access to Rice farms , Gakirage and Mimuli markets and community 2 don't have access to to Rukoma market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Rurenge secondary school and communities 1 don't have access to Cyonyo Primary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Nyagatare Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers and workers in Rice plantation farms, Traders at Rukomo, Gakirage, and Mimuli markets",
  //       "primary_crops_grown": "maiz, rice farms on a large scal, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "6 people fell and drowned trying to cross the river when it was flooded while 20 fell into the river but fortunately none died among those",
  //       "notes_on_social_information": "Rice farms on a large scale ( Community 1), Rukomo market which is open twice a week ( Community 2), Gakirage and Mimuli market which is open twice a week ( Community ), Rurenge secondary school ( Community ) Cyonyo Primary school ( Community 1), Nyagatare Hospital ( Community ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 63,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ubumwe",
  //       "bridge_opportunity_project_code": "1007457",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.42439,
  //       "bridge_opportunity_gps_longitude": 30.26354,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 20,
  //       "bridge_opportunity_individuals_directly_served": 5487,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1361m, Cell:Gahurura-Karugari, Injuries/Death-Many peoples injured while trying to cross the river/ More than one person died while trying to cross the river. Cross river on a normal day-< 50 people, Nearby city centers--Cyabayaga -Kirenge, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-2-6 hours,Hours walking to reach Secondary School-2-6 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.42439,
  //       "proposed_bridge_location_gps_longitude": 30.26354,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "6 km",
  //       "days_per_year_river_is_flooded": 210,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 day",
  //       "market_access_blocked_by_river": "Mimuri market (Community 4,5), Rukomo (Community 1,2,3), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Cyabayaga Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Mimuri Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "ADEPR Rugari church (Community 4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, sugarcan, tomato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "2 people died at this crossing point and 3 were seriously injured.",
  //       "notes_on_social_information": "Ubumwe, Isangano, Nteko, Busasamana, No1 and Ruyonza villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Rugari Cell Leader and the Ubumwe village leader, Augustin Kamana from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Not enough backspace on behind the left side tower and erosion on both sides of the river.",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamate",
  //       "bridge_opportunity_project_code": "1007459",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.2991944,
  //       "bridge_opportunity_gps_longitude": 30.2575833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1382m, Cell:Nyabitekeri, Injuries/Death-No person injured while trying to cross the river/ one person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Tabagwe -Nyabitekeri, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 34m.-The level difference between two banks is 0.3m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.2991944,
  //       "proposed_bridge_location_gps_longitude": 30.2575833,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Road was upgraded by VUP project, a safe vehecular bridge is on site already",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86ExAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mirambi",
  //       "bridge_opportunity_project_code": "1007460",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.296011,
  //       "bridge_opportunity_gps_longitude": 30.247121,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1393m, Cell:Nyabitekeri, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Nyabitekeri, Crossing River now-Walking through river / Banyura mumaziSimple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not abvailable / Ntibihaboneka.,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 45m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing any sign of erosion and it is located between flat areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.296011,
  //       "proposed_bridge_location_gps_longitude": 30.247121,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Communities needs a vehicular bridge , small vehicles passes",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86EyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mwishyogwe",
  //       "bridge_opportunity_project_code": "1007467",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.484,
  //       "bridge_opportunity_gps_longitude": 29.4196111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2145m, Cell:Rugogwe, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kizimyamuriro -Rugarika, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86F5AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarusengesi",
  //       "bridge_opportunity_project_code": "1007468",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.287455,
  //       "bridge_opportunity_gps_longitude": 29.434438,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1736m, Cell:Buteteri, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Rwimpiri -Mukongoro, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.04m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.287455,
  //       "proposed_bridge_location_gps_longitude": 29.434438,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyamagabe",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Hydro dam is planned to be constructed near the bridge (-2.28747, 29.433537)",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86F6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyimbogo",
  //       "bridge_opportunity_project_code": "1007474",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.2875833,
  //       "bridge_opportunity_gps_longitude": 29.4333889,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1728m, Cell:Buteteri-Musaraba, Injuries/Death-Many peoples injured while trying to cross the river/ 2 peoples died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Rwimpiri -Mukongoro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 42m.-The level difference between two banks is 0.3m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyamagabe",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Hydro dam is planned to be constructed near the bridge (-2.28747, 29.433537)",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamugari",
  //       "bridge_opportunity_project_code": "1007476",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.4912778,
  //       "bridge_opportunity_gps_longitude": 29.4210278,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2151m, Cell:Rugogwe, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kizimyamuriro -Rugarika -Subukiriro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.03m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Shaki",
  //       "bridge_opportunity_project_code": "1007487",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.391707,
  //       "bridge_opportunity_gps_longitude": 29.435709,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 13,
  //       "bridge_opportunity_individuals_directly_served": 1985,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1978m, Cell:Rusekera-Mukongoro, Injuries/Death--Many peoples were injured while trying to cross/ -No person died while trying to cross Cross river on a normal day-300-600 people, Nearby city centers--Shaki -Musebeya, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately5m.-The proposed bridge span is approximately 32m.-The level difference between two banks is 0.03m.-The space for foundation is sufficient for both sides. -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between an elevated area and a flat area.-The soil from the site is silt for both sides",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.391707,
  //       "proposed_bridge_location_gps_longitude": 29.435709,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "From february to April, after 12 hour",
  //       "market_access_blocked_by_river": "Markets blocked by river are mushubi on The LHS, musebeya market on the RHS., river block the farming on both side of river.",
  //       "education_access_blocked_by_river": "River block the students on the LHS of river for going to schools on the RHS of river , those schools are Gasekera primary school and VTC Musebeya",
  //       "health_access_blocked_by_river": "The river block the people from LHS for the health service at musebeya health center, and the people from The RHS are blocked to the Gugege and Mushubi health center.",
  //       "other_access_blocked_by_river": "The police station service blocked on the RHS of river, the people from The RHS are blocked for potable water in Kageyo, the people on the RHS of river are also blocked for supplying thee to the Mushubi thee factory.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One fell down and fractured and caused her to die, another fell down and teeth broken.",
  //       "notes_on_social_information": "Meeting with local people and village leader of two village near the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FPAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuga",
  //       "bridge_opportunity_project_code": "1007479",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.45674667,
  //       "bridge_opportunity_gps_longitude": 29.43966667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 3448,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2040m, Cell:kibyagira-Bushigishigi, Injuries/Death--Many peoples were injured while trying to cross/ -More than 3 peoples died while trying to cross Cross river on a normal day-300-600 people, Nearby city centers--Kibyagira -Bushigishigi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately15m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient for both sides. -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45674667,
  //       "proposed_bridge_location_gps_longitude": 29.43966667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "6 hours after rainfall, April and May",
  //       "market_access_blocked_by_river": "Market, farming",
  //       "education_access_blocked_by_river": "Secondary school",
  //       "health_access_blocked_by_river": "Health center",
  //       "other_access_blocked_by_river": "Government offiices",
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "All people who fall into the river they die according to the local people that's why they don't have injuries",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabingo",
  //       "bridge_opportunity_project_code": "1007480",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.395728,
  //       "bridge_opportunity_gps_longitude": 29.427631,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 2380,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1997m, Cell:Mukongoro-Gifurwe, Injuries/Death--Many peoples were injured while trying to cross/ -No person died while trying to cross Cross river on a normal day-150-300 people, Nearby city centers--Mukongoro -Shaki, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately10m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 1m.-The space for foundation is sufficient for both sides. -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between an elevated area and a flat area.-The soil from the site is silt for one side and rock for the other side.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.395728,
  //       "proposed_bridge_location_gps_longitude": 29.427631,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "From February to May, the flood last 3 hours",
  //       "market_access_blocked_by_river": "Musebeya is blocked for Gatare and Ruganda market is also blocked for buruhukiro people",
  //       "education_access_blocked_by_river": "Gikungu primary school is blocked for buruhukiro students and Gifurwe primary school is blocked for Gatare student",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Farms in shaki are blocked to the Gatare communities.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People near the bridge and Gifurwe cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": 1.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murwa",
  //       "bridge_opportunity_project_code": "1007482",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.39084,
  //       "bridge_opportunity_gps_longitude": 29.57068,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 55,
  //       "bridge_opportunity_individuals_directly_served": 3057,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1586m, Cell:Mutiwingoma-Bwenda, Injuries/Death--Many peoples were injured while trying to cross/ -One person died while trying to cross Cross river on a normal day-300-600 people, Nearby city centers--Rugarama -Kabuga, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient for both sides. -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.39084,
  //       "proposed_bridge_location_gps_longitude": 29.57068,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 210,
  //       "flood_duration_during_rainy_season": "30 times in April, May, October, November, December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, beans, animal keeping",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market of miko( Murwa, Nyamirama, Murambi, Nyagatovu, Munyinya and Kanyege) Market of Rugarama( Nyamirama, Muduha) Primary and Secondary schools (Nyamirama, and Muduha) Health Center Kibumbwe (Nyamirama and Muduha) Health Center of Ngara ( Murwa, Nyamirama, Murambi, Nyagatovu, Munyinya and Kanyege) The villages of Muduha and Nyamirama are using this crossing for the access to health center, Markets and primary and secondary. Therefore, their population are included in the total population to be served. These social survey numbers were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33.8,
  //       "height_differential_between_banks": 2.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwankango",
  //       "bridge_opportunity_project_code": "1007483",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.259663,
  //       "bridge_opportunity_gps_longitude": 29.592431,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 27,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1531m, Cell:Masizi, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Masizi -Rwankuba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.259663,
  //       "proposed_bridge_location_gps_longitude": 29.592431,
  //       "current_crossing_method": "Vehicular bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is vehicular bridge constructed in May, 2017",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwamataba",
  //       "bridge_opportunity_project_code": "1007484",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.47437333,
  //       "bridge_opportunity_gps_longitude": 29.488816,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 3554,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1972m, Cell:Uwindekezi-Munyege, Injuries/Death-Many peoples injured while trying to cross the river/ One person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers-Gasarenda, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 0.005m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between Flood areas.-The soil from the site is clay for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.47437333,
  //       "proposed_bridge_location_gps_longitude": 29.488816,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "20 times April, May, November and December and it lasts 3 days",
  //       "market_access_blocked_by_river": "Market of Gasarenda, local commercial center",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health center and Hospital of Kigeme",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming(Large beans farm, maize, potatoes, tea); local commerce in commercial center",
  //       "primary_crops_grown": ", bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market Gasarenda(Uwamataba, Mugote, Birembo, Gatovu) Primary and Secondary schools(Kimina, Nyarurambi) Health Center and Hospital of Kigeme(Kimina, Nyarurmbi) The numbers of people directly served and the sorounding communities were given by the local people and their leaders based on the monthly census which is done in every cell. Mugote village and Nyarurambi village can use this crossing and their people have been included in the total population.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40.8,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarurambi",
  //       "bridge_opportunity_project_code": "1007485",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": 2.4724,
  //       "bridge_opportunity_gps_longitude": 29.5,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 3523,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1966m, Cell:Munyege, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers-Gasarenda, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 0.005m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between Flood areas.-The soil from the site is clay for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": 2.4724,
  //       "proposed_bridge_location_gps_longitude": 29.5,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "20 in April, May, November and December",
  //       "market_access_blocked_by_river": "Market of Gasarenda, local commercial center",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center and Hospital of Kigeme",
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Farming: large beans farms, maize, potatoes",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market of Gasarenda(Birembo, Mugote, Gatovu, Uwamataba) Primary and Secondary schools(Nyarusanbi, Kimina) Health Center and Hospital of Kigeme (Nyarurambi, Kimina) The numbers of people directly served and the sorounding communities were given by the local people and their leaders based on the monthly census which is done in every cell. The village of Uwamataba usually uses this crossing and their people were included in the total population",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42.2,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FNAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muzirantwago",
  //       "bridge_opportunity_project_code": "1007488",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.428413,
  //       "bridge_opportunity_gps_longitude": 29.577879,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 11,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1717m, Cell:bugarura-Nyanza, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Kibingo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between Flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.428413,
  //       "proposed_bridge_location_gps_longitude": 29.577879,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "15 kilometers",
  //       "days_per_year_river_is_flooded": 9,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Markets, church, farms",
  //       "education_access_blocked_by_river": "Primary school, secondary school",
  //       "health_access_blocked_by_river": "Health center available on both sides but they prefer to cross river for quality service in Gitwa village",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Land farming",
  //       "primary_crops_grown": ", bean, coffe, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 15,
  //       "incident_descriptions": "Person coming from the market sliped on the bridge and drowned",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyamagabe",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi road",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 94.5,
  //       "height_differential_between_banks": 1.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyabagomba",
  //       "bridge_opportunity_project_code": "1007489",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.296023,
  //       "bridge_opportunity_gps_longitude": 29.557358,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 22,
  //       "bridge_opportunity_individuals_directly_served": 403,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1609m, Cell:Jenda, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Musange, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 45m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.296023,
  //       "proposed_bridge_location_gps_longitude": 29.557358,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": 3.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FRAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu",
  //       "bridge_opportunity_project_code": "1007490",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.43993333,
  //       "bridge_opportunity_gps_longitude": 29.51594167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1837m, Cell:Gashiha, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers-Gasharu, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between Flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.43993333,
  //       "proposed_bridge_location_gps_longitude": 29.51594167,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "A vehicle bridge is currently under construction at this exact site.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FSAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakabingo",
  //       "bridge_opportunity_project_code": "1007492",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.298329,
  //       "bridge_opportunity_gps_longitude": 29.459225,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1660m, Cell:Cyobe, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Kizanganya, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is clay for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "There is vehicular bridge which has constructed by government officials, however it has been deteriorated. And the cell leader confirms it.",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Cell leader",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FUAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagisumo",
  //       "bridge_opportunity_project_code": "1007493",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.337289,
  //       "bridge_opportunity_gps_longitude": 29.459825,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 11,
  //       "bridge_opportunity_individuals_directly_served": 2244,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1859m, Cell:Cyobe, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Mushubi -Peru, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 9m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.003m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.337289,
  //       "proposed_bridge_location_gps_longitude": 29.459825,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "The river floods in April, May, and from September to November, after 1hours the people can cross the river",
  //       "market_access_blocked_by_river": "Mushubi market is blocked for the people from the LHS of river",
  //       "education_access_blocked_by_river": "Mushubi primary and secondary schools are blocked from the students from LHS and nyagisumo primary school is blocked to the RHS students",
  //       "health_access_blocked_by_river": "Only Mushubi health center is blocked for the people from the cyobe community which is on LHS of river",
  //       "other_access_blocked_by_river": "Places of worship in Mushubi are blocked by river",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Drowned trying to cross the river.",
  //       "notes_on_social_information": "Village and near by people msetinf",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamurinda",
  //       "bridge_opportunity_project_code": "1007496",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.43885,
  //       "bridge_opportunity_gps_longitude": 29.56909,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 1050,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1757m, Cell:bugarura, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Gataba, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 38m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between Flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.43885,
  //       "proposed_bridge_location_gps_longitude": 29.56909,
  //       "current_crossing_method": "They cross it by jumping the river when it is low otherwise they don't cross",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometres far away",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Market, factories, construction sites, farms,",
  //       "education_access_blocked_by_river": "Primary school, secondary school, training center",
  //       "health_access_blocked_by_river": "Health centers",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Land farm, coffee washing plant, bricks production",
  //       "primary_crops_grown": "bean, coffe, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Most of the time they fall into the river while trying to jump over it",
  //       "notes_on_social_information": "Local people were gathered and health official from cell was present and knew the total population of the cell and the local people estimated how many people of each village to be served",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi road",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 68,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FYAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasagara",
  //       "bridge_opportunity_project_code": "1007498",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.286972,
  //       "bridge_opportunity_gps_longitude": 29.607523,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 30,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1529m, Cell:Masangano, Injuries/Death-Many peoples injured while trying to cross the river/ Two peoples died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Masangano, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 120m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.286972,
  //       "proposed_bridge_location_gps_longitude": 29.607523,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community need only the vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kasemanyana",
  //       "bridge_opportunity_project_code": "1007500",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.312785,
  //       "bridge_opportunity_gps_longitude": 29.559739,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 2628,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1678m, Cell:Murambi, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Kaduha, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-1-2 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 27m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.312785,
  //       "proposed_bridge_location_gps_longitude": 29.559739,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "From March to May, and december, it take 12 hours",
  //       "market_access_blocked_by_river": "Market ( villages 1,2), farms (1,2,3,4)",
  //       "education_access_blocked_by_river": "Primary school( villages 1,2,3,4)",
  //       "health_access_blocked_by_river": "Health center(villages 1,2)",
  //       "other_access_blocked_by_river": "Churches (villages 1,2,3,4), football terrain (villages 3,4), government services (villages 1,2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, maiz, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They were going to school, fell down and drowned",
  //       "notes_on_social_information": "The population information of each village was given by Murambi cell leader, Aimable Nsengimana, who sourced them from the cell officials record of ubudehe program in 2018. The population of all adjacent communities includes the following villages: Kasemanyana, Kibiraro, Rebero, Kivumu and Nyaruryango. The community members of Kivumu and Nyaruryango sometimes cross the river to visit the market, to do farming, and to visit the relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagbe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusave",
  //       "bridge_opportunity_project_code": "1007502",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.321754,
  //       "bridge_opportunity_gps_longitude": 29.44854,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 4,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Cell:Cyobe, Cross river on a normal day-150-300 people, Nearby city centers-Peru, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-,Travel to nearest safe bridge/river crossing-,Hours walking to reach the Hospital-,Hours walking to reach the Health Center-,Hours of walking to reach the market-,Hours walking to reach Primary School-,Hours walking to reach Secondary School-,Hours walking to reach the Church-,Land within 50m of river bank-,Soil-,Sand-,Gravel-,Stone-,Timber-,Stone provided by-,Sand Provided by-,Gravel provided by-,Timber provided by-,Cement provided by-,Reinforcement steel provided by-,Land ownership-, Land ownership permission-, General Comments",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.321754,
  //       "proposed_bridge_location_gps_longitude": 29.44854,
  //       "current_crossing_method": "There is Vehicular bridge on rusave river, and it accessible for truck,",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge at the river",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwumba",
  //       "bridge_opportunity_stage": "Rejected",
  //       "bridge_opportunity_project_code": "1007503",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.32834,
  //       "bridge_opportunity_gps_longitude": 29.44182,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 4,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Cell:Cyobe, Cross river on a normal day-150-300 people, Nearby city centers-Peru, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-1-2 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Sand Provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Gravel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Timber provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.32834,
  //       "proposed_bridge_location_gps_longitude": 29.44182,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitega",
  //       "bridge_opportunity_project_code": "1007505",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.280226,
  //       "bridge_opportunity_gps_longitude": 29.603769,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1531m, Cell:Masangano-Kadaho, Bridge would connecting Nyamagabe-Nyanza, Injuries/Death-Many peoples injured while trying to cross the river/ Two peoples died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--kanombe, Crossing River now-Walking through river / Banyura mumaziSwim / Baroga, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 100m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is sandy for both sides. 650 from Buheta cell that need to go to Buheta health center as Adjacent community.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.280226,
  //       "proposed_bridge_location_gps_longitude": 29.603769,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is beyond the engineering",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 300,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitwa~Nyagacaca",
  //       "bridge_opportunity_project_code": "1007509",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.275825,
  //       "bridge_opportunity_gps_longitude": 29.217288,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 2225,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1494m, Cell:Mutongo, Injuries/Death-Many peoples injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Macuba -Bisheke, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 6m.-The proposed bridge span is approximately 45m.-The level difference between two banks is approximately 7m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient (",
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.275825,
  //       "proposed_bridge_location_gps_longitude": 29.217288,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to April, October to December, 48 hours",
  //       "market_access_blocked_by_river": "Communities 3&4 are blocked to Gatare market, Communities 1&2 are blocked to karengera market, communities 3&4 do not have access to Rugari cows market. Communities 1&2 do not have access to farm in Muhororo community, communities 3&4 are blocked to farm in gitwa community.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to karengera secondary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to karengera health center.",
  //       "other_access_blocked_by_river": "Communities do not have access to sector office, communities 1&2 are blocked to church in cyampindu.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, ric, sugar can, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by the cyamindu cell leader and Gitwa village leader, Hakizimana Damien and mukakayumba Cecile, who sourced the data from cell register i in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 62,
  //       "height_differential_between_banks": 4.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugonero",
  //       "bridge_opportunity_project_code": "1007517",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.19384,
  //       "bridge_opportunity_gps_longitude": 29.27192,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 13,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1474m, Cell:Kibingo-Kagarama, Injuries/Death-Many peoples were injured while crossing the river./ 1 person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Mugonero -Mahembe -Gabiro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of 4m.-The proposed bridge span is approximately 25m.-The level difference between two banks is approximately 0.05m(almost the same)-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient (>Span/25).-There is no confluence area near the place.-The river bed at this site is unstable, there is a possibility of erosion.-The bank profile of the site is showing a sign of erosion and it is located between two flood areas.-The soil from the site is clay for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.19384,
  //       "proposed_bridge_location_gps_longitude": 29.27192,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The nearest crossing is less than three hundred meters ( it near the road Nyamasheke ~ karongi , the community will use the vehicular bridge to cross)",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musumba~ Rugano",
  //       "bridge_opportunity_project_code": "1007518",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.313353,
  //       "bridge_opportunity_gps_longitude": 29.214397,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 20,
  //       "bridge_opportunity_individuals_directly_served": 2237,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Cell:Nyakabingo, Injuries/Death-There are different people died by that river/ I remember 4 persons Cross river on a normal day-150-300 people, Nearby city centers-Groupe scolaire Rugano, Ep Mwasa, Centre Nyakabingo, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Timber-Not abvailable / Ntibihaboneka.,Stone provided by-District/ Akarere,Sand Provided by-Cell/ akagari,Gravel provided by-Sector/ umurenge,Timber provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments",
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.313353,
  //       "proposed_bridge_location_gps_longitude": 29.214397,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 kilometers",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "March to May, October to November, 12 hours",
  //       "market_access_blocked_by_river": "Communities 1&2 do not have access to Gatare market and bitare market. Communities 1 and 2 are blocked to farms in rugano and mugohe villages, communities 3&4 are blocked to farms in bugarama village and Macuba.",
  //       "education_access_blocked_by_river": "Villages 1&2 do not have access to Rugano (primary and secondary) school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to Gatare health center and Mubuga dispensary.",
  //       "other_access_blocked_by_river": "Communities 1&2 do not have access to Catholic church in Rugano villages.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": ", coffe",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by Bugarama village leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyamasheke",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kubisheke",
  //       "bridge_opportunity_project_code": "1007520",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.282545,
  //       "bridge_opportunity_gps_longitude": 29.208913,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 2118,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Cell:Gatare, Injuries/Death-hakunda kuba impanuka nyinshi/ mugihe nibuka hapfiriye umugore n'umugabo, n'abandi umuntu aba atamenye amakuru Cross river on a normal day-50-150 people, Nearby city centers-Masasu; Ngange; E.P Murambi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Cell/ akagari,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments",
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.282545,
  //       "proposed_bridge_location_gps_longitude": 29.208913,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge three kilometers away.",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 48 hours",
  //       "market_access_blocked_by_river": "Communities 3&4 do not have access to Rugari market, communities 1&2 are blocked to karengera market. Communities 1&2 and 3&4 do not have access to farms in kubisheke river valley.",
  //       "education_access_blocked_by_river": "Communities 3&4 do not have access to Mutongo primary school, communities 1&2 are blocked to karengera( primary school and secondary school), communities 1&2 kimindu primary school.",
  //       "health_access_blocked_by_river": "Communities 3&4 Gatare health center.",
  //       "other_access_blocked_by_river": "Communities 1&2 do not have access to church in cyamindu.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, ric, sugar can",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by the cyamindu cell leader, Mukakayumba Cecile, who sourced the population information from cell record in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karamba",
  //       "bridge_opportunity_project_code": "1007521",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.284299,
  //       "bridge_opportunity_gps_longitude": 29.196849,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 3433,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Cell:Mutongo, Injuries/Death-Uyu mugezi wishe abantu benshi, abanyeshuri n'abarimu/ uruzi rwaruzuye bagerageza kwabuka kubiti byariho amazi arabakubita baragenda Cross river on a normal day-150-300 people, Nearby city centers-E.P Mutongo; Kanyenkondo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-marsh (papyrus, marsh grasses, etc.) / igishanga,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Cell/ akagari,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.284299,
  //       "proposed_bridge_location_gps_longitude": 29.196849,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Four hundred meters away.",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 12 hours",
  //       "market_access_blocked_by_river": "Community 1 do have access to Rugari market , communities 2&3 are blocked to Gatare market. Both communities 1, 2 and 3 are blocked to the farms in each side of river, especially in kirimbi and Ntangara Mashland.",
  //       "education_access_blocked_by_river": "Communities 2&3 do not have access to Mutongo primary school.",
  //       "health_access_blocked_by_river": "Communities 2&3 do not have access to Gatare health center.",
  //       "other_access_blocked_by_river": "Community 1 do have access to the HANIKA CHURCH. Community 2 do not have access to Mutongo cell office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, pineappl, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Mutongo cell leader who sourced the the population population information from cell register done in 2018. The population of all adjacent communities includes the following villages Nyabihanga, karamba and Rwamiko. The community members from rwamiko village sometimes use the bridge to go to the market at Gatare and to the health center.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": 2.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyankunamirwa",
  //       "bridge_opportunity_project_code": "1007523",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.28014,
  //       "bridge_opportunity_gps_longitude": 29.72578,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 1801,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1668m, Cell:Mpanga-Kiruri, Injuries/Death--No person injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Kabuga -Birembo -Nyanza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 5m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between elevated area and flat area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.28014,
  //       "proposed_bridge_location_gps_longitude": 29.72578,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "In March, April and May; in September and October. It does last for a day",
  //       "market_access_blocked_by_river": "Ruhango and Buhanda Market blocked for communities on the RHS , Nyanza market blocked for communities on the LHS",
  //       "education_access_blocked_by_river": "Kaganza A Primary School blocked for communities on LHS , Mpanga Primary School blocked for communities on the RHS",
  //       "health_access_blocked_by_river": "Gatagara Health Centre blocked for communities on LHS",
  //       "other_access_blocked_by_river": "Mpanga Prison blocked for communities on the RHS",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86FzAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Macigati",
  //       "bridge_opportunity_project_code": "1007527",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.30422,
  //       "bridge_opportunity_gps_longitude": 29.65685,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 22,
  //       "bridge_opportunity_individuals_directly_served": 456,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1596m, Cell:Nyarurama, Injuries/Death--No person injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers-Cyabakamyi, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is sandy for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.30422,
  //       "proposed_bridge_location_gps_longitude": 29.65685,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "0.5 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "In April and May, in September and October; it last for 2 hours",
  //       "market_access_blocked_by_river": "Buhanda Market blocked for people on the LHS and Gashyushya Market blocked for people on the RHS",
  //       "education_access_blocked_by_river": "Cyabakamyi Primary and secondary school blocked for people on the RHS",
  //       "health_access_blocked_by_river": "Nyarurama Health center blocked for people on the RHS",
  //       "other_access_blocked_by_river": "Football pitch blocked for people on the LHS and Nyarurama Cell Office blocked for people on the RHS",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking different village leaders",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86G3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kumagare",
  //       "bridge_opportunity_project_code": "1007531",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.935831,
  //       "bridge_opportunity_gps_longitude": 30.051385,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 380,
  //       "bridge_opportunity_individuals_directly_served": 48588,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1370m, Cell:Nyabugogo-Karurimbura, Bridge would connecting Nyarugenge-Gasabo, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers-Nyabugogo, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Timber-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 410m.-The level difference between two banks is 2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat area and an elevated area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.935831,
  //       "proposed_bridge_location_gps_longitude": 30.051385,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "12 kilometers",
  //       "days_per_year_river_is_flooded": 360,
  //       "flood_duration_during_rainy_season": "Always flooded but they use boats",
  //       "market_access_blocked_by_river": "Nyabugogo Market (Gisozi), gisozi carpentry workshop (Muhima)",
  //       "education_access_blocked_by_river": "Muhima primary and secondary school (Gisozi), ULK university (Muhima)",
  //       "health_access_blocked_by_river": "Health center and hospital Muhima (Gisozi)",
  //       "other_access_blocked_by_river": "Taxi park Nyabugogo (Gisozi)",
  //       "primary_occupations": "Market, school, taxi park",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who use the boats to help people to cross the river",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kinamba Nyabugogo",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "More than 400 meter of span and they use boat",
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86G7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwinteko",
  //       "bridge_opportunity_project_code": "1007532",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.761531,
  //       "bridge_opportunity_gps_longitude": 29.494368,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 22,
  //       "bridge_opportunity_individuals_directly_served": 4221,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1966m, Cell:Shororo, Injuries/Death-Many peoples injured while trying to cross the river/ More than 3 peoples died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Gatunda -Uwinteko, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.761531,
  //       "proposed_bridge_location_gps_longitude": 29.494368,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "60times in April, May, October, November and December and it lasts for 4hours after rainfall",
  //       "market_access_blocked_by_river": "Uwinteko village doesn't have access to Gatunda market Rutabo, Rukinga villages don't have access to Uwinteko market( Market for domestic animals)",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Bukinga, Rutabo villages don't have access to Munini Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, beans, charcoal production",
  //       "primary_crops_grown": "bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell of the sector",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35.8,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86G8AAI",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Cyivugiza",
  //       "bridge_opportunity_project_code": "1007534",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7791667,
  //       "bridge_opportunity_gps_longitude": 29.464333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 23,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2209m, Cell:Remera-Uwumusebeya, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Gisanze -Remera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 48m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion.-The soil from the site is silt for one side and hard rock for other side",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7791667,
  //       "proposed_bridge_location_gps_longitude": 29.464333,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is a dam under construction on this site",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bihembe",
  //       "bridge_opportunity_project_code": "1007536",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.69544,
  //       "bridge_opportunity_gps_longitude": 29.45618,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 6394,
  //       "bridge_opportunity_comments": "Not Duplicate 500-1000 people directly served, Elevation:1946m, Cell:Kabere-Gihemvu, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Bihembe, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.69544,
  //       "proposed_bridge_location_gps_longitude": 29.45618,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Communities 1don't have access to Ruheru market, communities 2don't have access to to Kamirabagenzi market, communities 1don't have access to Nshili-Kivu tea factory",
  //       "education_access_blocked_by_river": "Communities2 don't have access to Nyabimata primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 2don't have access to Nyabimata Health center",
  //       "other_access_blocked_by_river": "Communities 2don't have access to Nyabimata sector and SACCO office",
  //       "primary_occupations": "Tea Plantation workers, traders at Ruheru and Kamirabagenzi market",
  //       "primary_crops_grown": "bean, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kamirabagenzi market which is open twice a week ( Community2 ), Nyabimata primary and secondary school ( Community 2), Nyabimata Parish and Bus Stop( community 2), Nyabimata Health center ( Community2 ), Tea plantations farms (Community1 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyacyondo",
  //       "bridge_opportunity_project_code": "1007537",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.62023,
  //       "bridge_opportunity_gps_longitude": 29.542442,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 4109,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1804m, Cell:Nyamabuye, Injuries/Death--No person injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Kibeho -Mata, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between a flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.62023,
  //       "proposed_bridge_location_gps_longitude": 29.542442,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 24,
  //       "flood_duration_during_rainy_season": "24 times in April, May, October, November and December and it lasts for 5 hours after rainfall",
  //       "market_access_blocked_by_river": "Nyacyondo, Rwamiko, Rwinanka villages don't have access to tea factory of NAEB Mataba, Rimbanya, Ruhunga don't have access to COOTENYA",
  //       "education_access_blocked_by_river": "Mataba, Rimbanya, Ruhunga don't have access to Rwamiko secondary school",
  //       "health_access_blocked_by_river": "Mataba, Rimbanya, Ruhunga don't have access to Nyamyumba Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Soja, tea, potatoes farming, animal keeping, Tea factory (NAEB)",
  //       "primary_crops_grown": "potato, soja, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihango",
  //       "bridge_opportunity_project_code": "1007540",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.67791,
  //       "bridge_opportunity_gps_longitude": 29.59175,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 81,
  //       "bridge_opportunity_individuals_directly_served": 4446,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1762m, Cell:Mariba, Injuries/Death-More peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Kibeho Rusenge, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.67791,
  //       "proposed_bridge_location_gps_longitude": 29.59175,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Gihango, Miko, Nyamugari, Rasaniro, Kabuye villages don't have access to Ndago market Murambi village doesn't have access to Viro and Busoro markets",
  //       "education_access_blocked_by_river": "Murambi village doesn't have access to Rasaniro Secondary school Miko and Gihango villages don't have access to Ndago and Munini Secondary schools",
  //       "health_access_blocked_by_river": "Gihango, Miko, Nyamugari, Rasaniro, Kabuye villages don't have access to Munini Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea farming, banana, charcoal production",
  //       "primary_crops_grown": "banana, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Miko village use this crossing it's people were included in the total population to be served. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33.8,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyuna",
  //       "bridge_opportunity_project_code": "1007541",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.706995,
  //       "bridge_opportunity_gps_longitude": 29.59134667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 30,
  //       "bridge_opportunity_individuals_directly_served": 5829,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1749m, Cell:cyuna, Injuries/Death-More peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Ndago, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.706995,
  //       "proposed_bridge_location_gps_longitude": 29.59134667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2.4 km",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October November and December and it lasts for 2 days after rainfall",
  //       "market_access_blocked_by_river": "Uwamuhizi, Cyuna and Remera villages don't have access to Ndago market",
  //       "education_access_blocked_by_river": "Uwamuhizi, Cyuna and Remera villages don't have access to Ndago Secondary school and Ruko Primary school",
  //       "health_access_blocked_by_river": "Uwamuhizi, Cyuna and Remera villages don't have access to Coko Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea farming and Animal keeping",
  //       "primary_crops_grown": "bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The numbers and information of this survey were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 28.4,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakaranka",
  //       "bridge_opportunity_project_code": "1007542",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.77593,
  //       "bridge_opportunity_gps_longitude": 29.4562,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 17,
  //       "bridge_opportunity_individuals_directly_served": 4842,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2201m, Cell:Uwumusebeya, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Gisanze -Rugote, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 4m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for one side and hard rock for other side",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.77593,
  //       "proposed_bridge_location_gps_longitude": 29.4562,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "10 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "10 times in April, May, October November and December and it lasts 2days after rainfall",
  //       "market_access_blocked_by_river": "Gakaranka, Zirambi, Ruyenzi villages don't have access to Gatunda market Mubuga and Rugote villages don't have access to Gisanze market",
  //       "education_access_blocked_by_river": "Rugote, Mubuga villages don't have access to Gakaranka primary school Rugote, Mubuga villages don't have access to Ruyenzi secondary school",
  //       "health_access_blocked_by_river": "Rugote, Mubuga villages don't have access to Ruheru health center",
  //       "other_access_blocked_by_river": "Sector office",
  //       "primary_occupations": "Farming of potatoes, wheat, beans, charcoal production",
  //       "primary_crops_grown": "bean, potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 61,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirwa",
  //       "bridge_opportunity_project_code": "1007543",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.798933,
  //       "bridge_opportunity_gps_longitude": 29.4761,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 41,
  //       "bridge_opportunity_individuals_directly_served": 4563,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2257m, Cell:Remera, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Mukato, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.798933,
  //       "proposed_bridge_location_gps_longitude": 29.4761,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 38,
  //       "flood_duration_during_rainy_season": "38times in April, May, October November and December and it lasts 1day after rainfall",
  //       "market_access_blocked_by_river": "Kirwa village doesn't have access to Gatunda market Kivugiza village doesn't have access to kumukato market",
  //       "education_access_blocked_by_river": "Kirwa village doesn't have access to Remera primary school",
  //       "health_access_blocked_by_river": "Kirwa village doesn't have access to Ruheru health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of potatoes, beans, maize",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Hhye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 54.4,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GJAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Samiyonge",
  //       "bridge_opportunity_project_code": "1007545",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.67962,
  //       "bridge_opportunity_gps_longitude": 29.46244,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 6119,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1913m, Cell:Nyabimata-Muganza, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Nyabimata, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 23m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.67962,
  //       "proposed_bridge_location_gps_longitude": 29.46244,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.5 hour",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities1,2,3,4 don't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Communities 1,2,3,4 don't have access to ES Mutovu(school ), communities don't have access to Nyabimata Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities1,2,3,4 don't have access to to Nyabimata Health center",
  //       "other_access_blocked_by_river": "Communities 5 don't have access to Police station office",
  //       "primary_occupations": "Brick making workers, Tea plantations workers and traders Kamirabagenzi market",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kamirabagenzi market which is open twice a week ( Community1,2,3,4 ), Nyabimata primary and secondary ( Community1,2,3,4 ), ES Mutovu( community5 ), Brick making site ( Community 1,2,3,4), Tea plantations farms ( Community 1,2,3,4).",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Urwishinzo",
  //       "bridge_opportunity_project_code": "1007546",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7803056,
  //       "bridge_opportunity_gps_longitude": 29.4508056,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2216m, Cell:Uwumusebeya, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Gisanze, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7803056,
  //       "proposed_bridge_location_gps_longitude": 29.4508056,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Too close to the vehicular road. The anchor would fall into the middle of the vehicular road",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karanka",
  //       "bridge_opportunity_project_code": "1007547",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.66297667,
  //       "bridge_opportunity_gps_longitude": 29.44955667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 20,
  //       "bridge_opportunity_individuals_directly_served": 3443,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1948m, Cell:Uwacyiza-Rukore, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Nsekera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated area and a flat area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.66297667,
  //       "proposed_bridge_location_gps_longitude": 29.44955667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 38,
  //       "flood_duration_during_rainy_season": "38times in April, May, October, November and December and it lasts for 3hours after rainfall",
  //       "market_access_blocked_by_river": "Karanka, Mazimeru, Cyurukore, Nyagisenyi villages don't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Karanka, Mazimeru, Cyurukore, Nyagisenyi villages don't have access to Sekera secondary school",
  //       "health_access_blocked_by_river": "Karanka, Mazimeru, Cyurukore, Nyagisenyi villages don't have access to Muganza health center",
  //       "other_access_blocked_by_river": "Sector office",
  //       "primary_occupations": "Farming of sweet potatoes, banana, beans",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The information of social survey were given by the local people and their leaders based on the monthly census which is done",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32.8,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GNAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihinga",
  //       "bridge_opportunity_project_code": "1009329",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.829439,
  //       "bridge_opportunity_gps_longitude": 29.882134,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 16300,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.13",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.829439,
  //       "proposed_bridge_location_gps_longitude": 29.882134,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 kilometers",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "April to May, 12hours",
  //       "market_access_blocked_by_river": "Gitega, kayenzi, Ruli markets( 1), Muhondo, kirenge markets ( 2),",
  //       "education_access_blocked_by_river": "Mbwenda secondary school ( 2)",
  //       "health_access_blocked_by_river": "Ruli hospital ( 1), Gihinga health center ( 2)",
  //       "other_access_blocked_by_river": "Bus stop , churches ( 2)",
  //       "primary_occupations": "Farming , livestock",
  //       "primary_crops_grown": "cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000asYQDAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bahimba",
  //       "bridge_opportunity_project_code": "1014279",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.05153,
  //       "bridge_opportunity_gps_longitude": 29.83695,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3362,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05153,
  //       "proposed_bridge_location_gps_longitude": 29.83695,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Musambira market",
  //       "education_access_blocked_by_river": "Musambira high school",
  //       "health_access_blocked_by_river": "Musambira health center",
  //       "other_access_blocked_by_river": "Musambira church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Mbari village dont have access to musambira market Information gathered from cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 97,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekg7AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bitare",
  //       "bridge_opportunity_project_code": "1007549",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.68734,
  //       "bridge_opportunity_gps_longitude": 29.65577,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 20,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1619m, Cell:Sheke-Rusenge, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Runyani Sheke, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 45m.-The level difference between two banks is 4m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.68734,
  //       "proposed_bridge_location_gps_longitude": 29.65577,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1day",
  //       "market_access_blocked_by_river": "Communities don't have access to Busoro market , communities to farms",
  //       "education_access_blocked_by_river": "Communities don't have access to Nyundo Primary and secondary school in Bitare cell",
  //       "health_access_blocked_by_river": "Communities don't have access to to Bitare health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Adventists and Catholic churches services",
  //       "primary_occupations": "Coffee farmers, local farmers on small scale and traders at Busoro market",
  //       "primary_crops_grown": "bean, coffee plantation, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people fall in the river when trying to cross it, due to slipping on timber",
  //       "notes_on_social_information": "Busoro market which is open twice a week ( Community ), Nyundo Primary and secondary school in Bitare cell ( Community ), Bitare health center ( Community), Church services( community ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GPAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Sheke",
  //       "bridge_opportunity_project_code": "1007550",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.67224,
  //       "bridge_opportunity_gps_longitude": 29.65063,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 4755,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1633m, Cell:Bitare, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Yaramba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.67224,
  //       "proposed_bridge_location_gps_longitude": 29.65063,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1day",
  //       "market_access_blocked_by_river": "Communities 2don't have access to Busoro market, communities 2 don't have access to farms on left side",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Nyundo Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Bitare health center",
  //       "other_access_blocked_by_river": "Communities 1don't have access Adventist church of Seven days and Catholic Churches services",
  //       "primary_occupations": "Coffee farmers, local farmers and traders at Busoro Market",
  //       "primary_crops_grown": "carrots), coffee plantation, maiz, sweet potato, vegetables (cabbag",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people were injured when trying to cross the river, due to slipping on timber and fall in the river",
  //       "notes_on_social_information": "Busoro market which is open twice a week ( Community 2), Bitare health center ( Community 2), Nyundo Primary and secondary school in Bitare cell ( Community 2 ), Churche services ( Community 1). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Remera",
  //       "bridge_opportunity_project_code": "1007551",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.70332833,
  //       "bridge_opportunity_gps_longitude": 29.58839667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 30,
  //       "bridge_opportunity_individuals_directly_served": 4398,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1745m, Cell:cyuna, Injuries/Death-More peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Ndago -Remera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.70332833,
  //       "proposed_bridge_location_gps_longitude": 29.58839667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December and it lasts 2 days after rainfall",
  //       "market_access_blocked_by_river": "Uwamuhizi, Cyuna and Remera villages don't have access to Ndago market",
  //       "education_access_blocked_by_river": "Uwamuhizi, Cyuna and Remera villages don't have access to Ndago Secondary school Uwamuhizi, Cyuna and Remera villages don't have access to Ruko Primary school",
  //       "health_access_blocked_by_river": "Uwamuhizi, Cyuna and Remera villages don't have access to Coko Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea farming and Animal keeping",
  //       "primary_crops_grown": "bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The information of this survey were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34.8,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GRAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Coko",
  //       "bridge_opportunity_project_code": "1007552",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": 2.713945,
  //       "bridge_opportunity_gps_longitude": 29.594535,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 30,
  //       "bridge_opportunity_individuals_directly_served": 4586,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1742m, Cell:Coko-cyuna, Injuries/Death-More peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Ndago, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": 2.713945,
  //       "proposed_bridge_location_gps_longitude": 29.594535,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December and it lasts 3days after rainfall",
  //       "market_access_blocked_by_river": "Uwamuhizi and Cyuna villages don't have access to Ndago market Coko, Agasharu, Gitara, and Coko village don't have access to Viro market",
  //       "education_access_blocked_by_river": "Uwamuhizi and Cyuna villages don't have access to Mirabyo Primary school Agasharu, Gitara, and Coko village don't have access to Cyahinda Secondary school",
  //       "health_access_blocked_by_river": "Uwamuhizi and Cyuna villages don't have access to coko health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea farming and Animal keeping",
  //       "primary_crops_grown": "bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The information of social survey were given by the local people and their leaders based on the monthly census which is done in every cell. The sector land manager of Cyahinda, Coko cell executive together with their village leaders.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 52.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GSAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitara",
  //       "bridge_opportunity_project_code": "1007553",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.71768,
  //       "bridge_opportunity_gps_longitude": 29.59726333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 30,
  //       "bridge_opportunity_individuals_directly_served": 5406,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1739m, Cell:Coko-Gasasa, Injuries/Death-More peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Ndago, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.71768,
  //       "proposed_bridge_location_gps_longitude": 29.59726333,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2.4 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Uwamuhizi and Ryamarembo villages don't have access to Ndago market Coko, Gitara, Ruko, Agasharu villages don't have access to Viro market",
  //       "education_access_blocked_by_river": "Uwamuhizi and Ryamarembo villages don't have access to Mirabyo Primary school Coko, Gitara, Ruko, Agasharu villages don't have access to Cyahinda Secondary school",
  //       "health_access_blocked_by_river": "Uwamuhizi and Ryamarembo villages don't have access to Coko Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea farming and Animal keeping",
  //       "primary_crops_grown": "bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Agasharu village uses this crossing regularly and itspeople are included in the total population to be served. The information of social survey were given by the local people and their leaders based on the monthly census which is done in every cell. The sector land manager, Cell leader and village leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 46.8,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GTAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitara",
  //       "bridge_opportunity_project_code": "1007554",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.721561,
  //       "bridge_opportunity_gps_longitude": 29.596655,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 30,
  //       "bridge_opportunity_individuals_directly_served": 5406,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1739m, Cell:Coko-Gasasa, Injuries/Death-More peoples injured while trying to cross the river/ One person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Ndago, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.721561,
  //       "proposed_bridge_location_gps_longitude": 29.596655,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "40 times In April, May, October, November and December and it lasts for 3 day after rainfall",
  //       "market_access_blocked_by_river": "Uwamuhizi, Ryamarembo villages don't have access Ndago market Coko, Gitara, Ruko, Agasharu villages don't have access to Viro market",
  //       "education_access_blocked_by_river": "Uwamuhizi, Ryamarembo villages don't have access to Gitara Secondary school, Mirabyo and Ruko Primary school Coko, Gitara, Ruko, Agasharu villages don't have access Cyahind secondary school",
  //       "health_access_blocked_by_river": "Uwamuhizi, Ryamarembo villages don't have access to Coko Health Center Coko, Gitara, Ruko, Agasharu villages don't have access Cyahind Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of tea, wood production,",
  //       "primary_crops_grown": ", bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Agasharu village uses this crossing regularly and their people were included in the total population to be served The information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 55.4,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GUAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Kabagu -gasihe",
  //       "bridge_opportunity_project_code": "1014098",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.57552,
  //       "bridge_opportunity_gps_longitude": 29.0818,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1791,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57552,
  //       "proposed_bridge_location_gps_longitude": 29.0818,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Nyakabuye market",
  //       "education_access_blocked_by_river": "Muramba high school",
  //       "health_access_blocked_by_river": "Nyabitimbo health center",
  //       "other_access_blocked_by_river": "Nyabitimbo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Gashihe village don't have access to nyakabuye market Information gathered from village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakabuye",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fW9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwishwa",
  //       "bridge_opportunity_project_code": "1007555",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.651346,
  //       "bridge_opportunity_gps_longitude": 29.43843,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 2757,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2058m, Cell:Rukore, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Rwishwa, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.03m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.651346,
  //       "proposed_bridge_location_gps_longitude": 29.43843,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": 2.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwamuhizi",
  //       "bridge_opportunity_project_code": "1007558",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.71525,
  //       "bridge_opportunity_gps_longitude": 29.5959167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 30,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1742m, Cell:Coko-cyuna, Injuries/Death-More peoples injured while trying to cross the river/ One person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Ndago, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.71525,
  //       "proposed_bridge_location_gps_longitude": 29.5959167,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is a duplicate of Coko site since they are too close by 30m, and people prefer the one of coko",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GYAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngarurira",
  //       "bridge_opportunity_project_code": "1007559",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.6965833,
  //       "bridge_opportunity_gps_longitude": 29.5401111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 4515,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1780m, Cell:Ngarurira, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Ndago -Munini, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6965833,
  //       "proposed_bridge_location_gps_longitude": 29.5401111,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Ndago market, communities 1 don't have access to Tea plantation farms",
  //       "education_access_blocked_by_river": "Communities 2don't have access to Nyarushishi school, communities 1don't have access to Munini school",
  //       "health_access_blocked_by_river": "Communities1 don't have access to Munini Hospital and Health center",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to Kibeho Parish",
  //       "primary_occupations": "Tea plantation workers, farmers on both sides and traders at Ndago market",
  //       "primary_crops_grown": ", sweet potato, tea plantation on large l",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One person fell into the river but fortunately none died , the communities avoid using the crossing in rain season because it is dangerous",
  //       "notes_on_social_information": "Munini Hospital ( Community1 ), Munini health center ( Community 1), Kibeho Holy place and Parish( community2 ), Tea plantations farms ( Community1 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwumusebeya",
  //       "bridge_opportunity_project_code": "1007560",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7785278,
  //       "bridge_opportunity_gps_longitude": 29.44775,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2235m, Cell:Uwumusebeya, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Gisanze, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is a no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7785278,
  //       "proposed_bridge_location_gps_longitude": 29.44775,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "No enough distance available for the anchor. It is too close to the vehicular road",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muyira",
  //       "bridge_opportunity_project_code": "1007589",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7211111,
  //       "bridge_opportunity_gps_longitude": 29.4486389,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 1746,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2103m, Cell:Mishungero-kabere, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Kabere -Mujeni, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7211111,
  //       "proposed_bridge_location_gps_longitude": 29.4486389,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities don't have access to Nshili-Kivu tea factory, communities don't have access to Ruheru market, communities don't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Communities don't have access to Ruheru primary and secondary school",
  //       "health_access_blocked_by_river": "Communities don't have access to Nyabimata Health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Nyabimata sector and SACCO",
  //       "primary_occupations": "Daily farmers on both sides, traders at Ruheru and Kamirabagenzi market, Tea plantations workers in farms and at the Factory",
  //       "primary_crops_grown": "bean, maiz, potato, sweet potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ruheru market which is open twice a week ( Community 1), Kamirabagenzi market which is open twice a week ( Community 1); Nshili-Kivu tea factory ( Community2 ), Tea plantations farms ( Community 2),Ruheru primary and secondary school ( Community 2 ), Nyabimata Health center ( Community ) , Nyabimata Sector and SACCO office ( Community 1), Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86H3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mutovu",
  //       "bridge_opportunity_project_code": "1007561",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.6860833,
  //       "bridge_opportunity_gps_longitude": 29.4780833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 48,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1817m, Cell:Gihembe-Samiyonga, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Kamirabagenzi -Mutovu, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 25m.-The proposed bridge span is approximately 85m.-The level difference between two banks is 4m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hill and a flat area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6860833,
  //       "proposed_bridge_location_gps_longitude": 29.4780833,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The location was shifted and have a vehicular bridge in timber 150 m as the first picture shows and the second picture is where the existing crossing used to be before being moved",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Businde",
  //       "bridge_opportunity_project_code": "1007564",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.6974722,
  //       "bridge_opportunity_gps_longitude": 29.4909444,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 20,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1812m, Cell:Bikamba-Cyanyirankora, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers-Ruheru, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 45m.-The level difference between two banks is 0.04m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6974722,
  //       "proposed_bridge_location_gps_longitude": 29.4909444,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is a planned vehicular bridge.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Agasaka",
  //       "bridge_opportunity_project_code": "1007565",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.77066667,
  //       "bridge_opportunity_gps_longitude": 29.66886,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1521m, Cell:Fugi-Rubona, Injuries/Death-Many peoples injured while trying to cross the river/ More than 3 peoples died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Akanyaru(Burundi Border to Rwanda), Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 30m.-The proposed bridge span is approximately 65m.-The level difference between two banks is 8m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hill and a flat area.-The soil from the site is hard rock for one side and a silt for other side.",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.77066667,
  //       "proposed_bridge_location_gps_longitude": 29.66886,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "No enough distance available for the anchor, it is too close to the asphalt road",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mutobwe",
  //       "bridge_opportunity_project_code": "1007566",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.69631,
  //       "bridge_opportunity_gps_longitude": 29.43436,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 2187,
  //       "bridge_opportunity_comments": "Not Duplicate 500-1000 people directly served, Elevation:2060m, Cell:Nyabimata-Ruhungu, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Nyabimata, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.69631,
  //       "proposed_bridge_location_gps_longitude": 29.43436,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 2don't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Communities 2don't have access to Nyabimata primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 2don't have access to Nyabimata Health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea plantation workers, daily farmers on both sides and traders at Kamirabagenzi and Ruheru market",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One person was injured when trying to cross the river, fortunately none died",
  //       "notes_on_social_information": "Kamirabagenzi market which is open twice a week ( Community 2), Nyabimata primary and secondary school ( Community2 ), Tea plantations farms ( Community1 ), Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gashushura",
  //       "bridge_opportunity_project_code": "1007633",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.61306,
  //       "bridge_opportunity_gps_longitude": 29.88583,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 1050,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1807m, Cell:Rwamahwa-Marembo, Injuries/Death--No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Gashushura, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 9m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 0.3m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.7.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61306,
  //       "proposed_bridge_location_gps_longitude": 29.88583,
  //       "current_crossing_method": "Six wood logs bridge",
  //       "nearest_all_weather_crossing_point": "They are vehicular timber bridge in one kilometer away moving upstream direction of the river in Burera",
  //       "days_per_year_river_is_flooded": 6,
  //       "flood_duration_during_rainy_season": "3days",
  //       "market_access_blocked_by_river": "Market is at Karambi, farms to both river banks",
  //       "education_access_blocked_by_river": "School is at karambi it is a combined nursery primary and secondary school",
  //       "health_access_blocked_by_river": "Hospital is in Cyungo sector",
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Children going to school, farmers, market, going to hospitals",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "One person died in past seven years, he slipped and fallen to the river in about four years the kid got injured while crossing",
  //       "notes_on_social_information": "The information are gathered from people who were farming around the river banks",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali _ Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HlAAI",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Kirinja",
  //       "bridge_opportunity_project_code": "1013631",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.87014,
  //       "bridge_opportunity_gps_longitude": 29.37139,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1100,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.87014,
  //       "proposed_bridge_location_gps_longitude": 29.37139,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Gakeri market",
  //       "education_access_blocked_by_river": "Kayove secondary school",
  //       "health_access_blocked_by_river": "Kayove health center",
  //       "other_access_blocked_by_river": "Church at kavumu",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "People do fall in the river when it is flooded",
  //       "notes_on_social_information": "Information gathered from kirinja leader. Kirinja village don't have access to gakeri market and nyundo village don't have access to their farms",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iROAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugote",
  //       "bridge_opportunity_project_code": "1007568",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7800833,
  //       "bridge_opportunity_gps_longitude": 29.451,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2217m, Cell:Uwumusebeya, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Gisanze, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is a no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7800833,
  //       "proposed_bridge_location_gps_longitude": 29.451,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge is required on this site",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gituramigina",
  //       "bridge_opportunity_project_code": "1007571",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7438056,
  //       "bridge_opportunity_gps_longitude": 29.6708056,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 12,
  //       "bridge_opportunity_individuals_directly_served": 3870,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1565m, Cell:Yaramba-Kibangu, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Ngera, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hill and a flat area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7438056,
  //       "proposed_bridge_location_gps_longitude": 29.6708056,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Busoro market, communities 2 don't have access to Ngoma market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Yaramba",
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Ngoma health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers, Traders at Ngoma market and Busoro market",
  //       "primary_crops_grown": "maize on small scal, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Busoro market which is open twice a week ( Community 2) , Ngoma health center( community 1), Farmers on both sides, Yaramba school ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye_Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Tugogo",
  //       "bridge_opportunity_project_code": "1007573",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.56058,
  //       "bridge_opportunity_gps_longitude": 29.49439,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 15,
  //       "bridge_opportunity_individuals_directly_served": 3885,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1987m, Cell:Giseke, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Matyazo -Gasarenda, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 38m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.56058,
  //       "proposed_bridge_location_gps_longitude": 29.49439,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 1 don't have access to Kitabi Tea plantation farms, communities 2don't have access to Mata Tea plantation farms , communities 1 don't have access to Gasarenda market, communities 2don't have access to Ruramba Market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Ruramba Primary and secondary school ,",
  //       "health_access_blocked_by_river": "Communities 2don't have access to Ruramba Health center",
  //       "other_access_blocked_by_river": "Communities on both sides don't have access to Churches services",
  //       "primary_occupations": "Tea plantation workers of Mata tea factory and Kitabi tea factory",
  //       "primary_crops_grown": "maiz, sweet potato, tea plantation farm",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 67.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GnAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwurusugi",
  //       "bridge_opportunity_project_code": "1007574",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.70144,
  //       "bridge_opportunity_gps_longitude": 29.43844,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 3900,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2041m, Cell:Kabere, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers-Kabere, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.70144,
  //       "proposed_bridge_location_gps_longitude": 29.43844,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 hours",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": "Communities2 don't have access to Ruheru market, communities 1don't have access to Kamirabagenzi market",
  //       "education_access_blocked_by_river": "Communities 1don't have access to Nyabimata primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1don't have access to Nyabimata Health center",
  //       "other_access_blocked_by_river": "Communities 1don't have access to sector office and saving and credit cooperative office",
  //       "primary_occupations": "Tea plantation workers, daily farmers on both sides and traders at Ruheru and Kamirabagenzi market",
  //       "primary_crops_grown": "maiz, sweet potato, tea plantation worker",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Up to nine people were injured including six incidents outside of three year window. Injuries were due to slipping on timber and fall in the river. One person died, was a student who was trying to cross the river when the river was flooding",
  //       "notes_on_social_information": "Ruheru market which is open twice a week ( Community2 ), Kamirabagenzi market which is open twice a week ( Community 1), Nyabimata primary and secondary school ( Community 1), Nyabimata Health center ( Community1 ), Nyabimata Parish ( community1 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GoAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryarugarama",
  //       "bridge_opportunity_project_code": "1007575",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7814444,
  //       "bridge_opportunity_gps_longitude": 29.6633611,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1420m, Cell:Fugi-Rubona, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Ryarugarama, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hill and a flat area.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7814444,
  //       "proposed_bridge_location_gps_longitude": 29.6633611,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is planned vehicular bridge on this crossing",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamuragi",
  //       "bridge_opportunity_project_code": "1007634",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.74278,
  //       "bridge_opportunity_gps_longitude": 29.94694,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 70,
  //       "bridge_opportunity_individuals_directly_served": 1260,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1765m, Cell:Taba, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Rebero -Tumba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 100m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flats areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.7.27",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "They use timbers over the bridge as the method of crossing",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 2,
  //       "flood_duration_during_rainy_season": "Flood takes 2 days",
  //       "market_access_blocked_by_river": "Gisiza market is located at left side of the river",
  //       "education_access_blocked_by_river": "Gasama secondary school at left side",
  //       "health_access_blocked_by_river": "Tumba health center at left side",
  //       "other_access_blocked_by_river": "Ruvumba cell",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cabbage is the most common agricultural product in this area",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "A women and her kid died crossing the river and one dead was missed",
  //       "notes_on_social_information": "People are crossing hours by hours going in different activities and many students use this bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Tumba",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31.4,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HmAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhengeri 2",
  //       "bridge_opportunity_project_code": "1013633",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.88027,
  //       "bridge_opportunity_gps_longitude": 29.34277,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 519,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.88027,
  //       "proposed_bridge_location_gps_longitude": 29.34277,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "400 m",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "30 minutes",
  //       "market_access_blocked_by_river": "Gakeri",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A child has fell in the river but fortunately the people were around and save him",
  //       "notes_on_social_information": "The community of ruhengeri village cross to visit their farms",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iRnAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusuzumiro",
  //       "bridge_opportunity_project_code": "1007577",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.6483056,
  //       "bridge_opportunity_gps_longitude": 29.4811389,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 14,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1915m, Cell:Kivu, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Rusuzumiro, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-sandy/ Umucanga,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is sandy for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6483056,
  //       "proposed_bridge_location_gps_longitude": 29.4811389,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The people don't use this crossing anymore because there is a vehicular bridge in 100 m upstream of the river and they prefer accessing all infrastructures through the vehicular road .",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rimbamya",
  //       "bridge_opportunity_project_code": "1007578",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.6378056,
  //       "bridge_opportunity_gps_longitude": 29.5095,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 17,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1847m, Cell:Kivu-Rugorwe, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Kivu, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.04m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is Hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.9",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6378056,
  //       "proposed_bridge_location_gps_longitude": 29.5095,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge is needed! And the RHS is very steep",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Businde",
  //       "bridge_opportunity_project_code": "1007579",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.636655,
  //       "bridge_opportunity_gps_longitude": 29.47937167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 5323,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. A bridge could likely be located 50 meters northeast along the river of where assessor took the centerline, however the river is likely too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.636655,
  //       "proposed_bridge_location_gps_longitude": 29.47937167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "50 times in April, May, October, November and December and it lasts for 3hours after rainfall",
  //       "market_access_blocked_by_river": "Rusuzumiro village doesn't have access to Kajwangari market Businde, cyanyirankora, Ruganza, Rugerero, Kivumu, kintama and Gasezo villages don't have access to Mukamirabagenzi market",
  //       "education_access_blocked_by_river": "Rusuzumiro village doesn't have access to Rugerero Secondary school, Businde, cyanyirankora villages don't have access to Rusuzumiro primary school",
  //       "health_access_blocked_by_river": "Rusuzumiro village doesn't have access to Rugerero health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of beans, sweet potatoes, and cow pea",
  //       "primary_crops_grown": ", bean, cow pea, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is not enough space for the anchor behind the proposed towers on both sides( take a look in technical assessment",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 25.4,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akatera",
  //       "bridge_opportunity_project_code": "1007583",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.71667,
  //       "bridge_opportunity_gps_longitude": 29.73864,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 5328,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1571m, Cell:Rusagara, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-< 50 people, Nearby city centers-Kigembe, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.71667,
  //       "proposed_bridge_location_gps_longitude": 29.73864,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "In March,April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Mburamazi, Rango and Huye Town Markets (Community 5), Busoro market (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "VTC Gahabwa (Community 5)",
  //       "health_access_blocked_by_river": "No health access blocked by river",
  //       "other_access_blocked_by_river": "Kansi Catholic Parish, Huye Town (Community 5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "Many people fall into the river and get rescued but so far 3 people have trying to cross the river during rainy season.",
  //       "notes_on_social_information": "Nyarukurazo, Nyarunyinya, Akatera, Ruhuha, Gasharu, Gatare, Kinteko and Gisozi villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Rusagara Cell Leader, Jean de Dieu Ndayishimiye, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mashetsa",
  //       "bridge_opportunity_project_code": "1007584",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.614243,
  //       "bridge_opportunity_gps_longitude": 29.571836,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 18,
  //       "bridge_opportunity_individuals_directly_served": 4070,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1801m, Cell:Nyamabuye, Injuries/Death--No person injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Kibeho -Mata, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between a flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.614243,
  //       "proposed_bridge_location_gps_longitude": 29.571836,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "20times in April, May, October, November and December and it lasts for 2days after rainfall",
  //       "market_access_blocked_by_river": "Rwinanka doesn't have access to Kiyovu market Kinazi, Rwimbogo, Migina villages don't have access to COTENYA(Tea farming cooperative)",
  //       "education_access_blocked_by_river": "Rwinanka doesn't have access to Mbasa primary school",
  //       "health_access_blocked_by_river": "Rwinanka doesn't have access to Mbasa health post",
  //       "other_access_blocked_by_river": "Sector office",
  //       "primary_occupations": "Tea farming, potato farming",
  //       "primary_crops_grown": "bean, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 27.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86GyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kurutare",
  //       "bridge_opportunity_project_code": "1009553",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.7338888889,
  //       "bridge_opportunity_gps_longitude": 29.6563888889,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2850,
  //       "bridge_opportunity_comments": "150 people from Ngororero District use Kurutare Bridge for their daily life basis to access Matyazo Market located at Matyazo Sector and visiting family and relatives.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.7338888889,
  //       "proposed_bridge_location_gps_longitude": 29.6563888889,
  //       "current_crossing_method": "They use boat to cross always",
  //       "nearest_all_weather_crossing_point": "No way",
  //       "days_per_year_river_is_flooded": 18,
  //       "flood_duration_during_rainy_season": "18",
  //       "market_access_blocked_by_river": "Ngororero market and kurutare market",
  //       "education_access_blocked_by_river": "Kurikigari",
  //       "health_access_blocked_by_river": "Dispensary rusore",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "0",
  //       "notes_on_social_information": "The data were gathered from village leader and neiborhood citizens",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali - musanze",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 186,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bKz7zAAC",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyumuzi",
  //       "bridge_opportunity_project_code": "1007591",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.69811,
  //       "bridge_opportunity_gps_longitude": 29.42603,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "Not Duplicate 1000-3000 people directly served, Elevation:2150m, Cell:Ruhinga, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers-Nyabimata, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-1-2 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-1-2 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.69811,
  //       "proposed_bridge_location_gps_longitude": 29.42603,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge, small cars use the road, they want a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86H5AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ndatemwa",
  //       "bridge_opportunity_project_code": "1007592",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.78607,
  //       "bridge_opportunity_gps_longitude": 29.53833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 5061,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1832m, Cell:Runyombyi, Injuries/Death--No person injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Runyombyi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.78607,
  //       "proposed_bridge_location_gps_longitude": 29.53833,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "800 m",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "45times in April, May, October, November and December and it lasts for 4hours after rainfall",
  //       "market_access_blocked_by_river": "Nyarukeri, Gisoro, Ndatemwa villages don't have access to Gatunda market",
  //       "education_access_blocked_by_river": "Nyarukeri, Gisoro, Ndatemwa , Kabavomo, Nyarusange, nteko villages don't have access to Runyombyi Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Nyarukeri, Gisoro, Ndatemwa , Kabavomo, Nyarusange, nteko villages don't have access to Runyombyi Health Center",
  //       "other_access_blocked_by_river": "Sector office",
  //       "primary_occupations": "Farming of sweet potatoes, coffee, tea,",
  //       "primary_crops_grown": "coffe, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Nyarukeri village is using this crossing regularly and it's people were included in the total population to be served The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32.2,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86H6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhinga",
  //       "bridge_opportunity_project_code": "1007594",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.69618,
  //       "bridge_opportunity_gps_longitude": 29.42616,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 17,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "Not Duplicate 1000-3000 people directly served, Elevation:2132m, Cell:Ruhinga, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Rumenero -Agasugi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.69618,
  //       "proposed_bridge_location_gps_longitude": 29.42616,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86H8AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muyira",
  //       "bridge_opportunity_project_code": "1007595",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.7221,
  //       "bridge_opportunity_gps_longitude": 29.43916,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:2236m, Cell:Mishungero-kabere, Injuries/Death--No person injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Kabere -Mujeni, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 9m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7221,
  //       "proposed_bridge_location_gps_longitude": 29.43916,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Huye",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Not needed , there is a vehicular bridge in 95 m, the second picture shows a road passing by",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86H9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gaseso",
  //       "bridge_opportunity_project_code": "1007597",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.62936,
  //       "bridge_opportunity_gps_longitude": 29.4521944,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 11,
  //       "bridge_opportunity_individuals_directly_served": 555,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2007m, Cell:Gahurizo, Injuries/Death--Many peoples injured while trying to cross/ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers-Gahurizo, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 15m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.62936,
  //       "proposed_bridge_location_gps_longitude": 29.4521944,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is no way to place the towers because the slope is too steep on both sides (RHS slope:78%; LHS slope : 62%",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sheke",
  //       "bridge_opportunity_project_code": "1007598",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.68053167,
  //       "bridge_opportunity_gps_longitude": 29.51431667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 22,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1813m, Cell:Nyange-Muganza, Injuries/Death--Many peoples injured while trying to cross/ Two peples died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Muganza -Ndago, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 3m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 6m.-The space for foundation is sufficient for one side and not sufficient for the other side.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.68053167,
  //       "proposed_bridge_location_gps_longitude": 29.51431667,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is a very steep slope on both sides of the river",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mucyondo",
  //       "bridge_opportunity_project_code": "1007601",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.70902,
  //       "bridge_opportunity_gps_longitude": 29.35808,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 13,
  //       "bridge_opportunity_individuals_directly_served": 65160,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1898m, Cell:Kamuhoza, Injuries/Death-Many peoples injured while crossing the bridge./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Cyondo -Mahoko, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 9m.-The proposed bridge span is approximately 32m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70902,
  //       "proposed_bridge_location_gps_longitude": 29.35808,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "APEFOKE",
  //       "health_access_blocked_by_river": "Karambo health center",
  //       "other_access_blocked_by_river": "ADPR",
  //       "primary_occupations": "Farming and business",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "They died trying to cross when the river was flooded",
  //       "notes_on_social_information": "Nkora village don't have access to mahoko market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Mahoko",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 96,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HFAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasenyi",
  //       "bridge_opportunity_project_code": "1007603",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.699166,
  //       "bridge_opportunity_gps_longitude": 29.336944,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 19,
  //       "bridge_opportunity_individuals_directly_served": 1732,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1830m, Cell:Nyundo, Injuries/Death-Many peoples injured while crossing the bridge./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Nyundo -Mahoko, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.01m(Almost the same).-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides. <<Apart from the major flooding of this river at this location ( Sebeya river covers the entire right side plus the paved road), Having the paved road along Sebeya River, there is no enough space to accommodate the right anchor , 14MAY2020>>",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.699166,
  //       "proposed_bridge_location_gps_longitude": 29.336944,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "They use timber bridge in one kilometer upstream",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Lycee nyundo and petit seminars nyundo",
  //       "health_access_blocked_by_river": "Nyundo health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information gathered from nyundo cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze- rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HHAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Ruraje",
  //       "bridge_opportunity_project_code": "1007605",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.70833,
  //       "bridge_opportunity_gps_longitude": 29.379722,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 700,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2031m, Cell:Rusongati, Injuries/Death-Many peoples injured while crossing the bridge./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Gashasho -Mahoko, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between a hill and an elevated area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70833,
  //       "proposed_bridge_location_gps_longitude": 29.379722,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "It takes hours",
  //       "market_access_blocked_by_river": "Kamuhoza market",
  //       "education_access_blocked_by_river": "Nyanjondori primary and secondary school",
  //       "health_access_blocked_by_river": "Nteranya",
  //       "other_access_blocked_by_river": "All churches are located at kanyambongo and they do cross always the river to reach the place",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Only one person fell and died and community changed the way",
  //       "notes_on_social_information": "Information gathered from local people",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 88.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HJAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamigina 2",
  //       "bridge_opportunity_project_code": "1007606",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.17262,
  //       "bridge_opportunity_gps_longitude": 30.6741,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 22,
  //       "bridge_opportunity_individuals_directly_served": 2436,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.17262,
  //       "proposed_bridge_location_gps_longitude": 30.6741,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In December, March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Buhanda and Gafunzo markets (Community 3,4), Farms (1,2,3,4)",
  //       "education_access_blocked_by_river": "Mwendo Primary and Secondary School (Community 1,2)",
  //       "health_access_blocked_by_river": "Muyunzwe health center (Community 3,4)",
  //       "other_access_blocked_by_river": "Muyunzwe Catholic Parish (Community 3,4); Byimana Catholic Church (1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One person died at this crossing point and two were injured.",
  //       "notes_on_social_information": "Kabacuzi, Nyarubumbiro, Nyamigina and Buhoro villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and farms. The population information for each village was provided by the Rukina Cell Leader and Kabacuzi village leader, Alexia Mukeshimana, from the population data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyangandika",
  //       "bridge_opportunity_project_code": "1007607",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.18495,
  //       "bridge_opportunity_gps_longitude": 29.80927,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 1067,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1553m, Cell:Buhoro, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Ntenyo, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 25m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides. In December, 2017>>>>>>Nyangandika is no longer existed because of flooding. On the two sides of the river there is an extraction of sand activity. You can pass through the water in other tobe able to cross this cyiruruma river ,in a rainy season people from Mbuye and Byimana sector access some services at Ruhango sector like school, Ntenyo market and Kizibere catholic church.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18495,
  //       "proposed_bridge_location_gps_longitude": 29.80927,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Ruhango and Ntenyo Market",
  //       "education_access_blocked_by_river": "Muhororo and Kizibere Primary school",
  //       "health_access_blocked_by_river": "Kizibere and Ruhango health centre",
  //       "other_access_blocked_by_river": "Ruhango district, potable water, kizibere parish",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Ruhango",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mabanza",
  //       "bridge_opportunity_project_code": "1007612",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.12558,
  //       "bridge_opportunity_gps_longitude": 29.67786,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 1321,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1648m, Cell:Mutara-Gishweru, Injuries/Death-Non person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Mutara, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a flat areas. In December ,2017>>>>>>we found at this site a timber bridge and the accessibility rocky soil seems to be the main technical constraint. .",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12558,
  //       "proposed_bridge_location_gps_longitude": 29.67786,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "MUTARA market",
  //       "education_access_blocked_by_river": "Giseke and MUTARA Primary school",
  //       "health_access_blocked_by_river": "Gishweru health center",
  //       "other_access_blocked_by_river": "Gishweru - MUTARA cell",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "NR7 (Kigali - Karongi)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": 2.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubanda",
  //       "bridge_opportunity_project_code": "1007615",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.6443889,
  //       "bridge_opportunity_gps_longitude": 29.8994722,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 65,
  //       "bridge_opportunity_individuals_directly_served": 2777,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1757m, Cell:cyohoha-Gitare, Injuries/Death--No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kiruri, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 20m.-The proposed bridge span is approximately 80m.-The level difference between two banks is 0.01m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6443889,
  //       "proposed_bridge_location_gps_longitude": 29.8994722,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 67,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities4,5 don't have access to Tea plantation farms; Communities 1,2,3 don't have access to Base market",
  //       "education_access_blocked_by_river": "Communities1,2,3 don't have access to Mushongi primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3 don't have access to Mushongi health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Churches services",
  //       "primary_occupations": "Tea plantation workers, Farmers on both side and traders at Base market",
  //       "primary_crops_grown": "bean, maiz, tea plantation on large scal",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Five people fell into the river trying to cross the river",
  //       "notes_on_social_information": "Base market which is open twice a week ( Community 1,2,3); Tea plantations farms ( Community 4,5); Mushongi primary and secondary school ( Community 1,2 3); Mushongi health center ( Community 1,2,3 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HTAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruvumba",
  //       "bridge_opportunity_project_code": "1007621",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.748844,
  //       "bridge_opportunity_gps_longitude": 29.951975,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 55,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1767m, Cell:Taba, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Rebero -Tumba, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 70m.-The level difference between two banks is 0.8m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flats areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.748844,
  //       "proposed_bridge_location_gps_longitude": 29.951975,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Communities needs a vehicular bridge, 2 years ago, vehicles passed to load crops",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngarama",
  //       "bridge_opportunity_project_code": "1007622",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.692446,
  //       "bridge_opportunity_gps_longitude": 29.904097,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 86,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1736m, Cell:Giko, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Gashushura, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 18m.-The proposed bridge span is approximately 97m.-The level difference between two banks is 0.6m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flats areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.692446,
  //       "proposed_bridge_location_gps_longitude": 29.904097,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Communities needs a vehicular bridge, no difficulties in crossing for pedestrians",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Pindura",
  //       "bridge_opportunity_stage": "Complete",
  //       "bridge_opportunity_project_code": "1007654",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.594639,
  //       "bridge_opportunity_gps_longitude": 28.981427,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 14,
  //       "bridge_opportunity_individuals_directly_served": 3802,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1282m, Cell:Cyingwa, Injuries/Death-Many peoples injured while crossing the river/ No person known died while crossing the river. Cross river on a normal day-300-600 people, Nearby city centers--Mubuga -Mibirizi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 5 m-The proposed bridge span is 42m-The level difference between two banks is approximately the same.-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the site-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is silt for both sides-The site is located between two hills.",
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.594639,
  //       "proposed_bridge_location_gps_longitude": 28.981427,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities1 don't have access to Gishoma market , communities 2 don't have access to Nyakabuye market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Kaboza Primary school and Mibilizi secondary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Cyingwa health Post and Mibilizi Hospital",
  //       "other_access_blocked_by_river": "Communities1 don't have access to to Gitambi sector office",
  //       "primary_occupations": "Cement factory workers, local farmers and traders at Nyakabuye and Gishoma markets",
  //       "primary_crops_grown": "bean, fruit, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gishoma market which is open twice a week ( Community 1), Nyakabuye market which is open twice a week ( Community ); Mibilizi and Kaboza school ( Community 2), Cyingwa health Post and Mibilizi Hospital ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Rusizi_Bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86I6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Base",
  //       "bridge_opportunity_stage": "Complete",
  //       "bridge_opportunity_project_code": "1007625",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.6404167,
  //       "bridge_opportunity_gps_longitude": 29.8977778,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 23,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1748m, Cell:Rwamahwa, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--kiruri -Base, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 34m.-The proposed bridge span is approximately 50m.-The level difference between two banks is 0.4m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Pre-Assessment - 2018.8.23",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community only wants a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyirangarama",
  //       "bridge_opportunity_stage": "Complete",
  //       "bridge_opportunity_project_code": "1007626",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.66889,
  //       "bridge_opportunity_gps_longitude": 29.89389,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 1800,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1732m, Cell:Nyirangarama, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Nyirangarama -Base, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 0.6m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.7.27",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66889,
  //       "proposed_bridge_location_gps_longitude": 29.89389,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 4,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Base Market, urwibutso enterprise factories",
  //       "education_access_blocked_by_river": "Tare primary school",
  //       "health_access_blocked_by_river": "Tare Health center",
  //       "other_access_blocked_by_river": "Tare catholic church, Tare Adventist Church",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cabbag, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze (National Road)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabahama",
  //       "bridge_opportunity_stage": "Complete",
  //       "bridge_opportunity_project_code": "1007628",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.6306667,
  //       "bridge_opportunity_gps_longitude": 29.8939167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 28,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1765m, Cell:Rwamahwa, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers- Tare hearth center, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-0.5-1 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6306667,
  //       "proposed_bridge_location_gps_longitude": 29.8939167,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "vehicles pass here and completed suspended bridge in 480 m serve the same communities",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatwa",
  //       "bridge_opportunity_stage": "Complete",
  //       "bridge_opportunity_project_code": "1007631",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.65237,
  //       "bridge_opportunity_gps_longitude": 29.9201,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 2509,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1751m, Cell:Maremo-Bwimo, Injuries/Death--No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kabasanza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 8m.-The proposed bridge span is approximately 110m.-The level difference between two banks is 0.04m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is clay for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.2",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65237,
  //       "proposed_bridge_location_gps_longitude": 29.9201,
  //       "current_crossing_method": "Bridge in timer",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Akabasaza Business center , Tea plantation",
  //       "education_access_blocked_by_river": "Mushongi Primary and secondary school and kindgarde not school",
  //       "health_access_blocked_by_river": "Mushongi Health center and Kinirihira Hospital",
  //       "other_access_blocked_by_river": "Church services",
  //       "primary_occupations": "Students from kindergarten, primary to secondary, farmers, accessing Agasaza business center , hospital and health center",
  //       "primary_crops_grown": "maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Sliding on the bridge while it is flooded",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HjAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musega",
  //       "bridge_opportunity_stage": "Complete",
  //       "bridge_opportunity_project_code": "1007632",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.8023333,
  //       "bridge_opportunity_gps_longitude": 30.0800278,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1455m, Cell:Cyivugiza, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Rusine, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 35m.-The level difference between two banks is 0.05m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is n0t sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.24",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "A vehicular concrete bridge has been constructed at this site. See photo in box",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutagara",
  //       "bridge_opportunity_stage": "Complete",
  //       "bridge_opportunity_project_code": "1009554",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.730472,
  //       "bridge_opportunity_gps_longitude": 29.662278,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.8.20",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": -1.730472,
  //       "proposed_bridge_location_gps_longitude": 29.662278,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Local community is requesting a vehicular bridge. See photo in Box",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bKzAFAA0",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitaba",
  //       "bridge_opportunity_stage": "Complete",
  //       "bridge_opportunity_project_code": "1007638",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.7067778,
  //       "bridge_opportunity_gps_longitude": 29.9143611,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 80,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1747m, Cell:Kayenzi, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-50-150 people, Nearby city centers--Mukoto -Gasiza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 100m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flats areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.24",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community wants to upgrade local bridge to concrete vehicle bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HqAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buhunde",
  //       "bridge_opportunity_stage": "Under Construction",
  //       "bridge_opportunity_project_code": "1007643",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.653,
  //       "bridge_opportunity_gps_longitude": 29.9257778,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 50,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1761m, Cell:Maremo-Bwimo, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while crossing the river Cross river on a normal day-150-300 people, Nearby city centers--Kabasaza, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Not abvailable / Ntibihaboneka.,Timber-Not abvailable / Ntibihaboneka.,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 9m.-The proposed bridge span is approximately 56m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.24",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community is requesting a concrete vehicular bridge to replace the current local wooden vehicular bridge. Photo in Box",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukoma",
  //       "bridge_opportunity_stage": "Under Construction",
  //       "bridge_opportunity_project_code": "1007645",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.79476,
  //       "bridge_opportunity_gps_longitude": 29.98846,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 2624,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1680m, Cell:mugote-mushari, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Gitabagwe -Rukoma, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 22m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.5m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.16",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.79476,
  //       "proposed_bridge_location_gps_longitude": 29.98846,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 5,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Remera market,farms on both side in Rukoma and Bukongi and daily workers at Gitabage nursery, primary and secondary",
  //       "education_access_blocked_by_river": "Gitabage nursery, primary and secondary school",
  //       "health_access_blocked_by_river": "Remera Health center and Rutongo Hospital",
  //       "other_access_blocked_by_river": "Catholic church in Bukongi/Mushari cell",
  //       "primary_occupations": "Students, teachers, buyers and sellers at Remera market and farmers",
  //       "primary_crops_grown": "banana, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Two died trying to cross the river when it was flooded. Slide on timber and fall in the river",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which requires them to cross the river. Community leaders helped giving the number of the people in the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86HxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyungwe",
  //       "bridge_opportunity_stage": "Under Construction",
  //       "bridge_opportunity_project_code": "1007652",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.857823,
  //       "bridge_opportunity_gps_longitude": 29.992177,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 30,
  //       "bridge_opportunity_individuals_directly_served": 3402,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1609m, Cell:Bugaragara-Nkotsi, Bridge would connecting Rulindo-Gasabo, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers--Nyonga, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 55m.-The level difference between two banks is 3m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between flat area and hill.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.857823,
  //       "proposed_bridge_location_gps_longitude": 29.992177,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 94,
  //       "flood_duration_during_rainy_season": "2 hours",
  //       "market_access_blocked_by_river": "Communities1,2,3 don't have access to Shyorongi market and Cassetarite mines , communities 4,5 don't have access to Rubingo market.",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Shyorongi primary and secondary school",
  //       "health_access_blocked_by_river": "Communities1 2,3 don't have access to Shyorongi health center",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to Shyorongi Catholic Parish",
  //       "primary_occupations": "Farmers on both side, workers in Mines at Shyorongi sites",
  //       "primary_crops_grown": "bean, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people fell into the river but fortunately none died",
  //       "notes_on_social_information": "Shyorongi market which is open twice a week ( Community 1,2,3), Shyorongi mining sites( communities 1,2,3), Shyorongi primary and secondary school ( Community 4,5); Shyorongi health center ( Community 1,2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86I4AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiziranyenzi",
  //       "bridge_opportunity_stage": "Under Construction",
  //       "bridge_opportunity_project_code": "1007653",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.848168,
  //       "bridge_opportunity_gps_longitude": 29.991187,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 32,
  //       "bridge_opportunity_individuals_directly_served": 5983,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1615m, Cell:Bugaragara-Nkusi, Bridge would connecting Rulindo-Gasabo, Injuries/Death-Many peoples injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-150-300 people, Nearby city centers--Kajevuba -Kabahinzi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 52m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is a confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between hills.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.848168,
  //       "proposed_bridge_location_gps_longitude": 29.991187,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 132,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Communities 1,3 don't have access to Shyorongi market and Cassetarite mines, communities 2,3don't have access to Rubingo market and Mines sites, communities 1,2 don't have access to Akabasaza market",
  //       "education_access_blocked_by_river": "Communities1,3 don't have access to Shyorongi primary and secondary school, communities 1 don't have access to Yanza primary and Ngoma secondary school, .",
  //       "health_access_blocked_by_river": "Communities1,3 don't have access to Shyorongi health center , communities 2,3 don't have access to Kajevuba health Post,",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to Nkusi Protestants and Rubingo Catholic church , communities don't have access to Shyorongi Catholic Parish",
  //       "primary_occupations": "Farmers on both side, workers in Shyorongi and Rubingo cassetarite mines, Traders",
  //       "primary_crops_grown": "bean, flower plantation, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Shyorongi market which is open twice a week and Shyorongi cassetarite mine sites( communities 1, 3); Rubingo market which is open weekly ( Community 2,3) and Mines in Rubingo( community 2,3); Shyorongi primary and secondary school ( Community 1,3); Ngoma secondary school and Yanza primary school ( Community 1); Shyorongi health center ( Community 2 ,3); Kajevuba health Post ( Community 2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86I5AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ndindiye",
  //       "bridge_opportunity_project_code": "1009069",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": null,
  //       "bridge_opportunity_comments": "BAJ confirms rejected. This site is identified under another name per Chatter communication.",
  //       "form_form_name": "Project Assessment - 2017.9.29",
  //       "form_created_by": "Abbie Noriega",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "if river is flooded no nearest crossing point, it requires to wait for good condition",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "normally, the flood lasts 10 hours",
  //       "market_access_blocked_by_river": "this time, no access to the markets",
  //       "education_access_blocked_by_river": "this time, students have shifted their schools",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "this time, there is no access to everything on the other side of river",
  //       "primary_occupations": "AGRICULTURE AND ANIMAL KEEPING",
  //       "primary_crops_grown": ", banana tre, bean, maiz, sugar can, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "this man has been drowned in the river , the river held him and hit him to rock and then he died.",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "MAHOKO",
  //       "name_of_nearest_paved_or_sealed_road": "RUBAVU-MUSANZE",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000aSNCUAA4",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "cyagara",
  //       "bridge_opportunity_stage": "Under Construction",
  //       "bridge_opportunity_project_code": "1007657",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.6891,
  //       "bridge_opportunity_gps_longitude": 28.99726,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 30956,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:998m, Cell:Nyange, Injuries/Death-Many peoples was injured while trying crossing the river./ 4 People died while crossing the river Cross river on a normal day-300-600 people, Nearby city centers--Bugarama -Cyagara -Rubyiro, Crossing River now-Walking through river / Banyura mumaziSimple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 15 m-The proposed bridge span is 62 m-The level difference between two banks is approximately the same.-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the site-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides-The site is located between two flat areas.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6891,
  //       "proposed_bridge_location_gps_longitude": 28.99726,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Bugarama market",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "The man slipped and died trying to cross",
  //       "notes_on_social_information": "Nzahaha sector don't have access to bugarama market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Bugarama city",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 95,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86I9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabiranka",
  //       "bridge_opportunity_stage": "Under Construction",
  //       "bridge_opportunity_project_code": "1007658",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.396098,
  //       "bridge_opportunity_gps_longitude": 28.927481,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 150,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1464m, Cell:Kamanyenga, Injuries/Death-Many peoples were injured while crossing the river/ Many peoples died while crossing the river. Cross river on a normal day-300-600 people, Nearby city centers--Nkombo -Nkanka -Kamembe, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 3 m-The proposed bridge span is 170m-The level difference between two banks is approximately the same.-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the site-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is silt for both sides-The site is located between two hills.",
  //       "form_form_name": "Project Assessment - 2018.12.13",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.396098,
  //       "proposed_bridge_location_gps_longitude": 28.927481,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The span is too long ( over 400m )",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muhari",
  //       "bridge_opportunity_stage": "Under Construction",
  //       "bridge_opportunity_project_code": "1007659",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.45399,
  //       "bridge_opportunity_gps_longitude": 28.89774,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 850,
  //       "bridge_opportunity_individuals_directly_served": 6000,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1470m, Cell:Gihaya, Injuries/Death-Many peoples were injured while trying crossing the lake./ Many People died while crossing the lake Cross river on a normal day-150-300 people, Nearby city centers--Nkombo -Gihundwe -Nkanka -Kamembe, Crossing River now-Boat / Bakoresha ubwato, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 5 m-The proposed bridge span is 900 m-The level difference between two banks is approximately 2m.-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the site-The lake bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is silt for both sides-The site is located between two hills.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45399,
  //       "proposed_bridge_location_gps_longitude": 28.89774,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The span would be exceeding 500 m",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusayo",
  //       "bridge_opportunity_stage": "Confirmed",
  //       "bridge_opportunity_project_code": "1007661",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.697308,
  //       "bridge_opportunity_gps_longitude": 29.029517,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 25,
  //       "bridge_opportunity_individuals_directly_served": 17270,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:962m, Cell:Nyange, Injuries/Death-Many peoples was injured while trying crossing the river./ No person died while crossing the river Cross river on a normal day-50-150 people, Nearby city centers--Bugarama, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-Sector/ umurenge,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing crossing point at a distance of 10 m-The proposed bridge span is 37 m-The level difference between two banks is approximately the same.-The space for foundations is sufficient -The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the site-The river bed at the site is unstable, there is a possibility of erosion.-The river bank of the site is showing sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides-The site is located between two flat areas.",
  //       "form_form_name": "Project Assessment - 2018.12.13",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.697308,
  //       "proposed_bridge_location_gps_longitude": 29.029517,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "April to May , October to December, 24 hours",
  //       "market_access_blocked_by_river": "rice farming ( village 1,2).",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming and livestock",
  //       "primary_crops_grown": "maiz, mango, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population information of each village was provided by cell leader, Bisengimana Vincent. The community members from villages 1 and 2 use the crossing to do farming only. Others circulation they use the other bridge in 300 m away",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community do not need a bridge because there will be no body to use the bridge. The nearest crossing is less than 300 meters.",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rungunga",
  //       "bridge_opportunity_stage": "Confirmed",
  //       "bridge_opportunity_project_code": "1007662",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.6668,
  //       "bridge_opportunity_gps_longitude": 29.00909,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 2471,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Cell:Cyarukara, Injuries/Death-3 amazi yaruzuye abageraho mu nkengero z'umugezi/ 1 yishwe n'amazi Cross river on a normal day-50-150 people, Nearby city centers-Murira, Crossing River now-Walking through river / Banyura mumazi, Impossible/Dangerous to cross the river-9-12 months / Hagati y?amezi icyenda na cuminabiri,Travel to nearest safe bridge/river crossing-< 1 hour / Munsi y?isaha imwe,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-sandy/ Umucanga,Sand-,Gravel-,Stone-,Timber-,Stone provided by-,Sand Provided by-,Gravel provided by-,Timber provided by-,Cement provided by-,Reinforcement steel provided by-,Land ownership-, Land ownership permission-, General Comments",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6668,
  //       "proposed_bridge_location_gps_longitude": 29.00909,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Pass alonf6way in 3km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Bugarama market",
  //       "education_access_blocked_by_river": "Nzahaha high school",
  //       "health_access_blocked_by_river": "Muganza health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They died trying to cross when the river was flooded",
  //       "notes_on_social_information": "Rungunga don't have access to muganza market and bugarama market Information gathered from cyarukara leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-cimerwa",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabugarama",
  //       "bridge_opportunity_stage": "Confirmed",
  //       "bridge_opportunity_project_code": "1007663",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.584342,
  //       "bridge_opportunity_gps_longitude": 28.971386,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 8,
  //       "bridge_opportunity_individuals_directly_served": 3414,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Cell:Cyingwa na Gahungeri, Injuries/Death-2 bakomeretse umwe yahurudutse ku mugogo undi yatwawe n'amazi/ hapfuye 2, umwe yatwawe n'amazi undi ahuruduka ku mugogo Cross river on a normal day-300-600 people, Nearby city centers-Kaninda na Mubuga, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-1-2 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-2-6 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-1-2 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Cell/ akagari,Sand Provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Gravel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Timber provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments",
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.584342,
  //       "proposed_bridge_location_gps_longitude": 28.971386,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 1 hour",
  //       "market_access_blocked_by_river": "Gishoma market ( 1,2), Nyakabuye market( 3,4) Bugarama market ( 3), cyingwa coffee washing station ( 3,4), farms ( 1,2,3,4).",
  //       "education_access_blocked_by_river": "Mpinga primary school( 3,4).",
  //       "health_access_blocked_by_river": "Cyingwa health center ( 3,4), Mibilizi hospital ( 3,4).",
  //       "other_access_blocked_by_river": "Mibilizi church, cyingwa church ( 3,4), Mubuga shops center( 3,4).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, coffe",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by cyingwa cell leader, IYAMUREMYE who sourced the population information from cell register in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama ~ kamembe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 28,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IFAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasovu",
  //       "bridge_opportunity_stage": "Confirmed",
  //       "bridge_opportunity_project_code": "1007664",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.89261,
  //       "bridge_opportunity_gps_longitude": 29.3735,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 24,
  //       "bridge_opportunity_individuals_directly_served": 2135,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1879m, Cell:Gatare-Mburamazi, Injuries/Death-Many peoples injured while crossing the river./ More than two peoples died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Gatare -Gasovu, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 45m.-The level difference between two banks is 005m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between an elevated area and a flat area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.89261,
  //       "proposed_bridge_location_gps_longitude": 29.3735,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Gisiza market and nkomero market",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Adepr church at gatoki and Mosce at gakeri",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Because the current timber bridge is at high elevation people slip and fell down",
  //       "notes_on_social_information": "The market is at ruhango and gasovu and kabeza villages dont have access to it and gatoki village dont have acces to farms and information gathered from gasovu village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkomero",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ntaruko",
  //       "bridge_opportunity_stage": "Confirmed",
  //       "bridge_opportunity_project_code": "1007665",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -2.03645,
  //       "bridge_opportunity_gps_longitude": 29.41441,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 22,
  //       "bridge_opportunity_individuals_directly_served": 2590,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1601m, Cell:Kabuga, Injuries/Death-Many peoples injured while crossing the bridge./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Rubengera -Kibirizi, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 20m.-The proposed bridge span is approximately 57m.-The level difference between two banks is 0.01m(Almost the same).-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.03645,
  //       "proposed_bridge_location_gps_longitude": 29.41441,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three weeks",
  //       "market_access_blocked_by_river": "Rubengera",
  //       "education_access_blocked_by_river": "Rubengera technical school and gihara primary school",
  //       "health_access_blocked_by_river": "Rubengera health center",
  //       "other_access_blocked_by_river": "Churches at rubengera",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "They fell during rainy season and sink",
  //       "notes_on_social_information": "Sanzare village don't have access to the rubengera market, rubengera hospital and rubengera school while nyabitare village don't have access to the farms and right bank and the population and data was obtained from Kabanda victory kabahigi village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubengera",
  //       "name_of_nearest_paved_or_sealed_road": "Rubengera-kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 120,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kumizero",
  //       "bridge_opportunity_stage": "Confirmed",
  //       "bridge_opportunity_project_code": "1007666",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.89091,
  //       "bridge_opportunity_gps_longitude": 29.37094,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 16,
  //       "bridge_opportunity_individuals_directly_served": 1506,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1874m, Cell:Nyakarera-Gatare, Injuries/Death-Many peoples injured while crossing the river./ One person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Gatare -Gasovu, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 40m.-The level difference between two banks is 0.8m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between an elevated area and a flat area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.89091,
  //       "proposed_bridge_location_gps_longitude": 29.37094,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Ruhango market,gakeri and nkomero market",
  //       "education_access_blocked_by_river": "Nine",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Adepr gasovu and paruwase murunda",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One person died in past four years when he was crossing the bridge at first bridge location",
  //       "notes_on_social_information": "Gasovu village and kabeza village both don't have access to markets [ruhango market (kabeza), gakeri market market (gasovu)] information for each village was provided by gasovu village leader and is the one who gave me the information regarding site",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkomero",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 80.8,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibara",
  //       "bridge_opportunity_stage": "Confirmed",
  //       "bridge_opportunity_project_code": "1007674",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.92899,
  //       "bridge_opportunity_gps_longitude": 29.4801,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 1750,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:2301m, Cell:Remera, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Rusebeya, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5-1 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two hills.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92899,
  //       "proposed_bridge_location_gps_longitude": 29.4801,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nyagasambu market",
  //       "education_access_blocked_by_river": "Kabona secondary school",
  //       "health_access_blocked_by_river": "Kabona health center",
  //       "other_access_blocked_by_river": "ADPR and cothoric church [One on each side]",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "irish potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "People fall in the river when flooded but no one died",
  //       "notes_on_social_information": "Information gathered from kibars leader. Kibara don't have access to kabona health center and bungwe don't have access to kabona market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 90,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinyempanda",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1007678",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -2.02475,
  //       "bridge_opportunity_gps_longitude": 29.41743,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 10,
  //       "bridge_opportunity_individuals_directly_served": 1806,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:1685m, Cell:Kabuga, Injuries/Death-No person injured while crossing the bridge./ No person died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Rubengera, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Private landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 1m.-The proposed bridge span is approximately 20m.-The level difference between two banks is 0.01m(Almost the same).-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between two flat areas.-The soil from the site is silt for both sides. \"Previously recorded GPS incorrect(-2.0285556,28.4155556);unable to find the correct precise location of the bridge site, but the approximate location is -2.031881°, 29.4314°), found by adding Rwanda Topographic Map to ArcMap and calculating the value of points x and y of the attribute table \"",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.02475,
  //       "proposed_bridge_location_gps_longitude": 29.41743,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Rubengera market",
  //       "education_access_blocked_by_river": "Rubengera school",
  //       "health_access_blocked_by_river": "Rubengera hospital",
  //       "other_access_blocked_by_river": "Kabeza church and gihara church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "One died in 2000 and now there is a girl who fell in the river and she is still in hospital",
  //       "notes_on_social_information": "Miraramo village don't have access to farm and churches while gakomeye village don't have access to rubengera market and schools at rubengera and hospital at rubengera. Data collected from havugiman Jean Claude security leader at miraramo",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubengera",
  //       "name_of_nearest_paved_or_sealed_road": "Rubengera-kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IUAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kazirankomo",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1007679",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.954166,
  //       "bridge_opportunity_gps_longitude": 29.3577,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 13,
  //       "bridge_opportunity_individuals_directly_served": 3000,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1589m, Cell:Gisiza-Nyarubuye, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Musasa -Gasutamo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Clay / Ibumba,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 2m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.954166,
  //       "proposed_bridge_location_gps_longitude": 29.3577,
  //       "current_crossing_method": "Three timber logs",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36",
  //       "market_access_blocked_by_river": "Congo nile",
  //       "education_access_blocked_by_river": "Gihango primary school and groupe scolaire de la paix secondary school",
  //       "health_access_blocked_by_river": "Congo Nile hospital and musasa",
  //       "other_access_blocked_by_river": "Paruwase Congo nile",
  //       "primary_occupations": "Planting of pine apple",
  //       "primary_crops_grown": "pine appl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Many years in 1994 a teacher fell in the river",
  //       "notes_on_social_information": "Information gathered from local people and nyagahinga village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rutsiro",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-rutsiro",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 34.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ntora",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1007680",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.916403,
  //       "bridge_opportunity_gps_longitude": 30.04942,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": 400,
  //       "bridge_opportunity_individuals_directly_served": 6000,
  //       "bridge_opportunity_comments": "6000-10000 people directly served, Elevation:1370m, Cell:Karurimbura, Injuries/Death-No person injured while trying to cross the river/ No person died while trying to cross the river Cross river on a normal day-300-600 people, Nearby city centers-Nyabugogo, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-0.5 hours,Hours walking to reach the Health Center-0.5 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Available / birahaboneka,Stone-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Timber-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 5m.-The proposed bridge span is approximately 430m.-The level difference between two banks is 0.006m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is unstable, there is possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9331389,
  //       "proposed_bridge_location_gps_longitude": 30.0493999,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "20 kilometers",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "Nyabugogo Market (Gisozi) carpentry workshop (Gatsata)",
  //       "education_access_blocked_by_river": "Gatsata primary school (Gisozi)",
  //       "health_access_blocked_by_river": "Muhima health center and Hospital (Gisozi) but they don't use this bridge",
  //       "other_access_blocked_by_river": "Taxi park Nyabugogo (Gisozi)",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They was trying to cross the bridge and found died",
  //       "notes_on_social_information": "People who work closer to bridge in farms",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "On right side there is a wetland of 300 meters which is flooded and they can not pass during rain season.",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86IWAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Baramba",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1007897",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.75261,
  //       "bridge_opportunity_gps_longitude": 29.81207,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 103,
  //       "bridge_opportunity_individuals_directly_served": 4032,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.75261,
  //       "proposed_bridge_location_gps_longitude": 29.81207,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Rutabu market",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "Coko hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Peo0le died whe. River was flooded",
  //       "notes_on_social_information": "Information gathered from baramba leader Mucumazo village dont have access to baramba village and health center",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rushashi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 95,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5VQsAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirwa",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1009702",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.61168,
  //       "bridge_opportunity_gps_longitude": 30.15833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1789,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61168,
  //       "proposed_bridge_location_gps_longitude": 30.15833,
  //       "current_crossing_method": "timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometers away",
  //       "days_per_year_river_is_flooded": 38,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Market on right side, farms on both side",
  //       "education_access_blocked_by_river": "Nusery, Primary and secondary school on right side,",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Churches on both side,",
  //       "primary_occupations": "Market, school, health center, farms",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "An old man was trying to cross the bridge when it was flooded",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and one of them was community leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 62,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMJxuAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sunzu",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1009703",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.60178,
  //       "bridge_opportunity_gps_longitude": 30.15318,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 612,
  //       "bridge_opportunity_comments": "Sunzu Bridge links Sunzu and Remera village in rebero cell,Sunzu Bridge serves the community on both sides espescially farmers",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.60178,
  //       "proposed_bridge_location_gps_longitude": 30.15318,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge three kilometers away",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Market and farms on both side,",
  //       "education_access_blocked_by_river": "Nursery on left side",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Church on right side",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": "bean, soghrom",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMJy4AAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bugomba",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1009704",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.44911,
  //       "bridge_opportunity_gps_longitude": 30.04685,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2294,
  //       "bridge_opportunity_comments": "in Sept/2017 more person injured when trying to cross the river",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.44911,
  //       "proposed_bridge_location_gps_longitude": 30.04685,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Markert and farms on both side, tea factor on right side,",
  //       "education_access_blocked_by_river": "Primary and secondary school on right side",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Potable water on left side, churches on both side,",
  //       "primary_occupations": "School, market,churches,",
  //       "primary_crops_grown": "bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and they come to different places",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMJysAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiruhura",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1009705",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.464697,
  //       "bridge_opportunity_gps_longitude": 30.056749,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1185,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.464697,
  //       "proposed_bridge_location_gps_longitude": 30.056749,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in one kilometer away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Murindi market and Tea factor and business center (Kariba )",
  //       "education_access_blocked_by_river": "Gatumba primary and secondary school (Kariba and Bwanika)",
  //       "health_access_blocked_by_river": "Murindi health center( Kaniga)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farms, schools,",
  //       "primary_crops_grown": "tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge and other closing the bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Byumba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMJz7AAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ndarama",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1009706",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.46305,
  //       "bridge_opportunity_gps_longitude": 30.0909,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1523,
  //       "bridge_opportunity_comments": "Rushaki Catholic Church, Rushaki Secondary School and Rushaki Health Center are the Primary Social services that are accessed by the community using Ndarama Bridge. When the river flood peoaple should pass on a vehicular Bridge located in 1km from Ndarama Bridge.When Ngoma River floods it takes several days to reach on the normal level. In the 3 recent years one student died trying to cross Ngoma River.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.46305,
  //       "proposed_bridge_location_gps_longitude": 30.0909,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one Kilometer away",
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Market on right side, farm on both side",
  //       "education_access_blocked_by_river": "Primary and secondary school on right side",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Football terrain on left side, church on right side, potable water on right side",
  //       "primary_occupations": "School, health side, church on right side",
  //       "primary_crops_grown": "bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They were children who were watching how it was flooded",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 59.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMJzCAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigoma",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1009707",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.65897,
  //       "bridge_opportunity_gps_longitude": 30.114,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3350,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65897,
  //       "proposed_bridge_location_gps_longitude": 30.114,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "For the rain season it always flooded in April and May, October and November and it can take two days",
  //       "market_access_blocked_by_river": "Market, farms on both side",
  //       "education_access_blocked_by_river": "Primary and secondary school on both side, nursery on left side, for right side, it is under construction",
  //       "health_access_blocked_by_river": "Health center on both side, hospital on left side",
  //       "other_access_blocked_by_river": "Church on left side, potable water on both side but they normally use one of the right side",
  //       "primary_occupations": "Market, farms, school on both side, churches on left side",
  //       "primary_crops_grown": "bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 78,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMJzqAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugaragara-Mayogi",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1009710",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.7012,
  //       "bridge_opportunity_gps_longitude": 30.20941,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1060,
  //       "bridge_opportunity_comments": "in September /2017 one person died while tried crossing the river",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.7012,
  //       "proposed_bridge_location_gps_longitude": 30.20941,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "4",
  //       "market_access_blocked_by_river": "Markets, farms on both side, coffee factor on left",
  //       "education_access_blocked_by_river": "Nusery, Primary and secondary on both side",
  //       "health_access_blocked_by_river": "Health center and post health center on both side",
  //       "other_access_blocked_by_river": "Potable water on left side, churches on both side, football terrain",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "banana plantain, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Old man was trying to cross the bridge and it was flooded",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMK0PAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamutore Barrage",
  //       "bridge_opportunity_stage": "Prospecting",
  //       "bridge_opportunity_project_code": "1009711",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.47875,
  //       "bridge_opportunity_gps_longitude": 30.10468,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1796,
  //       "bridge_opportunity_comments": "Kamutora Bridge serves the community mostly tea farmers and student of Kamutora Primary School and also the community can access Rushaki market and Gihengeli market by the use of Kamutora bridge . There is some timbers but not strong,the nearest crossing point is located in 2km. When the Ruhita River floods,it takes 1day for the water to be at a normal level.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.47875,
  //       "proposed_bridge_location_gps_longitude": 30.10468,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Seven days",
  //       "market_access_blocked_by_river": "Market on right side, farms on both side",
  //       "education_access_blocked_by_river": "Nursery and primary school on left side, primary and secondary school on right side",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Churches on both side, potable water on right side",
  //       "primary_occupations": "Market, school , farms, health center, churches",
  //       "primary_crops_grown": ", bean, maiz, tea",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "They were trying to cross the river, one died and other was handicapped until now",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and one of them was community leader of Kamutore",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMK0jAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngabira munsi y umurenge",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1009712",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.44522,
  //       "bridge_opportunity_gps_longitude": 30.08827,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.44522,
  //       "proposed_bridge_location_gps_longitude": 30.08827,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 24,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Market on left side and farm on both side",
  //       "education_access_blocked_by_river": "Nursery, Primary and secondary school on both side",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Potable water on right side, churches on both sides, sector office on left side",
  //       "primary_occupations": "Sector office, farms",
  //       "primary_crops_grown": "bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They were trying to cross the bridge when it was flooded, one was child and another a man",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 59,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMK0oAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamugari",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1009713",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.55224,
  //       "bridge_opportunity_gps_longitude": 30.16326,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 574,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.55224,
  //       "proposed_bridge_location_gps_longitude": 30.16326,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge four kilometers away",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Market both side, farms both",
  //       "education_access_blocked_by_river": "Primary and nusery school on left side, secondary school on right side,",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Potable water on left , churches on both side,",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "She was trying to cross the bridge when it was flooded",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and one of them was community leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMK1IAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rurenge",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1009715",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.51969,
  //       "bridge_opportunity_gps_longitude": 30.15237,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1326,
  //       "bridge_opportunity_comments": "Rurenge Bridge links Bwisige and Mukama Sector of Nyagatare district. Rurenge Bridge is made of three timbers. Akatuzura River doesn't flood because of it's depth ,it has arround 4m deep that makes the community to fear while crosssing . Rurenge bridge is located in Nyagatare district but links 56 families from Bwisige Sector use it in their daily life to access Gihengeli market and any other social services from Bwisige sector. There is no other crossing point other than to first pass to Nyagatare in order to get other rest areas of Bwisige sector. and also Rurenge Bridge is made of no strong timber. Rurenge village has 56 families in isolated areas.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.51969,
  //       "proposed_bridge_location_gps_longitude": 30.15237,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Market on left side, business center on left side",
  //       "education_access_blocked_by_river": "Primary and secondary school on left side",
  //       "health_access_blocked_by_river": "Health center on left side",
  //       "other_access_blocked_by_river": "Churches on left side",
  //       "primary_occupations": "Market, health center, school, farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He became handicappe",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMK1cAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murehe",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1009716",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.54881,
  //       "bridge_opportunity_gps_longitude": 30.13056,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 580,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.54881,
  //       "proposed_bridge_location_gps_longitude": 30.13056,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "5",
  //       "market_access_blocked_by_river": "Market and farms on both side",
  //       "education_access_blocked_by_river": "Nursery, Primary and secondary school on both side",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Potable water on right side, churches on right side,",
  //       "primary_occupations": "Health center , schools, farms, market",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "A child was tried to cross the bridge when it was flooded",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bMK1dAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitagara 2",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1009857",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.12042,
  //       "bridge_opportunity_gps_longitude": 29.6838,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "The current crossing point is made off of log timber bridge. In 2015, One people died while crossing the river and it is not flooded as before due to irrigation channel. The community from Gitaraga 1 can also access Gitagara 2 bridge once it is constructed. The site also called MIGURAMO",
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12042,
  //       "proposed_bridge_location_gps_longitude": 29.6838,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 ( Kigali - Huye - Akanyaru)",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge 100 meters downstream. See \"other site obstructions\" for more info.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bNTvYAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukuge",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1010404",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.682028,
  //       "bridge_opportunity_gps_longitude": 29.703194,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.682028,
  //       "proposed_bridge_location_gps_longitude": 29.703194,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge , currently vehicle like tracks are crossing through water",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://app.box.com/folder/13209470119",
  //       "bridge_opportunity_casesafeid": "006f100000bge1qAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mbuye",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1010405",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.751556,
  //       "bridge_opportunity_gps_longitude": 29.717861,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.751556,
  //       "proposed_bridge_location_gps_longitude": 29.717861,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is a planned vehicular bridge on this site",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://app.box.com/folder/11216408520",
  //       "bridge_opportunity_casesafeid": "006f100000bge3IAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Satinsyi",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1010406",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.75995,
  //       "bridge_opportunity_gps_longitude": 29.66276667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.8",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.75995,
  //       "proposed_bridge_location_gps_longitude": 29.66276667,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero- Muhanga",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicle bridge is planned to be constructed ,there was also a vehicle bridge which destroyed",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bge7oAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1010409",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.17554,
  //       "bridge_opportunity_gps_longitude": 30.69667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2246,
  //       "bridge_opportunity_comments": "The site is suitable for a strong/sustainable vehicular bridge. It is visible that the river floods during the rainy season at 0.3m over the existing bridge. The water lever goes back at the normal level within 1hour or 2hours.",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.17554,
  //       "proposed_bridge_location_gps_longitude": 30.69667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Gafunzo Market (2,3,4), Farms (1,2,3,4)",
  //       "education_access_blocked_by_river": "Mwendo Primary and Secondary School (Community 2,3,4)",
  //       "health_access_blocked_by_river": "Mwendo Health Center (Community 2,3,4)",
  //       "other_access_blocked_by_river": "Mwendo Sector office, Mwendo Catholic, Adventist and ADEPR Churches (Community 2,3,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ruhamagariro, Gasharu, Gaseke and Ruhondo villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and farms. The population information for each village was provided by the Saruheshyi Cell Leader and Gasharu village leader, Déogratias, from the population data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhanga town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bgsNQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhondo",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1010410",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.19008333,
  //       "bridge_opportunity_gps_longitude": 29.71277778,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 60,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. River is too small to warrant B2P bridge. Vehicular bridge under construction.",
  //       "form_form_name": "Project Pre-Assessment - 2018.8.24",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "A vehicle bridge is currently under construction (July 31, 2018)",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bgtSnAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gaseke",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1010411",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.16658,
  //       "bridge_opportunity_gps_longitude": 29.70104,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1497,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.16658,
  //       "proposed_bridge_location_gps_longitude": 29.70104,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 5,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Gafunzo market, Gafunzo Rice factory",
  //       "education_access_blocked_by_river": "Mwendo and Rugeyo Primary School",
  //       "health_access_blocked_by_river": "Mwendo Health Centre",
  //       "other_access_blocked_by_river": "Mwendo Sector, Mwendo Catholic Church, Mwendo Adventist Church",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders of communities that will directly benefit from the bridge.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ruhango",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali- Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bgtaSAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Miguramo 1",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1010423",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.12023,
  //       "bridge_opportunity_gps_longitude": 29.6893,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1081,
  //       "bridge_opportunity_comments": "December,2017 The river is narrow and it's height is not deep, when it is flooded it doesn't go beyond the bridge. Also it is near of Miguramo bridge 2",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12023,
  //       "proposed_bridge_location_gps_longitude": 29.6893,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "1 week",
  //       "market_access_blocked_by_river": "MUTARA and Muhanga Market",
  //       "education_access_blocked_by_river": "Giseke primary and secondary school",
  //       "health_access_blocked_by_river": "MUTARA health center",
  //       "other_access_blocked_by_river": "MUTARA health center",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye- Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bgzS3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiryango",
  //       "bridge_opportunity_stage": "Identified",
  //       "bridge_opportunity_project_code": "1010428",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.15158,
  //       "bridge_opportunity_gps_longitude": 30.65636,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3613,
  //       "bridge_opportunity_comments": "Unrejected by BAJ on 10-30-18",
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.15158,
  //       "proposed_bridge_location_gps_longitude": 30.65636,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Buhanda and Gafunzo markets (Community 4), Mutara market (Community 1,2,3,5), Farms (Community 1,2,4,5)",
  //       "education_access_blocked_by_river": "Mutara Primary and Secondary School (Community 1,2,5)",
  //       "health_access_blocked_by_river": "Gitwe Hospital (Community 4)",
  //       "other_access_blocked_by_river": "Ruhango town and Mwendo Sector Office (Community 4), Nyarutovu ADEPR and Adventist Churches (Community 1,2,3,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "4 people have died trying to cross the river and more than ten people were seriously injured.",
  //       "notes_on_social_information": "Nyarutovu, Ruhuha, Gasiza, Muyunzwe and Karambo villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and farms. The population information for each village was provided by the Muyunzwe Cell Leader and Ruhuha village leader, André, from the population data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhanga town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": 1.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000bh0WYAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryakwata",
  //       "bridge_opportunity_project_code": "1010572",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.57746,
  //       "bridge_opportunity_gps_longitude": 30.13654,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 700,
  //       "bridge_opportunity_comments": "We find that Ryakwata Bridge has some timbers but not strong . Ryakwata bridge serves the community to access Gihengeli market,Mukono Poste de Sante and also Mukono Primary School Students.",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.57746,
  //       "proposed_bridge_location_gps_longitude": 30.13654,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Market on right side, school on right side, farms on both side,",
  //       "education_access_blocked_by_river": "Primary and secondary school on right side",
  //       "health_access_blocked_by_river": "Health center On both side",
  //       "other_access_blocked_by_river": "Churches both side, potable water on right side",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Gatuna Kigali",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biK9AAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwarurema",
  //       "bridge_opportunity_project_code": "1010573",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.59687,
  //       "bridge_opportunity_gps_longitude": 30.15019,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1100,
  //       "bridge_opportunity_comments": "Rwaruremera Bridge serves the community especially Bisika Secondary School student and the community in general to access Rebero Market, Bisika maarket and Bisika poste de santé. Rwaruremera has some timbers that help the community. No injury,no death that happens on this bridge",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59687,
  //       "proposed_bridge_location_gps_longitude": 30.15019,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Market both side, farms both side, business center",
  //       "education_access_blocked_by_river": "Primary and secondary school both side",
  //       "health_access_blocked_by_river": "Health center on both side",
  //       "other_access_blocked_by_river": "Churches both side, potable water on left side,",
  //       "primary_occupations": "Market, school, health center, farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Information was given by the people lived closer to the river and existing crossing bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biK9KAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagatoma",
  //       "bridge_opportunity_project_code": "1010574",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.564607,
  //       "bridge_opportunity_gps_longitude": 30.107231,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6200,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Nyagatoma Bridge is made of 2 timbers that are not strong , those timbers help people from Nyabushingitwa , Mikono Secondary School. When the river floods the nearest crossing point is located at 3km from Nyagatoma bridge and 1km to Mukarange Bridge.TheRiver water appear periodically mostly in rainy season you can't find water in sunny season no injuries or death on this site.",
  //       "form_form_name": "Project Assessment - 2018.2.2",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.564607,
  //       "proposed_bridge_location_gps_longitude": 30.107231,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Duanne bridge",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Duanne market,Byumba market and Warufu market",
  //       "education_access_blocked_by_river": "Mokono secondary school",
  //       "health_access_blocked_by_river": "Mukono health center",
  //       "other_access_blocked_by_river": "Movement of community",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-gatuna",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 2.5,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biK9rAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryakirayi",
  //       "bridge_opportunity_project_code": "1010575",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.565258,
  //       "bridge_opportunity_gps_longitude": 30.110382,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 400,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. It is a place in which there was an extraction of clay nearby there is a football ground,normally it is not a river.It is a small drainage channel for irrigation.",
  //       "form_form_name": "Project Assessment - 2018.2.2",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.565258,
  //       "proposed_bridge_location_gps_longitude": 30.110382,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biK9wAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugiziza",
  //       "bridge_opportunity_project_code": "1010576",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.554772,
  //       "bridge_opportunity_gps_longitude": 30.129922,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3250,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Gahondo Bridge links Gicumbi District Gatsibo District at Warufu river on Bwisige and Mukono sectors. Gahondo Bridge allow people from both side either Gatsibo or Gicumbi to access Mukono Health Center,Ndayabana Primary School and Gahengeli market.Warufu River does not flood and Mugisiza Bridge has timbers that help the community to cross Warufu River safely.",
  //       "form_form_name": "Project Assessment - 2018.2.2",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.554772,
  //       "proposed_bridge_location_gps_longitude": 30.129922,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Warufu bridge",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Gicumbi market, Gihengeri market, Rebero market and Warufu market",
  //       "education_access_blocked_by_river": "Mukono secondary school",
  //       "health_access_blocked_by_river": "Mukono health center",
  //       "other_access_blocked_by_river": "Praying to Gihuke Catholic church",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, sweet poteto, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "The two children died when they came to fetch water after it was raining in 2015.",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-gatuna",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 4,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biKA1AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahondo",
  //       "bridge_opportunity_project_code": "1010577",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.539721,
  //       "bridge_opportunity_gps_longitude": 30.127624,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1867,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.53982,
  //       "proposed_bridge_location_gps_longitude": 30.12754,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Pedestrian bridge one kilometer",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Market on left side, farms on both side,",
  //       "education_access_blocked_by_river": "Primary on right side and secondary school on left side",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Cell and sector and officer on right side",
  //       "primary_occupations": "health center on right side, school and churches on both side, cell and sector and officer on right side, Market on left side",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They were trying to cross the bridge and most on them, they became handicappe",
  //       "notes_on_social_information": "Information given by people who live closer to the bridge and they are from different village who used this bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Gatuna Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 71,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biKABAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwangaruye",
  //       "bridge_opportunity_project_code": "1010578",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.675363,
  //       "bridge_opportunity_gps_longitude": 30.097712,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 2940,
  //       "bridge_opportunity_comments": "Kwangaruye Bridge has two non strong timbers that help the community to cross Mwange River. Kwangaruye Bridge links Nyamiyaga and Mutete Sector. Mutete health center,Mugina Secondary School is accessed by the use of Kwangaruye Bridge,The nearest crossing point is a vehicular bridge located in 2km from Kwangaruye Bridge.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.675363,
  //       "proposed_bridge_location_gps_longitude": 30.097712,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Rukomo business center and market (Maya) , Rusumo Business center (Maya)",
  //       "education_access_blocked_by_river": "Mugina primary and secondary school ( Rusumo)",
  //       "health_access_blocked_by_river": "Byumba Hospital (Maya)",
  //       "other_access_blocked_by_river": "District office (Maya)",
  //       "primary_occupations": "Farms, Market, school",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who live closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Byumba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biKALAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mwishogwe-nyirarushyunda",
  //       "bridge_opportunity_project_code": "1012696",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.49157,
  //       "bridge_opportunity_gps_longitude": 29.42108,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2759,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.49157,
  //       "proposed_bridge_location_gps_longitude": 29.42108,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "25 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "During April and May and it last about 2 hours after rainfall",
  //       "market_access_blocked_by_river": "Union forest company on the left side, farming on both sides of the river",
  //       "education_access_blocked_by_river": "Primary school at the left",
  //       "health_access_blocked_by_river": "Health center at Subukiniro (LHS of the river)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Charcoal production, farming",
  //       "primary_crops_grown": ", potato, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fall down and broken, however they had no permanent disability",
  //       "notes_on_social_information": "Names of communities, numbers served, Injuries, HWL were given by people nearby the river",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 59,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhyaYAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivugiza (nyange)",
  //       "bridge_opportunity_project_code": "1010579",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.66842,
  //       "bridge_opportunity_gps_longitude": 30.100122,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 2050,
  //       "bridge_opportunity_comments": "Kivugiza Bridge has 2 timbers that help the community to cross biziba river Kivugiza Bridge serves mostly Mugina Seconary school Student from Rusumo village and the community from Gahumuriza cell to access Rusumo Poste de santé, Gaseke,Rusumo and Gicumbi Market.The alternative crossing point is Mugina Bridge in 2.5 km but also this Mugina bridge is not safe,the water surpass the bridge in case Mwange River floods.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66842,
  //       "proposed_bridge_location_gps_longitude": 30.100122,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometers away",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Rukomo Market and business center (Maya and Mugina)",
  //       "education_access_blocked_by_river": "Mugina primary and secondary school ( Musanze and Kabuga)",
  //       "health_access_blocked_by_river": "Byumba Hospital (Maya and Mugina)",
  //       "other_access_blocked_by_river": "District office (Maya and Mugina)",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Byumba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biKAaAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kavuruga",
  //       "bridge_opportunity_project_code": "1010580",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.575188,
  //       "bridge_opportunity_gps_longitude": 30.144215,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1460,
  //       "bridge_opportunity_comments": "BAJ confirms rejeciton. It is a vehicular bridge that needs to be repaired",
  //       "form_form_name": "Project Assessment - 2018.2.2",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.575188,
  //       "proposed_bridge_location_gps_longitude": 30.144215,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Gihengeri market",
  //       "education_access_blocked_by_river": "Cyeye primary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, sorgo, sweet poteto",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "3 days",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 3,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biKAfAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiruruma",
  //       "bridge_opportunity_project_code": "1010581",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.58735,
  //       "bridge_opportunity_gps_longitude": 30.14216,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 832,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.58735,
  //       "proposed_bridge_location_gps_longitude": 30.14216,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Market on both side, farms,",
  //       "education_access_blocked_by_river": "Primary and secondary both side, and nursery to the right side",
  //       "health_access_blocked_by_river": "Health center to both side",
  //       "other_access_blocked_by_river": "Churches on both side, business centers on both site",
  //       "primary_occupations": "School, business, market",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They was trying to cross the river",
  //       "notes_on_social_information": "Pastor and",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53.8,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biKAkAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhango",
  //       "bridge_opportunity_project_code": "1010583",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.65891,
  //       "bridge_opportunity_gps_longitude": 30.114194,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1150,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Ruhango Bridge links Nyamiyaga and Mutete Sector. Ruhango Bridge is accessd by Mugina Secondary School Students and people from Nyamiyaga that go to take bus from Gicumbito kigali or from Gicumbi -Gatuna to kampala and Mutete Health Center. The nearest crossing point is Karambo Bridge and it takes 2 hours to reach on Karmbo Bridge. Currentlyt people pass through the water, the span goes beyond Bridges toProsprity standard , there is a Dam that gerates power and also there is an electrical transportation closer to the site. From photos in Project Assessment, the project is too small and would not call for a B2P style bridge. -BAJ",
  //       "form_form_name": "Project Assessment - 2018.2.2",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65891,
  //       "proposed_bridge_location_gps_longitude": 30.114194,
  //       "current_crossing_method": "Jumping",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Irwanda market ,Rukomo market and Gicumbi market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, sweet poteto",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 2,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000biKAuAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasunzu",
  //       "bridge_opportunity_project_code": "1010839",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.506683,
  //       "bridge_opportunity_gps_longitude": 30.023419,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 950,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. River is too small to warrant B2P bridge. Gasunzu Bridge links Manyagiro and Cyumba sectors, Mugera river has 2.5m of span and pass in a tea land, people from Cyumba move for health center located at Manyagiro Sector. Now Gasunzu bridge has been destroyed by the floods in the recent rain period. The bridge is a short-cut way from Manyagiro sector to Cyumba in case of flood the community have the alternative way by the use of main paved road Kigali -Gatuna in 0.3 km downstream",
  //       "form_form_name": "Project Assessment - 2018.2.23",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.506683,
  //       "proposed_bridge_location_gps_longitude": 30.023419,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "-",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Cyumba market, Yaramba market, Murindi market",
  //       "education_access_blocked_by_river": "Maya primary school and Cyumba-Manyagiro secondary school",
  //       "health_access_blocked_by_river": "Manyagiro and Cyumba-Manyagiro health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 3.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V2bAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare",
  //       "bridge_opportunity_project_code": "1010840",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.455716,
  //       "bridge_opportunity_gps_longitude": 30.0494,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1590,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. River is too small to warrant B2P bridge. Gatare Bridge is on a big ditch in the road which was widened by the erosion. We were informed that this bridge was used by vehicles before the erosion extended the width of the ditch. This means that Gatare Bridge needs a vehicular bridge than footbridge. The actual timber bridge is very narrow which serves only pedestrian (community from Rukururana cell especially students of Bugomba secondary school and EAR church members). The alternative crossing point is in 2km from Gatare Bridge.",
  //       "form_form_name": "Project Pre-Assessment - 2018.8.20",
  //       "form_created_by": "Kyle Shirley",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Local timber bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": null,
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The residents said they can always cross the existing bridge and the existing bridge can also be crossed by motos.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V2gAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahanda",
  //       "bridge_opportunity_project_code": "1010842",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.621819,
  //       "bridge_opportunity_gps_longitude": 30.165954,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2400,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Vehicle bridge 100m away. Gahanda Bridge is on Warufu River ,there are some timbers that help people to cross the river but those timbers should not stay there for long time due thefrequent floodings. Gahanda Brigde help the community to access Rebero market,Nyarubuye Secondary School,Rebero Commercial Center. The nearest way that should be used in case of floodings is in0.1km upstream from Gahanda bridge. The community use Gahanda Bridge especially the ones come to Rebero Market because it is a short-cut way,it can not take even 10 minutes to reach the Rebero concrete bridge.",
  //       "form_form_name": "Project Assessment - 2018.2.23",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.621819,
  //       "proposed_bridge_location_gps_longitude": 30.165954,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "100 m",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": "Rebero market",
  //       "education_access_blocked_by_river": "Rebero secondary school and college de Rebero",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, bean, maïz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "It was rained and the water were up to reach the bridge and it felt some community to loose stability and felt down in the river",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 3,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V2qAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubande-Gatobotobo",
  //       "bridge_opportunity_project_code": "1010843",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.6623,
  //       "bridge_opportunity_gps_longitude": 30.08107,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1353,
  //       "bridge_opportunity_comments": "Nyarubande Bridge is made of two timbers. Oftenly, Mwange River become impassable in the rainy season due to flooding and those timbers washed away by the floods. The problem is to find replacement timbers to cover Mwange River's span frequently. 1000-3000 people directly served, Elevation:1781m, Cell:kabuga-Mutandi, Injuries/Death-Many peoples injured while crossing the river./ Two peoples died while trying to cross the river. Cross river on a normal day-300-600 people, Nearby city centers--Mwange, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-0.5 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-hard rock/ Urutare,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 7m.-The proposed bridge span is approximately 58m.-The level difference between two banks is 0.1m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing a sign of erosion and it is located between two hills.-The soil from the site is hard rock for both sides.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6623,
  //       "proposed_bridge_location_gps_longitude": 30.08107,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Mwange Market ( Nyarubande and Mutandi) business center in Byumba( Nyarubande)",
  //       "education_access_blocked_by_river": "Not used for school",
  //       "health_access_blocked_by_river": "Muhondo health center (Nyarubande and Mutandi)",
  //       "other_access_blocked_by_river": "District office (Nyarubande and Mutandi)",
  //       "primary_occupations": "Market, farm,",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Byumba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V35AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rudogo",
  //       "bridge_opportunity_project_code": "1010844",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.729575,
  //       "bridge_opportunity_gps_longitude": 30.231912,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1350,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. River too small for B2P bridge. Rudogo Bridge currently has some timbers that serve the community from Ngange and Cyamuhinda Cell. Sometimes it floods and the water take 1 hours to reach at the level people can use the bridge. There is 2km between Mayogi and Rudogo Bridge.",
  //       "form_form_name": "Project Assessment - 2018.2.23",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.729575,
  //       "proposed_bridge_location_gps_longitude": 30.231912,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "30 minutes",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Rutare market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "maïz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Gatuna",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 3,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V3KAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugarama",
  //       "bridge_opportunity_project_code": "1010845",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.77241,
  //       "bridge_opportunity_gps_longitude": 30.22087,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2243,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Rugarama Bridge is on Gihurura River. Gihurura River is so narrow with a width less than 1m . With this river width, we assum that the the community themselves may be able to construct a sustainable timber bridge as the river never flood during the rainy season. Rugarama Bridge kinks Giti and Rwamiko Sector, the community crosses Gihurura River for agriculture purpose and there is also a market in Rwamiko Sector. It is also a small ditch less than 1.0m width.",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.77241,
  //       "proposed_bridge_location_gps_longitude": 30.22087,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Market on right side (Rugarama, Bushiranyota and Nyamirambo which is not closer to unpaved road are blocked ), farms on both side",
  //       "education_access_blocked_by_river": "Primary and secondary school on right side ( rugarama, Bushiranyota are blocked ) Nyamirambo which closer to the vehicular bridge cross the river there.",
  //       "health_access_blocked_by_river": "Health center on right side (Rugarama, Bushiranyota are blocked)",
  //       "other_access_blocked_by_river": "Churches on both side",
  //       "primary_occupations": "Farms, school",
  //       "primary_crops_grown": "banana plantain, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and number of population given by community leaders of different communities nearby the bridge and",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 52,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V3UAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamirambo 2",
  //       "bridge_opportunity_project_code": "1010846",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.76133,
  //       "bridge_opportunity_gps_longitude": 30.20837,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1150,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Nyamirambo 2 bridge, links Giti and Muko Sector on Gihurura River, Gihurura River is narrow and it has some timbers that are currently help the community to pass but the bridge is not strong. Nyamirambo 2 bridge is mostly used by the students of Nyagatoma Primary School. This bridge can be easily constructed by using timber bridge as the river narrow and doens't flood. It's a narrow stream less 1.5m.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.76133,
  //       "proposed_bridge_location_gps_longitude": 30.20837,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They said it is not needed because the bridge is close to the vehicular bridge (82 meters away). That is where they cross the river",
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V3eAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mayogi",
  //       "bridge_opportunity_project_code": "1010847",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.701199,
  //       "bridge_opportunity_gps_longitude": 30.209405,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 38,
  //       "bridge_opportunity_individuals_directly_served": 2200,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Plans to build vehicular bridge. Mayogi Bridge is made of 3 timbers that help people to cross Burimbi River . Burimbi River is deep and it floods several times during the rainy seasonand those timbers washed away by the floods. When Burimbi River floods , it blocks more activities like Agriculture,movent of people to: Muko Health Center , Muko Secondary School,Rugaragara Primary School and Rugaragara Commercial Center. It is difficultto find replacement timbers",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.69718,
  //       "proposed_bridge_location_gps_longitude": 30.20613,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There are plans to construct a vehicular bridge. The survey has already been completed.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V3oAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubindi (Kajevuba)",
  //       "bridge_opportunity_project_code": "1010849",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.53941,
  //       "bridge_opportunity_gps_longitude": 30.00825,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2498,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Rubindi Bridge links Manyagiro and Cyumba Sector on Rusebeya River. Cyumba health center and Cyumba secondary school From Rurembo Bridge to Rubindi bridge there is like 1.5km downstream. Due to the the severity of the river during the rainy season , it was considered not very needed.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.53941,
  //       "proposed_bridge_location_gps_longitude": 30.00825,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Market to the right side, boarder Gatuna on left side, business center on both side, farms on both side",
  //       "education_access_blocked_by_river": "Primary and secondary school on right side, nursery on left side",
  //       "health_access_blocked_by_river": "Health center on left side, post health center on right side",
  //       "other_access_blocked_by_river": "Sector office on left side, football terrain on right side, potable water on left side, churches on both side",
  //       "primary_occupations": "Market, school, farms, health centers,",
  //       "primary_crops_grown": "bean, potato, soghrom",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": "He loss teeth",
  //       "notes_on_social_information": "Community leader of Rubindi",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5V5LAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukondo",
  //       "bridge_opportunity_project_code": "1010908",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.71461,
  //       "bridge_opportunity_gps_longitude": 30.08255,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 1300,
  //       "bridge_opportunity_comments": "Rukondo Bridge links Gicumbi and Rulindo District on Mutete and Buyoga Sector. Rukondo Bridge has some timbers. Gatare Market, Mutete church,Mutete market and Nyabisiga Primary School are the Primary Social Services that people looking for. In case of flooding ,water will take 2 days to reach on the normal level and there is no alternative crossing point .",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.71461,
  //       "proposed_bridge_location_gps_longitude": 30.08255,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Market, farms, and business center both side",
  //       "education_access_blocked_by_river": "Primary and secondary school on both side",
  //       "health_access_blocked_by_river": "Health center on both side but the closer is left side",
  //       "other_access_blocked_by_river": "Cell office on both side",
  //       "primary_occupations": "Farms, teaching, Market on left side, health center, churches, and school on both side,",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Two of them was using motorcycle and one was crossing and one of them is handicapped",
  //       "notes_on_social_information": "The information was given by people crossed the bridge, one of them was community leader and other was teacher",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5hhNAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwafandi",
  //       "bridge_opportunity_project_code": "1010915",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.71943,
  //       "bridge_opportunity_gps_longitude": 30.11859,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 2876,
  //       "bridge_opportunity_comments": "Nearest location for a feasible bridge is 500 meters downstream. There is a vehicular bridge 700 meters upstream. Locals present at the site said if the bridge was built down stream no one would use it. They would walk upstream and use the vehicular bridge. That is what people currently do during the rainy season. For this reason the site is rejected. We find that Rwafundi Bridge has been removed by the floods, the community currently pass through the water . Normaly the community use Rwafandi Bridge to access Gaseke market and Rwafandi center .Rwafandi bridge links Mutete and Rutare Sector on Mwange River. The community tried to put on some timbers that help them to cross the river but they usually be removed by the flooding in the rainy season. When the river floods, the alternative crossing point is Kwidigiri Bridge in 1.5km from Rwagifandi Bridge.",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.71943,
  //       "proposed_bridge_location_gps_longitude": 30.11859,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "5 days",
  //       "market_access_blocked_by_river": "Muhororo and Gitaba mostly used Gasharu Market, there is factory of stones in Gasharu",
  //       "education_access_blocked_by_river": "Gashara left side of river cross bridge to the secondary on right side, primary on both sides of the river",
  //       "health_access_blocked_by_river": "Health center on both side they choose where they want",
  //       "other_access_blocked_by_river": "Churches on both side",
  //       "primary_occupations": "Farm, Market,",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and and numbers given by community leaders of different communities",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 89,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000c5iL7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bungwe",
  //       "bridge_opportunity_project_code": "1011302",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.92295,
  //       "bridge_opportunity_gps_longitude": 29.47887,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 825,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92295,
  //       "proposed_bridge_location_gps_longitude": 29.47887,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "People always cross and community in requesting modern vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME4YAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabona",
  //       "bridge_opportunity_project_code": "1011303",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9386111,
  //       "bridge_opportunity_gps_longitude": 29.45666,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1200,
  //       "bridge_opportunity_comments": "1000-3000 people directly served, Elevation:2165m, Cell:Kabona, Injuries/Death-No person injured while crossing the river./ No person died while trying to cross the river. Cross river on a normal day-150-300 people, Nearby city centers--Rusebeya, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-3-6 months / Hagati y?amezi atatu n?atandatu,Travel to nearest safe bridge/river crossing-2-3 hours / Hagati yamasaha 2 n?amasaha 3,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-2-6 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5-1 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-hilly / umusozi,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-Sector/ umurenge,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u Rwanda, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 60m.-The level difference between two banks is 2m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between elevated area and a flat area.-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9386111,
  //       "proposed_bridge_location_gps_longitude": 29.45666,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "They cross along road manihira rusebeya which is far",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "7 days after been raining",
  //       "market_access_blocked_by_river": "Muyira market",
  //       "education_access_blocked_by_river": "Gs kigambo",
  //       "health_access_blocked_by_river": "Kabona health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They fell in winter",
  //       "notes_on_social_information": "Information gathered from munini leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rutsiro",
  //       "name_of_nearest_paved_or_sealed_road": "Rutsiro-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME4dAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamakanda",
  //       "bridge_opportunity_project_code": "1011304",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.948219,
  //       "bridge_opportunity_gps_longitude": 29.479638,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 800,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.948219,
  //       "proposed_bridge_location_gps_longitude": 29.479638,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Congonile",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community needs avehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME4nAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukorobeza",
  //       "bridge_opportunity_project_code": "1011305",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.94222,
  //       "bridge_opportunity_gps_longitude": 29.485,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2521,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94222,
  //       "proposed_bridge_location_gps_longitude": 29.485,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gashubi market and nyagasambu market",
  //       "education_access_blocked_by_river": "Gakeri nursery primary and secondary schools",
  //       "health_access_blocked_by_river": "Kabona health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A teacher fell in the river and was injured",
  //       "notes_on_social_information": "Market(community 1). Sec school (community 1,2,3) . Health center (community 3,2). Farms (community 1,2,3 ). Population information for each village was provided by Mberi cell leader, Thomas Banguwiha, from cell census data collected in July 2017 Population of all adjacent communities includes the following: nyagasambu,marimba,gakeri and bungwe Community members in bungwe sometimes use this crossing to visit relatives once a month",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rutsiro-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 68,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME4sAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagatare",
  //       "bridge_opportunity_project_code": "1011306",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.94833,
  //       "bridge_opportunity_gps_longitude": 29.493611,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1788,
  //       "bridge_opportunity_comments": "Not Duplicate",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94833,
  //       "proposed_bridge_location_gps_longitude": 29.493611,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gashubi market",
  //       "education_access_blocked_by_river": "Ruronde primary school",
  //       "health_access_blocked_by_river": "Kabona health center",
  //       "other_access_blocked_by_river": "Church at gakeri",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They slipped and fell when the river was flooded",
  //       "notes_on_social_information": "Market(community1 ). Sec school (community 1 ) . Health center (community 1). Farms (community 1 and 2). Population information for each village was provided by Mberi cell leader, Thomas Banguwiha, from cell census data collected in July 2017 Population of all adjacent communities includes the following: kabeza, rurimba,gakeri and gatenga Community members in gatenga sometimes use this crossing to visit relatives",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rutsiro -rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 73,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME4xAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisayo",
  //       "bridge_opportunity_project_code": "1011308",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.777574,
  //       "bridge_opportunity_gps_longitude": 29.377044,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 40,
  //       "bridge_opportunity_individuals_directly_served": 400,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. This site is close to Kazo site once kazo will be built it will serve all the community",
  //       "form_form_name": "Project Assessment - 2018.3.28",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.777574,
  //       "proposed_bridge_location_gps_longitude": 29.377044,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No where else",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": "5 hours",
  //       "market_access_blocked_by_river": "Mahoko Market",
  //       "education_access_blocked_by_river": "Birembo secondary school",
  //       "health_access_blocked_by_river": "Terimbere health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gisenyi",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 8,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME5CAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Busuti",
  //       "bridge_opportunity_project_code": "1011311",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.7553,
  //       "bridge_opportunity_gps_longitude": 29.373762,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 600,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. there is a proposed plan for repairing a vehicular bridge in 300 m ,once built it will serve the communities",
  //       "form_form_name": "Project Assessment - 2018.3.28",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.7553,
  //       "proposed_bridge_location_gps_longitude": 29.373762,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Nowhere else",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Mahoko",
  //       "education_access_blocked_by_river": "Kavumo secondary school",
  //       "health_access_blocked_by_river": "Nyabirasi health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, maïz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Actually the timbers are not stable while it rain, anyone should fall dawn",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Musanze",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 11,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME5RAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyiramusenyi",
  //       "bridge_opportunity_project_code": "1011313",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.94245,
  //       "bridge_opportunity_gps_longitude": 29.470675,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1970,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94245,
  //       "proposed_bridge_location_gps_longitude": 29.470675,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Congonile",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community needs avehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME5bAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Marimba",
  //       "bridge_opportunity_project_code": "1011314",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.935,
  //       "bridge_opportunity_gps_longitude": 29.47888,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 700,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.3.28",
  //       "form_created_by": "stephaniemay taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.936309,
  //       "proposed_bridge_location_gps_longitude": 29.478881,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No elsewhere",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "Nyiramusenyi River doesn't flood",
  //       "market_access_blocked_by_river": "Nyagasambu Market",
  //       "education_access_blocked_by_river": "Marimba Primary school",
  //       "health_access_blocked_by_river": "Kabona health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "irish-poteto, maïz, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Congo-nil",
  //       "name_of_nearest_paved_or_sealed_road": "Kivu-belt",
  //       "bridge_classification": null,
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": 2,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME5gAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mungoti",
  //       "bridge_opportunity_project_code": "1011316",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.892213,
  //       "bridge_opportunity_gps_longitude": 29.456516,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2780,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.89213,
  //       "proposed_bridge_location_gps_longitude": 29.45658,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community need vehicular bridge and they started construction activity",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cME5vAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngabira",
  //       "bridge_opportunity_project_code": "1011330",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.43057,
  //       "bridge_opportunity_gps_longitude": 30.0783,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 906,
  //       "bridge_opportunity_comments": "We find that Ngabira Bridge has some timbers that help the community to access social services from Rushaki sector and Mukarange sectorNgabira Bridge serves the community especially students and farmers working in tea land . The alternative crossing point is in 1.5km",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.43057,
  //       "proposed_bridge_location_gps_longitude": 30.0783,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 27,
  //       "flood_duration_during_rainy_season": "3 weeks",
  //       "market_access_blocked_by_river": "Market on right side, farms on both side",
  //       "education_access_blocked_by_river": "Primary on left side, secondary on right side",
  //       "health_access_blocked_by_river": "Health center on right side",
  //       "other_access_blocked_by_river": "Churches on right side",
  //       "primary_occupations": "Student, Market, farmers, go to health centers",
  //       "primary_crops_grown": "bean, soghrom",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They were students, and trying to cross the bridge",
  //       "notes_on_social_information": "They information was given by director of s Primary school and the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cMOsWAAW",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibaya",
  //       "bridge_opportunity_project_code": "1011331",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.70215,
  //       "bridge_opportunity_gps_longitude": 30.07467,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 35,
  //       "bridge_opportunity_individuals_directly_served": 950,
  //       "bridge_opportunity_comments": "Kibaya Bridge was destroyed by the floods in the recent rainy season but the community tried themselve to put some timbers that are currently in use but are not sustainable. Kibaya Bridge help mostly the people transporting milk to Gaseke dairly and Kigali.",
  //       "form_form_name": "Project Assessment - 2018.8.5",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70215,
  //       "proposed_bridge_location_gps_longitude": 30.07467,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Farms, Market, school, health center on both side",
  //       "education_access_blocked_by_river": "Primary and secondary school on both side",
  //       "health_access_blocked_by_river": "Health center on both side but the closer on left side",
  //       "other_access_blocked_by_river": "Churches on both side, cell offices on both side,",
  //       "primary_occupations": "Students, Market, health center,",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by a group of community live closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cMPMMAA4",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kadaho",
  //       "bridge_opportunity_project_code": "1012380",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.266448,
  //       "bridge_opportunity_gps_longitude": 29.647273,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 45,
  //       "bridge_opportunity_individuals_directly_served": 1158,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. The Nyanza District has come to realize that they will build a vehicular bridge to this site",
  //       "form_form_name": "Project Assessment - 2018.6.28",
  //       "form_created_by": "clementinemukashyaka taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.266448,
  //       "proposed_bridge_location_gps_longitude": 29.647273,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "4 hour",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "7 hour",
  //       "market_access_blocked_by_river": "Kabere and kabeza communities blocked by this river when going to Buhanda Market and some people have lands at different sides from where they stay",
  //       "education_access_blocked_by_river": "There are nursery ,primary and secondary schools at both sides in equal distance some students and their teachers are blocked when going to schools",
  //       "health_access_blocked_by_river": "Kadaho cell community blocked by this river to access to the Gitwe Hospital",
  //       "other_access_blocked_by_river": "On both sides there are different churches some people blocked by this river when going to places of worship",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "At least 2 people die /3years; this river flow with trees ,stones and big clay when people crossing these debris hit them and get drowned",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyanza Road",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 1.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cPI5wAAG",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubande",
  //       "bridge_opportunity_project_code": "1012493",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.65595,
  //       "bridge_opportunity_gps_longitude": 30.07884,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "Site was rejected because it is a washed out concrete vehicular bridge 700 meters upstream from an Identified pedestrian bridge.",
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65595,
  //       "proposed_bridge_location_gps_longitude": 30.07884,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is a government constructed a vehicular bridge which was washed out. Government plans to rebuild the bridge. See current crossing method photos",
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000cPpL8AAK",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuhura ADPR",
  //       "bridge_opportunity_project_code": "1012540",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.70683,
  //       "bridge_opportunity_gps_longitude": 29.91433,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1778,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.2",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70683,
  //       "proposed_bridge_location_gps_longitude": 29.91433,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "No",
  //       "days_per_year_river_is_flooded": 8,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Gasiza market , large farms for potatoes",
  //       "education_access_blocked_by_river": "Gasiza secondary school",
  //       "health_access_blocked_by_river": "Bukoro health center",
  //       "other_access_blocked_by_river": "Church services",
  //       "primary_occupations": "Gasiza market, government facilities , health center",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Sliding on the bridge when it is flooded",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali_musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhmUvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasumo",
  //       "bridge_opportunity_project_code": "1012543",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.88597,
  //       "bridge_opportunity_gps_longitude": 29.65868,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2162,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.88597,
  //       "proposed_bridge_location_gps_longitude": 29.65868,
  //       "current_crossing_method": "Walking through water when river is not flood when ,when it floods they can't cross",
  //       "nearest_all_weather_crossing_point": "No one",
  //       "days_per_year_river_is_flooded": 1,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Ngororero Market and Kazabe Market",
  //       "education_access_blocked_by_river": "GS Ruhunga , Gs Kabyiniro",
  //       "health_access_blocked_by_river": "FOSACOM Nyamisekera",
  //       "other_access_blocked_by_river": "Muhororo Sector , Mubuga Cell",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They can't cross when river is full during heavy rain they just stay on their side",
  //       "notes_on_social_information": "The served population were determined by asking village leader the households within his or her village then , times 7 people in one household",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero -Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhpCRAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasovu",
  //       "bridge_opportunity_project_code": "1012544",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.88597,
  //       "bridge_opportunity_gps_longitude": 29.651,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.88597,
  //       "proposed_bridge_location_gps_longitude": 29.651,
  //       "current_crossing_method": "Walking on foot through water,or one who is scared stays on his or her side without crossing",
  //       "nearest_all_weather_crossing_point": "No other crossing method",
  //       "days_per_year_river_is_flooded": 4,
  //       "flood_duration_during_rainy_season": "4 days",
  //       "market_access_blocked_by_river": "Ngororero Market",
  //       "education_access_blocked_by_river": "GS Ruhunga",
  //       "health_access_blocked_by_river": "FOSACOM health center",
  //       "other_access_blocked_by_river": "Ngororero District",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, cassava, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "People though the is not too deep and when they are crossing the fall in and there is stones within the river",
  //       "notes_on_social_information": "Many village around the region cross the river to go to district and market , villages leader of Kasovu helped me to contact other village leaders to ask them their people who cross the river in their daily activities",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero-Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhpCWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwasare",
  //       "bridge_opportunity_project_code": "1012545",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.93678,
  //       "bridge_opportunity_gps_longitude": 29.63541,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1750,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.93678,
  //       "proposed_bridge_location_gps_longitude": 29.63541,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 1,
  //       "flood_duration_during_rainy_season": "No flood",
  //       "market_access_blocked_by_river": "Rusumo market",
  //       "education_access_blocked_by_river": "GS Muhororo",
  //       "health_access_blocked_by_river": "Muhororo hospital",
  //       "other_access_blocked_by_river": "Gatumba Sector and Cyome Cell",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "This bridge serves over three villages ,they cross it going to market ,hospital , sectors and to visit their families",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhpCbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubande",
  //       "bridge_opportunity_project_code": "1012546",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.88360333,
  //       "bridge_opportunity_gps_longitude": 29.62528667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1923,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.88360333,
  //       "proposed_bridge_location_gps_longitude": 29.62528667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "150 m",
  //       "days_per_year_river_is_flooded": 1,
  //       "flood_duration_during_rainy_season": "Flood occurs like once in heavy season and it takes one day",
  //       "market_access_blocked_by_river": "Kazabe Kazabe",
  //       "education_access_blocked_by_river": "Gs Kanogo and Butezi Primary school",
  //       "health_access_blocked_by_river": "Intaganzwa Health center",
  //       "other_access_blocked_by_river": "Kazabe cell",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "People crossing get scared as the timbers slipping",
  //       "notes_on_social_information": "People from Kansi village crossing this river to Kazabe market and church,there are also many student crossing the bridge to GS kanogo.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero-Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhpCgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamigina",
  //       "bridge_opportunity_project_code": "1012547",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.18874,
  //       "bridge_opportunity_gps_longitude": 29.69027,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2008,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18874,
  //       "proposed_bridge_location_gps_longitude": 29.69027,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "In March, April and May; in September and October, it does last for 2 hours",
  //       "market_access_blocked_by_river": "Gafunzo Market and Gafunzo rice factory blocked for people on the RHS",
  //       "education_access_blocked_by_river": "Gafunzo primary school blocked for people on the LHS",
  //       "health_access_blocked_by_river": "Mwendo Health Center blocked for people on the LHS",
  //       "other_access_blocked_by_river": "Mwendo Sector and Gafunzo Cell headquarters blocked for people on the LHS",
  //       "primary_occupations": "Agriculture and Brick & Tiles making",
  //       "primary_crops_grown": "banana plantation, bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information was determined by asking local leaders: cell leader and different village leaders.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Ruhango",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali- Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhpDZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitenga",
  //       "bridge_opportunity_project_code": "1012549",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6680555556,
  //       "bridge_opportunity_gps_longitude": 29.8036111111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4500,
  //       "bridge_opportunity_comments": "650 people from Buheta cell need to go to Buheta health center by the use of Gitenga Bridge as Adjacent community.",
  //       "form_form_name": "Project Assessment - 2018.8.4",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6680555556,
  //       "proposed_bridge_location_gps_longitude": 29.8036111111,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "90",
  //       "market_access_blocked_by_river": "Gakenke",
  //       "education_access_blocked_by_river": "Musave and Rukura primary and secondary school",
  //       "health_access_blocked_by_river": "Buheta health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "4",
  //       "notes_on_social_information": "Information obtained from cell leader and village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali -musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 62,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhpEhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gashiha",
  //       "bridge_opportunity_project_code": "1012697",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.424161,
  //       "bridge_opportunity_gps_longitude": 29.542492,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2110,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.424161,
  //       "proposed_bridge_location_gps_longitude": 29.542492,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "2hours during rain season, from March to June, December",
  //       "market_access_blocked_by_river": "Markets,farms, schools and officials service",
  //       "education_access_blocked_by_river": "Kiraro primary school located on The RHS of bridge",
  //       "health_access_blocked_by_river": "Health center kibirizi located in 3.5 km from the bridge on the RHS",
  //       "other_access_blocked_by_river": "District officials service, delivery of the coffee to the washing plant; church(seventh adventist in Nyarunyinya and Catholic church in Bugarura)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, coffe, forest, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Fell down in river and drowned and one person commit suicide",
  //       "notes_on_social_information": "Information was given by the community's individuals live near the bridge and local community officials",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 61,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhyadAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigogo ku ishuri",
  //       "bridge_opportunity_project_code": "1012698",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gicumbi",
  //       "bridge_opportunity_gps_latitude": -1.59361,
  //       "bridge_opportunity_gps_longitude": 30.01151,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1002,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59361,
  //       "proposed_bridge_location_gps_longitude": 30.01151,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Market, farms, on both side",
  //       "education_access_blocked_by_river": "Nusery, Primary and secondary school on left side , TVET on right side,",
  //       "health_access_blocked_by_river": "Health center on left side",
  //       "other_access_blocked_by_river": "Churches on both side, potable water on left side,",
  //       "primary_occupations": "Market, Prison of Miyove, school, health center, churches, sector office, ...",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi City",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhyaiAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirwa",
  //       "bridge_opportunity_project_code": "1012699",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.22162,
  //       "bridge_opportunity_gps_longitude": 29.61977,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 827,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.22162,
  //       "proposed_bridge_location_gps_longitude": 29.61977,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "From March to May and from September to December, it does last for 3 hours",
  //       "market_access_blocked_by_river": "Munanira Market blocked for people on the RHS",
  //       "education_access_blocked_by_river": "Nzuki Primary School, St Joseph Vocational training school blocked for people on the RHS",
  //       "health_access_blocked_by_river": "Munanira Health Center blocked for people on the RHS",
  //       "other_access_blocked_by_river": "Nzuki Catholic Church for people on the RHS",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Most of injuries were from children going or coming to/from school, this year two young girls coming from school drowned but were rescued and spent several days at the hospital.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders the number of population in their villages.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Ruhango",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhyeVAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambi",
  //       "bridge_opportunity_project_code": "1012700",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.22283,
  //       "bridge_opportunity_gps_longitude": 29.65287,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2543,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.22283,
  //       "proposed_bridge_location_gps_longitude": 29.65287,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In April and May, it last for 1 hour",
  //       "market_access_blocked_by_river": "Buhanda and Kabagari Market",
  //       "education_access_blocked_by_river": "Kabagari Primary school for people on the RHS",
  //       "health_access_blocked_by_river": "Kabagari health center blocked for people on the RHS",
  //       "other_access_blocked_by_river": "Kabagari Sector Office, Police station and football pitch blocked for people on the RHS",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking community village leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Ruhango",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 72,
  //       "height_differential_between_banks": 3.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhyeaAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mataba",
  //       "bridge_opportunity_project_code": "1012701",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Ruhango",
  //       "bridge_opportunity_gps_latitude": -2.23697,
  //       "bridge_opportunity_gps_longitude": 29.73556,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1140,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.23697,
  //       "proposed_bridge_location_gps_longitude": 29.73556,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "In April and May, in September and October, it last for a day",
  //       "market_access_blocked_by_river": "Ruhango market blocked for people on the LHS",
  //       "education_access_blocked_by_river": "Gitisi primary and secondary school blocked for people on the LHS",
  //       "health_access_blocked_by_river": "Ruhango health center blocked for people on the LHS",
  //       "other_access_blocked_by_river": "Ruhango Catholic Church, Gitisi Adventist and Pentecost church blocked for people on the LHS",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Ruhango",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000dhyefAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mataba",
  //       "bridge_opportunity_project_code": "1012797",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.62068,
  //       "bridge_opportunity_gps_longitude": 29.95006,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1060,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.16",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62068,
  //       "proposed_bridge_location_gps_longitude": 29.95006,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 6,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Rukozo market,",
  //       "education_access_blocked_by_river": "Rukozo second and primary",
  //       "health_access_blocked_by_river": "Rukozo health care",
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Traders at Rukozo market, students and teachers",
  //       "primary_crops_grown": "cassava, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Injuries are due to slipping on timber and fall in the river",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river. Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kpDAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bushyana",
  //       "bridge_opportunity_project_code": "1012798",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.63296,
  //       "bridge_opportunity_gps_longitude": 29.93438,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4016,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63296,
  //       "proposed_bridge_location_gps_longitude": 29.93438,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 7,
  //       "flood_duration_during_rainy_season": "2 hour",
  //       "market_access_blocked_by_river": "market, kinihira tea factory",
  //       "education_access_blocked_by_river": "Burebe Tvet(training center), primary and secondary schools school",
  //       "health_access_blocked_by_river": "Rukuzo health center, kinihira hospital",
  //       "other_access_blocked_by_river": "Catholic Parish in Burehe",
  //       "primary_occupations": "Farmers, students and teachers",
  //       "primary_crops_grown": "sugar can, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "Slide and fall",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river. Community leaders helped giving the number of the people in their community and facilities do they access",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kpNAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyirantarengwa",
  //       "bridge_opportunity_project_code": "1012799",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.67984,
  //       "bridge_opportunity_gps_longitude": 29.51707,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2272,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67984,
  //       "proposed_bridge_location_gps_longitude": 29.51707,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.8 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "1 day in April",
  //       "market_access_blocked_by_river": "Vunga market , farms in Rurambo and cyuve villages",
  //       "education_access_blocked_by_river": "Nkerima protestant school",
  //       "health_access_blocked_by_river": "Shyirahealth center",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Traders at Vunga market, students and teachers, farmers on both sides",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Population to be served by the bridge is calculated based on the number of the people in their community and facilities that are in their destination which require them to cross the river .Community leaders helped giving the number of the people in their community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira heading to Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 62,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kqzAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buhoro",
  //       "bridge_opportunity_project_code": "1012801",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.4418,
  //       "bridge_opportunity_gps_longitude": 29.44929833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1150,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4418,
  //       "proposed_bridge_location_gps_longitude": 29.44929833,
  //       "current_crossing_method": "Very Small trees",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "35 times April, May and September, it lasts 2 days after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Secondary school, primary school",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": ", maiz, meal, potato, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Falling into the river by jumping resulting to injuries and other they die",
  //       "notes_on_social_information": "The numbers given on this form are from the local people and their leaders, and the total population was estimated based on the communities to be directly served and the sorounding communities",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 67.8,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kr9AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakangaga",
  //       "bridge_opportunity_project_code": "1012802",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.43705833,
  //       "bridge_opportunity_gps_longitude": 29.44304667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1100,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.43705833,
  //       "proposed_bridge_location_gps_longitude": 29.44304667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "20 times in April and May, it lasts 3 days after rainfall",
  //       "market_access_blocked_by_river": "Markets,",
  //       "education_access_blocked_by_river": "Primary school, Secondary school",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Families cooperation",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The numbers of people that use this crossing weekly were given by the local people together with their leaders, and the total number of population to be served was based on the communities to be directly served and the sorounding communities which use the current pathway",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 84,
  //       "height_differential_between_banks": 2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6krEAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bishyiga",
  //       "bridge_opportunity_project_code": "1012803",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.42353667,
  //       "bridge_opportunity_gps_longitude": 29.46039667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1050,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42353667,
  //       "proposed_bridge_location_gps_longitude": 29.46039667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "20 times in April and May and it lasts for 8 hours",
  //       "market_access_blocked_by_river": "Markets, farms,",
  //       "education_access_blocked_by_river": "Primary school, Secondary school",
  //       "health_access_blocked_by_river": "Health center",
  //       "other_access_blocked_by_river": "Government Office buildings, church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, meal, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The wstimated figures were given by the local people together with their leaders and based on current population",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6krJAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuyenge",
  //       "bridge_opportunity_project_code": "1012804",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6225,
  //       "bridge_opportunity_gps_longitude": 29.66777,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1493,
  //       "bridge_opportunity_comments": "During rwanda National Wide Needs Assessment, we find that 60 people from Kirwa village and 100 people from Busengo Sector use Kabuyenge Bridge to access Kinkware Market located in Musanze District as Adjacent Community. During Y1 surveys program we found that a vehicular bridge is needed here and the Gakenke district proposed a new site called \"Kabutimbo\" that replaced this \"Kabuyenge\"",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6225,
  //       "proposed_bridge_location_gps_longitude": 29.66777,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 4,
  //       "flood_duration_during_rainy_season": "4",
  //       "market_access_blocked_by_river": "Gaseke market",
  //       "education_access_blocked_by_river": "Nyundo primary and secondary school",
  //       "health_access_blocked_by_river": "Nyundo hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Gathered from local people and mazinga leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali - musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6krTAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nkamba",
  //       "bridge_opportunity_project_code": "1012805",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.42504833,
  //       "bridge_opportunity_gps_longitude": 29.42907333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1390,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42504833,
  //       "proposed_bridge_location_gps_longitude": 29.42907333,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "800 m",
  //       "days_per_year_river_is_flooded": 6,
  //       "flood_duration_during_rainy_season": "6 times in April and May, and it lasts 3 hours after rainfall",
  //       "market_access_blocked_by_river": "Market, commercial center",
  //       "education_access_blocked_by_river": "Primary school, secondary school",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming, commercial activities,",
  //       "primary_crops_grown": "cow pea, maiz, potato, sweet potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They slipped on trees of the current crossing and they fall into the river,",
  //       "notes_on_social_information": "The numbers of people directly served by the bridge and the sorounding communities were estimated by the local people and their leaders, but also the local officials tried to relate with the current population of the village",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53.5,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6krYAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwinzovu",
  //       "bridge_opportunity_project_code": "1012806",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.43816,
  //       "bridge_opportunity_gps_longitude": 29.39109667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1180,
  //       "bridge_opportunity_comments": "Too badly communicated and not enough people served (District engineer also refused to build there)",
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.43816,
  //       "proposed_bridge_location_gps_longitude": 29.39109667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "15 times in April and May , and lasts 2 days after rainfall",
  //       "market_access_blocked_by_river": "Market, factory",
  //       "education_access_blocked_by_river": "Secondary school",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Local Commercial centers",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cow pea, maiz, potato, tea, wheat",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "They slipped o the crossing tree and fall down into the river",
  //       "notes_on_social_information": "These numbers were given by the local people and the village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6krdAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagashubi",
  //       "bridge_opportunity_project_code": "1012808",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.10805,
  //       "bridge_opportunity_gps_longitude": 29.79286,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1570,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10805,
  //       "proposed_bridge_location_gps_longitude": 29.79286,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "No floods",
  //       "market_access_blocked_by_river": "Kinini market",
  //       "education_access_blocked_by_river": "Rubugurizo ps",
  //       "health_access_blocked_by_river": "Shyogwe health center",
  //       "other_access_blocked_by_river": "Shyogwe sector",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "A women was crossing then falls into the river",
  //       "notes_on_social_information": "Village leader estimated the number of his people who crossing the river",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6ksPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mucyebera",
  //       "bridge_opportunity_project_code": "1012812",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.974166,
  //       "bridge_opportunity_gps_longitude": 29.3933,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2600,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.974166,
  //       "proposed_bridge_location_gps_longitude": 29.3933,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "They pass along way to Congo Nile",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "When it rains it takes three days without crossing",
  //       "market_access_blocked_by_river": "Congo Nile",
  //       "education_access_blocked_by_river": "Congo Nile primary and secondary school",
  //       "health_access_blocked_by_river": "Congo nile",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "Students fell when it is flooded",
  //       "notes_on_social_information": "Information gathered from kabiraro leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Congonile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-congonile",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 76,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kvOAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabiraho",
  //       "bridge_opportunity_project_code": "1012814",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9775,
  //       "bridge_opportunity_gps_longitude": 29.385,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2458,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9775,
  //       "proposed_bridge_location_gps_longitude": 29.385,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "1 day when it rained",
  //       "market_access_blocked_by_river": "Congo Nile",
  //       "education_access_blocked_by_river": "Bumba high school",
  //       "health_access_blocked_by_river": "Congo Nile",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "People fell during winter trying to cross",
  //       "notes_on_social_information": "Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rutsiro -karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kvYAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyori",
  //       "bridge_opportunity_project_code": "1012818",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.31818,
  //       "bridge_opportunity_gps_longitude": 29.425777,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2380,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.31818,
  //       "proposed_bridge_location_gps_longitude": 29.425777,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "During April, May and September to December, 3hours after rainfall they can cross",
  //       "market_access_blocked_by_river": "Nkomane market located on left side of river, Mushubi market",
  //       "education_access_blocked_by_river": "Primary school, buhanza primary school in nkomane sector is blocked to the students from buteteri and gashwati cell",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Farms, church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz, potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down from bridge and fractured",
  //       "notes_on_social_information": "Cell leader and people crossing bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kxKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugano-gatare",
  //       "bridge_opportunity_project_code": "1012819",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.367013,
  //       "bridge_opportunity_gps_longitude": 29.437399,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1982,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.17",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.367013,
  //       "proposed_bridge_location_gps_longitude": 29.437399,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "November, December, april. 4hours after rainfall",
  //       "market_access_blocked_by_river": "Mushubi market, Ruganda cattle market both are blocked to the RHS community",
  //       "education_access_blocked_by_river": "Students from The RHS are blocked to Mushubi secondary school",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Communities on LHS are blocked to ADPR Church in rugano",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "This person was drunk and decided to swim in order to cross, then he drowned and dead",
  //       "notes_on_social_information": "Local people near the bridge and the cell leader of rugano",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 108,
  //       "height_differential_between_banks": 5.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6kxPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhengeri",
  //       "bridge_opportunity_project_code": "1013634",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.880833,
  //       "bridge_opportunity_gps_longitude": 29.341388,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1052,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.880833,
  //       "proposed_bridge_location_gps_longitude": 29.341388,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Gakeri",
  //       "education_access_blocked_by_river": "Kagano primary school",
  //       "health_access_blocked_by_river": "Kayove health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, yam",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Ruhengeri village and kagano village don't have access to kayove health center and gakeri market and kagano primary school",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iRsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bweramana",
  //       "bridge_opportunity_project_code": "1012832",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.3098,
  //       "bridge_opportunity_gps_longitude": 29.69524,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3531,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.18",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3098,
  //       "proposed_bridge_location_gps_longitude": 29.69524,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In April and May, it last for 2hours",
  //       "market_access_blocked_by_river": "Rurangazi, Nyanza, Kigogo",
  //       "education_access_blocked_by_river": "Nyabinyenga primary and secondary school blocked for people on the right side , Cyerezo primary school blocked for people on the left side.",
  //       "health_access_blocked_by_river": "Bweramana Nealth Post blocked for people on the left side of the river",
  //       "other_access_blocked_by_river": "Nyabinyenga Catholic Church blocked for people on the right side of the river",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Most of injuries were for Motorcycle trying to cross the river on the timber bridge and were taken to hospital, some seriously injured.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders. The villages leaders have updated numbers of population in their villages.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6mYLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambi",
  //       "bridge_opportunity_project_code": "1012833",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.34876,
  //       "bridge_opportunity_gps_longitude": 29.68835,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3637,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.18",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34876,
  //       "proposed_bridge_location_gps_longitude": 29.68835,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May, it last for 30min",
  //       "market_access_blocked_by_river": "Nyanza Market blocked for people on the right side of the river",
  //       "education_access_blocked_by_river": "Cyarwa Primary and secondary school blocked for people on the right side of the river",
  //       "health_access_blocked_by_river": "Nyarusange Health center blocked for people on the right side of the river",
  //       "other_access_blocked_by_river": "Rwabicuma Sector office, Catholic, Adventist church blocked for people on the right side of the river",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, maiz, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking community village leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6mYQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyahafi",
  //       "bridge_opportunity_project_code": "1012834",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.37584,
  //       "bridge_opportunity_gps_longitude": 29.68033,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2887,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.18",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37584,
  //       "proposed_bridge_location_gps_longitude": 29.68033,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May, in September and October, when the river floods it last for 3 days",
  //       "market_access_blocked_by_river": "Nyanza Market blocked for people on the left side of the river and Rurangazi Market blocked for people on the right side of the river",
  //       "education_access_blocked_by_river": "Gashyenzi Primary School blocked for communities on the right side of the river",
  //       "health_access_blocked_by_river": "Nyarusange Health center blocked for people on the left side of the river",
  //       "other_access_blocked_by_river": "Adventist church blocked for people on the left side and Pentecost church blocked for people on the right side.",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 7,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "The majority of people who died trying to cross this bridge were kids going to Gashyenzi Primary School.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders. They have updated numbers of population in their villages",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6mYVAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Gisiza",
  //       "bridge_opportunity_project_code": "1012949",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.00518138,
  //       "bridge_opportunity_gps_longitude": 29.7139582,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3481,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.00518138,
  //       "proposed_bridge_location_gps_longitude": 29.7139582,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "3 hours of floods",
  //       "market_access_blocked_by_river": "Kabadaha market",
  //       "education_access_blocked_by_river": "GS Mushishiro",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Muhanga sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "A foot left within timbers",
  //       "notes_on_social_information": "Muhanga(Health Center ,School,market) ,Gisiza(Health Center ,School,market) ,kamacyende ( schools,farm)Naganiro( schools,farm) ,Karambo ( schools,farm) , these information are obtained in census of 2018 from the village leaders",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga-Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wBeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinihira",
  //       "bridge_opportunity_project_code": "1012954",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.73435,
  //       "bridge_opportunity_gps_longitude": 29.66043,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4456,
  //       "bridge_opportunity_comments": "Bridge would connect Muhanga and Gakenke districts",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.73435,
  //       "proposed_bridge_location_gps_longitude": 29.66043,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Floods occur Twice in year and takes 3 days",
  //       "market_access_blocked_by_river": "Vunga market",
  //       "education_access_blocked_by_river": "Janga SS , Shyira GS",
  //       "health_access_blocked_by_river": "Shyira hospital",
  //       "other_access_blocked_by_river": "Mugunga sector office",
  //       "primary_occupations": "Farmers are one of most of people who cross this bridge going to their field to cultivate .",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "Boat incident",
  //       "notes_on_social_information": "Vunga market ( masangano cell , kamahoro village ) , Janja ss( Masangano cell, nyamure village, muvumba village, kamahoro village ) , Shyira hospital ( masangano cell , kamahoro and nyamure village ). SEDO of Masangano cell collected the information from the census 2018 and that how we count the individual served .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 126,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wC3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitega",
  //       "bridge_opportunity_project_code": "1012955",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.77229,
  //       "bridge_opportunity_gps_longitude": 29.66985,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3321,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.77229,
  //       "proposed_bridge_location_gps_longitude": 29.66985,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "No point because it is souranded by Nyabarongo river",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Flood occurs in April and September and it can take a whole week",
  //       "market_access_blocked_by_river": "Vunga market and Ngororero market",
  //       "education_access_blocked_by_river": "GS Kiziguro protestant",
  //       "health_access_blocked_by_river": "Shyira hospital",
  //       "other_access_blocked_by_river": "Ngororero District and Muhanga district",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Some of dead men were drunk .",
  //       "notes_on_social_information": "Vunga market ( Gitwa village , mugeni, kanombe , nyarusange ) , Ngororero market ( gitwa village, mugeni ,kanombe, nyarusange ); GS Kiziguro protestant ( gitwa ,mugeni, kanombe, nyarusange) ; Shyira hospital ,( gitwa, nyarusange , mugeni and kanombe ) . Population Census of 2018 is the main source referred to determine numbers of individual served by Nyarusozi cell leader .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 108,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wC8AAI",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Mbuga Kwa Habuhazi",
  //       "bridge_opportunity_project_code": "1012957",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.78470369,
  //       "bridge_opportunity_gps_longitude": 29.68177755,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1631,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.78470369,
  //       "proposed_bridge_location_gps_longitude": 29.68177755,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Ruhango - rusuri market",
  //       "education_access_blocked_by_river": "ETG Gitumba, GS Nyabinoni",
  //       "health_access_blocked_by_river": "Vunga hospital",
  //       "other_access_blocked_by_river": "Mbuga cell office , Nyabinoni sector office e",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "Nyarusange village and Gitaba village ( Ruhango market , ETG Gitumba) ; karengere village and murama village ( GS Nyabinoni, vunga market ,Gitega market ,vunga hospital) . The information obtained from murama village leader with the help of Mbuga cell leader they referred to 2017 population census in determination of individual served .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wCIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamazi",
  //       "bridge_opportunity_project_code": "1012990",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.975,
  //       "bridge_opportunity_gps_longitude": 29.38805,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1250,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.975,
  //       "proposed_bridge_location_gps_longitude": 29.38805,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Pass along way in Congo nile",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "None",
  //       "market_access_blocked_by_river": "Congo Nile",
  //       "education_access_blocked_by_river": "College de la paix",
  //       "health_access_blocked_by_river": "Congo Nile health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Seeking administration services and farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They fell in trying to cross",
  //       "notes_on_social_information": "Market (community 1). Sec school (community1).health center (1). Farms (community 1). Population information for each village was provided by ngabire salaam mukebera leader. She got data from census that collected 2018 in July Population of all adjacent communities includes the following villages: mukebera village and Congo Nile cell . Sometimes Congo Nile cell people do cross to visit their relatives twice a month",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 87,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wKGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mu Kivogo",
  //       "bridge_opportunity_project_code": "1012958",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.79307191,
  //       "bridge_opportunity_gps_longitude": 29.6751037,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1881,
  //       "bridge_opportunity_comments": "During District Planning it was found that the HWL for this site was incorrect. The district planner for Muhanga is from this village and indicated that the need at this site is low. (BAJ_12-6-18)",
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.79307191,
  //       "proposed_bridge_location_gps_longitude": 29.6751037,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "Flood occurs in April and September and it takes 3 hours",
  //       "market_access_blocked_by_river": "Vunga market , Kibangu market , Ngororero market",
  //       "education_access_blocked_by_river": "GS Shaki, GS Nyabinoni , ETG Gitumba",
  //       "health_access_blocked_by_river": "Shall Health center ,Nyabinoni health center and Shyira hospital",
  //       "other_access_blocked_by_river": "Nyabinoni sector office, shaki Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "GS Shaki( murama village , munini village ), ngororero market ( murama village , munini village ), Poste De Sante Shaki( murama village , munini village ), Shyira hospital ( Muzamuzi village , Ryakiyange village ), Nyabinoni health center ( Muzamuzi village , Ryakiyange village ), vunga market ( Muzamuzi village , Ryakiyange village ). Information by Esperance Yadufashije Mbuga village leader and Iyamuremye Cylille Murama village leader they based on population sencus of 2017",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 73,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wCNAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Ku mashuri ya Rushara",
  //       "bridge_opportunity_project_code": "1012972",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.55437,
  //       "bridge_opportunity_gps_longitude": 29.85284,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2789,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.55437,
  //       "proposed_bridge_location_gps_longitude": 29.85284,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "The market is too far and Mugorero and Bugondo suppose to cross two river , where Kagihanga and Karyango is one only, all communities are farming in valley where there is rivers, they suppose to cross",
  //       "education_access_blocked_by_river": "Kagihanga and Karyango are blocked to Rushers secondary school and Mugonero and Bugondo have student crossing the river to the Nemba 1 primary school in Karyango",
  //       "health_access_blocked_by_river": "Kagihanga and Karyango are blocked to the health center in Ndongozi closer to Mugonero",
  //       "other_access_blocked_by_river": "There are churches on both side and they cross river based on faith",
  //       "primary_occupations": "School",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the cell leader and communities leaders of the communities nearby the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wFbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukigogo",
  //       "bridge_opportunity_project_code": "1012973",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.56439,
  //       "bridge_opportunity_gps_longitude": 29.85781,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2866,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.56439,
  //       "proposed_bridge_location_gps_longitude": 29.85781,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Market is so far but (bugondo and Kagesera are blocked and they have to cross two river even Kagihanga and Karyango cross one to the river), for farming all communities are blocked , the river are in valley where there plantain potatoes and it is big farm",
  //       "education_access_blocked_by_river": "Nyagahondo and Karyango are blocked to Rushera secondary school which is so far but on other side on river",
  //       "health_access_blocked_by_river": "Nyangondo and Karyango are blocked to Ndongozi Health center",
  //       "other_access_blocked_by_river": "There are churches on both side and it depends on faith and there are many people that cross the river to church",
  //       "primary_occupations": "School, farms,",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by cell leader of Nyamugali, numbers was given by different communities leaders of different communities nearby the bridge.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 67,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wGEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryaruhirima",
  //       "bridge_opportunity_project_code": "1012974",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.54643,
  //       "bridge_opportunity_gps_longitude": 29.84546,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2351,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.54643,
  //       "proposed_bridge_location_gps_longitude": 29.84546,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge 1 kilometer away",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "The market is so far but Mugonero suppose to cross two rivers, the Ntazi can use the vehicular bridge for only the one river, all communities are blocked to their farms because are in valley where there is water",
  //       "education_access_blocked_by_river": "Ryaruhirima and Kagihanga are blocked to Rushara secondary school and there is student of primary school prefer to go to rushara primary school in Mugonero",
  //       "health_access_blocked_by_river": "Ryaruhirima and Kagihanga are blocked to Health center",
  //       "other_access_blocked_by_river": "There are churches on both side and to cross the bridge is based on the faith",
  //       "primary_occupations": "Health center",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the cell leader and communities leaders of different communities nearby the bridge and the source of numbers was given by community leaders expect Ntazi",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 69,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wGdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musave",
  //       "bridge_opportunity_project_code": "1012975",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.55797,
  //       "bridge_opportunity_gps_longitude": 29.86744,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1972,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.55797,
  //       "proposed_bridge_location_gps_longitude": 29.86744,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 63,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Karyango and Nyagahondo are blocked to the Market, and all communities are blocked to the farms",
  //       "education_access_blocked_by_river": "Cyabarenge is blocked to the primary Nemba 1 and 2 and cyabarenga , Karyango and Nyagahondo are blocked to Rushara primary and secondary school",
  //       "health_access_blocked_by_river": "Cyabarenga, Karyango and Nyagahondo are blocked to Health center",
  //       "other_access_blocked_by_river": "Churches are both side and it depends on faith to cross the bridge",
  //       "primary_occupations": "Market, schools and farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the cell leader with the different communities leaders who use that bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wGnAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirwa",
  //       "bridge_opportunity_project_code": "1012976",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.57513,
  //       "bridge_opportunity_gps_longitude": 29.87746,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2885,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.57513,
  //       "proposed_bridge_location_gps_longitude": 29.87746,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 63,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Shores and Nyiraruhuha are blocked to the Market and all communities are blocked to the farms",
  //       "education_access_blocked_by_river": "Shorezo and Nyiraruhuha are blocked to the Rubona Primary school and Ruhunde secondary school",
  //       "health_access_blocked_by_river": "Shorezo and Nyiraruhuha are blocked to Kanyaru health center",
  //       "other_access_blocked_by_river": "Churches are both side",
  //       "primary_occupations": "This is the main path to Market, and it can be use for school and farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by cell leader and communities leaders of the nearby communities of the bridge special the numbers of people",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wHbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ku mashuri ya rubona",
  //       "bridge_opportunity_project_code": "1012977",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.58122,
  //       "bridge_opportunity_gps_longitude": 29.88095,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2700,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.58122,
  //       "proposed_bridge_location_gps_longitude": 29.88095,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 63,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Shorezo and Nyiraruhuha are blocked to market and all communities are blocked to farms",
  //       "education_access_blocked_by_river": "Shorezo and Nyiraruhuha are blocked to Nusery, primary and secondary",
  //       "health_access_blocked_by_river": "Shorezo and Nyiraruhuha are blocked to Post-health center",
  //       "other_access_blocked_by_river": "Potable water (Nyiraruhuha, Shorezo), churches on both side",
  //       "primary_occupations": "Market, school, health center, farm",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Child was trying to cross the river during the rain and it was flooded",
  //       "notes_on_social_information": "Cell leader of Nyamugali and numbers was given by community leaders of different communities nearby the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 82,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wHlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyiraruganza( Gakereko)",
  //       "bridge_opportunity_project_code": "1012978",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.427205,
  //       "bridge_opportunity_gps_longitude": 29.475815,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2393,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.427205,
  //       "proposed_bridge_location_gps_longitude": 29.475815,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "From April to May, September to November, after 2 hours they can cross.",
  //       "market_access_blocked_by_river": "Farms(villages1,2,3,4)",
  //       "education_access_blocked_by_river": "Primary school (villages 3,4)",
  //       "health_access_blocked_by_river": "Health center (villages3,4)",
  //       "other_access_blocked_by_river": "Churches(villages 3,4), visiting relatives (vil,ages 1,2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, flour., potato, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and fractured",
  //       "notes_on_social_information": "The population information was provided by Runege cell leader, Frederic nteziryayo who sourced them from the cell officials record in 2016 from ubudehe.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": 2.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wHvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwangambibi(Runege)",
  //       "bridge_opportunity_project_code": "1012979",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.422048,
  //       "bridge_opportunity_gps_longitude": 29.465853,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2393,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.422048,
  //       "proposed_bridge_location_gps_longitude": 29.465853,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "During April, 1hours people can cross",
  //       "market_access_blocked_by_river": "Musebeya market( villages ,2,3), farms ( villages 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Runege primary school( villages ,4,5), musebeya secondary school (villages 1,2,3)",
  //       "health_access_blocked_by_river": "Musebeya health center (community 1,2,3,)",
  //       "other_access_blocked_by_river": "Government services(villages 1,2,3,), churches(villages 4,5)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, flour, potato, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population data for each village was provided by the Runege cell leader, Frederic Nteziryayo, who sourced them from cell record of ubudehe 2016. Population of all adjacent communities includes the following villages: Gakereko,Ndogondwe, Bigugu, Ruganza and Rukaranka. Communities members in those villages use the bridge to visit relatives, to visit market, to the health center and sometimes They cross the river to the churches.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community cross the river year round",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wI0AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamugari(kibiraro)",
  //       "bridge_opportunity_project_code": "1012981",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.295722,
  //       "bridge_opportunity_gps_longitude": 29.551741,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2602,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.295722,
  //       "proposed_bridge_location_gps_longitude": 29.551741,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "7 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "From September to December, April to May, after 2 hours they can cross",
  //       "market_access_blocked_by_river": "Market(villages 3,4), farms (villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "Primary school (villages 3,4)",
  //       "health_access_blocked_by_river": "Health center( villages 3,4)",
  //       "other_access_blocked_by_river": "Churches(villages 3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population information of each village was provided by Kibiraro cell leader, Aimable Nsengimana who sourced the population from the ubudehe record done in June 2018. The population of all adjacent communities includes the following villages: kibiraro, Runyinya, Mugaragara and Nyaruryango. Community members in every villages given above they use the bridge to go to the market, to the health center and students to schools and to the places of worship. They sometimes use the bridge to do farming and to visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wIAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugazi(rukeri)",
  //       "bridge_opportunity_project_code": "1012982",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.395584,
  //       "bridge_opportunity_gps_longitude": 29.487653,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2217,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.395584,
  //       "proposed_bridge_location_gps_longitude": 29.487653,
  //       "current_crossing_method": "None, washed away by floods",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "April, May, October, 2.5 hours",
  //       "market_access_blocked_by_river": "Market(1,2,3,4), farms(1,2,3,4)",
  //       "education_access_blocked_by_river": "Sekera primary school and secondary school (2,4)",
  //       "health_access_blocked_by_river": "Hospital(2,4), health center(2,4)",
  //       "other_access_blocked_by_river": "Places of worship(1,2,3,4), potable water(2,4), places of recreation(2,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "0",
  //       "notes_on_social_information": "The population information of each village was given by the executive secretary of sekera leader, seraphine Nyirambanza and Rugazi village leader, Mark Ngezahayo. Population of all adjacent communities includes the following villages, Rugazi, Rukeri, Mugano, and Nkomero. Community members in all villages given above usually cross the river to visit relatives, to go visit the market four times in a week, or to do farming.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wIFAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyirarukeri (bitaba)",
  //       "bridge_opportunity_project_code": "1012985",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.433943,
  //       "bridge_opportunity_gps_longitude": 29.46317,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3580,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.433943,
  //       "proposed_bridge_location_gps_longitude": 29.46317,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "7 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "Typical flood duration is 3hours, from March to May",
  //       "market_access_blocked_by_river": "Musebeya market( community 1,2,3,4), farms ( community 1,2,3,4,5),",
  //       "education_access_blocked_by_river": "Rugogwe secondary school ( community 1,2,3,4)",
  //       "health_access_blocked_by_river": "Musebeya health center(community 1,2,3,4)",
  //       "other_access_blocked_by_river": "Churches(1,2,3,4,5), government services ( musebeya sector, community 1,2,3,4)",
  //       "primary_occupations": "Farming, livestock",
  //       "primary_crops_grown": "bean, flour, maiz, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The information of population from each village was provided by the Runege cell leader, Fedreric NTEZIRYAYO, was sourced the population information from the cell officials data. Population of all adjacent communities includes the following villages: taba, Gacundura, rukaranka, ndogondwe, bishyiga and Rukeri.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": 3.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wJ8AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kano ya mukebera",
  //       "bridge_opportunity_project_code": "1012987",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9788,
  //       "bridge_opportunity_gps_longitude": 29.378611,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 818,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9788,
  //       "proposed_bridge_location_gps_longitude": 29.378611,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Congo Nile",
  //       "education_access_blocked_by_river": "Kibingo primary school",
  //       "health_access_blocked_by_river": "Congo Nile health center",
  //       "other_access_blocked_by_river": "Gishusho village fetch water in nkwiro and they have to cross",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, maiz",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They fell when it is flooded",
  //       "notes_on_social_information": "Market(community 1). Sec school (community 1), health center (community 1),farms (community 1and 2) and community 2 is challenged in rainy season to fetch water as it takes them cross. Population information for each village was provided by each village leader [nkwiro leader nsigayehe evariste nsigiyumva Elias gishusho leader and hakizimana Faustin nyagahinga leader and nyamyenda Jacque Gitarama leader] Population of all adjacent communities includes the following villages: nkwiro, gishusho, Gitarama and nyagahinga. Sometimes Gitarama and nyagahinga people do cross to visit their relatives twice a month",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Congo nile",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 69.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wJwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mwishokero",
  //       "bridge_opportunity_project_code": "1012988",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.97027,
  //       "bridge_opportunity_gps_longitude": 29.3844,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2794,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.97027,
  //       "proposed_bridge_location_gps_longitude": 29.3844,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "40 minutes",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Congo Nile market",
  //       "education_access_blocked_by_river": "College de la paix and Congo Nile",
  //       "health_access_blocked_by_river": "Congo Nile health center",
  //       "other_access_blocked_by_river": "Churches mucyebera",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Market (community 3), sec school (village 1,2,3). Farms(community 3), healthy center (community 1,2,3), administration services (1,2,3).Population information for each village was provided by each village leader and for bumba cell population was provided from head of bumba cell village leader uzabakiriho spriyani from the cell census 2018 [Kabiraho leader Nshimiyimana Donat,nsigiyumva Elias Gishusho leader and ngabire salaam mukebera leader ] Population of all adjacent communities includes the following village:mucyebera, gishusho, kabiraho and Bumba cell. Some times people from bumba visit their relatives twice a month and they go to the gihango sector office once a month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Congo nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 109,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wK6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mucyebera",
  //       "bridge_opportunity_project_code": "1012989",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.93166,
  //       "bridge_opportunity_gps_longitude": 29.4955,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2476,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.93166,
  //       "proposed_bridge_location_gps_longitude": 29.4955,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Nowhere",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Congo Nile",
  //       "education_access_blocked_by_river": "College de la paix",
  //       "health_access_blocked_by_river": "Congo Nile health center",
  //       "other_access_blocked_by_river": "Mukebera and nduba People are being blocked to reach to gihango sector office and congo nile cell office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped in rainy season and fell in the river",
  //       "notes_on_social_information": "Market(community 1 and 2), Sec School (community 1 and 2), health center (community 1 and 2),farms(community 1 and 2). Population information for each village was provided by each village leader [Ngabire Salaam mucyebera leader, Setako Jean Pierre Nduba leader and Congo Nile leader ] Population of all adjacent communities includes the following villages:mukebera, Nduba and Congo Nile villages. Congo Nile cell people sometimes cross to visit friends and relatives once a month",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 93,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wKBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bisomera 1",
  //       "bridge_opportunity_project_code": "1012991",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9222,
  //       "bridge_opportunity_gps_longitude": 29.473611,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2048,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9222,
  //       "proposed_bridge_location_gps_longitude": 29.473611,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "They use away ten minutes to fifteen added to their usual way time",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "0",
  //       "market_access_blocked_by_river": "Nyagasambu market",
  //       "education_access_blocked_by_river": "Mberi primary school and kabona high school",
  //       "health_access_blocked_by_river": "Kabona health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Market (community 1). Sec School community 1, health center (none), farms(none), farms(community 1,2 and 3) Population information for each village was provided by each village leader and they got data from census that collected 2018. And the adjacent communities numbers were provided by revere cell leader Munyaneza Etienne. Population of all adjacent communities includes the following village: ruganda, gahunga,nturo, remera Remera people do visit their relatives twice a month",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rutsiro",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-rutsiro",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They requested the bridge thinking b2p construct vehicular bridges and after informing them that it's only pedestrian and motorcycles bridges they said they only want vehicular bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wMbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Minaga-Mujerenge",
  //       "bridge_opportunity_project_code": "1012992",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.45957,
  //       "bridge_opportunity_gps_longitude": 29.42245333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4790,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45957,
  //       "proposed_bridge_location_gps_longitude": 29.42245333,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": "12 times in March, April and May, 4 hours after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary school",
  //       "health_access_blocked_by_river": "Health poste",
  //       "other_access_blocked_by_river": "Government offices, church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cow pea, maiz, potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Market(Minaga, Kinaba, Winzira, Gishwati); Primary school(Mujerenge) The information about the numbers directly served is given by local people and village leaders based on the monthly social census in the cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 1.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wNZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinaba-Subukiniro",
  //       "bridge_opportunity_project_code": "1012993",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.48689,
  //       "bridge_opportunity_gps_longitude": 29.416145,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4502,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.48689,
  //       "proposed_bridge_location_gps_longitude": 29.416145,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "60 times in April, May, October, and November, and it last 2 days after rainfall",
  //       "market_access_blocked_by_river": "Market, commercial center",
  //       "education_access_blocked_by_river": "Primary school",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices, church",
  //       "primary_occupations": "Farming, timber production",
  //       "primary_crops_grown": "cow pea, maiz, potato, sweet potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They slipped on trees and fall down in the river resulting to injuries",
  //       "notes_on_social_information": "Market (Kinaba, Uwinzira,); Health Center(Kinaba, Uwinzira, Tantamara, Kagano, Gishwati); Primary school(Kinaba, Uwinzira) The information about the people directly served and the sorounding communities were given by the local people and village leaders, they referred to the monthly census which is done in every cell of the sector",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 51.4,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wNeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo-Twiya 1",
  //       "bridge_opportunity_project_code": "1012994",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.37318833,
  //       "bridge_opportunity_gps_longitude": 29.42095333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3607,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37318833,
  //       "proposed_bridge_location_gps_longitude": 29.42095333,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "20 times in April and September, and it lasts 1 day after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary school",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, potato, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 14,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market(Twiya, Karambo, and Muhingo village, Gatare cell) Primary and Secondary school( Twiya, Muhingo, Karambo) Health Center(Gituntu, Rwangambibi, Runaba) The numbers of people directly served are given by the local people and their leaders based on the census which is conducted monthly in every cell N.B: The village of Gituntu has a population of 497 and it regularly uses this crossing but due to lack of space, it is not mentioned but its people is included in the total population. It is the same case to Gatare cell which has the the population of 4372 people",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57.4,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wNjAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo-Twiya 2",
  //       "bridge_opportunity_project_code": "1012995",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.37023167,
  //       "bridge_opportunity_gps_longitude": 29.42249833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3547,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37023167,
  //       "proposed_bridge_location_gps_longitude": 29.42249833,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "20 times in April and September, and it lasts 1 day after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, potato, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 14,
  //       "incident_descriptions": "They fall into the river while trying to jump when the river is flooded",
  //       "notes_on_social_information": "Market(Karambo,Twiya, Muhingo village and Gatare cell) Primary and Secondary( Twiya, Karambo and Muhingo ) Health Center(Gituntu, Runaba, and Rwangambibi) The numbers are given by the local people and their leaders based on the monthly census which is done in every cell N.B: Gatare cell and Gituntu village are regularly crossing this river to access the market but they are not mentioned due to lack of space in the form but their population are included in the total population. Gatare cell has 4372 people and Gituntu village has 497 people",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 52.4,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wNoAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo-Gituntu",
  //       "bridge_opportunity_project_code": "1012996",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.368775,
  //       "bridge_opportunity_gps_longitude": 29.42337667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3154,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.368775,
  //       "proposed_bridge_location_gps_longitude": 29.42337667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "20 times in April and September, and it last 1 day after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary school",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government Office building",
  //       "primary_occupations": "Farming,",
  //       "primary_crops_grown": "bean, maiz, potato, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 15,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market (Twiya, Karambo, Muhingo); Primary school(Twiya, Karambo, Muhingo); Health Center (Gituntu, Rwangambibi, Karambo, Runaba) These numbers were given by the local people and their leaders referred to the monthly census which is done in every cell. N.B: there is also a village of Muhingo that it is not written in the people directly served due to lack of space and it has 890 people and also Gatare cell uses this crossing to have access to the market and it has 4372",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56.4,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wNtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasenge-Mubezi",
  //       "bridge_opportunity_project_code": "1012998",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.52520667,
  //       "bridge_opportunity_gps_longitude": 29.50410667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3455,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.52520667,
  //       "proposed_bridge_location_gps_longitude": 29.50410667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "28 times March, April, May, November, and December, it lasts 2 hours after rainfall",
  //       "market_access_blocked_by_river": "Market, Commercial center",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health post",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming, commerce",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market(Mubezi, Gahembe, Vumwe, Bireka, Mujuga) Primary and Secondary schools(Ruziba,Gasenge, Ryarubondo, Kanserege) Health post(Mubezi, Gahembe, Vumwe, Bireka, Mujuga) The numbers of the people directly served and the sorounding communities were given by the local people and their leaders based on the monthly report given by every village leader The villages of Ruziba, Kanserege, Gahembe, Vumwe, Bireka, Rwufe are using this crossing regularly but they are not mentioned due to lack of space in the form but their population are included in the total population to be served.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": 2.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wO3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Baziro-Gishenge",
  //       "bridge_opportunity_project_code": "1012999",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.34743667,
  //       "bridge_opportunity_gps_longitude": 29.4097,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2744,
  //       "bridge_opportunity_comments": "Not duplicate",
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34743667,
  //       "proposed_bridge_location_gps_longitude": 29.4097,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April and May, November and December, it lasts for 3 hours after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health post",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Large tree plantation(forest), potatoes farms, wheat farms, local commerce",
  //       "primary_crops_grown": ", maiz, potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market(Mutengeri, Gishenge) Primary and Secondary schools(Gishenge, Mutengeri, Baziro) The people directly served and the sorounding communities were provided by the local people and their leaders based on the monthly census which is done in every cell The people of Kagusa and Rushyarara use this crossing regularly but they are not mentioned due to lack of space on the form but they are included in the total population. Kagusa has 393 people and Rushyarara has 390 people",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53.8,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wO8AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Baziro-Kivumu",
  //       "bridge_opportunity_project_code": "1013000",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.35571333,
  //       "bridge_opportunity_gps_longitude": 29.4072,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2728,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.35571333,
  //       "proposed_bridge_location_gps_longitude": 29.4072,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 24,
  //       "flood_duration_during_rainy_season": "24 times in April, November, it lasts 2.5 hours after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary 3",
  //       "health_access_blocked_by_river": "Health post",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming( large potato and sweet potatoes farms)",
  //       "primary_crops_grown": "bean, maiz, potato, sweet potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market (Mutengeri, Kivumu) Primary and Secondary schools (Mutengeri, Kivumu, Baziro) Health post(Baziro) The numbers given for the people directly served are from the local people and their leaders who referred to the monthly census which is done in every cell. The village of Rushyarara is using this crossing regularly and it is not mentioned in the form due to lack of space but its population is added to the total population. Rushyarara has 390 people",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 61.8,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wODAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murembo-Kiyovu",
  //       "bridge_opportunity_project_code": "1013001",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.373135,
  //       "bridge_opportunity_gps_longitude": 29.40052667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3924,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.373135,
  //       "proposed_bridge_location_gps_longitude": 29.40052667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "10 km",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "50 times In March, April, May, November and December, and it lasts 4 hours after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Churches, government offices",
  //       "primary_occupations": "Farming, Tea factories, construction site,",
  //       "primary_crops_grown": "bean, cow pea, maiz, potato, tea, wheat",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market on Wednesday and Saturday (Murembo, Gashasha) Market on Tuesday (Kiyovu, Muhingo, Twiya, Karambo, Rushyarara, Bimba, Ruhanga, Kagusa, Baziro, Rugano,Gashwati, Rwangambibi, Runaba, Gituntu, Sangano, Kageyo, Gasharu, Nyarurambi Health Center (Kiyovu, Muhingo, Twiya, Karambo, Rushyarara, Bimba, Ruhanga, Kagusa, Baziro, Rugano,Gashwati, Rwangambibi, Runaba, Gituntu, Sangano, Kageyo, Gasharu, Nyarurambi) Primary and Secondary (Kiyovu, Muhingo) The numbers of people directly served and the sorounding communities were given by the local people and their leaders based on the monthly census which is done in every cell, and the villages mentioned here are using this crossing regularly. And Their population were included in the total population.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": 2.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wOIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muturirwa",
  //       "bridge_opportunity_project_code": "1013002",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.26129,
  //       "bridge_opportunity_gps_longitude": 29.74834,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3723,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.26129,
  //       "proposed_bridge_location_gps_longitude": 29.74834,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May it last for 24 hours",
  //       "market_access_blocked_by_river": "Muturirwa and Rugogwe Markets (Community 1,3), Ruhango and Butansinda Markets (Community 2,4)",
  //       "education_access_blocked_by_river": "Kaganza Primary and Secondary school (Community 1,3)",
  //       "health_access_blocked_by_river": "Gatagara Health center (Community 1,3)",
  //       "other_access_blocked_by_river": "Kagwa Pentecost church (Community 2,4) and Muturirwa Adventist church (Community 1,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking Safari Jean de Dieu the Executive Secretary of Ngwa Cell and Nkurunziza Amiel the village leader of Kidaturwa Village who collected the data in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wQXAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muhazi",
  //       "bridge_opportunity_project_code": "1013003",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.27217,
  //       "bridge_opportunity_gps_longitude": 29.76871,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2093,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.27217,
  //       "proposed_bridge_location_gps_longitude": 29.76871,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 7,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Butansinda and Ruhango Markets (Community 2,3), Nyanza Market (Community 1)",
  //       "education_access_blocked_by_river": "Mwanabiri primary school (Community 2,3)",
  //       "health_access_blocked_by_river": "No health access blocked here each community has its own health services and there are other destinations when they want to go to a more advanced health center.",
  //       "other_access_blocked_by_river": "Mwanabiri Adventist church (Community 2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries or death by river crossing.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking Safari Jean de Dieu the Executive Secretary of Ngwa Cell and Ngabirinda Francois: Karenge village leader and Ngiruwonsanga Uziel: Kigarama Village leader; from the data they collected early in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wQcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutete",
  //       "bridge_opportunity_project_code": "1013004",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.28832,
  //       "bridge_opportunity_gps_longitude": 29.75688,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2810,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.28832,
  //       "proposed_bridge_location_gps_longitude": 29.75688,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "0.5 km",
  //       "days_per_year_river_is_flooded": 7,
  //       "flood_duration_during_rainy_season": "In April, May and November it last for 2 hours",
  //       "market_access_blocked_by_river": "Ruhango and Butansinda Markets (Community 1,4), Nyanza, Gatagara and Kiruri Markets (Community 2,3)",
  //       "education_access_blocked_by_river": "Nyarutovu primary and secondary school (Community 2,3), Mwanabiri primary school (Community 1,4)",
  //       "health_access_blocked_by_river": "Gatagara Health center (Community 2,3)",
  //       "other_access_blocked_by_river": "Mwanabiri Adventist church (Community 1,4), Gatagara Catholic Church (Community 2,3) and Mukingo Sector Office (Community 2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "cassava, coffe, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking the Ngwa Cell leader, Safari Jean de Dieu; Rutete Village leader, Vuguziga Eliel; Karenge Village leader, Ngabirinda Francois; Mwanabiri village leader, Mbonigaba Thomas; from the data collected in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wQhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamiranzovu",
  //       "bridge_opportunity_project_code": "1013021",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.67981,
  //       "bridge_opportunity_gps_longitude": 29.58516,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": "BAJ confirms rejection.",
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67981,
  //       "proposed_bridge_location_gps_longitude": 29.58516,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musaz",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "At any distance up stream and down stream no available backstay and steep terrain",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yKxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagano",
  //       "bridge_opportunity_project_code": "1013635",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.876944,
  //       "bridge_opportunity_gps_longitude": 29.348055,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2696,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.876944,
  //       "proposed_bridge_location_gps_longitude": 29.348055,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gakeri",
  //       "education_access_blocked_by_river": "Apakape primary and secondary and kavumu primary school",
  //       "health_access_blocked_by_river": "Kayove",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One kid fell when it was flooded and got a serious injury",
  //       "notes_on_social_information": "Information gathered from kagano leader appollinaire. Kagano and kashashi and mukati don't have access to gakeri market and farms",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iSMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinyinya",
  //       "bridge_opportunity_project_code": "1013005",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.2864,
  //       "bridge_opportunity_gps_longitude": 29.73414,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3381,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2864,
  //       "proposed_bridge_location_gps_longitude": 29.73414,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Nyanza and Buhanda Markets (Community 1,3); Gatagara market (Community 2,4)",
  //       "education_access_blocked_by_river": "Nyarutovo primary and secondary school (Community 2,4)",
  //       "health_access_blocked_by_river": "Gatagara Health Center (Community 2,4)",
  //       "other_access_blocked_by_river": "Mukingo Sector Office (Community 2,4); Mpanga prison (Community 1,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking the Ngwa Cell leader, Safari Jean de Dieu; the Karambi Village leader, Mukeshimana Drocella. The data provided were collected in 2018. Population of All Adjacent Communities includes the following villages: Kiganda, Nzuki, Mataba, and Mwanabiri. Community members in Mwanabiri sometimes use this crossing to visit Mpanga Prison once a month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1(Kigali-Huye-Akanyaru )",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wQmAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mataba",
  //       "bridge_opportunity_project_code": "1013006",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.28569,
  //       "bridge_opportunity_gps_longitude": 29.71634,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5453,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.28569,
  //       "proposed_bridge_location_gps_longitude": 29.71634,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Ruhango and Murehe Markets (Community 2,3), Nyanza, Buhanda and Kigogo Markets(Community 1,4,5)",
  //       "education_access_blocked_by_river": "Kaganza primary and secondary (Community 2,3), Nkomero primary and secondary school (Community 1,4,5)",
  //       "health_access_blocked_by_river": "Gatagara Health Center Community (2,3), Nyanza and Gitwe Hospitals (Community 1,4,5)",
  //       "other_access_blocked_by_river": "Mpanga Prison (Community 1,4,5) , Kigarama Adventist church and Ruhango Catholic church (Community 2,3) Mukingo Sector office (Community 2,3)",
  //       "primary_occupations": "Agriculture and Dairy farming",
  //       "primary_crops_grown": "cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people on bicycle and motorcycle have been falling into the river, and some were seriously injured and taken to hospital.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking the Mpanga cell leader, Mukamajyambere Esperance; the Mataba village leader, Kalisa Vincent. These population Data were collected in 2016. Population of All Adjacent Communities includes the following villages: Karambi, Mwanabiri, Biroro, and Rutete. These adjacent Community members sometimes use this crossing to visit relatives, or to visit the market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wQwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kavure",
  //       "bridge_opportunity_project_code": "1013007",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.28603,
  //       "bridge_opportunity_gps_longitude": 29.67857,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2399,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.28603,
  //       "proposed_bridge_location_gps_longitude": 29.67857,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "When it floods during rainy season, it last for 2hours",
  //       "market_access_blocked_by_river": "Kinimba market (Community 3 and part of community 1), Nkomero and Buhanda Markets (Community 1,2)",
  //       "education_access_blocked_by_river": "Rubona primary and secondary school (Community 3 and part of community 1)",
  //       "health_access_blocked_by_river": "Nkomero Health post (Community 1,2)",
  //       "other_access_blocked_by_river": "Rubona Catholic Church (Community 3 and part of community 1), Rubona Cell Office (part of community 1)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries or death by river crossing",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking the Bugarama village leader, Sebyenxa Aimable and Rubona Cell leader, Ngirinshuti Jean Pierre. Adjacent community from Nkomero Cell use this crossing to visit relatives.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ndago",
  //       "bridge_opportunity_project_code": "1013008",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.35939,
  //       "bridge_opportunity_gps_longitude": 29.6848,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2306,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.35939,
  //       "proposed_bridge_location_gps_longitude": 29.6848,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "In April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Rurangazi, Kigohe, Gaseke Markets (Community 2,3); Cyahafi and Runga Markets (Community 1,4)",
  //       "education_access_blocked_by_river": "Cyarwa Primary School (Community 2,3)",
  //       "health_access_blocked_by_river": "Cyarwa Health Center (Community 2,3)",
  //       "other_access_blocked_by_river": "ADPR and Cyarwa Catholic Church (Community 2,3); Runga Anglican church (Community 1,4)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, potatoes., vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders of Ndago Village and Kavumu Village from the population data they collect every year.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kubateri",
  //       "bridge_opportunity_project_code": "1013009",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.39148,
  //       "bridge_opportunity_gps_longitude": 29.69369,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3704,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.39148,
  //       "proposed_bridge_location_gps_longitude": 29.69369,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2hours",
  //       "market_access_blocked_by_river": "Fatima, Rukondo and Mubuga Markets (Community 1,4)",
  //       "education_access_blocked_by_river": "Mubuga Primary and Secondary School (Community 1,4)",
  //       "health_access_blocked_by_river": "Cyaratsi Health Center (Community 1,4)",
  //       "other_access_blocked_by_river": "Mubuga Protestant Church (Community 1,4) and Runga Adventist Church (Community 2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A young girl trying to cross the river were injured and taken to hospital.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders of Kadusenyi Village, Rugarama B, Kabisine, and Kigarama Village. The population data were collected in 2016",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru )",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagina",
  //       "bridge_opportunity_project_code": "1013010",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.34749,
  //       "bridge_opportunity_gps_longitude": 29.79864,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4286,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34749,
  //       "proposed_bridge_location_gps_longitude": 29.79864,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 7,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1hour",
  //       "market_access_blocked_by_river": "Mugina and Kayanza Markets ( Community 4,5), Nyanza Market (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Nyamure Primary and Secondary School (Community 4,5), Kavumu Catholic Primary School ( Community 1,2,3)",
  //       "health_access_blocked_by_river": "Migina Health Center (Community 4,5), Hanika Health Post (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Nyamure Adventist church and Nyamure Catholic Church (Community 4,5), Hanika Catholic Church (Community 1,2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, cassava, pea, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "Two motorcycle riders fell into the river and one woman fell into the river, some were injured. But the number of injured people is more than 20.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buhaza",
  //       "bridge_opportunity_project_code": "1013012",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.33834,
  //       "bridge_opportunity_gps_longitude": 29.84104,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7973,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.33834,
  //       "proposed_bridge_location_gps_longitude": 29.84104,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Migina and Nyamiyaga Markets (Community 1), Gati Market (Community 2,3,4)",
  //       "education_access_blocked_by_river": "Nyarugunga primary school and Nyamiyaga primary and secondary school (Community 1); Kayanza primary school (Community 2,3,4)",
  //       "health_access_blocked_by_river": "Migina and Nyamiyaga Health Centers (Community 1)",
  //       "other_access_blocked_by_river": "Nyamiyaga catholic church (Community 1) and Kayanza Adventist church (Community 2,3,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders, Buhaza, Kinyoni and Nyarugunga villages. The population data were collected in 2017",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bigugu",
  //       "bridge_opportunity_project_code": "1013013",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.38034,
  //       "bridge_opportunity_gps_longitude": 29.86227,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7734,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.38034,
  //       "proposed_bridge_location_gps_longitude": 29.86227,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 7,
  //       "flood_duration_during_rainy_season": "In April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Kabirizi, Ntyazo and Migina Markets (Community 1,3)",
  //       "education_access_blocked_by_river": "Nyagasozi secondary school (Community 1,3); Nyabusunzu primary school (Community 2,4,5)",
  //       "health_access_blocked_by_river": "Nyamure Health Center (Community 2,4,5); Nyamiyaga, Karama and Kabirizi Health Centers (Community 1,3)",
  //       "other_access_blocked_by_river": "Muyira Sector office (Community 1,3); Nyamiyaga Catholic Parish (Community 1,3); ADPR & Protestant Churches (Community 2,4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, cassava, dairy product, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No major injuries except children going or coming to school that have been falling from the timber bridge into the river.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders of directly served communities. The population data were collected in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakagende",
  //       "bridge_opportunity_project_code": "1013014",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.37474,
  //       "bridge_opportunity_gps_longitude": 29.86776,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7734,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37474,
  //       "proposed_bridge_location_gps_longitude": 29.86776,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May, it last for 1 day",
  //       "market_access_blocked_by_river": "Kabirizi and Ntyazo market, Migina market (Community 1,3)",
  //       "education_access_blocked_by_river": "Nyagasozi Secondary school (Community 1,3); Nyabusunzu Primary school (Community 2,4,5)",
  //       "health_access_blocked_by_river": "Nyamure Health Center (Community 2,4,5); Nyamiyaga, Karama and Kabirizi Health Centers (Community 1,3)",
  //       "other_access_blocked_by_river": "Muyira Sector office (Community 1,3); Nyamiyaga Catholic Parish (Community 1,3); ADPR & Protestant Churches (Community 2,4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 21,
  //       "incident_descriptions": "Many people",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking village leaders. The population data were collected in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamiyaga",
  //       "bridge_opportunity_project_code": "1013015",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.34365,
  //       "bridge_opportunity_gps_longitude": 29.72707,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7504,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34365,
  //       "proposed_bridge_location_gps_longitude": 29.72707,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 months",
  //       "market_access_blocked_by_river": "Nyanza Market, Nyanza town (Community 1,3)",
  //       "education_access_blocked_by_river": "Primary and Secondary Schools in nyanza (Community 1,3)",
  //       "health_access_blocked_by_river": "Nyanza Health center and Nyanza Hospital (Community 1,3)",
  //       "other_access_blocked_by_river": "Rwabicuma Sector (Community 2,4); Nyanza Catholic Church and Nyanza Town (Community 1,3)",
  //       "primary_occupations": "Agriculture, animal husbandry and Brick making",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "More than 100 people have been falling into the river at the current crossing point none of them were seriously injured.",
  //       "notes_on_social_information": "The information about the population to be served by the bridge was determined by asking The executive Secretary of Gacu Cell, Ezechiel Ngirinshuti. The population data were collected in 2017. This crossing point is used by many communities from Rwabicuma Sector going to Nyanza town as it is located near the town.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyanza Town Roads",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wRzAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bugarama",
  //       "bridge_opportunity_project_code": "1013018",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.61591,
  //       "bridge_opportunity_gps_longitude": 29.45511,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4650,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61591,
  //       "proposed_bridge_location_gps_longitude": 29.45511,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "200 m",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "2days",
  //       "market_access_blocked_by_river": "Kora market open every Wednesday and Friday , potatoes farms",
  //       "education_access_blocked_by_river": "Bukinanyana Primary school is blocked to communities of the left side and Jenda secondary school blocked to communities of the left side but to access this school there's an alternative of using the paved road",
  //       "health_access_blocked_by_river": "Jenda health center blocked to communities of left side but there is an alternative of using the paved road Kigali-Rubavu",
  //       "other_access_blocked_by_river": "AEBR church blocked to communities of right side",
  //       "primary_occupations": "Kora market traders, local farmers on small scale of potatoes and vegetables",
  //       "primary_crops_grown": "potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Sliding on existing timber bridge when the channel is flooded but fortunately none died because the channel depth is not deeper",
  //       "notes_on_social_information": "Kora market (community 1); Jenda secondary school (Community 2,3);Jenda sector office (2,3);Bukinanyana (Community 2,3). Population information for each village was provided by the village leader of each village respectively, population information was sourced from village census data collected in January 2018 Other more communities ,the paved road will be easier way for them to access any facilities",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 23,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yKdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bukinanyana",
  //       "bridge_opportunity_project_code": "1013019",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.66374,
  //       "bridge_opportunity_gps_longitude": 29.4215,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2098,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66374,
  //       "proposed_bridge_location_gps_longitude": 29.4215,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 67,
  //       "flood_duration_during_rainy_season": "1day",
  //       "market_access_blocked_by_river": "Kora market open weekly is blocked to communities of right side of the river , access to potatoes ,onions and Pyreth farms is blocked by the river and large pastures for cattle and milk production in the right side is blocked as",
  //       "education_access_blocked_by_river": "Rega secondary is blocked to communities of the right",
  //       "health_access_blocked_by_river": "Arusha and Rega health center are blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Arusha cell office, Protestants and Catholic churches",
  //       "primary_occupations": "Farmers of potatoes on large land, livestock ( cows), Kora market traders",
  //       "primary_crops_grown": "a large l, beans maiz, for pastures (cattle ), potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "The traditional crossing was in timber, those passed away were due to slipping on wet logs and fall into the river flowing at high speed during rain season",
  //       "notes_on_social_information": "Rega secondary school (Community 2,3,4); Rega health center (2,3,4); kora market (2,3,4) pasture for cattle (Community 1), farms of potatoes and vegetables (Community ,1) Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018 Population of adjacent communities include Arusha village. Community members in Arusha sometimes use this crossing to Visit relatives",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yKiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinaba",
  //       "bridge_opportunity_project_code": "1013020",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.68764,
  //       "bridge_opportunity_gps_longitude": 29.5561,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4352,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.68764,
  //       "proposed_bridge_location_gps_longitude": 29.5561,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 hour",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day in April and December",
  //       "market_access_blocked_by_river": "Gasiza and Kabaya market are blocked to communities on right side,farmers on both sides",
  //       "education_access_blocked_by_river": "Gitebe secondary school blocked to communities of right side and Kilimbogo primary school blocked to communities on left",
  //       "health_access_blocked_by_river": "Jomba health center is blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Access District head quarter and churches are blocked",
  //       "primary_occupations": "Farmers, workers in tea plantation ,traders at Gisiza and Kabaya market",
  //       "primary_crops_grown": "maiz, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Gasiza market(community 1,3,4,5,6,7), Kabaya market( village 1,3,4,5); Jomba health center (villages 1,3,4,5,6,7), district. Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018. Population of adjacent communities include the following villages:Gisunza,Budaca,Kinanira,Gatwe and Remera. Community members in these villages sometimes use this crossing to Visit relatives and access Kabaya market sometimes",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yKsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwanika",
  //       "bridge_opportunity_project_code": "1013022",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.67288,
  //       "bridge_opportunity_gps_longitude": 29.57468,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1677,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67288,
  //       "proposed_bridge_location_gps_longitude": 29.57468,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 day Very often ,the river floods in April and September",
  //       "market_access_blocked_by_river": "Vunga market blocked to communities of left side, Rurembo market blocked to communities of right side and farms on both side",
  //       "education_access_blocked_by_river": "Gitebe secondary school and Jomba secondary school blocked to communities on the left side of the river",
  //       "health_access_blocked_by_river": "Jomba health center is blocked to communities of the left side of the river",
  //       "other_access_blocked_by_river": "Churches,",
  //       "primary_occupations": "Farmers of sweet potatoes and maize on small scale, Vunga market traders",
  //       "primary_crops_grown": "maiz, on some area trees were planted, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Jomba health center (community,1,4 ),Vunga market(community,1,4 ),Jomba secondary school (community,1,4 ),Nkerima primary school (Community,1,4 ),farms(community, 2,3). Population information for each village was provided by the village leader of each village was provided by the village leader of the respective villages who sourced the population information from the village census data collected in 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yL2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kidandari",
  //       "bridge_opportunity_project_code": "1013023",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.66939,
  //       "bridge_opportunity_gps_longitude": 29.59021,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3563,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66939,
  //       "proposed_bridge_location_gps_longitude": 29.59021,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "400 m",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "4days in April",
  //       "market_access_blocked_by_river": "Vunga , the major market is blocked to communities on left and Rurembo market is blocked to communities of right side, workers at Giciye hydroelectric power plant",
  //       "education_access_blocked_by_river": "Kazenzo Primary is near the communities but blocked to those on right side, Jomba secondary school on right",
  //       "health_access_blocked_by_river": "Jomba health center and Shyira health center",
  //       "other_access_blocked_by_river": "Rurembo Parish which is on left and Nkirima church on right side",
  //       "primary_occupations": "Farmers of maize,sweet potatoes on small scale, Vunga and Rurembo market traders and workers at Giciye hydroelectric power plant projects (roads construction)",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Vunga market (community 4,5); Jomba health center (community 4,5); Jomba secondary school (community 4,5); Kazenzo (community 1,2,3); Rurembo market (Community1,2,3); Rurembo Parish (community1,2,3) . Population information for each village was provided by the village leader of the respective villages. Population information sourced from village census data collected in 2018 Population of adjacent communities include the following villages: Rubona I and Musezero.Community members in Musezero and Rubona I sometimes use this crossing to Visit relatives and in some monthly communities services",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yL7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bihira",
  //       "bridge_opportunity_project_code": "1013024",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.63099,
  //       "bridge_opportunity_gps_longitude": 29.58643,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2186,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63099,
  //       "proposed_bridge_location_gps_longitude": 29.58643,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Rurembo market open on Monday and Friday blocked to communities of left side and mubaya markets blocked to communities of right side of the river",
  //       "education_access_blocked_by_river": "Rurembo primary and secondary school blocked to communities of the left side and Murungo primary and secondary school blocked to communities of right side",
  //       "health_access_blocked_by_river": "Rurembo health center on the right is blocked to communities of the left side of the river",
  //       "other_access_blocked_by_river": "Rurambo sector office and Rurembo Parish on the right is blocked",
  //       "primary_occupations": "Rurembo and Mubayu market traders, farmers on small scale of the sweet potatoes, maize and wheat",
  //       "primary_crops_grown": "maiz, sweet potato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Rurembo health center (Community3,4,5 ), Rurembo sec.school(community, 3,4,5),Rurembo market(Community, 3,4,5), Rurembo sector office (Community,3,4,5 ), Murungo primary and secondary school (community,1,2 ), Mubayo market(Community, 1,2) Population information for each village was provided by the village leader of the respective villages who sourced the population information from the village census data collected in 2018 Population of adjacent communities include Tyazo. Community members of Tyazo sometimes use this crossing to Visit relatives",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yLCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwamigega",
  //       "bridge_opportunity_project_code": "1013026",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.67288,
  //       "bridge_opportunity_gps_longitude": 29.57468,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2848,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67288,
  //       "proposed_bridge_location_gps_longitude": 29.57468,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "7 days( week) in April",
  //       "market_access_blocked_by_river": "Kabashumba market open on Thursday and Sunday , Rurembo market open on Monday and Friday",
  //       "education_access_blocked_by_river": "Rurembo primary and secondary schools are blocked to communities of the left side and Ryinyo primary school blocked to communities on Right side of the river",
  //       "health_access_blocked_by_river": "Rutoyi health center is blocked to communities from Right. This is preferred as it has emergence Vehicle Services and Rurambo health center blocked to communities on left",
  //       "other_access_blocked_by_river": "Baptistand Protestants churches , Catholic Parish at Rambura",
  //       "primary_occupations": "Rurambo and kabashumba market traders and local farmers on small scales",
  //       "primary_crops_grown": "maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded . Some got injured legs or arms",
  //       "notes_on_social_information": "Ryinyo primary (Community 1,3,4),Rutoyi health center (Community 1,3,4), Mukamira market open every Monday and Friday (community kabashumba market (community 1,3,4), Ruremo health center (2,5) Population information for each village was provided by the village leader of the respective villages",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yLMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murambi",
  //       "bridge_opportunity_project_code": "1013027",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "1 day in April and December",
  //       "market_access_blocked_by_river": "Gasiza market, potatoes plantation, tea plantation workers",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Potatoes, cattle and tea plantation",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and got injured and their bags are taken away",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yLRAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyiragakokora",
  //       "bridge_opportunity_project_code": "1013028",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.68216,
  //       "bridge_opportunity_gps_longitude": 29.46831,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1630,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.27",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.68216,
  //       "proposed_bridge_location_gps_longitude": 29.46831,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "1",
  //       "market_access_blocked_by_river": "Gasiza market open every Tuesday and Friday ,Kora market (major)open every Wednesday and Friday , pastures(livestock/cattle , ), Dairy (milk collection zone) frequently used , tea plantations and potatoes farms",
  //       "education_access_blocked_by_river": "Nyiragokokora primary school",
  //       "health_access_blocked_by_river": "Nyiragokokora health center",
  //       "other_access_blocked_by_river": "Protestants church",
  //       "primary_occupations": "Dairy farmers (there's is livestock/cattle on a large plot of land. Then milk is transported on head using this crossing ), traders at Kora market and workers in Nyabihu tea plantation",
  //       "primary_crops_grown": "maiz, milk products for cattle farmer, potatoes on large scal",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded",
  //       "notes_on_social_information": "Nyiragokokora health center(2,3,4) , Kora market (Community 2,3,4), Gisiza market (community2,3,4 ), Nyiragokokora primary school (community 2,3,4), Diary (Community 2,3,4) livestock farms(Community 1) Population information for each village was provided by the village leader in their respective villages who sourced the population information from the village census data collected in 2018 Population of adjacent communities include Murambi and Sukiro. Community members of Murambi and Sukiro sometimes use this crossing to Visit relatives and work in tea plantations",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6yLWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirwa",
  //       "bridge_opportunity_project_code": "1013216",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.53163167,
  //       "bridge_opportunity_gps_longitude": 29.53586,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3838,
  //       "bridge_opportunity_comments": "Not Duplicate",
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.53163167,
  //       "proposed_bridge_location_gps_longitude": 29.53586,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 26,
  //       "flood_duration_during_rainy_season": "26times in April, May, October and it lasts 2hours after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming(Large sweet potatoes farms, sorghum, cassava farms",
  //       "primary_crops_grown": ", cassava, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market Ryarubondo (Kirwa, Ntaruka, Rususa, Muhembe, Rweru ) Primary school Kirwa(Gitovu) Primary school Gisanze(Kirwa) Health post(Kirwa) The villages of Rususa, Muhembe, Rweru are using this crossing and their people were included in the total population. The survey numbers were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56.4,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75urAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasenge",
  //       "bridge_opportunity_project_code": "1013217",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.53568,
  //       "bridge_opportunity_gps_longitude": 29.5136,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3243,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.53568,
  //       "proposed_bridge_location_gps_longitude": 29.5136,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 56,
  //       "flood_duration_during_rainy_season": "8 times in April and October and it lasts 7days",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming(There are terraces on the right side, forest, cow pea farm, sweet potatoes farm)",
  //       "primary_crops_grown": ", cow pea, maiz, potato, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market Ryarubondo( Gasenge, Kigusa, Ruziba, Muhati) Market Gasarenda( Ryarubondo, Kanserege) Primary and Secondary schools( Kigusa, Gasenge) Health post(Kigusa, Gasenge, Ruziba) Kanserege village this crossing and their people were included in the total population. This social survey numbers were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 71.4,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75uwAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigarama",
  //       "bridge_opportunity_project_code": "1013219",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.500105,
  //       "bridge_opportunity_gps_longitude": 29.56810167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2894,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.1",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.500105,
  //       "proposed_bridge_location_gps_longitude": 29.56810167,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "50times April, May, October, November and it lasts 2hours after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Primary school, there are no children need to cross the river heading to secondary school, only those in primary need to do so",
  //       "health_access_blocked_by_river": "Health center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, sorghum, cassava, beans",
  //       "primary_crops_grown": "bean, potato, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "It was a kid coming from school and while trying to walk into the river for crossing, the river taken her away and she died.",
  //       "notes_on_social_information": "Market kamiro( Kigarama, Gitantu, Ryanyirataba) Market Gasaka( Gasharu, Kamiro) Primary school (Kigarama) Health Center (Kigarama, Ryanyirataba) Those numbers of the social survey were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": 2.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75vBAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryanyirataba",
  //       "bridge_opportunity_project_code": "1013221",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.50142333,
  //       "bridge_opportunity_gps_longitude": 29.55574,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3151,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.50142333,
  //       "proposed_bridge_location_gps_longitude": 29.55574,
  //       "current_crossing_method": "Vehicular bridge in 3km away from the proposed footbridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "50 times in April, May, October, November and it lasts 2hours after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Children study on the schools of their sides no need to cross the river heading to school but since they have farm lands on both sides of the river, children are used to cross for harvesting the crops",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of cassava, sweet potatoes, sorghum, but also animal keeping",
  //       "primary_crops_grown": "bean, sassava, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They are pushed by the flow of the river",
  //       "notes_on_social_information": "Market Kamiro (Ryanyirataba, Gasaka) Market Nzega( Kamiro, Gasharu) Health Center (Ryanyirataba) These numbers of the social survey were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38.6,
  //       "height_differential_between_banks": 2.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zAAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gafuro ya 2",
  //       "bridge_opportunity_project_code": "1013223",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.51139,
  //       "bridge_opportunity_gps_longitude": 29.81161,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1594,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.51139,
  //       "proposed_bridge_location_gps_longitude": 29.81161,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Rugarama, musama Are blocked to the Market and farms",
  //       "education_access_blocked_by_river": "Rugarama, musama Are blocked to secondary school",
  //       "health_access_blocked_by_river": "Rugarama, musama Are blocked to Health center",
  //       "other_access_blocked_by_river": "Musama And Mubuga are blocked to potable water, churches are on both side, this is a way link between two sectors Cyeru and Gitovu",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "She was trying to cross the bridge when it was flooded and",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and communities leaders of Rugarama",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinyovu",
  //       "bridge_opportunity_project_code": "1013224",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.50159333,
  //       "bridge_opportunity_gps_longitude": 29.54305167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3217,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.50159333,
  //       "proposed_bridge_location_gps_longitude": 29.54305167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and it lasts 3hours after rainfall",
  //       "market_access_blocked_by_river": "Market, commercial center",
  //       "education_access_blocked_by_river": "Primary school, but no children for secondary school need to cross this river only those in primary school",
  //       "health_access_blocked_by_river": "Health Center is accessible without any need to pass this crossing",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, maize, there is the forest surrounding the area",
  //       "primary_crops_grown": ", bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market Ryarubondo ( Kinyovu, Ryanyirataba, Gasharu, Nyentanga, Kamiro, Kigarama, Gitwa) Market Nyamagabe (Sovu, Nyesayo, Nyabwoma, Uwinyana, Rwufe, Kirwa) Primary school (Sovu) The numbers in this survey were given by the local people and their leaders based on the monthly census which is done in every cell by village health official. The villages of( Kamiro, Kigarama, Gitwa, Nyesayo, Nyabwoma, Uwinyana, Rwufe, Kirwa) they use this crossing and their people were included in the total population to be served",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38.4,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gafuro ya 1",
  //       "bridge_opportunity_project_code": "1013227",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.51287,
  //       "bridge_opportunity_gps_longitude": 29.8126,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1594,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.51287,
  //       "proposed_bridge_location_gps_longitude": 29.8126,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Rugarama, musama Are blocked to market and farms are both side",
  //       "education_access_blocked_by_river": "Rugarama, musama Are blocked to secondary schools",
  //       "health_access_blocked_by_river": "Rugarama and Musama are blocked to Health center",
  //       "other_access_blocked_by_river": "Musama And Mubuga are blocked to potable water , churches are on both side.",
  //       "primary_occupations": "Farm, school, market",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was trying to cross the bridge when it was flooded and fell into river and died",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and community leader of Rugarama",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zeAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Runyangwe",
  //       "bridge_opportunity_project_code": "1013295",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 976,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "All the information related to the bridge was given by Rwambogo cell leader",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Due to city master plan settlement. They need only vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EKgAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ku gatare",
  //       "bridge_opportunity_project_code": "1013228",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.55931,
  //       "bridge_opportunity_gps_longitude": 29.88196,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3390,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.55931,
  //       "proposed_bridge_location_gps_longitude": 29.88196,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Cyabarenga and kinkware are blocked to the Market, and farms on both side",
  //       "education_access_blocked_by_river": "Cyabarenga and kinkware are blocked to the nusery, primary and secondary school",
  //       "health_access_blocked_by_river": "Cyabarenga and kinkware are blocked to the health center",
  //       "other_access_blocked_by_river": "Cyabarenga and kinkware are blocked to the churches, potable water and cell and sector office",
  //       "primary_occupations": "School, Market, health center",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They was trying to cross the bridge when it was flooded and fell into and as there is rock inside, they got severe wounds",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and communities leaders of Rebero and cell leader of Rubona",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zjAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa magorwa",
  //       "bridge_opportunity_project_code": "1013229",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.59194,
  //       "bridge_opportunity_gps_longitude": 29.89186,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1709,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59194,
  //       "proposed_bridge_location_gps_longitude": 29.89186,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "nyantwere are blocked to the Market and farms are both side",
  //       "education_access_blocked_by_river": "Nyantwere are blocked to the nursery, primary and secondary school",
  //       "health_access_blocked_by_river": "Nyantwere is blocked to Health center",
  //       "other_access_blocked_by_river": "Nyantwere is blocked to the potable water, churches, cell and sector office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "She was trying to cross the bridge as there is big slope she fell down and until now she is handicapped",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and cell leader of Rubona",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The slope is so high 77 %, and upstream the span is more than 200 meter, downstream the slope is so high and there is another river merge to this one",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 36.8,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75zoAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa mizerero",
  //       "bridge_opportunity_project_code": "1013230",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.605,
  //       "bridge_opportunity_gps_longitude": 29.89527,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1598,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.605,
  //       "proposed_bridge_location_gps_longitude": 29.89527,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Butunda, Rugaragara and Kadehero are blocked to the Market, but the Butunda and Rugaragara must cross two river and Kadehero one river, farms are in both side",
  //       "education_access_blocked_by_river": "Butunda, Rugaragara and Kadehero are blocked to the nusery, primary and secondary , but the Butunda and Rugaragara must cross two river and Kadehero one river,",
  //       "health_access_blocked_by_river": "Butunda, Rugaragara and Kadehero are blocked to the health center, but the Butunda and Rugaragara must cross two river and Kadehero one river,",
  //       "other_access_blocked_by_river": "Butunda, Rugaragara and Kadehero are blocked to the cell and sector office, but the Butunda and Rugaragara must cross two river and Kadehero one river,",
  //       "primary_occupations": "Schools, Market, farm",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Old woman was trying to cross the bridge when it was flooded and fell in to river and until now she can't walk.",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and cell leader of Rubona",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d75ztAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa mudahindwa",
  //       "bridge_opportunity_project_code": "1013232",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.59537,
  //       "bridge_opportunity_gps_longitude": 29.89217,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1709,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59537,
  //       "proposed_bridge_location_gps_longitude": 29.89217,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Nyantwere and are blocked to the Market, farms are both side",
  //       "education_access_blocked_by_river": "Nyantwere and are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Nyantwere and are blocked to health center",
  //       "other_access_blocked_by_river": "Nyantwere and are blocked to churches and potable water",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the cell leader of Rubona and people who live in the different communities who use the existing crossing bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7603AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyabami (kwa jerome)",
  //       "bridge_opportunity_project_code": "1013234",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.60203,
  //       "bridge_opportunity_gps_longitude": 29.89157,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1994,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.60203,
  //       "proposed_bridge_location_gps_longitude": 29.89157,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Kadehero and butunda is blocked to market",
  //       "education_access_blocked_by_river": "Kadehero and butunda is blocked to Primary and secondary school",
  //       "health_access_blocked_by_river": "Kadehero and Butunda is blocked to to health center",
  //       "other_access_blocked_by_river": "Kadehero is blocked to potable water, churches",
  //       "primary_occupations": "School, farm, Market",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was trying to cross the bridge when it was racing and he fell down and died",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and cell leader of Rubona",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760DAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Sibomana",
  //       "bridge_opportunity_project_code": "1013235",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.59993,
  //       "bridge_opportunity_gps_longitude": 29.85702,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3759,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59993,
  //       "proposed_bridge_location_gps_longitude": 29.85702,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Gasanzwe, buhira , buturuba is blocked to the Market. Farms on both side",
  //       "education_access_blocked_by_river": "Gasanzwe, Buhira and Buturuba are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Gasanzwe, buhira and Buturuba are blocked to Health center even they have a post center",
  //       "other_access_blocked_by_river": "Churches are on both side",
  //       "primary_occupations": "Market, school, farming,",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "They was tried to cross the bridge when it was flooded and child was died, others were injured but now they are well",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and communities leaders of Songorero",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 102.8,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760IAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugarama",
  //       "bridge_opportunity_project_code": "1013236",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.59631,
  //       "bridge_opportunity_gps_longitude": 29.85719,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3054,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59631,
  //       "proposed_bridge_location_gps_longitude": 29.85719,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Buhira and gasanzwe blocked to the Market, farms on both side",
  //       "education_access_blocked_by_river": "Buhira and Gasanzwe are blocked on primary and secondary school",
  //       "health_access_blocked_by_river": "Buhira, Gasanzwe are blocked to Health center",
  //       "other_access_blocked_by_river": "Churches are on both side and they cross river depends on their faith",
  //       "primary_occupations": "Farms, Market, school",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and and communities leader of Songorero",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanzs",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760NAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa mvunabandi",
  //       "bridge_opportunity_project_code": "1013237",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.61204,
  //       "bridge_opportunity_gps_longitude": 29.86299,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5421,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61204,
  //       "proposed_bridge_location_gps_longitude": 29.86299,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 66,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Rubuga and Buturuba are blocked to the Market and farms are on both side",
  //       "education_access_blocked_by_river": "Buturuba and Rubuga are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Buturuba and Rubuga are blocked to Health center",
  //       "other_access_blocked_by_river": "Buturuba and Rubuga are blocked to football terrain ,",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": ", bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 15,
  //       "incident_descriptions": "They was trying to cross the bridge when it was flooded and most of them are handicapped",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and communities leaders of Mugano",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 57.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760SAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Rwanziye",
  //       "bridge_opportunity_project_code": "1013238",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.60708,
  //       "bridge_opportunity_gps_longitude": 29.85897,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2451,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.60708,
  //       "proposed_bridge_location_gps_longitude": 29.85897,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 66,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Rubuga and Buturuba are blocked to the Market and farms are both side",
  //       "education_access_blocked_by_river": "Rubuga and Buturuba are blocked to the nusery, primary and secondary school",
  //       "health_access_blocked_by_river": "Rubuga and Buturuba are blocked to the health center in Gashushura and butaro hospital",
  //       "other_access_blocked_by_river": "Churches are both side",
  //       "primary_occupations": "Market, school and farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Child was trying to cross the bridge when it was flooded and",
  //       "notes_on_social_information": "Community leaders of Mugano with people lived closer to the bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 112.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760XAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigeyo ya 2",
  //       "bridge_opportunity_project_code": "1013239",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.5999,
  //       "bridge_opportunity_gps_longitude": 29.88097,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2952,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.5999,
  //       "proposed_bridge_location_gps_longitude": 29.88097,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "400 m",
  //       "days_per_year_river_is_flooded": 84,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Kigeyo the part which is away of vehicular bridge like 2 kilometers and songorero are blocked (Market in Rubona) , farms on both side",
  //       "education_access_blocked_by_river": "Kigeyo one side ( primary and secondary)",
  //       "health_access_blocked_by_river": "Kigeyo and Songorero blocked to health center",
  //       "other_access_blocked_by_river": "Muhondo blocked to potable water and churches on both side, sector office of Nemba (Kigeyo one side, Songorero)",
  //       "primary_occupations": "Market, farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived and cell leader of Kivumu and communities leaders of different communities",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760cAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabubandi (Kwa mutayumba)",
  //       "bridge_opportunity_project_code": "1013240",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.6032,
  //       "bridge_opportunity_gps_longitude": 29.85826,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3884,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6032,
  //       "proposed_bridge_location_gps_longitude": 29.85826,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "4 days",
  //       "market_access_blocked_by_river": "Buturuba, Gasanzwe and Buhira are blocked to the Market, farms on both side",
  //       "education_access_blocked_by_river": "Buturuba, Gasanzwe and Buhira are blocked to the primary and secondary school and nursery",
  //       "health_access_blocked_by_river": "Buturuba, Gasanzwe and Buhira are blocked to the health center",
  //       "other_access_blocked_by_river": "Churches on both side",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 16,
  //       "incident_descriptions": "Most of them are children who fell into river and when they are trying to cross the bridge going to school",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and one of them was community leader of Songorero",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760hAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamusanze",
  //       "bridge_opportunity_project_code": "1013241",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.758679,
  //       "bridge_opportunity_gps_longitude": 29.8733,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2789,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.758679,
  //       "proposed_bridge_location_gps_longitude": 29.8733,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 84,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Nyamusanze, one side of kigeyo for one market",
  //       "education_access_blocked_by_river": "Nyamusanze blocked to Groupe Scolaire of Kigeyo (Primary and secondary)",
  //       "health_access_blocked_by_river": "Nyamusanze, One side kigeyo b,locked to health center",
  //       "other_access_blocked_by_river": "Nyamusanze and one side of Kigeyo blocked to potable water, churches are both side",
  //       "primary_occupations": "Market, school, and farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived and cell leader of Kivumu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760mAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa nshoboye",
  //       "bridge_opportunity_project_code": "1013242",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.59526,
  //       "bridge_opportunity_gps_longitude": 29.87748,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2952,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59526,
  //       "proposed_bridge_location_gps_longitude": 29.87748,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 84,
  //       "flood_duration_during_rainy_season": "7",
  //       "market_access_blocked_by_river": "Songorero, one side of kigeyo are blocked to the Market, farms on both side the river",
  //       "education_access_blocked_by_river": "Songorero and one side of kigeyo are blocked to Groupe Scolaire of Nemba",
  //       "health_access_blocked_by_river": "Songorero and one side of Kigeyo are blocked to Health center",
  //       "other_access_blocked_by_river": "Muhondo is blocked to potable water , churches are on both side",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and cell leader of Kivumu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760rAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Rucagu",
  //       "bridge_opportunity_project_code": "1013243",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.59855,
  //       "bridge_opportunity_gps_longitude": 29.89346,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 955,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59855,
  //       "proposed_bridge_location_gps_longitude": 29.89346,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "88.4 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is closer to main road and vehicular bridge is 88.4 meters away, and it doesn't flooded",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 10,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d760wAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mubarame",
  //       "bridge_opportunity_project_code": "1013244",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.58391,
  //       "bridge_opportunity_gps_longitude": 29.85683,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 970,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.58391,
  //       "proposed_bridge_location_gps_longitude": 29.85683,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "0",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Songorero and people lived closer to the bridge",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It flooded for four hours and they continue to cross the small river and communities who live nearby said it is not needed",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7611AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigeyo ya 1 (Butambi)",
  //       "bridge_opportunity_project_code": "1013245",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.60154,
  //       "bridge_opportunity_gps_longitude": 29.88182,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1976,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.60154,
  //       "proposed_bridge_location_gps_longitude": 29.88182,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "0.248 kilometers",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer and cell leader of Kivumu",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The bridge is 248 meters away of vehicular , and it is closer to the unpaved road 25 meter away the proposed tower",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 27,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7616AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kidomo",
  //       "bridge_opportunity_project_code": "1013246",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.56507,
  //       "bridge_opportunity_gps_longitude": 29.83916,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.56507,
  //       "proposed_bridge_location_gps_longitude": 29.83916,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Cyave and nyabitare are blocked to market",
  //       "education_access_blocked_by_river": "Kabukoko , kidomo and rwata are blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "Health center on both side they choose where they want but many more, kidomo and Rwata are blocked to the hospital kirambo",
  //       "other_access_blocked_by_river": "Kabukoko is blocked to district of Burera,",
  //       "primary_occupations": "School and farm",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Three are children who fell into river and they tried to save them, but the last was an old man who died in river when he tried to cross the bridge when it was flooded",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and communities leaders of Cyave",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761BAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisayo",
  //       "bridge_opportunity_project_code": "1013247",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.01790012,
  //       "bridge_opportunity_gps_longitude": 29.67739076,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2127,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01790012,
  //       "proposed_bridge_location_gps_longitude": 29.67739076,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 52,
  //       "flood_duration_during_rainy_season": "2 hours",
  //       "market_access_blocked_by_river": "Rutaka market , Kabadaha market",
  //       "education_access_blocked_by_river": "GS Gisovu",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Mushishiro sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "GS Gisovu ( Nyanza village ) , Rutaka market ( Nyanza village ), kabadaha market ( Gisovu village) , Mushishiro health center ( Gisovu village) . The information about number of individual served is provided by Kanyanza village leader referred to the population census of 2018 .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761GAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatura",
  //       "bridge_opportunity_project_code": "1013248",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.0118896,
  //       "bridge_opportunity_gps_longitude": 29.68145493,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2923,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0118896,
  //       "proposed_bridge_location_gps_longitude": 29.68145493,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 51,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Kabadaha market",
  //       "education_access_blocked_by_river": "GS Mushishiro",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Mushishiro sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "A student who were coming to school,",
  //       "notes_on_social_information": "Kabadaha market ( kanombe village) , GS Mushishiro ,( kanombe village ) , Mushishiro health center ( kanom e village) , the village of Nyanza is the one who provided all of this information and he referred to be population census of 2018 to deter,one number of individual served by calling his mate on phone",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761LAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugari 2",
  //       "bridge_opportunity_project_code": "1013296",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 876,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need only a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EKlAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kucyuzi",
  //       "bridge_opportunity_project_code": "1013249",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.03657322,
  //       "bridge_opportunity_gps_longitude": 29.66738107,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1960,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.03657322,
  //       "proposed_bridge_location_gps_longitude": 29.66738107,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "Water does not reach the bridge but the depth of bridge is 7 meter when u miss the timber u just fall in ,",
  //       "market_access_blocked_by_river": "Muhanga Market",
  //       "education_access_blocked_by_river": "GS Nyabitare",
  //       "health_access_blocked_by_river": "Gikomero health center",
  //       "other_access_blocked_by_river": "Rwuki village office, Mushishiro sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "One drunk man who were coming from rwuki center",
  //       "notes_on_social_information": "GS Nyabitare ( rwuki village) , Muhanga Market ( Nyamasheke village) , gikomero health center ( Nyamasheke village) , Rwuki village leader provided the information of directly individual served and he referred to the population census of 2017.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761QAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahama",
  //       "bridge_opportunity_project_code": "1013250",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.0290507,
  //       "bridge_opportunity_gps_longitude": 29.69007869,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4191,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0290507,
  //       "proposed_bridge_location_gps_longitude": 29.69007869,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Rutaka market, Muhanga Market",
  //       "education_access_blocked_by_river": "GS Nyabitare , GS Mushishiro",
  //       "health_access_blocked_by_river": "Kabgayi hospital",
  //       "other_access_blocked_by_river": "Mushishiro sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Three kids from school fall in, but they get injured only",
  //       "notes_on_social_information": "Rutaka market ( gihara village, kanombe village, Gisovu village, kibonwa village ) , kabgayi hospital ( gihara village, kanombe village, Gisovu village, kibonwa village ), GS nyabiteke ( gasharu village ). Nyagasozi cell leader is the one who provided the information of individual served as she referred to the population census of 2018 .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga to Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761VAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu",
  //       "bridge_opportunity_project_code": "1013251",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.02696824,
  //       "bridge_opportunity_gps_longitude": 29.69545811,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3705,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.02696824,
  //       "proposed_bridge_location_gps_longitude": 29.69545811,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": "Kabadaha market and Gikomero market",
  //       "education_access_blocked_by_river": "GS Mushishiro",
  //       "health_access_blocked_by_river": "Gikomero health center",
  //       "other_access_blocked_by_river": "Mushishiro church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "No person died crossing , only cows died . But some injury happen",
  //       "notes_on_social_information": "GS Mushishiro ( gasharu village, Gihara village , kanombe village) , kabadaha market ( ( gasharu village, Gihara village , kanombe village) , Mushishiro health center ( gasharu village, Gihara village , kanombe village) , gikomero health center ( Bandora village) . Information of individual served were given by Nyagasozi village leader and she referred to the population census of 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761aAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Budashya",
  //       "bridge_opportunity_project_code": "1013252",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.83974569,
  //       "bridge_opportunity_gps_longitude": 29.70503476,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1187,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.83974569,
  //       "proposed_bridge_location_gps_longitude": 29.70503476,
  //       "current_crossing_method": "People are using Timbers to cross the river",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "7 hours of flood",
  //       "market_access_blocked_by_river": "Ruhango - Rusuri market",
  //       "education_access_blocked_by_river": "GS Mubuga and GS Gitega",
  //       "health_access_blocked_by_river": "Kibangu health center",
  //       "other_access_blocked_by_river": "Kibangu sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "Students who were going to school,",
  //       "notes_on_social_information": "Mubuga ps ( jarama village ) , kibangu market ( Mubuga village ) , Gitega health center ( Mubuga village) . For determining number of individual served Mubuga village leader was there to give me all information and he referred to 2018 population census.",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761fAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyuzu",
  //       "bridge_opportunity_project_code": "1013253",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.85356287,
  //       "bridge_opportunity_gps_longitude": 29.67139626,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3270,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85356287,
  //       "proposed_bridge_location_gps_longitude": 29.67139626,
  //       "current_crossing_method": "People are using timbers to cross the river",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 33,
  //       "flood_duration_during_rainy_season": "2 hours",
  //       "market_access_blocked_by_river": "Nkondo market and Ngororero market",
  //       "education_access_blocked_by_river": "GS Gitega , GS Muhororo",
  //       "health_access_blocked_by_river": "Gitega Health center",
  //       "other_access_blocked_by_river": "Kibangu sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "Gitega health center ( murehe village , bukiro village, kaziba village and Gakurwe village ) , GS Gitega ( murehe village , bukiro village, kaziba village and Gakurwe village ) , Nkondo market ( murehe village , bukiro village, kaziba village and Gakurwe village ) , all of these info are from cyuzu village leader and he referred to population census of 2017 to determine number of individuals served",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga -Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761kAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakirambo",
  //       "bridge_opportunity_project_code": "1013254",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.8784817,
  //       "bridge_opportunity_gps_longitude": 29.69778352,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2307,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8784817,
  //       "proposed_bridge_location_gps_longitude": 29.69778352,
  //       "current_crossing_method": "Timbers are used as method of crossing",
  //       "nearest_all_weather_crossing_point": "No points",
  //       "days_per_year_river_is_flooded": 53,
  //       "flood_duration_during_rainy_season": "7 hours of floods",
  //       "market_access_blocked_by_river": "Mbonekamazi market",
  //       "education_access_blocked_by_river": "GS Gisharu , Gisharu ps",
  //       "health_access_blocked_by_river": "Gisharu health center",
  //       "other_access_blocked_by_river": "Murehe cell office , Kibangu sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "GS Gisharu ( Kimisange village and Rubona village ) , Gisharu ps ( Kimisange village and Rubona village ) , Gisharu health center ( Kimisange village and Rubona village ), mbonekamazi market ( Murambi village and Rumirantege village) , jurwe cell office ( Murambi village and Rumirantege village). All of these information are from jurwe cell office leader and she referred to population census of 2018 to determine the number of individual served",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761pAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Munyarubuga",
  //       "bridge_opportunity_project_code": "1013255",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.87302569,
  //       "bridge_opportunity_gps_longitude": 29.67017014,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3103,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.87302569,
  //       "proposed_bridge_location_gps_longitude": 29.67017014,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Nyabarongo is always full",
  //       "market_access_blocked_by_river": "Gahanga market",
  //       "education_access_blocked_by_river": "GS Murebe",
  //       "health_access_blocked_by_river": "Muhororo hospital",
  //       "other_access_blocked_by_river": "Muhanga district office , Ngororero District office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "Boat fall in river",
  //       "notes_on_social_information": "Gahinga market ( nzarwa village ) , Ngororero market ( kimisange village , Rumirantege village, Murambi village ,rwesero village) , Muhororo hospital ( kimisange village , Rumirantege village, Murambi village ,rwesero village), all of these information are given by kimisange village leader and he referred to population census of 2017 in determination of number of individual served",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 167,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d761uAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mu Gisuma",
  //       "bridge_opportunity_project_code": "1013257",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.81917977,
  //       "bridge_opportunity_gps_longitude": 29.69307801,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2959,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.81917977,
  //       "proposed_bridge_location_gps_longitude": 29.69307801,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Rusuri and Kibangu",
  //       "education_access_blocked_by_river": "GS Shaki , Kivumo ps",
  //       "health_access_blocked_by_river": "Poste de Sante de Shaki , kibangu health center",
  //       "other_access_blocked_by_river": "Kibangu sector office and Nyabinoni sector office",
  //       "primary_occupations": "Farming, student",
  //       "primary_crops_grown": "banana, bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "Rusuri market ( Ndaragati village , ntangamenyo village ) , kibangu market ( Ndaragati village , ntangamenyo village ) , shaki Poste De Sante ( mwumba village , mushubaguriko village ) , kibangu health center ( Ndaragati village , ntangamenyo village ) , GS Shaki ( mwumba village , mushubaguriko village ), Kivumo ps( Ndaragati village , ntangamenyo village ) . This information is obtained from SEDO of Ryakanimba cell and he referred to 2018 population census in determining individual served .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7624AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burumba",
  //       "bridge_opportunity_project_code": "1013258",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.81408288,
  //       "bridge_opportunity_gps_longitude": 29.67507767,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2471,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.81408288,
  //       "proposed_bridge_location_gps_longitude": 29.67507767,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Kibangu and Ngororero market",
  //       "education_access_blocked_by_river": "GS Shaki",
  //       "health_access_blocked_by_river": "Poste De Sante gashorera",
  //       "other_access_blocked_by_river": "Kibangu sector office",
  //       "primary_occupations": "Farming , student ( most of people crossing here are farmers going to their farms and student going to school )",
  //       "primary_crops_grown": "banana, bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "GS Shaki ( musekera village, Nyamugari village , kinogi ) , Poste De Sante Shaki ( Musekera village , nyamugari village and kinogi village ) , ngororero market ( muzamuzi village and Ryakiyange village) , this information is given by Ryakanimba village leader and she referred to the population census of 2018 to determine the numbers of individual served.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7629AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musenyi",
  //       "bridge_opportunity_project_code": "1013259",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.01273958,
  //       "bridge_opportunity_gps_longitude": 29.69851613,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2660,
  //       "bridge_opportunity_comments": "Not Duplicate, 2 rivers at a confluence District indicated that this bridge was not needed when PPD was submitted.",
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01273958,
  //       "proposed_bridge_location_gps_longitude": 29.69851613,
  //       "current_crossing_method": "People are using timbers as crossing method , there five timbers but for heavy rain they will be destroyed",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 55,
  //       "flood_duration_during_rainy_season": "3 hours of floods",
  //       "market_access_blocked_by_river": "Kabadaha market",
  //       "education_access_blocked_by_river": "GS Mushishiro",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Mushishiro church , Mushishiro sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Student who were coming from school",
  //       "notes_on_social_information": "Mushishiro health center ( gihara village, gasharu village, Bandora village) , kabadaha market( gihara village, gasharu village, Bandora village) , GS Mushishiro ( gihara village, gasharu village, Bandora village). These info are given by Munazi cell leader by contacting the village leader's that are using the bridges and they all referred to the population census of 2018 to determine the number of individual served",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d762EAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Munazi",
  //       "bridge_opportunity_project_code": "1013260",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.01273958,
  //       "bridge_opportunity_gps_longitude": 29.69851613,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2581,
  //       "bridge_opportunity_comments": "Not Duplicate, 2 rivers at a confluence",
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01273958,
  //       "proposed_bridge_location_gps_longitude": 29.69851613,
  //       "current_crossing_method": "There are 3 timbers connect by nail , people are using them to cross the river",
  //       "nearest_all_weather_crossing_point": "There is another concrete bridge between Nyanza village - Kiyoro village which people are using when they get scared of crossing Munazi bridge , that bridge is in one kilometer from Munazi",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Kabadaha market Nd Rwigerero market",
  //       "education_access_blocked_by_river": "GS Nyabitare",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Mushishiro sector office , kabadaha 7tn day Adventist church",
  //       "primary_occupations": "Farming ( people who are going in their land plantations they cross the bridge",
  //       "primary_crops_grown": "bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "Rwigerero market ( Rwinkindi village), Kabadaha market ( Kanyinya village, Nyanza village, nyamasheke village) , kabadaha church ( Kanyinya village, Nyanza village, nyamasheke village) , Mushishiro sector office ( Kanyinya village, Nyanza village, nyamasheke village) , these information is obtained from Rwinkindi village leader , he contact other village leader to ask them their numbers of population, population census of 2018 was the main reference in determination of individual served",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d762JAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ku Gatare",
  //       "bridge_opportunity_project_code": "1013261",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.99297066,
  //       "bridge_opportunity_gps_longitude": 29.68900376,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2350,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.99297066,
  //       "proposed_bridge_location_gps_longitude": 29.68900376,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 38,
  //       "flood_duration_during_rainy_season": "Flood can take like 4 hours per day in heavy rain",
  //       "market_access_blocked_by_river": "Kabadaha market is the major market in which the river blocked the people who are coming I in this market",
  //       "education_access_blocked_by_river": "GS Mushishiro",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Mushishiro sector office and Mushishiro church",
  //       "primary_occupations": "Most of People in village are crossing the bridge going to their land field to cultivate with plantation",
  //       "primary_crops_grown": "banana, cassava, maiz, sugar can, this area has many agricultural products but those one in common are bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "There is no death in recent years for people crossing, some of kids who were crosssing to primary school they sometimes fall in it but they get injuries only .",
  //       "notes_on_social_information": "Mushishiro health center ( Nyamatete village) , kabadaha market ( Nyamatete village) , Rugendabari health center kiyoro village) , GS Mushishiro ( Nyamatete village ) . The information of individual served is obtained from kiyoro village leader by rendering to the population census of 2018 .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga- Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d762OAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamugari",
  //       "bridge_opportunity_project_code": "1013262",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -1.99009157,
  //       "bridge_opportunity_gps_longitude": 29.667002,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2180,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.99009157,
  //       "proposed_bridge_location_gps_longitude": 29.667002,
  //       "current_crossing_method": "The people using six timbers to cross the river",
  //       "nearest_all_weather_crossing_point": "No other point",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "1 hour of flood during heavy rain people are unable to cross",
  //       "market_access_blocked_by_river": "Kabadaha market",
  //       "education_access_blocked_by_river": "GS Kicaro",
  //       "health_access_blocked_by_river": "Mushishiro health center",
  //       "other_access_blocked_by_river": "Mushishiro sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Drunk men",
  //       "notes_on_social_information": "Kabadaha market ( kivumu village, bitsibo village, hanika village) , GS Kicaro ( kivumu village, bitsibo village, hanika village), Mushishiro health center ( kivumu village, bitsibo village, hanika village). Kabare village leader is the one who provided the information of numbers of individual served , and be referred to he population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d762TAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sheni",
  //       "bridge_opportunity_project_code": "1013268",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.40452,
  //       "bridge_opportunity_gps_longitude": 29.83705,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3112,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.40452,
  //       "proposed_bridge_location_gps_longitude": 29.83705,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Farms(Community 1); Ruyenzi Market (Community 2,3)",
  //       "education_access_blocked_by_river": "Ruyenzi primary and secondary school (Community 2,3)",
  //       "health_access_blocked_by_river": "Karama health post (Community 1); Ruyenzi health center (Community 2,3)",
  //       "other_access_blocked_by_river": "Potable water (Community 1); Cyotamakara Cell office(Community 2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, potato, tomato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries or death by river crossing.",
  //       "notes_on_social_information": "Nyarutovu, Karuyumbu and Kankima villages were included in individuals directly served because community members of these villages use this crossing point daily to get access to market, schools, health centers, ... The information about the population to be served by the bridge was provided by the Muneza Felicien, Nyarutovu village leader and Mukamurigo Rose, Kankima village leader from the population data collected in 2018. Population of adjacent communities were not included because they use a vehicular bridge downstream to cross the river.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d766ZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa musakiranya",
  //       "bridge_opportunity_project_code": "1013318",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.56761,
  //       "bridge_opportunity_gps_longitude": 29.99711,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3383,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.56761,
  //       "proposed_bridge_location_gps_longitude": 29.99711,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "110 m",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Muremure, Kabuga, Bikumba are blocked to the Market and farms are both side",
  //       "education_access_blocked_by_river": "Part of Bikumba which is closer to the river is blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Part of Bikumba which is closer to the river is blocked to Health center",
  //       "other_access_blocked_by_river": "Part of Bikumba which is closer to the river is blocked to churches",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was trying to cross the bridge when it was flooded and fell into river and found died",
  //       "notes_on_social_information": "Community leaders of Bikumba and people who live closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Closer to vehicular bridge 0.110 kilometers",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EQEAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabugugu",
  //       "bridge_opportunity_project_code": "1013269",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.33172,
  //       "bridge_opportunity_gps_longitude": 29.88638,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3642,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.33172,
  //       "proposed_bridge_location_gps_longitude": 29.88638,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In April, May; in September and October, it last for 2 hours",
  //       "market_access_blocked_by_river": "Busoro market (Community 1,2); Nyamiyaga Market (Community 3,4)",
  //       "education_access_blocked_by_river": "Nyagasozi primary and secondary school (Community 3,4)",
  //       "health_access_blocked_by_river": "Nyamiyaga Health Center (Community 3,4)",
  //       "other_access_blocked_by_river": "Nyamiyaga catholic church, Muyira Sector Office (Community 3,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Mugari, Nyakibungo, Gihama and Nzoga villages were included in individuals directly served because community members of these villages use this crossing point to go to market, schools, health centers, ... The information about the population to be served by the bridge was provided by the Nyundo cell leader, Bampire Fortune and Mugabo Anatole: Gihama village leader from the population data collected in early 2018. Population of adjacent communities includes: Nyundo and Gasharu and they sometimes use this crossing point to visit relatives or to go to market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d766eAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gateme",
  //       "bridge_opportunity_project_code": "1013270",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.35699,
  //       "bridge_opportunity_gps_longitude": 29.93402,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2037,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.35699,
  //       "proposed_bridge_location_gps_longitude": 29.93402,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Mututu market and Busoro market (Community 1,3)",
  //       "education_access_blocked_by_river": "Mututu primary and secondary school (Community 1,3)",
  //       "health_access_blocked_by_river": "Mututu health center (Community 1,3); Nyakayaga health center (Community 2)",
  //       "other_access_blocked_by_river": "Kibirizi sector office (Community 2), Presbyterian church (Community 1,3), Muyebe Adventist church (Community 2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cassava, potato, ric, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Muyobora, Gicumbi and Kamatamu villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, churches, schools, health centers, ... The information about the population to be served by the bridge was provided by the Cyeru cell leader, Jean de la Croix from the population data collected in 2018. Population of adjacent communities includes: Muyebe village and some villages in Mututu Cell, they use this crossing point to visit relatives or to go to Kibirizi sector office.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d766jAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigufi",
  //       "bridge_opportunity_project_code": "1013271",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.33736,
  //       "bridge_opportunity_gps_longitude": 29.8197,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2054,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.33736,
  //       "proposed_bridge_location_gps_longitude": 29.8197,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Butara Mountain Coffee washing station (Community 3 ), Farms (Community 2,3), Migina Market (Community 2,3) and Gahama Market (Community3)",
  //       "education_access_blocked_by_river": "Butara Primary School & Kayanza Primary and secondary school (Community 3)",
  //       "health_access_blocked_by_river": "Nyamure Health Center (Community 1,2), Butara Health post (Community 3)",
  //       "other_access_blocked_by_river": "Kigufi Adventist church (Community 3), Nyarugunga Adventist church (Community 1,2)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, cassava, coffe, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries or death by river crossing.",
  //       "notes_on_social_information": "Kigufi, Runyinya and Gatare villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, churches, schools, health centers, ... The information about the population to be served by the bridge was provided by the Butara cell leader, Octave Ndayisaba from the population data collected in early 2018. Population of adjacent communities includes many villages in Muyira Sector, these communities members use the crossing point to bring their coffee to Butara Mountain coffee washing station, the current bridge was constructed by the owner of the coffee washing station so that people on the other side of the river can easly bring their coffee to the washing station.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d766oAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakagende",
  //       "bridge_opportunity_project_code": "1013272",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.29712,
  //       "bridge_opportunity_gps_longitude": 29.93744,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3284,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.29712,
  //       "proposed_bridge_location_gps_longitude": 29.93744,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May, September to December; it last for 1 hour",
  //       "market_access_blocked_by_river": "Busoro Market (Community 2,3)",
  //       "education_access_blocked_by_river": "APADEM Secondary school (Community 2,3), Kigali Primary School (Community 1)",
  //       "health_access_blocked_by_river": "Busoro Health center (Community 2,3)",
  //       "other_access_blocked_by_river": "Busoro Sector, Busoro Catholic, ADPR and Jehovah Witnesses Churches (Community 2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, maiz, ric, tomato, vegetables.",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many incidents that have occurred were of motorcycles or bicycles trying to cross the river, it happens almost every week and the number is more than 100.",
  //       "notes_on_social_information": "Nyarutovu, Kivugiza and Kigali villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, farms, schools, health centers, ... The information about the population to be served by the bridge was provided by the Masangano cell leader, Nzabonimpa Venantie, Sebukwerere Isidor, Kivugiza village leader and Mutegeyimana Vincente, Kigali village leader; from the population data collected in early 2018. Population of adjacent community includes: Kagarama village, they use this crossing point to access their farms or go to churches sometimes.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d766tAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Marongi",
  //       "bridge_opportunity_project_code": "1013274",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.30781,
  //       "bridge_opportunity_gps_longitude": 29.81484,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6724,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.30781,
  //       "proposed_bridge_location_gps_longitude": 29.81484,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Kayanza and Nyanza Markets (Community 3,4,5); Butansinda and Ruhango Markets (Community 1,2)",
  //       "education_access_blocked_by_river": "Kayanza primary and secondary school(Community 3,4,5), Kigoma secondary school (Community 1,2)",
  //       "health_access_blocked_by_river": "Gahombo Health Center (Community 1,2)",
  //       "other_access_blocked_by_river": "Kigoma sector office, Gahombo Catholic and ADPR Churches(Community 1,2); Kayanza Adventist church (Community 3,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation., cassava, coffe, potato",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "During the last 3 years the number of people who died trying to cross the river is 5 (3 died between April and May 2018)but many were rescued from drowning in the river and taken to health centers.",
  //       "notes_on_social_information": "Butara , Gasharu, Marongi, Kigoma and Kibavu villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, churches , schools, health centers, ... The information about the population to be served by the bridge was provided by the Butara cell leader, Octave Ndayisaba, Rutaganda Theoneste: Butara village leader and Misago Mathieu: Marongi village leader from the population data collected in 2018. Population of adjacent communities includes: Mataba, Kavumu, Kigufi and Buhaza. They use this crossing point to visit relatives, go to Sector office or to go to market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 1.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7673AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa rangira",
  //       "bridge_opportunity_project_code": "1013328",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.59045,
  //       "bridge_opportunity_gps_longitude": 29.93291,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 762,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59045,
  //       "proposed_bridge_location_gps_longitude": 29.93291,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They was trying to cross the bridge when it was flooded",
  //       "notes_on_social_information": "Community leaders of Kaberano",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 25,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ESjAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwanamiza",
  //       "bridge_opportunity_project_code": "1013276",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.3084,
  //       "bridge_opportunity_gps_longitude": 29.88881,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4791,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3084,
  //       "proposed_bridge_location_gps_longitude": 29.88881,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours.",
  //       "market_access_blocked_by_river": "Busoro Market and Ruhuha Market (Community 1,3), Kayanza market (Community 2)",
  //       "education_access_blocked_by_river": "Rwanamiza primary and secondary school (Community 1,3)",
  //       "health_access_blocked_by_river": "Busoro Health Center (Community 1,3)",
  //       "other_access_blocked_by_river": "Busoro Catholic church and Adventist church (Community 1,3) EAR rwabihanga (Community 2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cassava, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many people fall into the river trying to cross the river. So far more than 100 people fell into the river but no serious injuries.",
  //       "notes_on_social_information": "Rwabihanga, Kimfizi and Rwanamiza villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, schools, health centers, ... The information about the population to be served by the bridge was provided by the Gati cell leader, Nsabimana Theoneste and Rwabihanga village leader, Ngendahimana Theogene from the population data collected in 2017. Population of adjacent communities includes: Nyaruyenzi, Nyakiniga, Nyarukurazo, Cyivuko and Kintare and other villages in Gati cell. They sometimes use this crossing point to visit relatives to go to Busoro/Nyanza markets to go to market once or twice a month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d767DAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Seyi",
  //       "bridge_opportunity_project_code": "1013277",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.45455,
  //       "bridge_opportunity_gps_longitude": 29.85668,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3261,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45455,
  //       "proposed_bridge_location_gps_longitude": 29.85668,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "10 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May it last for 1 day",
  //       "market_access_blocked_by_river": "Rice Farms (Community 1,2), Murambi, Gikonko and Mugogwe Markets (Community 1,2); Ntyazo and Gatugunguru Markets (Community 3,4)",
  //       "education_access_blocked_by_river": "Ntarwe primary school and Gikonko primary & Secondary school (Community 1,2), Ruyenzi primary school (Community 3,4)",
  //       "health_access_blocked_by_river": "Ntyazo health center (Community 3,4), Gikonko and Gakoma health center (Community 1,2)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ntebe, Rusasa, Murambi and Sanzu villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, churches, schools, health centers, ... The information about the population to be served by the bridge was provided by the Kagunga cell leader, Munyaneza Jean Damascene from the population data collected in 2018. Population of adjacent communities includes: Samuduha, Cyinteko and Nyamirama villages. They use this crossing point to visit relatives, go to health centers or to go to market once or twice a month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d767IAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ntebe",
  //       "bridge_opportunity_project_code": "1013278",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.45118,
  //       "bridge_opportunity_gps_longitude": 29.87035,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1764,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45118,
  //       "proposed_bridge_location_gps_longitude": 29.87035,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 days.",
  //       "market_access_blocked_by_river": "Rice Farms (Community 1,2), Murambi, Gikonko and Mugogwe Markets (Community 1,2), Ntyazo and Gatugunguru Markets (Community 3)",
  //       "education_access_blocked_by_river": "Kagunga primary school (Community 3); Ntarwe primary school (Community 1,2), Gikonko Secondary school (Community 1,2)",
  //       "health_access_blocked_by_river": "Ruyenzi Health center (Community 3), Gikonko and Gakoma health center (Community 1,2)",
  //       "other_access_blocked_by_river": "Ruyenzi Catholic Church (Community 3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, bean, potato, ric, soy bean, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Many people fall into the river and recently more than 5 people have died trying to cross the river, and the timber bridge was washed away by floods in May 2018.",
  //       "notes_on_social_information": "Ntebe, Rusasa and Sanzu villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, churches, schools, health centers, ... The information about the population to be served by the bridge was provided by the Kagunga cell leader, Munyaneza Jean Damascene from the population data collected in 2018. Population of adjacent communities includes: Murambi, Ntarwe, Nyarurama and Cyinteko. They use this crossing point to visit relatives, go to health centers or to go to market once or twice a month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d767NAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyiri",
  //       "bridge_opportunity_project_code": "1013279",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyanza",
  //       "bridge_opportunity_gps_latitude": -2.45403,
  //       "bridge_opportunity_gps_longitude": 29.84815,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4264,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.2",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45403,
  //       "proposed_bridge_location_gps_longitude": 29.84815,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 days",
  //       "market_access_blocked_by_river": "Ntyazo and Gatugunguru Markets (Community 4,5), Murambi, Gikonko and Mugogwe Markets (Community 1,2,3), Rice Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Curusi and Sanzu primary schools (Community 1,2,3), Gikonko Secondary school (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Ruyenzi Health center (Community 4,5)",
  //       "other_access_blocked_by_river": "Ruyenzi Catholic Church (4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, cabbag, maiz, potato, ric, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 20,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many people fall into the river, recently (in May 2018) more than 20 people died trying to cross the river.",
  //       "notes_on_social_information": "Samuduha, Rusasa, Kamabuye, Kimigunga, Sanzu and Murambi villages were included in individuals directly served because community members of these villages use this crossing point to go to markets, churches, schools, health centers, ... The information about the population to be served by the bridge was provided by the Kagunga cell leader, Munyaneza Jean Damascene from the population data collected in 2018. Population of adjacent communities includes: Nyamirama, Ntebe, Ruyenzi and Cyinteko. They use this crossing point to visit relatives, go to churches, health centers or to go to market once or twice a month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d767SAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukinyogo",
  //       "bridge_opportunity_project_code": "1013280",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 650,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.5",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Typically there is no flood",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population information of each village was given by the kavumu cell leader Epiphanie Uwamariya",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need vehicular bridge only",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78NrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasagara",
  //       "bridge_opportunity_project_code": "1013282",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.28862,
  //       "bridge_opportunity_gps_longitude": 29.604975,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2356,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. River is too small to warrant B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.28862,
  //       "proposed_bridge_location_gps_longitude": 29.604975,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "200 m",
  //       "days_per_year_river_is_flooded": 8,
  //       "flood_duration_during_rainy_season": "April to May, December, 3 hours after rain they can cross",
  //       "market_access_blocked_by_river": "Masizi market ( villages 1,3), farms (villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "Nkore primary school (villages 2,4)",
  //       "health_access_blocked_by_river": "Jenda Health center (villages 1,3)",
  //       "other_access_blocked_by_river": "Goverment services such as cell office( villages 1,3)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The information of population from each village was provided by gasagara villages leader cyprien Munyentwari, was called every village leader of Nyakabuye, Rutunu,Mubuga, Kibuga. The population information of each was sourced from the record done in Ubudehe 2015.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is near to the all weather crossing 200m away",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78OBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugarama",
  //       "bridge_opportunity_project_code": "1013329",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.50973,
  //       "bridge_opportunity_gps_longitude": 29.92132,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1391,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.50973,
  //       "proposed_bridge_location_gps_longitude": 29.92132,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Rwasa",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 6,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ESoAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitega",
  //       "bridge_opportunity_project_code": "1013283",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.335233,
  //       "bridge_opportunity_gps_longitude": 29.499042,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2445,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.335233,
  //       "proposed_bridge_location_gps_longitude": 29.499042,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge 10 away",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "March to May, September to December, 2 hours they can cross",
  //       "market_access_blocked_by_river": "Kaduha market( villages 2,3,4), farming (villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "Kaduha secondary school upper level (villages 2,3,4)",
  //       "health_access_blocked_by_river": "Kaduha health center and hospital(villages 2,3,4)",
  //       "other_access_blocked_by_river": "Government services such sector, police station (villages 2,3,4), churches ( villages 2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He jumped, fell in river and drowned",
  //       "notes_on_social_information": "The population information of each village was provided by Musenyi leader, Mark Shyirambere who sourced the population from cell record in 2015. The population of all adjacent communities includes the following villages: Gitega, Gashiru, Rugamba and Ruganda. The community members from all villages use the bridge to the market twice a week , to the hospital and in school for students.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": 3.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78OGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bamba",
  //       "bridge_opportunity_project_code": "1013284",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.337125,
  //       "bridge_opportunity_gps_longitude": 29.525828,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2338,
  //       "bridge_opportunity_comments": "BAJ confirms rejection.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.337125,
  //       "proposed_bridge_location_gps_longitude": 29.525828,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Typically river doesn't flood year round",
  //       "market_access_blocked_by_river": "Kaduha markert(villages 3,4)",
  //       "education_access_blocked_by_river": "Kaduha secondary schools, kaduha primary school A&B (villages3,4)",
  //       "health_access_blocked_by_river": "Kaduha hospital (villages 3,4)",
  //       "other_access_blocked_by_river": "Kaduha Catholic church(3,4), ADPR(villages 3,4), government services (villages 3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population information of each village was provided by kavumu cell leader, Epiphanie Uwamariya Population of all adjacent communities includes the following villages: kavumu, bamba, karehe, kabuga.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They cross year round however they request bridge because it is old.",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78OQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakabingo",
  //       "bridge_opportunity_project_code": "1013285",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.37564,
  //       "bridge_opportunity_gps_longitude": 29.490052,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2170,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37564,
  //       "proposed_bridge_location_gps_longitude": 29.490052,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometers away",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "March to May, September to November, 2hours they can cross",
  //       "market_access_blocked_by_river": "Kaduha Market (villages 2,4), farms (1,2,3,4)",
  //       "education_access_blocked_by_river": "Nyamiyaga Primary school (villages 1,3), Nyamiyaga secondary school o'level (villages 1,3)",
  //       "health_access_blocked_by_river": "Health center , kaduha hospital (villages 2,4)",
  //       "other_access_blocked_by_river": "Government services (villages 2,4), churches (villages 2,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by nyamiyaga cell leader, Theoneste Habiyezu who sourced population information from cell register.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78OVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamugari",
  //       "bridge_opportunity_project_code": "1013286",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.37027,
  //       "bridge_opportunity_gps_longitude": 29.484132,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2170,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37027,
  //       "proposed_bridge_location_gps_longitude": 29.484132,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "April to May, september and October, after 2 hours they can cross",
  //       "market_access_blocked_by_river": "Kaduha Market (villages 2,4), farms (villages 2,4 and 1,3)",
  //       "education_access_blocked_by_river": "Nkomero primary school (villages 1,3)",
  //       "health_access_blocked_by_river": "Nyamiyaga Health center (villages 2,4), kaduha hospital (villages 1,3)",
  //       "other_access_blocked_by_river": "Government services ( 1,3), churches ( 1, 3 and 2,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Was crossing and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by nyamiyaga cell leader, Theoneste Habiyezu who sourced population information from cell register updated in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78OaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gafukuru",
  //       "bridge_opportunity_project_code": "1013287",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.331309,
  //       "bridge_opportunity_gps_longitude": 29.535533,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3130,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.331309,
  //       "proposed_bridge_location_gps_longitude": 29.535533,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "April, May, September to December, sometimes In February, 3 hours after floods people can cross the river.",
  //       "market_access_blocked_by_river": "Kaduha market(villages 2,3 5), farming (villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "2 Primary school, 2 secondary school (villages 2,3,5); kaduha VTC (vocational training center) villages 2,3,5)",
  //       "health_access_blocked_by_river": "Kaduha hospital( villages 2,3,5), kaduha health center ( villages 2,3,5)",
  //       "other_access_blocked_by_river": "Government services( sector office, police station) villages 2,3,5); banks( umurenge sacco, BPR) villages 2,3,5)",
  //       "primary_occupations": "Agriculture, farming",
  //       "primary_crops_grown": "cassava, potato, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Kavumu cell leader, Epiphanie Uwamariya who sourced the data from kavumu cell register in 2016.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": 1.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78OfAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyamuhinda",
  //       "bridge_opportunity_project_code": "1013288",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.290274,
  //       "bridge_opportunity_gps_longitude": 29.569592,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2634,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Vehicular bridge is desired and there is an all weather crossing 300m away.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.290274,
  //       "proposed_bridge_location_gps_longitude": 29.569592,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "300 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "April to May, September to December,",
  //       "market_access_blocked_by_river": "Masizi market (villages 1,2), farms(3,4)",
  //       "education_access_blocked_by_river": "Masizi primary school(villages1,2)",
  //       "health_access_blocked_by_river": "Kaduha hospital(3,4)",
  //       "other_access_blocked_by_river": "Football terrain (villages1,2)",
  //       "primary_occupations": "Farming, commerce, timber and charcoal processsing",
  //       "primary_crops_grown": "banana, maiz, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by the Jenda cell leader, Christine Mukarukundo.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is to the nearest all weather crossing 300m away, it was vehicular bridge before, they need motor bridge, they cross year round",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78OpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigarama",
  //       "bridge_opportunity_project_code": "1013290",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.271943,
  //       "bridge_opportunity_gps_longitude": 29.514311,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2873,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.271943,
  //       "proposed_bridge_location_gps_longitude": 29.514311,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "February, April to May, September to December, 12 hours after rain they can cross",
  //       "market_access_blocked_by_river": "Kigarama community market(villages 3,4), farms ( villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "Mugano health center ( villages 3,4)",
  //       "other_access_blocked_by_river": "Goverment services-sector offices ( villages 3,4), churches ( villages 1,2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They were crossing during rain m fell down and crowned",
  //       "notes_on_social_information": "The population information of each village was provided by Mugano land manager, Aimable Kurundengere who sourced the population from the sector office from the record statistics done in 2015 in Ubudehe program. The popular of all adjacent communities includes the following villages: kigarama, Ruhanga, Cyabute, and Rwamiko. The community members of Cyabute and Rwamiko they cross twice a week to visit the market, to visit churches, or to the health center.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d78P4AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamurera",
  //       "bridge_opportunity_project_code": "1013293",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 876,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Student fell and drowned",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need only a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EKWAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakoro",
  //       "bridge_opportunity_project_code": "1013294",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1345,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge only",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EKbAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kukamagi",
  //       "bridge_opportunity_project_code": "1013301",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.585599,
  //       "bridge_opportunity_gps_longitude": 29.749456,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2142,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.585599,
  //       "proposed_bridge_location_gps_longitude": 29.749456,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "October to December, April to May, 2hours",
  //       "market_access_blocked_by_river": "Kivuruga market( villalges 1,2), nyirabisekuru market(villages 3,4), farming (villages 1,2,3,4), karema vegetables market(villages 1,2)",
  //       "education_access_blocked_by_river": "Groupe Scolaire Ntarama-primary and secondary( villages 3,4), Groupe scholaire Bushoka-primary and secondary (villages 1,2), bushoka primary school (villages 1,2)",
  //       "health_access_blocked_by_river": "Bushoka health center ( villages 1,2)",
  //       "other_access_blocked_by_river": "Churches(villages 1,2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by mbwe cell leader, Jacqueline mukamana who sourced the population data from the cell register done 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali~musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ELAAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuba",
  //       "bridge_opportunity_project_code": "1013305",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.583976,
  //       "bridge_opportunity_gps_longitude": 29.74787,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2142,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.583976,
  //       "proposed_bridge_location_gps_longitude": 29.74787,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "October to December, April to May, 2hours",
  //       "market_access_blocked_by_river": "Kivuruga market( villalges 1,2), nyirabisekuru market(villages 3,4), farming (villages 1,2,3,4), karema vegetables market(villages  1,2)",
  //       "education_access_blocked_by_river": "Groupe Scolaire Ntarama-primary and secondary( villages 3,4), Groupe scholaire Bushoka-primary and secondary (villages 1,2), bushoka primary school (villages 1,2)",
  //       "health_access_blocked_by_river": " Bushoka health center ( villages 1,2,3,4)",
  //       "other_access_blocked_by_river": "Churches (villages 1,2,3,4)",
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by mbwe cell leader, Jacqueline mukamana who sourced the population from the cell register done in 2018 in Ubudehe program.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali~Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ELUAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamisave~kukibuga",
  //       "bridge_opportunity_project_code": "1013309",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.562608,
  //       "bridge_opportunity_gps_longitude": 29.705632,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1516,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.562608,
  //       "proposed_bridge_location_gps_longitude": 29.705632,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali~Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The nearest all weather crossing is less than 300m",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ELoAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Pansezi",
  //       "bridge_opportunity_project_code": "1013311",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.545719,
  //       "bridge_opportunity_gps_longitude": 29.67259,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4146,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.545719,
  //       "proposed_bridge_location_gps_longitude": 29.67259,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "April , May, 48 hours",
  //       "market_access_blocked_by_river": "Musanze market (villages 1,2), farms (villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "Kabushinge primary and secondary school ( villages 1,2 ), Rwaza primary school (villages 3,4), Rwaza secondary school(villages 3,4)",
  //       "health_access_blocked_by_river": "Rwaza health center (1,2)",
  //       "other_access_blocked_by_river": "Sector office (1,2), pansezi city center (1,2), Rwaza Catholic church(villages 3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell and drowned",
  //       "notes_on_social_information": "Population information of each village was provided kabushinge cell leader, console Uwambajimana who sourced the population information from cell record made in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EMIAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bigeshi",
  //       "bridge_opportunity_project_code": "1013312",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.557449,
  //       "bridge_opportunity_gps_longitude": 29.728546,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1800,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.557449,
  //       "proposed_bridge_location_gps_longitude": 29.728546,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "September to December, April to May, 12hours",
  //       "market_access_blocked_by_river": "Baziro market(villages1), farms(1,2,3)",
  //       "education_access_blocked_by_river": "Rurambo primary school(villages 1)",
  //       "health_access_blocked_by_river": "Murandi health center(villages 2)",
  //       "other_access_blocked_by_river": "Cell services (villages 1)",
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population information of each village was provided by Rurambo cell leader, Jean Claude Iradukunda who sourced the population information from cell register in Ubudehe program in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EMNAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare",
  //       "bridge_opportunity_project_code": "1013313",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.566405,
  //       "bridge_opportunity_gps_longitude": 29.731918,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2351,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.566405,
  //       "proposed_bridge_location_gps_longitude": 29.731918,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "September to December, April to May, 4hours",
  //       "market_access_blocked_by_river": "Baziro market(villages2,3,4), farms(1,2,3,4)",
  //       "education_access_blocked_by_river": " Rurambo primary school(villages 2,3,4)",
  //       "health_access_blocked_by_river": " Murandi health center(villages 1)",
  //       "other_access_blocked_by_river": " Cell services (villages 3 )",
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The population information of each village was provided by rurambo cell leader, Jean Claude Iradukkunda who sourced the population information from cell register done in 2018 in Ubudehe program.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": 7.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EMSAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare2",
  //       "bridge_opportunity_project_code": "1013314",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.576444,
  //       "bridge_opportunity_gps_longitude": 29.728154,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1114,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.576444,
  //       "proposed_bridge_location_gps_longitude": 29.728154,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": "Vehicular bridge in 1km away",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is river confluence, on the other there is a road that block the centerline",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": 3.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EMXAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabashima-mikamo",
  //       "bridge_opportunity_project_code": "1013315",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.536183,
  //       "bridge_opportunity_gps_longitude": 29.706608,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2936,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.536183,
  //       "proposed_bridge_location_gps_longitude": 29.706608,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "September to December and from April to May, it take 3hours",
  //       "market_access_blocked_by_river": "Mukinga market(1,2), nyirabisekuru market ( 3,4), farms ( 1,2,3,4)",
  //       "education_access_blocked_by_river": " Secondary schools( kabushinge, Rwaza, Notres dames was appotres Rwaza, GS Marie Rene rwaza,) villages(1,2), primary schools (Rwaza1, Rwaza2)-villages(1,2)",
  //       "health_access_blocked_by_river": " Rwaza health center( villages 1,2)",
  //       "other_access_blocked_by_river": " Catholic church, Rwaza parish(1,2), goverment services-sector office, murwa cell (villages 3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by Donate Uwimana the assistant cell leader of Murwa cell who sourced the population from cell register done in 2018 in Ubudehe program.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EMcAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Zihare",
  //       "bridge_opportunity_project_code": "1013316",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.50342,
  //       "bridge_opportunity_gps_longitude": 29.95362,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4869,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.50342,
  //       "proposed_bridge_location_gps_longitude": 29.95362,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Buzaniro, Mutungo and Tumba are blocked to the Market and farms are both side",
  //       "education_access_blocked_by_river": "No communities blocked to school",
  //       "health_access_blocked_by_river": "No communities blocked to Health center they choose where they want because both side have health center",
  //       "other_access_blocked_by_river": "Zihare is blocked to the business center which is closer and to the potable water",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They were tried to cross the bridge when it was flooded and fell into river",
  //       "notes_on_social_information": "Community leaders of Zihare and numbers of population was given by different communities leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Base Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EPzAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buzaniro",
  //       "bridge_opportunity_project_code": "1013317",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.50145,
  //       "bridge_opportunity_gps_longitude": 29.95181,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1434,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.50145,
  //       "proposed_bridge_location_gps_longitude": 29.95181,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 72,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Mutungo, Buzaniro are blocked to the Market and farms on both side",
  //       "education_access_blocked_by_river": "No communities blocked to school",
  //       "health_access_blocked_by_river": "No communities blocked to Health center",
  //       "other_access_blocked_by_river": "Zihare is blocked to business center and potable water",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They were trying to cross the bridge when it was flooded and fell into river",
  //       "notes_on_social_information": "Zihare community leader is the one who gives me information and numbers of population was given by different communities leaders of the nearby of the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Gicumbi Base",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EQ9AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivumo",
  //       "bridge_opportunity_project_code": "1013319",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.49022,
  //       "bridge_opportunity_gps_longitude": 29.95422,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1205,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.49022,
  //       "proposed_bridge_location_gps_longitude": 29.95422,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 52,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Rubaya, Sangabuzi and part of Kivumu are blocked to the Market and farms are both side",
  //       "education_access_blocked_by_river": "Part of Kivumu are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Part of Kivumu are blocked to post health center",
  //       "other_access_blocked_by_river": "Part of Kivumu are blocked to cell, sector and district office, to churches",
  //       "primary_occupations": "Schools, Market, farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Kivumu and people who live closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 71,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EQOAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusuzuma",
  //       "bridge_opportunity_project_code": "1013320",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.49763,
  //       "bridge_opportunity_gps_longitude": 29.80603,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3880,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.49763,
  //       "proposed_bridge_location_gps_longitude": 29.80603,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "2",
  //       "market_access_blocked_by_river": "Rusuzuma, Kiboga, Mariba and Buhemba are blocked to the Market in Kirambo, farms are both side",
  //       "education_access_blocked_by_river": "Rusuzuma, Kiboga, Mariba and Buhemba are blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "Rusuzuma, Kiboga, Mariba and Buhemba are blocked the health center which is in Kirambo",
  //       "other_access_blocked_by_river": "Rusuzuma, Kiboga, Mariba and Buhemba are blocked to the district office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "She was trying to cross the bridge when it was flooded and fell into river and found died, other were students but they were found alive",
  //       "notes_on_social_information": "Information was given by the two cell leaders Kiboga and Rusuzuma, and numbers given by all communities leaders of the nearby of bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EQdAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa moja",
  //       "bridge_opportunity_project_code": "1013321",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.52521,
  //       "bridge_opportunity_gps_longitude": 29.78268,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4327,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.52521,
  //       "proposed_bridge_location_gps_longitude": 29.78268,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "4 days",
  //       "market_access_blocked_by_river": "Musama, Kiraro and Mutungo are blocked to the Market of Mucaca, farms are on both side",
  //       "education_access_blocked_by_river": "Remya and Gatenga are blocked to primary school and secondary school, and there is part of Bushima which is blocked to secondary schools",
  //       "health_access_blocked_by_river": "Remya and Gatenga are blocked to Health center in Musasa",
  //       "other_access_blocked_by_river": "Remya and Gatenga are blocked to potable water, churches and football terrain",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Kiraro and numbers was given by community leaders of different communities nearby the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EQxAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mushubi",
  //       "bridge_opportunity_project_code": "1013322",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.52982,
  //       "bridge_opportunity_gps_longitude": 29.85156,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6566,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.52982,
  //       "proposed_bridge_location_gps_longitude": 29.85156,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "4 days",
  //       "market_access_blocked_by_river": "They have two market on both side but one in Kirambo is so closer and most used, farms on both side",
  //       "education_access_blocked_by_river": "Secondary and primary school are in Butare , Rushubi and Kirambo and gacyamo and Mushubi are blocked to the schools",
  //       "health_access_blocked_by_river": "Health center are in Ntazi and Kirambo, Gacyamo and Mushubi are blocked to the health center",
  //       "other_access_blocked_by_river": "Gacyamo, Mushubi, Murambi, Gatovu, Mucaca are blocked to the district office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Nobe",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and the numbers of people were given by all communities leaders of the nearby communities",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ER7AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Tangata",
  //       "bridge_opportunity_project_code": "1013323",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.51042,
  //       "bridge_opportunity_gps_longitude": 29.8463,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3991,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.51042,
  //       "proposed_bridge_location_gps_longitude": 29.8463,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "4 day",
  //       "market_access_blocked_by_river": "Tangata, Mushubi and Gacyamo are blocked to the Market of Kirambo, farms are on both side",
  //       "education_access_blocked_by_river": "Tangata , Gacyamo are blocked to primary and secondary school which are in But and Kirambo",
  //       "health_access_blocked_by_river": "Tangata and Gacyamo are blocked to Health center",
  //       "other_access_blocked_by_river": "Tangata and Gacyamo are blocked to district office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Tangata and numbers of people given by all communities leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ERlAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burindwa",
  //       "bridge_opportunity_project_code": "1013324",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.50887,
  //       "bridge_opportunity_gps_longitude": 29.84577,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4393,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.50887,
  //       "proposed_bridge_location_gps_longitude": 29.84577,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "4 days",
  //       "market_access_blocked_by_river": "Moma, Gacundura , Burindwa and Tangata are blocked to the Market and farms are on both sides",
  //       "education_access_blocked_by_river": "Moma, Gacundura , Burindwa and Tangata are blocked to nursery, primary and secondary school",
  //       "health_access_blocked_by_river": "Moma, Gacundura , Burindwa and Tangata are blocked to Health center",
  //       "other_access_blocked_by_river": "Moma, Gacundura , Burindwa and Tangata are blocked to district office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived and population numbers was given by all communities leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ERvAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruheka",
  //       "bridge_opportunity_project_code": "1013325",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.59185,
  //       "bridge_opportunity_gps_longitude": 29.923,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2627,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59185,
  //       "proposed_bridge_location_gps_longitude": 29.923,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "5 days",
  //       "market_access_blocked_by_river": "At both side there is market, but the most used is one on right side of river, that means Kivumu and Nyabisasa are blocked to Gitanga Market, farms on both side",
  //       "education_access_blocked_by_river": "Secondary school is in Gitare, and Kaberano and Genda are blocked to it, primary school are in Genda where Kivumu and Nyabisasa are blocked",
  //       "health_access_blocked_by_river": "The post health center is in Genda , where Kivumu and Nyabisasa are blocked",
  //       "other_access_blocked_by_river": "Churches are in Gitare where Kaberano and Genda cross the river to Gitare , business center is in Genda, every evening the Kivumu and Nyabisasa cross the river to Genda",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Children was trying to choose the river and fell into river and died",
  //       "notes_on_social_information": "Community leaders of Kaberano and communities of kivumu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ESAAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa kabandwa",
  //       "bridge_opportunity_project_code": "1013326",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.55462,
  //       "bridge_opportunity_gps_longitude": 29.98703,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3422,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.55462,
  //       "proposed_bridge_location_gps_longitude": 29.98703,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 93,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Kabuga, bikumba are blocked to market, farms are both side",
  //       "education_access_blocked_by_river": "School are both side. No communities blocked",
  //       "health_access_blocked_by_river": "Health center on both side",
  //       "other_access_blocked_by_river": "The churches on both side but it depends on faith",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ESPAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Bizimana",
  //       "bridge_opportunity_project_code": "1013327",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.55547,
  //       "bridge_opportunity_gps_longitude": 29.98941,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3422,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.55547,
  //       "proposed_bridge_location_gps_longitude": 29.98941,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 93,
  //       "flood_duration_during_rainy_season": "4 days",
  //       "market_access_blocked_by_river": "Kabuga and Bikumba are blocked to the Market, farms on both side",
  //       "education_access_blocked_by_river": "No communities blocked to school",
  //       "health_access_blocked_by_river": "No communities blocked to Health center",
  //       "other_access_blocked_by_river": "Churches are on both side but they cross river depends on their faith",
  //       "primary_occupations": "Market, farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and numbers of population was given by the communities leaders of the nearby of the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Gicumbi Base",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ESZAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabusunzu",
  //       "bridge_opportunity_project_code": "1013331",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.4851,
  //       "bridge_opportunity_gps_longitude": 29.80904,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4275,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4851,
  //       "proposed_bridge_location_gps_longitude": 29.80904,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April, May and October, it last for 6 hours.",
  //       "market_access_blocked_by_river": "Mugogwe, Huye, Rugogwe and Nyanza Markets (Community 4,5); Gikonko and Musha Markets (Community 1,2,3); Farms(All communities), Gikonko Rice Factory (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Kimuna Primary School (Community 4,5); Gafumba Primary and Secondary School (Community 4,5); Gasagara Primary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Cyimana and Gikonko Health Centers (Community 1,2,3); Rubona Health Center (Community 4,5); Gafumba Health Post (Community 4,5)",
  //       "other_access_blocked_by_river": "Gasagara Catholic Church (Community 1,2,3); Kanogo Catholic Church (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "fruit, ric, tomato",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "5 deaths between April and May 2018, the erosion washed away the timber bridge. During the same period people who were trying to cross the river were drowned.",
  //       "notes_on_social_information": "Nyabusunzu, Murambi, Cyimigo, Mugusa, and Bibungo were included in Individuals Directly Served because their community members use the crossing point daily to go to markets, health centers, churches, schools,... The population information for each village was provided by the Kimuna Cell Leader, and each village leader. The population information data were collected in 2018. Population of All Adjacent Communities includes the following villages: Rushikiri, Rwamuganda, Remera, Mubezi and Gasenyi. These community members sometimes use this crossing to visit relatives, to visit the market once a month or to go to Huye Town.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ET8AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubanga",
  //       "bridge_opportunity_project_code": "1013332",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.46826,
  //       "bridge_opportunity_gps_longitude": 29.77101,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4831,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46826,
  //       "proposed_bridge_location_gps_longitude": 29.77101,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In April, May, October to December it last for 2 hours.",
  //       "market_access_blocked_by_river": "Mijyajyaro Market (Community 4,5); Rugarama and Rugogwe Markets (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Rubona Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Rubona Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Kiruhura Adventist Church and Kiruhura Catholic Parish (Community 1,2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry.",
  //       "primary_crops_grown": "banana plantation, dairy product, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One adult person slipped and fell into the river and drowned but was rescued.",
  //       "notes_on_social_information": "Rubanga, Nyarutovu, Kavumu, Nyarugenge and Nyamuko were included in Individuals Directly Served because their community members use the crossing point daily to go to markets, health centers, churches, schools,... The population information for each village was provided by the Kimirehe Cell Leader, Hakuziyaremye Annonciata. The population information data were collected in 2018. Population of All Adjacent Communities includes the following village: Ndyome and Kagasa. These community members sometimes use this crossing to visit relatives or to go to Huye Town.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1(Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 1.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ETDAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruvugizo",
  //       "bridge_opportunity_project_code": "1013333",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.3965,
  //       "bridge_opportunity_gps_longitude": 29.79099,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1701,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3965,
  //       "proposed_bridge_location_gps_longitude": 29.79099,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "Kanyinya Primary School (Community 1,2)",
  //       "health_access_blocked_by_river": "Gitovu Health Post (Community 1,2)",
  //       "other_access_blocked_by_river": "Gitovu Cell Office (Community 1,2)",
  //       "primary_occupations": "Agriculture, animal husbandry and business trading",
  //       "primary_crops_grown": "banana plantation, bean, cassava, dairy product, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ruvugiza and Karambo were included in Individuals Directly Served because their community members use the crossing point daily to health center and cell office and schools,... The population information for each village was provided by the Ruvugizo Village Leader, Nyandwi Emmanuel and Karambo Village leader, Musoni John. The population information data were collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru )",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": 1.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ETIAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibiraro",
  //       "bridge_opportunity_project_code": "1013334",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.43844,
  //       "bridge_opportunity_gps_longitude": 29.7937,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.43844,
  //       "proposed_bridge_location_gps_longitude": 29.7937,
  //       "current_crossing_method": "Concrete",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It last for 2 hours",
  //       "market_access_blocked_by_river": "Gakoni Market (Community 3), coffee washing station (Community 3)",
  //       "education_access_blocked_by_river": "Remera Primary School and Lycée de Rusatira (Secondary School) (Community 1,2)",
  //       "health_access_blocked_by_river": "Rusatira Health Center (Community 1,2)",
  //       "other_access_blocked_by_river": "EER Church (Community 1,2)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, coffe, potato, ric, tomato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Mwunyu, Gakoni and Kibiraro were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, schools,... The population information for each village was provided by the Kabona Cell Leader, Mukandutiye Chantal. The population information data were collected in 2018. Population of All Adjacent Communities includes the following village: Nyarutovu and Kavumu. These community members sometimes use this crossing to visit relatives",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru )",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ETNAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugarama",
  //       "bridge_opportunity_project_code": "1013335",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.4812,
  //       "bridge_opportunity_gps_longitude": 29.74129,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1554,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4812,
  //       "proposed_bridge_location_gps_longitude": 29.74129,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May, it last for 2 hours",
  //       "market_access_blocked_by_river": "Rugarama Market (Community 2,3), Farms (All Communities)",
  //       "education_access_blocked_by_river": "There is no education access blocked by the river, each community has a school on its side.",
  //       "health_access_blocked_by_river": "No health access blocked.",
  //       "other_access_blocked_by_river": "Kiruhura ADPR church (Community 2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rugarama, Mbagabaga and Rwamabare were included in Individuals Directly Served because their community members use the crossing point daily to go to markets, health centers, churches, schools,... The population information for each village was provided by the Rugarama Viallage Leader, Uwizeyimana John and Mbagabaga and Rwamabare villages. The population information data were collected in late 2017. Population of All Adjacent Communities use other path to get access to schools, markets and health centers.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ETSAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musonga",
  //       "bridge_opportunity_project_code": "1013336",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.48378,
  //       "bridge_opportunity_gps_longitude": 29.68794,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2945,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.48378,
  //       "proposed_bridge_location_gps_longitude": 29.68794,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Rugogwe Market (Community 4), Nyangazi and Cyiri Markets (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Gisakura Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Gisakura Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Gisakura Cell Office and Gisakura Catholic Church, Nyangazi EAR and ADPR Churches (Community 1,2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, cabbag, cassava, milk, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyabisindu, Kirarambogo, Bambiro and Gasharu were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, schools,... The population information for each village was provided by the Gisakura Cell Leader, Rutebuka Noel. The population information data were collected in 2018. Population of All Adjacent Communities includes the following village: Gisakura, Nyangazi and Gasharu. These community members sometimes use this crossing to visit relatives or to go to market once or twice a month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ETXAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akanyana",
  //       "bridge_opportunity_project_code": "1013337",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.49432,
  //       "bridge_opportunity_gps_longitude": 29.73509,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5277,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.49432,
  //       "proposed_bridge_location_gps_longitude": 29.73509,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Rugogwe Market (Community 4,5), Gafumba and Mara Markets (Community 1,2,3), Farms (Communities )",
  //       "education_access_blocked_by_river": "Rugogwe Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Rugogwe Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Rugogwe EAR, ADPR and Jehovah Witnesses Church (Community 4,5), Kiruhura Adventist and Catholic Parish (Community 1,2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, cassava, milk, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "Most of the injuries are from motorcyclists or bicyclists who fall into the river at the crossing point.",
  //       "notes_on_social_information": "Akanyana, Murambi, Gasharu, Rwamabare and Mbagabaga were included in Individuals Directly Served because their community members use the crossing point daily to go to markets, health centers, churches, schools,... The population information for each village was provided by the Rugogwe Cell Leader, Kayirangwa Theophile. The population information data were collected in 2018. Population of All Adjacent Communities includes the following village: Ruhashya, Rugarama and different communities in Mara cell, Kimuna and Kimirehe cells in Rusatira sector. These community members sometimes use this crossing to visit relatives or to go to Rugogwe Cattle Market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ETcAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarutovu",
  //       "bridge_opportunity_project_code": "1013338",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.44354,
  //       "bridge_opportunity_gps_longitude": 29.7827,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4308,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.44354,
  //       "proposed_bridge_location_gps_longitude": 29.7827,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Gakoni Market (Community 1,2); Rugogwe Market (Community 3); Coffee Washing Station (1,2)",
  //       "education_access_blocked_by_river": "Kato Primary School (3); Buhimba Primary and Secondary School (3)",
  //       "health_access_blocked_by_river": "Each community has a health center on its sides, they don't cross for health services.",
  //       "other_access_blocked_by_river": "Kiruhura Catholic Parish (3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One person fell into the river but was rescued.",
  //       "notes_on_social_information": "Nyarutovu, Rubanga and Mwunyu were included in Individuals Directly Served because their community members use the crossing point daily to go to markets, health centers, churches, schools,... The population information for each village was provided by and each village leader: the Nyarutovu village leader, Nsengimana Edgard, the Rubanga village leader, Nguyeneza Alexis and the Munyu village leader, Gasana. The population information data were collected in early 2018. Population of All Adjacent Communities includes the following villages: Gakoni, Kavumu and Ndyome. These community members sometimes use this crossing to visit relatives, to visit the market once a month or to go to Huye Town. Different communities use this crossing point to bring cows to Rugogwe Cattle Market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EThAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahana",
  //       "bridge_opportunity_project_code": "1013340",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.38471,
  //       "bridge_opportunity_gps_longitude": 29.76592,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2290,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.38471,
  //       "proposed_bridge_location_gps_longitude": 29.76592,
  //       "current_crossing_method": "Concrete",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 7,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Nyanza and Kibaga Markets (Community 1,2); Areté Market (Community 3,4); Farms (All Communities)",
  //       "education_access_blocked_by_river": "Kibaga Primary School (Community 1,2); Kinazi Primary and Secondary School (Community 3,4)",
  //       "health_access_blocked_by_river": "Gahondo Health Post and Nyanza District Hospital (Community 1,2)",
  //       "other_access_blocked_by_river": "Nyanza Catholic Parish (Community 1,2); Rugarama Adventist and ADPR (Community 3,4)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, cabbag, dairy product, pea, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people have been falling into the river at the current crossing point during rainy season, but were rescued before drowning and some were send to hospitals for health care. 2 children died trying to cross.",
  //       "notes_on_social_information": "Gahana, Rugarama, Kibaga and Gahondo were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, schools,... The population information for each village was provided by the Gahana Cell Leader, Nkurunziza Fidele and Gahana, Rugarama and Gahondo village leaders. The population information data were collected in 2018. Population of All Adjacent Communities includes the following village: Kinazi, Ruvugizo and Karambo. These community members sometimes use this crossing to visit relatives, go to Gahondo cattle market or go to Nyanza Town.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ETrAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibaribari",
  //       "bridge_opportunity_project_code": "1013342",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.537665,
  //       "bridge_opportunity_gps_longitude": 29.700128,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2936,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.537665,
  //       "proposed_bridge_location_gps_longitude": 29.700128,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "September to December, April to May, 6hours",
  //       "market_access_blocked_by_river": "Mukinga market(1,2), nyirabisekuru( 3,4), farms ( 1,2,3,4), bricks manufacturing ( 3,4)",
  //       "education_access_blocked_by_river": "Secondary schools( kabushinge, Rwaza, Notres dames was appotres Rwaza, GS Marie Rene rwaza,) villages(1,2), primary schools (Rwaza1, Rwaza2)-villages(1,2)",
  //       "health_access_blocked_by_river": "Rwaza health center( villages 1,2)",
  //       "other_access_blocked_by_river": "Catholic church, Rwaza parish(1,2), goverment(villages 3,4)",
  //       "primary_occupations": "Farming, bricks making",
  //       "primary_crops_grown": "banana, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Drowned while crossing river",
  //       "notes_on_social_information": "The population information of each village was provided Social executive director (SEDO)of Murwa cell, Donate Uwimana who sourced the population information from cell register in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EVYAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bukane",
  //       "bridge_opportunity_project_code": "1013343",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.497265,
  //       "bridge_opportunity_gps_longitude": 29.616601,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6321,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.497265,
  //       "proposed_bridge_location_gps_longitude": 29.616601,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "700 m",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "December, April to May, 24 hours",
  //       "market_access_blocked_by_river": "market (villages 1,2), musanze cetraf Ltd ( villages 1,2), farms (villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "INES Ruhengeri university( villages 1,2) Musanze primary school and secondary school(1,2), cyabagarura secondary school (3,4), Tvet trying center (villages 3,4)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Catholic churches(1,2)",
  //       "primary_occupations": "Farming, commerce, goverment workers",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by the cyabagarura cell leader , Theoneste Ntawurushimanimbabazi who sourced the population from the cell register done in 2017 in Ubudehe program. The community members from Gaturo and Bukane use the bridge to market , to churches and the bridge also used by the students of INES University Daily. These two communities Gaturo and Bukane there is planned city community settlement on the master plan.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EVdAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatandaganya",
  //       "bridge_opportunity_project_code": "1013413",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.39137,
  //       "bridge_opportunity_gps_longitude": 29.52399167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2136,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.39137,
  //       "proposed_bridge_location_gps_longitude": 29.52399167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Normally the can cross, but they wish they can have a bridge that motorcycles can cross.",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, animal Keeping, small local commercial center",
  //       "primary_crops_grown": "bean, cassava, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Markets of Dusenyi and Kibibi ( Zigati, Nkomero) Primary and Secondary schools(Zigati, Nkomero) Health Center( Zigati, Nkomero) The numbers of this survey were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 28.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JCJAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kageyo",
  //       "bridge_opportunity_project_code": "1013345",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.491395,
  //       "bridge_opportunity_gps_longitude": 29.626729,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8280,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.9",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.491395,
  //       "proposed_bridge_location_gps_longitude": 29.626729,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "April to May, 1hours, notes the river is seasonal during sunny season the river stops.",
  //       "market_access_blocked_by_river": "Goyiko market in musanze city(villages 3,4,5), Bukane community Market ( 3,4,5), farms( 1,2,3,4,5), kungagi community Market ( 1,2).",
  //       "education_access_blocked_by_river": "gashangiro 2 primary school (1,2), Gahondogo primary school , musanze(3,4,5)",
  //       "health_access_blocked_by_river": "Cyabagarura clinics(villages 3,4,5), Musanze health center(villages 3,4,5)",
  //       "other_access_blocked_by_river": "Churches( 3,4,5), EAR church( villages 1,2)",
  //       "primary_occupations": "Farming, commerce, construction, etc..",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Drowned while crossing",
  //       "notes_on_social_information": "Population information of each village was provided by cyabagarura assistant cell leader, Theoneste Ntawurushimanimbabazi who sourced the population from the cell register done in 2017 in Ubudehe program.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7EVnAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwangege",
  //       "bridge_opportunity_project_code": "1013363",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.60288,
  //       "bridge_opportunity_gps_longitude": 29.59389,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2849,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.60288,
  //       "proposed_bridge_location_gps_longitude": 29.59389,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "One",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": "Byangabo market which is open daily is blocked to communities of right side of the river has, farms on both sise",
  //       "education_access_blocked_by_river": "Murama Primary and secondary school blocked to communities of right side of the river",
  //       "health_access_blocked_by_river": "Bite health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Murama Catholic Parish and Bihe Adventist of Seven days church blocked to communities of right side of the river",
  //       "primary_occupations": "Farmers on both side and traders at Byangabo market",
  //       "primary_crops_grown": "carrots ), potato, vegetables (tomato, wheat",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died",
  //       "notes_on_social_information": "Byangabo market(Village 1,4,5), Bihe health center(village 1,4,5), Murama Catholic Parish(village 1,4,5), Murama Primary and secondary school(1,4,5) . Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018. Population of adjacent communities include a part of Gasiza village. Village members in Gasiza sometimes use this crossing to go to Parish during some celebration days in the church",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GqvAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruyebe",
  //       "bridge_opportunity_project_code": "1013366",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.65036,
  //       "bridge_opportunity_gps_longitude": 29.52165,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2671,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65036,
  //       "proposed_bridge_location_gps_longitude": 29.52165,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Mukamira and Gasiza markets which are open weekly, workers in tea plantation and to the Factory (Rwanda mountain Tea company/Nyabihu)",
  //       "education_access_blocked_by_river": "Nyaburaro Primary school and Gihira secondary school blocked to communities of right side of the river",
  //       "health_access_blocked_by_river": "Mwiyanike health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Karago sector office blocked to communities of right side of the river",
  //       "primary_occupations": "Tea plantation workers, farmers of Potatoes and vegetables and traders at Mukamira and Gasiza markets",
  //       "primary_crops_grown": "bean, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died",
  //       "notes_on_social_information": "Mukamira and Gasiza markets which are open weekly ( village 2,3,4,5), Gihira primary and secondary school ( village 2,3,4 5), Mwiyanike health center ( village 2,3,4,5), Nyaburaro Primary school ( village 2,3,4 5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018. Population of adjacent communities include the following villages of Bikereri and Muvure. Community members in Bikereri and Muvure use this crossing to Visit relatives and go to Mukamira market monthly",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GrAAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mashyuza",
  //       "bridge_opportunity_project_code": "1013367",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.64985,
  //       "bridge_opportunity_gps_longitude": 29.52289,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2025,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.64985,
  //       "proposed_bridge_location_gps_longitude": 29.52289,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Mukamira and Gasiza markets which are open twice a week are blocked to communities of the left side of the river, daily workers in Tea plantations farms and at the Factory are blocked",
  //       "education_access_blocked_by_river": "Nyaburaro Primary school and Gihira secondary school blocked to communities of the left side of the river",
  //       "health_access_blocked_by_river": "Mwiyanike health center blocked to communities of left side of the river",
  //       "other_access_blocked_by_river": "Karago sector office blocked to communities of the left side of the river",
  //       "primary_occupations": "Tea plantation workers, farmers (Potatoes and vegetables) and traders at Mukamira market",
  //       "primary_crops_grown": "bean, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately he didn't die",
  //       "notes_on_social_information": "Nyaburaro Primary school ( village 2,3,4, ), Mukamira and Gasiza market ( village 2,3,4,), Mwiyanike health center ( village 2,3 ,4 ,) Rega sector office ( village 2,3,4,). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018 Population of adjacent communities include Bikereri community. Community members in Bikereri use this crossing to Visit relatives",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GrFAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubare",
  //       "bridge_opportunity_project_code": "1013368",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.59466,
  //       "bridge_opportunity_gps_longitude": 29.47184,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3159,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59466,
  //       "proposed_bridge_location_gps_longitude": 29.47184,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Kora market and Mukamira which is open every Monday and Thursday are blocked to communities on Right side of the river, Pyreth plantation which is extended on both sides of the river and one part is blocked to communities on either side of the river",
  //       "education_access_blocked_by_river": "Kareba primary and secondary school blocked to communities of the right side of the river",
  //       "health_access_blocked_by_river": "Kareba health center blocked to communities of the right side",
  //       "other_access_blocked_by_river": "Churches blocked to communities of right side of the river",
  //       "primary_occupations": "Workers in Pyreth farms (large )of Sopirwa company, potatoes farmers/workers",
  //       "primary_crops_grown": "potatoes farm, pyreth plantation on large scal",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died, only injuries of arms and legs",
  //       "notes_on_social_information": "Potatoes store/collection zone( village 2,3,4), Kareba Primary and secondary school ( village 2, 3 ,4 ), Kareba health center ( village 2,3 ,4 ), Kora market which is open twice a week ( village 2,3,4 ), Pyreth plantation farms( village1,5 ), Potatoes farms ( village 1,5 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018. Population of adjacent communities include Terimbere community. Community members of Terimbere use this crossing to Visit relatives and in Pyreth farms",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GrKAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burera",
  //       "bridge_opportunity_project_code": "1013790",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.68033,
  //       "bridge_opportunity_gps_longitude": 29.69028,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.68033,
  //       "proposed_bridge_location_gps_longitude": 29.69028,
  //       "current_crossing_method": "They always cross they just need away for vehicle",
  //       "nearest_all_weather_crossing_point": "They always cross",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "0",
  //       "market_access_blocked_by_river": "Vunga and murambo market",
  //       "education_access_blocked_by_river": "Janja school",
  //       "health_access_blocked_by_river": "Janja health center",
  //       "other_access_blocked_by_river": "Janja cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information gathered from nyagisozi leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community is requesting a vehicular bridge not a pedestrian bridge",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 52,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wuqAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Matyazo",
  //       "bridge_opportunity_project_code": "1013369",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.64694,
  //       "bridge_opportunity_gps_longitude": 29.47735,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4288,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.64694,
  //       "proposed_bridge_location_gps_longitude": 29.47735,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "Kora market which is open twice a week is blocked to communities of right side of the river, Tea plantations farms, and potatoes farms",
  //       "education_access_blocked_by_river": "Jenda Primary and secondary school blocked to communities of right side of the river",
  //       "health_access_blocked_by_river": "Jenda and Kora health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Kora Parish and Adventist of Seven days church blocked to communities are blocked to communities of right side of the river",
  //       "primary_occupations": "Daily workers in tea plantation, farmers of Potatoes and vegetables (carrots and cabbages ) and traders at Mukamira",
  //       "primary_crops_grown": ", potatoes on large l, tea plantation on large scal, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into it but fortunately none died only some had fracture on their arms and legs",
  //       "notes_on_social_information": "Tea Plantation ( village 2,3,4 ), Ruhigiro primary school ( village 1 ), Jenda Primary and secondary school ( village 2,3,4 ), Kora market which is open twice a week ( village 2,3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GrPAAU",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Rushungura",
  //       "bridge_opportunity_project_code": "1013370",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.62862,
  //       "bridge_opportunity_gps_longitude": 29.47369,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2862,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62862,
  //       "proposed_bridge_location_gps_longitude": 29.47369,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "0.8 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Kora and Mukamira markets open weekly are blocked to communities of the left side, farms on both sides are blocked due to the river",
  //       "education_access_blocked_by_river": "Jenda secondary school blocked to communities of right side of the river",
  //       "health_access_blocked_by_river": "Jenda health center",
  //       "other_access_blocked_by_river": "1 church on right and two churches on right side, potable water on right side",
  //       "primary_occupations": "Nyabihu tea plantations workers, farmers on both sides and traders at Kora market",
  //       "primary_crops_grown": "carrot, potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died, only injuries on legs or arms",
  //       "notes_on_social_information": "Jenda health center (village 1,4,5), Potable water (village2,3 ), Kora market which is open twice a week ( village 1,4,5 ), Farms on both sides. Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GrUAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisozi",
  //       "bridge_opportunity_project_code": "1013371",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.61452,
  //       "bridge_opportunity_gps_longitude": 29.47951,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61452,
  //       "proposed_bridge_location_gps_longitude": 29.47951,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is always crossed the whole year around and it doesn't get flooded",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GrZAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "RunyanjaII",
  //       "bridge_opportunity_project_code": "1013372",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.61142,
  //       "bridge_opportunity_gps_longitude": 29.47289,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4855,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61142,
  //       "proposed_bridge_location_gps_longitude": 29.47289,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Potatoes and vegetables farms blocked by the river on both side, Mukamira market blocked to communities of left side of the river",
  //       "education_access_blocked_by_river": "Jenda Primary and secondary school blocked to communities of left side",
  //       "health_access_blocked_by_river": "Jenda health center blocked to communities of the left side and Kareba health center blocked to communities of right side",
  //       "other_access_blocked_by_river": "Churches and kabatezi cell office",
  //       "primary_occupations": "Farmers (Potatoes and vegetables ) and traders at Mukamira market",
  //       "primary_crops_grown": "carrots ), potato, vegetables (cabbag",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Mukamira market which is open twice a week (village 4,5), Jenda Primary and secondary school ( village4 5 ) , Jenda health center (village 4,5), Farms on both sides. Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in this year 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GreAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "RunyanjaI",
  //       "bridge_opportunity_project_code": "1013373",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.60836,
  //       "bridge_opportunity_gps_longitude": 29.47061,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2887,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.60836,
  //       "proposed_bridge_location_gps_longitude": 29.47061,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Mukamira market open every weekly blocked to communities of the left side, vegetables farms",
  //       "education_access_blocked_by_river": "Jenda Primary and secondary school blocked to communities of the left side",
  //       "health_access_blocked_by_river": "Jenda health center blocked to communities of the left side",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farmers on both side and traders at Mukamira",
  //       "primary_crops_grown": "onions), potato, vegetables ( carrot",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died only some had fracture on their arms and legs",
  //       "notes_on_social_information": "Jenda health center (village2,3,4 ), Mukamira market which is open twice a week (village 2,3,4 ), Jenda Primary and secondary school (village 2,3,4 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GrjAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhigiro",
  //       "bridge_opportunity_project_code": "1013375",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.65254,
  //       "bridge_opportunity_gps_longitude": 29.4929,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1320,
  //       "bridge_opportunity_comments": "Not Duplicate",
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65254,
  //       "proposed_bridge_location_gps_longitude": 29.4929,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Mukamira market which is open every day is blocked to communities of left side of the river , potatoes farms on both side of the river are blocked",
  //       "education_access_blocked_by_river": "Ruhigiro primary blocked to communities of right side of the river, Bihira secondary school blocked to communities of the left side of the",
  //       "health_access_blocked_by_river": "Mwiyanike health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Potable water blocked to communities of right side of the river",
  //       "primary_occupations": "Farmers ( of Potatoes and maize,), traders at Mukamira market",
  //       "primary_crops_grown": "maiz, potato, soya bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river",
  //       "notes_on_social_information": "Gihira secondary school ( village 1) , Mukamira market ( village 1) Mwiyanike health center( village1), Ruhigiro primary school( village2), Potatoes farms ( village 2) Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GrtAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamirama",
  //       "bridge_opportunity_project_code": "1013414",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.385695,
  //       "bridge_opportunity_gps_longitude": 29.54770167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2504,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.385695,
  //       "proposed_bridge_location_gps_longitude": 29.54770167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December, and it lasts for 1hour after rainfall",
  //       "market_access_blocked_by_river": "Markets,",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Farming of beans, Maize, soja, cassava",
  //       "primary_crops_grown": "bean, cassava, maiz, som",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Market of Kibibi( Nyamirama, Murwa) Market of Bwenda( Kirwa, Ryingarura) Secondary school (Nyamirama, Murwa) Primary school ( Kirwa) Health Center (Nyamirama, Murwa) These numbers of the social survey were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 25.8,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JCTAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatagara",
  //       "bridge_opportunity_project_code": "1013379",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.62934,
  //       "bridge_opportunity_gps_longitude": 29.4568,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2017,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62934,
  //       "proposed_bridge_location_gps_longitude": 29.4568,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Mukamira and Kora market which are open weekly are blocked to communities of right side of the river , potatoes and vegetables farms are blocked to communities of right side of the river",
  //       "education_access_blocked_by_river": "Bukinanyana Primary and Jenda secondary school blocked to communities of right side of the river",
  //       "health_access_blocked_by_river": "Jenda and Kora health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Potable water(water spring) blocked to communities of the left side of the river and Kora Parish blocked to communities of right side of the river",
  //       "primary_occupations": "Farmers of potatoes( on large land ) and vegetables( carrots and cabbages,) , Tea plantations workers of Nyabihu Mountain tea and traders at Mukamira and Kora markets",
  //       "primary_crops_grown": "cabbages ), onion, potato, vegetables (carrot",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river",
  //       "notes_on_social_information": "Kora and Mukamira markets (village 2,3), Jenda Primary and secondary school (2,3),Tea plantations (village2 3,) , potable water(village). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018. Population of adjacent communities include part of kijote members who sometimes use this crossing to fetch water",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GsDAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagasozi",
  //       "bridge_opportunity_project_code": "1013380",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.62865,
  //       "bridge_opportunity_gps_longitude": 29.61529,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4946,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62865,
  //       "proposed_bridge_location_gps_longitude": 29.61529,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "5 hours",
  //       "market_access_blocked_by_river": "Vunga market opens weekly is blocked to communities of the left side, local farms on both side blocked by the river",
  //       "education_access_blocked_by_river": "Marangara primary school blocked to communities of right side of the river has",
  //       "health_access_blocked_by_river": "Nyakiriba health center blocked to communities of left side and Shyira Hospital blocked to communities of the left side of the river",
  //       "other_access_blocked_by_river": "Rutgera sector office blocked to communities of left side of the river, Adventist church of Seven days",
  //       "primary_occupations": "Local farmers(sweet potatoes , maize) and traders at Vunga market",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river flowing",
  //       "notes_on_social_information": "Vunga market (village2,5 ), Shyira Hospital (village2,5 ), Rugera secondary (village2,5), Marangara Primary school (village1,3,4) , Adventist of Seven days 7(village1,3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GsIAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagihinga",
  //       "bridge_opportunity_project_code": "1013381",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.65624,
  //       "bridge_opportunity_gps_longitude": 29.42214,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2528,
  //       "bridge_opportunity_comments": "Not Duplicate",
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65624,
  //       "proposed_bridge_location_gps_longitude": 29.42214,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "4 hour",
  //       "market_access_blocked_by_river": "Kora market open weekly , milk zone collection are blocked to communities of left side of the river",
  //       "education_access_blocked_by_river": "Rega secondary school blocked to communities of left side of the river and Ngandu Primary school blocked to communities of right side of the river",
  //       "health_access_blocked_by_river": "Arusha Health center blocked to communities of right side of the river has a",
  //       "other_access_blocked_by_river": "Arusha cell office and churches are blocked to communities of right side of the river",
  //       "primary_occupations": "This is an area mostly reserved for pasture(cattle) and Potatoes farms. Then the most common occupations in the communities are farmers and milk and seeds traders",
  //       "primary_crops_grown": "a large part of l, bean, in these communities around the bridge is specialised for farming(especially potato, is reserved for livestock (cattle ), pyreth, the l, vegetables )",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "One person died trying to cross the river when it was flooded",
  //       "notes_on_social_information": "Kora market( village 3), Arusha Health center(village 3), Milk zone collection(village 3), Rega secondary school(1,2,4), Ngandu Primary( village3), Pastures(village1,2,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2017 Population of adjacent communities include Bukinanyana",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GsNAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Busasamana",
  //       "bridge_opportunity_project_code": "1013382",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.61593,
  //       "bridge_opportunity_gps_longitude": 29.45548,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1678,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61593,
  //       "proposed_bridge_location_gps_longitude": 29.45548,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": "Kora market open twice a week is blocked to communities of right side of the river, cattle farms blocked to communities left side of the river and potatoes and vegetables farms",
  //       "education_access_blocked_by_river": "Arusha secondary school is blocked to communities of right side of the river and Ngando Primary school blocked to communities of left side",
  //       "health_access_blocked_by_river": "Arusha Health center is blocked to communities of right side and it is the only option that community has",
  //       "other_access_blocked_by_river": "Arusha cell office and churches",
  //       "primary_occupations": "Farmers( Potatoes and vegetables on large scale) and cattle farmers, traders at Koran market",
  //       "primary_crops_grown": ", bean, carrots), cattle on a large l, potato, vegetables (onion",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river",
  //       "notes_on_social_information": "Kora market(village 1,3,4), Arusha Health center(village1,3 ,4), Arusha secondary school( village 1,3,4) , Milk zone(village1,3,4 ), Pastures ( village1). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GsSAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabahendanyi",
  //       "bridge_opportunity_project_code": "1013383",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.62433,
  //       "bridge_opportunity_gps_longitude": 29.59547,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1064,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62433,
  //       "proposed_bridge_location_gps_longitude": 29.59547,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Very close to houses, and near this one down stream; another bridge is under construction",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GsXAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bwumba",
  //       "bridge_opportunity_project_code": "1013384",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.61143,
  //       "bridge_opportunity_gps_longitude": 29.57829,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3312,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61143,
  //       "proposed_bridge_location_gps_longitude": 29.57829,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Byangabo and Mburabuturo markets which are open weekly are blocked to communities of left side of the river, Gashusha market which is open weekly is blocked to communities of right side of the river",
  //       "education_access_blocked_by_river": "Mburabuturo primary school blocked to communities of left side of the river and Murungu primary and secondary school blocked to communities of left side of the river",
  //       "health_access_blocked_by_river": "Nyakiriba health center blocked to communities of left side of the river",
  //       "other_access_blocked_by_river": "Marangara cell office Rugera sector office blocked to communities of the left side of the river and Adventist of Seven days church blocked to communities of right side of the river",
  //       "primary_occupations": "Local farmers and traders at Byangabo, Mburabuturo and Gashusha markets",
  //       "primary_crops_grown": "potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died only some had fracture on their arms and legs",
  //       "notes_on_social_information": "Mburabuturo market(village1,4 ), Mburabuturo primary and secondary school(village1,4 ),Nyakiriba health center(village2,3 ), Marangara cell office(village2,3 ) . Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GscAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasayo",
  //       "bridge_opportunity_project_code": "1013385",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.61454,
  //       "bridge_opportunity_gps_longitude": 29.5842,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4424,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61454,
  //       "proposed_bridge_location_gps_longitude": 29.5842,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "1hour",
  //       "market_access_blocked_by_river": "Byangabo, Mburabuturo markets open weekly are blocked to communities of left side of the river and Gashusha market which is open weekly blocked to communities of right side of the river",
  //       "education_access_blocked_by_river": "Mburabuturo primary school blocked to communities of left side and Murungu primary and secondary school blocked to communities of right side",
  //       "health_access_blocked_by_river": "Nyakiriba health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Marangara cell and Rega sector office and Adventist of Seven days church blocked to communities of right side of the river,",
  //       "primary_occupations": "Farmers of (Potatoes, carrots ), traders at Byangabo,Mburabuturo and Gashusha markets",
  //       "primary_crops_grown": ", carrots ), maiz, potato, vegetables (cabbag",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died",
  //       "notes_on_social_information": "Gashusha mrarket(village1,3 ); Nyakiriba health center (village1,3)Murungu primary and secondary school(1,3) ;Marangara cell office(village1,3); Mburabuturo primary school (village 2,4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018 Population of adjacent communities include Nyanshundura community. Community members in Nyanshundura use this crossing to Visit relatives and accessing the cell office",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GshAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murengere",
  //       "bridge_opportunity_project_code": "1013386",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.62778,
  //       "bridge_opportunity_gps_longitude": 29.59093,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3334,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62778,
  //       "proposed_bridge_location_gps_longitude": 29.59093,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "10 m",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Vunga ,Mubayu and Gashusha markets open weekly are blocked to communities of left side of the river, farms on both sides of the river",
  //       "education_access_blocked_by_river": "Murungu primary and secondary school blocked to communities of right side",
  //       "health_access_blocked_by_river": "Rurembo health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Potable water blocked to communities of left side of the river and Catholic church blocked to communities of right side of the river",
  //       "primary_occupations": "Local farmers and traders at Vunga and Mubayo markets",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None got injured yet, they prefer to use farthest crossing during rain season",
  //       "notes_on_social_information": "Vunga and Mubayu markets open every week ( village 2,3,4) ; Murungu primary and secondary school (village 1,5) ; Catholic church (village 1,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GsmAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mucaca",
  //       "bridge_opportunity_project_code": "1013387",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.62606,
  //       "bridge_opportunity_gps_longitude": 29.60041,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1864,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62606,
  //       "proposed_bridge_location_gps_longitude": 29.60041,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Vunga and Mubayo markets open weekly are blocked to communities of left side of the river ,farms on both side of the river are blocked",
  //       "education_access_blocked_by_river": "Marangara primary and Rivera secondary school blocked to one part of communities of left side and one part of right side",
  //       "health_access_blocked_by_river": "Nyakiriba health center blocked to communities of left side of the river",
  //       "other_access_blocked_by_river": "Rugera sector office and protestant churches blocked to communities of the left side",
  //       "primary_occupations": "Local farmers and traders at Mubayo and Vunga market",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People got injuries by falling in the river due to difficult in crossing a 3 log bridge especially when the river is flooded. They injured the arms and legs but fortunately none died",
  //       "notes_on_social_information": "Mubayo market open weekly (village 2); Nyakiriba health center ( village 2) ; Rugera sector office ( village 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018 Population of adjacent communities include Murengere village . Community member in Murengere use this crossing to Visit relatives",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GsrAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "RuhigiroKibundi",
  //       "bridge_opportunity_project_code": "1013388",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.65113,
  //       "bridge_opportunity_gps_longitude": 29.49184,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 720,
  //       "bridge_opportunity_comments": "Not Duplicate",
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65113,
  //       "proposed_bridge_location_gps_longitude": 29.49184,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Always crossed all the year around, it is never flooded , the pathway is not accessible by motos",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GswAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyacyonga",
  //       "bridge_opportunity_project_code": "1013389",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.57778,
  //       "bridge_opportunity_gps_longitude": 29.47565,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4139,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.57778,
  //       "proposed_bridge_location_gps_longitude": 29.47565,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Kora market and Mukamira marke which is open every Monday and Thursday are blocked to communities of left side of the river. Potatoes and carrots farms blocked to communities on either side of the river because both side have potatoes farms . Potatoes collection zone blocked to communities of left side of the river",
  //       "education_access_blocked_by_river": "Kareba primary and secondary schools are blocked to communities of left side of the river",
  //       "health_access_blocked_by_river": "Kareba health center blocked to communities of the left side of the river",
  //       "other_access_blocked_by_river": "Catholic and Protestant churches blocked to communities of right side and Adventist of Seven days church and Kareba cell office blocked to communities of the left side of the river.",
  //       "primary_occupations": "Farmers(Potatoes and carrots are the main agriculture products in this area and main source of money to this communities), traders to Mukamira and Kora market and tourists",
  //       "primary_crops_grown": "carrot, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "All the injuries were due to slipping on existing timber bridge and fall in the river. One of those 3 had a serious injury. He got a fracture on his backbone",
  //       "notes_on_social_information": "Kora market open twice a week (village 2,3,4); Kareba health center ( village 2,3 ,4), Kareba Potatoes store/ collection zone (2,3,4), Potatoes and vegetables farms(village 1,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mtn and Air tel /tigo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Gt1AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakiriba",
  //       "bridge_opportunity_project_code": "1013390",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.63183,
  //       "bridge_opportunity_gps_longitude": 29.60816,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63183,
  //       "proposed_bridge_location_gps_longitude": 29.60816,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge needed, the land manager confirmed that the bridge is planed to be rebuilt soon",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Gt6AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruyebe-cyanika",
  //       "bridge_opportunity_project_code": "1013391",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.66123,
  //       "bridge_opportunity_gps_longitude": 29.52429,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.11",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66123,
  //       "proposed_bridge_location_gps_longitude": 29.52429,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": "Mukamira market which is open twice a week is blocked to communities of right side of the river, Tea plantations farms and potatoes farms",
  //       "education_access_blocked_by_river": "Ntarama primary and Gihira secondary school blocked to communities of right side of the river",
  //       "health_access_blocked_by_river": "Mwiyanike health center blocked to communities of right side of the river",
  //       "other_access_blocked_by_river": "Ntarama parish ,Guriro business cente",
  //       "primary_occupations": "Tea plantation workers, local farmers (Potatoes ) traders at Mukamira market",
  //       "primary_crops_grown": "potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river but fortunately none died",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7GtBAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamifumba",
  //       "bridge_opportunity_project_code": "1013415",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.46756167,
  //       "bridge_opportunity_gps_longitude": 29.55258167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4139,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46756167,
  //       "proposed_bridge_location_gps_longitude": 29.55258167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December. And it lasts for 4hours after rainfall",
  //       "market_access_blocked_by_river": "Markets, coffee factory,",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Paved road in 10km away from the proposed footbridge",
  //       "primary_occupations": "Coffee factory, farming of maize, coffee, banana",
  //       "primary_crops_grown": "banana, coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Primary school(Nyamifumba, Gitwa) Commercial center on the paved road(Nyamifumba, Muriro) Coffee factory(Nyamifumba, Muriro, Nyabubare, Munombe, Kabuga, Nzega) Health Center and Hospital of Kigeme ( Nyamifumba, Muriro) The villages of Kabuga, Nzega, Nyabubare and Muriro are crossing this river towards the coffee factory, and Primary school, health center and the hospital. Therefore their population are included in the total population to be served. The numbers of people directly served and the sorounding were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 27.5,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JCYAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Butare",
  //       "bridge_opportunity_project_code": "1013416",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.3796,
  //       "bridge_opportunity_gps_longitude": 29.6106633,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2252,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3796,
  //       "proposed_bridge_location_gps_longitude": 29.6106633,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April, May, Octeber, November and December and it lasts 4hours after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming, of coffee, sweet potatoes, banana plantation in abundance",
  //       "primary_crops_grown": ", banana, cassava, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Kids drawn when they were trying to cross the river, but they were rescued",
  //       "notes_on_social_information": "Market of Miko( Butare, Ruseke) Primary and Secondary schools(Nyagishumbu, Gaseke, Gisiza) Health Center(Ruseke, Butare) Grave for passed away people( Gisiza, Gaseke, Nyagishumbu) Government offices ( Gisiza, Gaseke, Nyagishumbu) The numbers given in this survey were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36.4,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JCdAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruseke",
  //       "bridge_opportunity_project_code": "1013417",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.372525,
  //       "bridge_opportunity_gps_longitude": 29.6006183,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2668,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.372525,
  //       "proposed_bridge_location_gps_longitude": 29.6006183,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "32 times in April, May, November and December and it lasts 4hours after rainfall",
  //       "market_access_blocked_by_river": "Market, local commercial center,",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Sector office, cell office",
  //       "primary_occupations": "Farming of cassava and coffee in abundance, Teaching, local commerce",
  //       "primary_crops_grown": "bean, cassava, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Market of Gasharu(Butare, Ruseke) Primary and Secondary schools(Butare, Ruseke, Nyagishumbu, Gisiza, Gaseke) The villages of Gasharu, and Gisiza are crossing this river every day to go to schools, Sector office. Therefore their population are included in the total population to be served. The numbers of people directly served and the sorounding communities were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 21.4,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JCiAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare",
  //       "bridge_opportunity_project_code": "1013418",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.46321833,
  //       "bridge_opportunity_gps_longitude": 29.63056167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2425,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46321833,
  //       "proposed_bridge_location_gps_longitude": 29.63056167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December and it lasts for 2 days after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health post",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of banana, maize, sweet potatoes, local commerce",
  //       "primary_crops_grown": "banana, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Market of Nyamagabe( Ruhungu, Rwabuye, Nkenke, Nyanzamura) Market of nkenke( Gatare, Nyarucyamo, Gishike, Gikomero, Kaviri) Primary and Secondary schools( Ruhungu, Rwabuye, Nkenke, Nyanzamura) Health Post ( Ruhungu, Rwabuye, Nkenke, Nyanzamura) The villages of Nkenke, Nyanzamura, Rwabuye, and Kaviri are using this crossing regularly to go to school, market s and health post that is why their people were included in the total population to be served. The numbers of people directly served and the sorounding communities were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 27.4,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JCnAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyege",
  //       "bridge_opportunity_project_code": "1013419",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.396595,
  //       "bridge_opportunity_gps_longitude": 29.549835,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2530,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.396595,
  //       "proposed_bridge_location_gps_longitude": 29.549835,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "20 times in April, May, October, and November and December and it lasts for 1hour after rainfall",
  //       "market_access_blocked_by_river": "Markets, local commercial center",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming especially cassava, beans, bananas, forest in abundance",
  //       "primary_crops_grown": "banana, bean, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Market of Kibibi (Murambi, Nyagatovu, Munyinya,) Market Rugaraga( Kanyege) Secondary school (Murambi, Nyagatovu, Munyinya,) Primary school (Kanyebe) Health Center (Murambi, Nyagatovu, Munyinya,) These numbers were given by the local people and their leaders based on the monthly census which is done in every cell. The village of Munyinya was included in the total population to be served because they use this crossing to reach the market.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 25.8,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JCxAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinyana",
  //       "bridge_opportunity_project_code": "1013420",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.37946833,
  //       "bridge_opportunity_gps_longitude": 29.54139167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2384,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37946833,
  //       "proposed_bridge_location_gps_longitude": 29.54139167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "30 times in April, May, October, November, December and it lasts 2 days after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, beans, maize",
  //       "primary_crops_grown": "banana, bean, forest of eucalyptu, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Market Kibibi(Kinyana, Karambo, Nyakizu) Market Kaduha(Kirwa, Ryingarura, Rwezamenyo, Kanyege) Primary school (Kinyana, Karambo, Nyakizu) Secondary school (Kinyana, Karambo, Nyakizu) Health Center (Kinyana, Karambo, Nyakizu) The villages of Rwezamenyo and Kanyege were included in the total population to be served because they use this crossing to access the Primary and Secondary schools, as well as the market. The numbers of people directly served and the sorounding communities were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JD7AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gikomero",
  //       "bridge_opportunity_project_code": "1013421",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": 2.442831,
  //       "bridge_opportunity_gps_longitude": 29.49934667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 0,
  //       "bridge_opportunity_comments": "BAJ confirms rejection. Technical. Slope is too steep.",
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": 2.442831,
  //       "proposed_bridge_location_gps_longitude": 29.49934667,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is no enough space for the anchor behind the RHS tower, because it close to nearby earth road and on the other side, there is a steep terrain and the slope is above 67%",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JDCAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyinya",
  //       "bridge_opportunity_project_code": "1013423",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.374415,
  //       "bridge_opportunity_gps_longitude": 29.51966667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3246,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.374415,
  //       "proposed_bridge_location_gps_longitude": 29.51966667,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "20 times April, May, October and November and it lasts 1day after rainfall",
  //       "market_access_blocked_by_river": "Market",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, sorghum, beans, cassava,",
  //       "primary_crops_grown": "bean, cassava, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Markets of Kibibi and Nyakiza( Murambi and Gataba) Primary and Secondary schools( Murambi) Health Center of Kibibi( Murambi) The villages of Nkurubuye and Gatandaganya are using this crossing regularly to access the market of Nyakiza, Therefore, their population are included in the total population to be served The numbers in this social survey were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 2.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JDMAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Zigati",
  //       "bridge_opportunity_project_code": "1013424",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.39188167,
  //       "bridge_opportunity_gps_longitude": 29.52233833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2136,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.39188167,
  //       "proposed_bridge_location_gps_longitude": 29.52233833,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 24,
  //       "flood_duration_during_rainy_season": "24 times in April, May, October, November and December and it lasts for 1day after rainfall",
  //       "market_access_blocked_by_river": "Markets",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices",
  //       "primary_occupations": "Farming of sweet potatoes, animal keeping,",
  //       "primary_crops_grown": ", bean, cassava, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Markets of Dusenyi and Kibibi ( Zigati, Nkomero) Primary and Secondary schools(Zigati, Nkomero) Health Center( Zigati, Nkomero) The numbers of this survey were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JDWAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabajogo",
  //       "bridge_opportunity_project_code": "1013425",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.48488667,
  //       "bridge_opportunity_gps_longitude": 29.57838,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4509,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.12",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.48488667,
  //       "proposed_bridge_location_gps_longitude": 29.57838,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December and it lasts for 5hours after rainfall",
  //       "market_access_blocked_by_river": "Markets, commercial center",
  //       "education_access_blocked_by_river": "Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Health Center",
  //       "other_access_blocked_by_river": "Government offices and churches",
  //       "primary_occupations": "Farming of sweet potatoes, banana and cassava, commerce, teaching",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was flown by the river during its flooding",
  //       "notes_on_social_information": "Market Nyamagabe(Gitantu, Kadoma, Kigarama(Bwama), Kamiro, Gitwa, Kigarama(kirehe)) Primary( Kabajogo, Sumba, Dusego) Secondary school(Gitantu, Kadoma) Health Center(Gitantu, Kadoma, Kigarama(Kirehe) Commercial center (Gitantu, Kadoma, Kigarama(Bwama), Kamiro, Gitwa, Kigarama(kirehe)) The villages of Kigarama(Bwama), Kamiro, Gitwa, Kigarama(Kirehe) are using this crossing regularly to access the market, secondary and primary school as well as the Health Center. Therefore, their population are included in the total population to be served. The numbers of people directly served and the sorounding communities were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 26.4,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7JDbAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muganza",
  //       "bridge_opportunity_project_code": "1013450",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -2.04927,
  //       "bridge_opportunity_gps_longitude": 29.5796,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3950,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.04927,
  //       "proposed_bridge_location_gps_longitude": 29.5796,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Vuganyana village and muganza village don't have access to NYANGE MARKET",
  //       "education_access_blocked_by_river": "Nyarusange village don't have access to vuganyana secondary school",
  //       "health_access_blocked_by_river": "Vuganyana village and muganza village don't have access to NYANGE HEALTH CENTER",
  //       "other_access_blocked_by_river": "Vuganyana village and muganza village don't have access to NYANGE sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "People walking in water",
  //       "notes_on_social_information": "Information about directly individual served are provided by Nsibo cell leader , as he referred to he population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Pq8AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiriza",
  //       "bridge_opportunity_project_code": "1013453",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -2.03409,
  //       "bridge_opportunity_gps_longitude": 29.63099,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5519,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.03409,
  //       "proposed_bridge_location_gps_longitude": 29.63099,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "15 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Nyabarongo river always floods",
  //       "market_access_blocked_by_river": "Karucura village, Bahimba village ,musange village ,Muhororo village and other village around the river from Muhanga district they don't have access to NYANGE MARKET",
  //       "education_access_blocked_by_river": "Karucura village, Bahimba village ,musange village ,Muhororo village and other village around the river from Muhanga district they don't have access to KIGALI SECONDARY SCHOOL",
  //       "health_access_blocked_by_river": "Karucura village, Bahimba village ,musange village ,Muhororo village and other village around the river from Muhanga district they don't have access to NYANGE B HEALTH CENTER",
  //       "other_access_blocked_by_river": "All peeople from Gakoma village, bugabe village ,Murambi village , nyarushubi village and other villages around river from Ngororero side they don't have access to their farms of the other side.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 12,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Boat fall in water",
  //       "notes_on_social_information": "The information of directly individual served is provided by Bambiro cell leader after calling all his village leader to confirm , they referred to the population census of 2018 .",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 125,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7PqrAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabisindu",
  //       "bridge_opportunity_project_code": "1013454",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -2.08128,
  //       "bridge_opportunity_gps_longitude": 29.61731,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4873,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08128,
  //       "proposed_bridge_location_gps_longitude": 29.61731,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 62,
  //       "flood_duration_during_rainy_season": "2 hours of floods",
  //       "market_access_blocked_by_river": "Mwunguzi village, murehe village ,nzobe village ,nyakarambi village ,kiroro village don't have access to NYANGE MARKET",
  //       "education_access_blocked_by_river": "Mwunguzi village, murehe village ,nzobe village ,nyakarambi village ,kiroro village don't have access to GROUPE SCOLAIRE VUNGU",
  //       "health_access_blocked_by_river": "Mwunguzi village, murehe village ,nzobe village ,nyakarambi village ,kiroro village don't have access to NYANGE B HEALTH CENTER",
  //       "other_access_blocked_by_river": "Dutwe village, Gaseke village , Giko village ,ngobagoba village don't have access to Kiroro church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Timbers destroyed and people fall in river because of much erosion",
  //       "notes_on_social_information": "Information of directly individual served is from Gaseke village leader and she referred to the population census of 2018 .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7PqwAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyahafi",
  //       "bridge_opportunity_project_code": "1013456",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.92556,
  //       "bridge_opportunity_gps_longitude": 29.60749,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3620,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92556,
  //       "proposed_bridge_location_gps_longitude": 29.60749,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 55,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Mwiha village, nyarutare village and Kabirizi village don't have access to RUSUMO MARKET , while cyahafi village does have access to cyabingo market",
  //       "education_access_blocked_by_river": "Mwiha village, nyarutare village and Kabirizi village don't have access to GROUPE SCOLAIRE KABIRIZI , while cyahafi village doesn't have access to GS RUHINDAGE",
  //       "health_access_blocked_by_river": "Mwiha village, nyarutare village and Kabirizi village don't have access to MUHORORO HOSPITAL",
  //       "other_access_blocked_by_river": "Cyahafi village doesn't have access to BWIRA SECTOR OFFICE",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Some farmers who were coming from their farms",
  //       "notes_on_social_information": "Jean Damsecen is the one who provided the information about directly individuals served he is the cell leader of Ruhindage , he referred to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga Ngororero",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Pr6AAE",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Kireka",
  //       "bridge_opportunity_project_code": "1013458",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.96626,
  //       "bridge_opportunity_gps_longitude": 29.57464,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4272,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.15",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.96626,
  //       "proposed_bridge_location_gps_longitude": 29.57464,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 41,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Kurushishi village, rusebeye village , nyakarambi village and gitarama village don't have access to GASHUBI MARKET , while bereshi village , Mukingi village, rwamakara village don't have access to KAYEBE MARKET .",
  //       "education_access_blocked_by_river": "bereshi village , Mukingi village, rwamakara village don't have access to GS RUSEBEYA",
  //       "health_access_blocked_by_river": "bereshi village , Mukingi village, rwamakara village don't have access to NTOBWE HEALTH CENTER , Kurushishi village, rusebeye village , nyakarambi village and gitarama village don't have access to GASHUBI HEALTH CENTER",
  //       "other_access_blocked_by_river": "Kurushishi village, rusebeye village , nyakarambi village and gitarama village don't have access to BWIRA SECTOR OFFICE",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One kids who were crossing",
  //       "notes_on_social_information": "Kabarondo cell leader provide the information about individual directly served by referring to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7PrGAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubuye",
  //       "bridge_opportunity_project_code": "1013463",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.523318,
  //       "bridge_opportunity_gps_longitude": 29.691622,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.523318,
  //       "proposed_bridge_location_gps_longitude": 29.691622,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge four kilometers away.",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "April to May, October to November, 1 hours after they can cross.",
  //       "market_access_blocked_by_river": "Communities 1&2 are blocked to Gahunga market. Communities 3&4 do not have access to Musanze market. Communities 1&2 do not have access to farms in communities 3&4 and communities 3&4 do not have access to farms in comminuties 1&2.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to Rungu primary school. Communities 3&4 are blocked to Rwaza secondary school and Rwaza primary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to Karwaza health center.",
  //       "other_access_blocked_by_river": "Communities 1&2 are blocked to kibirizi cell office. Communities 3&4 are blocked to Rwaza Catholic parish.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali~Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q4sAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakoro~muhe",
  //       "bridge_opportunity_project_code": "1013464",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.530129,
  //       "bridge_opportunity_gps_longitude": 29.631873,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2166,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.530129,
  //       "proposed_bridge_location_gps_longitude": 29.631873,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 8 hours",
  //       "market_access_blocked_by_river": "Communities 2&3 are blocked to Musanze market. Communities 1,2&3 do not have access to farms in Gakoro and nyakanama villages.",
  //       "education_access_blocked_by_river": "Communities 2&3 do not have access to Kabaya primary school and Kabaya secondary school.",
  //       "health_access_blocked_by_river": "Communities 2&3 do not have access to Muhoza health center and Ruhengeri hospital.",
  //       "other_access_blocked_by_river": "Communities 2&3 do not have access to goverment service such as sector office, district office. Communities 2&3 do not have access to churches located in Musanze city.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by cell leader, Jeanne Mukamuhire who sourced the population information from every year record of population in Ubudehe in each village. The last record done in 2018. Population of all adjacent communities includes the following villages: Gakoro, Nyakanama and Kamutara. The villages members from Gakoro and kamutara one part they cross river to do farm, or to the market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~Nyakinama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q4xAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabirehe~ Nyarubande",
  //       "bridge_opportunity_project_code": "1013466",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.548732,
  //       "bridge_opportunity_gps_longitude": 29.515524,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7753,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.548732,
  //       "proposed_bridge_location_gps_longitude": 29.515524,
  //       "current_crossing_method": "Stones",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 3 hours",
  //       "market_access_blocked_by_river": "Villages 1&4 do not have access to byangabo market. Villages 1 do not have access to kora market in nyabihu district. Villages 1,2,3&4,5 do not have access to farms.",
  //       "education_access_blocked_by_river": "Villages 4&5 do not have access to Nyabirehe primary school",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "flour, potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided was provided by Nyarubare villages leader, thadee Bahimba was sourced from every village leader which gave the population based on the register in Ubudehe program made in 2014.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q57AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakanama 2",
  //       "bridge_opportunity_project_code": "1013467",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.527581,
  //       "bridge_opportunity_gps_longitude": 29.62739,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2786,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.527581,
  //       "proposed_bridge_location_gps_longitude": 29.62739,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Communities 1&2 do not have access to Musanze market. Communities 1&2 do not have access to farms in Gakoro and kamutara villages. Communities 3&4 are blocked to farms in village 1&2.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to Kabaya primary school and Kabaya secondary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to cyivugiza dispensary, Muhoza health center and Ruhengeri hospital.",
  //       "other_access_blocked_by_river": "Communities 1&2 are blocked to goverment service such as sector office and district office. People from communities 1&2 are blocked to churches in Muko center and Musanze city.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, maiz, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and fractured",
  //       "notes_on_social_information": "Population information of each village was provided by cell leader, Jeanne Mukamuhire who sourced the population information from every year record of population in Ubudehe in the villages. The last record done in 2018. Population of all adjacent communities includes the following villages: Gakoro, Nyakanama and Kamutara. The villages members from Gakoro and kamutara one part they cross river to do farm, or to the market and visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Nyakinama~Musazne",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5CAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakanama 1",
  //       "bridge_opportunity_project_code": "1013468",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.532046,
  //       "bridge_opportunity_gps_longitude": 29.62881,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2786,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.532046,
  //       "proposed_bridge_location_gps_longitude": 29.62881,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Villages 1&2 do not have access to Musanze market. Communities 1&2 are blocked to farms in Gakoro and Kamutara communities. Communities 3&4 are blocked to the farms in Nyakanama and Buhor0 communities.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to Kabaya primary school and Kabaya secondary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 are blocked to Muhoza health center and Ruhengeri hospital.",
  //       "other_access_blocked_by_river": "Villages 1&2 do not have access to Muko Sacco and district office. Communities members from villages 1&2 do not have access to churches in Muko center and Musanze city.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by cell leader, Jeanne Mukamuhire who sourced the population information from every year record of population in Ubudehe in the villages. The last record done in 2018. Population of all adjacent communities includes the following villages: Gakoro, Nyakanama, buhoro and Kamutara. The villages members from Gakoro and kamutara one part they cross river to do farm, or to the market and sometimes to visit the relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Nyakinama~Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5HAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakoro 2 ~ Rwebeya",
  //       "bridge_opportunity_project_code": "1013469",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.529524,
  //       "bridge_opportunity_gps_longitude": 29.633423,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2166,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.529524,
  //       "proposed_bridge_location_gps_longitude": 29.633423,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 12 hours",
  //       "market_access_blocked_by_river": "The river is flowing though Gakoro and Kamutara villages so one part of Gakoro and Kamutara plus communities members from nyakanama do not have access to Musanze market. The same the villages 1,2 &3 do not have access to farms in each side of river.",
  //       "education_access_blocked_by_river": "Communities (1&2 one part) & nyakanama do not have access to Kabaya primary school and Kabaya secondary school.",
  //       "health_access_blocked_by_river": "Communities (1&2 one part) & nyakanama do not have access to Muhoza health center and Ruhengeri hospital.",
  //       "other_access_blocked_by_river": "Communities (1&2 one part) & nyakanama do not have access to goverment service district office, Muko Sacco( savings and credit cooperative). Communities (1&2 one part) & nyakanama do not have access to Muko bus stop.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": ", bean",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by cell leader, Jeanne Mukamuhire who sourced the population information from every year record of population in Ubudehe in the villages. The last record done in 2018. Population of all adjacent communities includes the following villages: Gakoro, Nyakanama and Kamutara. The villages members from Gakoro and kamutara one part they cross river to do farm, or to the market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Nyakinama~ Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 63,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5MAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bunyereri",
  //       "bridge_opportunity_project_code": "1013470",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.477522,
  //       "bridge_opportunity_gps_longitude": 29.714723,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6737,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.477522,
  //       "proposed_bridge_location_gps_longitude": 29.714723,
  //       "current_crossing_method": "Stones",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "March, April to May, September to November, 1 week without crossing.",
  //       "market_access_blocked_by_river": "Communties 1,2 &3 do not have access to Nyanga market ,rugarama market and gahunga market. Communities 3&4 are blocked to gasakuza market and nyirabisekuru animals market.communities 3&4 do not have access to Musanze market. Communities 1,2&3 are blocked to farms in Burera and communities 3&4 are blocked to farms in Gakoro cell.",
  //       "education_access_blocked_by_river": "Communities 1,2&3 are blocked to nkombo primary school. Communities 1,2&3 are blocked to nyanga secondary school. Communities 3&4 do not have access to Gakoro secondary school.",
  //       "health_access_blocked_by_river": "Communities 1,2&3 do not have access to kinoni health center in Burera.",
  //       "other_access_blocked_by_river": "Communities 1,2&3 do not have access to kinoni Catholic church,",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Gakoro leader, Mukankusi Eugenie who sourced them from the cell register done in 2017. The population of all adjacent communities includes the following villages: Murora, cyivugiza, Nkomero, cyiri, Cyanya and Gasenyi.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5RAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kidendezi",
  //       "bridge_opportunity_project_code": "1013471",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.47301,
  //       "bridge_opportunity_gps_longitude": 29.53233,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3926,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.47301,
  //       "proposed_bridge_location_gps_longitude": 29.53233,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "April to May, October to November, they can cross year round except that the timber is too old, it can cause the injuries.",
  //       "market_access_blocked_by_river": "Communities1, 2&5 do not have access to nyiragihema market In shingiro sector. Communities 3&4 are blocked to kinigi market. Communities 1,2,34,&5 are blocked to farms.",
  //       "education_access_blocked_by_river": "Communities 1,2&5 are blocked to Nyamurimirwa primary school and secondary school. Communities 3&4 do not have access to Susa 1 primary school.",
  //       "health_access_blocked_by_river": "Communities 3&4 do not have access to Gisate health center and Kabazungu dispensary.",
  //       "other_access_blocked_by_river": "Communities 1,2&5 are blocked to ADPER church in kidendezi village.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, onion, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and fractured the arm.",
  //       "notes_on_social_information": "Population information of each village was provided by kabazungu cell leader, Zirimabagabo Alphonse who sourced the population information from cell register done in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kinigi~kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5WAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rufugwe",
  //       "bridge_opportunity_project_code": "1013472",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.543877,
  //       "bridge_opportunity_gps_longitude": 29.546123,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5767,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.543877,
  //       "proposed_bridge_location_gps_longitude": 29.546123,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "0.7 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "April to May, October to December, 6hours after rainfall they can cross.",
  //       "market_access_blocked_by_river": "Communities 1&2 do not have access to byangabo market. Communities 1&2 are blocked to to farm in Manjali. Communities 3&4 do not have access to farms in Rukingo.",
  //       "education_access_blocked_by_river": "Communities 3&4 do not have access to Rurambu primary school. Communities 1&2 do not have access to Busogo secondary school, Busogo Vocational training center, Busogo primary school and Busogo university of Rwanda.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to Busogo health center. Communities 3&4 do not have access to Gataraga health center.",
  //       "other_access_blocked_by_river": "Communities 3&4 are blocked to sector office, communities 3&4 are blocked to churches in Gataraga center, communities 1&2 are blocked to Catholic church in Busogo.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato, tre, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by given by Rukingo village leader, Pasific Rwamirora who sourced the population information from each village leader from which register done in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5bAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamiyaga",
  //       "bridge_opportunity_project_code": "1013473",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.43056,
  //       "bridge_opportunity_gps_longitude": 29.624836,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1510,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. There is an alternate all weather crossing less than 300m away and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.43056,
  //       "proposed_bridge_location_gps_longitude": 29.624836,
  //       "current_crossing_method": "Timber brigde in 120m away",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "April to May, November, 2hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~kinigi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The nearest crossing is less than 300m (m)",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5gAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kavumu",
  //       "bridge_opportunity_project_code": "1013474",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.596674,
  //       "bridge_opportunity_gps_longitude": 29.658056,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2488,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.596674,
  //       "proposed_bridge_location_gps_longitude": 29.658056,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "April to May, November and December, 12 hours",
  //       "market_access_blocked_by_river": "Communities 3 & 4 do not have access to the Musanze market, communities 1, 2, 3, &4 do not have access to the farms.",
  //       "education_access_blocked_by_river": "Communities 1& 2 do not have access to Nyundo primary and secondary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to the health center ( Nyundo)",
  //       "other_access_blocked_by_river": "Communities 1&2 do not have access to adventist church in Nyundo.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, sugar can, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided was provided by Gisorora villages leader who called every communities leader to tell the population in the village. The population data was sourced in the record villages leader do after one year, the data for now is in 2018. Population of all adjacent communities includes: kavumu, Gisorora, Tane and Murori.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~nyakinama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5lAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagatoki",
  //       "bridge_opportunity_project_code": "1013489",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.43466,
  //       "bridge_opportunity_gps_longitude": 29.6722,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 902,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.43466,
  //       "proposed_bridge_location_gps_longitude": 29.6722,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Buhoro and nyagahondo are blocked to Market",
  //       "education_access_blocked_by_river": "Buhoro and nyagahondo are blocked to secondary schools, and Buhoro is blocked to the primary",
  //       "health_access_blocked_by_river": "Buhoro and nyagahondo are blocked to Health center",
  //       "other_access_blocked_by_river": "Buhoro and nyagahondo are blocked to library, sector office, churches,",
  //       "primary_occupations": "School, ma4ket, farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Nyagatoki",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9IAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhehe",
  //       "bridge_opportunity_project_code": "1013475",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.535683,
  //       "bridge_opportunity_gps_longitude": 29.745093,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1352,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. The current crossing seems to be sufficient and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.535683,
  //       "proposed_bridge_location_gps_longitude": 29.745093,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "April to, October and November, 1hour after rainfall they can cross",
  //       "market_access_blocked_by_river": "Remera market ( villages 1,2), murwa market (villages 3,4), farms (villages 1,2,3,4)",
  //       "education_access_blocked_by_river": "Gashaki primary school, gashaki seconday school(villages 1,2), Ryandinzi primary and secondary school(3,4)",
  //       "health_access_blocked_by_river": "Gashaki health center ( villages 3,4)",
  //       "other_access_blocked_by_river": "Churches such Ryandinzi Catholic church, seventh adventist, and ADEPR(villages 3,4), gashaki sector office (villages 3,4)",
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell in water and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by Harerimana celestin who sourced the population from cell data collected in 2017. Population of all adjacent communities includes:",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They have raised the bridge now they can cross year round",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 1.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q5qAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakoro 1",
  //       "bridge_opportunity_project_code": "1013478",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.527416,
  //       "bridge_opportunity_gps_longitude": 29.631312,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2166,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.527416,
  //       "proposed_bridge_location_gps_longitude": 29.631312,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "April, May, October to December, 6 hours",
  //       "market_access_blocked_by_river": "Communities 2&3 do not have access to Musanze market, communities 1,2,&3 are blocked to farms in Bali to villages.",
  //       "education_access_blocked_by_river": "Communities 2&3 are blocked to Kabaya primary school and Kabaya secondary school.",
  //       "health_access_blocked_by_river": "Communities 2&3 are blocked to Ruhengeri hospital, Muhoza health center and Kivumu dispensary.",
  //       "other_access_blocked_by_river": "Communities 2&3 are blocked to musanze district office and muko sector office, communities 2&3 are blocked to to the churches in Musanze city.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided cyivugiza cell leader, Mukamuhire Jeanne who sourced the population information from cell register done in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze~Nyakinama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q65AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kurimurora",
  //       "bridge_opportunity_project_code": "1013480",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.494191,
  //       "bridge_opportunity_gps_longitude": 29.715385,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1110,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. There is an alternate crossing less than 300m away and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.494191,
  //       "proposed_bridge_location_gps_longitude": 29.715385,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "300 m",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "April to May, September to November, 6 hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The nearest all weather crossing is less than 300m",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 3.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q6FAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuye",
  //       "bridge_opportunity_project_code": "1013481",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Musanze",
  //       "bridge_opportunity_gps_latitude": -1.577664,
  //       "bridge_opportunity_gps_longitude": 29.654812,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 567,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Vehicular bridge desired and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.577664,
  //       "proposed_bridge_location_gps_longitude": 29.654812,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "April, May, November, the cross every time",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge, they cross year round, dam",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q6KAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubona",
  //       "bridge_opportunity_project_code": "1013482",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.73310167,
  //       "bridge_opportunity_gps_longitude": 29.57745167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4633,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.73310167,
  //       "proposed_bridge_location_gps_longitude": 29.57745167,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April, May, November and December and it lasts 4hours after rainfall",
  //       "market_access_blocked_by_river": "Rubona, Akagera, Ruseke, Coko Gitara villages don't have access to Market of Viro Coko, Gitara don't have access to the In River project for tea plantation",
  //       "education_access_blocked_by_river": "Rubona village don't have access to Mirabyo Secondary school",
  //       "health_access_blocked_by_river": "Rubona, Ngeri, Akagera villages and Ngeri cell don't have access to Coko Health Center Coko, Gitara villages don't have access to Hospital of Munini",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of tea, banana, sweet potatoes,",
  //       "primary_crops_grown": "banana, bean, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He was flown by the river while trying to walk in the river",
  //       "notes_on_social_information": "The social survey were conducted based on the information given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 116.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q8FAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutega",
  //       "bridge_opportunity_project_code": "1013483",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.735675,
  //       "bridge_opportunity_gps_longitude": 29.59105333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4776,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.735675,
  //       "proposed_bridge_location_gps_longitude": 29.59105333,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October, November and December and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Rubona, Akagera, Ruseke, Coko, Gitara villages don't have access to Viro Market",
  //       "education_access_blocked_by_river": "Rutega village doesn't have access to Mirabyo Primary school",
  //       "health_access_blocked_by_river": "Rutega village doesn't have access to Coko Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of beans, animal keeping,",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Akagera village uses this crossing regularly and their people were included in the total population to be served. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 65.8,
  //       "height_differential_between_banks": 3.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q8KAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Resume (kwa Frederick)",
  //       "bridge_opportunity_project_code": "1013484",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.37445,
  //       "bridge_opportunity_gps_longitude": 29.80846,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1892,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.37445,
  //       "proposed_bridge_location_gps_longitude": 29.80846,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge four kilometers away",
  //       "days_per_year_river_is_flooded": 196,
  //       "flood_duration_during_rainy_season": "Seven days",
  //       "market_access_blocked_by_river": "Gitoma and part of Gatare are blocked to the Market and farms are on both side,",
  //       "education_access_blocked_by_river": "Gitoma and part of Gatare are blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "Gitoma and part of Gatare are blocked to the health center",
  //       "other_access_blocked_by_river": "Gitoma and part of Gatare are blocked to the bank, business centers, churches, football terrain and cell and sector office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They was trying to cross the river when it was flooded and fell into river",
  //       "notes_on_social_information": "Community leaders of Gatare and numbers given by all communities leaders of the nearby",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q8jAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karunga",
  //       "bridge_opportunity_project_code": "1013487",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.38143,
  //       "bridge_opportunity_gps_longitude": 29.81682,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1714,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.38143,
  //       "proposed_bridge_location_gps_longitude": 29.81682,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Ndabizi is blocked to market and business center,",
  //       "education_access_blocked_by_river": "Ndabizi is blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Ndabizi is blocked to Health center",
  //       "other_access_blocked_by_river": "Ndabizi is blocked to bank, churches, cell and sector office",
  //       "primary_occupations": "School, Market, bank, health center",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Kabingo and people who was crossing river, and numbers given by all communities leaders of nearby",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q98AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ku mashuri ya GSNDM Carmel Gahunga",
  //       "bridge_opportunity_project_code": "1013488",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.45014,
  //       "bridge_opportunity_gps_longitude": 29.67945,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3119,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.45014,
  //       "proposed_bridge_location_gps_longitude": 29.67945,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "150 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Never flooded but it is big ditch",
  //       "market_access_blocked_by_river": "Two part of Rusenyi and Mubuga and bahenda are blocked to market",
  //       "education_access_blocked_by_river": "Two part of Rusenyi and Mubuga and bahenda are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Two part of Rusenyi and Mubuga are blocked to post health center",
  //       "other_access_blocked_by_river": "Two part of Rusenyi and Mubuga and bahenda are blocked to churches,",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They were trying to river and felt into and being injured",
  //       "notes_on_social_information": "Community leaders of mubuga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9DAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Twagira",
  //       "bridge_opportunity_project_code": "1013490",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.46467,
  //       "bridge_opportunity_gps_longitude": 29.74894,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1519,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Vehicular bridge needed and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.46467,
  //       "proposed_bridge_location_gps_longitude": 29.74894,
  //       "current_crossing_method": "Timbe",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 72,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Nyarubuye, Shenyi and Kigina are blocked to the Market",
  //       "education_access_blocked_by_river": "Nyarubuye, Shenyi and Kigina are blocked to secondary schools and Nyarubuye, Shenyi are blocked to primary school",
  //       "health_access_blocked_by_river": "Nyarubuye, Shenyi and Kigina are blocked to health center",
  //       "other_access_blocked_by_river": "Nyarubuye, Shenyi are blocked to churches, Hotel, sector office",
  //       "primary_occupations": "Market, farms, school",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "She was trying to cross the bridge when the bridge was old and fell into river",
  //       "notes_on_social_information": "Community leaders of shenyi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need a bridge, but it on the road and it was used by car by car five years ago",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9NAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ku mashuri ya karangara",
  //       "bridge_opportunity_project_code": "1013492",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.42212,
  //       "bridge_opportunity_gps_longitude": 29.70465,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3255,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.42212,
  //       "proposed_bridge_location_gps_longitude": 29.70465,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in one kilometer away",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Karutwe and Gahama are blocked to the Market",
  //       "education_access_blocked_by_river": "Garza, Nyabizi, busura and muhabura are blocked to primary school and Karutwe and Gahama are blocked to the secondary school",
  //       "health_access_blocked_by_river": "Karutwe and Gahama are blocked to the health center",
  //       "other_access_blocked_by_river": "Karutwe and Gahama are blocked to the sector office",
  //       "primary_occupations": "School, farms, church",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He was trying to cross the bridge during the night and he didn't know that the bridge was destroyed that day and felt in to ditch",
  //       "notes_on_social_information": "Community leaders of Gasiza and numbers given by all communities leaders of the nearby",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze To Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9XAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugeshi",
  //       "bridge_opportunity_project_code": "1013493",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.38299,
  //       "bridge_opportunity_gps_longitude": 29.71278,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2398,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.38299,
  //       "proposed_bridge_location_gps_longitude": 29.71278,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 72,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Gahama and one part of Mugeshi is blocked to the Market",
  //       "education_access_blocked_by_river": "Gahama and one part of Mugeshi is blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "Gahama and one part of Mugeshi is blocked to the health center",
  //       "other_access_blocked_by_river": "Gahama and one part of Mugeshi is blocked to the cell and sector office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They was trying to cross the bridge and the timber was broken and they felt in to ditch",
  //       "notes_on_social_information": "Community leaders of Mugeshi and people who live closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9cAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Shaga",
  //       "bridge_opportunity_project_code": "1013494",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.34705,
  //       "bridge_opportunity_gps_longitude": 29.82387,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2267,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.34705,
  //       "proposed_bridge_location_gps_longitude": 29.82387,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "Two day",
  //       "market_access_blocked_by_river": "Kavumu and Shaga are blocked to the Market",
  //       "education_access_blocked_by_river": "Kavumu and Shaga are blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "Kavumu and Shaga are blocked to the health center",
  //       "other_access_blocked_by_river": "Kavumu and Shaga are blocked to the cell office and sector, to the churches,",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "It was raining and He crossed the river and they did not found him",
  //       "notes_on_social_information": "Cell leader of Rutovu",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9hAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Cosma",
  //       "bridge_opportunity_project_code": "1013495",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.32782,
  //       "bridge_opportunity_gps_longitude": 29.83106,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1854,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.32782,
  //       "proposed_bridge_location_gps_longitude": 29.83106,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Nyabizi 1,2,3 are blocked to the Market",
  //       "education_access_blocked_by_river": "Nyabizi 1,3 and part of 2 are blocked to primary school and all Nyabizi are blocked to secondary schools",
  //       "health_access_blocked_by_river": "Nyabizi 1,2 3 are blocked to Health center",
  //       "other_access_blocked_by_river": "Nyabizi 1,2,3 are blocked to cell and sector office, churches,",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Umugore bari bahetse mu ngombu",
  //       "notes_on_social_information": "Community leaders of Nyabizi 1",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 72,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9mAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubuye",
  //       "bridge_opportunity_project_code": "1013497",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.46659,
  //       "bridge_opportunity_gps_longitude": 29.74716,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1519,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.46659,
  //       "proposed_bridge_location_gps_longitude": 29.74716,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Kigina and nyarubuye are blocked to the Market",
  //       "education_access_blocked_by_river": "Kigina and nyarubuye is blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Kigina and nyarubuye is blocked to Health center",
  //       "other_access_blocked_by_river": "Kigina and nyarubuye is blocked to business center, churches, cell office",
  //       "primary_occupations": "Marker, school, farm",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He was trying to cross the bridge when it was flooded and fell into river",
  //       "notes_on_social_information": "Community leaders of nyarubuye",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7Q9wAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muranbo",
  //       "bridge_opportunity_project_code": "1013498",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.36675,
  //       "bridge_opportunity_gps_longitude": 29.80889,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2942,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.36675,
  //       "proposed_bridge_location_gps_longitude": 29.80889,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 72,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by community leader Murambo 0781772134 Munyankindi Evariste",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is vehicular bridge and there is another one 500 meters away",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 17,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QA1AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buharo",
  //       "bridge_opportunity_project_code": "1013499",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.45314,
  //       "bridge_opportunity_gps_longitude": 29.73895,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 902,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.45314,
  //       "proposed_bridge_location_gps_longitude": 29.73895,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of nyagatoki",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded the whole day, it takes only hours of rain",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 14,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QA6AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa ntawitonderisi",
  //       "bridge_opportunity_project_code": "1013500",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.46061,
  //       "bridge_opportunity_gps_longitude": 29.74088,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1241,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Should be a vehicular bridge and the river is likely too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.46061,
  //       "proposed_bridge_location_gps_longitude": 29.74088,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nyarurembo is blocked to the Market",
  //       "education_access_blocked_by_river": "Nyarurembo is blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Nyarurembo is blocked to Health center",
  //       "other_access_blocked_by_river": "Nyarurembo is blocked to churches, cell and sector office, bank and business center",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the community leader of Kabaya",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze to Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It supossed to be vehicular bridge but now they they need bridge to help them to cross",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QABAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasumo",
  //       "bridge_opportunity_project_code": "1013501",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.33816,
  //       "bridge_opportunity_gps_longitude": 29.81862,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2889,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.16",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.33816,
  //       "proposed_bridge_location_gps_longitude": 29.81862,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "After three hours",
  //       "market_access_blocked_by_river": "Rubaya, Nyabizi, people from Uganda are blocked to the Market",
  //       "education_access_blocked_by_river": "Rubaya and Nyabizi 1 are blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Rubaya and Nyabizi 1 are blocked to Health center",
  //       "other_access_blocked_by_river": "Rubaya and Nyabizi 1 are blocked to churches, cell and sector office,",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Rubayu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Cyanika",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QAGAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kajinja",
  //       "bridge_opportunity_project_code": "1014280",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.0264,
  //       "bridge_opportunity_gps_longitude": 29.85626,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2858,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0264,
  //       "proposed_bridge_location_gps_longitude": 29.85626,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "Four hours",
  //       "market_access_blocked_by_river": "Musambira market",
  //       "education_access_blocked_by_river": "Musambira health center",
  //       "health_access_blocked_by_river": "Musambira high school",
  //       "other_access_blocked_by_river": "Musambira church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Karengera dont have access to musambira market Information gathered from cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 74,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekgCAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyiramana",
  //       "bridge_opportunity_project_code": "1013502",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.48655,
  //       "bridge_opportunity_gps_longitude": 29.65746,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1865,
  //       "bridge_opportunity_comments": "BAJ Good Site.",
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.48655,
  //       "proposed_bridge_location_gps_longitude": 29.65746,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "In April and May it last for It last for 6 hours.",
  //       "market_access_blocked_by_river": "Nyangazi and Rugogwe Markets (Community 1,2); Birambo and Nkeke Markets (Community 3,4); Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "Birambo Primary School (Community 3,4)",
  //       "health_access_blocked_by_river": "No health access blocked.",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cabbag, maiz, potato, rice.",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many people (more than 100) fall into the river and they get rescued before drowning.",
  //       "notes_on_social_information": "Population information for each village was provided by the Gishehe Cell Leader, Vincent Mporanimana, from the data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR10 (Huye - Nyamagabe)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QQOAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyendajuru",
  //       "bridge_opportunity_project_code": "1013503",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.51947,
  //       "bridge_opportunity_gps_longitude": 29.6697,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2542,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.51947,
  //       "proposed_bridge_location_gps_longitude": 29.6697,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "It last for 3 hours",
  //       "market_access_blocked_by_river": "Amasimbi maize factory (Community 1,2,3), Maraba Coffee washing station (Community 4,5)",
  //       "education_access_blocked_by_river": "Simbi Primary and Secondary School and Jean Bosco Secondary (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Simbi Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Simbi Catholic Parish, EER Church (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, coffee., maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "Many people fall into the river at the crossing point, the death incident that occurred was a child who fell into the river and drowned.",
  //       "notes_on_social_information": "Population information for each village was provided by the Kigarama Village Leader, Namagabo Eric, Cyendajuru and Rwatsi Village Leaders , from the data collected in 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Road Huye Town - Nyamagabe District",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QQTAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mariza",
  //       "bridge_opportunity_project_code": "1013504",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.51052,
  //       "bridge_opportunity_gps_longitude": 29.70255,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1178,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.51052,
  //       "proposed_bridge_location_gps_longitude": 29.70255,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Rusuma and Rugogwe Markets (Community 2), Cyizi Market (Community 1), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Ndago primary and Kabusanza Primary and Secondary School (Community 2)",
  //       "health_access_blocked_by_river": "Kabusanza Health Post (Community 2)",
  //       "other_access_blocked_by_river": "Kabusanza Catholic church and Kabusanza Cell office (Community 2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rusuma and Mariza village were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. The population information for each village was provided by the Kabusanza Cell Leader, Francois, from the data collected in early 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QQYAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasekebuye",
  //       "bridge_opportunity_project_code": "1013505",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.63019,
  //       "bridge_opportunity_gps_longitude": 29.71337,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3254,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.63019,
  //       "proposed_bridge_location_gps_longitude": 29.71337,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 4,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours.",
  //       "market_access_blocked_by_river": "Busoro Market (Community 4,5), Muyogoro and Huye Town Markets (Community 1,2), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Ryakibogo Primary and Secondary School, Vumbi Secondary School (Community 1,2)",
  //       "health_access_blocked_by_river": "Kiduha Health Center and University Hospital of Butare (Community 1,2)",
  //       "other_access_blocked_by_river": "Ryakibogo Catholic, Adventist and ADEPR Churches, Ryakibogo Cell Office (Community 1,2), Gishamvu sector office (Community 3,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, pea, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gasekebuye, Rwimbogo, Gitwa, Kidahire, Gakombe and Mpinga village were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. The population information for each village was provided by the Ryakibogo Cell Leader, Innocent Gakwandi, from the data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QQdAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiduha",
  //       "bridge_opportunity_project_code": "1013506",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.61005,
  //       "bridge_opportunity_gps_longitude": 29.69215,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2141,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.61005,
  //       "proposed_bridge_location_gps_longitude": 29.69215,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Matyazo and Huye Town Markets (Community 1,2)",
  //       "education_access_blocked_by_river": "Kiduha Primary School and Vumbi Primary and Secondary School (Community 3,4)",
  //       "health_access_blocked_by_river": "Kiduha Health Center (Community 3,4)",
  //       "other_access_blocked_by_river": "Potable water, Nazareth Church (Community 3,4), Ngoma Catholic Parish (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kiduha, Rwaza, Rwinkoni and Nyarutovu villages were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. The population information for each village was provided by the Ryakibogo Cell Leader, Innocent Gakwandi, from the data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QQiAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamapfunda",
  //       "bridge_opportunity_project_code": "1013507",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.63352,
  //       "bridge_opportunity_gps_longitude": 29.62583,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2832,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.63352,
  //       "proposed_bridge_location_gps_longitude": 29.62583,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Rugarika and Ndago Markets (Community 1,2,3); Farms (All Communities )",
  //       "education_access_blocked_by_river": "Kabirizi Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Kabirizi Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Kabirizi Catholic, Adventist and Jehovah Witnesses churches (Community 1,2,3); Karama Catholic Parish (Community 4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maize., potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "More than 100 people. At least one person per week fall into the river by the timber bridge, mostly children going or coming to/from Kabirizi school.",
  //       "notes_on_social_information": "The population information for each village was provided by the Buhoro Cell Leader Byukusenge Clementine, the data collected in 2018. This crossing point is mainly used by children going or coming to/from Kabirizi School.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QQnAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyumba",
  //       "bridge_opportunity_project_code": "1013508",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.66388,
  //       "bridge_opportunity_gps_longitude": 29.69276,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5654,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.66388,
  //       "proposed_bridge_location_gps_longitude": 29.69276,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Busoro Market, BPR Bank, Ingeri SACCO Saving Gishamvu(Community 1,2,3,4), Farms (Community 5)",
  //       "education_access_blocked_by_river": "Petit Seminaire, College Notre Dame du Rosaire, Nyumba Primary and Secondary School (Community 1,2,3,4)",
  //       "health_access_blocked_by_river": "Busoro - Gishamvu Health Center (Community 1,2,3,4)",
  //       "other_access_blocked_by_river": "Gishamvu Sector, Nyumba ADEPR church, Nyumba Catholic Parish (Community 1,2 3,4)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "Many people fall into the river at the current crossing point but no serious injuries or death by river crossing.",
  //       "notes_on_social_information": "Busoro, Cyambwe, Kabeza, Rebero, Umunyinya, Gishamvu, Nyagatama and Gasyankingi villages were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. The population information for each village was provided by the Nyumba Cell Leader, Jean Paul Karanganwa, from the data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QSoAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatongati",
  //       "bridge_opportunity_project_code": "1013509",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.58804,
  //       "bridge_opportunity_gps_longitude": 29.67228,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 979,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.58804,
  //       "proposed_bridge_location_gps_longitude": 29.67228,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 7,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours.",
  //       "market_access_blocked_by_river": "Mpungwe, Muyogoro, Huye, Matyazo and Gako Markets (Community 1,2), Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "Mpungwe Primary and Secondary School and Kibingo School (Community 1,2)",
  //       "health_access_blocked_by_river": "Nyakagezi Health Center (New) and Huye Health Center (Community 1,2)",
  //       "other_access_blocked_by_river": "Nyakagezi Cell, Ngoma Catholic Parish, Methodist church (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cabbag, maize., potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The population information for each village was provided by the Gatongati Village Leader, Manirabaruta Markiadi, from the data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QStAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinyamaganga",
  //       "bridge_opportunity_project_code": "1013510",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Huye",
  //       "bridge_opportunity_gps_latitude": -2.61104,
  //       "bridge_opportunity_gps_longitude": 29.65406,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3800,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.17",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.61104,
  //       "proposed_bridge_location_gps_longitude": 29.65406,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Karama and Busoro Markets (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Karama Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Karama Health Center (Community 1,2 3)",
  //       "other_access_blocked_by_river": "Karama Sector office, Karama Catholic Parish, ADEPR and Adventist Churches (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, beans., maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Zaga, Agatovu and Gasharu villages were included in Individuals Directly Served, because community members of these villages use this crossing point to go to markets, churches, schools and health centers. Muyange and Butare villages use the crossing point to visit relatives. The population information for each village was provided by the Zaga Village Leader, Nyandwi Innocent and other village leaders,from the data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7QTXAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubambira",
  //       "bridge_opportunity_project_code": "1013540",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Ngororero",
  //       "bridge_opportunity_gps_latitude": -1.82053,
  //       "bridge_opportunity_gps_longitude": 29.54759,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4403,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.82053,
  //       "proposed_bridge_location_gps_longitude": 29.54759,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "8 hours of flood",
  //       "market_access_blocked_by_river": "Buhuma vilkage , gashiki village , kantobo village dont have acess to Kabaya market , while rubambiro village , bukonde village, and nyabirinda village don't have access to BIREMBO MARKET.",
  //       "education_access_blocked_by_river": "rubambiro village , bukonde village, and nyabirinda village don't have access to Kavumu secondary school",
  //       "health_access_blocked_by_river": "Buhuma vilkage , gashiki village , kantobo village dont have acess to Kabaya hospital",
  //       "other_access_blocked_by_river": "rubambiro village , bukonde village, and nyabirinda village don't have access to ADEPR Kavumu",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "A student coming from school with his bags",
  //       "notes_on_social_information": "Sedo mwendo cell provided the info for individual served by referring to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngororero",
  //       "name_of_nearest_paved_or_sealed_road": "Muhanga - Mukamira",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ayRAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubuye",
  //       "bridge_opportunity_project_code": "1013543",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.10774,
  //       "bridge_opportunity_gps_longitude": 29.42038,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4304,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10774,
  //       "proposed_bridge_location_gps_longitude": 29.42038,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 84,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Gasayo village and Nyarubuye village don't have access to Gitaka market.",
  //       "education_access_blocked_by_river": "Gasayo village and Nyarubuye village don't have access to GS Kirambo",
  //       "health_access_blocked_by_river": "Gasayo village and Nyarubuye village don't have access to Kirambo health center",
  //       "other_access_blocked_by_river": "Gasayo village and Nyarubuye village don't have access to Gitesi Catholic Church , while gahigiro village ,nyarucyamo village and munanira village don't have access to Nyarubuye Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "People fall in the river",
  //       "notes_on_social_information": "Munanira cell leader was there to give me information about direct individual served by the bridge , he referred to the population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi _ Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ayvAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamuhenja",
  //       "bridge_opportunity_project_code": "1013544",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.1067,
  //       "bridge_opportunity_gps_longitude": 29.42296,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2530,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1067,
  //       "proposed_bridge_location_gps_longitude": 29.42296,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Muvungu village, and nyamiyaga village dont have access to Gitaka market",
  //       "education_access_blocked_by_river": "Muvungu village, and nyamiyaga village dont have access to Kirambo secondary school",
  //       "health_access_blocked_by_river": "Muvungu village, and nyamiyaga village dont have access to Kirambo health",
  //       "other_access_blocked_by_river": "Transportation of tea from right side to the left side of the river at Gahizi tea factory is blocked by the river , the tea factory is at left side while the tea fields is at right ,and also Muvungu village, and nyamiyaga village dont have access to EAR Kirambo",
  //       "primary_occupations": "Farming , coffee factory of Gahizi Alex",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "People coming from Gitaka center , two women died and one man survived",
  //       "notes_on_social_information": "Ruhinga cell leader provided the information about directly individual served , he called all village leader that their population served by the bridge to confirm their number of population who are using it , they referred to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi -muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7az0AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukombe",
  //       "bridge_opportunity_project_code": "1013545",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.11248,
  //       "bridge_opportunity_gps_longitude": 29.42269,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4514,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11248,
  //       "proposed_bridge_location_gps_longitude": 29.42269,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 115,
  //       "flood_duration_during_rainy_season": "4 days of flood",
  //       "market_access_blocked_by_river": "Nyarubuye village ,gasayo village, muramba village , nyabikate villagee and rugomfo vilkage dont have acess to Kibirizi market",
  //       "education_access_blocked_by_river": "Nyarubuye village ,gasayo village, muramba village , nyabikate villagee and rugomfo vilkage dont have acess to GS Kirambo",
  //       "health_access_blocked_by_river": "Nyarubuye village ,gasayo village, muramba village , nyabikate villagee and rugomfo vilkage dont have acess to Kirambo health center",
  //       "other_access_blocked_by_river": "Kinama village , kirambo village , gahigiro village dont have acess to ADEPR Nyarubuye while Nyarubuye village ,gasayo village, muramba village , nyabikate villagee and rugomfo vilkage dont have acess to EPR Kirambo and Gitesi sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Old man got drunk and fall in the river",
  //       "notes_on_social_information": "Ruhinga cell leader is the one who provided the information about directly individual served by the bridge, he referred to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azAAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasuma",
  //       "bridge_opportunity_project_code": "1013546",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.12787,
  //       "bridge_opportunity_gps_longitude": 29.43396,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2110,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12787,
  //       "proposed_bridge_location_gps_longitude": 29.43396,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 89,
  //       "flood_duration_during_rainy_season": "2 days if flood",
  //       "market_access_blocked_by_river": "Gasharu village don't have access to Gitaka market",
  //       "education_access_blocked_by_river": "Gasharu village don't have acess to GS Kirambo",
  //       "health_access_blocked_by_river": "Gasharu village don't have acess to Kirambo health center",
  //       "other_access_blocked_by_river": "Nyakibati village don't have acess to Gasharu Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Students",
  //       "notes_on_social_information": "Ruhinga cell leader was there to give me info about direct individual served by referring to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azFAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mujebeshi",
  //       "bridge_opportunity_project_code": "1013629",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.92009,
  //       "bridge_opportunity_gps_longitude": 29.46229,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1561,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92009,
  //       "proposed_bridge_location_gps_longitude": 29.46229,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Nyagasambu market",
  //       "education_access_blocked_by_river": "Kigamba secondary and primary school",
  //       "health_access_blocked_by_river": "Rutsiro healthy center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "The river is very dangerous when it rains people slips and fall as there is no bridge for them to cross",
  //       "notes_on_social_information": "Rufungo don't have access nyagasambu market, murengeri don't have access to gisiza market. Information gathered from murengeri leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iQuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarukeri",
  //       "bridge_opportunity_project_code": "1013548",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.14404,
  //       "bridge_opportunity_gps_longitude": 29.43463,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4386,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14404,
  //       "proposed_bridge_location_gps_longitude": 29.43463,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Kinyami village , karwiru village ,rurumbu village and Rwariro village dont have acess to Rubengera market , while Nyarukeri village ,nyaruvumu village and Gasharu village don't have access to gasenyi market",
  //       "education_access_blocked_by_river": "Nyarukeri village ,nyaruvumu village and Gasharu village don't have access to Musango secondary school , while Kinyami village , karwiru village ,rurumbu village and Rwariro village dont have acess to kirambo secondary school",
  //       "health_access_blocked_by_river": "Nyarukeri village ,nyaruvumu village and Gasharu village don't have access to Musango health center , while Kinyami village , karwiru village ,rurumbu village and Rwariro village dont have acess to Karambo health center.",
  //       "other_access_blocked_by_river": "Kinyami village , karwiru village ,rurumbu village and Rwariro village dont have acess to Kagunga church , While Nyarukeri village ,nyaruvumu village and Gasharu village don't have access to musango church.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "No big incident only few people fall in the river",
  //       "notes_on_social_information": "Kanyami village leader given information about directly individual served by referring to population census of 2018",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwarushishi",
  //       "bridge_opportunity_project_code": "1013549",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.12657,
  //       "bridge_opportunity_gps_longitude": 29.45745,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1642,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12657,
  //       "proposed_bridge_location_gps_longitude": 29.45745,
  //       "current_crossing_method": "None timber is used to cross the river",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 88,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Gitega population don't have acess to Rugabano market",
  //       "education_access_blocked_by_river": "Gitega population don't have acess to Gahengeri secondary school",
  //       "health_access_blocked_by_river": "Gitega population don't have acess to Rugabano health center",
  //       "other_access_blocked_by_river": "Gitega population don't have acess to Rugabano Catholic church while ruhondo village and rubatura village don't have access to Gitega Catholic church and ADEPR Gitega",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "No death , when river is flood the people get scared and stay on their respective sides , but there is one man who were walking in water and fall in the river but survived",
  //       "notes_on_social_information": "Ruhinga cell leader provide the information about individual directly served , and he referred to the population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azUAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakoma",
  //       "bridge_opportunity_project_code": "1013550",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.108,
  //       "bridge_opportunity_gps_longitude": 29.44281,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1706,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.108,
  //       "proposed_bridge_location_gps_longitude": 29.44281,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 89,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Kamihaho village don't have acess to rubengera market",
  //       "education_access_blocked_by_river": "Kamihaho village don't have acess to GS Kirambo , muvungu village don't have acess to Gitega primary school",
  //       "health_access_blocked_by_river": "Kamihaho village don't have acess to Kirambo health center",
  //       "other_access_blocked_by_river": "Muvungu village don't have acess to Gitega cell office ,and EPR Gitega ( church )",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": ", cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "A kid of 6 year",
  //       "notes_on_social_information": "Gitega cell leader is the one who gives info for direct individual served",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisiza",
  //       "bridge_opportunity_project_code": "1013551",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.11251,
  //       "bridge_opportunity_gps_longitude": 29.41945,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4353,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11251,
  //       "proposed_bridge_location_gps_longitude": 29.41945,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 99,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Gahigiro village , nyarucyamo village , ruhundo village, kinama village don't have acess to mukungu market & kivunga market &gasenyi market, while Kirambo village , nzabuhara village, buye village, Gasharu village don't have access to Rubengera market & kibuye market & Gitaka market .",
  //       "education_access_blocked_by_river": "Gahigiro village , nyarucyamo village , ruhundo village, kinama village don't have acess to GS Kirambo",
  //       "health_access_blocked_by_river": "Gahigiro village , nyarucyamo village , ruhundo village, kinama village don't have acess to Kirambo health center , while Kirambo village , nzabuhara village, buye village, Gasharu village don't have access to Kibuye hospital",
  //       "other_access_blocked_by_river": "Gahigiro village , nyarucyamo village , ruhundo village, kinama village don't have acess to ADEPR Kirambo and EPER Kirambo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "1 death",
  //       "notes_on_social_information": "Kirambo village leader given info about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azeAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo",
  //       "bridge_opportunity_project_code": "1013552",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.11217,
  //       "bridge_opportunity_gps_longitude": 29.41652,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2079,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11217,
  //       "proposed_bridge_location_gps_longitude": 29.41652,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 72,
  //       "flood_duration_during_rainy_season": "3 days of flood",
  //       "market_access_blocked_by_river": "Nyarusange village , kirambo village and nyarubuyr vilage dont have acess to rubengera market",
  //       "education_access_blocked_by_river": "Nyarucyamo village, kinama village , and gahigiro village dont have access to GS Kirambo",
  //       "health_access_blocked_by_river": "Nyarucyamo village, kinama village , and gahigiro village dont have access to Kirambo health center",
  //       "other_access_blocked_by_river": "Nyarucyamo village, kinama village , and gahigiro village dont have access to Gitesi sector office",
  //       "primary_occupations": "Farnimg",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No death , no injuries",
  //       "notes_on_social_information": "Kirambo cell leader is the one who provided information about directly individual served ,she referred to the population census of 2018 .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi _ Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azjAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisiza Ya Ruhinga",
  //       "bridge_opportunity_project_code": "1013553",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.11589,
  //       "bridge_opportunity_gps_longitude": 29.4245,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4023,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11589,
  //       "proposed_bridge_location_gps_longitude": 29.4245,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 76,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Rubengera market",
  //       "education_access_blocked_by_river": "GS Kirambo",
  //       "health_access_blocked_by_river": "Kirambo health center",
  //       "other_access_blocked_by_river": "Gitesi health center",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Drunk man",
  //       "notes_on_social_information": "Ruhinga cell leader provided info about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azoAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakibyeyi",
  //       "bridge_opportunity_project_code": "1013554",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.09586,
  //       "bridge_opportunity_gps_longitude": 29.3907,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3131,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.22",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.09586,
  //       "proposed_bridge_location_gps_longitude": 29.3907,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No",
  //       "days_per_year_river_is_flooded": 103,
  //       "flood_duration_during_rainy_season": "3 days of flood",
  //       "market_access_blocked_by_river": "Nyabitare village , nemba village , Bwishyura village don't have access to Rubengera market.., all people from Munanira cell don't have access to kibuye market",
  //       "education_access_blocked_by_river": "Nyabitare village , nemba village , Bwishyura village don't have access to GS Kirambo , all people from Munanira cell don't have acess to GS Bwishyura",
  //       "health_access_blocked_by_river": "Nyabitare village , nemba village , Bwishyura village don't have access to Kirambo health center",
  //       "other_access_blocked_by_river": "Nyabitare village , nemba village , Bwishyura village don't have access to Gitesi sector office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "2 injuries and no death",
  //       "notes_on_social_information": "Munanira cell leader is the one who provided all info about individual served and he referred to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7azyAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rufungo",
  //       "bridge_opportunity_project_code": "1013630",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.92623,
  //       "bridge_opportunity_gps_longitude": 29.44603,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1378,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92623,
  //       "proposed_bridge_location_gps_longitude": 29.44603,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Muyira market",
  //       "education_access_blocked_by_river": "Mujebeshi primary school",
  //       "health_access_blocked_by_river": "Rutsiro health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "A cow one day died in the river",
  //       "notes_on_social_information": "Information gathered from Damascene mujebeshi leader. Rufungo village don't have access to muyira market. Mujebeshi village don't have access to their farms.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 95,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iR9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kageyo",
  //       "bridge_opportunity_project_code": "1013558",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.332639,
  //       "bridge_opportunity_gps_longitude": 29.249679,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2571,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.332639,
  //       "proposed_bridge_location_gps_longitude": 29.249679,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "March to May, October and November, 2 hours",
  //       "market_access_blocked_by_river": "Communities 1&2 do not have access to Gatare market, communities 3&4 are blocked to vire market, communities 3&4 are blocked to Cyivugiza thee factory. Communities 1&2 do not have access to farms in Gasovu villages and communities 3&4 do not have access to farms in kageyo.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to karambi secondary school, communities 3&4 do not have access to Kageyo rimary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to cyivugiza Health center.",
  //       "other_access_blocked_by_river": "Communities 1&2 do not have access to church in rurembo( ADPR, MRTHODISTE, ADVENTIST), communities 3&4 are blocked to Catholic church In kageyo.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, the, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "Fell down and fractured",
  //       "notes_on_social_information": "Population information of each village was provided by Gasovu cell leader, Niyonizeye Theogene who sourced the population information from cell register done in 2018 during Ubudehe program. Population of all adjacent communities includes the following villages; Kageyo, Mutivuga, Bitare and rurembo.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 2.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b5hAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruzibira",
  //       "bridge_opportunity_project_code": "1013559",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.324086,
  //       "bridge_opportunity_gps_longitude": 29.237155,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2395,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.324086,
  //       "proposed_bridge_location_gps_longitude": 29.237155,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "March to May, October to November, 2 hours",
  //       "market_access_blocked_by_river": "No market is blocked, communities 1&2 are blocked to farms in kabeza, communities 3 are blocked to farm in rushyarara.",
  //       "education_access_blocked_by_river": "communities 1&2 are blocked to karambi secondary school.",
  //       "health_access_blocked_by_river": "No health center is blocked they use another path.",
  //       "other_access_blocked_by_river": "Communities 1&2 do not have access to ADPR Church in kabeza. Communities 1&2 do not have access to karambi sector office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Gasovu cell leader, niyonizeye Theogene who sourced the population information from cell register done in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "RUSIZI",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b5mAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugohe~Bugarama",
  //       "bridge_opportunity_project_code": "1013560",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.316496,
  //       "bridge_opportunity_gps_longitude": 29.218564,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4299,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.316496,
  //       "proposed_bridge_location_gps_longitude": 29.218564,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "March to May, October to November, 3 hours in order to cross",
  //       "market_access_blocked_by_river": "Communities 4&5 do not have access to Gatare market and bitaba market. Communities 1,2&3 do not have access to farms in villages 4&5. Communities 4&5 do not have access to farms in Rugano.",
  //       "education_access_blocked_by_river": "Communities 4&5 do not have access to Rugano primary school and Rugano secondary school.",
  //       "health_access_blocked_by_river": "Communities 4&5 do not have access to Kabuga dispenary, communities 4&5 are blocked to Gatare health center.",
  //       "other_access_blocked_by_river": "Communities 4&5 do not have access to sector office and cell office, communities 4&5 are blocked to church in Rugano, Mugohe and Gatare.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, coffe",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Fell down and fractured",
  //       "notes_on_social_information": "Population information of each village was provided by Bugarama village leader, Manirakiza Ezekiel who gave the population information from all villages leaders in which they have done each villages population record in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": 2.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b5rAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bisamba",
  //       "bridge_opportunity_project_code": "1013562",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.323533,
  //       "bridge_opportunity_gps_longitude": 29.254731,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2076,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.323533,
  //       "proposed_bridge_location_gps_longitude": 29.254731,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "March to May, 1hours",
  //       "market_access_blocked_by_river": "Communities 3&4 do not have access to farms in gasamba, communities 1&2 vire market.",
  //       "education_access_blocked_by_river": "Communities 3&4 do not have access to G.S karambi( primary school and secondary school).",
  //       "health_access_blocked_by_river": "Communities 3&4 do not have access to",
  //       "other_access_blocked_by_river": "Communities 3&4 do not have access to karambi Catholic church. Communities 3&4 do not have access to Gasovu cell office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Gasovu cell leader, Theogene Niyonzima who sourced the population from cell register in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b61AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Peru",
  //       "bridge_opportunity_project_code": "1013563",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.304747,
  //       "bridge_opportunity_gps_longitude": 29.219334,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2955,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.304747,
  //       "proposed_bridge_location_gps_longitude": 29.219334,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "April to May, October to December. They cross every time, river does not flood.",
  //       "market_access_blocked_by_river": "Communities 2,3,4&5 do not have access to Rugari market, communities 2,3,4&5 do have access to farms in wimana.",
  //       "education_access_blocked_by_river": "Communities 2,3,4&5 are blocked to Groupe scholaire Rugano( primary school and secondary school Ordinary level) and G.S Mbuga ( primary and secondary school advanced level).",
  //       "health_access_blocked_by_river": "Communities 2,3,4&5 do not have access to Gatare health center.",
  //       "other_access_blocked_by_river": "Communities 2,3,4&5 do not have access to Macuba sector office, police station and district office. Community 1 do have access to Gatare cell office, communities 2,3,4&5 are blocked to Catholic church in Wimana, ADPR Church .",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided was provided by Gatare cell leader, Nyirahabimana Anne Marie Who sourced the population information from cell register in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamaskeke~rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b66AAA",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Murambi",
  //       "bridge_opportunity_project_code": "1013564",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.311176,
  //       "bridge_opportunity_gps_longitude": 29.239786,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2829,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.311176,
  //       "proposed_bridge_location_gps_longitude": 29.239786,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 kilometers",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "April to May , October to December, 2 hours",
  //       "market_access_blocked_by_river": "Communities 1,2,& 3 do not have access to Gatare market, rugari market, and Peru market. Communities 4&5 are blocked to karambi market. Communities 1,2,&3 do not have access to farms in Gatare and communities 4&5 do not have access to farms in Murambi.",
  //       "education_access_blocked_by_river": "Communities 1,2,&3 do not have access to Ryasagahara primary school. Communities 4&5 do not have access to karambi primary school and Karambi secondary school.",
  //       "health_access_blocked_by_river": "Communities 1,2& 3 do not have access to Gatare health center , communities 4&5 are blocked to Rubona health center.",
  //       "other_access_blocked_by_river": "Communities 1,2&3 do not have access to Hanika church, communities 4&5 are blocked to karambi Catholic church.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Slipped on the timber and fell down on the rock and died.",
  //       "notes_on_social_information": "Population information of each village was provided by Gasovu cell leader and Gatare SEDO who sourced the population information from cell record in Ubudehe 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b6BAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mubitare",
  //       "bridge_opportunity_project_code": "1013565",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.322038,
  //       "bridge_opportunity_gps_longitude": 29.247239,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2043,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.322038,
  //       "proposed_bridge_location_gps_longitude": 29.247239,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "250 m",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "April to May, october and november ,1 hour",
  //       "market_access_blocked_by_river": "Communities 3 is blocked to kagarama market. Commuites 1&2 do not have access to gatare thee factory, Communities 1&2 do not have access to farms. Communities 3 do not have access to farms.",
  //       "education_access_blocked_by_river": "Communities 3 is blocked to karambi primary school.",
  //       "health_access_blocked_by_river": "Community 3 is blocked to kagarama health center.",
  //       "other_access_blocked_by_river": "Communities 3 do not have access to cell office and karambi sector office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, the, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b6GAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugasebeya",
  //       "bridge_opportunity_project_code": "1013566",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.251326,
  //       "bridge_opportunity_gps_longitude": 29.21786,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2780,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.251326,
  //       "proposed_bridge_location_gps_longitude": 29.21786,
  //       "current_crossing_method": "Stepping on stones",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "February to May , October to December, 2 hours",
  //       "market_access_blocked_by_river": "Community 3 do have access to karengera market. Communities 1&2 do not have access to farms in ntogota valley.",
  //       "education_access_blocked_by_river": "Community 3 is blocked to Nyabinaga Primary school. Community 3 do have access to Gitwa primary school, VTC Gitwa, Gitwa Secondary school, cyangabo primary school and Umucyo karengera secondary school.",
  //       "health_access_blocked_by_river": "Community 3 karengera health center.",
  //       "other_access_blocked_by_river": "Community 3 do have access to ADPR and Nyabinaga church, community 3 do not have access to potable water in nyabinaga.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down on rock.",
  //       "notes_on_social_information": "Population information of each village was provided by the villages leader, who sourced them from villagerecord in every year, the last register done in 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b6LAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gacumbi",
  //       "bridge_opportunity_project_code": "1013567",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.26295,
  //       "bridge_opportunity_gps_longitude": 29.189909,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 46,
  //       "bridge_opportunity_individuals_directly_served": 1888,
  //       "bridge_opportunity_comments": "Need for geotechnical investigation on the right side (RICE PLANTATION)",
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.26295,
  //       "proposed_bridge_location_gps_longitude": 29.189909,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away.",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Communities 1&2 do not have access to Rugari market. Community 3 do have access to karengera market. Com unites 1,2& 3 do not have access to farms.",
  //       "education_access_blocked_by_river": "Communities 3 don't have access to Gacumbi primary school and karengera secondary school.",
  //       "health_access_blocked_by_river": "Community 3 is blocked karengera health center.",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Muhororo cell leader, who sourced them from the cell register done in 2017. Population of all adjacent communities includes the following villages: Gacumbi, kagarama and , communities members from Gacumbi and kagarama sometimes cross the river to visit relatives in Ijwi island in congo.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi ~ Nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b6QAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murama",
  //       "bridge_opportunity_project_code": "1013569",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.301919,
  //       "bridge_opportunity_gps_longitude": 29.242738,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2889,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.301919,
  //       "proposed_bridge_location_gps_longitude": 29.242738,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "March to May, sometimes in October to December, 5 hours",
  //       "market_access_blocked_by_river": "Communities 1,2&3 do not have access to kagarama market and mugonero market. Communities 4&5 do not have access to Gatare market and Gatere cows market. Communities 1,2&3 do not have access to farms kigarama cell., communities 4&5 are blocked to farms in Gatare cell. Communities 1,2&3 do not have access to kagarama coffee factory.",
  //       "education_access_blocked_by_river": "Communities 1,2&3 do not have access to Mweya primary school. Communities 4&5 do not have access to Ryasagahara primary school.",
  //       "health_access_blocked_by_river": "Communities 1,2&3 do not have access to kagarama health center.",
  //       "other_access_blocked_by_river": "Communities 1,2&3 do not have access to churches in Kagarama. Communities 4&5 do not have access to potable water in Murama village.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by Murama village leader, Manirafasha Emmanuel who sourced information from villages'leader by calling them, they also have sourced the data in every year record of population in village in the Ubudehe program, the last record 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": 2.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7b6aAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinamba",
  //       "bridge_opportunity_project_code": "1013571",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.46509,
  //       "bridge_opportunity_gps_longitude": 29.94044,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6191,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46509,
  //       "proposed_bridge_location_gps_longitude": 29.94044,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Ntyazo, Mamba and Musha Markets (Community 4,5), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Mamba Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Gakoma Hospital (Community 4,5)",
  //       "other_access_blocked_by_river": "Gakoma Catholic Parish, Mamba Adventist church and Kabeza ADEPR church (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "More than 100 people have been falling into the river, mostly motorcyclists or bicyclists who were trying to cross the river at the bridge but no serious injuries.",
  //       "notes_on_social_information": "Rebero, Mamba, Mashenyi, Munopfu, Nunga, Nyarugenge and Muhabura villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms. The population information for each village was provided by the Gakoma Cell Leader, Mushimiyimana Berthe, who sourced the population information from the cell census data collected in late 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bA2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Runyeshyanga",
  //       "bridge_opportunity_project_code": "1013572",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.40829,
  //       "bridge_opportunity_gps_longitude": 29.9468,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5170,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.40829,
  //       "proposed_bridge_location_gps_longitude": 29.9468,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 100,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Ntyazo Market (Community 1,2,3,4), Farms (Community 1,2,5)",
  //       "education_access_blocked_by_river": "No education access blocked",
  //       "health_access_blocked_by_river": "Ntyazo Pharmacy (Community 1,2,3)",
  //       "other_access_blocked_by_river": "ADEPR and EER Churches (Community 1,2,3), Kizenga Catholic church (Community 5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "More than 100 people have been falling into the river but were rescued, but the number of deaths goes up to 4 people who died during rainy season.",
  //       "notes_on_social_information": "Ruhuha, Sokofi, Gakomeye, Kizenga, Rugwiza, Rebero and Kamabuye villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms. The population information for each village was provided by the Gakoma Cell Leader, Mushimiyimana Berthe, who sourced the population information from the cell census data collected in late 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bA7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwihinda",
  //       "bridge_opportunity_project_code": "1013573",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.434,
  //       "bridge_opportunity_gps_longitude": 29.93238,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5191,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.434,
  //       "proposed_bridge_location_gps_longitude": 29.93238,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 100,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours.",
  //       "market_access_blocked_by_river": "Ntyazo Market (Community 1,2,3 ), Rebero Market (Community 5), Farms (Community 1,3,4,5)",
  //       "education_access_blocked_by_river": "No education access blocked",
  //       "health_access_blocked_by_river": "Gakoma Hospital (Community 5)",
  //       "other_access_blocked_by_river": "Adventist church (Community 1,2,3), ADEPR church (Community 5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Sokofi, Rebero, Rugwiza, Gakomeye, Kizenga, Ruhuha and Gatare villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms. The population information for each village was provided by the Gakoma Cell Leader, Mushimiyimana Berthe, who sourced the population information from the cell census data collected in late 2017.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bACAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Iterambere",
  //       "bridge_opportunity_project_code": "1014263",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.94544,
  //       "bridge_opportunity_gps_longitude": 30.05341,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1162,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94544,
  //       "proposed_bridge_location_gps_longitude": 30.05341,
  //       "current_crossing_method": "Timber combine with concrete",
  //       "nearest_all_weather_crossing_point": "50 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Nyarugenge Market (Iterambere) Nyabugogo Market (Nyenyeri)",
  //       "education_access_blocked_by_river": "Cyahafi primary and secondary school (Nyenyeri)",
  //       "health_access_blocked_by_river": "CHUK (Iterimbere)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Market, school, hospital",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Chef of Security in Akabahizi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "CBD KIGALI",
  //       "name_of_nearest_paved_or_sealed_road": "CBD to Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bojo",
  //       "bridge_opportunity_project_code": "1013574",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.50203,
  //       "bridge_opportunity_gps_longitude": 29.91714,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5131,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.50203,
  //       "proposed_bridge_location_gps_longitude": 29.91714,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Mamba, Musha and Ntyazo Markets (Community 4,5), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Mwendo Primary and Secondary School and Mamba Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Gakoma Hospital (Community 4,5)",
  //       "other_access_blocked_by_river": "Gakoma Catholic Parish; Mamba Sector Office; Mamba Adventist, EER, Baptist churches, ADEPR Muzenga (Community 4,5), ADEPR Muyaga (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "More than 30 people, mostly motorcyclists and bicyclists trying to cross the river.",
  //       "notes_on_social_information": "Ruhamagariro, Shyembe, Butezi, Kibumba, Murambi and Runazi villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms or to visit relatives. The population information for each village was provided by the Muyaga Cell Leader, Alex Mutabaruka, who sourced the population information from the cell census data collected in 2018. Adjacent communities include the villages from Gishubi Sector, community members from these villages use this crossing point to visit relatives, to go to Gakoma Hospital or to go to markets.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bAHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwamuzenga",
  //       "bridge_opportunity_project_code": "1013575",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.49883,
  //       "bridge_opportunity_gps_longitude": 29.927,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3359,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.49883,
  //       "proposed_bridge_location_gps_longitude": 29.927,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours.",
  //       "market_access_blocked_by_river": "Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "No Education access blocked by river.",
  //       "health_access_blocked_by_river": "No health access blocked by river.",
  //       "other_access_blocked_by_river": "No other access blocked by river.",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation., bean, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Murambi, Murama, Runazi, Gatare and Kayenzi villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms or to visit relatives. The population information for each village was provided by the Ramba Cell Leader, Claude Habimana, who sourced the population information from the cell census data collected in 2018. All communities on the right side of the river were moved to the left side. So all these community members cross the river only to get access to their farms.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bAMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamiyaga",
  //       "bridge_opportunity_project_code": "1013577",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.52882,
  //       "bridge_opportunity_gps_longitude": 29.82786,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1706,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.52882,
  //       "proposed_bridge_location_gps_longitude": 29.82786,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for it last for 3 hours",
  //       "market_access_blocked_by_river": "Musha Market (Community 1,2), Kimana Market (Community 3), Farms (Community 3)",
  //       "education_access_blocked_by_river": "No education access blocked by river.",
  //       "health_access_blocked_by_river": "Musha Health Center (Community 1,2)",
  //       "other_access_blocked_by_river": "Musha Sector Office (Community 1,2), Potable water (Community 3)",
  //       "primary_occupations": "Agriculture, Sand collection",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Murambi, Nyamiyaga and Akabanga villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, Farms or to visit relatives. The population information for each village was provided by the Kimana Cell Leader, Veneranda, who sourced the population information from the cell census data collected in 2018. Adjacent communities include the villages, community members from these villages use this crossing point to visit relatives, to go to markets, or to Musha Sector Office.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bAWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akarukambira",
  //       "bridge_opportunity_project_code": "1013578",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.4855,
  //       "bridge_opportunity_gps_longitude": 29.84336,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2364,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4855,
  //       "proposed_bridge_location_gps_longitude": 29.84336,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "0.5 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Rwatano, Gikonko and Ntyazo Markets (Community 1,2), Rwanza Market (Community 3,4)",
  //       "education_access_blocked_by_river": "Gikonko Primary and Secondary School & Ecole Secondaire de Gikonko (Community 1,2), Farms (All Communities)",
  //       "health_access_blocked_by_river": "Gikonko Health Center (Community 1,2)",
  //       "other_access_blocked_by_river": "Gasagara Catholic Church and Huye town (Community 3,4), Gikonko Catholic Parish, Gikonko ADEPR and Protestant Churches, Gikonko Sector Office, Gikonko Police Station (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, vegetables.",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Akarukamba, Agasenyi, Ryamugunga and Agahabwa villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms or to visit relatives. The population information for each village was provided by the Gasagara Cell Leader, Jean Pierre Nyandwi and Jean Pierre Nyangawindemera, Akarukambira Village leader, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bAgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare",
  //       "bridge_opportunity_project_code": "1013579",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.49034,
  //       "bridge_opportunity_gps_longitude": 29.87577,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3643,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.49034,
  //       "proposed_bridge_location_gps_longitude": 29.87577,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "0.7 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours.",
  //       "market_access_blocked_by_river": "Gikonko Market (Community 3,4), Mamba, Rwatano and Musha Markets (Community 1,2), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Gikonko Primary and Secondary School, VTC Gikonko Secondary school, Ecole Secondaire de Gikonko (Community 3,4), Rwatano Primary and Secondary School (Community 1,2)",
  //       "health_access_blocked_by_river": "Gikonko Health Center (Community 3,4)",
  //       "other_access_blocked_by_river": "Gikonko Catholic Parish, Gikonko ADEPR and Adventist Churches, Gikonko Police Station, Gikonko Sector Office (Community 3,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many people fall into the river on the timber bridge, but no death by river crossing so far, because when the water level is high they use a vehicular bridge which is some distance downstream.",
  //       "notes_on_social_information": "Runyinya, Karubondo, Rwatano and Rwinyana villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms or to visit relatives. The population information for each village was provided by the Gikonko Cell Leader, Nyiramana Claudine and Nshimiyimana Jean Pierre, from the population data collected in 2018. Adjacent communities include the villages from Mbogo Cell, community members from these villages use this crossing point to visit relatives, to go to Gikonko Health Center and to Gikonko Sector Office.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bAlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kintama",
  //       "bridge_opportunity_project_code": "1013613",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.62757667,
  //       "bridge_opportunity_gps_longitude": 29.43474,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3778,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.62757667,
  //       "proposed_bridge_location_gps_longitude": 29.43474,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "30 times in April, May, October, November and December and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Kintama doesn't have access to Kajwangara and kamirabagenzi market",
  //       "education_access_blocked_by_river": "Kintama doesn't have access to Rugerero Secondary school",
  //       "health_access_blocked_by_river": "Kintama doesn't have access to Kivu Health Center",
  //       "other_access_blocked_by_river": "Sector office",
  //       "primary_occupations": "Farming of tea and cow pea",
  //       "primary_crops_grown": "cow pea, tea",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58.4,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7hE3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahuru",
  //       "bridge_opportunity_project_code": "1013580",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.50934,
  //       "bridge_opportunity_gps_longitude": 29.90858,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4404,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.23",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.50934,
  //       "proposed_bridge_location_gps_longitude": 29.90858,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 hours.",
  //       "market_access_blocked_by_river": "Karama, Mamba and Musha Markets (Community 1,2,3), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Mwendo Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Gakoma Hospital (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Mamba Sector Office, Gakoma Catholic Parish, Mamba Adventist church (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maize., potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 in the last 3 years. But no serious injuries.",
  //       "notes_on_social_information": "Ruhamagariro, Shyembe, Butezi, Kibumba, Kigangazi and Rusave villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, Farms or to visit relatives. The population information for each village was provided by the Muyaga Cell Leader, Alex Mutabaruka, who sourced the population information from the cell census data collected in 2018. Adjacent communities include the villages from Gishubi Sector, community members from these villages use this crossing point to visit relatives, to go to Gakoma Hospital or to go to markets.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7bAqAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bisomera",
  //       "bridge_opportunity_project_code": "1013595",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.9233,
  //       "bridge_opportunity_gps_longitude": 29.469722,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1394,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9233,
  //       "proposed_bridge_location_gps_longitude": 29.469722,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "They use a road way that delays them one hour",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Murunda market",
  //       "education_access_blocked_by_river": "Kabona secondary school",
  //       "health_access_blocked_by_river": "Rutsiro hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A woman has fallen trying to cross when it was flooded",
  //       "notes_on_social_information": "Market (community 2). Sec School (community 1), farms (community 1 and 2). Population information for each village was provided by each village leader from village census collected in 2018.[basesa bosco ruganda village leader and Munyaneza Etienne remera cell leader] Population of all adjacent communities includes the following village: ruganda, kacyiru, Bungwe, marimba and some people in remera cell. Bungwe, marimba and some people in remera cell do cross to visit their relatives twice a month",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rutsiro-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7capAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitunu",
  //       "bridge_opportunity_project_code": "1013596",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "0",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Gisiza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "People always cross the bridge and it is a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7cerAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyacika",
  //       "bridge_opportunity_project_code": "1013599",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.74886,
  //       "bridge_opportunity_gps_longitude": 29.87465,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1372,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.74886,
  //       "proposed_bridge_location_gps_longitude": 29.87465,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Kinyari market",
  //       "education_access_blocked_by_river": "Karushashi secondary and primary school",
  //       "health_access_blocked_by_river": "Rwankuba hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "In five years one person died trying to cross",
  //       "notes_on_social_information": "Nganzo village don't have access to karushashi school and rwankuba hospital and kinyari market and Ngambe village don't have access to farms. Information gathered from ndacyayisenga Isaac Ngambe village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 179,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7cjcAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabingo",
  //       "bridge_opportunity_project_code": "1013601",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.73099,
  //       "bridge_opportunity_gps_longitude": 29.87352,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1250,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.73099,
  //       "proposed_bridge_location_gps_longitude": 29.87352,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gasiza market",
  //       "education_access_blocked_by_river": "EAV rushashi secondary school and ES karungu secondary school",
  //       "health_access_blocked_by_river": "Ruri hospital",
  //       "other_access_blocked_by_river": "ADPR rushashi",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 7,
  //       "river_crossing_injuries_in_last_3_years": 23,
  //       "incident_descriptions": "People fell in the river when flooded. They slip over the current bridge",
  //       "notes_on_social_information": "Kabingo village don't have access to ruri hospital,EAV rushashi and rutabu market. Murambi village don't have access to gasiza market. Information gathered from Christian kabingo leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 96,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7cnFAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyinoni 1",
  //       "bridge_opportunity_project_code": "1013603",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.65105,
  //       "bridge_opportunity_gps_longitude": 29.80862,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1892,
  //       "bridge_opportunity_comments": "Rejected per comment from Nico on 2020.06.09: Visited on October 28th by Aimable with the district engineer who communicated the plan for building a vehicular bridge in the same location. Aimable communicated the issue to Hannis and they decided to reject the site.",
  //       "form_form_name": "Project Assessment - 2018.9.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65105,
  //       "proposed_bridge_location_gps_longitude": 29.80862,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Nemba and Kirebe secondary schools",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "Karambo Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People used to fell when the river bets flood",
  //       "notes_on_social_information": "Kabaya don't have access to Kirebe school and kanyanza Karenge don't have access to Nemba hospital and Nemba school. Information gathered from mwitende Patrick gatembe leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 68,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7crlAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mohora",
  //       "bridge_opportunity_project_code": "1013605",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.97905,
  //       "bridge_opportunity_gps_longitude": 29.36179,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 921,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.97905,
  //       "proposed_bridge_location_gps_longitude": 29.36179,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Congo Nile market",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Two People died when they were preparing to get married and fell trying to cross",
  //       "notes_on_social_information": "Kagarama village dont have access to congonile market and hospital and schools also in Congo Nile city. Muhora don't have access to farms. Information gathered from kambandana saver kagarama leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7cxUAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Tububuro",
  //       "bridge_opportunity_project_code": "1013611",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.59941667,
  //       "bridge_opportunity_gps_longitude": 29.56459167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2579,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.59941667,
  //       "proposed_bridge_location_gps_longitude": 29.56459167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "12 km",
  //       "days_per_year_river_is_flooded": 140,
  //       "flood_duration_during_rainy_season": "20 times in April, May, October, September, October, November and December and it lasts for 7days after rainfall",
  //       "market_access_blocked_by_river": "Ruramba market ( Rwinanka, Nyacyondo ) Ndago market( Tububuro, Nyamyumba)",
  //       "education_access_blocked_by_river": "Rwamiko secondary school (Tububuro, Nyamyumba, Ramba)",
  //       "health_access_blocked_by_river": "Rwinanka, Nyacyondo villages don't have access to Nyamyumba Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Potatoes and Tea farming,",
  //       "primary_crops_grown": "bean, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33.4,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7gjeAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Runono",
  //       "bridge_opportunity_project_code": "1013612",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.56125667,
  //       "bridge_opportunity_gps_longitude": 29.56492833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4192,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.56125667,
  //       "proposed_bridge_location_gps_longitude": 29.56492833,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "30times in April, May, October, November and December and it lasts for 3hours after rainfall",
  //       "market_access_blocked_by_river": "Runono doesn't have access to Mata market Mata doesn't have access to their farms Runono doesn't have access to Ruramba market",
  //       "education_access_blocked_by_river": "Runono doesn't have access to Mata secondary school",
  //       "health_access_blocked_by_river": "Runono doesn't have access to Nyamyumba Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea farming,",
  //       "primary_crops_grown": "tea, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "People prefer to pass the night at the opposite side of their home to avoid any incident The survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 85,
  //       "height_differential_between_banks": 4.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7hDyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryabidandi",
  //       "bridge_opportunity_project_code": "1013614",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.74995333,
  //       "bridge_opportunity_gps_longitude": 29.62531333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4794,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.74995333,
  //       "proposed_bridge_location_gps_longitude": 29.62531333,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "20 times in April, May, October November and December and it lasts for 1 day after rainfall",
  //       "market_access_blocked_by_river": "Ryabidandi, Bugarama, Nkima, Maraba, Rushunguriro villages don't have access to Viro market Nyamiyaga, Uwimfizi, Muriza, Nyagishayo villages don't have access to Birambo market( It occurs two times per week)",
  //       "education_access_blocked_by_river": "Ryabidandi, Bugarama, Nkima, Maraba, Rushunguriro villages don't have access to Akagarama secondary school Ryabidandi, Bugarama, Nkima, Maraba, Rushunguriro villages don't have access to Akagarama primary school",
  //       "health_access_blocked_by_river": "Nyamiyaga, Uwimfizi, Muriza, Nyagishayo villages don't have access to Maraba Health Center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of cassava and beans",
  //       "primary_crops_grown": "bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Buagarama, Nkima, Maraba, Rushunguriro villages uses this crossing regularly to access markets, Health Center, and Schools. Therefore, their population are included in the total population to be served. The survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 63.8,
  //       "height_differential_between_banks": 5.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7hE8AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Ndimurwango",
  //       "bridge_opportunity_project_code": "1013618",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.591966,
  //       "bridge_opportunity_gps_longitude": 29.876044,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2946,
  //       "bridge_opportunity_comments": "This site was requested when Kyle & Clementine were doing audits. The village leader said it is the greater need between the two Kwa Nshoboye sites (other located downstream) as many people cross at this location to get water from the spring.",
  //       "form_form_name": "Project Assessment - 2018.12.10",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.591966,
  //       "proposed_bridge_location_gps_longitude": 29.876044,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gitaraga Market (Kigeyo, Songorero,) business center Nyamugali ( kigeyo and Songorero)",
  //       "education_access_blocked_by_river": "Primary and secondary Nyamugari ( Kigeyo and Songorero)",
  //       "health_access_blocked_by_river": "Nyamugali Health center (Kiigeyo and Songorero)",
  //       "other_access_blocked_by_river": "Water potable, district office, sector office, football terrain ( kigeyo and Songorero)",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None incidents",
  //       "notes_on_social_information": "People who live closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7hMWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bwingeyo",
  //       "bridge_opportunity_project_code": "1013619",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.93923,
  //       "bridge_opportunity_gps_longitude": 30.46986,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5481,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.93923,
  //       "proposed_bridge_location_gps_longitude": 30.46986,
  //       "current_crossing_method": "Vehicular bridge in Renforced concrete",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded the whole day",
  //       "market_access_blocked_by_river": "Both side have market but all are used by different communities",
  //       "education_access_blocked_by_river": "Both side habe schools, but there are students from Bwingeyo who go to Nyarusange",
  //       "health_access_blocked_by_river": "Both side have health center but the hospital is in Rwamagana , bwingeyo and Gasura used this bridge to go to the hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Business between both side, to the prison, Market, schools",
  //       "primary_crops_grown": ", maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Brings to and people who work closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 10,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7i5UAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mburabuturo",
  //       "bridge_opportunity_project_code": "1013620",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.90822,
  //       "bridge_opportunity_gps_longitude": 30.4727,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2877,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.90822,
  //       "proposed_bridge_location_gps_longitude": 30.4727,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "8 kilometers",
  //       "days_per_year_river_is_flooded": 92,
  //       "flood_duration_during_rainy_season": "Five days",
  //       "market_access_blocked_by_river": "Mburabuturo and kinunga are blocked to the Market",
  //       "education_access_blocked_by_river": "Mburabuturo and Kinunga are blocked to secondary schools",
  //       "health_access_blocked_by_river": "Mburabuturo and Kinunga are blocked to Health center and hospital",
  //       "other_access_blocked_by_river": "Mburabuturo and Kinunga are blocked to district and sector office, bus park, ..",
  //       "primary_occupations": "Health center, school secondary, district",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived and one who in charge of development in Mburabuturo community",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7i74AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bisiniya",
  //       "bridge_opportunity_project_code": "1013621",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.95182,
  //       "bridge_opportunity_gps_longitude": 30.59996,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2969,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Irrigation ditch. River is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.95182,
  //       "proposed_bridge_location_gps_longitude": 30.59996,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "'Vehicular bridge three meters away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It takes three hours but they don't have where to pass",
  //       "market_access_blocked_by_river": "Akayebe is blocked to the Market",
  //       "education_access_blocked_by_river": "Akayebe is blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Akayebe is blocked to Health center and hospital",
  //       "other_access_blocked_by_river": "Akayebe is blocked to the business center and churches",
  //       "primary_occupations": "Hospital, farms, market",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Seka and people who work closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7i95AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Barage",
  //       "bridge_opportunity_project_code": "1013622",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.95152,
  //       "bridge_opportunity_gps_longitude": 30.59912,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2969,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.95152,
  //       "proposed_bridge_location_gps_longitude": 30.59912,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge three kilometers away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded the whole day but they can cross during raining because how timber are old",
  //       "market_access_blocked_by_river": "Akayebe is blocked to the Market",
  //       "education_access_blocked_by_river": "Akayebe is blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Akayebe is blocked health center and hospital",
  //       "other_access_blocked_by_river": "Akayebe is blocked to churches",
  //       "primary_occupations": "Market, farm and hospital",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of seka and people who work closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iJPAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisiza",
  //       "bridge_opportunity_project_code": "1013624",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.92376,
  //       "bridge_opportunity_gps_longitude": 29.32233,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1697,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92376,
  //       "proposed_bridge_location_gps_longitude": 29.32233,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gisiza market",
  //       "education_access_blocked_by_river": "Syiki secondary and primary school",
  //       "health_access_blocked_by_river": "Kinunu health center",
  //       "other_access_blocked_by_river": "Kinunu cothoric church",
  //       "primary_occupations": "Farming and fishing",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "The current bridge is not safe and people fall over it",
  //       "notes_on_social_information": "Gisiza village don't have access to gisiza market and syiki secondary school and syiki village don't have access to kinunu Catholic church and kinunu health center.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nkomero",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iPrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamujyambere",
  //       "bridge_opportunity_project_code": "1013625",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.76314,
  //       "bridge_opportunity_gps_longitude": 29.30402,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1428,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.76314,
  //       "proposed_bridge_location_gps_longitude": 29.30402,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Rubavu market",
  //       "education_access_blocked_by_river": "Kivumu secondary school",
  //       "health_access_blocked_by_river": "Kivumu health center",
  //       "other_access_blocked_by_river": "Kivumu church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "One person died when he was drunk trying to cross and lose stamina",
  //       "notes_on_social_information": "Gihari village don't have access to kivumu hospital, kivumu school, and burambo village don't have access to rubavu town.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iQ1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarutovu",
  //       "bridge_opportunity_project_code": "1013627",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.68267,
  //       "bridge_opportunity_gps_longitude": 29.67093,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1592,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.68267,
  //       "proposed_bridge_location_gps_longitude": 29.67093,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Kinoko market and vunga market",
  //       "education_access_blocked_by_river": "Janja primary and secondary school",
  //       "health_access_blocked_by_river": "Janja health center",
  //       "other_access_blocked_by_river": "Janja cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 21,
  //       "incident_descriptions": "Students used to fall in the river before shifting the current bridge",
  //       "notes_on_social_information": "Information gathered from nizeyimana aimable nyakagezi leader. Nyakagezi village don't have access to janja school, janja hospital and vunga market. Kinoko village don't have access to farms.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Vunga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iQLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rucamahembe",
  //       "bridge_opportunity_project_code": "1013636",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.81695,
  //       "bridge_opportunity_gps_longitude": 29.29326,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 860,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.81695,
  //       "proposed_bridge_location_gps_longitude": 29.29326,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Nkora market",
  //       "education_access_blocked_by_river": "Kimbiri primary and secondary school",
  //       "health_access_blocked_by_river": "Kimbiri health center",
  //       "other_access_blocked_by_river": "ADPR kigeyo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, coffe",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "People fall usually when the river is not flooded",
  //       "notes_on_social_information": "Gisiza village don't have access to nkora market and kimbiri hospital. Information gathered from theogene gisiza leade.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkora",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iSlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rucamahembe2",
  //       "bridge_opportunity_project_code": "1013637",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.81635,
  //       "bridge_opportunity_gps_longitude": 29.29171,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.81635,
  //       "proposed_bridge_location_gps_longitude": 29.29171,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Nkora market",
  //       "education_access_blocked_by_river": "Kimbiri secondary school",
  //       "health_access_blocked_by_river": "Kimbiri health center",
  //       "other_access_blocked_by_river": "ADPR kigeyo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People slipped trying to cross",
  //       "notes_on_social_information": "Gisiza village don't have access to nkora market. Information gathered from theogene gisiza security leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkora",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iTAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burambo",
  //       "bridge_opportunity_project_code": "1013638",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.80494,
  //       "bridge_opportunity_gps_longitude": 29.30232,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6052,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.80494,
  //       "proposed_bridge_location_gps_longitude": 29.30232,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Fourdays",
  //       "market_access_blocked_by_river": "Nkore",
  //       "education_access_blocked_by_river": "Trinity secondary school and kigeyo primary and secondary school",
  //       "health_access_blocked_by_river": "Kivumu health center",
  //       "other_access_blocked_by_river": "Adventist church at kigeyo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, sugarcan",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "People slips on the current timber bridge and fall resulted them to be injured",
  //       "notes_on_social_information": "Nganzo people don't have access to market and school at kivumu. Information gathered from nganzo leader habimana yohani",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkore",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 69,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iTZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nganzo",
  //       "bridge_opportunity_project_code": "1013640",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.8054,
  //       "bridge_opportunity_gps_longitude": 29.29628,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6052,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8054,
  //       "proposed_bridge_location_gps_longitude": 29.29628,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "They pass through the road in a half kilometer away",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Nkora market and rwinyoni",
  //       "education_access_blocked_by_river": "Rwinyoni primary secondary school and kigeyo secondary school",
  //       "health_access_blocked_by_river": "Kimbiri health center and kivumu",
  //       "other_access_blocked_by_river": "Catholic church at rwinyoni",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "People fell in when it was flooded",
  //       "notes_on_social_information": "Nganzo community members don't have access nkora market. Information gathered from nganzo leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 77,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iUcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Manjanja",
  //       "bridge_opportunity_project_code": "1013643",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.91805,
  //       "bridge_opportunity_gps_longitude": 29.43911,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1373,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.91805,
  //       "proposed_bridge_location_gps_longitude": 29.43911,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Congo Nile market",
  //       "education_access_blocked_by_river": "Mujebeshi primary school",
  //       "health_access_blocked_by_river": "Rutsiro health center",
  //       "other_access_blocked_by_river": "Birambo Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two old men fell in when the river was flooded but they have survived",
  //       "notes_on_social_information": "Rutare village don't have access to rutsiro health center. Kagarama village dont have access to Congo Nile market. Information gathered from mbarinabo celestin",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 72,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iVLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musekera",
  //       "bridge_opportunity_project_code": "1013644",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.90752,
  //       "bridge_opportunity_gps_longitude": 29.44373,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1541,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.90752,
  //       "proposed_bridge_location_gps_longitude": 29.44373,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Muyira market",
  //       "education_access_blocked_by_river": "Rutsiro primary school",
  //       "health_access_blocked_by_river": "Murunda hospital and rutsiro health 6",
  //       "other_access_blocked_by_river": "Rutsiro cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "There is no current bridge where people could fall they do pass through the water and when it is flooded people stay where they are, no one can cross",
  //       "notes_on_social_information": "Birambo village don't have access to murunda hospital and nyakarambi village don't have access to muyira market. Information gathered from muyira leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Congo Nile",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iVVAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruvayaga",
  //       "bridge_opportunity_project_code": "1013649",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.85333,
  //       "bridge_opportunity_gps_longitude": 29.320833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1969,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85333,
  //       "proposed_bridge_location_gps_longitude": 29.320833,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nkora market",
  //       "education_access_blocked_by_river": "Gishwati primary school",
  //       "health_access_blocked_by_river": "Biruyi health center",
  //       "other_access_blocked_by_river": "Cothoric church on right hand side",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "In past five years a student fell in the river and got injured",
  //       "notes_on_social_information": "Market(mugara village), primary school (kamaranzara and karengera village ). Health center (mugara village ). Farms(mugara village, karengera village and kamaranzara village).Population information for each village was provided by biruyi cell leader and population of all adjacent communities including mushonyi sector was got from box. Population of all adjacent communities includes the following villages: kamaranzara, mugara,karengera and mushonyi sector. Mushonyi community members sometimes cross to visit relatives twice A month.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iWiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kayabaraza",
  //       "bridge_opportunity_project_code": "1013650",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.8577,
  //       "bridge_opportunity_gps_longitude": 29.3111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1118,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8577,
  //       "proposed_bridge_location_gps_longitude": 29.3111,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nkora market",
  //       "education_access_blocked_by_river": "Gishwati primary school",
  //       "health_access_blocked_by_river": "Biruyi health center",
  //       "other_access_blocked_by_river": "River hand side there is Adventist church and left hand side there is Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "pptato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "She fell in the river during flooded but she was drunk",
  //       "notes_on_social_information": "Market(buhunde) Sec school (buhunde and cyondo ). Health center (both cyondo and buhunde ). Farms(cyondo and buhunde).Population information for each village was provided by biruyi and kaguriro cell leaders . Population of all adjacent communities includes the following villages: cyondo, buhunde and kaguriro and biruyi cell.biruyi cell and kaguriro community members sometimes cross to visit market twice amonth.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 71,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iWsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kayabaraza 2",
  //       "bridge_opportunity_project_code": "1013651",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.855,
  //       "bridge_opportunity_gps_longitude": 29.31,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1010,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.855,
  //       "proposed_bridge_location_gps_longitude": 29.31,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "280 m",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nkora",
  //       "education_access_blocked_by_river": "Gishwati primary school",
  //       "health_access_blocked_by_river": "Biruyi health center",
  //       "other_access_blocked_by_river": "Church both sides [There is Catholic church on left side and Adventist church on right hand side]",
  //       "primary_occupations": "Fsrming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "People fell in the river when it was flooded one died but the two survived",
  //       "notes_on_social_information": "Market(buzukira), Sec school (buzikira ). Health center (biruyi). Farms(cyondo and buzukira).Population information for each village was provided by kaguriro cell leader habimana marcel who got the data from cell census that collected in July 2017. Population of all adjacent communities includes the following villages: cyondo,buzukira, kaguriro cell and biruyi cell.biruyi cell and kaguriro cell community members sometimes cross to visit relatives twice amonth.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iX2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nkurunziza",
  //       "bridge_opportunity_project_code": "1013973",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.48234,
  //       "bridge_opportunity_gps_longitude": 28.90941,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3614,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.48234,
  //       "proposed_bridge_location_gps_longitude": 28.90941,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "800 m",
  //       "days_per_year_river_is_flooded": 56,
  //       "flood_duration_during_rainy_season": "One days",
  //       "market_access_blocked_by_river": "Kamembe Market (MONT cyangugu)",
  //       "education_access_blocked_by_river": "Catholic primary and secondary school ( nkurunziza, gihundwe)",
  //       "health_access_blocked_by_river": "Gihundwe health center and Hospital (Mont Cyangugu)",
  //       "other_access_blocked_by_river": "District office ( Gihundwe sector) taxi park ( Mont cyangugu)",
  //       "primary_occupations": "Market, district office,",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of MONT cyangugu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1Tn3AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivumu-nyamugari",
  //       "bridge_opportunity_project_code": "1013653",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.85666,
  //       "bridge_opportunity_gps_longitude": 29.290277,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1530,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85666,
  //       "proposed_bridge_location_gps_longitude": 29.290277,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 hour",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Nkora market",
  //       "education_access_blocked_by_river": "Maziba primary school",
  //       "health_access_blocked_by_river": "Kimbiri health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "In rainy season the erosion meets with lake kivu and then people can't cross easily",
  //       "notes_on_social_information": "Market(maziba), primary school (kivumu). Health center (kivumu). Farms(maziba and kivumu).Population information for each village was provided by kaguriro cell vice leader yusufu ntacyobarimaza. Population of all adjacent communities includes the following villages. Kivumu and maziba and kaguriro. Kaguriro cell community members sometimes cross to visit market twice amonth at nkora.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkora",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 145,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iXMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakagezi-kariba",
  //       "bridge_opportunity_project_code": "1013655",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.84493,
  //       "bridge_opportunity_gps_longitude": 29.34447,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 635,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.84493,
  //       "proposed_bridge_location_gps_longitude": 29.34447,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Nyagahinika",
  //       "education_access_blocked_by_river": "Gs kinihira and gs rugaragara",
  //       "health_access_blocked_by_river": "Kinihira in rukaragate cell in kinihira village",
  //       "other_access_blocked_by_river": "ADPR butare in ruksragate",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "forest",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "People used to fall when it was flooded",
  //       "notes_on_social_information": "Kaboneye don't have access to kinihira school and hospital and rwamiyaga don't have access to Peru market . Information gathered from teacher",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iXgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Peru",
  //       "bridge_opportunity_project_code": "1013656",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.85047,
  //       "bridge_opportunity_gps_longitude": 29.33792,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1815,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85047,
  //       "proposed_bridge_location_gps_longitude": 29.33792,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Peru market",
  //       "education_access_blocked_by_river": "Ecole primary murambi",
  //       "health_access_blocked_by_river": "Kinihira hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "People fell in when the river was flooded",
  //       "notes_on_social_information": "Kaboneye don't have access to murambi school and rwamiyaga don't have access to Peru market. Information gathered from ntakirituminan Emmanuel",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 111,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iY5AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahotora",
  //       "bridge_opportunity_project_code": "1013657",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.84792,
  //       "bridge_opportunity_gps_longitude": 29.33218,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1450,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.84792,
  //       "proposed_bridge_location_gps_longitude": 29.33218,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Peru market",
  //       "education_access_blocked_by_river": "Groupe scolaire rugaragara",
  //       "health_access_blocked_by_river": "Biruyi hospital",
  //       "other_access_blocked_by_river": "ADPR gishwati",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "People fell in the river when it is flooded",
  //       "notes_on_social_information": "Rurimba dont have access to farms and rwamiyaga dont have access to peru market. Information gathered from ntakirutimana emmanuel",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iYPAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugamba",
  //       "bridge_opportunity_project_code": "1013659",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.8777,
  //       "bridge_opportunity_gps_longitude": 29.3219444,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1348,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8777,
  //       "proposed_bridge_location_gps_longitude": 29.3219444,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "30 minutes",
  //       "market_access_blocked_by_river": "Kinunu",
  //       "education_access_blocked_by_river": "Karugarika",
  //       "health_access_blocked_by_river": "Biruyi health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Young students fell in the river when it was flooded but they survived",
  //       "notes_on_social_information": "Gakomeye village doesn't have access to biruyi hospital and karugarika primary and secondary school And mashanya market. Kariba village doesn't have access to kinunu market and both villages doesn't have access to farms",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkomero",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iYjAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabeza",
  //       "bridge_opportunity_project_code": "1013660",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.87722,
  //       "bridge_opportunity_gps_longitude": 29.319444,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 484,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.87722,
  //       "proposed_bridge_location_gps_longitude": 29.319444,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "30 minutes",
  //       "market_access_blocked_by_river": "Mashanya market",
  //       "education_access_blocked_by_river": "Karugarika primary and secondary school",
  //       "health_access_blocked_by_river": "Biruyi health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "When it flooded children slip and fall",
  //       "notes_on_social_information": "Gakomeye village don't have access to mashanya market and biruyi hospital and karugarika primary and secondary school",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nkomero",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iZhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasoyo",
  //       "bridge_opportunity_project_code": "1013664",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.85645,
  //       "bridge_opportunity_gps_longitude": 29.36927,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2403,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.85645,
  //       "proposed_bridge_location_gps_longitude": 29.36927,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Gakeri market",
  //       "education_access_blocked_by_river": "Kavumu secondary school",
  //       "health_access_blocked_by_river": "Kayove hospital",
  //       "other_access_blocked_by_river": "ADPR gasoyo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "In past five years a Man fell when it was flooded and he died",
  //       "notes_on_social_information": "Information gathered from gasoyo village leader Pierre. Gakeri village don't have access to farms and church at gasoyo. Gasoyo village don't have access to gakeri market and kavumu school and kayove hospital.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 64.2,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iaLAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyinoni 2",
  //       "bridge_opportunity_project_code": "1013666",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.64738,
  //       "bridge_opportunity_gps_longitude": 29.80296,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1364,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.64738,
  //       "proposed_bridge_location_gps_longitude": 29.80296,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two weeks",
  //       "market_access_blocked_by_river": "Gakenke",
  //       "education_access_blocked_by_river": "Nemba secondary school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Kabaya don't have access to farms and kirehe and bukwete don't have access to gakenke market, Nemba school and Nemba hospital",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iaaAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamuhimba",
  //       "bridge_opportunity_project_code": "1013667",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.6279,
  //       "bridge_opportunity_gps_longitude": 29.79311,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 870,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6279,
  //       "proposed_bridge_location_gps_longitude": 29.79311,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Nemba primary and secondary school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "Church at Nemba",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "People fall in the river but they don't get hurt much",
  //       "notes_on_social_information": "Kaburusha don't have access to Nemba hospital and gakenke market. Kamuvunyi don't have access to farms. Information gathered from kamuvunyi leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iauAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Munyege",
  //       "bridge_opportunity_project_code": "1013669",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.61413,
  //       "bridge_opportunity_gps_longitude": 29.79371,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1136,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61413,
  //       "proposed_bridge_location_gps_longitude": 29.79371,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 26,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Nemba primary and secondary school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "Nemba church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "People fall in the river due to have a current bridge at high level",
  //       "notes_on_social_information": "Munyege village don't have access to Nemba hospital and gakenke market. Gisagara village don't have access to farms. Information gathered from hakundimana",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ibJAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugera",
  //       "bridge_opportunity_project_code": "1013671",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.79797,
  //       "bridge_opportunity_gps_longitude": 29.80379,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1340,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.79797,
  //       "proposed_bridge_location_gps_longitude": 29.80379,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Mbuye market",
  //       "education_access_blocked_by_river": "Groupe scolaire cyanika both primary and secondary school",
  //       "health_access_blocked_by_river": "Nyange health center",
  //       "other_access_blocked_by_river": "Cyanika cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One man has died in past seven years when he was trying to cross the river when it was flooded",
  //       "notes_on_social_information": "Kanduga don't have access to farms at mbogo and mbogo don't have access to cyanika school and muhanga market Information gathered from mbogo leader munyanziza faustin",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 125,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ibYAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukati",
  //       "bridge_opportunity_project_code": "1013674",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -1.86618,
  //       "bridge_opportunity_gps_longitude": 29.33919,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1071,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.86618,
  //       "proposed_bridge_location_gps_longitude": 29.33919,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Gakeri market",
  //       "education_access_blocked_by_river": "Groupe scolaire rugaragara",
  //       "health_access_blocked_by_river": "Biruyi hospital",
  //       "other_access_blocked_by_river": "Churches both sides",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People slips on the current bridge and fall",
  //       "notes_on_social_information": "Gasoro village don't have access to gakeri market and mukati village don't have access to Peru market and biruyi health center. Information gathered from mukati leader uwimana Fred",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakeri",
  //       "name_of_nearest_paved_or_sealed_road": "Rubavu-Rubengera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7icHAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakina",
  //       "bridge_opportunity_project_code": "1013675",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.64821,
  //       "bridge_opportunity_gps_longitude": 29.85487,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11408,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.64821,
  //       "proposed_bridge_location_gps_longitude": 29.85487,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Base market",
  //       "education_access_blocked_by_river": "Nyakina secondary school",
  //       "health_access_blocked_by_river": "Rutenderi health center",
  //       "other_access_blocked_by_river": "ADPR and EAR church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Due to the is near the cell office they have blocked the way",
  //       "notes_on_social_information": "Taba cell don't have access to police office and base market. Nyacyina cell don't have access to rutenderi health center. Information gathered from ndacyayisenga Martin",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Base",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7icMAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyondo",
  //       "bridge_opportunity_project_code": "1013676",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.62306,
  //       "bridge_opportunity_gps_longitude": 29.86773,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1768,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62306,
  //       "proposed_bridge_location_gps_longitude": 29.86773,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Base market",
  //       "education_access_blocked_by_river": "Cyondo primary and secondary school",
  //       "health_access_blocked_by_river": "Rutabo health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 8,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "When the river floods people fall people can't cross the river because the bridge got destroyed",
  //       "notes_on_social_information": "Masoro village don't have access to cyondo school and cyondo people don't have access to base market. Information gathered from nyakina leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Base",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 85,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7icRAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutenderi",
  //       "bridge_opportunity_project_code": "1013677",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.66137,
  //       "bridge_opportunity_gps_longitude": 29.84701,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1450,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66137,
  //       "proposed_bridge_location_gps_longitude": 29.84701,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Rutenderi primary school",
  //       "health_access_blocked_by_river": "Rutenderi health center",
  //       "other_access_blocked_by_river": "Rutenderi cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "When the river get floods people can't cross because the whole area is flooded",
  //       "notes_on_social_information": "Gihango village don't have access to rutenderi health center and school and murambo village don't have access to gakenke market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 78,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7icbAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryumuzungu",
  //       "bridge_opportunity_project_code": "1013679",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.76435,
  //       "bridge_opportunity_gps_longitude": 29.8756,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1274,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.76435,
  //       "proposed_bridge_location_gps_longitude": 29.8756,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Kinyari market",
  //       "education_access_blocked_by_river": "Karushashi secondary and primary school",
  //       "health_access_blocked_by_river": "Rwankuba hospital",
  //       "other_access_blocked_by_river": "ADPR church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "People slip and fall in the river trying to cross",
  //       "notes_on_social_information": "Bukwera don't have access to karushashi school and rwankuba hospital and kinyari market and ngambe village don't have access to farms . Information gathered from ndacyayisenga Isaac Ngambe village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 79,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7icqAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Congori",
  //       "bridge_opportunity_project_code": "1013681",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.79831,
  //       "bridge_opportunity_gps_longitude": 29.83496,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1171,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.79831,
  //       "proposed_bridge_location_gps_longitude": 29.83496,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 25,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Gitega market",
  //       "education_access_blocked_by_river": "Kabagenda secondary and primary school",
  //       "health_access_blocked_by_river": "Ruli hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One person has slidded and fell but he survived",
  //       "notes_on_social_information": "Murambi village don't have access to market, school and hospital and congoli don't have access to farms and cell office. Information gathered from murambi leader sagahutu sylveste",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 71,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7idtAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarutovu 2",
  //       "bridge_opportunity_project_code": "1013682",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.68267,
  //       "bridge_opportunity_gps_longitude": 29.67093,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 892,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.68267,
  //       "proposed_bridge_location_gps_longitude": 29.67093,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Vunga market",
  //       "education_access_blocked_by_river": "Janja primary and secondary school",
  //       "health_access_blocked_by_river": "Janja health center",
  //       "other_access_blocked_by_river": "Catholic church at janja",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 15,
  //       "incident_descriptions": "People usually slips on the current timber bridge and are likely to fall",
  //       "notes_on_social_information": "Kabuhoro village don't have access to kinoko center, vunga market, and Janja hospital. Kinoko village don't have access to farms",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Vunga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ieDAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamubuga",
  //       "bridge_opportunity_project_code": "1013684",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.61659,
  //       "bridge_opportunity_gps_longitude": 29.7064,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61659,
  //       "proposed_bridge_location_gps_longitude": 29.7064,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 49,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gaseke",
  //       "education_access_blocked_by_river": "Rubaga primary and secondary school",
  //       "health_access_blocked_by_river": "Busengo health center",
  //       "other_access_blocked_by_river": "Busengo Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "They slipped on the current bridge and fall",
  //       "notes_on_social_information": "Mwumba don't have access to rubaga school. Rubaga don't have access to busengo hospital and gaseke market Information gathered from Kirwa leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ieXAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusenyi",
  //       "bridge_opportunity_project_code": "1013685",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.62252,
  //       "bridge_opportunity_gps_longitude": 29.70826,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1550,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62252,
  //       "proposed_bridge_location_gps_longitude": 29.70826,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gaseke",
  //       "education_access_blocked_by_river": "Rubaga primary and secondary school",
  //       "health_access_blocked_by_river": "Busengo health center",
  //       "other_access_blocked_by_river": "Busengo Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "People fall due to gaseke river when is flooded moves with pressure",
  //       "notes_on_social_information": "Mwumba village don't have access to Gaseke village Rubaga village don't have access to busengo. Information gathered from community farming at the site",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 105,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iecAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mubatarugera",
  //       "bridge_opportunity_project_code": "1013686",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.61835,
  //       "bridge_opportunity_gps_longitude": 29.7302,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1550,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.61835,
  //       "proposed_bridge_location_gps_longitude": 29.7302,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Kivuruga",
  //       "education_access_blocked_by_river": "Kamina primary and secondary school",
  //       "health_access_blocked_by_river": "Busengo health center",
  //       "other_access_blocked_by_river": "Kanyirabutare cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "farming",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "A man and A kid have died when they were trying to cross when the river was flooded",
  //       "notes_on_social_information": "Rugandabari village don't have access to busengo hospital Mwendo village don't have access to rwungo market and farms. Information gathered from rurakabije venat community member",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 121,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7iewAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Miraramo",
  //       "bridge_opportunity_project_code": "1013688",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rutsiro",
  //       "bridge_opportunity_gps_latitude": -2.0312,
  //       "bridge_opportunity_gps_longitude": 29.39964,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0312,
  //       "proposed_bridge_location_gps_longitude": 29.39964,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rubengera",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The have a pedestrian bridge they do need avehecular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ifBAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabutaka kwamuvara",
  //       "bridge_opportunity_project_code": "1013689",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.66377,
  //       "bridge_opportunity_gps_longitude": 29.80285,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1510,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66377,
  //       "proposed_bridge_location_gps_longitude": 29.80285,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Musave primary and secondary school",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "Nemba church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Busingigi don't have access to farms at Gitenga Gitenga don't have access to gakenke market. Information gathered from community member .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 95,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ifGAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirebe",
  //       "bridge_opportunity_project_code": "1013690",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.63772,
  //       "bridge_opportunity_gps_longitude": 29.81581,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1838,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63772,
  //       "proposed_bridge_location_gps_longitude": 29.81581,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "45 minutes",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Kirebe primary and secondary school",
  //       "health_access_blocked_by_river": "Bukunga health center",
  //       "other_access_blocked_by_river": "Nemba church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "A kid died in past five years when the river was flooded",
  //       "notes_on_social_information": "Bukunga village don't have access to gakenke market. Bikes to village don't have access to school. Information gathered from community member",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 82.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7igsAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ndurumu",
  //       "bridge_opportunity_project_code": "1013691",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.62681,
  //       "bridge_opportunity_gps_longitude": 29.80387,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1820,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62681,
  //       "proposed_bridge_location_gps_longitude": 29.80387,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Gakenke market",
  //       "education_access_blocked_by_river": "Mushubi market",
  //       "health_access_blocked_by_river": "Nemba hospital",
  //       "other_access_blocked_by_river": "Nemba church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "A person was drunk and slipped on the bridge and died",
  //       "notes_on_social_information": "Kirebe village don't have access to farms Nyabigugu village don't have access to gakenke market and mushubi school Information gathered from community farming around",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 79,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ihbAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nkondo",
  //       "bridge_opportunity_project_code": "1013693",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.9314,
  //       "bridge_opportunity_gps_longitude": 30.60922,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2471,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. There is an all weather crossing 300 meters away and the river is fairly small and likely would not warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9314,
  //       "proposed_bridge_location_gps_longitude": 30.60922,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "0.235 kilometers",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Akayebe and Gihinga are blocked to the Market",
  //       "education_access_blocked_by_river": "Akayebe and Gihinga are blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "Akayebe and Gihinga are blocked to the hospital and health center",
  //       "other_access_blocked_by_river": "Akayebe and Gihinga are blocked to the churches, sector office",
  //       "primary_occupations": "Market, hospital, farms",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Nkondo",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is closer to the road 235 meter away",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7j9uAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bisayu2",
  //       "bridge_opportunity_project_code": "1013694",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.46159,
  //       "bridge_opportunity_gps_longitude": 29.82579,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1426,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.27",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.46159,
  //       "proposed_bridge_location_gps_longitude": 29.82579,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "700 m",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Not blocked to market",
  //       "education_access_blocked_by_river": "Kajerijeri and Karorero are blocked Primary and secondary school",
  //       "health_access_blocked_by_river": "Karorero and Kajerijeri are blocked to Butaro Hospital",
  //       "other_access_blocked_by_river": "Kajerijeri and Karorero are blocked to sector office",
  //       "primary_occupations": "School, farms, cell and sector",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The one who is in charge of sector of Bisayu community and people who live closer to the bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jAsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngundu",
  //       "bridge_opportunity_project_code": "1013695",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.45343,
  //       "bridge_opportunity_gps_longitude": 29.85064,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1952,
  //       "bridge_opportunity_comments": "Site Rejected. This seems like an irrigation floodplain. To span the full floodplain the bridge would likely need to be 230m+ suspension bridge. The water does not appear to flood that high given the width of the floodplain. A causeway would be more appropriate.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.45343,
  //       "proposed_bridge_location_gps_longitude": 29.85064,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None, but they can walk where the mountain can meet and it takes one hour to be there",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "Two months during rain season April and Mai, they can't cross",
  //       "market_access_blocked_by_river": "Kamukondo, ruhurura ya 1 and Bumbu are blocked to the Market in Kirambo and butaro",
  //       "education_access_blocked_by_river": "Kamukondo, ruhurura ya 1 and Bumbu are blocked to the Rutoro secondary and primary school",
  //       "health_access_blocked_by_river": "Kamukondo, ruhurura ya 1 and Bumbu are blocked to the post health center",
  //       "other_access_blocked_by_river": "Kamukondo, ruhurura ya 1 and Bumbu are blocked to the churches",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and two of them were community leader of Kamukondo and Ngundu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Musanze Kigali",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The span will be 230 meters and",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 230,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jAxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murori",
  //       "bridge_opportunity_project_code": "1013697",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.91118,
  //       "bridge_opportunity_gps_longitude": 30.56047,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2871,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.91118,
  //       "proposed_bridge_location_gps_longitude": 30.56047,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "One month",
  //       "market_access_blocked_by_river": "Nyabisindu and Burori to the Kayonza market",
  //       "education_access_blocked_by_river": "Nyabisindu and Burori to the Kirambo 1 primary and secondary school",
  //       "health_access_blocked_by_river": "Nyabisindu and Burori to the health center",
  //       "other_access_blocked_by_river": "Nyabisindu and Burori to the bus park",
  //       "primary_occupations": "School, farms, health center",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They were trying to cross the igishanga and fell, down and being handicapped",
  //       "notes_on_social_information": "Community leaders of of Murori",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jB7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwamiko~Gitwa",
  //       "bridge_opportunity_project_code": "1013699",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.286079,
  //       "bridge_opportunity_gps_longitude": 29.17952,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8374,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.286079,
  //       "proposed_bridge_location_gps_longitude": 29.17952,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometers.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Communities 3 is blocked to Rugali cows market, communities 1&2 are blocked to Gitwa small cattle, communities 1&2 are blocked to Gitwa border to congo.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to Muramba secondary school Ordinary level and Rusozi primary school. communities 3 is blocked to Hanika primary school.",
  //       "health_access_blocked_by_river": "Community 3 is blocked to Hanika health center.",
  //       "other_access_blocked_by_river": "Community 3 is blocked to Hanika Catholic church, communities 1&2 do have access to church in Gitwa.",
  //       "primary_occupations": "Farming and livestock ( cows and fishes)",
  //       "primary_crops_grown": "cassava, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by Rugari cell leader, Ndagijimana Eric who sourced the population information from cell register i 2018. Sometimes the people from Ijwi island use the bridge to visit Rugari cows market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jCAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rumamfu~Mugeyo",
  //       "bridge_opportunity_project_code": "1013702",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.337668,
  //       "bridge_opportunity_gps_longitude": 29.186374,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2617,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.337668,
  //       "proposed_bridge_location_gps_longitude": 29.186374,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometers away.",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "March to April, October to December, 3 hours",
  //       "market_access_blocked_by_river": "Communities 1&2 do have access to kirambo market and susa market. Community 3 do have access to Gatare market. Communities 1&2 are blocked to farms in kanjongo sector. Community 3 do have access to farms in Macuba sector.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to Groupe scholaire Cyavuma( Primary and secondary school Ordinary level ). Communities 3 is blocked to Rumamfu primary school.",
  //       "health_access_blocked_by_river": "Community 3 do not have access to Rumamfu dispensary, communities 1&2 are blocked to susa health center.",
  //       "other_access_blocked_by_river": "Communities 3 do not have access to cyavuma church.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": ", cassava, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by nyakabingo cell leader, Sehorana Bismark who sourced the population information from cell register of each villages in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamanseke~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jCPAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karubanda",
  //       "bridge_opportunity_project_code": "1014281",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.08084,
  //       "bridge_opportunity_gps_longitude": 29.91191,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3490,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08084,
  //       "proposed_bridge_location_gps_longitude": 29.91191,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Mugina",
  //       "education_access_blocked_by_river": "Riyumba high school",
  //       "health_access_blocked_by_river": "Nyamiyaga health center",
  //       "other_access_blocked_by_river": "EPR riyumba",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet occured",
  //       "notes_on_social_information": "Karubanda village dont have access to mugina market Information gathered from village member",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kumugina",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekgHAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mutongo",
  //       "bridge_opportunity_project_code": "1013703",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.288204,
  //       "bridge_opportunity_gps_longitude": 29.197543,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3734,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.288204,
  //       "proposed_bridge_location_gps_longitude": 29.197543,
  //       "current_crossing_method": "None but now they cross over dam.",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away.",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 12 hours",
  //       "market_access_blocked_by_river": "Communities 3&4 do not have access to Gatare market. Communities 1&2 do not have access to Rugari cows market, communities 1&2 are blocked to farms in villages 3&4 , the same as community 3&4 do not have access to farms in villages 1&2.",
  //       "education_access_blocked_by_river": "Communities 1&2 do not have access to Hanika primary school , communities 3&4 do not have access to Mutongo primary school.",
  //       "health_access_blocked_by_river": "Communities 3&4 do not have access to Gatare health center.",
  //       "other_access_blocked_by_river": "Communities Hanika church. Community 3 is blocked cell office.",
  //       "primary_occupations": "Farming and livestock.",
  //       "primary_crops_grown": "coffee ric, pineapple.",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Mutongo cell leader, who sourced them from the cell register done in 2017 during Ubudehe program .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jCUAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabeza",
  //       "bridge_opportunity_project_code": "1013704",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.89013,
  //       "bridge_opportunity_gps_longitude": 30.61139,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3695,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.89013,
  //       "proposed_bridge_location_gps_longitude": 30.61139,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away",
  //       "days_per_year_river_is_flooded": 86,
  //       "flood_duration_during_rainy_season": "14 days",
  //       "market_access_blocked_by_river": "Kigarama is blocked Gasarabwayi market",
  //       "education_access_blocked_by_river": "Kigarama is blocked to Gasarabwayi Primary school and Kabukeye secondary schools",
  //       "health_access_blocked_by_river": "Kigarama is blocked to the health center",
  //       "other_access_blocked_by_river": "Kigarama is blocked to sector and cell offices",
  //       "primary_occupations": "School, Market,",
  //       "primary_crops_grown": "maiz, soghrom",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Kabeza and people who was crossing river",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 67,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jCeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mutembo",
  //       "bridge_opportunity_project_code": "1013705",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.96456,
  //       "bridge_opportunity_gps_longitude": 30.66115,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2269,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. A vehicular bridge is needed and this is a small stream that would not warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.96456,
  //       "proposed_bridge_location_gps_longitude": 30.66115,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None, they still cross the river",
  //       "days_per_year_river_is_flooded": 86,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "Umuyenzi and Rwarurema are blocked to the Market",
  //       "education_access_blocked_by_river": "Umuyenzi and Rwarurema are blocked to the primary and secondary school",
  //       "health_access_blocked_by_river": "Mutembo and is blocked post health center",
  //       "other_access_blocked_by_river": "Umuyenzi and Rwarurema are blocked to the churches",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "banana plantain",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Rwarurema and Mutembo",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jCtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kazeneza",
  //       "bridge_opportunity_project_code": "1013706",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.06686,
  //       "bridge_opportunity_gps_longitude": 30.62524,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1862,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06686,
  //       "proposed_bridge_location_gps_longitude": 30.62524,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "4 kilometers",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "7 days",
  //       "market_access_blocked_by_river": "Kazeneza is blocked to the Market",
  //       "education_access_blocked_by_river": "Rugunga is blocked to primary and secondary school",
  //       "health_access_blocked_by_river": "Kazeneza is blocked to Health center",
  //       "other_access_blocked_by_river": "Kazeneza is blocked to sector office",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jCyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gikombe",
  //       "bridge_opportunity_project_code": "1013707",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.0901,
  //       "bridge_opportunity_gps_longitude": 30.65996,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1603,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0901,
  //       "proposed_bridge_location_gps_longitude": 30.65996,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Gikombe and Gahama are blocked to Market",
  //       "education_access_blocked_by_river": "On both side there are primary school but Rompuhwe is blocked to secondary schools",
  //       "health_access_blocked_by_river": "Rompuhwe is blocked to the post health center",
  //       "other_access_blocked_by_river": "Gikombe is blocked churches",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "banana plantain, tomato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was trying to cross the river and found died",
  //       "notes_on_social_information": "Community leaders of of Rompuhwe and Gikombe and people who live closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jDNAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarukore",
  //       "bridge_opportunity_project_code": "1013708",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.5066,
  //       "bridge_opportunity_gps_longitude": 29.99458,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1416,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.5066,
  //       "proposed_bridge_location_gps_longitude": 29.99458,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in one kilometer away",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "On both side there are market but Murambo and Nyarukore often used Rubaya market",
  //       "education_access_blocked_by_river": "School are on both side, communities choose where they want",
  //       "health_access_blocked_by_river": "Health center on both side communities choose where they want",
  //       "other_access_blocked_by_river": "None because left and right of river are different district",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Murambo",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi city",
  //       "name_of_nearest_paved_or_sealed_road": "Gatuna Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jDXAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sangabuzi",
  //       "bridge_opportunity_project_code": "1013709",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.47722,
  //       "bridge_opportunity_gps_longitude": 29.94955,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1807,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.47722,
  //       "proposed_bridge_location_gps_longitude": 29.94955,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Both side have market, they choose where they want , but it where Sangabuzi, Rubayu, Kivumu pass to Uganda Market",
  //       "education_access_blocked_by_river": "School are both side and they cross river depends where they want",
  //       "health_access_blocked_by_river": "Health center on both side",
  //       "other_access_blocked_by_river": "Munshunga is Blocked to the churches",
  //       "primary_occupations": "Business center, churches, markets, to Uganda",
  //       "primary_crops_grown": "bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They were trying to cross the river and found died",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge and one of them was chief of Security of Sangabuzi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jDcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyahera",
  //       "bridge_opportunity_project_code": "1013710",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Burera",
  //       "bridge_opportunity_gps_latitude": -1.43601,
  //       "bridge_opportunity_gps_longitude": 29.85018,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 964,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.43601,
  //       "proposed_bridge_location_gps_longitude": 29.85018,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge ten kilometers away",
  //       "days_per_year_river_is_flooded": 123,
  //       "flood_duration_during_rainy_season": "Seven days",
  //       "market_access_blocked_by_river": "Cyahera and Gahunge are blocked to the Market of Kirambo",
  //       "education_access_blocked_by_river": "Both side have schools but students of Cyahera na Gahunge choose Kirambo secondary school",
  //       "health_access_blocked_by_river": "No side is blocked to hospital",
  //       "other_access_blocked_by_river": "Cyahera and Gahunge are blocked to district office",
  //       "primary_occupations": "Market, school, district,",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information was given by the people lived closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jDhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muhozi",
  //       "bridge_opportunity_project_code": "1013711",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.9054,
  //       "bridge_opportunity_gps_longitude": 30.55323,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3654,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. River is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9054,
  //       "proposed_bridge_location_gps_longitude": 30.55323,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded the whole day",
  //       "market_access_blocked_by_river": "Muhozi and Ryakibanda are blocked to market",
  //       "education_access_blocked_by_river": "School are both side and they cross river depends where they want",
  //       "health_access_blocked_by_river": "Muhozi and Ryakibanda are blocked to Health center",
  //       "other_access_blocked_by_river": "Muhozi and Ryakibanda are blocked to potable water",
  //       "primary_occupations": "Fetch water, Market,",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Muhozi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded the whole day",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jDwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyifuzo",
  //       "bridge_opportunity_project_code": "1013791",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.65975,
  //       "bridge_opportunity_gps_longitude": 29.72655,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1600,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65975,
  //       "proposed_bridge_location_gps_longitude": 29.72655,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "5 hours",
  //       "market_access_blocked_by_river": "Murambo market and murwungo market",
  //       "education_access_blocked_by_river": "Rwingoma primary school and rutaki high school",
  //       "health_access_blocked_by_river": "Rutaki health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "People slip and fall in when river is flooded",
  //       "notes_on_social_information": "Murambo market, rutaki secondary school and rutaki hospital [cyifuzo village ], murwungo market and rwingoma primary school [mugando village ] .Information gathered from cyifuzo village leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 141,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wuvAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryashyomba",
  //       "bridge_opportunity_project_code": "1013712",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.12346,
  //       "bridge_opportunity_gps_longitude": 29.40763,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3907,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12346,
  //       "proposed_bridge_location_gps_longitude": 29.40763,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 100,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Nzabuhara village , nyarusange village , buye village, Rwintare village don't have access to kibuye market",
  //       "education_access_blocked_by_river": "Nzabuhara village , nyarusange village , buye village, Rwintare village don't have access to Gitesi primary school",
  //       "health_access_blocked_by_river": "People are not using bridge site to go to health centers they use roads",
  //       "other_access_blocked_by_river": "Nzabuhara village , nyarusange village , buye village, Rwintare village don't have access to Gitesi memorial site & Gitesi Catholic church & Ruhundo Adventist church .",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One injury in 2016 , person coming from bar at Gitesi",
  //       "notes_on_social_information": "Buye village leader is the one who provided information about directly individual served , by referring to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jE1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamatabaro",
  //       "bridge_opportunity_project_code": "1013713",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.14826,
  //       "bridge_opportunity_gps_longitude": 29.46926,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3917,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14826,
  //       "proposed_bridge_location_gps_longitude": 29.46926,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Karwiru village, rurumbu village, rusekera village don't have access to gasenyi market , and Rwungu village don't have access to BIRAMBO market.",
  //       "education_access_blocked_by_river": "Karwiru village, rurumbu village, rusekera village don't have access to GS Gahengeri, and Rwungu village don't have access to Gasharu primary school.",
  //       "health_access_blocked_by_river": "Karwiru village, rurumbu village, rusekera village don't have access to Gasenyi health center , and Rwungu village don't have access to birambo health center",
  //       "other_access_blocked_by_river": "Karwiru village, rurumbu village, rusekera village don't have access to Gahengeri Catholic church and Rwungu village don't have access to rurumbu Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Young student coming from GS Gahengeri",
  //       "notes_on_social_information": "Karwiru village leader provided the info about direct individual served, he referred to the population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi _ Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jEBAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Senga",
  //       "bridge_opportunity_project_code": "1013714",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.0824,
  //       "bridge_opportunity_gps_longitude": 29.4245,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4329,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0824,
  //       "proposed_bridge_location_gps_longitude": 29.4245,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 127,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Senga village , bugobera village , Kamihaho village , muvungu village , and kagari village don't have access to Rubengera market and Kibuye market",
  //       "education_access_blocked_by_river": "Senga village , bugobera village , Kamihaho village , muvungu village , and kagari village don't have access to GS Bubazi and GS Ruragwe",
  //       "health_access_blocked_by_river": "Senga village , bugobera village , Kamihaho village , muvungu village , and kagari village don't have access to Kirambo health center",
  //       "other_access_blocked_by_river": "Senga village , bugobera village , Kamihaho village , muvungu village , and kagari village don't have access to ADEPR bubazi & EPER Nyagatovu",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "No death here , but 3 injuries . Many people far in river and some times luckily don't get injured",
  //       "notes_on_social_information": "Gitega cell leader provided all info about directly individual served by the bridge , she referred to the population cesnsu of 2018 and she called all village leaders to know their number of population",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jEGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitindo",
  //       "bridge_opportunity_project_code": "1013715",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.335284,
  //       "bridge_opportunity_gps_longitude": 29.184096,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1949,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.335284,
  //       "proposed_bridge_location_gps_longitude": 29.184096,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 2 hours",
  //       "market_access_blocked_by_river": "Communities 3 do not have access to kirambo market and Rugari market. Communities 3 do not have access to Bizi Rwanda coffee factory. Communities 1&2 do not have access to farms in kanjongo and communities 3 do not have access to farms in vugangoma.",
  //       "education_access_blocked_by_river": "Communities 3 do not have access to cyavuma primary school.",
  //       "health_access_blocked_by_river": "Communities 1&2 do not have access to Ruheru health center.",
  //       "other_access_blocked_by_river": "Communities 3 do not have access to cyavuma church.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by vugangoma cell leader, Pateick, who sourced them from the cell register done in 2018 in Ubudehe program.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 2.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jELAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruganzu",
  //       "bridge_opportunity_project_code": "1013716",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.319874,
  //       "bridge_opportunity_gps_longitude": 29.161228,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2680,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.319874,
  //       "proposed_bridge_location_gps_longitude": 29.161228,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "March April , October to November, 12 hours",
  //       "market_access_blocked_by_river": "Communities 3&4 do not have access to Rugari market and Kirambo market. Communities 3&4 do not have access to Kanya coffe factory. Communities 1&2 do not have access to farms in Ruganzu, communities 3&4 do not have access to farms in Kigarama cell.",
  //       "education_access_blocked_by_river": "Communities 3&4 do not have access to Muraza primary school and Muraza secondary school.",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Communities 3&4 do not have access to Muraza ADPR parish church, communities 1&2 do not have access to kanjongo sector office.",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, coffe",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Two students fell down and drowned, two community members who were going to the market also fell down on the rock and died.",
  //       "notes_on_social_information": "Population information of each village was provided by kigoya cell leader, Thierry hategekimana, who sourced the population information from cell register in 2017 in Ubudehe program. Population of all adjacent communities includes the following villages: Ruganzu, Museke, Kajumiro and Murambi. Communities members from Kajumiro and Murambi sometimes use the bridge to bring the coffee to Kanjongo coffee factory.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jEQAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo",
  //       "bridge_opportunity_project_code": "1013720",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.18681,
  //       "bridge_opportunity_gps_longitude": 29.42727,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3724,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18681,
  //       "proposed_bridge_location_gps_longitude": 29.42727,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 88,
  //       "flood_duration_during_rainy_season": "2 hours",
  //       "market_access_blocked_by_river": "Rucura village , kivumu village don't have acess to Gasenyi market , while musango village & nyarushekera village ,mahembe village don't have access to mukungu market",
  //       "education_access_blocked_by_river": "Rucura village , kivumu village don't have acess to GS Musango",
  //       "health_access_blocked_by_river": "Rucura village , kivumu village don't have acess to Musango health center",
  //       "other_access_blocked_by_river": "Rucura village , kivumu village don't have acess to Musango church , while musango village & nyarushekera village ,mahembe village don't have access to kivumu adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people fall in river",
  //       "notes_on_social_information": "Mahembe village leader is the one who gave me information about individual directly served, he referred to 2017 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jEkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitongo",
  //       "bridge_opportunity_project_code": "1013722",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.312095,
  //       "bridge_opportunity_gps_longitude": 29.149186,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1030,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. A vehicular bridge is desired and the river is likely too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.312095,
  //       "proposed_bridge_location_gps_longitude": 29.149186,
  //       "current_crossing_method": "None, there was vehicular bridge but the timber washed away by the flood.",
  //       "nearest_all_weather_crossing_point": "Vehicular road four hundred meters away.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "All the information was provided by kigoya cell leader, hategekimana Thierry after visiting the site together.",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jF9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivumu",
  //       "bridge_opportunity_project_code": "1013725",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.59149,
  //       "bridge_opportunity_gps_longitude": 29.75931,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2477,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.59149,
  //       "proposed_bridge_location_gps_longitude": 29.75931,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 hours",
  //       "market_access_blocked_by_river": "Huye Town and Matyazo Markets, Huye Taxi Park (Community 1,2,3,4,5), Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "VTC Rwabuye Secondary School (Community 1,2,3,4,5)",
  //       "health_access_blocked_by_river": "Huye Health Center (Community 1,2,3,4,5)",
  //       "other_access_blocked_by_river": "Huye Stadium (Community 1,2,3,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potatoes., ric",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "4 people died trying to cross the river all of them during rainy season and more than 50 people have been falling into the river but were not injuried.",
  //       "notes_on_social_information": "Population information for each village was provided by the Duwani Cell Leader, Mukakarangwa Cartas, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jHFAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gaseke",
  //       "bridge_opportunity_project_code": "1013726",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.59415,
  //       "bridge_opportunity_gps_longitude": 29.77829,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3182,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.59415,
  //       "proposed_bridge_location_gps_longitude": 29.77829,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Rwanza and Huye Town Markets (Community 1,2,3,4), Gisagara Market (Community 5)",
  //       "education_access_blocked_by_river": "Ndora Primary and Secondary School (Community 1,2,3,4), Kinteko Primary School (Community 5)",
  //       "health_access_blocked_by_river": "Duwani Health Post (Community 1,2,3,4), Bweya Health Center (Community 5)",
  //       "other_access_blocked_by_river": "Kinteko Adventist church (Community 1,2,3,4), Gisanze ADEPR church (Community 5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, beans., maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population information for each village was provided by the Duwani cell Leader, Mukakarangwa Cartas , from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jHKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabogoti",
  //       "bridge_opportunity_project_code": "1013727",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.64711,
  //       "bridge_opportunity_gps_longitude": 29.80976,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2305,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.64711,
  //       "proposed_bridge_location_gps_longitude": 29.80976,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Rango Market (Community 1,2,3), Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "No education access blocked by river",
  //       "health_access_blocked_by_river": "Kibirizi District Hospital, Kibirizi Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Kibirizi Sector Office, Kibirizi Catholic Parish (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population information for each village was provided by the Ruturo cell Leader, Hakuzimana Jean Paul, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jHPAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigarama",
  //       "bridge_opportunity_project_code": "1013728",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.65762,
  //       "bridge_opportunity_gps_longitude": 29.81981,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2975,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.65762,
  //       "proposed_bridge_location_gps_longitude": 29.81981,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 6,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Kibayi, Gatunda and Mukindo Markets (Community 1,2,3,4), Gisagara Market (Community 5), Farms (Community 1,2,5)",
  //       "education_access_blocked_by_river": "No education access blocked by river",
  //       "health_access_blocked_by_river": "Kibirizi District Hospital and Kibirizi Health Center (Community 1,2,3,4)",
  //       "other_access_blocked_by_river": "ADEPR Karama Church (Community 5), Baziro Adventist church and Kibirizi Sector Office (Community 1,2,3,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people have been falling into the river, mostly motorcyclists or bicyclists trying to cross the river. No serious injuries.",
  //       "notes_on_social_information": "Population information for each village was provided by the Ruturo cell Leader, Jean Paul Hakuzimana from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jHyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyogo",
  //       "bridge_opportunity_project_code": "1013729",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.56425,
  //       "bridge_opportunity_gps_longitude": 29.78521,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3079,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.56425,
  //       "proposed_bridge_location_gps_longitude": 29.78521,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Rwanza, Ruhashya and Huye Town Markets (Community 1,2,3), Gisagara and Musha Markets (Community 4,5)",
  //       "education_access_blocked_by_river": "Save Secondary School, TTC Save Secondary School, Ste Bernadette Secondary School, Immaculée Conception Secondary School (1,2,3)",
  //       "health_access_blocked_by_river": "Save Health Center (Community 1,2 3)",
  //       "other_access_blocked_by_river": "Munazi ADEPR and Adventist Churches, Gisagara District Office, Save Sector Office (Community 4,5), Save Catholic Parish (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, vegetables.",
  //       "river_crossing_deaths_in_last_3_years": 50,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "None of the people who have been falling into the river was injuried. Only one person died trying to cross the river and was drunk. Normally when it's flooded people use a vehicular bridge which is 1km upstream.",
  //       "notes_on_social_information": "Population information for each village was provided by the Munazi cell Leader, Muhire Manasseh, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jI3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ingirakamaro",
  //       "bridge_opportunity_project_code": "1013730",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.57166,
  //       "bridge_opportunity_gps_longitude": 29.78138,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2751,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57166,
  //       "proposed_bridge_location_gps_longitude": 29.78138,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "0.8 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 hours",
  //       "market_access_blocked_by_river": "Rwanza and Huye Town Markets (Community 1,2,3), Gisagara Market (Community 4), Farms (All Communities )",
  //       "education_access_blocked_by_river": "Munazi Primary School (Community 4), Most of Save Secondary Schools :TTC Save, Ste Bernadette, Immaculée Conception and Save Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Save Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Munazi ADEPR and Adventist Churches, Save Sector Office, Gisagara District Office (Community 4), Save Catholic Parish (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "People have been falling into the river when trying to cross, but no serious injuries.",
  //       "notes_on_social_information": "Population information for each village was provided by the Munazi cell Leader,, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jI8AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakagezi",
  //       "bridge_opportunity_project_code": "1013731",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.55904,
  //       "bridge_opportunity_gps_longitude": 29.83055,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2647,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.55904,
  //       "proposed_bridge_location_gps_longitude": 29.83055,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 hours",
  //       "market_access_blocked_by_river": "Gasagara and Rwanza Markets (Community 4), Musha and Ntyazo Markets (Community 1,2,3), Farms (Community 1,4)",
  //       "education_access_blocked_by_river": "Tamba Primary School (Community 4)",
  //       "health_access_blocked_by_river": "Musha Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Musha ADEPR and Adventist Churches (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, pea, potato, tomato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population information for each village was provided by the Zivu cell Leader assistant, Nirere Pascasie , from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jIDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihonga",
  //       "bridge_opportunity_project_code": "1013793",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.64305,
  //       "bridge_opportunity_gps_longitude": 29.67318,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1709,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.64305,
  //       "proposed_bridge_location_gps_longitude": 29.67318,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Gaseke market, biziba market",
  //       "education_access_blocked_by_river": "Groupe scolaire gakenke",
  //       "health_access_blocked_by_river": "Gatonde health center and janja hospital",
  //       "other_access_blocked_by_river": "Rusasa cothoric church and Adventist church at bukerera",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They slip on the current bridge and fall",
  //       "notes_on_social_information": "Biziba market, Gaseke market and gatonde health center [bukerera village ]. Nemba hospital and GS Gakenke [rurambi village ]. Information gathered from local people.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 77,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wv5AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyirakimene",
  //       "bridge_opportunity_project_code": "1013732",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.52261,
  //       "bridge_opportunity_gps_longitude": 29.86105,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6360,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.52261,
  //       "proposed_bridge_location_gps_longitude": 29.86105,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Musha and Gisagara Markets (Community 4,5), Farms (Community 2,3,4)",
  //       "education_access_blocked_by_river": "Musha Adventist Secondary School (Community 4,5), Gatovu Primary School (Community 2)",
  //       "health_access_blocked_by_river": "Musha Health Center (Community 4), Gikonko Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Musha Anglican, ADEPR and Catholic churches (Community 4,5), Gisagara District Office (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population information for each village was provided by the Gatovu cell Leader, Twahirwa Gerard, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jIIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Runigiro",
  //       "bridge_opportunity_project_code": "1013733",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.51012,
  //       "bridge_opportunity_gps_longitude": 29.86378,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2378,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.51012,
  //       "proposed_bridge_location_gps_longitude": 29.86378,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Musha and Gisagara Markets (Community 2,3), Gikonko Market (Community 1), Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "Gikonko Primary and Secondary School (Community 1)",
  //       "health_access_blocked_by_river": "Gikonko Health Center (Community 1)",
  //       "other_access_blocked_by_river": "Gisagara District Office (Community 2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population information for each village was provided by the Gatovu cell Leader, Twahirwa Gerard, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jINAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabasore",
  //       "bridge_opportunity_project_code": "1013734",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.4919,
  //       "bridge_opportunity_gps_longitude": 29.85804,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2248,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4919,
  //       "proposed_bridge_location_gps_longitude": 29.85804,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Gikonko Market (Community 1,3), Musha and Gisagara Markets (Community 2)",
  //       "education_access_blocked_by_river": "Gikonko Primary and Secondary School (Community 1,3)",
  //       "health_access_blocked_by_river": "Gikonko Health Center (Community 1,3)",
  //       "other_access_blocked_by_river": "Gikonko Catholic, ADEPR and Adventist Churches (Community 1,3), Gisagara District Office (Community 2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population information for each village was provided by the Gatovu cell Leader, Twahirwa Gerard, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7jISAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibuye",
  //       "bridge_opportunity_project_code": "1013745",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.64805,
  //       "bridge_opportunity_gps_longitude": 30.01587,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4343,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.64805,
  //       "proposed_bridge_location_gps_longitude": 30.01587,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Community 1,2,3dont ahave access to Miyove Market, community 4,5 don't have access to Kisaro market, Buyoga market",
  //       "education_access_blocked_by_river": "Community 1,2,3, don't have access to Rumuri Primary and Gakenke secondary school",
  //       "health_access_blocked_by_river": "Community 1,2,3 don't have access to Kinihira health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Tea plantation workers, farmers on both sides and traders at Miyove and Lisa to markets",
  //       "primary_crops_grown": "maiz, potato, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kisaro market (Community 4,5);Buyoga market (Community 4,5); Miyove market (Community1,2,3 ) Kinihira health center ( Community 1,2,3) Rumuri Primary school, Gakenke secondary schools (Community1,2,3 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base-Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kfSAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo",
  //       "bridge_opportunity_project_code": "1013746",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.8472,
  //       "bridge_opportunity_gps_longitude": 30.02041,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4418,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8472,
  //       "proposed_bridge_location_gps_longitude": 30.02041,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "5 hours",
  //       "market_access_blocked_by_river": "Communities 4don't have access to Bweramvura market, communities 4 don't have access to crushed stones sites",
  //       "education_access_blocked_by_river": "Communities 1,2,3, don't have access to Kigarama Primary school, communities 1,2,3 don't have access to Bubangu secondary school",
  //       "health_access_blocked_by_river": "Communities 4 don't have access to Bubangu health center",
  //       "other_access_blocked_by_river": "Communities 4 don't have access to Catholic church",
  //       "primary_occupations": "Crushed stones workers, Farmers and traders at Bweramvura",
  //       "primary_crops_grown": "banana, bean, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People got injuries due to slipping and fall in the river",
  //       "notes_on_social_information": "Bweramvura market which is open twice a week ( Community 4), Bubangu health center ( Community 4), Kigarama Primary school ( Community 1,2,3 ), Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7khOAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bitare",
  //       "bridge_opportunity_project_code": "1013748",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.82989,
  //       "bridge_opportunity_gps_longitude": 29.92981,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2841,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.82989,
  //       "proposed_bridge_location_gps_longitude": 29.92981,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "0",
  //       "market_access_blocked_by_river": "Communities 1,2,3don't have access to to Rwahi market, Communities 1,2,3 don't have access to to brick making site in Muvumu",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to to Taba Primary school and communities 1,2,3 don't have access to Barakatsi school",
  //       "health_access_blocked_by_river": "Communities 4,5 don't have access to Taba health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Bricks making workers, farmers on both sides and traders at Rwahi market",
  //       "primary_crops_grown": "banana, bean, maize on small scal",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rwahi market which is open twice a week ( Community 1,2,3), Taba health center ( Community 4,5), Taba Primary school ( Community 4,5 ), Barakatsi school ( Community 1,2,3 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kk8AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigarama",
  //       "bridge_opportunity_project_code": "1013749",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.78679,
  //       "bridge_opportunity_gps_longitude": 29.93873,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.78679,
  //       "proposed_bridge_location_gps_longitude": 29.93873,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge, and currently this road is used",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kkDAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gifumba",
  //       "bridge_opportunity_project_code": "1013750",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.83904,
  //       "bridge_opportunity_gps_longitude": 29.97107,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5300,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.83904,
  //       "proposed_bridge_location_gps_longitude": 29.97107,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 hours",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to to Shyorongi market, communities 1 don't have access to Kajevuba market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Nkanga primary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Shyorongi health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Coffee workers and distrubuter at Coffee factory, farmers on both sides and traders at Shyorongi and Kajevuba market.",
  //       "primary_crops_grown": "bean, coffee in ngoma sector, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Five people were injured when trying to cross the river",
  //       "notes_on_social_information": "Shyorongi market which is open twice a week ( Community 2 ), Kajevuba market which is open weekly ( Community 1 ), Shyorongi health center ( Community 2 ), Nkanga Primary school ( Community2 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected at the beginning of the 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kkNAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuye",
  //       "bridge_opportunity_project_code": "1013751",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.79607,
  //       "bridge_opportunity_gps_longitude": 29.9438,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1961,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.79607,
  //       "proposed_bridge_location_gps_longitude": 29.9438,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "8 hours",
  //       "market_access_blocked_by_river": "Communities 2,3 don't have access to Kirenge market and communities 1 don't have access to Nturo market",
  //       "education_access_blocked_by_river": "Communities 2,3 don't have access to Nkanga primary, Kanye nursery and Rukinga secondary school",
  //       "health_access_blocked_by_river": "Communities 2,3 don't have access to Kinini Health center",
  //       "other_access_blocked_by_river": "Communities 1 don't have access to Protestants church in Munini",
  //       "primary_occupations": "Coffee workers and distrubuter at Kinini coffee factory",
  //       "primary_crops_grown": "coffe, maiz, potato, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Four people were injured either a leg or an arm when trying to cross the river",
  //       "notes_on_social_information": "Kirenge market which is open every week (Community 2,3 ), Nturo market which is open every week( community 1); Nkanga primary, Kabuye nursery and Rukinga secondary school ( Community 2,3 ); Munini Protestants church ( Community 1 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kibali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kl1AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karenge",
  //       "bridge_opportunity_project_code": "1013752",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.83068,
  //       "bridge_opportunity_gps_longitude": 29.90837,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2772,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.83068,
  //       "proposed_bridge_location_gps_longitude": 29.90837,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "45 minutes",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Muhondo market",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to Gitanda primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 4,5 don't have access to Gitanda health center",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to church in Muhondo",
  //       "primary_occupations": "Farmers on both side, Traders at Muhondo market",
  //       "primary_crops_grown": "maiz, sweet potatoes., vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Muhondo market which is open twice a week ( Community1,2,3 ); Gitanda primary and secondary school ( Community 4,5 ); Taba health center ( Community 4,5), Bwenda school ( Community 1,2,3) Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kmJAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinini/health center",
  //       "bridge_opportunity_project_code": "1013753",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.77387,
  //       "bridge_opportunity_gps_longitude": 29.93239,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3356,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.77387,
  //       "proposed_bridge_location_gps_longitude": 29.93239,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Kirenge market, communities 2 don't have access to Gasiza market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Kinini Primary and secondary school (G.S. Rukingu) and Kinini school of disabled people",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Kinini Health center",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to Kinini Catholic church",
  //       "primary_occupations": "Farmers on both side, traders at kirenge market",
  //       "primary_crops_grown": "cabbag, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people were injured when trying to cross the river by slipping on timber and fall in the river",
  //       "notes_on_social_information": "Kirenge market which is open twice a week (Community 2); Kinini Health center (Community2 ); Kinini/G.S.Rukingu(Community2 ); Gisiza market which is open twice a week ( Community 2 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kmYAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinini",
  //       "bridge_opportunity_project_code": "1013754",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.75492,
  //       "bridge_opportunity_gps_longitude": 29.92516,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4460,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.75492,
  //       "proposed_bridge_location_gps_longitude": 29.92516,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "45 days",
  //       "market_access_blocked_by_river": "Communities2 don't have access to kirenge market , communities 1 don't have access to Remera market , communities don't have access to Kinini Coffee factory",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Kinini school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Kinini Health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Daily farmers on both sides and traders at kirenge market",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kinini market which is open twice a week ( Community 2), Kinini coffee factory ( Community 2), Kinini School ( Community 2 ), Kinini Health center ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kmxAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutabo",
  //       "bridge_opportunity_project_code": "1013755",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.66643,
  //       "bridge_opportunity_gps_longitude": 30.03168,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2552,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.66643,
  //       "proposed_bridge_location_gps_longitude": 30.03168,
  //       "current_crossing_method": "Bridge in timber with 2 logs",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities1,2 don't have access to Buyoga market",
  //       "education_access_blocked_by_river": "Communities 1,2 don't have access to Sayo primary and secondary school",
  //       "health_access_blocked_by_river": "Communities don't have access to Sayo health center",
  //       "other_access_blocked_by_river": "Communities 3,4 don't have access to Kisaro sector office",
  //       "primary_occupations": "Farmers on both side and traders at Buyoga market",
  //       "primary_crops_grown": "potato, sweet potato, vegetables (cabbages)",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Sayo health center ( Community 1,2), Sayo primary and secondary school ( Community 1,2), Buyoga market ( Community 1,2), Rutabo health center ( Community 3,4), Kisaro sector office ( Community 3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base_Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7knHAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karwa",
  //       "bridge_opportunity_project_code": "1013756",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.83463,
  //       "bridge_opportunity_gps_longitude": 30.04618,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.83463,
  //       "proposed_bridge_location_gps_longitude": 30.04618,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge, the river have been damaged",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7knMAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rumuri",
  //       "bridge_opportunity_project_code": "1013757",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.63989,
  //       "bridge_opportunity_gps_longitude": 30.01374,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2488,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63989,
  //       "proposed_bridge_location_gps_longitude": 30.01374,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "none",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 4 don't have access to Kisaro market, communities 1, 2,3 don't have access to Miyove Market , communities 1,2,3 don't have access to Kinihira Tea factory",
  //       "education_access_blocked_by_river": "Communities1,2,3 don't have access to Rumuri Primary and Gakenke secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3 don't have access to Kinihira health center",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to Catholic and Protestant Church, communities 4 don't have access to Potable water source",
  //       "primary_occupations": "Potatoes, beans, carrots and maize",
  //       "primary_crops_grown": "farmers on both sid, kisaro market, tea plantation worker, traders at miyov",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kisaro market which is open twice a week ( Community 4), Kisaro Primary and secondary school ( Community 4), Rumuri Primary school ( Community 1,2,3), Kinihira Tea Factory ( communities 1,2,3) , Potable water ( Community 4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gicumbi",
  //       "name_of_nearest_paved_or_sealed_road": "Base_Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7kngAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinaba",
  //       "bridge_opportunity_project_code": "1013758",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.74472,
  //       "bridge_opportunity_gps_longitude": 29.53323,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1200,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.74472,
  //       "proposed_bridge_location_gps_longitude": 29.53323,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is a place that is crossed all the time ,the only problem is land slide",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ko0AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyabihira",
  //       "bridge_opportunity_project_code": "1013759",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyabihu",
  //       "bridge_opportunity_gps_latitude": -1.74404,
  //       "bridge_opportunity_gps_longitude": 29.53444,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3873,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.74404,
  //       "proposed_bridge_location_gps_longitude": 29.53444,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "600 m",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Communities 1 don't have access to Kabaya market, communities 1 don't have access to Kabaya tea factory",
  //       "education_access_blocked_by_river": "Communities 1 don't have access to to St Raphael Kabaya school",
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Kabaya Hospital",
  //       "other_access_blocked_by_river": "Communities 1 don't have access to Kabaya Catholic church and Protestants church",
  //       "primary_occupations": "Tea plantation workers, traders at Kabaya market and daily farmers on both sides",
  //       "primary_crops_grown": "forest, tea plantation, vegetables (cabbages)",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river, one died and 3 people were injured",
  //       "notes_on_social_information": "Kabaya market which is open every day ( Community 1), Kabaya Hospital ( Community 1 ), Kabaya Tea factory ( Community 1), St Raphael Kabaya school ( Community 1 ), Kabaya churches ( Community 1). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in January 2018. Population of adjacent communities include some other villages of Nkomane cell that the proposed bridge will be the best option to use",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Mukamira-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7koKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Iraro",
  //       "bridge_opportunity_project_code": "1013763",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.77748,
  //       "bridge_opportunity_gps_longitude": 30.01516,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2846,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.77748,
  //       "proposed_bridge_location_gps_longitude": 30.01516,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "40 minutes",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities1 and 3 don't have access to Remera market, communities 2and 4 don't have access to Mugambazi market; Communities 2, 4 don't have access to cassetarite mine site",
  //       "education_access_blocked_by_river": "Communities 2 and 4 don't have access to Budakiranya primary school, communities 2, 4 don't have access to Kanyoni secondary schools",
  //       "health_access_blocked_by_river": "Communities 1 and 3 don't have access to Remera Health center and Rutongo hospital",
  //       "other_access_blocked_by_river": "Communities2, 4 don't have access to Protestants and Catholic churches",
  //       "primary_occupations": "Cassetarite mine workers, farmers and traders at Remera market",
  //       "primary_crops_grown": "cabbage ), potato, sweet potato, vegetables (carrot",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Sliding on existing timber bridge when the river is flooded and fell into the river , one passed away after being drowned and two were injured",
  //       "notes_on_social_information": "Budakiranya primary school ( Community 2,4 ), Kanyoni Primary and secondary school ( Community 2,4); Mugambazi market which is open twice a week ( Community 2,4),Remera market which is open twice a week ( Community 1,3) Rutongo hospital and Remera Health center ( Community 1,3); Cassetarite mine ( Community 2,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ktKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahama",
  //       "bridge_opportunity_project_code": "1013764",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Rulindo",
  //       "bridge_opportunity_gps_latitude": -1.795,
  //       "bridge_opportunity_gps_longitude": 30.03292,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 520,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.9.28",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.795,
  //       "proposed_bridge_location_gps_longitude": 30.03292,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge, every day is crossed and",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ktZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mubahayo",
  //       "bridge_opportunity_project_code": "1013772",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.18591,
  //       "bridge_opportunity_gps_longitude": 29.43513,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4002,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18591,
  //       "proposed_bridge_location_gps_longitude": 29.43513,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "8 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 days of flood",
  //       "market_access_blocked_by_river": "People from Mutuntu sector don't have access to Gasenyi market while people from Rwankuba sector don't have access to mukungu market",
  //       "education_access_blocked_by_river": "People from Rwankuba sector don't have access to GS Gasango , while people from Mutuntu sector don't have access to GS Musango",
  //       "health_access_blocked_by_river": "People from Rwankuba sector don't have access to rusango health center , while people from Mutuntu village don't have access to Musango health center",
  //       "other_access_blocked_by_river": "People from Mutuntu sector don't have access to Musango Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "No death on injuries",
  //       "notes_on_social_information": "Musango village leader provided the information about direct individual served and he referred to 2018 population census , he also called other village leader to confirm their number of population",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wXTAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryampande",
  //       "bridge_opportunity_project_code": "1013775",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.16427,
  //       "bridge_opportunity_gps_longitude": 29.41347,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10007,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.16427,
  //       "proposed_bridge_location_gps_longitude": 29.41347,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 89,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Nyarushekera village, himbo village and rukore village don't have access to Kivuruga market",
  //       "education_access_blocked_by_river": "Nyarushekera village, himbo village and rukore village don't have access to GS Burega",
  //       "health_access_blocked_by_river": "No health movements on this site",
  //       "other_access_blocked_by_river": "Nyarushekera village, himbo village and rukore village don't have access to Rwankuba sector HQ and Burega church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, maiz, tea",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "A women who was crossing the river",
  //       "notes_on_social_information": "Nyakamira cell leader is the one who provided information about directly individuals served, by calling on phones the village leaders to confirm number of their population . They referred to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wXiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagasozi",
  //       "bridge_opportunity_project_code": "1013778",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.08015,
  //       "bridge_opportunity_gps_longitude": 29.4189,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11383,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08015,
  //       "proposed_bridge_location_gps_longitude": 29.4189,
  //       "current_crossing_method": "Cemented timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Muvungu village , Nyagasozi village , and Kigarama village don't have access to kibirizi market",
  //       "education_access_blocked_by_river": "Muvungu village , Nyagasozi village , and Kigarama village don't have access to Nyagatovu primary school",
  //       "health_access_blocked_by_river": "Nyagatovu village , bunyankungu village and rwimpongo village don't have access to bubazi health center",
  //       "other_access_blocked_by_river": "Muvungu village , Nyagasozi village , and Kigarama village don't have access to EPR kibirizi church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People fall in the river during the night hours",
  //       "notes_on_social_information": "Nyagasozi village leader provided the information about direct individual served and referred to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi _ Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wY2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigarama",
  //       "bridge_opportunity_project_code": "1013779",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.0924,
  //       "bridge_opportunity_gps_longitude": 29.44834,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4026,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0924,
  //       "proposed_bridge_location_gps_longitude": 29.44834,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Kigarama village , Karambo village ,migina village don't have access to Rubengera market while bugoberi village ,Nyagasozi village don't have access to gashinge market",
  //       "education_access_blocked_by_river": "Kigarama village , Karambo village ,migina village don't have access to GS Bubazi",
  //       "health_access_blocked_by_river": "Kigarama village , Karambo village ,migina village don't have access to bubazi health center",
  //       "other_access_blocked_by_river": "Kigarama village , Karambo village ,migina village don't have access to Gitega cell office and ADEPR Bugoberi",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Two people died last heavy rain",
  //       "notes_on_social_information": "Kamata village leader provided so, info about individual served , referred to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wY7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Byimana3",
  //       "bridge_opportunity_project_code": "1014403",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.109384,
  //       "bridge_opportunity_gps_longitude": 30.433798,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.109384,
  //       "proposed_bridge_location_gps_longitude": 30.433798,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Small drainage channel on a vehecular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0bAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisiza",
  //       "bridge_opportunity_project_code": "1013780",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.08381,
  //       "bridge_opportunity_gps_longitude": 29.45655,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3536,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08381,
  //       "proposed_bridge_location_gps_longitude": 29.45655,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Migina village , bihembe village, Kigarama village don't have access to Rubengera market, while kibande village , gitwa village , mukimba village to have access to Gashinge market",
  //       "education_access_blocked_by_river": "Migina village , bihembe village, Kigarama village don't have access to ES Rugabano",
  //       "health_access_blocked_by_river": "Migina village , bihembe village, Kigarama village don't have access to Rugabano health center",
  //       "other_access_blocked_by_river": "Migina village , bihembe village, Kigarama village don't have access to Karongi district office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two injuries",
  //       "notes_on_social_information": "Kamata village leader provided info about directly individual served after call other village leader using the bridge they all referred to he population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wYHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ntarabana",
  //       "bridge_opportunity_project_code": "1013781",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.13355,
  //       "bridge_opportunity_gps_longitude": 29.5053,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3318,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.13355,
  //       "proposed_bridge_location_gps_longitude": 29.5053,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 65,
  //       "flood_duration_during_rainy_season": "7 hours of flood",
  //       "market_access_blocked_by_river": "Ntarabana village , Musasa village , kabasare village and kagangare village don't have access to Gashari market",
  //       "education_access_blocked_by_river": "Ntarabana village , Musasa village , kabasare village and kagangare village don't have access to",
  //       "health_access_blocked_by_river": "Ntarabana village , Musasa village , kabasare village and kagangare village don't have access to birambo health center",
  //       "other_access_blocked_by_river": "Ntarabana village , Musasa village , kabasare village and kagangare village don't have access to Birsmbo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Some injuries but to the hospital",
  //       "notes_on_social_information": "Rubona village leader provided all info about directly individual served by refering to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wYMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubona",
  //       "bridge_opportunity_project_code": "1013782",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.13374,
  //       "bridge_opportunity_gps_longitude": 29.50472,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3768,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.13374,
  //       "proposed_bridge_location_gps_longitude": 29.50472,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Rubona village, Rugabano village , gitwa village , kamina village don't have access to Gashari market",
  //       "education_access_blocked_by_river": "Rubona village, Rugabano village , gitwa village , kamina village don't have access to GS Kabirizi",
  //       "health_access_blocked_by_river": "Rubona village, Rugabano village , gitwa village , kamina village don't have access to birambo health center",
  //       "other_access_blocked_by_river": "Rubona village, Rugabano village , gitwa village , kamina village don't have access to birambo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "People become injured to this river",
  //       "notes_on_social_information": "Rubona village leader provided info about directly individual served after calling other village leaders , they referred to the population census if 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wYRAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamwenda",
  //       "bridge_opportunity_project_code": "1013783",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.1213,
  //       "bridge_opportunity_gps_longitude": 29.48652,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4201,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1213,
  //       "proposed_bridge_location_gps_longitude": 29.48652,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Wurugogwe village , Gitega village, bubazi village and fatako village don't have access to Birambo market , while Kirabo village, Karambi village and Gasharu village don't have access to Rugabano market .",
  //       "education_access_blocked_by_river": "Wurugogwe village , Gitega village, bubazi village and fatako village don't have access to EP Kirabo , while Kirabo village, Karambi village and Gasharu village don't have access to GS Rugabano",
  //       "health_access_blocked_by_river": "Kirabo village, Karambi village and Gasharu village don't have access to Rugabano health center",
  //       "other_access_blocked_by_river": "Kirabo village, Karambi village and Gasharu village don't have access to Rugabano Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Student from EP Kirabo",
  //       "notes_on_social_information": "Kirabo security village chief is the one who provided information about individual served he called different village leaders , they referred to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wYWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakabingo",
  //       "bridge_opportunity_project_code": "1013784",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.12557,
  //       "bridge_opportunity_gps_longitude": 29.48183,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 987,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12557,
  //       "proposed_bridge_location_gps_longitude": 29.48183,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "People only want vehicle bridge to be constructed",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wYgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabyaza",
  //       "bridge_opportunity_project_code": "1013785",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.11554,
  //       "bridge_opportunity_gps_longitude": 29.47351,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11064,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.6",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11554,
  //       "proposed_bridge_location_gps_longitude": 29.47351,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 58,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Ruhinga cell and Gitega cell don't have access to Rugabano market",
  //       "education_access_blocked_by_river": "Kirabo village and winzira village don't have access to Gs Karambo",
  //       "health_access_blocked_by_river": "Ruhinga cell and Gitega cell don't have access to Rugabano Health center",
  //       "other_access_blocked_by_river": "Kirabo village and winzira village don't have access to Karambo Methodist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A woman who was crossing the river",
  //       "notes_on_social_information": "Kirabo village security officer provided info about directly individual served by referring to the population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wYlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyiryamo",
  //       "bridge_opportunity_project_code": "1013787",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.68275,
  //       "bridge_opportunity_gps_longitude": 29.74224,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1230,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.68275,
  //       "proposed_bridge_location_gps_longitude": 29.74224,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Murambo market",
  //       "education_access_blocked_by_river": "Kiryamo primary school",
  //       "health_access_blocked_by_river": "Rutaki health center",
  //       "other_access_blocked_by_river": "ADPR karama",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Student fall in the river when it is flooded",
  //       "notes_on_social_information": "Rugege don't have access to murambo market and rutaki health center. Rugarama don't have access to farms. Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 84,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wubAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugambazi",
  //       "bridge_opportunity_project_code": "1013788",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.72692,
  //       "bridge_opportunity_gps_longitude": 29.72306,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2188,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.72692,
  //       "proposed_bridge_location_gps_longitude": 29.72306,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Mataba market",
  //       "education_access_blocked_by_river": "Mataba secondary school",
  //       "health_access_blocked_by_river": "Mataba health center",
  //       "other_access_blocked_by_river": "Church at gitoki",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "In past six years one person died trying to cross when the river was flooded",
  //       "notes_on_social_information": "Mataba market, mataba health center, and mataba school[gitoki, rubayo and nyagasozi]. Nyangoma village don't only have access to farms. Information gathered from local people and cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 108,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wugAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gikokwe",
  //       "bridge_opportunity_project_code": "1013789",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.67796,
  //       "bridge_opportunity_gps_longitude": 29.70261,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1100,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67796,
  //       "proposed_bridge_location_gps_longitude": 29.70261,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Murambo market",
  //       "education_access_blocked_by_river": "Kivune primary school and rutaki high school",
  //       "health_access_blocked_by_river": "Rutaki health center",
  //       "other_access_blocked_by_river": "Janja Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One person has fallen and died in past six years",
  //       "notes_on_social_information": "Gihororo village don't have access to kivune school and rutaki hospital Gitovu village don't have access to janja church Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 87,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wulAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyimbogo",
  //       "bridge_opportunity_project_code": "1013794",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.81602,
  //       "bridge_opportunity_gps_longitude": 29.85876,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2190,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.81602,
  //       "proposed_bridge_location_gps_longitude": 29.85876,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "They use abridge far in two hours",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Muhondo market",
  //       "education_access_blocked_by_river": "Muasagara high school",
  //       "health_access_blocked_by_river": "Ruli hospital",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "As they cross by passing through the water people slips on stones and get injured",
  //       "notes_on_social_information": "Kimbogo village don't have access to ruli hospital and ngayaki village don't have access to muhondo market. Information gathered from local elder peson",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 98,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wvAAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kugasumo",
  //       "bridge_opportunity_project_code": "1013795",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.56001,
  //       "bridge_opportunity_gps_longitude": 29.69342,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1700,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.56001,
  //       "proposed_bridge_location_gps_longitude": 29.69342,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Four hours",
  //       "market_access_blocked_by_river": "Mukinga market",
  //       "education_access_blocked_by_river": "Apedu high school, kwitsinda high school",
  //       "health_access_blocked_by_river": "Rwaza health center",
  //       "other_access_blocked_by_river": "Rwaza cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "One died coming from school",
  //       "notes_on_social_information": "Tongoburi don't have access to school and gakoro and gihango don't have access to mukunga market. Information gathered from muhororo cell leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 79,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wvFAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kumusenyi",
  //       "bridge_opportunity_project_code": "1013796",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.5905,
  //       "bridge_opportunity_gps_longitude": 29.7052,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.5905,
  //       "proposed_bridge_location_gps_longitude": 29.7052,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "2days",
  //       "market_access_blocked_by_river": "Bazira market and gaseke market",
  //       "education_access_blocked_by_river": "Muramba high school",
  //       "health_access_blocked_by_river": "Kamisave health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "People slips as the bridge is on high elevation and easily fall down",
  //       "notes_on_social_information": "Ntaraga village don't have access to Gaseke market . Nyamugari don't have access to bazira market. Information gathered from rukore leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 140,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wvKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigembe",
  //       "bridge_opportunity_project_code": "1013797",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.62963,
  //       "bridge_opportunity_gps_longitude": 29.65738,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2386,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.62963,
  //       "proposed_bridge_location_gps_longitude": 29.65738,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two weeks",
  //       "market_access_blocked_by_river": "Cyinkware market",
  //       "education_access_blocked_by_river": "Rusasa primary school",
  //       "health_access_blocked_by_river": "Nyamuteri health center",
  //       "other_access_blocked_by_river": "Rusasa cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, sugar can",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "One old man died trying to cross in 1978",
  //       "notes_on_social_information": "Gapfura and gakindo village don't have access vunga market Bukiza village don't have access to rusasa school. Information gathered from local people around",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Vunga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 107,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wvZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kugatare",
  //       "bridge_opportunity_project_code": "1013798",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.5932,
  //       "bridge_opportunity_gps_longitude": 29.70506,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1370,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.5932,
  //       "proposed_bridge_location_gps_longitude": 29.70506,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Six hours",
  //       "market_access_blocked_by_river": "Masha market and bazira, and gaseke market",
  //       "education_access_blocked_by_river": "Muramba high school",
  //       "health_access_blocked_by_river": "Kamisave health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "People slips trying to cross the current bridge",
  //       "notes_on_social_information": "Ntaraga village don't have access to Gaseke market. Information gathered from rukore cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musanze",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 134,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wveAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirombe",
  //       "bridge_opportunity_project_code": "1013799",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.63737,
  //       "bridge_opportunity_gps_longitude": 29.65462,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1768,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63737,
  //       "proposed_bridge_location_gps_longitude": 29.65462,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Gashusha",
  //       "education_access_blocked_by_river": "Mugunga high school",
  //       "health_access_blocked_by_river": "Mugunga health center",
  //       "other_access_blocked_by_river": "ADPR church at gapfura",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato, yam",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "People used to slip on current bridge and fall",
  //       "notes_on_social_information": "Gapfura do t have access to gashusha market and karuhunge village don't have access to Gaseke market. Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Vunga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 86,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wvjAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kubahamya",
  //       "bridge_opportunity_project_code": "1013800",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.73494,
  //       "bridge_opportunity_gps_longitude": 29.85478,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1542,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.73494,
  //       "proposed_bridge_location_gps_longitude": 29.85478,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Kinyari market at rushashi",
  //       "education_access_blocked_by_river": "Kiruku high school",
  //       "health_access_blocked_by_river": "Rushashi health center",
  //       "other_access_blocked_by_river": "Rushashi cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Only one person fell in but he did get injured",
  //       "notes_on_social_information": "Kabuye village don't have access to rushashi center and rushashi hospital Karambi don't have access to kiruku high school Information gathered from kageyo cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rushashi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wvoAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Razi",
  //       "bridge_opportunity_project_code": "1013801",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.69699,
  //       "bridge_opportunity_gps_longitude": 29.86647,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1871,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.69699,
  //       "proposed_bridge_location_gps_longitude": 29.86647,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "20 minutes",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Gisiza market",
  //       "education_access_blocked_by_river": "Mugera primary school",
  //       "health_access_blocked_by_river": "Muyongwe health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Gikongoro village don't have access to base market and taking a village don't have access to rushashi marker6 Information gathered from gikongoro leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rushashi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7wvtAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mbizi",
  //       "bridge_opportunity_project_code": "1013802",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.72314,
  //       "bridge_opportunity_gps_longitude": 29.84565,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1888,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.72314,
  //       "proposed_bridge_location_gps_longitude": 29.84565,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Kinyari market",
  //       "education_access_blocked_by_river": "Gangi primary and kiruku high school, Eave rushashi",
  //       "health_access_blocked_by_river": "Rushashi health center",
  //       "other_access_blocked_by_river": "Rushashi cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato, sugarcan, tomato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "As the bridge is at high elevation they slip and fall",
  //       "notes_on_social_information": "Kara village don't have access to tare primary school, gatwa village don't have access to rushashi market. Information gathered from gatwa leader",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rushashi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ww3AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabere",
  //       "bridge_opportunity_project_code": "1013803",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Northern Province",
  //       "bridge_opportunity_level2_government": "Gakenke",
  //       "bridge_opportunity_gps_latitude": -1.69199,
  //       "bridge_opportunity_gps_longitude": 29.70148,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 650,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.10.7",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.69199,
  //       "proposed_bridge_location_gps_longitude": 29.70148,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "They always cross",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "0",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Information gathered from local people",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Gakenke",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7ww8AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarukurazo",
  //       "bridge_opportunity_project_code": "1013804",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.7242,
  //       "bridge_opportunity_gps_longitude": 29.75411,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3437,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7242,
  //       "proposed_bridge_location_gps_longitude": 29.75411,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Mburamazi, Busoro and Huye Town Markets (Community 4,5), Farms (Community 1,2,4)",
  //       "education_access_blocked_by_river": "Kansi Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Kansi Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Kansi Catholic Parish (Community 4,5), ADEPR Gatare (Community 1,2), potable water (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, pea, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "3 people died when trying to cross the river, all these incidents happened during rainy season when the river floods.",
  //       "notes_on_social_information": "Nyarukurazo, Nyarunyinya, Akatera, Gasharu and Gatare villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Rusagara Cell Leader, Jean de Dieu Ndayishimiye, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 1.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5AAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rususa",
  //       "bridge_opportunity_project_code": "1013807",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.74102,
  //       "bridge_opportunity_gps_longitude": 29.85624,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5175,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.74102,
  //       "proposed_bridge_location_gps_longitude": 29.85624,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Agatunda market (Community 1,2,3), Farms (Community 4,5)",
  //       "education_access_blocked_by_river": "Magi Primary School (Community 4)",
  //       "health_access_blocked_by_river": "Mukomacara Health Post (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Rususa Adventist church (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maize., potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rususa, Gatare, Butare, Nturubuye, Nyabikoni, Akaboti and Agatunda villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Nyabisagara Cell Leader, Mukamisha Laetitia, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5PAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Maheresho",
  //       "bridge_opportunity_project_code": "1013808",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.77338,
  //       "bridge_opportunity_gps_longitude": 29.75503,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2879,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.77338,
  //       "proposed_bridge_location_gps_longitude": 29.75503,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Nyaruteja Market (Community 3,4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Ruhororo Primary School and Higiro Secondary School (Community 3,4,5)",
  //       "health_access_blocked_by_river": "Remera Health Post (Community 1), Kigembe Health Center (Community 3,4,5)",
  //       "other_access_blocked_by_river": "Higiro Catholic, Adventist and ADEPR Churches, Nyanza Sector Office and Umubanga Cell Office (Community 3,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Maheresho, Akinyana, Urukeri, Akamabuye and Remera villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches, sector office, cell office and schools . Population information for each village was provided by the Umubanga Cell Leader, Kubwimana Esperance, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5ZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akagano",
  //       "bridge_opportunity_project_code": "1013809",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.78075,
  //       "bridge_opportunity_gps_longitude": 29.74108,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2490,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. River is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.78075,
  //       "proposed_bridge_location_gps_longitude": 29.74108,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Nyaruteja Market (Community 1,2,3), Farms (Community 1,4)",
  //       "education_access_blocked_by_river": "Ruhororo Primary School (Community 5), Rusongati Primary School and Higiro Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Kigembe Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Higiro Catholic and ADEPR Churches, Nyanza Sector Office (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Akinyana, Manyoni, Karwishyura and Kabakene villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Umubanga Cell Leader, Kubwimana Esperance, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru )",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The area was flooded by stormwater coming from the uphill road and it was dangerous during rainy season but now water has been channelled away and there is no river to cross.",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5eAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarunyinya",
  //       "bridge_opportunity_project_code": "1013810",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.7234,
  //       "bridge_opportunity_gps_longitude": 29.76373,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2631,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7234,
  //       "proposed_bridge_location_gps_longitude": 29.76373,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Mburamazi and Huye markets (Community 3,4), Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Janja Primary School (Community 3,4)",
  //       "health_access_blocked_by_river": "Kansi Health Center (Community 3,4)",
  //       "other_access_blocked_by_river": "ADEPR Gatare (Community 1,2), Kansi Catholic Parish (Community 3,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, cabbag, cassava, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "2 people died trying to cross the river during rainy season.",
  //       "notes_on_social_information": "Nyarukurazo, Nyarunyinya, Gasharu and Gatare villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Rusagara Cell Leader, Jean de Dieu Ndayishimiye, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru )",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5jAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabinyenga",
  //       "bridge_opportunity_project_code": "1013811",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.70198,
  //       "bridge_opportunity_gps_longitude": 29.81289,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5029,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.70198,
  //       "proposed_bridge_location_gps_longitude": 29.81289,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Mburamazi, Rango and Nyaruteja Markets (Community 1,2,3), Kabuga Market (Community 4,5), Farms (Community 1,2,4)",
  //       "education_access_blocked_by_river": "Kansi Secondary Schools (Community 1,2,3), Mugombwa Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Gikori Health Center and Kibirizi District Hospital (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Nyarukeri Adventist church, ADEPR Baziro church and Mugombwa Catholic Church (Community 4,5), Kansi Catholic Parish, Gisagara District Office (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, tobacco",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "5 people have died trying to cross the river during rainy season.",
  //       "notes_on_social_information": "Nyabinyenga, Nyamirama, Nyagatovu, Nyagahuru, Nyamure, Ruburanjwiri, Gisororo, Rwimbogo, and Gatare villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Baziro Cell Leader, Umuhoza Pacifique, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5oAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akadogo",
  //       "bridge_opportunity_project_code": "1013812",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.70192,
  //       "bridge_opportunity_gps_longitude": 29.76218,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2941,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.70192,
  //       "proposed_bridge_location_gps_longitude": 29.76218,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 hours",
  //       "market_access_blocked_by_river": "Mburamazi, Huye, Rango and Busoro Markets (Community 1,2,3,4), Farms (Community 1,2,5)",
  //       "education_access_blocked_by_river": "Kansi Primary and Secondary School, St Bernard and St Francois d'Assise Secondary Schools (Community 1,2,3,4),",
  //       "health_access_blocked_by_river": "Kansi Health Center (Community 1,2,3,4)",
  //       "other_access_blocked_by_river": "Kansi Catholic Parish and ADEPR Kansi (Community 1,2,3,4), Impinga ADEPR and Adventist Churches (Community 5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "Many people have been falling into the river trying but were not injuried.",
  //       "notes_on_social_information": "Akadogo, Akakijugujugu, Nyarunyinya and Gatare (Kansi) villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Impinga cell leader, Mukaremera Christine amd the Rusagara Cell Leader, Jean de Dieu Ndayishimiye, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5tAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu",
  //       "bridge_opportunity_project_code": "1013813",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.7045,
  //       "bridge_opportunity_gps_longitude": 29.75324,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5282,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7045,
  //       "proposed_bridge_location_gps_longitude": 29.75324,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "0.8 km",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Mburamazi, Rango, Huye Town and Busoro Markets (Community 1,2,3,4), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Kansi A and Kansi B Primary and Secondary Schools (Community 1,2,3), St Bernard and St Francois d'Assise Secondary Schools (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Kansi Health Center (Community 1,2,3,4)",
  //       "other_access_blocked_by_river": "Kansi Catholic Parish and ADEPR Kansi (Community 1,2,3,4), Impinga Adventist church and ADEPR Nyarunyinya (Community 5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "bean, maiz, potato, ric, vegetables.",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "More than 100 people have been falling trying to cross the river but none of them were seriously injured.",
  //       "notes_on_social_information": "Nyarukurazo, Nyarunyinya, Akatera, Kigarama, Gasharu and Gatare villages were included in Individuals Directly Served because members of these communities use this crossing point to get access to markets, health centers, churches, schools and farms. They also use the crossing point to visit relatives. Population information for each village was provided by the Rusagara Cell Leader, Jean de Dieu Ndayishimiye, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7x5yAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagacyamo",
  //       "bridge_opportunity_project_code": "1013828",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.9592,
  //       "bridge_opportunity_gps_longitude": 30.47838,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3189,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. River does not flood and river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9592,
  //       "proposed_bridge_location_gps_longitude": 30.47838,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kayonza Market (Nyagacyamo, sabununga, Mubuga)",
  //       "education_access_blocked_by_river": "Both side have school no communities blocked to school",
  //       "health_access_blocked_by_river": "Both side have health center",
  //       "other_access_blocked_by_river": "District office (Nyagacyamo, Sabununga, Mubuga)",
  //       "primary_occupations": "Market and Farms",
  //       "primary_crops_grown": "vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Mubuga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xpLAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambi",
  //       "bridge_opportunity_project_code": "1013829",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.01879,
  //       "bridge_opportunity_gps_longitude": 30.7448,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 21305,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.10.8",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01879,
  //       "proposed_bridge_location_gps_longitude": 30.7448,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "It is lake",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Karambi",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is a lake",
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xpQAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Taba",
  //       "bridge_opportunity_project_code": "1013830",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.00111,
  //       "bridge_opportunity_gps_longitude": 30.53096,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3926,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Vehicular bridge needed.",
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.00111,
  //       "proposed_bridge_location_gps_longitude": 30.53096,
  //       "current_crossing_method": "Concrete",
  //       "nearest_all_weather_crossing_point": "None, they search where it is not flooded and pass by but on the same river and no path",
  //       "days_per_year_river_is_flooded": 135,
  //       "flood_duration_during_rainy_season": "Three weeks",
  //       "market_access_blocked_by_river": "Kabarondo Market (Taba Rukomo, Gitoki)",
  //       "education_access_blocked_by_river": "Rugwagwa primary and secondary school (Taba Rukomo, Gitoki) but there is another",
  //       "health_access_blocked_by_river": "Kabarondo health center (Taba Rukomo, Gitoki)",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Market, schools",
  //       "primary_crops_grown": "sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Tare",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is vehicular bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xpVAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Vungiro",
  //       "bridge_opportunity_project_code": "1013831",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.94853,
  //       "bridge_opportunity_gps_longitude": 30.66917,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3055,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94853,
  //       "proposed_bridge_location_gps_longitude": 30.66917,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Kabarondo and Cyarubare Market, (Umuyenzi, Rwaburara)",
  //       "education_access_blocked_by_river": "TVET and Gishanda secondary school (Umuyenzi, Rwaburara)",
  //       "health_access_blocked_by_river": "Umuyenzi health center (Nyankora, Kiyovu, vunbiro) Rwinkwavu Hospital (Umuyenzi, Rwaburara)",
  //       "other_access_blocked_by_river": "Cell, sector and district offices((Umuyenzi, Rwaburara)",
  //       "primary_occupations": "Market, school, health center, farm",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Vungiro",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xpaAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rucaca",
  //       "bridge_opportunity_project_code": "1013832",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.74771,
  //       "bridge_opportunity_gps_longitude": 30.50005,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7168,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.74771,
  //       "proposed_bridge_location_gps_longitude": 30.50005,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 112,
  //       "flood_duration_during_rainy_season": "Seven days",
  //       "market_access_blocked_by_river": "Karubama market (Akanyerezo, Nyabugando)",
  //       "education_access_blocked_by_river": "Nyabugando primary school (Rucaca, Kibari)",
  //       "health_access_blocked_by_river": "No village blocked to Health center",
  //       "other_access_blocked_by_river": "Rucaca and Kibari are blocked to district and sector office",
  //       "primary_occupations": "School, farms,",
  //       "primary_crops_grown": "maiz, soja",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xq9AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryamanyoni",
  //       "bridge_opportunity_project_code": "1013833",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.74678,
  //       "bridge_opportunity_gps_longitude": 30.50085,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7168,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.74678,
  //       "proposed_bridge_location_gps_longitude": 30.50085,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 112,
  //       "flood_duration_during_rainy_season": "Seven days",
  //       "market_access_blocked_by_river": "Karubama Market (Akanyerezo, Nyabugando)",
  //       "education_access_blocked_by_river": "Nyabugando primary school (Rucaca, Kibari)",
  //       "health_access_blocked_by_river": "No village blocked to Health center",
  //       "other_access_blocked_by_river": "Karambi, Rucaca and Kibari are blocked to sector and district office",
  //       "primary_occupations": "School and farms",
  //       "primary_crops_grown": "maiz, soja",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xqEAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyabugore (kanyinya)",
  //       "bridge_opportunity_project_code": "1013834",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.93163,
  //       "bridge_opportunity_gps_longitude": 30.79019,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 394,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.8",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.93163,
  //       "proposed_bridge_location_gps_longitude": 30.79019,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "It is a big river closer to lake",
  //       "market_access_blocked_by_river": "None",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "It is a breach where it is not allowed to pass closer to boarder",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Kinyinya",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is Lake and link to Tanzaniya",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xqJAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamata",
  //       "bridge_opportunity_project_code": "1013835",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.04215,
  //       "bridge_opportunity_gps_longitude": 30.67317,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 39670,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.04215,
  //       "proposed_bridge_location_gps_longitude": 30.67317,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometers away",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Ndego Market (Rwatamama, gishoza and all Kabare), Kabarondo Market (Ndego including Nyamata as village)",
  //       "education_access_blocked_by_river": "Byimana primary and ES Ndego secondary school (Rwatamama and Gishoza)",
  //       "health_access_blocked_by_river": "Ndego health center (Rwatamama and Gishoza)",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farm, fetch water, school,",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Nyamata",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xuzAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngoma",
  //       "bridge_opportunity_project_code": "1013836",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.05688,
  //       "bridge_opportunity_gps_longitude": 30.59736,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3134,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05688,
  //       "proposed_bridge_location_gps_longitude": 30.59736,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded the whole day",
  //       "market_access_blocked_by_river": "Kabarondo Market (Gihazo, Rebero)",
  //       "education_access_blocked_by_river": "Rebezo primary and secondary schools (Ngoma Kinyinya and Karama )",
  //       "health_access_blocked_by_river": "Karama health center (Rebezo and Gihazo)",
  //       "other_access_blocked_by_river": "Muko cell office (Ngoma and Karama)",
  //       "primary_occupations": "School, health center farms",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is vehicular bridge and it doesn't flooded",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xv4AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rebezo",
  //       "bridge_opportunity_project_code": "1013837",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.05203,
  //       "bridge_opportunity_gps_longitude": 30.58818,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2076,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05203,
  //       "proposed_bridge_location_gps_longitude": 30.58818,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 160,
  //       "flood_duration_during_rainy_season": "Two Months",
  //       "market_access_blocked_by_river": "Kabarondo Market (Rebezo, Gihazo)",
  //       "education_access_blocked_by_river": "Rebezo primary and secondary school ( Kinyinya, Ngoma and Karama)",
  //       "health_access_blocked_by_river": "Karama health center (Gihazo and Rebezo)",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "School, market, farm,",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabarondo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 79,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xv9AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ku mbuga ya 1",
  //       "bridge_opportunity_project_code": "1013838",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.01049,
  //       "bridge_opportunity_gps_longitude": 30.48377,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 37326,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01049,
  //       "proposed_bridge_location_gps_longitude": 30.48377,
  //       "current_crossing_method": "Concrete",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Munyaga ku munara market (Buhoro, Agasharu, Bugambira); Kamboje Market (Munyaga)",
  //       "education_access_blocked_by_river": "Both side have schools",
  //       "health_access_blocked_by_river": "Bugambira post health center and Munyaga peoples who are closer to the bridge use it",
  //       "other_access_blocked_by_river": "Buhoro potable water (Munyaga)",
  //       "primary_occupations": "Fetching water, farm, health center and market",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work in rice plantation and one of them was sent by community leader of Buhoro",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xzLAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ku mbuga ya 2",
  //       "bridge_opportunity_project_code": "1013839",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -2.01757,
  //       "bridge_opportunity_gps_longitude": 30.48546,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 37321,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01757,
  //       "proposed_bridge_location_gps_longitude": 30.48546,
  //       "current_crossing_method": "Concrete",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Market munyaga (buhoro, Agasharu,Ruramira, Bugambira), Kaboje Market (Munyaga)",
  //       "education_access_blocked_by_river": "Both side have schools",
  //       "health_access_blocked_by_river": "Both side have health center but people of Munyaga who are closer to the bridge used Bugambira post health center",
  //       "other_access_blocked_by_river": "Agasharu water potable (Munyaga)",
  //       "primary_occupations": "Market, farms, fetching water, health center",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of agasharu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xzVAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Migera",
  //       "bridge_opportunity_project_code": "1013840",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kayonza",
  //       "bridge_opportunity_gps_latitude": -1.92364,
  //       "bridge_opportunity_gps_longitude": 30.57811,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 951,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Vehicle bridge desired and river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.9",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92364,
  //       "proposed_bridge_location_gps_longitude": 30.57811,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "Two weeks",
  //       "market_access_blocked_by_river": "Kayonza Market (Migera)",
  //       "education_access_blocked_by_river": "Gihinga primary and secondary school (Migera)",
  //       "health_access_blocked_by_river": "Gihinga health center (Migera)",
  //       "other_access_blocked_by_river": "Potable water (Migera)",
  //       "primary_occupations": "Circulation in village, Market, school, fetching water, farms",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Migera and people who live closer to the bridge",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "KIGALI Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d7xzaAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ndatemwa",
  //       "bridge_opportunity_project_code": "1013846",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.799865,
  //       "bridge_opportunity_gps_longitude": 29.55367,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4288,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.10",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.799865,
  //       "proposed_bridge_location_gps_longitude": 29.55367,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "16 times in April, May, October, November and December and it lasts for 3hours after rainfall",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": "Kabavomo, Nyarusange villages don't have access to Nyarusange primary school Kabavomo, Nyarusange villages don't have access to Runyombyi Secondary school",
  //       "health_access_blocked_by_river": "Kabavomo, Nyarusange villages don't have access to Runyombyi Health Center",
  //       "other_access_blocked_by_river": "Jyambere Busanze Sacco, Busanze sector office",
  //       "primary_occupations": "Farming of sweet potatoes, cassava, beans",
  //       "primary_crops_grown": "bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "Huye-Akanyaru",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50.8,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d80kGAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukoro",
  //       "bridge_opportunity_project_code": "1013862",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.19868,
  //       "bridge_opportunity_gps_longitude": 29.4931,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2270,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.19868,
  //       "proposed_bridge_location_gps_longitude": 29.4931,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40 times in April, May, October November and December and it lasts 1day after rainfall",
  //       "market_access_blocked_by_river": "Bizitiro village doesn't have access to Birambo market Kabaranda village doesn't have access to Nyabikeri market",
  //       "education_access_blocked_by_river": "Bizitiro village doesn't have access to Kinyovu primary school",
  //       "health_access_blocked_by_river": "Bizitiro village doesn't have access to Mwendo health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, beans, banana",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 72.4,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d888bAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabikenke",
  //       "bridge_opportunity_project_code": "1013864",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.07676,
  //       "bridge_opportunity_gps_longitude": 29.38212,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1120,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.07676,
  //       "proposed_bridge_location_gps_longitude": 29.38212,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "People only want vehicle bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d888lAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "KwaJackson",
  //       "bridge_opportunity_project_code": "1013865",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.06989,
  //       "bridge_opportunity_gps_longitude": 29.342,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2138,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06989,
  //       "proposed_bridge_location_gps_longitude": 29.342,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "200 m",
  //       "days_per_year_river_is_flooded": 55,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": "Nyegabo village don't have access to Rugando Market",
  //       "education_access_blocked_by_river": "Nyagahinga village and Gisayo village don't have access to Nyegabo secondary school",
  //       "health_access_blocked_by_river": "Nyagahinga village and Gisayo village don't have access to kibuye health center",
  //       "other_access_blocked_by_river": "Nyagahinga village and Gisayo village don't have access to kibuye Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "Gisayo village leader is the one who provided information about directly individual served by calling other village leaders to confirm their number of population they referred to 2018 population census .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d888qAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muryaruzigura",
  //       "bridge_opportunity_project_code": "1013868",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.16278,
  //       "bridge_opportunity_gps_longitude": 29.28921,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3904,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.16278,
  //       "proposed_bridge_location_gps_longitude": 29.28921,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 119,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Gitovu village & Mpatsi village & Gatare village don't have access to Mugonera market",
  //       "education_access_blocked_by_river": "Gitovu village & Mpatsi village & Gatare village don't have access to GS Mwishya ( 12 years basic education) whereas gitwa village & Magarama village don't have access to GS Gishyita ( 9 years basic education)",
  //       "health_access_blocked_by_river": "Gitovu village & Mpatsi village & Gatare village don't have access to Mugonera health center",
  //       "other_access_blocked_by_river": "Gitovu village & Mpatsi village & Gatare village don't have access to Ngoma Adventist church whereas gitwa village & Magarama village don't have access to ADEPR Gishyita",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "two injuries on this river",
  //       "notes_on_social_information": "Gitovu village leader provided info about directly individual served, by referring to 2017 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Nyamasheke - Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8895AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bizitiro",
  //       "bridge_opportunity_project_code": "1013869",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.19785667,
  //       "bridge_opportunity_gps_longitude": 29.496655,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2270,
  //       "bridge_opportunity_comments": "BAJ Follow up with assessor",
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.19785667,
  //       "proposed_bridge_location_gps_longitude": 29.496655,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "there is only 22m remaining from 5m setback of the neaby earth road and we need 30m setback for a suspension bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38.2,
  //       "height_differential_between_banks": 2.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d889AAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare",
  //       "bridge_opportunity_project_code": "1013870",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 55,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is a feeder road, and the crossings over it are small to be constructed using trees, and the river never reach the trees",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d889FAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasasa~ mutuntu",
  //       "bridge_opportunity_project_code": "1013891",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.392599,
  //       "bridge_opportunity_gps_longitude": 29.239326,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3697,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.392599,
  //       "proposed_bridge_location_gps_longitude": 29.239326,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge three kilometers away.",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "March to May, October to December, four hours",
  //       "market_access_blocked_by_river": "Rugari market, Kirambo market, ville( village 1,and 2)",
  //       "education_access_blocked_by_river": "Tsinduka primary school ( village 3 ,4 and 5), Mutuntu secondary school( village 1 and 2].",
  //       "health_access_blocked_by_river": "Mutuntu dispensary ( village 3 and 2).",
  //       "other_access_blocked_by_river": "ADPR BISUMO , METHODIST LIBRE BISUMO( village 1, 2 and 3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe, the, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 72,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88IMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwagisasa",
  //       "bridge_opportunity_project_code": "1013871",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.14492,
  //       "bridge_opportunity_gps_longitude": 29.30137,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3843,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14492,
  //       "proposed_bridge_location_gps_longitude": 29.30137,
  //       "current_crossing_method": "Two timbers are used as current crossing method",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 78,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Kibaya village & kimbo village &kabuga village and nyagatare village don't have access to Mubuga market",
  //       "education_access_blocked_by_river": "Musebeya village & kamunungu village and Rwagisasa village don't have access to GS Gishyita",
  //       "health_access_blocked_by_river": "Musebeya village & kamunungu village and Rwagisasa village don't have access to Gishyita health center",
  //       "other_access_blocked_by_river": "Kibaya village & kimbo village &kabuga village and nyagatare village don't have access to Mubuga Catholic church whereas Musebeya village & kamunungu village and Rwagisasa village don't have access to ADEPR Gishyita and Gishyita sector office HQ",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "One old woman died , and 1 injured person",
  //       "notes_on_social_information": "Rwagisasa village leader was there to provide information about directly individuals served by the bridge and he referred to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d889KAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahinga",
  //       "bridge_opportunity_project_code": "1013872",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.11586,
  //       "bridge_opportunity_gps_longitude": 29.26521,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3780,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11586,
  //       "proposed_bridge_location_gps_longitude": 29.26521,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 57,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Gisoro village , mboneko village, tura village don't have access to Mubuga market",
  //       "education_access_blocked_by_river": "Buhire village and myeya village don't have access to GS hanika",
  //       "health_access_blocked_by_river": "Buhire village and myeya village don't have access to hanika health center",
  //       "other_access_blocked_by_river": "Gisoro village , mboneko village, tura village don't have access to buhire market",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two injuries during last heavy rain season",
  //       "notes_on_social_information": "Mboneko village security chief provided the info about people served by the bridge by referring to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d889UAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu",
  //       "bridge_opportunity_project_code": "1013874",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.12272,
  //       "bridge_opportunity_gps_longitude": 29.34027,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2176,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12272,
  //       "proposed_bridge_location_gps_longitude": 29.34027,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 52,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Buhari village and rubondo village don't have access to Kiziba refugees champ market.",
  //       "education_access_blocked_by_river": "Kagarama village don't have access to to GS nyarubati",
  //       "health_access_blocked_by_river": "Buhari village and rubondo village don't have access to Kiziba health center",
  //       "other_access_blocked_by_river": "Kagarama village don't have access to to nyarubati church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One people get injured by this river",
  //       "notes_on_social_information": "A volunteer from kagarama village was there to provide the information about individual served by the bridge .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d889eAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Wagati",
  //       "bridge_opportunity_project_code": "1013876",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.18942,
  //       "bridge_opportunity_gps_longitude": 29.507745,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1646,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18942,
  //       "proposed_bridge_location_gps_longitude": 29.507745,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "30 times in April, May, October November and December and it lasts 2hours after rainfall",
  //       "market_access_blocked_by_river": "Kabaranda village doesn't have access to Birambo, Nyagisozi village doesn't have access to Gahunduguru",
  //       "education_access_blocked_by_river": "Kabaranda village doesn't have access to Wagishimbiri primary school Kabaranda village doesn't have access to Mwendo secondary school",
  //       "health_access_blocked_by_river": "Kabaranda village doesn't have access to Mwendo health center",
  //       "other_access_blocked_by_river": "Transit center",
  //       "primary_occupations": "Farming of sweet potatoes, banana, cassava, beans",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "They are drawn while trying to walk in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": 2.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d889yAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyegenyege",
  //       "bridge_opportunity_project_code": "1013877",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.19348,
  //       "bridge_opportunity_gps_longitude": -29.49645,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2270,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.19348,
  //       "proposed_bridge_location_gps_longitude": -29.49645,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "35times in April, May, October November and December and it lasts for 1hour after rainfall",
  //       "market_access_blocked_by_river": "Kanyegenyege village doesn't have access to Birambo market Kabaranda village doesn't have access to Nyabikeri market",
  //       "education_access_blocked_by_river": "Kanyegenyege, Bizitiro villages don't have access to Kinyovu primary school",
  //       "health_access_blocked_by_river": "Kanyegenyege, Bizitiro villages don't have access to Mwendo health center",
  //       "other_access_blocked_by_river": "Cell office",
  //       "primary_occupations": "Farming of banana, sweet potatoes, beans",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They are drawn while trying to walk in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40.4,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88A3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwabagoyi",
  //       "bridge_opportunity_project_code": "1013878",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.414849,
  //       "bridge_opportunity_gps_longitude": 29.046601,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3087,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.414849,
  //       "proposed_bridge_location_gps_longitude": 29.046601,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "October to November, March to May, sometimes in February, 48 hours",
  //       "market_access_blocked_by_river": "Bushenge market ( village 3and 4), Rwesero market ( village 1 and 2). Farms ( villages 1,2,3and 4), Gisakura tea factory ( village 1 and 2).",
  //       "education_access_blocked_by_river": "Nyanza secondary school ( village village 1 and 2), mpishyi ( village 3 and 4), Nyakibingo secondary school( village 1 and 2).",
  //       "health_access_blocked_by_river": "Mugera health center ( village 3 and 4), Bushenge hospital ( village 3 and 4).",
  //       "other_access_blocked_by_river": "Bushekeri churches ( village 1 and 2), mpishyi churches ( villages 3 and 4). District office ( village 1 and 2 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, sugar can, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population data of each village was provided by villages leader Who called by rwabagoyi village leader to give population. The population data given was updated in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88D2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mpishyi",
  //       "bridge_opportunity_project_code": "1013879",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.422817,
  //       "bridge_opportunity_gps_longitude": 29.043546,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2563,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.422817,
  //       "proposed_bridge_location_gps_longitude": 29.043546,
  //       "current_crossing_method": "Timber but it dangerous to cross",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 3 hours",
  //       "market_access_blocked_by_river": "Bushenge market ( village 3 and 4),Rwesero market ( village 1 and 2), farms ( village 1,2 3and 4), Gisakura tea factory ( village 1 and 2, 5 )",
  //       "education_access_blocked_by_river": "Nyanza secondary school( village 1 & 2), mpishyi primary school( village 3 and 4), Nyakibingo secondary school ( villages 1 & 2 ).",
  //       "health_access_blocked_by_river": "Mugera health center ( village 3 and 4 ), Bushenge hospital ( village 3 and 4 ).",
  //       "other_access_blocked_by_river": "Churches in mpishyi ( village 3 and 4 ), churches in Bishekeri( village 1 and 2 ), district office ( village 1 and 2 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, sugar can, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down in river.",
  //       "notes_on_social_information": "Population information of each village was provided by village of mpishyi and other villages leader through phone call. Community members in Shangi sector was included because they cross bridge everyday to do farm in Bushekeri tea mountains.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": 1.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88D7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakombe",
  //       "bridge_opportunity_project_code": "1013880",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.395291,
  //       "bridge_opportunity_gps_longitude": 28.992706,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1622,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.395291,
  //       "proposed_bridge_location_gps_longitude": 28.992706,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge only because before the bridge damage the truck was using the road.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88DCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rushoka 2",
  //       "bridge_opportunity_project_code": "1013881",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.213654,
  //       "bridge_opportunity_gps_longitude": 29.257268,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2078,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.213654,
  //       "proposed_bridge_location_gps_longitude": 29.257268,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 3 hours",
  //       "market_access_blocked_by_river": "Mugonero markert( village 1, 4 and 3), karengera market ( village 2 and 1) , farms ( village 1 and 2).",
  //       "education_access_blocked_by_river": "Kibingo secondary school ( village 1 and 3), Binogo primary school( 1 and 2).",
  //       "health_access_blocked_by_river": "Kibingo health center ( 3 ), mahembe health center ( village 1, and 2 )",
  //       "other_access_blocked_by_river": "Karambo church ( 1 and 2), kibingo church ( village 3 and 1).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by villages leader who sourced the population from village population monthly record.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 69,
  //       "height_differential_between_banks": 2.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88DHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarunyinya~Rwabisindu",
  //       "bridge_opportunity_project_code": "1013882",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.183169,
  //       "bridge_opportunity_gps_longitude": 29.262155,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3765,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.183169,
  //       "proposed_bridge_location_gps_longitude": 29.262155,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "October to December , March to May, 1 hour",
  //       "market_access_blocked_by_river": "Mugonero market ( villages 4&5), farms ( villages 1,2,3 ,4&5), Butare thee factory( village 1,2, and 3 ).",
  //       "education_access_blocked_by_river": "Kibingo secondary school( 4 & 5 ).",
  //       "health_access_blocked_by_river": "Kibingo health center ( village 4 & 5 ).",
  //       "other_access_blocked_by_river": "Kibingo Catholic church ( villages 4 & 5),",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down in river",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88DMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kizenga 2",
  //       "bridge_opportunity_project_code": "1013883",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.232363,
  //       "bridge_opportunity_gps_longitude": 29.254785,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1531,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.232363,
  //       "proposed_bridge_location_gps_longitude": 29.254785,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "April to May, October to February, 1 hours",
  //       "market_access_blocked_by_river": "Karengera market ( village 1 & 2), Mahembe coffee factory ( one part of village 1 & village 3). Farms ( villages 1, 2 &3).",
  //       "education_access_blocked_by_river": "Gihombo primary school ( one part of village 1, village 2 ), nyagatare secondary school( village 1 one part).",
  //       "health_access_blocked_by_river": "Mahembe health center( village 3 and one part of village 1).",
  //       "other_access_blocked_by_river": "Remera adventist church ( village 2 ), Catholic church ( village 1), Pentecost church ( 2, 3)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by nyagatare cell leader , Ntahondereye Modeste who sourced the population from cell register done in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88DWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigarama",
  //       "bridge_opportunity_project_code": "1013884",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.200863,
  //       "bridge_opportunity_gps_longitude": 29.268609,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1934,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.200863,
  //       "proposed_bridge_location_gps_longitude": 29.268609,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.5 kilometers",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 24 hours",
  //       "market_access_blocked_by_river": "Mugonero market( village 1 and 2), farms ( villages 1 and 2).",
  //       "education_access_blocked_by_river": "Mahembe primary school( village 1), kibingo secondary school( village 2 and 3 )",
  //       "health_access_blocked_by_river": "Kibingo health center ( village 1 ).",
  //       "other_access_blocked_by_river": "Catolicc church in kibingo ( village 1).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, ric, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by cell leader of kibingo and kigarama cell leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": 2.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88DbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muhororo",
  //       "bridge_opportunity_project_code": "1013885",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.232662,
  //       "bridge_opportunity_gps_longitude": 29.218742,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1720,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.232662,
  //       "proposed_bridge_location_gps_longitude": 29.218742,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge six kilometers away.",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "April to May , October to November, four hours",
  //       "market_access_blocked_by_river": "Karengera market( villages 1&2), farms ( all given villages ).",
  //       "education_access_blocked_by_river": "Kibirizi primary and nursery school( villages 1&2), Gitsimbwe secondary school( village 3).",
  //       "health_access_blocked_by_river": "Jarama health center( villages 1 & 2).",
  //       "other_access_blocked_by_river": "Mubuga Catholic church ( village 3)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population of each village was provided by cell leader, Nshimiyimana Pierre celestin who sourced the population from the villages leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88DgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kizenga 1",
  //       "bridge_opportunity_project_code": "1013887",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.233859,
  //       "bridge_opportunity_gps_longitude": 29.250362,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1408,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.233859,
  //       "proposed_bridge_location_gps_longitude": 29.250362,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "October to May, 3 hours",
  //       "market_access_blocked_by_river": "Karengera market ( 1 & 3 ), Rugali livestock market ( 1& 3), Mahembe coffee factory ( village 2).",
  //       "education_access_blocked_by_river": "Gihombo primary school ( villages 1 & 3).",
  //       "health_access_blocked_by_river": "Mahembe health center ( village 2 ).",
  //       "other_access_blocked_by_river": "Mahembe adventist church ( village 2).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Nyagatare cell leader,",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi ~ nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88EyAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mutusa",
  //       "bridge_opportunity_project_code": "1013888",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.37385,
  //       "bridge_opportunity_gps_longitude": 29.095785,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2662,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.37385,
  //       "proposed_bridge_location_gps_longitude": 29.095785,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away.",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 2 hours",
  //       "market_access_blocked_by_river": "Rwesero market( village 3 and 4), farms ( villages 1,2 and 3), Gasayo coffee factory ( village 3 ).",
  //       "education_access_blocked_by_river": "Nyamasheke secondary school( village 3 ).",
  //       "health_access_blocked_by_river": "Nyamasheke health center ( village 3 ).",
  //       "other_access_blocked_by_river": "Nyamasheke Catholic church ( village 3 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, tre, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88F3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwisovo~Nyarusasa",
  //       "bridge_opportunity_project_code": "1013889",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.34745,
  //       "bridge_opportunity_gps_longitude": 29.143437,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2123,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34745,
  //       "proposed_bridge_location_gps_longitude": 29.143437,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Footbridge in Two kilometers away.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to May, October to November, 48 hours",
  //       "market_access_blocked_by_river": "Lumos market, and Tyazo market ( village 3 and 4), farms ( village 1 and 3 ), Rushondi coffee factory.",
  //       "education_access_blocked_by_river": "Nyarusasa primary school( village 1 and 2). Rangiro secondary school ( village 3 and 4).",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Methodist church and Baptist church ( village 1 and 2).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by Rwisovu cell leader, who sourced the information from the cell office record of every village polulation. population",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 85,
  //       "height_differential_between_banks": 5.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88ICAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakabingo",
  //       "bridge_opportunity_project_code": "1013890",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.393212,
  //       "bridge_opportunity_gps_longitude": 29.219801,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3336,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.393212,
  //       "proposed_bridge_location_gps_longitude": 29.219801,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehiculer bridge two kilometers away.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "October to May, after 48hours",
  //       "market_access_blocked_by_river": "Ville market,Kirambo market and Rugari market ( village 1, 2 and 3 ), farms ( villages 1 and 2) and villages( 3, 4 and 5). Susa thee factory ( villages 1 and 2).",
  //       "education_access_blocked_by_river": "Nyakabingo primary school ( village 1, 2 and 3), yove secondary school ( village 4 and 5 ), Mutuntu primary and secondary school( village 1,2,3).",
  //       "health_access_blocked_by_river": "Mutuntu dispensary ( village 1 and 2 ), yove health center ( village 4 and 5).",
  //       "other_access_blocked_by_river": "Mutuntu church ( village 1 and 2), Sector office ( village 4 and 5 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, coffe, maiz, the",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population data was provided by BISUMO cell leader, nkurikiyimana Emmanuel who sourced the population from cell record which is updated in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88IHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamiheha",
  //       "bridge_opportunity_project_code": "1013893",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.210267,
  //       "bridge_opportunity_gps_longitude": 29.263236,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2698,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.210267,
  //       "proposed_bridge_location_gps_longitude": 29.263236,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 kilometers",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "April and May, October to December, 2 hours",
  //       "market_access_blocked_by_river": "Farms ( villages 1,2,3 and 4).",
  //       "education_access_blocked_by_river": "Nyamabuye primary school( village 2 and 4 ), kibingo secondary school ( village 1, 2 and 3).",
  //       "health_access_blocked_by_river": "Kibingo health center( villages 1,2 and 3).",
  //       "other_access_blocked_by_river": "Kibingo Catholic church ( villages 1,2,and 3); kibingo police station ( villages 1,2,3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Fell down and drowned , however it is before three years",
  //       "notes_on_social_information": "Population data was given by kibingo cell leader and kigarama cell leader, who sourced the data from cell office rgister which has done in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~ karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 1.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88IWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubura",
  //       "bridge_opportunity_project_code": "1013896",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.36254,
  //       "bridge_opportunity_gps_longitude": 29.2193,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4514,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.36254,
  //       "proposed_bridge_location_gps_longitude": 29.2193,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "15 kilometers",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "April to May, October to November , sometimes in February, 24 hours",
  //       "market_access_blocked_by_river": "Kirambo market( village 3 ), ville market( villages 1,2 and 4), kivugiza thee factory( villages 1 ), thee farms (villages 1, 2,3,and 4),",
  //       "education_access_blocked_by_river": "Nyarubura primary school( village 3), cyavumu secondary school( village 3).",
  //       "health_access_blocked_by_river": "Ruheru health center ( village 3 ), gatebe dispensary ( village 3 ).",
  //       "other_access_blocked_by_river": "Kabuga church ( village 1 ), Nyamasheke district office ( village 3), nyarubura spring ( potable water) village 3 .",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "flour, maiz, the, tre",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Fell down on timber , fell down in river and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by nyarubura villages'leader, kanyoni Donaciien who attended the meeting and by call asked other cell leader the population they have.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65,
  //       "height_differential_between_banks": 5.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88KNAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rushoka 1",
  //       "bridge_opportunity_project_code": "1013897",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.208637,
  //       "bridge_opportunity_gps_longitude": 29.262007,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2078,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.208637,
  //       "proposed_bridge_location_gps_longitude": 29.262007,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "March to April and october to December, 2 hours",
  //       "market_access_blocked_by_river": "Mugonero market ( village 2 and 3, 4), karengera market ( village 1, 5), farms ( villages 1,2).",
  //       "education_access_blocked_by_river": "Kibingo secondary school ( village 2 and 3)",
  //       "health_access_blocked_by_river": "Kibingo health center ( 2 and 3).",
  //       "other_access_blocked_by_river": "Kibingo church ( Catholic, ADPR , And adventist ) village 2 and 3)., Gihombo sector office and kibingo cell office ( village 2 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Fell down and fracture , then died",
  //       "notes_on_social_information": "Population information was provided by kibingo cell leader,Nyandwi donatile who sourced the data from cell office rgister.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ karongi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88KcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kumugeti",
  //       "bridge_opportunity_project_code": "1013900",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.404371,
  //       "bridge_opportunity_gps_longitude": 29.168585,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2014,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.404371,
  //       "proposed_bridge_location_gps_longitude": 29.168585,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away.",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 8 hours",
  //       "market_access_blocked_by_river": "Tyazo market ( community 3 and 4), farms ( village 1,2,3 and 4), kamatsira timber manufacturing factory ( village 1 and 2).",
  //       "education_access_blocked_by_river": "Kamatsira primary school ( village 1 ), Rangiro secondary school ( community 3 and 4).",
  //       "health_access_blocked_by_river": "Rangiro health center ( village 3 and 4).",
  //       "other_access_blocked_by_river": "Kamatsira church ( 1 and 2), Rangiro angrican church( village 3 and 4).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maiz, tre",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe~Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88KrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahisi",
  //       "bridge_opportunity_project_code": "1013901",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.408611,
  //       "bridge_opportunity_gps_longitude": 29.188273,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1559,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.408611,
  //       "proposed_bridge_location_gps_longitude": 29.188273,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge seven kilometers away.",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 12 hours",
  //       "market_access_blocked_by_river": "Banda market( village 3), custom market ( village 1and 2), farms( village 1, 2 and 3).",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None.",
  //       "other_access_blocked_by_river": "E.A.R church village ( 3 ) inkurunzi cyato( village 1 and 2).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maiz, tre",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by Gakenke cell leader, who sourced them from cell book register which is updated in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~ Rusizi",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 160,
  //       "height_differential_between_banks": 3.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88KwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahira 1",
  //       "bridge_opportunity_project_code": "1013902",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.442198,
  //       "bridge_opportunity_gps_longitude": 29.203302,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7032,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.442198,
  //       "proposed_bridge_location_gps_longitude": 29.203302,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in eight hundred meters, however it sometimes flooded.",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "October December, March to May, 5 hours",
  //       "market_access_blocked_by_river": "Gahira market ( village 5 ), ville market and yove market( village 1,2,3,and 4), farms( village 1,2,3,and 4), geranium factory ( village 5 ).",
  //       "education_access_blocked_by_river": "Kageno nursery school( village 5 ), GROUPE SCHOLAIRE BANDA ( village 5).",
  //       "health_access_blocked_by_river": "Kageno dispensary ( village 5)",
  //       "other_access_blocked_by_river": "Kageno church ( village 5 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned.",
  //       "notes_on_social_information": "Population information of each village was provided by Banda cell leader, Jean baptiste nzahabayo who sourced the population from cell register in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88PDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahira 2",
  //       "bridge_opportunity_project_code": "1013903",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.442784,
  //       "bridge_opportunity_gps_longitude": 29.202178,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 980,
  //       "bridge_opportunity_comments": "Site Rejected. There is an alternate crossing less than 300 meters away.",
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.442784,
  //       "proposed_bridge_location_gps_longitude": 29.202178,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The nearest all weather crossing is less than 300 meters",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88PIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabukunzi",
  //       "bridge_opportunity_project_code": "1013904",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.36555,
  //       "bridge_opportunity_gps_longitude": 29.033081,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 741,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.36555,
  //       "proposed_bridge_location_gps_longitude": 29.033081,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge only",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88TZAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamabera",
  //       "bridge_opportunity_project_code": "1013905",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.365632,
  //       "bridge_opportunity_gps_longitude": 29.008657,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2112,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.365632,
  //       "proposed_bridge_location_gps_longitude": 29.008657,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Crossing the source of river in three kilometers away.",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "October to November , March to May, eight hours",
  //       "market_access_blocked_by_river": "Bushenge market (village 1 and 2), farms ( vilage 1,2,3,4 and 5), Gitaba coffee factory ( village 1,and 2).",
  //       "education_access_blocked_by_river": "GROUPE SCOLAIRE ST Maxmilier corbe Mukoma( village 3, 4, and 5), Gafuba primary school( village 3,4,and 5), Buhokora secondary school( village 3,4,and 5).",
  //       "health_access_blocked_by_river": "MUKOMA health center ( village 3,4 and 5).",
  //       "other_access_blocked_by_river": "ADPR MUKOMA( village 3,4and 5), mariba cell office ( village 3,4 and 5).",
  //       "primary_occupations": "Farming and fishing",
  //       "primary_crops_grown": "cassava, coffe, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by mariba cell leader, uwamahoro Jean Claude who sourced the data from cell register which was done I two 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d88TeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Agahama",
  //       "bridge_opportunity_project_code": "1014450",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.849236,
  //       "bridge_opportunity_gps_longitude": 30.064609,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1484,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.849236,
  //       "proposed_bridge_location_gps_longitude": 30.064609,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "10 kilometers",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "nyacyonga Market, Kidashya business center (Ngiryi Agahama)",
  //       "education_access_blocked_by_river": "Not used for school",
  //       "health_access_blocked_by_river": "Jabana health center ( Ngiryi)",
  //       "other_access_blocked_by_river": "Fetching water (Kidashya)",
  //       "primary_occupations": "Farms, fetching water",
  //       "primary_crops_grown": "bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Ngiryi",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 90,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevObAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubindi",
  //       "bridge_opportunity_project_code": "1013909",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.54605,
  //       "bridge_opportunity_gps_longitude": 28.96095,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2908,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.54605,
  //       "proposed_bridge_location_gps_longitude": 28.96095,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2,3), Bambiro and Kamembe markets (Community 4,5), Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Petit Seminaire (Secondary School ), Gihundwe Primary and Secondary School, Gatare Primary and Secondary School, Mururu Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Gisunzu Health Post, Mibirizi Hospital (Community 4,5)",
  //       "other_access_blocked_by_river": "Nyakarenzo Sector Office, Rusizi Town, Ibanga ry'Amahoro (A catholic pilgrimage place), Kanoga ADEPR Church (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kanoga, Kamanura, Kumana, Kanyovu, Ryamaraza and Gako villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Kanoga Cell Leader and the Kanoga Village Leader, Evariste Ndagijimana from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Nkungu and Nyakabuye Sectors. Community members in these sectors sometimes use this crossing to go to markets or to go to Kamembe.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AigAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugabe",
  //       "bridge_opportunity_project_code": "1013910",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.51669,
  //       "bridge_opportunity_gps_longitude": 28.96432,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2449,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.51669,
  //       "proposed_bridge_location_gps_longitude": 28.96432,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2), Nyarushishi and Kamembe markets (Community 3,4), Shagasha tea company (Community 3,4)",
  //       "education_access_blocked_by_river": "Runyanzovu primary school and Gatare Primary and Secondary School (Community 1,2), TVET Nyarushishi (Secondary School) (Community 3,4)",
  //       "health_access_blocked_by_river": "Gihundwe Hospital (Community 3,4)",
  //       "other_access_blocked_by_river": "Runyanzovu Catholic Church and Nkungu Sector Office (Community 1,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people have been falling into the river and some were seriously injured.",
  //       "notes_on_social_information": "Rugabe, Nyarushishi, Gisovu, Rususa and Gatarange villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches, farms, schools and to Shagasha tea company. The population information for each village was provided by the Rugabe village leader, Twagirayezu Jean Marie Vianney and other village leaders from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Nyamasheke)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 1.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AilAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabumbwe",
  //       "bridge_opportunity_project_code": "1013911",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.53318,
  //       "bridge_opportunity_gps_longitude": 28.95045,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3037,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.53318,
  //       "proposed_bridge_location_gps_longitude": 28.95045,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Bambiro and Kamembe markets (Community 1,2,3,4), Nyakabuye market (Community 1), farms (All Communities)",
  //       "education_access_blocked_by_river": "Gatare Primary and Secondary School (Community 1)",
  //       "health_access_blocked_by_river": "No health access blocked",
  //       "other_access_blocked_by_river": "Kanoga ADEPR church (Community 1), Rusizi Town, Ibanga ry'Amahoro (A Catholic pilgrimage place), Gatare Methodist church (Community 2,3,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, passion fruit, potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kabumbwe, Kumana, Kanoga, Ryamaraza and Bahuro villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches, farms and schools. The population information for each village was provided by the Gatare Cell Leader, Cyriaque Twayigize and the Kumana village leader, Emmanuel Nzamwita from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Nkungu and Nyakabuye Sectors. Community members in these cells sometimes use this crossing to visit relatives to go to Kamembe, to health centers or to visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 3.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AiqAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabyunyu",
  //       "bridge_opportunity_project_code": "1013912",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.57105,
  //       "bridge_opportunity_gps_longitude": 29.88974,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5337,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57105,
  //       "proposed_bridge_location_gps_longitude": 29.88974,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April, May, October, November and December; it last for 6 hours.",
  //       "market_access_blocked_by_river": "Gisagara and Musha Markets (Community 1,2,3), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Kagoma and Gabiro Primary and Secondary Schools (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Gishubi Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Gishubi Sector Office, Gisagara District Office, Kagoma Catholic Church, Gishubi ADEPR and Adventist Churches (Community 1,2,3), Nyeranzi Cell Office (Community 4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potatoes., ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "More than 100 people have been falling into the river but none of them were seriously injured.",
  //       "notes_on_social_information": "Nyabyunyu, Muyinza, Cyamanyeri, Gikuyo, Nyamure, Kagoma, Gabiro, Rwanza and Busave villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Nyeranzi Cell Leader, Jean Claude Kanyamahanga and the Nyabyunyu Village Leader, Philbert Ntirushwamaboko from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Gabiro and Nyakibungo Cells. Community members in these cells sometimes use this crossing to go to market or to visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AivAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusasa",
  //       "bridge_opportunity_project_code": "1013913",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.59858,
  //       "bridge_opportunity_gps_longitude": 29.81743,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3822,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.59858,
  //       "proposed_bridge_location_gps_longitude": 29.81743,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Gisagara and Musha Markets (Community 1,2,3), Rwanza and Huye Town Markets (Community 4,5)",
  //       "education_access_blocked_by_river": "VTC Gisagara Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Gisagara Health Center (Community 1,2,3), Kabutare Hospital (4,5)",
  //       "other_access_blocked_by_river": "Gisagara District Office, Gisagara Catholic Parish, Gisagara Sport Complex and Gisagara ADEPR church (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, coffe, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people have been falling into the river but none of them were seriously injured. 2 people have died trying to cross the river by the timber bridge during rainy season.",
  //       "notes_on_social_information": "Akiminazi, Kantabana, Kamahembe, Mirayi, Sabudari, Urusenyi and Nyarubari villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Bweya Cell Leader, Birindabagabo Theophile and the Akiminazi Village Leader, Yohani Ruzima from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Bweya, Gisagara and Cyamakuza Cells. Community members in these cells sometimes use this crossing to visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8Aj0AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musizi",
  //       "bridge_opportunity_project_code": "1013914",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.60413,
  //       "bridge_opportunity_gps_longitude": 29.80698,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3851,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.60413,
  //       "proposed_bridge_location_gps_longitude": 29.80698,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Gisagara and Musha Markets (Community 1,2,3), Rwanza and Huye Town Markets (Community 4,5), Farms (1,2 3 4)",
  //       "education_access_blocked_by_river": "Ndoba and Gisagara Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Gisagara Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Gisanze Catholic Church (Community 4,5), Jehovah Witnesses church (Community 1,2,3), Huye Town (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cabbag, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Akiminazi, Kantabana, Kamahembe, Mirayi, Sabudari, Rugara and Nyabitare villagee were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Bweya Cell Leader, Birindabagabo Theophile and the Akiminazi Village Leader, Yohani Ruzima from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Bweya and Gisagara Cells. Community members in these cells sometimes use this crossing to visit relatives or to go to Huye Town once in awhile.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8Aj5AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusasa",
  //       "bridge_opportunity_project_code": "1013915",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.59392,
  //       "bridge_opportunity_gps_longitude": 29.8922,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7829,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.59392,
  //       "proposed_bridge_location_gps_longitude": 29.8922,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April, May, October, November and December; it last for 4 days",
  //       "market_access_blocked_by_river": "Gisagara, Musha and Huye markets (Community 1,2,3), Nyakibungo market (Community 4,5), Farms (All communities)",
  //       "education_access_blocked_by_river": "VTC Gisagara (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Gishubi Health Center (Community 1,2,3), Nyakibungo Health Post (Community 4,5)",
  //       "other_access_blocked_by_river": "Gishubi sector Office, Gisagara District Office and Gishubi Sacco Saving (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potatoes., ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 300,
  //       "incident_descriptions": "At least one person per day fell in the river. And the total number of people falling into the river by the crossing bridge is more than 300, all with minor injuries.",
  //       "notes_on_social_information": "Rusasa, Gisagara, Kibingi, Rebero, Nkunamo, Banga, Rugarama, Kigozi, Rweza, Kivugiza, Nyundo and Tamba villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches, schools and farms . The population information for each village was provided by the Nyakibungo Cell Leader, Rutihunza Frederic and the Rusasa Village Leader, Nyandwi Samuel from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Nyakibungo Nyakibungo and Nyabitare cells. Community members in these cells sometimes use this crossing to go to market or to visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali - Huye - Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AjFAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyovu",
  //       "bridge_opportunity_project_code": "1013916",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.55346,
  //       "bridge_opportunity_gps_longitude": 28.95224,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2905,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.55346,
  //       "proposed_bridge_location_gps_longitude": 28.95224,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Bambiro and Kamembe markets (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Cyato Primary and Secondary School (Community 1,2,3,4)",
  //       "health_access_blocked_by_river": "No health access blocked",
  //       "other_access_blocked_by_river": "Cyato Anglican church and Nyakarenzo Sector Office (Community 1,2,3,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maize., potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two elderly people have been seriously injured on this crossing point.",
  //       "notes_on_social_information": "Kabumbwe, Kanyove, Kumana, Kanoga and Ryamaraza villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches, farms and schools. The population information for each village was provided by the Gatare Cell Leader, Cyriaque Twayigize and the Kanyovu village leader, Micheline Nyiransabimana from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AjKAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngoboka",
  //       "bridge_opportunity_project_code": "1013917",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.54047,
  //       "bridge_opportunity_gps_longitude": 28.95991,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1753,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.54047,
  //       "proposed_bridge_location_gps_longitude": 28.95991,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2), Bambiro and Kamembe markets (Community 3), Tea Hangar storage (Community 3), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Gatare Primary and Secondary School, Mururu Secondary School, Gihundwe Primary and Secondary School (Community 3)",
  //       "health_access_blocked_by_river": "Gisunzu Health Post and Mibirizi Hospital (Community 3)",
  //       "other_access_blocked_by_river": "Rusizi Town, Ibanga ry'Amahoro (A Catholic pilgrimage place), Kanoga ADEPR church and potable water (Community 3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, passion fruits., potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kanoga, Kumana and Ryamarara villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Kanoga Cell Leader and the Kanoga Village Leader, Evarist Ndagijimana from the population data collected in 2018. This crossing point is no longer used by many people because the community on the left side of the river has been moved from the valley to uphill and now they use another crossing point which is upstream.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AjZAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kankenge2",
  //       "bridge_opportunity_project_code": "1013918",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.55358,
  //       "bridge_opportunity_gps_longitude": 28.95937,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2247,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.55358,
  //       "proposed_bridge_location_gps_longitude": 28.95937,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2,3), Bambiro and Kamembe markets (Community 4,5), Tea Hangar storage (Community 4,5)",
  //       "education_access_blocked_by_river": "Mibirizi Primary School (Community 4,5), Gatare Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Nkungu Health Center (Community 1,2 3), Mibirizi Hospital (Community 4,5)",
  //       "other_access_blocked_by_river": "Mibirizi Catholic Parish, Ibanga ry'Amahoro (A Catholic pilgrimage place), Rusizi Town (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, fruits., maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kanyovu, Kamanura, Kanoga, Gatare and Gako villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Kanoga Cell Leader, Celestin Hakizimana and the Kanyovu Village Leader, Micheline Nyiransabimana from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Nkungu Sector. Community members in these cells sometimes use this crossing to go to market, health centers or visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1(Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AnvAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gaseke",
  //       "bridge_opportunity_project_code": "1014097",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.5679,
  //       "bridge_opportunity_gps_longitude": 29.01254,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8296,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.5679,
  //       "proposed_bridge_location_gps_longitude": 29.01254,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Nkungu market",
  //       "education_access_blocked_by_river": "Nyamubembe high school",
  //       "health_access_blocked_by_river": "Nkungu health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "People slipped and fell in the river trying to cross",
  //       "notes_on_social_information": "Gaseke village don't have access to nyakabuye market and munyana village don't have access to nkungu market Information gathered from village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nhakabuye",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fW4AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisuma",
  //       "bridge_opportunity_project_code": "1013919",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.70557,
  //       "bridge_opportunity_gps_longitude": 29.89536,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2563,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.70557,
  //       "proposed_bridge_location_gps_longitude": 29.89536,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Nyagatunda and Kibaye markets (Community 1,2,3), Rice drying ground and storage (Community 4)",
  //       "education_access_blocked_by_river": "No education access blocked by river",
  //       "health_access_blocked_by_river": "Nyabisagara Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Mukindo ADEPR church (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, beans., maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyagafumberi , Bucaya, Rwinkuba and Rubona villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and farms. The population information for each village was provided by the Nyagafumberi Village Leader, Macumi Jean de Dieu and other village leaders from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8Ao5AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuhinda",
  //       "bridge_opportunity_project_code": "1013920",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.68141,
  //       "bridge_opportunity_gps_longitude": 29.87402,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2096,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.68141,
  //       "proposed_bridge_location_gps_longitude": 29.87402,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Gisagara Market (Community 3,4), Migina and Agatunda markets (Community 1,2), Farms (All Communities )",
  //       "education_access_blocked_by_river": "Rwimisambi Primary and Secondary School (Community 3,4)",
  //       "health_access_blocked_by_river": "Byiza Health Center (Community 3,4)",
  //       "other_access_blocked_by_river": "Gisagara District Office and Huye Town (Community 3,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kamabango, Musatsi, Gasharu and Kagarama villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Cyumba Cell Leader, Jean Pierre Basabose and the Kamabango Village Leader, Joseph Kambanda from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Cyumba, Mugombwa and Saga Cells. Community members in these cells sometimes use this crossing to visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AoAAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Busave",
  //       "bridge_opportunity_project_code": "1013921",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.57408,
  //       "bridge_opportunity_gps_longitude": 29.87933,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6071,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57408,
  //       "proposed_bridge_location_gps_longitude": 29.87933,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April, May, October, November and December; it last for 8 hours.",
  //       "market_access_blocked_by_river": "Musha, Gisagara and Ntyazo Markets (Community 1,2,3), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Gabiro Primary and Secondary School (Community 4,5), Kagoma Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Gishubi Health Center (Community 4,5), Gakoma Hospital (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Gisagara District Office, Kagoma Catholic Church (Community 1,2,3), Gishubi Sector Office, Gishubi ADEPR and Adventist Churches (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maize., potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "More than 100 people fell into the river. Most of them are motorcyclists or bicyclists who fall into the river trying to cross it. More than 10 people were seriously injured.",
  //       "notes_on_social_information": "Busave, Nyundo, Kigozi, Nyamure, Zamwe, Kagoma, Muyinza, Rwegura, Cyamanyeri and Nyabyunyu villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Gabiro Cell Leader, Athanase Ruziraguhunga and the Busave Village Leader, Daniel Hanyurwimfura from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Gabiro, Nyakibungo and Nyabitare Cells. Community members in these cells sometimes use this crossing to go to market, health centers or visit relatives.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AoFAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwinyana",
  //       "bridge_opportunity_project_code": "1013922",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.69786,
  //       "bridge_opportunity_gps_longitude": 29.90142,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2959,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.69786,
  //       "proposed_bridge_location_gps_longitude": 29.90142,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": "In March, April, May, October, November and December it last for 4 hours",
  //       "market_access_blocked_by_river": "Farms (Community 1,2,3,4,5), Agatunda and Kibaye markets (people from Burundi)",
  //       "education_access_blocked_by_river": "No Education access blocked",
  //       "health_access_blocked_by_river": "No health access blocked",
  //       "other_access_blocked_by_river": "No other access blocked by river",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyagafumberi, Bucaya, Rwinkuba, Akabacuzi and Nyamiheto villages were included in Individuals Directly Served because members of these communities use this crossing point to go farms in Nyagafumberi valley. The population information for each village was provided by the Nyagafumberi Village Leader, Macumi Jean de Dieu and other village leaders from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru )",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AoKAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitinsi",
  //       "bridge_opportunity_project_code": "1013923",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Gisagara",
  //       "bridge_opportunity_gps_latitude": -2.62646,
  //       "bridge_opportunity_gps_longitude": 29.88709,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4897,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.62646,
  //       "proposed_bridge_location_gps_longitude": 29.88709,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": "In March, April, May, October, November and December; it last for 8 hours",
  //       "market_access_blocked_by_river": "Gisagara and Huye Markets (Community 4,5), Kibangu and Musha Markets (Community 1,2,3), Farms (All Communities ), Rice drying ground and storage (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Muganza Primary School (Community 4,5), Rwamiko Primary and Secondary School (1,2,3)",
  //       "health_access_blocked_by_river": "Kirarambogo Health Center (Community 1,2,3), Kibirizi District Hospital (Community 4,5)",
  //       "other_access_blocked_by_river": "Muganza Sector Office, Muganza ADEPR and Adventist Churches (Community 4,5), Kirarambogo Catholic Parish, Football pitch (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, beans., maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "More than 30 people have been falling into the river and some of them were seriously injured. 2 people died when trying to cross the river during rainy season in May 2018.",
  //       "notes_on_social_information": "Gitinsi, Gatongati, Cyanamo, Rwamugoyi, Rwinkuba, Akimirama, Kidaturwa and Ubuseruka villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches, farms and schools. The population information for each village was provided by the Muganza Cell Leader, Kabaranga Jeannine from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Muganza and Rwamiko Cells. Community members in these cells sometimes use this crossing to visit relatives to go to health centers or the football pitch .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 (Kigali-Huye-Akanyaru)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AoPAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Ntomoka",
  //       "bridge_opportunity_project_code": "1013972",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.49231,
  //       "bridge_opportunity_gps_longitude": 28.91087,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2270,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. River too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.49231,
  //       "proposed_bridge_location_gps_longitude": 28.91087,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded because they made drainage",
  //       "market_access_blocked_by_river": "Kamembe Market (Ngoma)",
  //       "education_access_blocked_by_river": "Gikombe primary and secondary school (Ngoma)",
  //       "health_access_blocked_by_river": "Gihundwe health center and Hospital (Ngoma)",
  //       "other_access_blocked_by_river": "Taxi park, business centers, banks, (Ngoma)",
  //       "primary_occupations": "School, farm,",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of MONT cyangugu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TmoAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bitaba",
  //       "bridge_opportunity_project_code": "1013924",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.55713,
  //       "bridge_opportunity_gps_longitude": 28.92587,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3092,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.55713,
  //       "proposed_bridge_location_gps_longitude": 28.92587,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Bambiro market (Community 2,3), Karangiro market (Community 1,4), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Cyato Primary and Secondary School (Community 2,3)",
  //       "health_access_blocked_by_river": "Mibirizi Hospital (Community 2,3)",
  //       "other_access_blocked_by_river": "Nyakarenzo Sector Office and Cyato Anglican church (Community 2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyamugari, Bitaba, Bisenyi and Gatarama villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches, farms and schools. The population information for each village was provided by the Kabagina Cell Leader, Callixte Nzabonimpa from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8AoyAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihari",
  //       "bridge_opportunity_project_code": "1013925",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.55375,
  //       "bridge_opportunity_gps_longitude": 28.94637,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5138,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.55375,
  //       "proposed_bridge_location_gps_longitude": 28.94637,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Nyamugari, Kabumbwe, Kumana, Kanoga, Kanyovu, Ryamaraza and Bahuro villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches, farms and schools. The population information for each village was provided by the Kabagina Cell Leader, Callixte Nzabonimpa from the population data collected in 2018.",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Bambiro and Kamembe markets (Community 2,3,4,5), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Groupe Scolaire Marie Reine (Secondary School ), Cyato Primary and Secondary School (Community 2,3,4,5)",
  //       "health_access_blocked_by_river": "Bambiro Health Post (Community 2,3)",
  //       "other_access_blocked_by_river": "Nyakarenzo Sector Office and Bambiro SACCO Saving (Community 2,3,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, passion fruit, potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8Ap8AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kankenge1",
  //       "bridge_opportunity_project_code": "1013926",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.53862,
  //       "bridge_opportunity_gps_longitude": 28.96073,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2908,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.16",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.53862,
  //       "proposed_bridge_location_gps_longitude": 28.96073,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2,3), Bambiro and Kamembe markets (Community 4,5), Tea Hangar storage (Community 4,5)",
  //       "education_access_blocked_by_river": "Gihundwe and Gatare Primary and Secondary Schools, Mururu Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Gisunzu Health Post and Mibirizi Hospital (Community 4,5)",
  //       "other_access_blocked_by_river": "Rusizi Town, Ibanga ry'Amahoro (A Catholic pilgrimage place), Kanoga ADEPR Church (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, fruit, maiz, potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kumana, Kanoga, Kamanura, Gako and Ruamaraza villages were included in Individuals Directly Served because members of these communities use this crossing point to go to markets, health centers, churches and schools. The population information for each village was provided by the Kanoga cell Leader and the Kumana Village Leader, Emmanuel Nzamwita from the population data collected in 2018. Population of All Adjacent Communities includes other villages from Nkungu and Nyakabuye Sectors. Community members in these sectors use this crossing to go to Rusizi Town, health centers and catholics use this crossing point to go to pray once or twice a month at Kamembe (a pilgrimage place called Ibanga ry'Amahoro).",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 52,
  //       "height_differential_between_banks": 1.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d8ApIAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabutimbiri",
  //       "bridge_opportunity_project_code": "1013966",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.40129,
  //       "bridge_opportunity_gps_longitude": 28.95172,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3601,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.40129,
  //       "proposed_bridge_location_gps_longitude": 28.95172,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Unpaved road three kilometers away",
  //       "days_per_year_river_is_flooded": 98,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Hepho Market (rebero, kabutimbiri,Miramba)",
  //       "education_access_blocked_by_river": "Miramba primary and secondary (kinyaga, sumoyamana, Rugaragara), Rugaragara primary school (kabutimbiri, Rebero, miramba)",
  //       "health_access_blocked_by_river": "Rebero post health center (kinyaga, sumoyamana, Rugaragara), Gihundwe hospital district (kabutimbiri, Rebero, miramba)",
  //       "other_access_blocked_by_river": "District office and sector office (kabutimbiri, Rebero, miramba), cell office (Kabutimbiri)",
  //       "primary_occupations": "School, Market, farms,..",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Kinyaga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TkxAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burege",
  //       "bridge_opportunity_project_code": "1013967",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.40908,
  //       "bridge_opportunity_gps_longitude": 28.94244,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2081,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. River does not flood.",
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.40908,
  //       "proposed_bridge_location_gps_longitude": 28.94244,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Hepfo market (Burege)",
  //       "education_access_blocked_by_river": "Rugaragara primary school (Burege)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Market, School, farms,",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Kinyaga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TlCAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sumoyamana",
  //       "bridge_opportunity_project_code": "1013968",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.39416,
  //       "bridge_opportunity_gps_longitude": 28.94347,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1716,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. One vehicular road and river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.39416,
  //       "proposed_bridge_location_gps_longitude": 28.94347,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Hepfo Market (Kabutimbiri, Rugaragara) coffee wash site ( kabutimbiri, Rugaragara)",
  //       "education_access_blocked_by_river": "Primary school (Sumoyamana, Kinyaga) , Miramba primary and secondary school (Sumoyamana and Kinyaga)",
  //       "health_access_blocked_by_river": "Rebero post health center (Sumoyamana and Kinyaga)",
  //       "other_access_blocked_by_river": "Cell office (Kabutimbiri) district office (Kabutimbiri and Miramba)",
  //       "primary_occupations": "Market, school, farms",
  //       "primary_crops_grown": "coffe, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Kinyaga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Kamembe",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The cell leader insists that we can build the suspension bridge but it is on unpaved road even no car used this road",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TlHAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karama",
  //       "bridge_opportunity_project_code": "1013969",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.42356,
  //       "bridge_opportunity_gps_longitude": 28.94508,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42356,
  //       "proposed_bridge_location_gps_longitude": 28.94508,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 65,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Hepfo Market (Giheke sector)",
  //       "education_access_blocked_by_river": "Rugaragara primary school and Miramba primary and secondary school (Giheke sector)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Market, school, farms",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of kamahoro",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TlqAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamahoro",
  //       "bridge_opportunity_project_code": "1013970",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.42341,
  //       "bridge_opportunity_gps_longitude": 28.95197,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42341,
  //       "proposed_bridge_location_gps_longitude": 28.95197,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded , they continue to cross",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Hepfo Market (Giheke sector), farms on both side,",
  //       "education_access_blocked_by_river": "Miramba primary and secondary school (giheke sector)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Kivu lac (Giheke sector)",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Kamahoro",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1Tm5AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buzi",
  //       "bridge_opportunity_project_code": "1013971",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.42021,
  //       "bridge_opportunity_gps_longitude": 28.95772,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42021,
  //       "proposed_bridge_location_gps_longitude": 28.95772,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 68,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Hepfo Market (Giheke), rice farm (Giheke sector)",
  //       "education_access_blocked_by_river": "Miramba primary and secondary school (Giheke sector)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Kivu Lac (Giheke sector)",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "coffe, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Kamahoro",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 79,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TmAAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burunga",
  //       "bridge_opportunity_project_code": "1013974",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.47061,
  //       "bridge_opportunity_gps_longitude": 28.91442,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4328,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.47061,
  //       "proposed_bridge_location_gps_longitude": 28.91442,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kamembe Market (Burunga, Karorabose, Kamabuye, karushaririza)",
  //       "education_access_blocked_by_river": "Primary and secondary school Islamic (Burunga, Karorabose, Kamabuye, karushaririza), saint Bruno primary and secondary school (Rushakamba)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Churches both side, taxi park and district office (Burunga, Karorabose, Kamabuye, karushaririza)",
  //       "primary_occupations": "Market, farm, school,..",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Chef of Security of Burunga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TnIAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitinda",
  //       "bridge_opportunity_project_code": "1013975",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.46143,
  //       "bridge_opportunity_gps_longitude": 28.91068,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4287,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46143,
  //       "proposed_bridge_location_gps_longitude": 28.91068,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Farms on both side, business center Munyana (Karorabose, Burunga, Karitasi, Kamabuye)",
  //       "education_access_blocked_by_river": "Saint Bruno Burunga Primary and secondary school (Kanyogo, Kamatita)",
  //       "health_access_blocked_by_river": "Gihundwe health center and Hospital (Kanyogo, Kamatita)",
  //       "other_access_blocked_by_river": "Kivu lac ( Kanyogo, Kamatita), taxi park (Karorabose, Burunga, Karitasi, Kamabuye),",
  //       "primary_occupations": "Farms, school, health center",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali and Rusizi",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TnmAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubenga1",
  //       "bridge_opportunity_project_code": "1013976",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.45007,
  //       "bridge_opportunity_gps_longitude": 28.91671,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2554,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45007,
  //       "proposed_bridge_location_gps_longitude": 28.91671,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "100 m",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Kamembe Market (Kivumu and Gatsiro), Gatsiro Market (Rubenga)",
  //       "education_access_blocked_by_river": "Nkanka college (Rubenga)CEFG SECONDARY SCHOOL (Rubenga) Kamatitu primary school (Rubenga)",
  //       "health_access_blocked_by_river": "Kwiperu post health center (Rubenga)",
  //       "other_access_blocked_by_river": "Churches (Rubenga)",
  //       "primary_occupations": "Market, school",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Rubenga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is closer to road 61.4 meters , and closer to vehicular bridge around 200 meter away",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TqvAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukohwa",
  //       "bridge_opportunity_project_code": "1013977",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.44658,
  //       "bridge_opportunity_gps_longitude": 28.9137,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2344,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.44658,
  //       "proposed_bridge_location_gps_longitude": 28.9137,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in two kilometers away",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Kabuga Market (Rukohwa, Kivoga , Nyandarima) Kamembe Market( Gatsiro)",
  //       "education_access_blocked_by_river": "No school blocked",
  //       "health_access_blocked_by_river": "Post health center kwiperu(Gatsiro)",
  //       "other_access_blocked_by_river": "Churches (Gatsiro)",
  //       "primary_occupations": "Market, farm,",
  //       "primary_crops_grown": "soja, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 5,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They was trying to cross the bridge when it was flooded and fell and became handicapped",
  //       "notes_on_social_information": "Community leaders of Rukohwa",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1Tr5AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivoga",
  //       "bridge_opportunity_project_code": "1013978",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.4432,
  //       "bridge_opportunity_gps_longitude": 28.90885,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1836,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4432,
  //       "proposed_bridge_location_gps_longitude": 28.90885,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometers away",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Kamembe Market (Kivoga, Nyandarima)",
  //       "education_access_blocked_by_river": "CEPJ secondary school (Kivoga, Nyandarima)",
  //       "health_access_blocked_by_river": "Health center kwiperu (Kivoga, Nyandarima)",
  //       "other_access_blocked_by_river": "Catholic church (Kivoga, Nyandarima)",
  //       "primary_occupations": "Market, school,",
  //       "primary_crops_grown": "coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Rukohwa",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TrAAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagasozi",
  //       "bridge_opportunity_project_code": "1013979",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.57813,
  //       "bridge_opportunity_gps_longitude": 28.97657,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5081,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57813,
  //       "proposed_bridge_location_gps_longitude": 28.97657,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 hour",
  //       "market_access_blocked_by_river": "Bambiro and Kamembe markets (Community 1,4,5), Nyakabuye market (Community 1,2,3), Coffee Washing Station (Community 1,4,5)",
  //       "education_access_blocked_by_river": "Kaboza Primary School (Community 1,4,5), Mibirizi Primary and Secondary School (Community 1,4,5)",
  //       "health_access_blocked_by_river": "Cyingwa Health Post and Mibirizi Hospital (Community 1,4,5)",
  //       "other_access_blocked_by_river": "Cyingwa Cell Office, Cyingwa ADEPR church and Mibirizi Catholic Parish (Community 1,4,5)",
  //       "primary_occupations": "Agriculture and Brick making",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many people have been falling by this bridge, three among them were seriously injured with one amputated of one leg.",
  //       "notes_on_social_information": "Mugenge, Rwihene, Kabucuku, Mpinga and Kabugarama villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Cyingwa Cell Leader, Iyamuremye Jean Bosco from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TsSAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karongi",
  //       "bridge_opportunity_project_code": "1013980",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.57549,
  //       "bridge_opportunity_gps_longitude": 28.97839,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5081,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57549,
  //       "proposed_bridge_location_gps_longitude": 28.97839,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Nond",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2,3), Bambiro and Kamembe markets (Community 4,5), Coffee Washing Station (Community 4,5)",
  //       "education_access_blocked_by_river": "Kaboza Primary School (Community 4,5), Mibirizi Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Cyingwa Health Post and Mibirizi Hospital (Community 4,5)",
  //       "other_access_blocked_by_river": "Cyingwa Cell Office, Cyingwa ADEPR church and Mibirizi Catholic Parish (Community 4,5)",
  //       "primary_occupations": "Agriculture and Brick making",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "People have been falling into the river but none of them were seriously injured.",
  //       "notes_on_social_information": "Mugenge, Rwihene, Kabucuku, Mpinga and Kabugarama villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Cyingwa Cell Leader, Iyamuremye Jean Bosco from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TsXAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gafumba",
  //       "bridge_opportunity_project_code": "1013981",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.58071,
  //       "bridge_opportunity_gps_longitude": 28.97723,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5081,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.58071,
  //       "proposed_bridge_location_gps_longitude": 28.97723,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Nyakabuye (Community 1,2,3), Bambiro and Kamembe markets (Community 1,4,5), Coffee Washing Station (Community 1,4,5)",
  //       "education_access_blocked_by_river": "Kaboza Primary School (Community 4,5), Mibirizi Secondary School (Community 1,4,5)",
  //       "health_access_blocked_by_river": "Cyingwa Health Post and Mibirizi Hospital (Community 1,4,5)",
  //       "other_access_blocked_by_river": "Cyingwa Cell Office, Cyingwa ADEPR church and Mibirizi Catholic Parish (Community 1,4,5)",
  //       "primary_occupations": "Agriculture and Brick making",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato, vegetables.",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people per year fall into the river at this crossing point, 4 of them were seriously injured.",
  //       "notes_on_social_information": "Mugenge, Rwihene, Kabucuku, Mpinga and Kabugarama villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Cyingwa Cell Leader, Iyamuremye Jean Bosco from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 2.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TscAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitega",
  //       "bridge_opportunity_project_code": "1013982",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.57392,
  //       "bridge_opportunity_gps_longitude": 28.98504,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5081,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57392,
  //       "proposed_bridge_location_gps_longitude": 28.98504,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 2,3,4,5), Bambiro and Kamembe markets (Community 1)",
  //       "education_access_blocked_by_river": "Kaboza Primary School (Community 1), Mibirizi Secondary School (Community 1)",
  //       "health_access_blocked_by_river": "Cyingwa Health Post and Mibirizi Hospital (Community 1)",
  //       "other_access_blocked_by_river": "Cyingwa Cell Office, Cyingwa ADEPR church and Mibirizi Catholic Parish (Community 1)",
  //       "primary_occupations": "Agriculture and Brick making",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "Many people fell into the river but none of them were seriously injured.",
  //       "notes_on_social_information": "Mugenge, Rwihene, Kabucuku, Mpinga and Kabugarama villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Cyingwa Cell Leader, Iyamuremye Jean Bosco from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TshAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakivomero",
  //       "bridge_opportunity_project_code": "1013983",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.5847,
  //       "bridge_opportunity_gps_longitude": 29.01409,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9195,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.5847,
  //       "proposed_bridge_location_gps_longitude": 29.01409,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2,3), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Nyakabwende Primary and Secondary School (Community 1,2,3), Mashesha Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Mashesha Health Center and Kibirizi Hospital (Community 4,5)",
  //       "other_access_blocked_by_river": "Amashyuza (Geothermal water) tourism attraction, Nyakabuye ADEPR church and Catholic Church (Community 1,2,3), Mashesha ADEPR church (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Karama, Idaga, Kankuba, Busasamana, Nyakivomero, Ruganzu, Kibirizi, Murambi and Rukamba villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Mashesha Cell Leader, Verena Kanakuze from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 1.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TsmAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karama",
  //       "bridge_opportunity_project_code": "1013984",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.60072,
  //       "bridge_opportunity_gps_longitude": 28.99702,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4309,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.60072,
  //       "proposed_bridge_location_gps_longitude": 28.99702,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Nyakabuye (Community 4,5), Farms (Community 1,4)",
  //       "education_access_blocked_by_river": "Mashesha Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Mashesha Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Mashesha ADEPR church (Community 4,5), Amashyuza (Geothermal water)tourism attraction",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "2 people were seriously injured when crossing by this bridge but more than 100 people have been falling into the river in the past 3 years.",
  //       "notes_on_social_information": "Karama, Idaga, Kankuba, Kazinda and Kamagaju villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Mashesha Cell Leader, Verena Kanakuze from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR1 1 (Rusizi Town-Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TsrAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ntenyi",
  //       "bridge_opportunity_project_code": "1013985",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.60778,
  //       "bridge_opportunity_gps_longitude": 28.95301,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3384,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.60778,
  //       "proposed_bridge_location_gps_longitude": 28.95301,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "In April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Bambiro market (Community 1,2), Gishoma market (Community 3,4,5), Coffee Washing & Drying Station (Community 3,4,5), Farms (All Communities)",
  //       "education_access_blocked_by_river": "Ntenyi Primary School (Community 3,4,5), Mibirizi Primary and Secondary School (Community 1,2), College de la lumière de Gashonga (Community 3,4,5),",
  //       "health_access_blocked_by_river": "Mibirizi Hospital (1,2) and Mushaka health center (Community 3,4,5)",
  //       "other_access_blocked_by_river": "Mibirizi Catholic Parish (Community 1,2), Mushaka Catholic and ADEPR Churches (Community 3,4,5),",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ntenyi, Gatare, Bitaba, Kiremereye and Kamuhana villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, coffee washing station, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Rubugu Cell Leader, Dieudonne Uzayisenga and the Ntenyi village leader, Telesphore Harindintwali, from the population data collected in 2018. Population of All Adjacent Communities includes the villages from Mushaka and Karenge Cells in Rwimbogo Sector and Kacyuma cell in Gashonga sector and villages from Nyakabuye and Gitambi Sectors. Community members from these villages sometimes use this crossing to visit relatives, or to visit the market once a month.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TswAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyange",
  //       "bridge_opportunity_project_code": "1013986",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.61167,
  //       "bridge_opportunity_gps_longitude": 28.96442,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3437,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.61167,
  //       "proposed_bridge_location_gps_longitude": 28.96442,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "6 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market(Community 1,2,3), Gishoma market (Community 4,5), Coffee Washing & Drying Station (Community 4,5), Farms (All Communities)",
  //       "education_access_blocked_by_river": "No education access blocked by river",
  //       "health_access_blocked_by_river": "Mibirizi Hospital (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Mibirizi Catholic Parish (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 200,
  //       "incident_descriptions": "Many people have been falling into the river, a person almost every two days. 2 people died last season during rainy season.",
  //       "notes_on_social_information": "Ntenyi, Gatare, Nyange, Rurama, Kagomero and Ruhinga villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, coffee washing station, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Rubugu Cell Leader, Diedonne Uzayisenga and the Ntenyi village leader, Telesphore Harindintwali, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1Tt1AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karitasi 2",
  //       "bridge_opportunity_project_code": "1013993",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.45603,
  //       "bridge_opportunity_gps_longitude": 28.91183,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5163,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45603,
  //       "proposed_bridge_location_gps_longitude": 28.91183,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded the whole day but it takes three hours",
  //       "market_access_blocked_by_river": "Kamembe Market (Kanombe,Karitasi, Karorabose)",
  //       "education_access_blocked_by_river": "Karushaririza primary and secondary (Gitinda and Munyana) APEDIK primary and secondary (Karitasi,Kanombe, Karorabose, ...)",
  //       "health_access_blocked_by_river": "Gihundwe health center and Hospital (Gitinda and Munyana)",
  //       "other_access_blocked_by_river": "Catholic, Pentecost and Adventists churches (Gitinda and Munyana)",
  //       "primary_occupations": "Market, school,",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Karitasi and people who live closer to the bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TuEAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyuma",
  //       "bridge_opportunity_project_code": "1013987",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.62002,
  //       "bridge_opportunity_gps_longitude": 28.96343,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1610,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.62002,
  //       "proposed_bridge_location_gps_longitude": 28.96343,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 3,4), Gishoma market (Community 1,2), Coffee Washing Station (Community 3,4), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Gishoma Primary and Secondary School (Community 1,2)",
  //       "health_access_blocked_by_river": "Mibirizi Hospital (Community 3,4)",
  //       "other_access_blocked_by_river": "Mibirizi Catholic Parish (Community 3,4), Mushaka Catholic church (Community 1,2), Rwimbogo Sector Office (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 20,
  //       "incident_descriptions": "One person fell into the river and died, more than 20 people have been injured at this crossing point.",
  //       "notes_on_social_information": "Nyange, Gatare, Rukombe and Murama villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, coffee washing station, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Rubugu Cell Leader, Diedonne Uzayisenga and the Gatare village leader, Nehemiah Mukekarugamba, from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1Tt6AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahongobwe",
  //       "bridge_opportunity_project_code": "1013988",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.6174,
  //       "bridge_opportunity_gps_longitude": 28.95564,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2169,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6174,
  //       "proposed_bridge_location_gps_longitude": 28.95564,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "6 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Bambiro market (Community 3), Gishoma market (Community 1,2), Coffee Washing Station (Community 3), Farms(Community 1,2,3)",
  //       "education_access_blocked_by_river": "No education access blocked by river",
  //       "health_access_blocked_by_river": "Mibirizi Hospital (Community 3)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, fruit, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ntenyi, Gatare and Rukombe villages were included in Individuals Directly Served because their community members use the crossing point to go to farms, markets, coffee washing station, health centers or to visit relatives. The population information for each village was provided by the Rubugu Cell Leader, Diedonne Uzayisenga and the Ntenyi village leader, Telesphore Harindintwali, from the population data collected in 2018. This crossing point is mainly used to go to farms on both sides of the river.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TtBAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyamabuye",
  //       "bridge_opportunity_project_code": "1013989",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.6627,
  //       "bridge_opportunity_gps_longitude": 28.95512,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4686,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6627,
  //       "proposed_bridge_location_gps_longitude": 28.95512,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Bugarama market (Community 3,4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Kabuhanda Primary School (Community 3,4,5), Ruhoko Primary School, Butambamo Primary and Secondary School (Community 1,2)",
  //       "health_access_blocked_by_river": "Rwinzuki health center (Community 1,2)",
  //       "other_access_blocked_by_river": "Ngoma and Burembo ADEPR Churches (Community 3,4,5), Ruhoko Catholic Church and Nzahaha Sector Office (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "One person has died on this crossing point and more than 50 people have been injured.",
  //       "notes_on_social_information": "Ngoma, Gashagwa, Buganza, Gaculiro and Kamina villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, coffee washing station, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Murya Cell Leader from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TtaAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare",
  //       "bridge_opportunity_project_code": "1013990",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.6639,
  //       "bridge_opportunity_gps_longitude": 28.95315,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4154,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6639,
  //       "proposed_bridge_location_gps_longitude": 28.95315,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Bugarama market (Community 3,4), Farms (Community 1,2,3,4 )",
  //       "education_access_blocked_by_river": "No education access blocked by river",
  //       "health_access_blocked_by_river": "No health access blocked",
  //       "other_access_blocked_by_river": "Potable water (Community 1)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 100,
  //       "incident_descriptions": "One person (child) died at this crossing point, and many have been injured trying to cross the river.",
  //       "notes_on_social_information": "Ngoma, Gashagwa, Buganza and Gaculiro villages were included in Individuals Directly Served because their community members use the crossing point to go to farms, markets, to get potable water or to visit relatives. The population information for each village was provided by the Murya Cell Leader and the Buganza village leader, Vincent, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TtfAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagasayo",
  //       "bridge_opportunity_project_code": "1013991",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.66859,
  //       "bridge_opportunity_gps_longitude": 28.94991,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4263,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.66859,
  //       "proposed_bridge_location_gps_longitude": 28.94991,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "6 km",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Bugarama market (Community 4,5), Gishoma market (Community 1,2,3), Coffee Washing Station (Community 1,2,3), Farms (Community1,2,3,4,5), Gishoma Thermal Power Station (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Butambamo Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Rwinzuki health center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Nzahaha Sector Office (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people have been injured trying to cross the river.",
  //       "notes_on_social_information": "Gashagwa, Tare, Nyagahanga, Buganza and Ryagashyitse villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, coffee washing station, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Murya Cell Leader and the Buganza village leader from the population data collected in 2018. Many members of communities 1,2 and 3 work at Gishoma Thermal Power Station so they use this crossing point everyday.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Rusizi Town - Bugarama)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TtkAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruramba",
  //       "bridge_opportunity_project_code": "1013992",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.6402,
  //       "bridge_opportunity_gps_longitude": 29.00718,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4704,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.6402,
  //       "proposed_bridge_location_gps_longitude": 29.00718,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours.",
  //       "market_access_blocked_by_river": "Muganza market and Muganza trading center (Community 1,2), Gishoma market (Community 3), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Muganza TVET school, Ruganda Primary School, Mère du Bon Conseil Secondary School (Community 2)",
  //       "health_access_blocked_by_river": "Muganza health center (Community 1,2)",
  //       "other_access_blocked_by_river": "Ruganda cell office (Community 2), Mashyuza Catholic Parish and ADEPR Church (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "More than 30 people have been injured at this crossing point.",
  //       "notes_on_social_information": "Ruramba, Rubuye and all Gakoni villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, farms, health centers, churches and schools or to visit relatives. The population information for each village was provided by the Ruganda Cell Leader, Isae Tuyishimire, from the population data collected in 2018. Population of All Adjacent Communities includes the villages from Rubugu Cell in Nzahaha Sector, and villages from Rwimbogo and Gashonga sectors. Community members from these villages sometimes use this crossing to visit relatives, or to visit the market.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama - CIMERWA",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TtpAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karitasi 1",
  //       "bridge_opportunity_project_code": "1013994",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.45187,
  //       "bridge_opportunity_gps_longitude": 28.91158,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4842,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. There is an alternate crossing 200 meters away and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45187,
  //       "proposed_bridge_location_gps_longitude": 28.91158,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "200 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kamembe Market (Karitasi, Kanombe, Karorabose)",
  //       "education_access_blocked_by_river": "Primary and secondary Karushaririza (Kamatita cell)",
  //       "health_access_blocked_by_river": "Gihundwe health center and Hospital (Kamatita cell)",
  //       "other_access_blocked_by_river": "Sector office (Kamatita)",
  //       "primary_occupations": "Market, farms, hospital,..",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Karitasi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is closer to vehicular bridge around 200 meters",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TuOAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karushaririza",
  //       "bridge_opportunity_project_code": "1013995",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.46236,
  //       "bridge_opportunity_gps_longitude": 28.92434,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7365,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46236,
  //       "proposed_bridge_location_gps_longitude": 28.92434,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None, it takes on three hours",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It takes 3 hours",
  //       "market_access_blocked_by_river": "Kamembe Market (Shagasha, Munyove, Bisanganiro,..)",
  //       "education_access_blocked_by_river": "Karushaririza primary and secondary school (Shagasha, Munyove, Bisanganiro,...), what's she primary school (Rwahi, Karushaririza, Karangiro, Kamabuye, Karorabose)",
  //       "health_access_blocked_by_river": "Gihundwe Helth center and Hospital (Ntura Munyove, Kwisha Shagasha Bisanganiro,..)",
  //       "other_access_blocked_by_river": "Gihundwe sector ( shagasha, Bisanganiro) , Rusizi District (Ntura Munyove, Kwisha Shagasha Bisanganiro,..), Catholic, Adventists and pentecotist churches (Ntura Munyove, Kwisha Shagasha Bisanganiro,..)",
  //       "primary_occupations": "School, Market, farm,",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 9,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "They was trying to cross the bridge when it was flooded and fell into river and became handicapped",
  //       "notes_on_social_information": "Community leaders of karishaririza",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Other",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TuTAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rebero",
  //       "bridge_opportunity_project_code": "1013996",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.40718,
  //       "bridge_opportunity_gps_longitude": 28.95003,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2804,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.21",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.40718,
  //       "proposed_bridge_location_gps_longitude": 28.95003,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Another timber bridge (footbridge), 1 kilometer away",
  //       "days_per_year_river_is_flooded": 38,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Hepfo Market (rebero)",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farms, Market",
  //       "primary_crops_grown": "cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Kinyaga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1TvcAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Pfunda",
  //       "bridge_opportunity_project_code": "1014004",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.70533,
  //       "bridge_opportunity_gps_longitude": 29.30478,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 650,
  //       "bridge_opportunity_comments": "BAJ Could be built.",
  //       "form_form_name": "Project Assessment - 2018.10.26",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70533,
  //       "proposed_bridge_location_gps_longitude": 29.30478,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 43,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Nkama high school",
  //       "health_access_blocked_by_river": "Nyundo health center",
  //       "other_access_blocked_by_river": "Churches at nyundo",
  //       "primary_occupations": "Farming and business",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One child fell when the river was flooded and got a serious injury and another fell while he was trying to cross because the bridge is at elevation",
  //       "notes_on_social_information": "Rugerero village don't have access to mahoko market and nombe village don't have access to farms. Information gathered from nombe village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 69,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1dvfAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiziguro",
  //       "bridge_opportunity_project_code": "1014005",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.70002,
  //       "bridge_opportunity_gps_longitude": 29.34484,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1506,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Would require homes to be demolished to locate abutments. There is an alternative crossing 100 meters and 500 meters away that can be seen from Google Earth.",
  //       "form_form_name": "Project Assessment - 2018.10.26",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70002,
  //       "proposed_bridge_location_gps_longitude": 29.34484,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "They us a vehicular bridge in half kilometer",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Kanama high school",
  //       "health_access_blocked_by_river": "Kanama hospital",
  //       "other_access_blocked_by_river": "ADPR in kanama",
  //       "primary_occupations": "Farming and business",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Children has signed trying to cross when it was flooded",
  //       "notes_on_social_information": "Information gathered from kiziguro leader Kiziguro village don't have access to mahoko market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is not enough space for the bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1dz1AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kayanza",
  //       "bridge_opportunity_project_code": "1014007",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.70278,
  //       "bridge_opportunity_gps_longitude": 29.33445,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 560,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.26",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.70278,
  //       "proposed_bridge_location_gps_longitude": 29.33445,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "365",
  //       "market_access_blocked_by_river": "Mahoko",
  //       "education_access_blocked_by_river": "Petit seminaire nyundo",
  //       "health_access_blocked_by_river": "Nyundo health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "People try to cross and as there is no current bridge sometimes they cross without knowing the river has raised and get flooded",
  //       "notes_on_social_information": "Information gathered from kanyanza cell leader Kanyanza don't have access to mahoko market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 47.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1e9pAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusambu",
  //       "bridge_opportunity_project_code": "1014008",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.431462,
  //       "bridge_opportunity_gps_longitude": 29.018172,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4465,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.431462,
  //       "proposed_bridge_location_gps_longitude": 29.018172,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge three kilometers away.",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "March to May , October to December, 8 hours",
  //       "market_access_blocked_by_river": "Bushenge market ( village 1,2 and 3), shagasha tea factory( village 4 and 5), farms ( village on both side)",
  //       "education_access_blocked_by_river": "EAVE Ntendezi, Rusumba primary school and Kamonyi secondary school( village 4 and 5). VTC shangi( village 1,2,and 3).",
  //       "health_access_blocked_by_river": "Kamonyi health center ( village 4 and 5).",
  //       "other_access_blocked_by_river": "Churches ( both are blocked), Shangazi Bus stop( village 4 and 5).",
  //       "primary_occupations": "Farming , tree plantation and tea farms workers",
  //       "primary_crops_grown": "cassava, coffe, tea, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Fell down in the river.",
  //       "notes_on_social_information": "Population information of each village was provided by villages leader who sourced from every month record of population in the community.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2EAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhabwa",
  //       "bridge_opportunity_project_code": "1014009",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.515733,
  //       "bridge_opportunity_gps_longitude": 29.04382,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9384,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.515733,
  //       "proposed_bridge_location_gps_longitude": 29.04382,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge five kilometers away.",
  //       "days_per_year_river_is_flooded": 57,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 6 hours",
  //       "market_access_blocked_by_river": "Mwezi market ( village 3), farms ( 1,2,3 ), mwezi coffee factory ( village 3 ).",
  //       "education_access_blocked_by_river": "G. S. Nyarusange , TTC mwezi, mwezi primary school mwezi, primary school nyanunda(village 3 )",
  //       "health_access_blocked_by_river": "Mwezi health center ( village 3)",
  //       "other_access_blocked_by_river": "Mwezi Catholic parish ( village 3 ), karengera sector ( village 3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, coffe, tre, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by mwezi cell leader, Nsengumuremyi Jean Baptists who sourced the data from cell register.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2JAAQ",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Bushekeri~ kamina",
  //       "bridge_opportunity_project_code": "1014010",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.401338,
  //       "bridge_opportunity_gps_longitude": 29.092203,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6637,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.401338,
  //       "proposed_bridge_location_gps_longitude": 29.092203,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometers away.",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 8 hours",
  //       "market_access_blocked_by_river": "Rwesero market ( village 2 ), Bushenge market ( village 2 ), buhinga mini market ( village 2), farms ( village 1 and 2), Gisakura tea factory( village 2 ), Akagera coffee washing station ( village 2).",
  //       "education_access_blocked_by_river": "Bishekeri primary school ( village 2) , Nyanza secondary school( village 2).",
  //       "health_access_blocked_by_river": "Gisakura health center ( village 2 )",
  //       "other_access_blocked_by_river": "Churches ( village 2), football terrain ( village 2).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by mpundu cell leader, who sourced the data from the cell register. The population of all adjacent communities includes the following villages : Bushekeri and mpundu cell., the community members from mpundu cell was included because the cross the river to do farming, to find service to the sector office and the students to school.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamasheke~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2OAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuganza",
  //       "bridge_opportunity_project_code": "1014012",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.504565,
  //       "bridge_opportunity_gps_longitude": 28.994356,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4005,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.504565,
  //       "proposed_bridge_location_gps_longitude": 28.994356,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge eight kilometers away.",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "October to May , one hours",
  //       "market_access_blocked_by_river": "Kamembe market ( community 5 ), mwezi market ( villages 1,2,3 and 4), Nyakabuye market ( village 1,2,3and 4), farms ( villages 1,2,3and 4).",
  //       "education_access_blocked_by_river": "Mwezi secondary school( village 1,2,3,4), college Matare( village 5).",
  //       "health_access_blocked_by_river": "Kiziguro dispensary ( community 5 ).",
  //       "other_access_blocked_by_river": "Mwezi Catholic parish ( village 1,2,3 and 4 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz, tre, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned while crossing the river from market .",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Rusizi~nyamasheke",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2YAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mpinga",
  //       "bridge_opportunity_project_code": "1014013",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.517903,
  //       "bridge_opportunity_gps_longitude": 29.002786,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4281,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.517903,
  //       "proposed_bridge_location_gps_longitude": 29.002786,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 3,
  //       "flood_duration_during_rainy_season": "October to May, 5 hours",
  //       "market_access_blocked_by_river": "Mwezi market ( 1,2 and 3), kamembe market ( village 4 and 5). Farms ( 1,2,3 and 4, 5).",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Mwezi Catholic church ( 1,2, and 3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, fruit, tre, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by villages leader who sourced the population from village record book. Population of all adjacent communities includes the following villages: mpinga, kadashya, karongoro, kabisheshe and karehe. The community members from villages 1,2 and 3 use the crossing to visit market twice a week and to worship on sundays.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kamambe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 2.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2dAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahati",
  //       "bridge_opportunity_project_code": "1014014",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.523685,
  //       "bridge_opportunity_gps_longitude": 28.998094,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2616,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.523685,
  //       "proposed_bridge_location_gps_longitude": 28.998094,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "October to November, March to May, 6 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market ( 1), kamembe market ( 2,3), farms ( 1,2 3).",
  //       "education_access_blocked_by_river": "Gahati primary school ( 2,3), Mataba secondary school ( 1 )",
  //       "health_access_blocked_by_river": "Nkungu health center ( 1 )",
  //       "other_access_blocked_by_river": "Central Catholic gahati ( 2,3 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, fruit, tre, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by villages leader during the Assessment meeting.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2iAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muhora",
  //       "bridge_opportunity_project_code": "1014015",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.531842,
  //       "bridge_opportunity_gps_longitude": 29.000594,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3350,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.531842,
  //       "proposed_bridge_location_gps_longitude": 29.000594,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Timber bridge one kilometer away.",
  //       "days_per_year_river_is_flooded": 5,
  //       "flood_duration_during_rainy_season": "October to December, March to May,",
  //       "market_access_blocked_by_river": "Farms ( 1,2,3 and 4 ).",
  //       "education_access_blocked_by_river": "G.S. Nkungu ( primary and secondary school) ~ village 1 and 2.",
  //       "health_access_blocked_by_river": "Nkungu health center ( 1,2)",
  //       "other_access_blocked_by_river": "Churches in mataba ( 1,2), cell office ( 1)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by mataba cell leader who sourced the population information from cell register book. Population of all adjacent communities includes the following villages: Mpinga, Muhora, honga and get onto. Population from mpinga use the bridge to the health center and the students to the secondary school.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama ~ Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 27,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2nAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitwa",
  //       "bridge_opportunity_project_code": "1014016",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.434499,
  //       "bridge_opportunity_gps_longitude": 28.946438,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 565,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.434499,
  //       "proposed_bridge_location_gps_longitude": 28.946438,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge only",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f2xAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Isha",
  //       "bridge_opportunity_project_code": "1014017",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.452429,
  //       "bridge_opportunity_gps_longitude": 28.938735,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 565,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Vehicular bridge wanted and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.452429,
  //       "proposed_bridge_location_gps_longitude": 28.938735,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 18,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 8 hours",
  //       "market_access_blocked_by_river": "Kamembe market ( 1,2)",
  //       "education_access_blocked_by_river": "Kamashangi primary school( 3)",
  //       "health_access_blocked_by_river": "Turandi dispensary ( 1,2), nkanka hospital ( 1,2)",
  //       "other_access_blocked_by_river": "Church ( 3 )",
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need only a vehicular bridge because the truck use the road sometimes",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f37AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Honga",
  //       "bridge_opportunity_project_code": "1014018",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.533586,
  //       "bridge_opportunity_gps_longitude": 28.997215,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.533586,
  //       "proposed_bridge_location_gps_longitude": 28.997215,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "October to December, April and May, community cross all days",
  //       "market_access_blocked_by_river": "Kamembe market ( village 1 and 4), mataba market ( village 2 and 3), farms ( 1 and 2).",
  //       "education_access_blocked_by_river": "Groupe scholaire nkungu~ primary and secondary school ( village 2 ).",
  //       "health_access_blocked_by_river": "Nkungu health center( village 2 and 3).",
  //       "other_access_blocked_by_river": "Churches ( 2 , 3), cell office ( 2 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama cimerwa",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community cross year round",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f3CAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatagara",
  //       "bridge_opportunity_project_code": "1014019",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.552118,
  //       "bridge_opportunity_gps_longitude": 29.007152,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5237,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.552118,
  //       "proposed_bridge_location_gps_longitude": 29.007152,
  //       "current_crossing_method": "Stones",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge three kilometers away.",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "October to December, March, April and May, 2 to 3 hours",
  //       "market_access_blocked_by_river": "No market is blocked they use a vehicular bridge to go to the market, nyakabuye coffee washing station ( village 1 ), farms ( 1and 2).",
  //       "education_access_blocked_by_river": "G.S.Nkungu ( primary and secondary school) ( village 2 )",
  //       "health_access_blocked_by_river": "Nkungu health center ( 2 )",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by mataba cell leader, who sourced them from the cell register done in 2018. Community directly served by the bridge are gatagara and . Population from cross the river to the health center and do farming in gatagara. Gatagara people cross the river to do farming and sometimes to visit relatives.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Cimerwa ~ bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 1.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f3HAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatondo",
  //       "bridge_opportunity_project_code": "1014020",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.53305,
  //       "bridge_opportunity_gps_longitude": 29.016558,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8228,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.53305,
  //       "proposed_bridge_location_gps_longitude": 29.016558,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "October to December, April and May, 8 hours",
  //       "market_access_blocked_by_river": "Mwezi market ( village 1 and 2), mataba market ( 3 ), farms ( 1,2,3).",
  //       "education_access_blocked_by_river": "VTC Mwezi ( 1 and 2 ).",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Mwezi Catholic church ( 1 and 2 ), mataba curches( 3 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, tre, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by cell leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 59,
  //       "height_differential_between_banks": 2.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f3MAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubona 1",
  //       "bridge_opportunity_project_code": "1014034",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.2405167,
  //       "bridge_opportunity_gps_longitude": 29.491855,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 22292,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2405167,
  //       "proposed_bridge_location_gps_longitude": 29.491855,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 55,
  //       "flood_duration_during_rainy_season": "55times in April, May, October November and December and it lasts 1day after rainfall",
  //       "market_access_blocked_by_river": "Mugano sector doesn't have access to Gahunduguru market Rubona, Muremure, Maryohe, Nyagasozi villages don't have access to Kigarama market",
  //       "education_access_blocked_by_river": "Rubona, Maryohe villages don't have access to Biguhu A Primary school Muremure, Nyagasozi villages don't have access to Biguhu B primary school and Ruganda secondary school",
  //       "health_access_blocked_by_river": "Mugano sector, Muremure, Nyagasozi villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, banana, cassava",
  //       "primary_crops_grown": "banana, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 102,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fN7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruvunasati",
  //       "bridge_opportunity_project_code": "1014021",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.542708,
  //       "bridge_opportunity_gps_longitude": 29.035636,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 19437,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.542708,
  //       "proposed_bridge_location_gps_longitude": 29.035636,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "12 kilometers",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "March to May, October to December, 8 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market, Muganza market , Bugarama site market ( community 1,2, and 3), Bumazi livestock market( community from nyakabuye sector in rusizi), farms ( village 1 and 4), cimerwa factory, cocoshoma factory, and rice factory in Bugarama and Bugarama coffee washing station( villages 1, 2 and 3).",
  //       "education_access_blocked_by_river": "Groupe scholaire Nyarusange( village 4 ), TTC mwezi ( village 4 ), VTC mwezi ( village 4)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Mwezi Catholic churches ( village 4 ), Anglican church, Jehovah witness( village 4), Ntendezi bus stop( village 4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, fruit, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "Slipped on the timber and fell down",
  //       "notes_on_social_information": "Population information of each village was provided by cell leaders, who sourced the population from cell record. The population of all adjacent communities includes the following communities: Mwezi cell, Miko cell, Gashashi cell and Muhondo .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Cimerwa road",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f3RAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rushwati ~ mwimereri",
  //       "bridge_opportunity_project_code": "1014022",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.575882,
  //       "bridge_opportunity_gps_longitude": 29.136492,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2631,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.575882,
  //       "proposed_bridge_location_gps_longitude": 29.136492,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in ten kilometers away",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 4 to 5 hours",
  //       "market_access_blocked_by_river": "Karambo market ( 2,3,4), rasano market ( 1), farms ( 1,2,3,4).",
  //       "education_access_blocked_by_river": "G.S.Gasumo primary and secondary school ( 2,3,4).",
  //       "health_access_blocked_by_river": "Gasumo dispensary ( 2,3,4),",
  //       "other_access_blocked_by_river": "Gasumo churches ( 2,3,4), nyamihanda cell office( 2,3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population data was provided by cell leader who called every village leader, and Gave the number.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama cimerwa",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 1.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f3WAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rushwati~ kirwano",
  //       "bridge_opportunity_project_code": "1014023",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.578095,
  //       "bridge_opportunity_gps_longitude": 29.140707,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2267,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.578095,
  //       "proposed_bridge_location_gps_longitude": 29.140707,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 5 hours",
  //       "market_access_blocked_by_river": "Karambo market ( 2,3), Rasano market ( 1), farms ( 1,2,3).",
  //       "education_access_blocked_by_river": "G.S.Gasumo ~ primary and secondary school ( 2,3)",
  //       "health_access_blocked_by_river": "Gasumo dispensary ( 2,3)",
  //       "other_access_blocked_by_river": "Gasumo churches ( 2,3), nyamihanda cell office ( 2,3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population data was provided by cell leader who sourced the population information from villages leader by phone call.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi( kamembe)",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f3bAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirwano~ mwimereri",
  //       "bridge_opportunity_project_code": "1014024",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.577491,
  //       "bridge_opportunity_gps_longitude": 29.140912,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1446,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.577491,
  //       "proposed_bridge_location_gps_longitude": 29.140912,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "15 kilometers",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 4 hours",
  //       "market_access_blocked_by_river": "Rasano market ( 1), farms ( 1,2,3)",
  //       "education_access_blocked_by_river": "G.S. Gasumo(2,3)",
  //       "health_access_blocked_by_river": "Gasumo dispensary ( 2,3)",
  //       "other_access_blocked_by_river": "Gasumo churches ( 2,3)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by nyamihanda cell leader who called every village to give the population number in their village.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 25,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f3gAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Munkamba",
  //       "bridge_opportunity_project_code": "1014025",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.566146,
  //       "bridge_opportunity_gps_longitude": 29.144802,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1403,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.27",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.566146,
  //       "proposed_bridge_location_gps_longitude": 29.144802,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "4 kilometers",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 2.5 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market , Gasumo market ( 1, 2). Farms ( 1,2,3)",
  //       "education_access_blocked_by_river": "Gasumo secondary school ( 1,2)",
  //       "health_access_blocked_by_river": "Nyabicyimbo health center ( 1,2)",
  //       "other_access_blocked_by_river": "Gasumo churches ( 1,2)",
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by nyamihanda cell leader who called every village leader to give the population they have in the village. The population members from village 1 and 2 are blocked to the market and cell office , community 4 sometimes uses the bridge to visit Nyakabuye Market once in the week.",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1f3lAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamata",
  //       "bridge_opportunity_project_code": "1014029",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": null,
  //       "bridge_opportunity_gps_longitude": null,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 55,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is a small ditch which they can build using timbers for motorcycle to cross, in addition it never get flooded. Information provided by locals and their leader: Gerard Uwimana( Sedo)",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fMdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngange",
  //       "bridge_opportunity_project_code": "1014030",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.230115,
  //       "bridge_opportunity_gps_longitude": 29.47708167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.230115,
  //       "proposed_bridge_location_gps_longitude": 29.47708167,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "36times in April, May, October November and December and it lasts 4hours after rainfall",
  //       "market_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Gahunduguru market Maryohe village doesn't have access to Mukungu animal market",
  //       "education_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Biguhu B primary school Maryohe village doesn't have access to Biguhu A Primary school",
  //       "health_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, cassava, beans",
  //       "primary_crops_grown": "bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He slipped on stones while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65.8,
  //       "height_differential_between_banks": 4.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fMiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Dusasa",
  //       "bridge_opportunity_project_code": "1014032",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.2195333,
  //       "bridge_opportunity_gps_longitude": 29.459935,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2205,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2195333,
  //       "proposed_bridge_location_gps_longitude": 29.459935,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 38,
  //       "flood_duration_during_rainy_season": "38times in April, May, October November and December and it lasts 4hours after rainfall",
  //       "market_access_blocked_by_river": "Kiguhu village doesn't have access to Gasenyi market Dusasa village doesn't have access to Gahunduguru market Kiguhu village doesn't have access to Mukungu animal market",
  //       "education_access_blocked_by_river": "Dusasa, Gahororo villages don't have access to Gituntu primary school",
  //       "health_access_blocked_by_river": "Dusasa, Gahororo villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, beans, banana,",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fMxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gikuku",
  //       "bridge_opportunity_project_code": "1014033",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.23241333,
  //       "bridge_opportunity_gps_longitude": 29.4756,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.23241333,
  //       "proposed_bridge_location_gps_longitude": 29.4756,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "Every time the rain falls, there is erosion with stones, trees, soil and flowing water at high speed At least 60times within a year people can't cross",
  //       "market_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Gahunduguru market Maryohe village doesn't have access to Mukungu animal market",
  //       "education_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Biguhu B primary school Maryohe village doesn't have access to Biguhu A Primary school",
  //       "health_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, beans, cassava",
  //       "primary_crops_grown": "bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 143.2,
  //       "height_differential_between_banks": 5.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fN2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabingo",
  //       "bridge_opportunity_project_code": "1014035",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.20644333,
  //       "bridge_opportunity_gps_longitude": 29.518888,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5441,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20644333,
  //       "proposed_bridge_location_gps_longitude": 29.518888,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "700 m",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "45times in April, May, October November and December and it lasts 3hours after rainfall",
  //       "market_access_blocked_by_river": "Kabingo cell, Birambo, Kagorora, villages don't have access to Kirinda market Gihororo, Gataba, Kabageni villages don't have access to Gahunduguru market",
  //       "education_access_blocked_by_river": "Gihororo, Gataba, Kabageni villages don't have access to Ruganda secondary school Kabingo cell, Birambo, Kagorora villages don't have access to Mwendo secondary school",
  //       "health_access_blocked_by_river": "Kabingo cell, Birambo, Kagorora, villages don't have access to Mwendo health center Kabingo cell, Birambo, Kagorora, villages don't have access to Kirinda hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of cassava, sweet potatoes, beans, maize",
  //       "primary_crops_grown": "bean, cassava, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 94,
  //       "height_differential_between_banks": 4.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubona 2",
  //       "bridge_opportunity_project_code": "1014036",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.2408033,
  //       "bridge_opportunity_gps_longitude": 29.4925267,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 22292,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2408033,
  //       "proposed_bridge_location_gps_longitude": 29.4925267,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 55,
  //       "flood_duration_during_rainy_season": "55times in April, May, October November and December and it lasts 1day after rainfall",
  //       "market_access_blocked_by_river": "Mugano sector doesn't have access to Gahunduguru market Rubona, Muremure, Maryohe, Nyagasozi villages don't have access to Kigarama market",
  //       "education_access_blocked_by_river": "Muremure, Nyagasozi villages don't have access to Biguhu B primary school and Ruganda secondary school Rubona, Maryohe villages don't have access to Biguhu A Primary school",
  //       "health_access_blocked_by_river": "Mugano sector,Muremure, Nyagasozi villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, banana, beans, cassava",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He slipped on trees that were on this crossing 1year ago and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 85,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagahara",
  //       "bridge_opportunity_project_code": "1014037",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.23438167,
  //       "bridge_opportunity_gps_longitude": 29.47267167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.23438167,
  //       "proposed_bridge_location_gps_longitude": 29.47267167,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 44,
  //       "flood_duration_during_rainy_season": "44times in April, May, October November and December and it lasts 5hours after rainfall",
  //       "market_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Gahunduguru market Maryohe village doesn't have access to Mukungu animal market",
  //       "education_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Biguhu B primary school Maryohe village doesn't have access to Biguhu A Primary school",
  //       "health_access_blocked_by_river": "Ngange, Murambi, Gitwa, Kiguhu villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": "Cell office",
  //       "primary_occupations": "There is farming of cassava, sweet potatoes, banana, beans",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 66,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakibande1",
  //       "bridge_opportunity_project_code": "1014040",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.67323,
  //       "bridge_opportunity_gps_longitude": 29.36088,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1200,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Would need to demolish homes to find space for an abutment and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67323,
  //       "proposed_bridge_location_gps_longitude": 29.36088,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Nyakiriba high school",
  //       "health_access_blocked_by_river": "Nyakiriba health center",
  //       "other_access_blocked_by_river": "ADPR nyakiriba ,",
  //       "primary_occupations": "Business and farming",
  //       "primary_crops_grown": "potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "The river killed three person trying to cross",
  //       "notes_on_social_information": "Rugerero village don't have access to nyariba high school and nyakibande don't have access mahoko market Information gathered from nyakibande leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is not enough space for the bridge unless they destruct houses",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNgAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakibande2",
  //       "bridge_opportunity_project_code": "1014041",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.67428,
  //       "bridge_opportunity_gps_longitude": 29.36004,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2150,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Would need to demolish houses to construct bridge and river only floods for 1 hour.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.67428,
  //       "proposed_bridge_location_gps_longitude": 29.36004,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Mahoko",
  //       "education_access_blocked_by_river": "Nyakiriba high school",
  //       "health_access_blocked_by_river": "Nyakiriba health center",
  //       "other_access_blocked_by_river": "ADPR nyakiriba",
  //       "primary_occupations": "Farming and business",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "The commu ith slips on the current bridge and fall",
  //       "notes_on_social_information": "Rugerero don't have access to farms Nyakibande don't have access to mahoko village . Information gathered from nyakibande village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is no space for the bridge unless we destruct buildings but assessed the bridge and placed upstream way where there is enough space and community was suggesting that would be far by I had no choice expect to put it upstream way",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakibande3",
  //       "bridge_opportunity_project_code": "1014042",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.676,
  //       "bridge_opportunity_gps_longitude": 29.35857,
  //       "bridge_opportunity_bridge_type": "Concrete (11 - 20m)",
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2060,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.676,
  //       "proposed_bridge_location_gps_longitude": 29.35857,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 26,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Mahoko",
  //       "education_access_blocked_by_river": "Nyakiriba high school",
  //       "health_access_blocked_by_river": "Nyakiriba health center",
  //       "other_access_blocked_by_river": "ADPR nyakiriba",
  //       "primary_occupations": "Farming and business",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "In past ten years three Children and a girl were killed by river trying to cross",
  //       "notes_on_social_information": "Rugerero village don't have access to rubavu prison and nyakibande don't have access to mahoko village Information gathered from nyakibande village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rubavu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNqAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyahene",
  //       "bridge_opportunity_project_code": "1014043",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.72928,
  //       "bridge_opportunity_gps_longitude": 29.3348,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 680,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.72928,
  //       "proposed_bridge_location_gps_longitude": 29.3348,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Mahoko market",
  //       "education_access_blocked_by_river": "Kamugarura primary school",
  //       "health_access_blocked_by_river": "Mukondo post health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz, sugarcan",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "In past five years a child got injured trying to cross the river",
  //       "notes_on_social_information": "Gatovu cell don't have access to mahoko market Mukondo cell don't have access to centre scolaire kamugarura Information gathered from gatovu cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Mahoko",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fNvAAI",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Mizingo",
  //       "bridge_opportunity_project_code": "1014044",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.63268,
  //       "bridge_opportunity_gps_longitude": 29.39084,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2060,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63268,
  //       "proposed_bridge_location_gps_longitude": 29.39084,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 76,
  //       "flood_duration_during_rainy_season": "Week",
  //       "market_access_blocked_by_river": "Kabari market",
  //       "education_access_blocked_by_river": "Kanzeze high school",
  //       "health_access_blocked_by_river": "Nkamira hospital",
  //       "other_access_blocked_by_river": "ADPR church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "A child died when the river was flooded trying to cross",
  //       "notes_on_social_information": "Rwamikungu village don't have access to kabone market Information gathered from rwamikungu leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyabihu",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 82,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fO0AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwamikungu2",
  //       "bridge_opportunity_project_code": "1014045",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.63268,
  //       "bridge_opportunity_gps_longitude": 29.39084,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2160,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.63268,
  //       "proposed_bridge_location_gps_longitude": 29.39084,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Mizingo",
  //       "education_access_blocked_by_river": "Kanzeze high school",
  //       "health_access_blocked_by_river": "Kabari hospital",
  //       "other_access_blocked_by_river": "ADPR",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Rwamikungu village don't have access to mizingo hospital and kabare market Information gathered from rwamikungu leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Mizingo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fOAAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Muremure",
  //       "bridge_opportunity_project_code": "1014048",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.23574,
  //       "bridge_opportunity_gps_longitude": 29.48168167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 22292,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.23574,
  //       "proposed_bridge_location_gps_longitude": 29.48168167,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 52,
  //       "flood_duration_during_rainy_season": "52times in April, May, October November and December and it lasts 1day after rainfall",
  //       "market_access_blocked_by_river": "Muremure, Nyagasozi villages don't have access to Gahunduguru market Maryohe, Rubona villages don't have access to Ngunduzi market",
  //       "education_access_blocked_by_river": "Muremure, Nyagasozi villages don't have access to Biguhu B primary school Maryohe, Rubona villages don't have access to Bigugu A Primary school",
  //       "health_access_blocked_by_river": "Muremure, Nyagasozi villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": "Cell office",
  //       "primary_occupations": "Farming of sweet potatoes, beans, cassava, banana",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 80.8,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fOjAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabisiga",
  //       "bridge_opportunity_project_code": "1014049",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.153882,
  //       "bridge_opportunity_gps_longitude": 29.506953,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1836,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.153882,
  //       "proposed_bridge_location_gps_longitude": 29.506953,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "40times in April, May, October November and December and it lasts for 2days after rainfall",
  //       "market_access_blocked_by_river": "Nyabisiga, Nyakivumba villages don't have access to Rugabano market",
  //       "education_access_blocked_by_river": "Nyabisiga, Nyakivumba villages don't have access to Kabirizi Primary school Kabirizi village Nyabisiga Primary school",
  //       "health_access_blocked_by_river": "Kabirizi village doesn't have access to Mwendo health center",
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Farming of sweet potatoes, cassava, beans, banana",
  //       "primary_crops_grown": "banana, bean, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 89.8,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fOtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwankuba",
  //       "bridge_opportunity_project_code": "1014050",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.18135,
  //       "bridge_opportunity_gps_longitude": 29.37769,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3441,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18135,
  //       "proposed_bridge_location_gps_longitude": 29.37769,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Muvumba village & Gakangaga village and Kinaba village don't have access to Ruhuha market",
  //       "education_access_blocked_by_river": "Muvumba village & Gakangaga village and Kinaba village don't have access to GS Bigugu",
  //       "health_access_blocked_by_river": "Muvumba village & Gakangaga village and Kinaba village don't have access to Bigugu health center",
  //       "other_access_blocked_by_river": "Muvumba village & Gakangaga village and Kinaba village don't have access to Bigugu church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 10,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Many people died here",
  //       "notes_on_social_information": "A volunteer from nyantwa village leader provided some information about villages using the bridge and Bigugu cell leader told us info about people directly served by the bridge through phone call",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 100,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fOyAAI",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Karutare",
  //       "bridge_opportunity_project_code": "1014051",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.164835,
  //       "bridge_opportunity_gps_longitude": 29.491473,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3151,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.164835,
  //       "proposed_bridge_location_gps_longitude": 29.491473,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "75times in April, May, October November and December and it lasts 4hours after rainfall",
  //       "market_access_blocked_by_river": "Gatare, Nyakivumba villages don't have access to Mukibaya market Karutare, Karambo, Shungwe, Nyagasambu villages don't have access to Birambo market",
  //       "education_access_blocked_by_river": "Gatare, Nyakivumba, Nyabisiga villages don't have access to Shoba-Muramba Primary and Secondary school.",
  //       "health_access_blocked_by_river": "Karutare, Karambo, Shungwe villages don't have access to Mwendo health center",
  //       "other_access_blocked_by_river": "Church, Playground,",
  //       "primary_occupations": "Farming banana, beans, sweet potatoes",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "Nyagasambu village uses this crossing regularly and their people were included in the total population to be served. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41.2,
  //       "height_differential_between_banks": 2.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fPDAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Munini II",
  //       "bridge_opportunity_project_code": "1014053",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.1886,
  //       "bridge_opportunity_gps_longitude": 29.37909,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 852,
  //       "bridge_opportunity_comments": "Not Duplicate",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1886,
  //       "proposed_bridge_location_gps_longitude": 29.37909,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 122,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Two deaths across gitare river",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi _ Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fPcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukore",
  //       "bridge_opportunity_project_code": "1014055",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.17259,
  //       "bridge_opportunity_gps_longitude": 29.40382,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2606,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.17259,
  //       "proposed_bridge_location_gps_longitude": 29.40382,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": "Rukore village &Himbo village &Gishwati village don't have access to kivuruga market",
  //       "education_access_blocked_by_river": "Rukore village &Himbo village &Gishwati village don't have to access GS Gitesi",
  //       "health_access_blocked_by_river": "Rukore village &Himbo village &Gishwati village don't have access To Gasenyi health center",
  //       "other_access_blocked_by_river": "Rukore village &Himbo village &Gishwati village don't have access to ADEPR Kinaba, ryampande people don't have access to their field",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Ryampande village security officer provided all info about directly individual served by calling on phone other village leader . They referred to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fPmAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivumu",
  //       "bridge_opportunity_project_code": "1014057",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.228383,
  //       "bridge_opportunity_gps_longitude": 29.51722,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 21645,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.228383,
  //       "proposed_bridge_location_gps_longitude": 29.51722,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "30times in April, May, October November and December and it lasts for 1hour after rainfall",
  //       "market_access_blocked_by_river": "Mugano sector doesn't have access to Gahunduguru market Mugano sector doesn't have access to Birambo market Kagorora, Birambo villages don't have access to Kaduha market",
  //       "education_access_blocked_by_river": "Kagorora, Birambo villages don't have access to Turyango secondary school",
  //       "health_access_blocked_by_river": "Mugano sector doesn't have access to Biguhu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "There is farming of banana, cassava, sweet potatoes",
  //       "primary_crops_grown": "banana, cassava. bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 39.8,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fPwAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Marero",
  //       "bridge_opportunity_project_code": "1014058",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rubavu",
  //       "bridge_opportunity_gps_latitude": -1.64072,
  //       "bridge_opportunity_gps_longitude": 29.39906,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1748,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.64072,
  //       "proposed_bridge_location_gps_longitude": 29.39906,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Kabare market",
  //       "education_access_blocked_by_river": "Groupe scolaire nyamirango",
  //       "health_access_blocked_by_river": "Nyamikongi hea,th center",
  //       "other_access_blocked_by_river": "ADPR",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "People slips and fall in the river and get injured",
  //       "notes_on_social_information": "Marero village don't have access to farms And Kirebe market and mizingo market don't have access to Kirebe market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Mahoko",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rubavu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fQLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gipfura",
  //       "bridge_opportunity_project_code": "1014093",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.5886,
  //       "bridge_opportunity_gps_longitude": 29.05452,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7070,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.5886,
  //       "proposed_bridge_location_gps_longitude": 29.05452,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "0",
  //       "market_access_blocked_by_river": "Rusizi market, and kamembe market",
  //       "education_access_blocked_by_river": "TTC mururu and some cross going to study in DRC",
  //       "health_access_blocked_by_river": "Rusizi health center",
  //       "other_access_blocked_by_river": "ADPR gipfura",
  //       "primary_occupations": "Farming and business",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Because the bridge is at high level people are likely to fall",
  //       "notes_on_social_information": "Ryangoma village don't have access to rusizi market and gapfura village don't have access to kamembe market Information gathered from gipfura village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Birambo",
  //       "bridge_opportunity_project_code": "1014060",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.21065,
  //       "bridge_opportunity_gps_longitude": 29.519803,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4626,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.21065,
  //       "proposed_bridge_location_gps_longitude": 29.519803,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "48times in April, May, October November and December and it lasts 2hours after rainfall",
  //       "market_access_blocked_by_river": "Birambo, Kagorora villages don't have access to Birambo market",
  //       "education_access_blocked_by_river": "Kabingo cell doesn't have access to Ruganda primary school",
  //       "health_access_blocked_by_river": "Birambo, Kagorora villages don't have access to Kirinda Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, rice, forest",
  //       "primary_crops_grown": ", ric, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gataba village uses this crossing regularly and their people were included in the total population to be served. The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fSCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitwa",
  //       "bridge_opportunity_project_code": "1014062",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.242973,
  //       "bridge_opportunity_gps_longitude": 29.464718,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1703,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.242973,
  //       "proposed_bridge_location_gps_longitude": 29.464718,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "35 times in April, May, October November and December and it lasts 1day after rainfall",
  //       "market_access_blocked_by_river": "Murambi, Ngange villages don't have access to Mukungu animal market Gitwa, KIBARI villages don't have access to Gahunduguru market",
  //       "education_access_blocked_by_river": "Gitwa, KIBARI villages don't have access to Biguhu A Primary school",
  //       "health_access_blocked_by_river": "Gitwa, KIBARI villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": "Cell office",
  //       "primary_occupations": "Farming of banana, beans,",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44.4,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fSbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabivumu",
  //       "bridge_opportunity_project_code": "1014070",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.154842,
  //       "bridge_opportunity_gps_longitude": 29.5107383,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4055,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.154842,
  //       "proposed_bridge_location_gps_longitude": 29.5107383,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "32times in April,May, October November and December and it lasts for 2hours after rainfall",
  //       "market_access_blocked_by_river": "Rugobagoba cell doesn't have access to Birambo market",
  //       "education_access_blocked_by_river": "Rugobagoba cell doesn't have access to Birambo primary and secondary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Farming of maize, banana, sweet potatoes",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32.8,
  //       "height_differential_between_banks": 1.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fTKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugogo",
  //       "bridge_opportunity_project_code": "1014071",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.20755,
  //       "bridge_opportunity_gps_longitude": 29.44008,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3955,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20755,
  //       "proposed_bridge_location_gps_longitude": 29.44008,
  //       "current_crossing_method": "Timbers are used to cross the river",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 113,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Murambi village and rugogo village don't have acess to Mukungu market whereas Burango village , nyamugwagwa village and Kaduha village don't have access to Gasenyi market",
  //       "education_access_blocked_by_river": "Murambi village and rugogo village don't have acess to GS Nyamugwagwa",
  //       "health_access_blocked_by_river": "Murambi village and rugogo village don't have acess to mukungu health center",
  //       "other_access_blocked_by_river": "Murambi village and rugogo village don't have acess to EPR Burango",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One old woman died across Kiraga river",
  //       "notes_on_social_information": "Byogo cell leader provided the information about individual served by the bridge by referring to the population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fTPAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhondo",
  //       "bridge_opportunity_project_code": "1014073",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.24952,
  //       "bridge_opportunity_gps_longitude": 29.38323,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4867,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.24952,
  //       "proposed_bridge_location_gps_longitude": 29.38323,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 128,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Rwufi cell , kadehero village don't have access to Gakuta market whereas Twumba village, Karumbi village don't have access to Mukungu market",
  //       "education_access_blocked_by_river": "Rwufi cell , kadehero village don't have access to GS Gakuta",
  //       "health_access_blocked_by_river": "Rwufi cell , kadehero village don't have access to Gakuta Health center whereas Twumba village, Karumbi village don't have access to Mukungu health center",
  //       "other_access_blocked_by_river": "Twumba village, Karumbi village don't have access to Mukungu health center EPR Nyarukeri",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "3 people died across this mbirurume river",
  //       "notes_on_social_information": "Kadehero village leader provided info about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fTeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyamakamba",
  //       "bridge_opportunity_project_code": "1014074",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.22396167,
  //       "bridge_opportunity_gps_longitude": 29.43661833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5357,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.22396167,
  //       "proposed_bridge_location_gps_longitude": 29.43661833,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40times in April, May, October November and December and it lasts 3hours after rainfall",
  //       "market_access_blocked_by_river": "Nyamugwagwa cell doesn't have access to Mukungu animal market Murengezo cell doesn't have access to Gahunduguru market",
  //       "education_access_blocked_by_river": "Nyamugwagwa cell doesn't have access to Kiraga primary school Murengezo cell doesn't have access to Kibari Primary and Secondary school",
  //       "health_access_blocked_by_river": "Nyamugwagwa cell doesn't have access to Mukungu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, banana, beans, maize",
  //       "primary_crops_grown": "banana, bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": 2.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fTjAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rasaniro",
  //       "bridge_opportunity_project_code": "1014077",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.24468,
  //       "bridge_opportunity_gps_longitude": 29.40848,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3263,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.24468,
  //       "proposed_bridge_location_gps_longitude": 29.40848,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 121,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Mutuntu village, Gasharu village, mukungu village don't have access to Ruhuha market whereas Rasaniro village, Gatiti village, rugusa village and mwumba village don't have access to mukungu market",
  //       "education_access_blocked_by_river": "Mutuntu village, Gasharu village, mukungu village don't have access to Gs Nyamikeri whereas Rasaniro village, Gatiti village, rugusa village and mwumba village don't have access to GS mukungu",
  //       "health_access_blocked_by_river": "Rasaniro village, Gatiti village, rugusa village and mwumba village don't have access to mukungu health center",
  //       "other_access_blocked_by_river": "Mutuntu village, Gasharu village, mukungu village don't have access to kanyege Adventist church whereas Rasaniro village, Gatiti village, rugusa village and mwumba village don't have access to mukungu church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "3 injuries here and 2 death",
  //       "notes_on_social_information": "Rwufi cell leader provided all info about directly individual served by refering to 2018 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fU8AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabutagwa-gaseke",
  //       "bridge_opportunity_project_code": "1014096",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.55317,
  //       "bridge_opportunity_gps_longitude": 28.99986,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 968,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.55317,
  //       "proposed_bridge_location_gps_longitude": 28.99986,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyakabuye",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They are requesting a vehicular bridge",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVzAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Ruberandinda",
  //       "bridge_opportunity_project_code": "1014078",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.23732,
  //       "bridge_opportunity_gps_longitude": 29.40253,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2383,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.23732,
  //       "proposed_bridge_location_gps_longitude": 29.40253,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 126,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": "Mwumba village, rugusa village , and Rasaniro village don't have access to nyarutagara market",
  //       "education_access_blocked_by_river": "Kaganda village, kavumu village and nyarutagara village don't have access to GS Nyarukeri whereas Mwumba village, rugusa village , and Rasaniro village don't have access to GS Nyarutagara",
  //       "health_access_blocked_by_river": "Mwumba village, rugusa village , and Rasaniro village don't have access to nyarutagara health center",
  //       "other_access_blocked_by_river": "Kaganda village, kavumu village and nyarutagara village don't have access to kabere Adventist church whereas Mwumba village, rugusa village , and Rasaniro village don't have access to Nyarutagara Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "2 injuries and one death",
  //       "notes_on_social_information": "Rwufi cell leader provided all info about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fUDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusayo",
  //       "bridge_opportunity_project_code": "1014079",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.2414,
  //       "bridge_opportunity_gps_longitude": 29.39529,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1802,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2414,
  //       "proposed_bridge_location_gps_longitude": 29.39529,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 98,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": "Rugusa village and Mwumba village don't have access to Gakuta market, whereas murehe village don't have access to Ruhuha market",
  //       "education_access_blocked_by_river": "Rugusa village and Mwumba village don't have access to GS Gashiru , whereas murehe village don't have access to GS Mwanji",
  //       "health_access_blocked_by_river": "Rugusa village and mwumba village don't have access to Gakuta Health center",
  //       "other_access_blocked_by_river": "Rugusa village and Mwumba village don't have access to murehe church , whereas murehe village don't have access to uwabashi Adventist church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "No death , only 2 injuries in 2017",
  //       "notes_on_social_information": "Rwufi cell leader provided all info about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - uhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fUIAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhina",
  //       "bridge_opportunity_project_code": "1014080",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.11637,
  //       "bridge_opportunity_gps_longitude": 29.5875,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2582,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11637,
  //       "proposed_bridge_location_gps_longitude": 29.5875,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point near",
  //       "days_per_year_river_is_flooded": 86,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Mujyojyo village and Gasharu village don't have access to Kinnyane market",
  //       "education_access_blocked_by_river": "Mujyojyo village and Gasharu village don't have access to ES Munzanga whereas kuruganda village and ruhungamiyaga village don't have access to EP Mujyojyo",
  //       "health_access_blocked_by_river": "Mujyojyo village and Gasharu village don't have access to Munzanga health center",
  //       "other_access_blocked_by_river": "Mujyojyo village and Gasharu village don't have access to EPR kuruganda , whereas Kuruganda village and ruhungamiyaga village don't have access to Mujyojyo church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two injuries",
  //       "notes_on_social_information": "Murundi sector office security leader is the one who provided information about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fUNAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwinkomo",
  //       "bridge_opportunity_project_code": "1014081",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.10922,
  //       "bridge_opportunity_gps_longitude": 29.59721,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2059,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10922,
  //       "proposed_bridge_location_gps_longitude": 29.59721,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 116,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Karambo village , Mujyojyo village and Gakomeye village don't don't have access to Nyange market",
  //       "education_access_blocked_by_river": "Karambo village , Mujyojyo village and Gakomeye village don't don't have access to ES Munzanga",
  //       "health_access_blocked_by_river": "Karambo village , Mujyojyo village and Gakomeye village don't don't have access to Munzanga health center",
  //       "other_access_blocked_by_river": "Karambo village , Mujyojyo village and Gakomeye village don't don't have access to Budaha Adventist church , whereas Gasharu village, nyakirambo village and Bwenda village don't have access to EPR Gakomeye",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Four injuries across Rwinkomo river at this point",
  //       "notes_on_social_information": "Murundi sector security leader is the one who provided information about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fUSAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabutaka",
  //       "bridge_opportunity_project_code": "1014084",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.57067,
  //       "bridge_opportunity_gps_longitude": 29.02658,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 965,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Community wants vehicular bridge and the river is too small to warrant a B2P bridge.",
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57067,
  //       "proposed_bridge_location_gps_longitude": 29.02658,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyakabuye",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community is requesting a vehicular bridge",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56.2,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fUmAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nkanga",
  //       "bridge_opportunity_project_code": "1014085",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.57161,
  //       "bridge_opportunity_gps_longitude": 29.03953,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 42778,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57161,
  //       "proposed_bridge_location_gps_longitude": 29.03953,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "0",
  //       "market_access_blocked_by_river": "Nyakabuye",
  //       "education_access_blocked_by_river": "Nyakabwende high school",
  //       "health_access_blocked_by_river": "Nyakabuye health center",
  //       "other_access_blocked_by_river": "Nyakabuye cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "Because the bridge is not well constructed the community slip and fall",
  //       "notes_on_social_information": "Nkanga village don't have access to nyakabuye market and nyakabwende school Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyakabuye",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fUrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gata",
  //       "bridge_opportunity_project_code": "1014086",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.60327,
  //       "bridge_opportunity_gps_longitude": 29.0416,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1694,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.60327,
  //       "proposed_bridge_location_gps_longitude": 29.0416,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Muganza market and nyakabuye market",
  //       "education_access_blocked_by_river": "Nyabihanga high school",
  //       "health_access_blocked_by_river": "Gikundamvura health center",
  //       "other_access_blocked_by_river": "gikundamvura church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "People slu9s on the current bridge and fall",
  //       "notes_on_social_information": "Birindiro village don't have access to nyakabuye market and jyambere village don't have access to gikundamvura hospital Information gathered from cell labor",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Bugarama",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fV1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisesero2",
  //       "bridge_opportunity_project_code": "1014087",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.59176,
  //       "bridge_opportunity_gps_longitude": 29.04348,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1863,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.59176,
  //       "proposed_bridge_location_gps_longitude": 29.04348,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 56,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Nyakabuye",
  //       "education_access_blocked_by_river": "Nyakabwende high school",
  //       "health_access_blocked_by_river": "Gikundamvura health center",
  //       "other_access_blocked_by_river": "Nyabihanga church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "coffe",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "People slios on the current bridge and fall",
  //       "notes_on_social_information": "Buhinga village don't have access to nyakabuye market and kariba village dont have access to gikundamvura hospital. Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Bugarama",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 62,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabusheshe",
  //       "bridge_opportunity_project_code": "1014088",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.59647,
  //       "bridge_opportunity_gps_longitude": 29.04596,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1825,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.59647,
  //       "proposed_bridge_location_gps_longitude": 29.04596,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Nyakabuye market",
  //       "education_access_blocked_by_river": "Nyabinga high school",
  //       "health_access_blocked_by_river": "Gikundamvura health center",
  //       "other_access_blocked_by_river": "Nyabihanga church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 12,
  //       "incident_descriptions": "The community fall in the river when it is flooded",
  //       "notes_on_social_information": "Buying a village don't have access to gikundamvura hospital and kaberenge village don't have access to nyakabuye market Information gathered from local",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Bugarama",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fVLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabitimbo mwoya",
  //       "bridge_opportunity_project_code": "1014100",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.56517,
  //       "bridge_opportunity_gps_longitude": 29.08278,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1855,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.56517,
  //       "proposed_bridge_location_gps_longitude": 29.08278,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Nyakabuye market and kareba market",
  //       "education_access_blocked_by_river": "GS nyabitimbo",
  //       "health_access_blocked_by_river": "Nyabitimbo health center",
  //       "other_access_blocked_by_river": "Nyabitimbo cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 8,
  //       "incident_descriptions": "They slipped and fell down because the bridge is not in good condition",
  //       "notes_on_social_information": "Buganzo village don't have access to nyakabuye market Information gathered from nyabitimbo village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakabuye",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 67.2,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fWOAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugongo",
  //       "bridge_opportunity_project_code": "1014101",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.50322,
  //       "bridge_opportunity_gps_longitude": 28.90339,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2425,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.50322,
  //       "proposed_bridge_location_gps_longitude": 28.90339,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Kamembe market",
  //       "education_access_blocked_by_river": "Gihundwe secondary school",
  //       "health_access_blocked_by_river": "Rusizi health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Business",
  //       "primary_crops_grown": "tea",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two men slipped and fell in the river later they died due to the injury",
  //       "notes_on_social_information": "Karambi cell don't have access to kamembe market and gihundwe high school Information gathered from local and cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kamembe",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 77,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fWdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mizibira",
  //       "bridge_opportunity_project_code": "1014102",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.56301,
  //       "bridge_opportunity_gps_longitude": 29.06172,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8925,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.56301,
  //       "proposed_bridge_location_gps_longitude": 29.06172,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Gatereri market and nyakabuye market",
  //       "education_access_blocked_by_river": "Makoko primary school and nyantomvu high school",
  //       "health_access_blocked_by_river": "Nyabitimbo health center",
  //       "other_access_blocked_by_river": "Saint Dominic savio cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Mizibira market don't have access to gatereri market and mizibira village don't have access to nyakabuye market Information gathered from mizibira leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyakabuye",
  //       "name_of_nearest_paved_or_sealed_road": "Kamembe-bugarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fWiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigarama",
  //       "bridge_opportunity_project_code": "1014103",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.55734,
  //       "bridge_opportunity_gps_longitude": 29.0933,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6073,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.55734,
  //       "proposed_bridge_location_gps_longitude": 29.0933,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Nyaruteja Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Nyabitimbo Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Butare Sector Office (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maize., potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Three people have been injured trying to cross the river.",
  //       "notes_on_social_information": "Kigarama, Bisengo, Nyaruteja, Cyaruhiza, Cyijuru, Murambi, Buganzo and Gasine villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools and farming. Population information for each village was provided by the Rwambogo Cell Leader and the Kigarama Village leader Phenias Nizeyimana, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Kigali - Rusizi Town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 76,
  //       "height_differential_between_banks": 2.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fjhAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakabanda",
  //       "bridge_opportunity_project_code": "1014105",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.42715,
  //       "bridge_opportunity_gps_longitude": 28.95369,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3418,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42715,
  //       "proposed_bridge_location_gps_longitude": 28.95369,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Kamembe market (Community 2,3,4,5), Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Ntura Catholic and Protestant Schools (Community 1)",
  //       "health_access_blocked_by_river": "No health access blocked by river",
  //       "other_access_blocked_by_river": "Rusizi Town (Community 2,3,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric, sugarcan",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kanoga, Gacyamo, Buzi, Kabuga, Kagarama and Gaseke villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools and farming. Population information for each village was provided by the Gakomeye Cell Leader, Feline Niyonasenze, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Kigali - Rusizi Town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fjrAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamigisha",
  //       "bridge_opportunity_project_code": "1014106",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.42486,
  //       "bridge_opportunity_gps_longitude": 28.95726,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3398,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42486,
  //       "proposed_bridge_location_gps_longitude": 28.95726,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Kamembe market (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Kibumba Primary and Secondary School (Community 4,5), Ntura Catholic and Protestant Schools (Community 4,5)",
  //       "health_access_blocked_by_river": "Mwito Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Kamembe (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric, sugarcane.",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gacyamo, Buzi, Kabuga, Kagarama and Gasheke villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools and farming. Population information for each village was provided by the Gakomeye Cell Leader, Feline Niyonsenga, from the population data collected in 2018.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Kigali - Rusizi Town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fjwAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buzi",
  //       "bridge_opportunity_project_code": "1014107",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.42056,
  //       "bridge_opportunity_gps_longitude": 28.9662,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2859,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42056,
  //       "proposed_bridge_location_gps_longitude": 28.9662,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Kamembe market (Community 4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Kibumba Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Mwito Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Rusizi Town (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric, sugarcane.",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gacyamo, Buzi, Kabuga, Kagarama and Gaseke villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools and farming. Population information for each village was provided by the Gakomeye Cell Leader, Feline Niyonasenze, from the population data collected in 2018.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Kigali - Rusizi Town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fk1AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gacyamo",
  //       "bridge_opportunity_project_code": "1014108",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.41855,
  //       "bridge_opportunity_gps_longitude": 28.96946,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2859,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.41855,
  //       "proposed_bridge_location_gps_longitude": 28.96946,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Kamembe market (Community 5), Farms (Community 1,2,3,5)",
  //       "education_access_blocked_by_river": "Kibumba Primary and Secondary School (Community 5)",
  //       "health_access_blocked_by_river": "Mwito Health Center (Community 1,2,3,4)",
  //       "other_access_blocked_by_river": "Rusizi Town (Community 5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gacyamo, Buzi, Kabuga, Kagarama and Gaseke villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools and farming. Population information for each village was provided by the Gakomeye Cell Leader, Feline Niyonasenze, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Kigali - Rusizi)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fk6AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabirondo",
  //       "bridge_opportunity_project_code": "1014264",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -2.05434,
  //       "bridge_opportunity_gps_longitude": 30.04781,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5872,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05434,
  //       "proposed_bridge_location_gps_longitude": 30.04781,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Nyarurenzi Market ( Bugesera Kiganwa), farms both side",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "Nyarurenzi Health center ( Bugesera Kiganwa)",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Market, health center, farms",
  //       "primary_crops_grown": "sugar can, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None incidents because they use boat",
  //       "notes_on_social_information": "Cell leader of Nyarurenzi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "CBD KIGALI",
  //       "name_of_nearest_paved_or_sealed_road": "Kicukiro to Bugesera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXlAAI",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Nyagatango",
  //       "bridge_opportunity_project_code": "1014109",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.58868,
  //       "bridge_opportunity_gps_longitude": 29.11247,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2780,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.58868,
  //       "proposed_bridge_location_gps_longitude": 29.11247,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Nyakabuye market (Community 1,2), Karamo market (Community 1,2,3,4), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Gasumo Primary and Secondary School (Community 1,2,3,4)",
  //       "health_access_blocked_by_river": "Gasumo Health Post (Community 1,2,3,4)",
  //       "other_access_blocked_by_river": "Gasumo Military camp on the LHS (Military ), Gasumo Catholic and Methodist churches (Community 1,2,3,4), Butare Sector Office (Community 1,2)",
  //       "primary_occupations": "Agriculture and mining",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gasumo, Kenya, Ndengerezi and Rushwati villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools and farming. Population information for each village was provided by the Rwambogo Cell Leader and the Gasumo Village Leader, Stephanie Ayabino, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi Town",
  //       "name_of_nearest_paved_or_sealed_road": "NR11 (Kigali - Rusizi Town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Steep slope on both sides and waterfall around 5m downstream.",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1fkBAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bisoro-Makoko",
  //       "bridge_opportunity_project_code": "1014112",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.3557,
  //       "bridge_opportunity_gps_longitude": 29.11136,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3557,
  //       "proposed_bridge_location_gps_longitude": 29.11136,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicular bridge,",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1h7wAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murambi- Makoko",
  //       "bridge_opportunity_project_code": "1014113",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.34996,
  //       "bridge_opportunity_gps_longitude": 29.11603,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7477,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34996,
  //       "proposed_bridge_location_gps_longitude": 29.11603,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": "Communities4,5 don't have access to Kirambo and Rwesero markets",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to Makoko primary and secondary",
  //       "health_access_blocked_by_river": "Communities4,5 don't have access to Makoko Health Post",
  //       "other_access_blocked_by_river": "Communities 4 , 5 don't have access to Kagano sector office",
  //       "primary_occupations": "Farmers (Rice) and traders at Kirambo and Rwesero markets",
  //       "primary_crops_grown": "maiz, rice plantation, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Two people fell into the river and drowned and one injured when trying to cross the river",
  //       "notes_on_social_information": "Kirambo and Rwesero market which are open twice a week ( Community 4,5), Makoko Primary and secondary school ( Community 4,5), Makoko Health Post ( Community 4,5), Rice plantation farms ( Community 1,2,3,4 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in June 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 52,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1h8GAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murambi",
  //       "bridge_opportunity_project_code": "1014114",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.3645,
  //       "bridge_opportunity_gps_longitude": 29.1246,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3645,
  //       "proposed_bridge_location_gps_longitude": 29.1246,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Always crossed",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1h8QAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubindi",
  //       "bridge_opportunity_project_code": "1014115",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.73352,
  //       "bridge_opportunity_gps_longitude": 29.44932,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1100,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.73352,
  //       "proposed_bridge_location_gps_longitude": 29.44932,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Huye",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community needed a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1h8aAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu-Makoko",
  //       "bridge_opportunity_project_code": "1014116",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.34716,
  //       "bridge_opportunity_gps_longitude": 29.11627,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 743,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34716,
  //       "proposed_bridge_location_gps_longitude": 29.11627,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is already a vehecular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1h8fAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murambi",
  //       "bridge_opportunity_project_code": "1014117",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.38842,
  //       "bridge_opportunity_gps_longitude": 29.16833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.38842,
  //       "proposed_bridge_location_gps_longitude": 29.16833,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 150,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Community 5 don't have access to Rwesero market, communities1,2 3,4 don't have access to Susa and Cyato market",
  //       "education_access_blocked_by_river": "Community 5 don't have access to Rangiro primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 5 don't have access to Rangiro health center and Kibogora Hospital",
  //       "other_access_blocked_by_river": "Communities5 don't have access to Churches services",
  //       "primary_occupations": "Farmers on both side of the river, and traders at Susa, cyato and Rwesero markets",
  //       "primary_crops_grown": "beans on large scal, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rwesero market which is open twice a week ( Community 5), Susa and Cyato market which are open twice a week ( Community 1,2,3,4). Rangiro primary and secondary school ( Community 5), Rangiro health center ( Community 5), Farms on both sides. Population information for each village was provided by Mukamana Tamali leader of Murambi cell and population information was sourced from village census data collected in June 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1h94AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatagara",
  //       "bridge_opportunity_project_code": "1014120",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.38897,
  //       "bridge_opportunity_gps_longitude": 29.1315,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12237,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.38897,
  //       "proposed_bridge_location_gps_longitude": 29.1315,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 97,
  //       "flood_duration_during_rainy_season": "4hours",
  //       "market_access_blocked_by_river": "Communities 1 don't have access to Rwesero market and communities 2,3 don't have access to Susa and Rangiro market , communities 1 don't have access to Gisakura Tea",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Kibogora Hospital",
  //       "other_access_blocked_by_river": "Communities 1 don't have access to District head quarters",
  //       "primary_occupations": "Farmers and workers in Tea plantations farms of Gisakura Tea factory , trader's at Rwesero market",
  //       "primary_crops_grown": "bean, maiz, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "One person died trying to cross the river and three fall in the river",
  //       "notes_on_social_information": "Gisakura Tea factory ( Community 1), Kibogora Hospital ( Community ), Rwesero market which is open twice a week ( Community 1), Rangiro market ( Community 1). Population information for each village was provided by the village leader of each village and cell reader respectively and population information was sourced from village census data collected in July2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hDpAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kazibo",
  //       "bridge_opportunity_project_code": "1014121",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.34955,
  //       "bridge_opportunity_gps_longitude": 29.04256,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1030,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34955,
  //       "proposed_bridge_location_gps_longitude": 29.04256,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "2hours",
  //       "market_access_blocked_by_river": "Communities3,4 don't have access to Nyamitaka market, communities 3,4 don't have access to Kazibo coffee Washing station",
  //       "education_access_blocked_by_river": "Communities 3,4 don't have access to Kazibo primary school and Bunyenga secondary school",
  //       "health_access_blocked_by_river": "Communities 3,4 don't have access to Muyange health center",
  //       "other_access_blocked_by_river": "Communities 3,4 don't have access to Muyange cell office and Nyabitekeri sector office",
  //       "primary_occupations": "Coffee Farmers, and workers of kaziba coffee factor",
  //       "primary_crops_grown": "banana, coffe, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyamitaka market ( Community 3,4), Kazibo primary and Bunyenga secondary school ( Community 3,4), Kazibo coffee Washing station ( Community 3,4), Muyange health center ( Community 3,4). Population information for each village was provided by Ntirenganya Euphrem , Muyange Cell Social affair and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 28,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hE4AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mpanga",
  //       "bridge_opportunity_project_code": "1014265",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -2.0638,
  //       "bridge_opportunity_gps_longitude": 30.0279,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12213,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0638,
  //       "proposed_bridge_location_gps_longitude": 30.0279,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "25 kilometers",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Nyarurenzi Market (Kagoma \"Ntarama\")",
  //       "education_access_blocked_by_river": "No communities blocked to school when she",
  //       "health_access_blocked_by_river": "Nyarurenzi Health center (Kagoma \"Ntarama\")",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Market, farms, health center",
  //       "primary_crops_grown": "sugar can",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Runzenze",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "CBD KIGALI",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXqAAI",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Cyamuti",
  //       "bridge_opportunity_project_code": "1014122",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.33294045,
  //       "bridge_opportunity_gps_longitude": 29.02570225,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2959,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.33294045,
  //       "proposed_bridge_location_gps_longitude": 29.02570225,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 3,4,5 don't have access to Nyamitaka market, Communities 1,2 don't have access to Bushenge market",
  //       "education_access_blocked_by_river": "Communities 3,4 don't have access to Cyamuti primary school and communities 1,2 don't have access to GS Buhokoro St.bonaventure",
  //       "health_access_blocked_by_river": "Communities1,2 don't have access to Muyange health center",
  //       "other_access_blocked_by_river": "Communities1,2 don't have access to Muyange Catholic Parish and communities 3,4,5 don't have access to Adventists church",
  //       "primary_occupations": "Workers at Mubira coffee, Nyamitanzi coffee, daily farmers on both sides and traders at Nyamitaka market",
  //       "primary_crops_grown": "bean, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyamitaka market which is open every day ( Community 3,4,5), Bushenge market ( Community 1,2), Cyamuti primary school ( Community 3,4), G.S. Buhokoro St.bonaventure secondary school ( Community 1,2), Muyange health center ( Community 1,2), Muyange Catholic Parish ( Community 1,2), Adventist of Seven days church ( Community 3,4,5), Nyabitekeri sector office ( Community 1,2). Population information for each village was provided by Social affair of Muyange Cell and population information was sourced from village census data collected in September 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hEEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuhigi",
  //       "bridge_opportunity_project_code": "1014124",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.38012159,
  //       "bridge_opportunity_gps_longitude": 29.04157223,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6190,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.38012159,
  //       "proposed_bridge_location_gps_longitude": 29.04157223,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Bushenge market , communities 4,5 don't have access to CAFERWA Mugera washing station,",
  //       "education_access_blocked_by_river": "Communities1,2,3 don't have access to Nyamugali and Nyakibingo school , communities4,5 don't have access to Bikunda and Mugera Primary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3 don't have access to Mugera health center",
  //       "other_access_blocked_by_river": "Communities1,2,3 don't have access to Shangi sector office",
  //       "primary_occupations": "Tea plantation workers, CAFERWA coffee washing station workers and farmers and traders at Bushenge market",
  //       "primary_crops_grown": "bean, coffee plantation, sweet potato, tea plantation",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "1 old women ; fell in the river when the timber were flooded with the water and the logs were not Cleary seen while four people fell into the river but fortunately still alive",
  //       "notes_on_social_information": "Bushenge market ( Community 1,2,3), CAFERWA Mugera washing station ( Community 4,5), Nyakibingo and Nyamugali ( community 1,2,3), Bikunda and Mugera primary school ( Community 4,5), Mugera health center ( Community 1,2,3), Nyakabingo Catholic church ( Community 1 ,2,3). Population information for each village was provided by Ubalijoro Silas the Cell leader Mugera and population information was sourced from village census data collected in September 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hEYAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigenge-Kamayenga",
  //       "bridge_opportunity_project_code": "1014125",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.43036899,
  //       "bridge_opportunity_gps_longitude": 28.98131295,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5115,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.43036899,
  //       "proposed_bridge_location_gps_longitude": 28.98131295,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3hours",
  //       "market_access_blocked_by_river": "Communities4,5 don't have access to Rice plantation farms and Kaziba Coffee washing station",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Rumanga and Bushenge secondary schools , communities 4,5 don't have access to Kaziba Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Communities1,2,3 don't have access to Bushenge Hospital",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to Shangi Parish and Bushenge sector office",
  //       "primary_occupations": "Rice plantation Farmers , coffee farmers and traders at Bushenge market ,Kaziba Coffee washing station workers",
  //       "primary_crops_grown": "bean, coffe, ric, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Almost Ten people fell into the river but fortunately none died",
  //       "notes_on_social_information": "Bushenge market which is open twice a week ( Community 1,2,3); Kazibo primary and secondary school ( Community 4,5), Rice plantation farms ( Community 4,5), Kaziba Coffee washing station (Community 1,2,3), Rumanga secondary ( Community 1,2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hF7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitwa",
  //       "bridge_opportunity_project_code": "1014126",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.42782026,
  //       "bridge_opportunity_gps_longitude": 28.96789415,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5811,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.42782026,
  //       "proposed_bridge_location_gps_longitude": 28.96789415,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "Never",
  //       "market_access_blocked_by_river": "Communities 4,5 don't have access to Bushenge market, communities 1,2,3 don't have access to Kamembe and Bumazi markets",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to Bushenge secondary school",
  //       "health_access_blocked_by_river": "Communities 4,5don't have access to Bushenge Hospital",
  //       "other_access_blocked_by_river": "Communities 4,5 don't have access to Bushenge Parish",
  //       "primary_occupations": "Workers in Rice, workers at Rwega coffee washing station , local farmers on small scale and traders at Bushenge market",
  //       "primary_crops_grown": "bean, potato, ric, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people fell into the and one person died trying to cross the river",
  //       "notes_on_social_information": "Bushenge market ( Community 4,5), Kamembe market ( Community 1,2,3 ), Bumazi markets which is open twice a week and is an cattle market community 1,2,3), Bushenge secondary schools ( Community 4,5), Ntura Catholic primary school ( Community 1 ,2, 3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hFbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rujeberi",
  //       "bridge_opportunity_project_code": "1014131",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.54704093,
  //       "bridge_opportunity_gps_longitude": 29.03581174,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5644,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.54704093,
  //       "proposed_bridge_location_gps_longitude": 29.03581174,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 97,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Kamanu coffee washing station , Kamanu Rice farms and Nyakabuye market",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to G .S. St Paul and communities 1,2,3 don't have access to Nyamubembe secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3 don't have access to Nyakabuye and Nkungu Health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Mpinga Church",
  //       "primary_occupations": "Kamanu Coffee factory , Kamanu Rice farmers and workers, traders at Nyakabuye market",
  //       "primary_crops_grown": "banana, bean, coffe, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Falling on the bridge , 5 deaths incidents are outside of three year window",
  //       "notes_on_social_information": "Kamanu coffee washing station ( Community 1,2,3), Kamanu Rice farms( community 1,2,3), Nyakabuye market ( Community 1,2,3), G.S. St Paul ( Community 4,5), Nyamubembe secondary school ( Community 1,2,3), Nyakabuye and Nkungu Health center ( Community 1,2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hGeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ku kibuga",
  //       "bridge_opportunity_project_code": "1014262",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.95291,
  //       "bridge_opportunity_gps_longitude": 30.0532,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 50628,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.95291,
  //       "proposed_bridge_location_gps_longitude": 30.0532,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded t",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kimisagara Market (Kora) CBD and Nyarugenge Market (Kimisagara)",
  //       "education_access_blocked_by_river": "UR University (Kimisagara), all secondary school in CBD (Kimisagara)",
  //       "health_access_blocked_by_river": "Kabusunzu Health center (Kora) , CHUK (Kimisagara)",
  //       "other_access_blocked_by_river": "Catholic church st Pierre (Kora)",
  //       "primary_occupations": "Market, business center in CBD, schools",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF KORA",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "CBD KIGALI",
  //       "name_of_nearest_paved_or_sealed_road": "Nyabugogo-Kimisagara-Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXbAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Wambonye",
  //       "bridge_opportunity_project_code": "1014137",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.36102,
  //       "bridge_opportunity_gps_longitude": 29.14898,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4373,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.36102,
  //       "proposed_bridge_location_gps_longitude": 29.14898,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "24 hours",
  //       "market_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Remera coffee washing station, communities 1,2,3,4 don't have access to Tyazo and Kirambo market , communities 5 don't have access to to Rangiro markets",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Kibogora Hospital ( District level )",
  //       "other_access_blocked_by_river": "Communities on both sides don't have access to Churches",
  //       "primary_occupations": "Remera coffee washing station workers and suppliers, Farmers on both side and traders at Tyazo and kirambo markets",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Taken by the river when it was flooded",
  //       "notes_on_social_information": "Remera coffee washing station ( Community 1,2,3,4); Tyazo and Kirambo market which are open twice a week ( Community 1,2,3,4),Rangiro market which is open twice a week ( Community 5), Kibogora Hospital ( Community 1,2,3,4). Population information for each village was provided by Mukamana Tamali Murambi cell leader and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hI6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugombo",
  //       "bridge_opportunity_project_code": "1014139",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.46906,
  //       "bridge_opportunity_gps_longitude": 28.95562,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4203,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46906,
  //       "proposed_bridge_location_gps_longitude": 28.95562,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "3 hous",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Minyove and Gisuma coffee washing stations and Kamembe market, communities 4,5 don't have access to Bumazi livestock market",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to Giheke health center",
  //       "health_access_blocked_by_river": "Communities 4,5 don't have access to Giheke secondary school and and Giheke TVT",
  //       "other_access_blocked_by_river": "Communities 4,5 don't have access to Giheke sector head quarter and SACCO office",
  //       "primary_occupations": "Minyove and Gisuma coffee washing stations workers and suppliers,",
  //       "primary_crops_grown": "bean, coffe, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kamembe market which is open every day ( Community 1,2,3), Bumazi livestock market ( Community 4,5), Minyove and Gisuma coffee washing stations ( Community 1 ,2,3), Giheke secondary and TVT( communities 4,5), Giheke health center ( Community 4,5), Giheke sector and SACCO office ( Community 4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018.",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hIvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo",
  //       "bridge_opportunity_project_code": "1014140",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.45575,
  //       "bridge_opportunity_gps_longitude": 28.97641,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4588,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.45575,
  //       "proposed_bridge_location_gps_longitude": 28.97641,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Shagasha tea factory , Isha coffee washing station and Farmers and Kamembe market, communities 1 don't have access to Bumazi livestock market and Bushenge market",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Giheke TVT school ,communities 1don't have access to Bumazi primary school",
  //       "health_access_blocked_by_river": "Communities 1don't have access to Bushenge Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Shagasha tea factory workers and farmers, Isha coffee washing station workers and suppliers",
  //       "primary_crops_grown": ", bean, coffe, maiz, sweet potato, tea",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Shagasha tea factory and Farms ( Community 2); Isha coffee washing station ( Community 2); Kamembe market which is open every day ( Community 2), Bumazi livestock market which is open twice a week ( Community 1), Bushenge market which is open twice a week( community 1) Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hJOAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabeza",
  //       "bridge_opportunity_project_code": "1014142",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.46169,
  //       "bridge_opportunity_gps_longitude": 28.96475,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2631,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46169,
  //       "proposed_bridge_location_gps_longitude": 28.96475,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Gisuma coffee washing stations and Kamembe market, communities 4,5 don't have access to Bushenge market",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Cyendajuru Nursery school and Ntura Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 4,5 don't have access to Giheke health center and Bushenge Hospital",
  //       "other_access_blocked_by_river": "Communities 4,5 don't have access to Protestants and Adventist of Seven days churches",
  //       "primary_occupations": "Gisuma coffee washing stations workers and suppliers and farmers, Traders at Kamembe and Bushenge markets",
  //       "primary_crops_grown": "beans maiz, coffe, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Falling over the bridge logs",
  //       "notes_on_social_information": "Gisuma coffee washing station( community 1,2,3); Kamembe market which is open every day ( Community 1,2,3); Bushenge market which is open twice a week ( Community 4,5); Bushenge Hospital and Giheke health center ( Community 4,5), Cyendajuru Nursery and Ntura Primary and secondary school ( Community 1,2,3) ; Adventist of Seven days and Protestants churches( communities 4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 47,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hKHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burembo",
  //       "bridge_opportunity_project_code": "1014143",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.44613,
  //       "bridge_opportunity_gps_longitude": 28.96986,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1441,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.44613,
  //       "proposed_bridge_location_gps_longitude": 28.96986,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "2hours",
  //       "market_access_blocked_by_river": "Communities don't have access to Farms on both sides, communities 1 don't have access to Kamembe market",
  //       "education_access_blocked_by_river": "Communities 1 don't have access to Ntura Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Giheke health center",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to Ntura Protestants church",
  //       "primary_occupations": "Local Farmers and traders at Kamembe market",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kamembe market which is open every day ( Community 1 ), Ntura Primary and secondary ( Community 1). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hLKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabakure",
  //       "bridge_opportunity_project_code": "1014144",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.46402,
  //       "bridge_opportunity_gps_longitude": 28.95182,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1334,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.46402,
  //       "proposed_bridge_location_gps_longitude": 28.95182,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "2hour",
  //       "market_access_blocked_by_river": "Communities1 don't have access to Kamembe market, communities 2 don't have access to Bushenge and Bumazi livestock market",
  //       "education_access_blocked_by_river": "Communities 1don't have access to Kamashangi secondary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Bushenge Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers on both side and traders at Kamembe and Bumazi markets",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kamembe market which is open every day ( Community 1), Bushenge and Bumazi livestock market ( Community1 ); Kamashangi secondary school ( Community 1); Bushenge Hospital ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hLUAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabere",
  //       "bridge_opportunity_project_code": "1014148",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.39624002,
  //       "bridge_opportunity_gps_longitude": 28.9969806,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4696,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.39624002,
  //       "proposed_bridge_location_gps_longitude": 28.9969806,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": "Communities1,2 don't have access to Rice depot, Kabere coffee washing station workers and Karusimbi market, communities 3,4,5 don't have access to Bushenge market",
  //       "education_access_blocked_by_river": "Communities 3,4,5 don't have access to Shangi secondary school",
  //       "health_access_blocked_by_river": "Communities 3,4,5 don't have access to Bushenge Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers in rice, Kabere coffee washing station workers and farmers",
  //       "primary_crops_grown": "bean, coffe, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Bushenge market ( Community 3,4,5), Karusimbi market ( Community 1,2), Shangi secondary school ( Community 3,4,5), Kabere coffee washing station ( Community ),Rice plantation farms and store ( Community 1,2 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 78,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hMSAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambi",
  //       "bridge_opportunity_project_code": "1014154",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.43675,
  //       "bridge_opportunity_gps_longitude": 28.95227,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3651,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.43675,
  //       "proposed_bridge_location_gps_longitude": 28.95227,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities1,2,3 don't have access to Kamembe and Gatsiro market , communities4,5 don't have access to Bushenge and Bumazi livestock market , communities 1,2,3 don't have access to Rwega Coffee washing station",
  //       "education_access_blocked_by_river": "Communities1,2,3 don't have access to Kamashangi Primary school",
  //       "health_access_blocked_by_river": "Communities4,5 don't have access to Ntura health Post, Giheke health center and Bushenge Hospital",
  //       "other_access_blocked_by_river": "Communities1,2,3 don't have access to Nkanka Catholic Parish",
  //       "primary_occupations": "Rwega Coffee washing station workers and suppliers, farmers on both sides and Traders at Kamembe , Bumazi livestock market and Gatsiro market",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Only one died in 25 years ego",
  //       "notes_on_social_information": "Kamembe market which is open every day ( Community 1,2,3); Gatsiro market which is open twice a week ( Community 1,2,3); Bushenge and Bumazi livestock market which are open twice a week ( Community 4,5); Rwega Coffee washing station ( Community 1,2,3); Kamashangi Primary school ( Community 1,2,3); Ntura health Post, Giheke health center, Bushenge Hospital ( Community 4,5);Nkanka Catholic Parish ( Community 1,2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hOxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Maryohe",
  //       "bridge_opportunity_project_code": "1014155",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.44319,
  //       "bridge_opportunity_gps_longitude": 28.97635,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1430,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.44319,
  //       "proposed_bridge_location_gps_longitude": 28.97635,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is always crossed all the year around",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hPMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabyuma",
  //       "bridge_opportunity_project_code": "1014156",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.44926,
  //       "bridge_opportunity_gps_longitude": 28.95522,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3570,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.44926,
  //       "proposed_bridge_location_gps_longitude": 28.95522,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Communities 3,4,5 don't have access to Gisuma coffee washing stations and Kamembe market",
  //       "education_access_blocked_by_river": "Communities1,2 don't have access to Ntura Primary and secondary school, communities 1,2,3 don't have access to Minyove primary and secondary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Communities1,2 don't have access to Ntura Adventist of Seven days and Protestants churches",
  //       "primary_occupations": "Gisuma coffee washing stations workers and suppliers, farmers on both sides and traders at Kamembe market",
  //       "primary_crops_grown": "bean, coffe, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "3 people fell into the river due to slipping but fortunately none died",
  //       "notes_on_social_information": "Kamembe market which is open every day ( Community 3,4,5); Gisuma coffee washing stations ( Community 3,4,5); Minyove Primary and secondary school ( Community 3,4,5); Ntura Primary and secondary school ( Community 1,2); Ntura Adventist of Seven days and Protestants church ( Community 1,2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hPlAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabagabo",
  //       "bridge_opportunity_project_code": "1014159",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Nyamasheke",
  //       "bridge_opportunity_gps_latitude": -2.3441,
  //       "bridge_opportunity_gps_longitude": 29.11119,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 620,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3441,
  //       "proposed_bridge_location_gps_longitude": 29.11119,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Crossed all the year around, width 1.0 m depth 1m",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hQ0AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuye",
  //       "bridge_opportunity_project_code": "1014161",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.34684,
  //       "bridge_opportunity_gps_longitude": 29.11432,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4256,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.34684,
  //       "proposed_bridge_location_gps_longitude": 29.11432,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "500 m",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "2 hours",
  //       "market_access_blocked_by_river": "Communities 1,3 don't have access to Rwesero market, and communities 2,4,5 don't have access to Kirambo market",
  //       "education_access_blocked_by_river": "Communities 1,3 don't have access to Makoko primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,3 don't have access to Makoko Health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice plantation workers (Dufatanye Cooperative ), local farmers on small scale and traders at Kirambo and Rwesero markets",
  //       "primary_crops_grown": "maiz, ric, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rwesero market which is open twice a week ( Community 1,3), Kirambo market which is open twice a week ( Community 2,4,5), Makoko Health center ( Community 1,3), Makoko Primary and secondary school ( Community 1,3), Rice plantation farms on both side (Community 1,2,3,4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hQKAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwega",
  //       "bridge_opportunity_project_code": "1014165",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.4334,
  //       "bridge_opportunity_gps_longitude": 28.93374,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 750,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.4334,
  //       "proposed_bridge_location_gps_longitude": 28.93374,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "People and motorcycle all the year around cross here, only that it need to be improved so that vehicle can use it again",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hTiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Impala",
  //       "bridge_opportunity_project_code": "1014166",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.44246,
  //       "bridge_opportunity_gps_longitude": 28.9333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 400,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.44246,
  //       "proposed_bridge_location_gps_longitude": 28.9333,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The bridge is currently used for vehicles, there is quarry stone on that direction",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hTnAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ndengerezi",
  //       "bridge_opportunity_project_code": "1014167",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.58127,
  //       "bridge_opportunity_gps_longitude": 28.15265,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2380,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.58127,
  //       "proposed_bridge_location_gps_longitude": 28.15265,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Communities1,2,3,4 don't have access to Rasano market , communities5 don't have access to Gasumo markets",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Communities1,2,3,4 don't have access to Rasano health center",
  //       "other_access_blocked_by_river": "Communities don't have access to to Churches services on both sides",
  //       "primary_occupations": "Farmers on both side and traders at Rasano and Gasumo markets",
  //       "primary_crops_grown": "bean, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "One kid was taken away by the river",
  //       "notes_on_social_information": "Rasano market which is open twice a week ( Community 1,2,3,4), Gasumo markets which is open twice a week ( Community 5); Rasano health center( community 1,2,3, 4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 100,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hU7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Munkamba",
  //       "bridge_opportunity_project_code": "1014168",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.57245,
  //       "bridge_opportunity_gps_longitude": 29.15343,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2985,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.57245,
  //       "proposed_bridge_location_gps_longitude": 29.15343,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 31,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Communities 3,4 5 don't have access to Rasano market",
  //       "education_access_blocked_by_river": "Communities 1,2 don't have access to Nyamihanda Primary school",
  //       "health_access_blocked_by_river": "Communities 3,4,5 don't have access to Rasano health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Local farmers and traders at Rasano market",
  //       "primary_crops_grown": "bean, fruits ( pineapple ), maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rasano market which is open twice a week ( Community 3,4,5); Rasano health center ( Community 3,4,5); Nyamihanda Primary school ( Community 1,2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hUHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rushwati",
  //       "bridge_opportunity_project_code": "1014169",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Rusizi",
  //       "bridge_opportunity_gps_latitude": -2.58421,
  //       "bridge_opportunity_gps_longitude": 29.14232,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3991,
  //       "bridge_opportunity_comments": "BAJ Site Rejected. Ground slope is too steep.",
  //       "form_form_name": "Project Assessment - 2018.10.29",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.58421,
  //       "proposed_bridge_location_gps_longitude": 29.14232,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 64,
  //       "flood_duration_during_rainy_season": "2 hours",
  //       "market_access_blocked_by_river": "Communities don't have access to farms on both side, communities 4,5 don't have access to Gasumo markets",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Nyamihanda Primary school , communities 4,5 don't have access to Gasumo secondary school.",
  //       "health_access_blocked_by_river": "Communities 4,5 don't have access to Gasumo health Post",
  //       "other_access_blocked_by_river": "Communities don't have access to Churches, there are Army Forces stations on both sides",
  //       "primary_occupations": "Local farmers and traders at Gasumo market",
  //       "primary_crops_grown": "bean, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gasumo markets ( Community 4,5); Nyamihanda Primary school ( Community 1,2,3) ;Gasumo Schools( community4,5); Churches on both sides;Army Force stations on both sides. Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rusizi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Very steep profile on both sides",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 74,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d1hUWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Iterambere",
  //       "bridge_opportunity_project_code": "1014238",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.94381,
  //       "bridge_opportunity_gps_longitude": 30.05001,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 712,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94381,
  //       "proposed_bridge_location_gps_longitude": 30.05001,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "20 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Umucyo",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "CBD",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Between houses and closer to powerlines",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 10,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekV1AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akatabaro",
  //       "bridge_opportunity_project_code": "1014239",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.985294,
  //       "bridge_opportunity_gps_longitude": 30.056113,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3340,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.985294,
  //       "proposed_bridge_location_gps_longitude": 30.056113,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "In charge of security of Akatabaro",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is vehicular bridge and it also closer to unpaved road 13 meter away of edge of bridge right side",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 15,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekV6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Dubaii",
  //       "bridge_opportunity_project_code": "1014241",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.903719,
  //       "bridge_opportunity_gps_longitude": 30.104828,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.903719,
  //       "proposed_bridge_location_gps_longitude": 30.104828,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "There is another unpaved road they used which is underconstruction",
  //       "days_per_year_river_is_flooded": 125,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Rwankuba",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need to put culvert in the unpaved road",
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekVGAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Itsinzi",
  //       "bridge_opportunity_project_code": "1014242",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.96302,
  //       "bridge_opportunity_gps_longitude": 30.05622,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1824,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.96302,
  //       "proposed_bridge_location_gps_longitude": 30.05622,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "134.5 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Not flooded",
  //       "market_access_blocked_by_river": "Kimisagara Market (Gacyamo)",
  //       "education_access_blocked_by_river": "Primary and secondary school Kabusunzu(Gacyamo)",
  //       "health_access_blocked_by_river": "CHUK and Gitega health center (Kimisagara Kabusunzu )",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "School, Market, church",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They were trying to cross the bridge and fell into river",
  //       "notes_on_social_information": "Community leaders of Itsinzi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Nyabugogi Kimisagara nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 22,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekVLAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyami",
  //       "bridge_opportunity_project_code": "1014243",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.36537,
  //       "bridge_opportunity_gps_longitude": 30.17092,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2576,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.36537,
  //       "proposed_bridge_location_gps_longitude": 30.17092,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April, May, November and December; it last for 6 hours",
  //       "market_access_blocked_by_river": "Kabuga Market (Community 4,5), Buguma and Karama Markets (Community 1,2,3), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Gitagati Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Nyarurema Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Rumuri Catholic Church and Gasukari Anglican church (Community 4,5), Karama Sector (Community 1,2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kanyami, Ndego Center, Rutoma, Gishenyi and Gataba villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Ndego Cell Leader and the Kanyami Village Leader, Cyprien Karemera from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekVkAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kisaro",
  //       "bridge_opportunity_project_code": "1014244",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.45106,
  //       "bridge_opportunity_gps_longitude": 30.20714,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6245,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.45106,
  //       "proposed_bridge_location_gps_longitude": 30.20714,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 hours",
  //       "market_access_blocked_by_river": "Nyagahita, Gihengeri, Ngarama, Cyambwana and Mimuri markets (Community 1,2,3), Karujumba and Karama Markets (Community 4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Gishororo Primary and Secondary School (Community 4,5), Gakoma Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Muhambo Health Center (Community 4,5), Nyagaheta Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Mahoro Adventit Church (Community 1,2,3), Kisaro ADEPR church (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "More than 30 people have been injured trying to cross the river mostly motorcyclists and bicyclists.",
  //       "notes_on_social_information": "Kisaro, Kabukunzu, Kabeza, Kinyambo, Cyambwana, Iterambere, Shenga and Gitwe villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Gishororo Cell Leader, Primier Twahirwa from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekVuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karushuga",
  //       "bridge_opportunity_project_code": "1014260",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.29792,
  //       "bridge_opportunity_gps_longitude": 30.55167,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2140,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.29792,
  //       "proposed_bridge_location_gps_longitude": 30.55167,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Rwimiyaga market (Community 2), Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "Gatebe Primary and Secondary School (Community 2)",
  //       "health_access_blocked_by_river": "Karushuga health post (Community 2)",
  //       "other_access_blocked_by_river": "Karushuga Cell Office (Community 2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people were injured at this crossing point.",
  //       "notes_on_social_information": "Karujumba and Akagera villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Karushuga Cell Leader, Faustin from the population data collected in 2018.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 Kigali Nyagatare town",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXMAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kavu",
  //       "bridge_opportunity_project_code": "1014245",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.35292,
  //       "bridge_opportunity_gps_longitude": 30.144,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2494,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.35292,
  //       "proposed_bridge_location_gps_longitude": 30.144,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 5 hours",
  //       "market_access_blocked_by_river": "Karama, Buguma, Rukomo markets (people from Uganda), Kabare market in Uganda (Community 1,2,3,4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Ndego Primary and Secondary School (Community 1)",
  //       "health_access_blocked_by_river": "Nyarurema Health Center (Community 1)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, pineappl, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "More than 50 people mostly cyclists have been injured trying to cross the river.",
  //       "notes_on_social_information": "Mishasha, Rubanda, Kabeza, Mutete and Kababanda villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, schools and to farms. The population information for each village was provided by the Ndego Cell Leader and the Mishasha Village Leader, Donatien Bariburemwe from the population data collected in 2018.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": 1.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekVzAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Katoma",
  //       "bridge_opportunity_project_code": "1014246",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.44263,
  //       "bridge_opportunity_gps_longitude": 30.15516,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2405,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.44263,
  //       "proposed_bridge_location_gps_longitude": 30.15516,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 day",
  //       "market_access_blocked_by_river": "Muhambo, Karujumba, Karama and Mimuri markets (Community 1,2,3), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Karujumba and Muhambo Primary and Secondary Schools (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Condo Health Center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Karujumba Catholic Church, Karujumba cell office, Kiyombe SACCO Saving and Kiyombe Sector Office (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 50,
  //       "incident_descriptions": "3 people have died before the timber bridge was built and more than 50 people got injuried. Since the bridge was built there have been no death and injuries in 2 years.",
  //       "notes_on_social_information": "Katoma, Ngangare, Nyange, Kajevuba, Kagorogoro, Cyenzizi and Mushesha villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Karujumba Cell Leader and the Katoma village leader, Faustin Ndaribitse from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekW9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Burera",
  //       "bridge_opportunity_project_code": "1014247",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.52911,
  //       "bridge_opportunity_gps_longitude": 30.30129,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3354,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.52911,
  //       "proposed_bridge_location_gps_longitude": 30.30129,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 4 hours",
  //       "market_access_blocked_by_river": "Ngarama and Mugera markets (Community 1,2,3), Kiganda market (Community 4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Bushyanguhe Primary and Secondary School and Nyarurambi Primary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Kigasha health center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Kigasha ADEPR and Anglican churches (Community 1,2,3), Faith center church (Community 4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Burera, Kanyesunzu, Igitego, Kirongo and Kagarama villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Rugazi Cell Leader, Adidas Nsengimana from the population data collected in 2018.",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakagende",
  //       "bridge_opportunity_project_code": "1014248",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.46111,
  //       "bridge_opportunity_gps_longitude": 30.23321,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6204,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.46111,
  //       "proposed_bridge_location_gps_longitude": 30.23321,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "7 km",
  //       "days_per_year_river_is_flooded": 210,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 1 day",
  //       "market_access_blocked_by_river": "Mimuri market (Community 4,5), Nyagahita, Rukomo, Gihengeri and Karama Markets (Community 1,2,3), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Mahoro Primary School (Community 1,2,3), Nyaruziba Primary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Mimuri Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Mimuri sector office (Community 4), Nyaruziba ADEPR and Anglican churches (Community 4,5), Mizero ADEPR and Anglican churches (Community 1,2,3)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, sugarcan",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Four people died on this crossing point and more than ten people were injured.",
  //       "notes_on_social_information": "Mizero, Nyabugogo, Shenga, Cyambwana, Nyakagende, Karukwanza, Bibare centre, Rwimirama and Nyaruziba villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Bibare Cell Leader and the Nyakagende village leader, Jean Paul Havugimana from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWJAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kubwamariko",
  //       "bridge_opportunity_project_code": "1014249",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.43877,
  //       "bridge_opportunity_gps_longitude": 30.25549,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6852,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.43877,
  //       "proposed_bridge_location_gps_longitude": 30.25549,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Rukomo market (Community 1,2,3), Mimuri market (Community 4,5), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Bufunda Primary and Secondary School (Community 1,2,3), Cyabayaga Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Mimuri Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Mimuri Catholic Parish and Adventist church (Community 4,5), Nyagatare Town (Community 4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation sugarcan, bean, maiz, potato, ric, tomato",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "3 people have died at this crossing point and more than 10 were injured",
  //       "notes_on_social_information": "Ubumwe, Rebero, Amahoro, Indahemuka, Cyibihanga, Ibitabo and Nyakajeje villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Rugari Cell Leader and the Ubumwe Village Leader, Augustin Kamana from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali- Nyagatare Town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWOAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Isangano I",
  //       "bridge_opportunity_project_code": "1014251",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.4216,
  //       "bridge_opportunity_gps_longitude": 30.27098,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8144,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.4216,
  //       "proposed_bridge_location_gps_longitude": 30.27098,
  //       "current_crossing_method": "disrepair",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 8 hours",
  //       "market_access_blocked_by_river": "Rukomo market (Community 1,2,3), Mimuri market (Community 4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Ruyonza Primary School (Community 1,2,3), Cyabayaga Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Gahurura Health Post (Community 1,2,3), Mimuri Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Rukomo Catholic Church (Community 1,2,3), Rugari ADEPR and Adventist Churches (Community 4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, sugarcan, tomato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 15,
  //       "incident_descriptions": "2 people died trying to cross the river and more than 15 people have been injured.",
  //       "notes_on_social_information": "Ubumwe, Akamonyi, Isangano, Nteko, Ubumwe (Rukomo) Ruyonza, Number1, and Busasamana villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Rugari Cell Leader and the Ubumwe Village Leader, Augustin Kamana from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWYAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rujuga",
  //       "bridge_opportunity_project_code": "1014252",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.42013,
  //       "bridge_opportunity_gps_longitude": 30.26972,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8144,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.42013,
  //       "proposed_bridge_location_gps_longitude": 30.26972,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 180,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Rukomo market (Community 1,2,3), Mimuri market (Community 4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Ruyonza Primary School (Community 1,2,3), Cyabayaga Primary and Secondary School (Community 4,5)",
  //       "health_access_blocked_by_river": "Mimuri Health Center (Community 4,5), Gahurura health post (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Rukomo Catholic Church (Community 1,2,3), Rugari ADEPR and Adventist Churches (Community 4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato, ric, sugarcan, tomato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ubumwe, Akamonyi, Isangano, Nteko, Ubumwe (Rukomo), Ruyonza, Number1, and Busasamana villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Rugari Cell Leader and the Ubumwe Village Leader, Augustin Kamana from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali-Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 52,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWdAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagatare",
  //       "bridge_opportunity_project_code": "1014253",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.42836,
  //       "bridge_opportunity_gps_longitude": 30.1828,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2972,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.42836,
  //       "proposed_bridge_location_gps_longitude": 30.1828,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Mimuri, Muhambo and Nyagahita markets (Community 4,5), Karama and Buguma markets (Community 1,2,3), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Gishororo and Muhambo Primary and Secondary Schools (Community 4,5)",
  //       "health_access_blocked_by_river": "Nyarurema Health Center (Community 1,2,3), Mukama Health Center (Community 4,5)",
  //       "other_access_blocked_by_river": "Gishororo ADEPR church and Mukama Catholic Church (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyagatare, Nyakagarama, Cyabahurura, Iramiro and Kibisabo villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Kagina Cell Leader, Eric Habinshuti, from the population data collected in 2018.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ubumwe",
  //       "bridge_opportunity_project_code": "1014254",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.966149,
  //       "bridge_opportunity_gps_longitude": 30.05606,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1821,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.966149,
  //       "proposed_bridge_location_gps_longitude": 30.05606,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kimisagara Market (Itsinzi, Ubumwe)",
  //       "education_access_blocked_by_river": "Gitega primary school (kabuguru 1, nyakabanda), nusery, primary and secondary school on Kimisagara and Nyakabanda side (Ubumwe and Itsinzi)",
  //       "health_access_blocked_by_river": "CHUK and Gaitega health center (Kimisagara)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "School, Market,",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Itsinzi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyarugenge",
  //       "name_of_nearest_paved_or_sealed_road": "Nyabugogo-Kimisagara-Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It does floaded",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 28,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gishenyi",
  //       "bridge_opportunity_project_code": "1014255",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.3683,
  //       "bridge_opportunity_gps_longitude": 30.17181,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2514,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.3683,
  //       "proposed_bridge_location_gps_longitude": 30.17181,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Kabuga Market (Community 1,2), Buguma and Karama Markets (Community 3,4,5), Farms (Community 1,2,3,4,5)",
  //       "education_access_blocked_by_river": "Gitagati Primary and Secondary School (Community 3,4,5)",
  //       "health_access_blocked_by_river": "Bushara health center (Community 1,2), Nyarurema Health Center (Community 3,4,5)",
  //       "other_access_blocked_by_river": "Urumuri Catholic Church and Gasukari Anglican church (Community 1,2), Karama Sector and Nyagatare town (Community 3,4,5)",
  //       "primary_occupations": "Agriculture and animal husbandry",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Two people have died trying to cross the river and more than ten people were injured.",
  //       "notes_on_social_information": "Gashenyi, Gataba, Kanyami, Ndego Center and Rutoma villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health centers, schools, churches and to farms. The population information for each village was provided by the Ndego Cell Leader and the Kanyami Village Leader, Cyprien Karemera from the population data collected in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR19 (Kigali - Nyagatare town)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekWxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mpazi Wasac",
  //       "bridge_opportunity_project_code": "1014256",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.95435,
  //       "bridge_opportunity_gps_longitude": 30.054,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 869,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.95435,
  //       "proposed_bridge_location_gps_longitude": 30.054,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Does not flooded",
  //       "market_access_blocked_by_river": "Kimisagara Market (Kabeza, Kora), CBD and Nyarugenge Market (Kimisagara)",
  //       "education_access_blocked_by_river": "UR University and all secondary school in CBD (Kimisagara) and all school in Kimisagara (Gitega special Kora, Kabeza)",
  //       "health_access_blocked_by_river": "CHUK (Kimisagara), Kabusunzu Health center ( Kabeza, Kora)",
  //       "other_access_blocked_by_river": "Catholic church st Pierre (Kabeza, Kora)",
  //       "primary_occupations": "School, Market, CBD,",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Mpazi village /Kabeza",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyarugenge",
  //       "name_of_nearest_paved_or_sealed_road": "Nyabugogo-Kimisagara-Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekX2AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ituze",
  //       "bridge_opportunity_project_code": "1014257",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.95322,
  //       "bridge_opportunity_gps_longitude": 30.0552,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1018,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.95322,
  //       "proposed_bridge_location_gps_longitude": 30.0552,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "None",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "To visit neighborhood",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "A child who was trying to cross the bridge and fell into channel and broken arm",
  //       "notes_on_social_information": "Community leaders of ituze",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyarugenge",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded and closer to houses",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 15,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekX7AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ubukorikori",
  //       "bridge_opportunity_project_code": "1014258",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.94934,
  //       "bridge_opportunity_gps_longitude": 30.05571,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1211,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94934,
  //       "proposed_bridge_location_gps_longitude": 30.05571,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Nyarugenge Market and CBD (Kora )",
  //       "education_access_blocked_by_river": "UR University (Kora)",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Market, school",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Kora cell and community leader of Kora village",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali CBD",
  //       "name_of_nearest_paved_or_sealed_road": "Nyarugenge to Nyamirambo",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Between houses and no where to find another center line due to the settlement",
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXCAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugano",
  //       "bridge_opportunity_project_code": "1014259",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.94354,
  //       "bridge_opportunity_gps_longitude": 30.05083,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 51939,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94354,
  //       "proposed_bridge_location_gps_longitude": 30.05083,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kimisagara Market (Rugari, rugano, kora cell), CBD and Nyarugenge Market (Kimisagara)",
  //       "education_access_blocked_by_river": "UR University and all secondary school in CBD (Kimisagara), all primary and secondary school on are in Kimisagara (Kora)",
  //       "health_access_blocked_by_river": "CHUK (Kimisagara), Kabusunzu Health center ((Kora)",
  //       "other_access_blocked_by_river": "Foot ball terrain (Kora),",
  //       "primary_occupations": "School, Market,",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Kora",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "CBD Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Nyabugogi Kimisagra Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 27,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXHAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugari",
  //       "bridge_opportunity_project_code": "1014261",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.9517,
  //       "bridge_opportunity_gps_longitude": 30.05254,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 51377,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9517,
  //       "proposed_bridge_location_gps_longitude": 30.05254,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "CBD and Nyarugenge Market (Kimisagara), Kimisagara Market (Kora)",
  //       "education_access_blocked_by_river": "UR University and all secondary schools in CBD (Kimisagara)",
  //       "health_access_blocked_by_river": "Kabusunzu Health center (Kora),",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Market, to CBD, school",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Kora",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "CBD Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Nyabugogo-Kimisagara-Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXWAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubungo",
  //       "bridge_opportunity_project_code": "1014266",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -2.072995,
  //       "bridge_opportunity_gps_longitude": 30.016687,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9713,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.072995,
  //       "proposed_bridge_location_gps_longitude": 30.016687,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "25 kilometers",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Farms both side,",
  //       "education_access_blocked_by_river": "No communities blocked to school",
  //       "health_access_blocked_by_river": "Not used for health center and Hospital",
  //       "other_access_blocked_by_river": "No",
  //       "primary_occupations": "Farms",
  //       "primary_crops_grown": "sugar can, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Ntungamo",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "CBD KIGALI",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Nyamirambo",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Left side surrounded by the vast swamp where it was not easy to access the place and people said that normally they used Mpanga site which on -02.064151, 030.028170",
  //       "bridge_type": "Other",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekXvAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubuye",
  //       "bridge_opportunity_project_code": "1014267",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -2.04925,
  //       "bridge_opportunity_gps_longitude": 29.98573,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3484,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.04925,
  //       "proposed_bridge_location_gps_longitude": 29.98573,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "30 kilometers",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Rugarika Market (Kivumu, Ntungamo), Mageragere Market (Rugarika)",
  //       "education_access_blocked_by_river": "No communities blocked to school",
  //       "health_access_blocked_by_river": "Kiboga health center (Kivumu, Ntungamo)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Market, health center, farms",
  //       "primary_crops_grown": "sugar can",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Nyarubuye",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "CBD KIGALI",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 78,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekYFAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karukina",
  //       "bridge_opportunity_project_code": "1014268",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -2.01861,
  //       "bridge_opportunity_gps_longitude": 30.0085,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3180,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01861,
  //       "proposed_bridge_location_gps_longitude": 30.0085,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "30 kilometers",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "Two months",
  //       "market_access_blocked_by_river": "Mageragere Market and Kimisange Market (Rugarika \"Masaka\"), Bishenyi Market (Mageragere \"Karukina\")",
  //       "education_access_blocked_by_river": "No communities blocked to education",
  //       "health_access_blocked_by_river": "Butamwa Health center (Rugarika )",
  //       "other_access_blocked_by_river": "Nyarusange Prison (Rugarika)",
  //       "primary_occupations": "Market, health center, visit to prison",
  //       "primary_crops_grown": "sugar can, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who was wauiting to closer to river with boat",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "CBD KIGALI",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Nyamirambo",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 120,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekYPAAY",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Nyakirambi",
  //       "bridge_opportunity_project_code": "1014270",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.91659,
  //       "bridge_opportunity_gps_longitude": 30.01887,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1220,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.91659,
  //       "proposed_bridge_location_gps_longitude": 30.01887,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "20 kilometers",
  //       "days_per_year_river_is_flooded": 190,
  //       "flood_duration_during_rainy_season": "Seven days",
  //       "market_access_blocked_by_river": "Shyorongi Market ( Mataba and Jali) Nyabugogo Market (Nyaweru and Taba)",
  //       "education_access_blocked_by_river": "GS Kanyinya and Primary school (Mataba and Muko)",
  //       "health_access_blocked_by_river": "Healthy center Kanyinya (Mataba and Muko)",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "School, health center, farm, Market,",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "They was trying to cross the bridge when it was flooded and fell into river and one found died",
  //       "notes_on_social_information": "Community leaders of Nyakirambi and Mataba",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekYeAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Makuza",
  //       "bridge_opportunity_project_code": "1014271",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.982414,
  //       "bridge_opportunity_gps_longitude": 30.056395,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3060,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.982414,
  //       "proposed_bridge_location_gps_longitude": 30.056395,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "30 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Biryogo Market ( one party of Mumena and Akatabaro)",
  //       "education_access_blocked_by_river": "CESK Secondary and primary school ( one party of Mumena and Akatabaro)",
  //       "health_access_blocked_by_river": "Nyiranuma health center ( one party of Mumena and Akatabaro)",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "School, Market, health center,",
  //       "primary_crops_grown": "none",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They were trying to cross and they felt in to the channel and one them is handicapped totally",
  //       "notes_on_social_information": "Community leaders of Akatabaro",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "CBD KIGALI _Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Closer to this vehicular bridge 30 meters see picture below",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekYjAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mu Bitare",
  //       "bridge_opportunity_project_code": "1014272",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.94731,
  //       "bridge_opportunity_gps_longitude": 30.025352,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8643,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94731,
  //       "proposed_bridge_location_gps_longitude": 30.025352,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "600 m",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Nyabugogo Market (Rutagara 1, 2, Nzove)",
  //       "education_access_blocked_by_river": "Muhima primary and secondary school (Rutagara 1, 2, Nzove) Nzove primary and secondary school (Kinyoni)",
  //       "health_access_blocked_by_river": "Muhima district Hospital and CHUK (Rutagara 1, 2, Nzove)",
  //       "other_access_blocked_by_river": "Potable water (Rutagara 1)",
  //       "primary_occupations": "School, Market, health center",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Rutagara 1",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekYoAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kohaki",
  //       "bridge_opportunity_project_code": "1014273",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.88659,
  //       "bridge_opportunity_gps_longitude": 30.09792,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5492,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.88659,
  //       "proposed_bridge_location_gps_longitude": 30.09792,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "It doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Batsinda Market(Gasanze Rwankuba)",
  //       "education_access_blocked_by_river": "Rwankuba primary and secondary school (Ngaruyinka)",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Market,farm, fetching water",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Community leaders of Rwankuba",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gicumbi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekYtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyangesa",
  //       "bridge_opportunity_project_code": "1014274",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.06966,
  //       "bridge_opportunity_gps_longitude": 29.84335,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2055,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06966,
  //       "proposed_bridge_location_gps_longitude": 29.84335,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Musambira",
  //       "education_access_blocked_by_river": "Kambyeyi primary and kigusa high school",
  //       "health_access_blocked_by_river": "Musambira",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "0",
  //       "notes_on_social_information": "Ruseke village don't have access musambira market Information gathered from cell worker",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekcKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukunguri",
  //       "bridge_opportunity_project_code": "1014275",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.05318,
  //       "bridge_opportunity_gps_longitude": 29.86879,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1858,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05318,
  //       "proposed_bridge_location_gps_longitude": 29.86879,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Musambira",
  //       "education_access_blocked_by_river": "Buye high school",
  //       "health_access_blocked_by_river": "Musambira health center",
  //       "other_access_blocked_by_river": "Musambira churches",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "A boy died trying to cross when it was flooded",
  //       "notes_on_social_information": "Buye village dont have access to rugarama musambira market Information gathered from cell worker",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekcPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gacaca-rubanga",
  //       "bridge_opportunity_project_code": "1014276",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.03922,
  //       "bridge_opportunity_gps_longitude": 29.84801,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3868,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.03922,
  //       "proposed_bridge_location_gps_longitude": 29.84801,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Musambira",
  //       "education_access_blocked_by_river": "ECOSE high school",
  //       "health_access_blocked_by_river": "Musambira",
  //       "other_access_blocked_by_river": "Musambira",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Cyambwe cell dont have access to musambira market and karengera cell don't have access to cyambwe cell Information gathered from cell worker",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 88,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekdDAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bweya",
  //       "bridge_opportunity_project_code": "1014277",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.03693,
  //       "bridge_opportunity_gps_longitude": 29.83341,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1858,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.03693,
  //       "proposed_bridge_location_gps_longitude": 29.83341,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 53,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Musambira market",
  //       "education_access_blocked_by_river": "Musambira high school",
  //       "health_access_blocked_by_river": "Musambira health center",
  //       "other_access_blocked_by_river": "Musambira cothoric church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Not yet",
  //       "notes_on_social_information": "Kingoma village dont have access to musambira market Information gathered from village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekfxAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahama",
  //       "bridge_opportunity_project_code": "1014278",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.02057,
  //       "bridge_opportunity_gps_longitude": 29.80686,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3558,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.02057,
  //       "proposed_bridge_location_gps_longitude": 29.80686,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": "Musambira",
  //       "education_access_blocked_by_river": "Mpushi high school",
  //       "health_access_blocked_by_river": "Kivumu health center",
  //       "other_access_blocked_by_river": "ADPER mpushi",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Kabere village dont have access to musambira market Information gathered from kabere leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekg2AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kataburara",
  //       "bridge_opportunity_project_code": "1014282",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.09794,
  //       "bridge_opportunity_gps_longitude": 29.93278,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1659,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.09794,
  //       "proposed_bridge_location_gps_longitude": 29.93278,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Mugina market and gashyushya market",
  //       "education_access_blocked_by_river": "Mbati high school",
  //       "health_access_blocked_by_river": "Mugina health center",
  //       "other_access_blocked_by_river": "Mugina parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Information gathered from cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Mugina",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The commmynity is suggesting vehicular bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekgMAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mombori2",
  //       "bridge_opportunity_project_code": "1014284",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.08488,
  //       "bridge_opportunity_gps_longitude": 29.81828,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2800,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08488,
  //       "proposed_bridge_location_gps_longitude": 29.81828,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Musumba market and musumba market",
  //       "education_access_blocked_by_river": "Ruyanza high school",
  //       "health_access_blocked_by_river": "Nyarubaka health center",
  //       "other_access_blocked_by_river": "Ruyanza parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "People died trying to cross the river when it was flooded",
  //       "notes_on_social_information": "Ruyanza dont have access to musambira market Information gathered from neighborhood locals",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekgWAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasenyi",
  //       "bridge_opportunity_project_code": "1014285",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.05255,
  //       "bridge_opportunity_gps_longitude": 29.89237,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1580,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05255,
  //       "proposed_bridge_location_gps_longitude": 29.89237,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 16,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Musambira market and mugina market",
  //       "education_access_blocked_by_river": "Nyamiyaga high school",
  //       "health_access_blocked_by_river": "Nyamiyaga health center",
  //       "other_access_blocked_by_river": "Nyamiyaga church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Nothing serious yet occured",
  //       "notes_on_social_information": "Mugarama village don't have access to nyamiyaga center and kiranzi village don't have access to musambira market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rugobagoba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 62,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekgbAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyonyombya",
  //       "bridge_opportunity_project_code": "1014286",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.065,
  //       "bridge_opportunity_gps_longitude": 29.91408,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.065,
  //       "proposed_bridge_location_gps_longitude": 29.91408,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Mugina and gashyushya market",
  //       "education_access_blocked_by_river": "Ruyumba high schoo",
  //       "health_access_blocked_by_river": "Nyamiyaga health center",
  //       "other_access_blocked_by_river": "Ruyumba parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "People has fallen in the river before constructing the current timber bridge",
  //       "notes_on_social_information": "Nkoto village dont have access to mugina market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rugobagoba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekggAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugomero",
  //       "bridge_opportunity_project_code": "1014287",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.05616,
  //       "bridge_opportunity_gps_longitude": 29.90943,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05616,
  //       "proposed_bridge_location_gps_longitude": 29.90943,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "None",
  //       "education_access_blocked_by_river": "Nyamiyaga high school",
  //       "health_access_blocked_by_river": "Nyamiyaga health center",
  //       "other_access_blocked_by_river": "Nyamiyaga parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet occurred",
  //       "notes_on_social_information": "Kirehe village don't have access to nyamiyaga Information gathered from local 6",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rugobagoba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekglAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabungo-nyagihamba",
  //       "bridge_opportunity_project_code": "1014288",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.0829,
  //       "bridge_opportunity_gps_longitude": 29.88202,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0829,
  //       "proposed_bridge_location_gps_longitude": 29.88202,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community need avehicular bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekgqAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bigaga",
  //       "bridge_opportunity_project_code": "1014289",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.07133,
  //       "bridge_opportunity_gps_longitude": 29.87194,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 890,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.07133,
  //       "proposed_bridge_location_gps_longitude": 29.87194,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community needs avehicular bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekgvAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhuha/akaruruma",
  //       "bridge_opportunity_project_code": "1014291",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.06986,
  //       "bridge_opportunity_gps_longitude": 29.86084,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2160,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06986,
  //       "proposed_bridge_location_gps_longitude": 29.86084,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two weeks",
  //       "market_access_blocked_by_river": "Musambira",
  //       "education_access_blocked_by_river": "Musambira high school",
  //       "health_access_blocked_by_river": "Musambira health center",
  //       "other_access_blocked_by_river": "Musambira parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet occured",
  //       "notes_on_social_information": "Information gathered from cell leader Kambyeyi cell don't have access to gashyushya market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 83,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekh5AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasamasazi",
  //       "bridge_opportunity_project_code": "1014294",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.10176,
  //       "bridge_opportunity_gps_longitude": 29.84282,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5057,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10176,
  //       "proposed_bridge_location_gps_longitude": 29.84282,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Musambira market",
  //       "education_access_blocked_by_river": "Kigusa high school",
  //       "health_access_blocked_by_river": "Nyarubaka health center",
  //       "other_access_blocked_by_river": "Kigusa parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Not yet occured",
  //       "notes_on_social_information": "Information gathered from rugarama village leader Rugarama dont have access to rwinanka village",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 97,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekhKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kavumu-ngarama",
  //       "bridge_opportunity_project_code": "1014295",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.06614,
  //       "bridge_opportunity_gps_longitude": 29.82734,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06614,
  //       "proposed_bridge_location_gps_longitude": 29.82734,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Musambira market",
  //       "education_access_blocked_by_river": "Ruyanza high school",
  //       "health_access_blocked_by_river": "Musambira health center",
  //       "other_access_blocked_by_river": "Ruyanza parish",
  //       "primary_occupations": "Faming",
  //       "primary_crops_grown": "maiz, soya bean",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Awoman died trying to cross",
  //       "notes_on_social_information": "Ngarama and bubunga dont have access to musambira market Informstion gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 74,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekhPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanombe",
  //       "bridge_opportunity_project_code": "1014296",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.08032,
  //       "bridge_opportunity_gps_longitude": 29.822,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2650,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08032,
  //       "proposed_bridge_location_gps_longitude": 29.822,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "I have assessed another pedestrian bridge in one kilometer upstream",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Musumba market",
  //       "education_access_blocked_by_river": "Ruyanza high school",
  //       "health_access_blocked_by_river": "Nyarubaka heakth center",
  //       "other_access_blocked_by_river": "Ruyanza parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, soya bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Gitenga villave dont have access to musambira market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Dubai",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 69.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekhUAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagashubi",
  //       "bridge_opportunity_project_code": "1014297",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.07748,
  //       "bridge_opportunity_gps_longitude": 29.90302,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1986,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.07748,
  //       "proposed_bridge_location_gps_longitude": 29.90302,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Week",
  //       "market_access_blocked_by_river": "Mugina market and gashyushya market",
  //       "education_access_blocked_by_river": "Ruyumba high school",
  //       "health_access_blocked_by_river": "Nyamiyaga health center",
  //       "other_access_blocked_by_river": "Nyamiyaga parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Karubanda village dont have access to gashyushya market Kigabiro village dont have access to mugina market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rugobagoba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 57,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekhZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bahimba ya kigabiro",
  //       "bridge_opportunity_project_code": "1014298",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.08375,
  //       "bridge_opportunity_gps_longitude": 29.9012,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1810,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.11",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08375,
  //       "proposed_bridge_location_gps_longitude": 29.9012,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Mugina market and mugashyushya market.",
  //       "education_access_blocked_by_river": "Ruyumba high school and bibungo high school",
  //       "health_access_blocked_by_river": "Mugina and nyagihamba heakth center",
  //       "other_access_blocked_by_river": "Riyumba parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 9,
  //       "incident_descriptions": "Students fall in the ruver when it is flooded",
  //       "notes_on_social_information": "Nyamabere village dont have access to gashyushya market and kigabiro village dont have access to mugina market Information gathered from village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rugobagoba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 61,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eekheAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kimiyumbo",
  //       "bridge_opportunity_project_code": "1014300",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.07671,
  //       "bridge_opportunity_gps_longitude": 29.88236,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1606,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.07671,
  //       "proposed_bridge_location_gps_longitude": 29.88236,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Mugashyushya market",
  //       "education_access_blocked_by_river": "Ruyumba high school",
  //       "health_access_blocked_by_river": "Ruyumba health center",
  //       "other_access_blocked_by_river": "Nyarubaka parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet occured",
  //       "notes_on_social_information": "Mukuyo village dont have access to mugashyushya market Information gathered from village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rugobagoba",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eelYiAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugitare",
  //       "bridge_opportunity_project_code": "1014301",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.11204,
  //       "bridge_opportunity_gps_longitude": 29.82869,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2560,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11204,
  //       "proposed_bridge_location_gps_longitude": 29.82869,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 56,
  //       "flood_duration_during_rainy_season": "Two weeks",
  //       "market_access_blocked_by_river": "Musumba market and bienvenue market",
  //       "education_access_blocked_by_river": "Mbuye high school",
  //       "health_access_blocked_by_river": "Mbuye health center",
  //       "other_access_blocked_by_river": "Gitare parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Nyabintare village dont have acces to bienvenue market and bereshi village don't have access to musumba market Information gathered from village community member",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kwibereshi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 58.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eelZRAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Runiga",
  //       "bridge_opportunity_project_code": "1014302",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.10741,
  //       "bridge_opportunity_gps_longitude": 29.80042,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1690,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10741,
  //       "proposed_bridge_location_gps_longitude": 29.80042,
  //       "current_crossing_method": "Timber. Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Muhanga",
  //       "education_access_blocked_by_river": "Gitare high school",
  //       "health_access_blocked_by_river": "Musumba health center",
  //       "other_access_blocked_by_river": "Gitare parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Rubuye village dont have access to musumba market Information gathered from people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eelkqAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ntibiki",
  //       "bridge_opportunity_project_code": "1014303",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.09932,
  //       "bridge_opportunity_gps_longitude": 29.81269,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2496,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.09932,
  //       "proposed_bridge_location_gps_longitude": 29.81269,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "2 hours",
  //       "market_access_blocked_by_river": "Musumba",
  //       "education_access_blocked_by_river": "Gitare high school and ruyanza high school",
  //       "health_access_blocked_by_river": "Nyagihamba health center",
  //       "other_access_blocked_by_river": "Gitare parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Old man slipped and died",
  //       "notes_on_social_information": "Karora village dont have access to musumba market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 49,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eelnpAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyiragakokwe",
  //       "bridge_opportunity_project_code": "1014304",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.07101,
  //       "bridge_opportunity_gps_longitude": 29.84978,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2870,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.07101,
  //       "proposed_bridge_location_gps_longitude": 29.84978,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": "Musambira market",
  //       "education_access_blocked_by_river": "Cyambwe primary school, giheta nursery school",
  //       "health_access_blocked_by_river": "Musambira health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Giheta village dont have access to musambira market Information gathered from cell leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Musambira",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eelq8AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bahimba-maswa-nyamweru",
  //       "bridge_opportunity_project_code": "1014305",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.08723,
  //       "bridge_opportunity_gps_longitude": 29.92198,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2554,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08723,
  //       "proposed_bridge_location_gps_longitude": 29.92198,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 56,
  //       "flood_duration_during_rainy_season": "Five days",
  //       "market_access_blocked_by_river": "Mugashyushya market",
  //       "education_access_blocked_by_river": "Mataba high school",
  //       "health_access_blocked_by_river": "Nyamiyaha health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Information gathered from local people Munyinya village dont have access to mugina market Nyamweru village don't have access to mugashyushya market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Mugina",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32.5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eelvcAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kazabagarura",
  //       "bridge_opportunity_project_code": "1014306",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.08435,
  //       "bridge_opportunity_gps_longitude": 29.93516,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2640,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08435,
  //       "proposed_bridge_location_gps_longitude": 29.93516,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Farming",
  //       "education_access_blocked_by_river": "Mataba high school",
  //       "health_access_blocked_by_river": "Mugina health center",
  //       "other_access_blocked_by_river": "Ruhuko parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Gitega village dont have access to mugina market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Mugina",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eelvmAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamirabageni",
  //       "bridge_opportunity_project_code": "1014307",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.08754,
  //       "bridge_opportunity_gps_longitude": 29.94017,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8025,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.12",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08754,
  //       "proposed_bridge_location_gps_longitude": 29.94017,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two weeks",
  //       "market_access_blocked_by_river": "Mugina market",
  //       "education_access_blocked_by_river": "Mataba high school",
  //       "health_access_blocked_by_river": "Ngoma health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "In past twenty years the bridge and groom fell in the river",
  //       "notes_on_social_information": "Buhoro village dont have access to mugina market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Mugina",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eelvwAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakigezi",
  //       "bridge_opportunity_project_code": "1014309",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.87493,
  //       "bridge_opportunity_gps_longitude": 29.849092,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1830,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.87493,
  //       "proposed_bridge_location_gps_longitude": 29.849092,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "October to December, March to MAY , 24 HOURS",
  //       "market_access_blocked_by_river": "Kayenzi market ( 1,2, 4), nyabikenke market ( 3 ), farms ( 1,3),GIMI Mining Ltd ( 1 , 2).",
  //       "education_access_blocked_by_river": "St Bernard primary school( 3), Gisizi Primary school( 1).",
  //       "health_access_blocked_by_river": "Ntwali dispensary ( 3), kayenzi health center ( 3).",
  //       "other_access_blocked_by_river": "Cubi churches ( 3) , Gisizi church ( 1,2), potable water ( 1).",
  //       "primary_occupations": "Farming and Mining activities",
  //       "primary_crops_grown": "banana, pineappl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by village leaders.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 87,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeqpoAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamabuye",
  //       "bridge_opportunity_project_code": "1014311",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.856669,
  //       "bridge_opportunity_gps_longitude": 29.838176,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5800,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.856669,
  //       "proposed_bridge_location_gps_longitude": 29.838176,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming and mining activities",
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The span beyond the existing engineering scope",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 150,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeqqXAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyabariza",
  //       "bridge_opportunity_project_code": "1014313",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.056492,
  //       "bridge_opportunity_gps_longitude": 29.940225,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 13900,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.056492,
  //       "proposed_bridge_location_gps_longitude": 29.940225,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There was a vehicular bridge, the community need the rehabilitation of that bridge.",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeqsEAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatovu",
  //       "bridge_opportunity_project_code": "1014314",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.985042,
  //       "bridge_opportunity_gps_longitude": 29.951748,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5572,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.985042,
  //       "proposed_bridge_location_gps_longitude": 29.951748,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Bishenyi market( 1), shops ( 2), farms ( 2,1).",
  //       "education_access_blocked_by_river": "Groupe Scolaire Sheli~ primary and secondary school ( village 2 )",
  //       "health_access_blocked_by_river": "Kigesi health center( 2)",
  //       "other_access_blocked_by_river": "Sheli Catholic church( 2), cell office( 2), potable water ( 2).",
  //       "primary_occupations": "Farming, goverment workers, business owners",
  //       "primary_crops_grown": "banana, bean, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned while crossing the river",
  //       "notes_on_social_information": "Population information of each village was provided by Gatovu leader, karangwa fidele who sourced the population from villages leader by phone call. The last population information was updated in 2018. Population of all adjacent communities includes: Gatovu, and kagangayire. The population members from village 2 are blocked daily to the school, shops and farms.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali~ Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeqsYAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibanza",
  //       "bridge_opportunity_project_code": "1014315",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.951433,
  //       "bridge_opportunity_gps_longitude": 29.878932,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2646,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.951433,
  //       "proposed_bridge_location_gps_longitude": 29.878932,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 kilometers",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "April , 5 hours",
  //       "market_access_blocked_by_river": "Gacurabwenge market ( 2 ), farms ( 1,2), Remera coffee washing station ( 2 ).",
  //       "education_access_blocked_by_river": "Nyakabuye primary school and secondary school ( 1, 3)",
  //       "health_access_blocked_by_river": "Rwishima health center ( 1,3), Remera~Rukoma Hospital ( 2 )",
  //       "other_access_blocked_by_river": "Churches ( 1,2,3), places of recreation( football terrain 1,2,3)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by village leader, Martin Minani who sourced the population information from village register book. The population of all adjacent communities includes the following villages: kibanza , Mbizi, kigarama and karama sector. People from karama sector use the crossing twice a week to visit the market, and sometimes to the district office.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeqssAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mataba",
  //       "bridge_opportunity_project_code": "1014316",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.005117,
  //       "bridge_opportunity_gps_longitude": 29.917354,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6305,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.005117,
  //       "proposed_bridge_location_gps_longitude": 29.917354,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Going around the river in two kilometers away",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "March to May, sometimes in November and December , 1 hours",
  //       "market_access_blocked_by_river": "Gashyushya market ( 2 and 3 ), farms ( 1,2).",
  //       "education_access_blocked_by_river": "Groupe Scolaire St Jean Bosco Kamonyi~ primary and secondary school( 2)",
  //       "health_access_blocked_by_river": "Kamonyi health center( 2 )",
  //       "other_access_blocked_by_river": "Churches ( 2), shops center ( 1 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population data was provided by cell leader, Iryivuze Chantal Who sourced the population from cell register. Population of all adjacent communities includes the following villages: mataba, Nyagasozi and Runda and Rugalika sector. Population members from Rugalika and Runda sometimes use the bridge to visit Market twice a week.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeqt7AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruheka",
  //       "bridge_opportunity_project_code": "1014319",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.883957,
  //       "bridge_opportunity_gps_longitude": 29.850548,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1559,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.883957,
  //       "proposed_bridge_location_gps_longitude": 29.850548,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 58,
  //       "flood_duration_during_rainy_season": "October to December , March to May, 3 to 4 hours",
  //       "market_access_blocked_by_river": "Kayenzi market ( 1), farms ( 1,2).mining activities ( 2)",
  //       "education_access_blocked_by_river": "Gishubi primary school ( 1), Kirwa secondary school( 2)",
  //       "health_access_blocked_by_river": "Girimpuhwe health center ( 1 )",
  //       "other_access_blocked_by_river": "Churches ( 1), sector office ( 1)",
  //       "primary_occupations": "Farming and mining",
  //       "primary_crops_grown": "banana, cassava, tre",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by village leader, Nubahimana frugence who sourced the population information from village register book , which was updated in 2018. Population of all adjacent communities includes the following villages Ruheka and kabana.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesclAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Munyegera",
  //       "bridge_opportunity_project_code": "1014320",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.915772,
  //       "bridge_opportunity_gps_longitude": 29.866533,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5030,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.915772,
  //       "proposed_bridge_location_gps_longitude": 29.866533,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Timber bridge in four kilometers away",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 24 hours",
  //       "market_access_blocked_by_river": "Kayenzi market( 4), Rukoma market ( 1,2,3), farms ( 1 and 4).",
  //       "education_access_blocked_by_river": "G.S. Bubazi( 4), E.S. Bugarama(4), G.S.MUGANZA( 1).",
  //       "health_access_blocked_by_river": "Kayenzi health center (4), Rukoma Hospital ( 1,2,3).",
  //       "other_access_blocked_by_river": "Potable water ( 1),kayenzi churches( 4), Muganza churches (1,3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, coffe, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population data of Bugarama cell was provided by cell leader, Akimana Jonas who sourced the data from cell register book, the last update was in 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi~kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 65,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eescqAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyenyeri",
  //       "bridge_opportunity_project_code": "1014321",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.939737,
  //       "bridge_opportunity_gps_longitude": 29.843622,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2200,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.939737,
  //       "proposed_bridge_location_gps_longitude": 29.843622,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Five kilometer away",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 24 hours",
  //       "market_access_blocked_by_river": "Kayenzi market ( 1,2),karambo , manyana, murara markets( 3), farms (1,2,3).",
  //       "education_access_blocked_by_river": "Bunyonga Primary school ( 3), Bubazi primary school and secondary school ( 1,2), VTC Bugarama( 1,2).",
  //       "health_access_blocked_by_river": "Karama health center ( 3)",
  //       "other_access_blocked_by_river": "Churches ( 3), potable water ( 1).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, coffe, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 37,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eescvAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bunyonga 2",
  //       "bridge_opportunity_project_code": "1014323",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.939927,
  //       "bridge_opportunity_gps_longitude": 29.818313,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.939927,
  //       "proposed_bridge_location_gps_longitude": 29.818313,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There was a vehicular bridge, now community want the repair of that bridge ( community need a vehicular bridge only).",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesdAAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinkeri",
  //       "bridge_opportunity_project_code": "1014324",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.977729,
  //       "bridge_opportunity_gps_longitude": 29.850108,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 600,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.977729,
  //       "proposed_bridge_location_gps_longitude": 29.850108,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge. In four month ago there was a vehicular bridge and during April , 2018 disater the flood washed the away the bridge.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesdKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karama",
  //       "bridge_opportunity_project_code": "1014325",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.980126,
  //       "bridge_opportunity_gps_longitude": 29.905502,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4804,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.980126,
  //       "proposed_bridge_location_gps_longitude": 29.905502,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge in three kilometers away",
  //       "days_per_year_river_is_flooded": 49,
  //       "flood_duration_during_rainy_season": "October to december, April to May , over 48 hours",
  //       "market_access_blocked_by_river": "Gacurabwenge market ( 1,2,3), bishenyi market ( 4,5), AGIR Kamonyi market ( 4,5), farms ( 1,4)",
  //       "education_access_blocked_by_river": "Gihinga primary school ( 4)",
  //       "health_access_blocked_by_river": "Gihinga health center (4)",
  //       "other_access_blocked_by_river": "Kamonyi district office ( 4,5), Gacurabwenge sector office ( 4), Gihinga bus stop( 4,5), churches in karama ( 4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, casssava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Gihinga cell leader, NZAYISENGA who sourced the population information from cell register, the last update was in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi ~ Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesdPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugobagoba",
  //       "bridge_opportunity_project_code": "1014326",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.001263,
  //       "bridge_opportunity_gps_longitude": 29.888983,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3070,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.001263,
  //       "proposed_bridge_location_gps_longitude": 29.888983,
  //       "current_crossing_method": "Two log of Timber",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 3 to 4 hours",
  //       "market_access_blocked_by_river": "Gacurabwenge market ( 1), Gashyushya market ( 2,3), farms (1,2,3).",
  //       "education_access_blocked_by_river": "Rubona primary school ( 1)",
  //       "health_access_blocked_by_river": "Remera~ Rukoma Hospital ( 1 )",
  //       "other_access_blocked_by_river": "Churches ( 1 ), potable water ( 2 ,3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population data provided by village leader, Nsengimana who sourced the population information from village book register.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi~kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesdUAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Raro",
  //       "bridge_opportunity_project_code": "1014327",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.896261,
  //       "bridge_opportunity_gps_longitude": 29.951448,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 600,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.15",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.896261,
  //       "proposed_bridge_location_gps_longitude": 29.951448,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge only",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesdZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murindi",
  //       "bridge_opportunity_project_code": "1014451",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.05615,
  //       "bridge_opportunity_gps_longitude": 29.93258,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6620,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05615,
  //       "proposed_bridge_location_gps_longitude": 29.93258,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 19,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Mugashyushya and rugarika",
  //       "education_access_blocked_by_river": "Magu primary school",
  //       "health_access_blocked_by_river": "Ngoma health center",
  //       "other_access_blocked_by_river": "Mataba parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Sabanunga village don't have access to mugashyushya village Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevdqAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagarama",
  //       "bridge_opportunity_project_code": "1014328",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.984548,
  //       "bridge_opportunity_gps_longitude": 29.931428,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6640,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.984548,
  //       "proposed_bridge_location_gps_longitude": 29.931428,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "400 m",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 3 hours",
  //       "market_access_blocked_by_river": "Bishenyi market ( 1,2,3), Rugali market ( 1,2,3), Gacurabwenge and AGIR Kamonyi market( 4,5), farms ( 1,4)",
  //       "education_access_blocked_by_river": "Rugalika primary school and secondary school ( 1,2,3,4), Rugalika Nursary school( 1,2).",
  //       "health_access_blocked_by_river": "Rugalika heath center ( 1,2)",
  //       "other_access_blocked_by_river": "Churches ( 1,2), potable water ( 4).",
  //       "primary_occupations": "Farming and businessman",
  //       "primary_crops_grown": "banana, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesiPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabuga (Fukwe)",
  //       "bridge_opportunity_project_code": "1014329",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.872181,
  //       "bridge_opportunity_gps_longitude": 29.92942,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.872181,
  //       "proposed_bridge_location_gps_longitude": 29.92942,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "April and May, between two to four week.",
  //       "market_access_blocked_by_river": "Kijabagwe market ( 1), Rwahi market ( 1), Rwacof washing station ( 2), farms ( 1,2).",
  //       "education_access_blocked_by_river": "Rwahi primary school ( 1), Kabasare primary and secondary school ( 2 ), PEDEKA school ( 2 ).",
  //       "health_access_blocked_by_river": "Rutonde health center ( 1), Ruri health center ( 1).",
  //       "other_access_blocked_by_river": "Bus stop to Kigali ( 1 ), church ( 1 ), ( 2 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, cassava, maiz, sugar can, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They were in the boat and drowned.",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 120,
  //       "height_differential_between_banks": 1.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesiUAAQ",
  //       "country": "Rwanda",
  //       "good_site": 0
  //     },
  //     {
  //       "bridge_name": "Rubare",
  //       "bridge_opportunity_project_code": "1014331",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.908306,
  //       "bridge_opportunity_gps_longitude": 29.881692,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 800,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.908306,
  //       "proposed_bridge_location_gps_longitude": 29.881692,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There was a vehicular bridge and washed away by floods, the community need the vehicular bridge because the truck now pass into the river to cross.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesieAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigabiro 1",
  //       "bridge_opportunity_project_code": "1014332",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.964977,
  //       "bridge_opportunity_gps_longitude": 29.975556,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3963,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.964977,
  //       "proposed_bridge_location_gps_longitude": 29.975556,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "October to December, March to May, 5 hours",
  //       "market_access_blocked_by_river": "Farms ( 1,2).",
  //       "education_access_blocked_by_river": "Ruyenzi secondary school ( 1).",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Sector office ( 1)",
  //       "primary_occupations": "Farming and goverment workers",
  //       "primary_crops_grown": "maiz, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by the Muganza cell leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Bishenyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesitAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigabiro 2",
  //       "bridge_opportunity_project_code": "1014333",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.960603,
  //       "bridge_opportunity_gps_longitude": 29.972412,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3057,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.960603,
  //       "proposed_bridge_location_gps_longitude": 29.972412,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 kilometers",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "November to December, April and May, 3 to 5 hours",
  //       "market_access_blocked_by_river": "Farms(1,2).",
  //       "education_access_blocked_by_river": "Muganza primary school (2).",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Muganza cell office ( 2 ), potable water ( 2 ).",
  //       "primary_occupations": "Farming and self employed , employers",
  //       "primary_crops_grown": "banana, bean, maiz, sweet potatoes. livestock ( cows).",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Muganza cell leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Bishenyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesiyAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyaruhoko",
  //       "bridge_opportunity_project_code": "1014334",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.969472,
  //       "bridge_opportunity_gps_longitude": 29.959591,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3793,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.969472,
  //       "proposed_bridge_location_gps_longitude": 29.959591,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 kilometers",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "October to December, March to May, ( 2 to 3 hours)",
  //       "market_access_blocked_by_river": "Bishenyi market ( 3 ), farms ( 1,2,3).",
  //       "education_access_blocked_by_river": "Muganza primary school ( 3 ). Runda TVT school ( 1,2).",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "Church ( 1,2), (3), sector office ( 3 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by Muganza cell leader.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Bishenyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesorAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamabuye",
  //       "bridge_opportunity_project_code": "1014336",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.931734,
  //       "bridge_opportunity_gps_longitude": 29.894059,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3702,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.931734,
  //       "proposed_bridge_location_gps_longitude": 29.894059,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "March to May , November to December, 4 to 5 hours",
  //       "market_access_blocked_by_river": "Kazirabonde , Bugoba market, Gacurabwenge market ( 3), farms ( 1,2,3), mining activities ( 1,2,3).",
  //       "education_access_blocked_by_river": "Nyarubuye primary and secondary school ( 3), Remera primary and secondary school ( 3).",
  //       "health_access_blocked_by_river": "Rukoma Hospital ( 3 ).",
  //       "other_access_blocked_by_river": "Churches ( 3 ), potable water ( 3).",
  //       "primary_occupations": "Farming and Minerals Mining a activities",
  //       "primary_crops_grown": "banana, bean, cassava, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Fell down and fractured",
  //       "notes_on_social_information": "Population data was provided by village data Musabyimana who sourced data from village book record.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi ( RN1)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eessKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kireka",
  //       "bridge_opportunity_project_code": "1014337",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.119285,
  //       "bridge_opportunity_gps_longitude": 29.997436,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1026,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.119285,
  //       "proposed_bridge_location_gps_longitude": 29.997436,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The information was provided by Giraneza Bernard.",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge because there was vehicular road them the flood come and washed away the road and the stream formed.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eessPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bukimba",
  //       "bridge_opportunity_project_code": "1014338",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -1.943021,
  //       "bridge_opportunity_gps_longitude": 29.982635,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1383,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.943021,
  //       "proposed_bridge_location_gps_longitude": 29.982635,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eessUAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mikamba~nyaruhengeri",
  //       "bridge_opportunity_project_code": "1014339",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.126854,
  //       "bridge_opportunity_gps_longitude": 29.946166,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 23060,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.126854,
  //       "proposed_bridge_location_gps_longitude": 29.946166,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge four kilometers away.",
  //       "days_per_year_river_is_flooded": 5,
  //       "flood_duration_during_rainy_season": "April to May, 2 hours",
  //       "market_access_blocked_by_river": "Kinazi market ( 1,4), Mugina market ( 2,3),farms ( 1,2). Mukunguri rice factory ( 1,4).",
  //       "education_access_blocked_by_river": "College saint Ignance secondary school(2,3), Mbati secondary school ( 2,3).",
  //       "health_access_blocked_by_river": "Kinazi hospital ( 1,4), Mugina health center ( 2,3).",
  //       "other_access_blocked_by_river": "Churches( 2,3), Mugina sector office (2,3).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, cassava, maiz, onion, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned but was rescued by surrounding peopke",
  //       "notes_on_social_information": "Population information of each village was provided cell leader, Jean Baptist. Population of all adjacent communities includes the following villages: Mbati, Jenda, Mukinga and Nteko. The community members from Mbati and Nteko are blocked to the markets , farms and Kinazi hospital.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kamonyi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eesseAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigende",
  //       "bridge_opportunity_project_code": "1014340",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.362459,
  //       "bridge_opportunity_gps_longitude": 30.642264,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 418,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.16",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.362459,
  //       "proposed_bridge_location_gps_longitude": 30.642264,
  //       "current_crossing_method": "Stones",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "April and May, 2 hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "The information were provided by cell leader and community who attended the Assessment meeting. They said there is no need of footbridge because even the river can be flooded sometime, the flood does not take a long time , they still cross the river every day.",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The river is very norrow, Community cross year round.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eessjAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngugu",
  //       "bridge_opportunity_project_code": "1014449",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.05618,
  //       "bridge_opportunity_gps_longitude": 29.92399,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2707,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.05618,
  //       "proposed_bridge_location_gps_longitude": 29.92399,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "Four days",
  //       "market_access_blocked_by_river": "Gashyushya market",
  //       "education_access_blocked_by_river": "Magu primary school and nyamiyaga high school",
  //       "health_access_blocked_by_river": "Ruyumba health center",
  //       "other_access_blocked_by_river": "Nyamiyaga parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "People fell during big storm that made river to be flooded",
  //       "notes_on_social_information": "Rwezamenyo village dont have access to mugashyushya market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 44,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevORAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhungamiyaga",
  //       "bridge_opportunity_project_code": "1014345",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.13099,
  //       "bridge_opportunity_gps_longitude": 29.57793,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1823,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.13099,
  //       "proposed_bridge_location_gps_longitude": 29.57793,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 181,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Mwumba village don't have acess to Nyange market",
  //       "education_access_blocked_by_river": "Mwumba village don't have acess to ES Munzanga",
  //       "health_access_blocked_by_river": "Mwumba village don't acess to Munzanga health center",
  //       "other_access_blocked_by_river": "Mwumba village don't have acess to Murundi sector office HQ & EPR Ruganda whereas Ruhungamiyaga village don't have access to ADEPR Mwumba",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident here, but there so much soil erosion and when it rains people are scared to cross and stay on one side",
  //       "notes_on_social_information": "Ruhungamiyaga village leader provided information about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuu4AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatare",
  //       "bridge_opportunity_project_code": "1014346",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.10761,
  //       "bridge_opportunity_gps_longitude": 29.56258,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2972,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10761,
  //       "proposed_bridge_location_gps_longitude": 29.56258,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 201,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Gishyikiro village, Kibingo village, Gisebeya village don't have access to Rambura market",
  //       "education_access_blocked_by_river": "Gishyikiro village, Kibingo village, Gisebeya village don't have access to ES Ngoma whereas Remera village, gitwa village and nyamyumba village don't have access to ES Munzanga",
  //       "health_access_blocked_by_river": "Remera village, gitwa village and nyamyumba village don't have access to Munzanga health center",
  //       "other_access_blocked_by_river": "Gishyikiro village, Kibingo village, Gisebeya village don't have access to Ngoma church whereas Remera village, gitwa village and nyamyumba village don't have access to nzaratsi church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Two death",
  //       "notes_on_social_information": "Commander reserve force in Murundi sector was there to provide information about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuu9AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinyinya",
  //       "bridge_opportunity_project_code": "1014347",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.07245,
  //       "bridge_opportunity_gps_longitude": 29.60469,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3105,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.07245,
  //       "proposed_bridge_location_gps_longitude": 29.60469,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 98,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": "Mwunguzi village, Kirehe village, nzobe village don't have access to Birambo market",
  //       "education_access_blocked_by_river": "Mwunguzi village, Kirehe village, nzobe village don't have access to EAV Kivumu",
  //       "health_access_blocked_by_river": "Mwunguzi village, Kirehe village, nzobe village don't have access to Nyange health center",
  //       "other_access_blocked_by_river": "Mwunguzi village, Kirehe village, nzobe village don't have access to Nyange church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One injury across this river",
  //       "notes_on_social_information": "mwunguzi broadcast officer provided info about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuuOAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Gahakwa",
  //       "bridge_opportunity_project_code": "1014348",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.10605,
  //       "bridge_opportunity_gps_longitude": 30.49761,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11503,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10605,
  //       "proposed_bridge_location_gps_longitude": 30.49761,
  //       "current_crossing_method": "Concrete",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 119,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Gisunzu village ,urusagara village ,nyamata village don't have access to Kigarama market, whereas ruhuha village ,Uwimana village and kamagande village don't have access to Kizungu market",
  //       "education_access_blocked_by_river": "Gisunzu village ,urusagara village ,nyamata village don't have access to EP Rwikubo , whereas ruhuha village ,Uwimana village and kamagande village don't have access to EP Rujambara",
  //       "health_access_blocked_by_river": "Gisunzu village ,urusagara village ,nyamata village don't have access to Akagarama health post, whereas ruhuha village ,Uwimana village and kamagande village don't have access to Muhurizi health post",
  //       "other_access_blocked_by_river": "Gisunzu village ,urusagara village ,nyamata village don't have access to Kigarama church, whereas ruhuha village ,Uwimana village and kamagande village don't have access to Kizungu church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "4 injuries",
  //       "notes_on_social_information": "Rujambara Njyanama president is the one who provided information about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuuTAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitinga",
  //       "bridge_opportunity_project_code": "1014349",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.0566,
  //       "bridge_opportunity_gps_longitude": 30.47997,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11340,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0566,
  //       "proposed_bridge_location_gps_longitude": 30.47997,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No near point",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "7 days of flood",
  //       "market_access_blocked_by_river": "People around river from Ngoma district don't have access to Rwamagana market whereas those one from Rwamagana don't have access to Gasetsa market",
  //       "education_access_blocked_by_river": "No schools is blocked by the river",
  //       "health_access_blocked_by_river": "No health center is blocked by the river",
  //       "other_access_blocked_by_river": "Rwamagana district blocked at right whereas and Ngoma District at left",
  //       "primary_occupations": "Rice farmers",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries",
  //       "notes_on_social_information": "Icyakabiri village leader is the one who provided information about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuudAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngoma 22",
  //       "bridge_opportunity_project_code": "1014350",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.08722,
  //       "bridge_opportunity_gps_longitude": 30.50135,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11512,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.08722,
  //       "proposed_bridge_location_gps_longitude": 30.50135,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 92,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Gikomero village don't have access to rujambara market , whereas urusagara village , akarambaraye village and Mbonwa village don't have access to to ndekwe market",
  //       "education_access_blocked_by_river": "Gikomero village don't have access to GS rujambara , whereas urusagara village , akarambaraye village and Mbonwa village don't have access to to Gs ndekwe",
  //       "health_access_blocked_by_river": "Gikomero village don't have access to rujambara health center , whereas urusagara village , akarambaraye village and Mbonwa village don't have access to to ndekwe health center",
  //       "other_access_blocked_by_river": "Gikomero village don't have access to rujambara church , whereas urusagara village , akarambaraye village and Mbonwa village don't have access to to ndekwe catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No one died here , no injuries too , but crossing is not safe anyway",
  //       "notes_on_social_information": "Rujamba cell Jyanama president is the one who provided information about directly individual served by the bridge by referring to population census of 2017",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuuiAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kasherangabo",
  //       "bridge_opportunity_project_code": "1014351",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.1344,
  //       "bridge_opportunity_gps_longitude": 30.53379,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12039,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1344,
  //       "proposed_bridge_location_gps_longitude": 30.53379,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 72,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Rwasaburo village and Runazi village don't have access to kabare market whereas Rebero village and Kinanira village don't have access to Rugabano market",
  //       "education_access_blocked_by_river": "Rwasaburo village and Runazi village don't have access to Rebezo technical school",
  //       "health_access_blocked_by_river": "Kinanira village don't have access to Rugabano market Kirwa health center",
  //       "other_access_blocked_by_river": "Rwasaburo village and Runazi village don't have access to Kibungo Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries",
  //       "notes_on_social_information": "Kinanira village leader is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuunAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahama",
  //       "bridge_opportunity_project_code": "1014452",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.02057,
  //       "bridge_opportunity_gps_longitude": 29.80686,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5600,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.02057,
  //       "proposed_bridge_location_gps_longitude": 29.80686,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kirehe",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The river width is less than one meter",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eewEcAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugazi",
  //       "bridge_opportunity_project_code": "1014352",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.068,
  //       "bridge_opportunity_gps_longitude": 30.57965,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9156,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.068,
  //       "proposed_bridge_location_gps_longitude": 30.57965,
  //       "current_crossing_method": "People use Boat to cross the river",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "3 months of flood",
  //       "market_access_blocked_by_river": "People from Kayonza don't have access to Remera market , whereas people from Ngoma don't have access to rugazi market",
  //       "education_access_blocked_by_river": "People from Ngoma don't have access to GS Muko",
  //       "health_access_blocked_by_river": "People from Kayonza don't have access to Remera health center",
  //       "other_access_blocked_by_river": "People from Kayonza don't have access to Remera health center",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries",
  //       "notes_on_social_information": "Murambi village leader provided info about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 122,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuusAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugaragara",
  //       "bridge_opportunity_project_code": "1014353",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.19132,
  //       "bridge_opportunity_gps_longitude": 30.60191,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6321,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.19132,
  //       "proposed_bridge_location_gps_longitude": 30.60191,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 58,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Kabeza village , Gatare village, and rurama village don't have access to Nyange market whereas Nyinya village, rugaragara village and rwamukobwa village don't have access to Rurama market",
  //       "education_access_blocked_by_river": "Nyinya village, rugaragara village and rwamukobwa village don't have access to GS Rurama",
  //       "health_access_blocked_by_river": "No health center is blocked by the river",
  //       "other_access_blocked_by_river": "Nyinya village, rugaragara village and rwamukobwa village don't have access to Rurama Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries",
  //       "notes_on_social_information": "Buliba cell leader is the one who provided information about directly individual served by the bridge by referring to population census 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuv2AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyunuzi",
  //       "bridge_opportunity_project_code": "1014354",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.20179,
  //       "bridge_opportunity_gps_longitude": 30.60416,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9665,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20179,
  //       "proposed_bridge_location_gps_longitude": 30.60416,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 240,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Karenge village ,impara village , isangano vilage , Kigarama village and ubwixa village don't have access to to Rurama market",
  //       "education_access_blocked_by_river": "Karenge village ,impara village , isangano vilage , Kigarama village and ubwixa village don't have access to to GS Rurama ( Kwa muzigura )",
  //       "health_access_blocked_by_river": "Karenge village ,impara village , isangano vilage , Kigarama village and ubwixa village don't have access to Rurama health center",
  //       "other_access_blocked_by_river": "Karenge village ,impara village , isangano vilage , Kigarama village and ubwixa village don't have access to Ngoma district office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Last rain season in may 2018 two children died across this river",
  //       "notes_on_social_information": "Buliba cell leader is the one who provided information about directly individual served by the bridge by referring to population census 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuv7AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakondo",
  //       "bridge_opportunity_project_code": "1014355",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.20091,
  //       "bridge_opportunity_gps_longitude": 30.60236,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10789,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20091,
  //       "proposed_bridge_location_gps_longitude": 30.60236,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 151,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Cyero village don't have access to Rurama market",
  //       "education_access_blocked_by_river": "Cyero village don't have access to GS Rurama",
  //       "health_access_blocked_by_river": "Cyero village don't have access to Murama health center",
  //       "other_access_blocked_by_river": "Cyero village don't have access to Rurama Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries",
  //       "notes_on_social_information": "Buliba cell leader is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuvCAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bweranka",
  //       "bridge_opportunity_project_code": "1014356",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.15593,
  //       "bridge_opportunity_gps_longitude": 30.63163,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7491,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.15593,
  //       "proposed_bridge_location_gps_longitude": 30.63163,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 240,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Mirambi village , Ruhama village and Rwagakobe village don't have access to Gituku market",
  //       "education_access_blocked_by_river": "Mirambi village , Ruhama village and Rwagakobe village don't have access to Gituku market Gs Gituku whereas Bweranka village, Agatare village and Rusenyi village don't have access to GS Nyinya",
  //       "health_access_blocked_by_river": "Mirambi village , Ruhama village and Rwagakobe village don't have access to Gituku Health center",
  //       "other_access_blocked_by_river": "Mirambi village , Ruhama village and Rwagakobe village don't have access to Gituku market Gituku church whereas Bweranka village, Agatare village and Rusenyi village don't have access to Nyinya church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One teacher injured to this river",
  //       "notes_on_social_information": "Bweranka village leader is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "NGOMA - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuvbAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusenyi",
  //       "bridge_opportunity_project_code": "1014357",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.12877,
  //       "bridge_opportunity_gps_longitude": 30.64523,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 584,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12877,
  //       "proposed_bridge_location_gps_longitude": 30.64523,
  //       "current_crossing_method": "No current crossing method",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 62,
  //       "flood_duration_during_rainy_season": "1 hour during heavy rain season",
  //       "market_access_blocked_by_river": "Gituku village, munezero village, terimbere village and korandebe village don't have access to murindi market whereas Kabusunzu village, matahiro village, Gashiru village don't have access to Gituku market",
  //       "education_access_blocked_by_river": "Kabusunzu village, matahiro village, Gashiru village don't have access to GS Gituku",
  //       "health_access_blocked_by_river": "Kabusunzu village, matahiro village, Gashiru village don't have access to Gituku Health center",
  //       "other_access_blocked_by_river": "Kabusunzu village, matahiro village, Gashiru village don't have access to Gituku church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Gituku village leader is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuvgAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Masoko",
  //       "bridge_opportunity_project_code": "1014358",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.12746,
  //       "bridge_opportunity_gps_longitude": 30.64571,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 584,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12746,
  //       "proposed_bridge_location_gps_longitude": 30.64571,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 198,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuvlAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyamabuye",
  //       "bridge_opportunity_project_code": "1014359",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.12939,
  //       "bridge_opportunity_gps_longitude": 30.61855,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12806,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.12939,
  //       "proposed_bridge_location_gps_longitude": 30.61855,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Buliba cell, Nyamahehe village don't have access to Gituku market , whereas Nyamabuye village , gahoshyi village , buhabwa village and nyarusange village don't have access to Rukira market",
  //       "education_access_blocked_by_river": "Buliba cell, Nyamahehe village don't have access to GS gahoshyi",
  //       "health_access_blocked_by_river": "Buliba cell, Nyamahehe village don't have access to Gituku Health center , whereas Nyamabuye village , gahoshyi village , buhabwa village and nyarusange village don't have access to Rukira health center",
  //       "other_access_blocked_by_river": "Buliba cell, Nyamahehe village don't have access to Gituku church , whereas Nyamabuye village , gahoshyi village , buhabwa village and nyarusange village don't have access to Rukira church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, orang",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two injuries",
  //       "notes_on_social_information": "Nyamabuye village leader is the one who provided information about directly individual served by refering to the population census 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "NGOMA",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuvqAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabare",
  //       "bridge_opportunity_project_code": "1014476",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.332831,
  //       "bridge_opportunity_gps_longitude": 30.652159,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 670,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.332831,
  //       "proposed_bridge_location_gps_longitude": 30.652159,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The river is not dangerous, community can cross year round.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6yvAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhama",
  //       "bridge_opportunity_project_code": "1014360",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.18396,
  //       "bridge_opportunity_gps_longitude": 30.62926,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12210,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18396,
  //       "proposed_bridge_location_gps_longitude": 30.62926,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 99,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Nyinya cell don't have access to Nyakarambi market , whereas Bisagara cell don't have access to Gituku market",
  //       "education_access_blocked_by_river": "Bisagara cell don't have access to GS Nyinya",
  //       "health_access_blocked_by_river": "Bisagara cell don't have access to Nyinya health center",
  //       "other_access_blocked_by_river": "Nyinya cell don't have access to kirehe district , whereas Bisagara cell don't have access to Ngoma district",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "3 injuries across the river",
  //       "notes_on_social_information": "Nyinya cell leader ( Sedo ) is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuvvAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "MuKirombe",
  //       "bridge_opportunity_project_code": "1014361",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.18396,
  //       "bridge_opportunity_gps_longitude": 30.62258,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6890,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18396,
  //       "proposed_bridge_location_gps_longitude": 30.62258,
  //       "current_crossing_method": "Timbers, curvert",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Rwamukobwa village don't have access to Nyakarambi market",
  //       "education_access_blocked_by_river": "Karuruma village don't have access to GS Rugaragara",
  //       "health_access_blocked_by_river": "Rwamukobwa village don't have access to to Nyinya Health center",
  //       "other_access_blocked_by_river": "Karuruma village don't have access to Rugaragara church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Karuruma village is the one who provided information about directly individual served by the bridge by referring to population census 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuw0AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuberwa",
  //       "bridge_opportunity_project_code": "1014362",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.14193,
  //       "bridge_opportunity_gps_longitude": 30.50383,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11555,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14193,
  //       "proposed_bridge_location_gps_longitude": 30.50383,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 106,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Akagarama cell don't have access to Karembo market , whereas Mutsindo cell don't have access to Kigarama market",
  //       "education_access_blocked_by_river": "Akagarama cell don't have access to Gs Kansana , whereas Mutsindo cell don't have access to GS Kigarama",
  //       "health_access_blocked_by_river": "No health center blocked by the river",
  //       "other_access_blocked_by_river": "Akagarama cell don't have access to Kansana church , whereas Mutsindo cell don't have access to Musya church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, coffe, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No injuries",
  //       "notes_on_social_information": "Rwanyamuhinda village leader is the one who provided information about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuw5AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Busasamana",
  //       "bridge_opportunity_project_code": "1014363",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.18739,
  //       "bridge_opportunity_gps_longitude": 30.41009,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11440,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18739,
  //       "proposed_bridge_location_gps_longitude": 30.41009,
  //       "current_crossing_method": "People use Cyprus papyrus to cross the valley",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 200,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Ruhembe cell don't have access to Sake market",
  //       "education_access_blocked_by_river": "Ruhembe cell don't have access to GS Sangaza",
  //       "health_access_blocked_by_river": "Ruhembe cell don't have access to Sangaza Health center",
  //       "other_access_blocked_by_river": "Ruhinga cell don't have access to zaza church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "2 injuries across this valley",
  //       "notes_on_social_information": "Ruhinga cell leader provided all info about directly individual served by the bridge by referring to population census 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuwAAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rubirizi",
  //       "bridge_opportunity_project_code": "1014364",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.17331,
  //       "bridge_opportunity_gps_longitude": 30.57956,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 13110,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.17331,
  //       "proposed_bridge_location_gps_longitude": 30.57956,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 89,
  //       "flood_duration_during_rainy_season": "1 hour of flood",
  //       "market_access_blocked_by_river": "Kibimba village and murama village don't have access to Kibungo market , whereas nyagataba village and amahoro village don't have access to Rukira market",
  //       "education_access_blocked_by_river": "nyagataba village and amahoro village don't have access to GS Rukira",
  //       "health_access_blocked_by_river": "Kibimba village and murama village don't have access to Kibungo health center , whereas nyagataba village and amahoro village don't have access to Rukira health center",
  //       "other_access_blocked_by_river": "Kibimba village and murama village don't have access to Kibungo church , whereas nyagataba village and amahoro village don't have access to Rukira church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Buliba cell leader is the one who provided information about directly individual served by the bridge by referring to population census 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuwFAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwarudogodo",
  //       "bridge_opportunity_project_code": "1014365",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.14107,
  //       "bridge_opportunity_gps_longitude": 30.59631,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12806,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14107,
  //       "proposed_bridge_location_gps_longitude": 30.59631,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 138,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Kagarama village ,Nyamabuye village ,gahushyi village and kibimba village don't have access to Kibaya market, whereas Agatare village , isangano village and terimbere village don't have access to Gituku market",
  //       "education_access_blocked_by_river": "Kagarama village ,Nyamabuye village ,gahushyi village and kibimba village don't have access to GS Kibaya , whereas Agatare village , isangano village and terimbere village don't have access to GS Gituku",
  //       "health_access_blocked_by_river": "Kagarama village ,Nyamabuye village ,gahushyi village and kibimba village don't have access to Kibaya health center whereas Agatare village , isangano village and terimbere village don't have access to Gituku Health center",
  //       "other_access_blocked_by_river": "Kagarama village ,Nyamabuye village ,gahushyi village and kibimba village don't have access to Kibaya church, whereas Agatare village , isangano village and terimbere village don't have access to Gituku church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "1 injury",
  //       "notes_on_social_information": "Kagarama village leader is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma- Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuwKAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukibimba",
  //       "bridge_opportunity_project_code": "1014366",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.14135,
  //       "bridge_opportunity_gps_longitude": 30.49706,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9025,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14135,
  //       "proposed_bridge_location_gps_longitude": 30.49706,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 188,
  //       "flood_duration_during_rainy_season": "2 days full of water in the valley",
  //       "market_access_blocked_by_river": "Akagarama cell don't have access to Karembo market",
  //       "education_access_blocked_by_river": "Akagarama cell don't have access to GS Kansana",
  //       "health_access_blocked_by_river": "Akagarama cell don't have access to Gashanda health center",
  //       "other_access_blocked_by_river": "Akagarama cell don't have access to Gashanda church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident in this area , it is a valley which becomes full of water during the rain",
  //       "notes_on_social_information": "Mukibimba village leader is the one who provided information about directly individual served by the bridge by referring to population census 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuwPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagahandagaza",
  //       "bridge_opportunity_project_code": "1014367",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.1755,
  //       "bridge_opportunity_gps_longitude": 30.40085,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10440,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1755,
  //       "proposed_bridge_location_gps_longitude": 30.40085,
  //       "current_crossing_method": "People use cyperus papyrus fragment to cross the valley",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 231,
  //       "flood_duration_during_rainy_season": "4 days days of flood",
  //       "market_access_blocked_by_river": "Nyagatugunda cell don't have access to Sake market",
  //       "education_access_blocked_by_river": "Nyagatugunda cell don't have access to GS Sangaza",
  //       "health_access_blocked_by_river": "Nyagatugunda cell don't have access to Sangaza Health center",
  //       "other_access_blocked_by_river": "Nyagahandagaza cell don't have access to zaza Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One injury",
  //       "notes_on_social_information": "Ruhinga cell leader provided all info about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuwUAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagongoyi",
  //       "bridge_opportunity_project_code": "1014368",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.11144,
  //       "bridge_opportunity_gps_longitude": 30.46133,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12766,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11144,
  //       "proposed_bridge_location_gps_longitude": 30.46133,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 210,
  //       "flood_duration_during_rainy_season": "7 days of flood",
  //       "market_access_blocked_by_river": "Kivugangoma village , nyamiranbo village, gashekasheke village don't have access to Kigarama market whereas akabakanda village , kivugangoma village ,Kigarama village and rwaromba village don't have access to Karembo market",
  //       "education_access_blocked_by_river": "Kivugangoma village , nyamiranbo village, gashekasheke village don't have access to GS Kirwa whereas akabakanda village , kivugangoma village ,Kigarama village and rwaromba village don't have access to college Karembo",
  //       "health_access_blocked_by_river": "Kivugangoma village , nyamiranbo village, gashekasheke village don't have access to Kirwa health center whereas akabakanda village , kivugangoma village ,Kigarama village and rwaromba village don't have access to Karembo health center",
  //       "other_access_blocked_by_river": "Kivugangoma village , nyamiranbo village, gashekasheke village don't have access to Kigarama catholic church whereas akabakanda village , kivugangoma village ,Kigarama village and rwaromba village don't have access to zaza Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "cassava, maiz, potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "3 injuries across the river",
  //       "notes_on_social_information": "Akabakanda village leader provided info about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kirehe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 79,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuwZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatembo",
  //       "bridge_opportunity_project_code": "1014369",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.11637,
  //       "bridge_opportunity_gps_longitude": 30.46358,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12766,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11637,
  //       "proposed_bridge_location_gps_longitude": 30.46358,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 123,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Murambi village and Nyamirambo village don't have access to Kigarama market whereas Akabaganda village, ruhuha village, akabashumba village and Kigarama village don't have access to Karembo market",
  //       "education_access_blocked_by_river": "Murambi village and Nyamirambo village don't have access to GS Kirwa whereas Akabaganda village, ruhuha village, akabashumba village and Kigarama village don't have access to college Kabirizi",
  //       "health_access_blocked_by_river": "Murambi village and Nyamirambo village don't have access to kirwa health center whereas Akabaganda village, ruhuha village, akabashumba village and Kigarama village don't have access to Karembo health center",
  //       "other_access_blocked_by_river": "Murambi village and Nyamirambo village don't have access to Kigarama Catholic church whereas Akabaganda village, ruhuha village, akabashumba village and Kigarama village don't have access to Zaza Catholic church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two injuries during last heavy season",
  //       "notes_on_social_information": "Akabaganda village leader is the one who provided information about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kirehe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 62,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuweAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gikomero",
  //       "bridge_opportunity_project_code": "1014370",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.085,
  //       "bridge_opportunity_gps_longitude": 30.50046,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6450,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.085,
  //       "proposed_bridge_location_gps_longitude": 30.50046,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 85,
  //       "flood_duration_during_rainy_season": "2 hours of flood",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Gikomero village leader is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Local people only want vehicle bridge to be constructed",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuwjAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwa Gapfizi",
  //       "bridge_opportunity_project_code": "1014371",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.07431,
  //       "bridge_opportunity_gps_longitude": 30.48649,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 14418,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.07431,
  //       "proposed_bridge_location_gps_longitude": 30.48649,
  //       "current_crossing_method": "Timbers ( Two)",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 98,
  //       "flood_duration_during_rainy_season": "8 hours of flood",
  //       "market_access_blocked_by_river": "Ruhuha village and ruganda village xotm have access to kirwa market, whereas kumunini village, rugarika village, nyamigende village don't have access to ndekwe market",
  //       "education_access_blocked_by_river": "Ruhuha village and ruganda village xotm have access to Bs kirwa, whereas kumunini village, rugarika village, nyamigende village don't have access to Gs ndekwe",
  //       "health_access_blocked_by_river": "Ruhuha village and ruganda village xotm have access to kirwa health center , whereas kumunini village, rugarika village, nyamigende village don't have access to ndekwe health center",
  //       "other_access_blocked_by_river": "Ruhuha village and ruganda village xotm have access to kirwa church , whereas kumunini village, rugarika village, nyamigende village don't have access to ndekwe church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "1 injury across the river",
  //       "notes_on_social_information": "Kumunini village leader provided info about directly individual served by the bridge by referring to population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuwoAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanyarusanga",
  //       "bridge_opportunity_project_code": "1014373",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.15347,
  //       "bridge_opportunity_gps_longitude": 29.35955,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5748,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.15347,
  //       "proposed_bridge_location_gps_longitude": 29.35955,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, cassava",
  //       "primary_crops_grown": "cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45.4,
  //       "height_differential_between_banks": 0.1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuxmAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutovu",
  //       "bridge_opportunity_project_code": "1014377",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.095675,
  //       "bridge_opportunity_gps_longitude": 30.576452,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12720,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.095675,
  //       "proposed_bridge_location_gps_longitude": 30.576452,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "10times March, April and May and it lasts for 5days after rainfall",
  //       "market_access_blocked_by_river": "Gatonde cell doesn't have access to Remera market Nyakanazi cell doesn't have access to Remera market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Umurenge Sacco financial services",
  //       "primary_occupations": "Farming of Rice farm, beans",
  //       "primary_crops_grown": "bean, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 71.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuyBAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwamihuro",
  //       "bridge_opportunity_project_code": "1014378",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.103568,
  //       "bridge_opportunity_gps_longitude": 30.57552,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8714,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.103568,
  //       "proposed_bridge_location_gps_longitude": 30.57552,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "20times In March, April and May and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Gatonde cell doesn't have access to Kibungo market",
  //       "education_access_blocked_by_river": "Gahima cell doesn't have access to Gatonde Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Gahima cell doesn't have access to Gatonde health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice farming, banana plantation",
  //       "primary_crops_grown": "banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuyGAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Misange",
  //       "bridge_opportunity_project_code": "1014379",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.0921133,
  //       "bridge_opportunity_gps_longitude": 30.585332,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8628,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.0921133,
  //       "proposed_bridge_location_gps_longitude": 30.585332,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "30 times in March, April and May and it lasts for 3days",
  //       "market_access_blocked_by_river": "Gatonde cell doesn't have access to Kabarondo market Nyakanazi cell doesn't have access to Kibungo market",
  //       "education_access_blocked_by_river": "Nyakanazi cell doesn't have access to Rubona Primary and Secondary school",
  //       "health_access_blocked_by_river": "Nyakanazi cell doesn't have access to Gatonde health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of banana, sweet potatoes, maize, beans",
  //       "primary_crops_grown": "banana, bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 43.2,
  //       "height_differential_between_banks": 1.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuyLAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagumiro",
  //       "bridge_opportunity_project_code": "1014380",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.107592,
  //       "bridge_opportunity_gps_longitude": 30.609893,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10222,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.107592,
  //       "proposed_bridge_location_gps_longitude": 30.609893,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "10times in March, April, May and it last for 7days after rainfall",
  //       "market_access_blocked_by_river": "Gatonde cell doesn't have access to Kiyonza market",
  //       "education_access_blocked_by_river": "Gatonde cell doesn't have access to Rubimba Primary school",
  //       "health_access_blocked_by_river": "Gitara cell doesn't have access to Rubona health center",
  //       "other_access_blocked_by_river": "Church, Mosque",
  //       "primary_occupations": "Farming of sweet potatoes, beans, maize",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "4hours with a motorcycle",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33.4,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuyfAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabimba",
  //       "bridge_opportunity_project_code": "1014381",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.165545,
  //       "bridge_opportunity_gps_longitude": 30.549758,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 14274,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.165545,
  //       "proposed_bridge_location_gps_longitude": 30.549758,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "25times in April, May, October November and December and it lasts 3days after rainfall",
  //       "market_access_blocked_by_river": "Mahango cell doesn't have access to Kibungo market Mvumba cell doesn't have access to Kibungo market",
  //       "education_access_blocked_by_river": "Cyasemakamba cell doesn't have access to Mvumba Primary and Secondary schools Mvumba, Mahango cells don't have access to Kibungo A Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Mvumba, Mahango cells don't have access to Kibungo health center Mvumba, Mahango cells don't have access to Kibungo Referral Hospital",
  //       "other_access_blocked_by_river": "District office",
  //       "primary_occupations": "Farming of fruits, legumes, cassava, sweet potatoes",
  //       "primary_crops_grown": "cassava, legum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 42.8,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuykAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Marembo",
  //       "bridge_opportunity_project_code": "1014382",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.160985,
  //       "bridge_opportunity_gps_longitude": 30.551312,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10352,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.160985,
  //       "proposed_bridge_location_gps_longitude": 30.551312,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "15times in March, April and May and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Mahango cell doesn't have access to Kibungo market",
  //       "education_access_blocked_by_river": "Mahango cell doesn't have access to Kibungo Primary and Secondary school",
  //       "health_access_blocked_by_river": "Mahango cell doesn't have access to Kibungo health center mahango cell doesn't have access to Kibungo Referral Hospital",
  //       "other_access_blocked_by_river": "District office",
  //       "primary_occupations": "Fish farm, fruits farm, beans, banana",
  //       "primary_crops_grown": "banana, bean, fruit",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": 2.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuypAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabeza",
  //       "bridge_opportunity_project_code": "1014383",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.144405,
  //       "bridge_opportunity_gps_longitude": 30.531062,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12153,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.144405,
  //       "proposed_bridge_location_gps_longitude": 30.531062,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 84,
  //       "flood_duration_during_rainy_season": "28times in March, April, May and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Musya cell doesn't have access to Kibungo market Karenge cell doesn't Nteko market",
  //       "education_access_blocked_by_river": "Musya cell doesn't have access to Kabeza primary and secondary school",
  //       "health_access_blocked_by_river": "Musya cell doesn't have access to Kibungo health center and Referral Hospital",
  //       "other_access_blocked_by_river": "District office",
  //       "primary_occupations": "Farming of sweet potatoes, legumes, cassava",
  //       "primary_crops_grown": "cassava, legum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58.8,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuyuAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwasaburo",
  //       "bridge_opportunity_project_code": "1014384",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.157735,
  //       "bridge_opportunity_gps_longitude": 30.532793,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12153,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.157735,
  //       "proposed_bridge_location_gps_longitude": 30.532793,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 84,
  //       "flood_duration_during_rainy_season": "28times in March, April, May and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Musya Cell doesn't have access to Kibungo market Karenge cell doesn't have access to Rwarusaburo local center",
  //       "education_access_blocked_by_river": "Musya cell doesn't have access to Kabeza primary and secondary school",
  //       "health_access_blocked_by_river": "Musya cell doesn't have access to Kibungo health center and Referral Hospital",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming of sweet potatoes, banana, legumes,",
  //       "primary_crops_grown": "banana, legum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They slipped on trees and fall down in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuyzAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akabaya",
  //       "bridge_opportunity_project_code": "1014385",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.181385,
  //       "bridge_opportunity_gps_longitude": 30.479072,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7450,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.181385,
  //       "proposed_bridge_location_gps_longitude": 30.479072,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "20times in March, April, May, October November and December and it lasts 3days after rainfall",
  //       "market_access_blocked_by_river": "Umukamba cell doesn't have access to Kibimba market Umukamba cell doesn't have access to Local brick factory",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Munege Cell doesn't have access to Kibungo Referral Hospital",
  //       "other_access_blocked_by_river": "District office",
  //       "primary_occupations": "Large rice plantation, banana",
  //       "primary_crops_grown": "banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuz4AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Isangano",
  //       "bridge_opportunity_project_code": "1014387",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.39413,
  //       "bridge_opportunity_gps_longitude": 30.28182,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3683,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.39413,
  //       "proposed_bridge_location_gps_longitude": 30.28182,
  //       "current_crossing_method": "Bridge in steel",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Communities 4,5 don't have access to Rukomo market, communities1,2,3 don't have access to Gakirage market, communities 1,2,3 don't have access to Rice plantation farms .",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to Rukomo primary and secondary school",
  //       "health_access_blocked_by_river": "Communities1,2,3 don't have access to Nyagatare health center",
  //       "other_access_blocked_by_river": "Communities 4,5 don't have access to kabeza protestant church",
  //       "primary_occupations": "Farmers on both side and traders at Gakirage and Rukoma markets",
  //       "primary_crops_grown": "bean, maiz, rice plantation farm, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One person fell into the river",
  //       "notes_on_social_information": "Rukomo market which is open twice a week ( Community 4,5 ); Gakirage market which is open weekly ( Community 1,2,3); Rice plantation farms ( Community 1,2,3); Rukomo primary and secondary school ( Community 4,5); Nyagatare health center ( Community 1,2,3); Kabeza protestant church ( Community 4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50.4,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuzEAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagarama",
  //       "bridge_opportunity_project_code": "1014388",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.186622,
  //       "bridge_opportunity_gps_longitude": 30.483668,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4146,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.186622,
  //       "proposed_bridge_location_gps_longitude": 30.483668,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "When flooded it can last up to 30days without crossing!! But in normal rain, for people to cross again they can wait 5hours after rainfall",
  //       "market_access_blocked_by_river": "Akabaya village (Umukamba cell) doesn't have access to COWABIK warehouse Umukamba cell doesn't have access to Kibimba Market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Umukamba cell doesn't have access to Gashanda health center Akabaya village (Umukamba cell) doesn't have access to Birenga health center",
  //       "other_access_blocked_by_river": "District office",
  //       "primary_occupations": "Large maize plantation, cassava, beans",
  //       "primary_crops_grown": "bean, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuzJAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabeza",
  //       "bridge_opportunity_project_code": "1014389",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.36432,
  //       "bridge_opportunity_gps_longitude": 30.28194,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3293,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.36432,
  //       "proposed_bridge_location_gps_longitude": 30.28194,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "2days",
  //       "market_access_blocked_by_river": "Communities 1,2 3 don't have access to Rurenge and Gakirage markets and 4,5 don't have access to Rukoma market.",
  //       "education_access_blocked_by_river": "Communities 4,5 don't have access to Rukoma primary and secondary school and 1,2,3 don't have access to Rurenge primary and secondary",
  //       "health_access_blocked_by_river": "Communities1,2,3 don't have access to to Rurenge health center",
  //       "other_access_blocked_by_river": "Communities 4,5 don't have access to Rukomo sector office and Kabeza protestant church and 1,2,3 don't have access to Adventists church in Rurengeri.",
  //       "primary_occupations": "Rice Farmers, traders at Rurenge, Gakirage and Rukomo markets",
  //       "primary_crops_grown": "bean, maiz, ric, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rukomo market which is open twice a week ( Community 4,5), Gakirage and Rurenge market( community 1,2 3), Rice farms on both side, Rukomo school( community 4,5) and Rurenge primary and secondary school( community 1,2,3).Rurenge health center ( Community 1,2,3), sector and SACCO and Protestants church ( 4,5), Adventist of Seven days church ( Community 1,2,3). This crossing will especially help motorcycles to cross the river Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuzOAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akimpundu",
  //       "bridge_opportunity_project_code": "1014390",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.340982,
  //       "bridge_opportunity_gps_longitude": 30.219604,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 14036,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.340982,
  //       "proposed_bridge_location_gps_longitude": 30.219604,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Rice plantation farms ,Rukomo and Gafaru markets",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Runyinya primary and secondary school and communities 2 don't have access to Gikundamvura primary school",
  //       "health_access_blocked_by_river": "Communities 2,4 don't have access to Kabuga health center and communities 2 don't have access to to Gikundamvura health Post",
  //       "other_access_blocked_by_river": "Communities don't have access to Runyinya Catholic church and communities 2 don't have access to Gikundamvura cell office",
  //       "primary_occupations": "Farmers ( Rice&Bananas), Traders at Rukomo , kabuga and Gafaru markets",
  //       "primary_crops_grown": "banana, bean, maiz, rice plantation",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Almost Four people fell into the river but fortunately none died only to some their shoes and luggage were taken away by the river",
  //       "notes_on_social_information": "Rice plantation farms on both side, Rukomo and Gafaru markets which are open weekly ( Community 1,2,3); Kabuga market ( Community 2,4); Runyinya primary and secondary school ( Community 1,2,3); Gikundamvura primary school ( Community 2);Kabuga health center ( Community 2,4); Gikundamvura health Post ( Community 2); Runyinya Catholic church ( Community 1,2,3); Gikundamvura cell office ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuzTAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagasharara",
  //       "bridge_opportunity_project_code": "1014391",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.336893,
  //       "bridge_opportunity_gps_longitude": 30.213863,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 14036,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.336893,
  //       "proposed_bridge_location_gps_longitude": 30.213863,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 47,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Rice plantation farms , communities 1,2,3 don't have access to Rukomo and Gafaru market ; Communities 1,2 don't have access to Kabuga market ;",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Runyinya primary and secondary school and communities 1 and a part of community 2 don't have access to Gikundamvura primary school",
  //       "health_access_blocked_by_river": "Communities 2,4 don't have access to Kabuga health center",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to Runyinya Catholic church",
  //       "primary_occupations": "Rice Farmers on large scale, Traders at Rukomo, Gafaru and Kabuga markets",
  //       "primary_crops_grown": "banana, bean, maiz, rice plantation farm",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "Almost 5 people fell into the river but fortunately none died. Only to some their shoes and luggage were taken away by the river",
  //       "notes_on_social_information": "Rukomo and Gafaru markets which are open weekly ( Community 1,2 3); Kabuga market which is open twice a week ( Community 2 ,4) ; Rice farms blocked on both sides ; Runyinya primary and secondary school ( Community 1,2,3), Gikundamvura primary school ( Community 2); Kabuga health center ( Community 2,4); Runyinya Catholic church ( Community 1,2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 70,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuzYAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murujanjara",
  //       "bridge_opportunity_project_code": "1014392",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.393255,
  //       "bridge_opportunity_gps_longitude": 30.162868,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1942,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.393255,
  //       "proposed_bridge_location_gps_longitude": 30.162868,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2.5 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1hour",
  //       "market_access_blocked_by_river": "Communities3,4 don't have access to Buguma and Karama markets and Nyakiga diary",
  //       "education_access_blocked_by_river": "Communities 3,4 don't have access to Mutumba primary and secondary school, communities 1,2 don't have access to Gikagati Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 3,4don't have access to Nyarurema health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Churches services on both sides",
  //       "primary_occupations": "Farmers and Traders at Buguma and Karama markets",
  //       "primary_crops_grown": "banana, bean, livestock ( cattle ), maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Buguma and Karama market which is open twice a week ( Community 3,4), Nyakiga Dairy/milk collection zone (Community 3,4 ), Mutumba primary and secondary school ( Community 3,4), Gikagati Primary and secondary school ( Community 1,2), Nyarurema health center ( Community1,2 ). This crossing will especially help motorcycles to cross. Population information for each village was provided Muhindakazi Daria , Nyakiga cell leader and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuzdAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Isangano-Kabeza",
  //       "bridge_opportunity_project_code": "1014393",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.349094,
  //       "bridge_opportunity_gps_longitude": 30.202762,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4604,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.349094,
  //       "proposed_bridge_location_gps_longitude": 30.202762,
  //       "current_crossing_method": "Bridge in timber ( 2 small logs )",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Both Communities don't have access to Rice Farms , Communities 4,5 don't have access to Rukomo and Bushari market",
  //       "education_access_blocked_by_river": "Communities1,2,3 don't have access to Bushari primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3 don't have access to Bushari health center",
  //       "other_access_blocked_by_river": "Communities 4,5 don't have access to Protestants, Anglican, Adventist of Seven days and Runyinya Parish",
  //       "primary_occupations": "Rice Farmers, Traders at Rukomo and Bushari market",
  //       "primary_crops_grown": "bean, livestock ( cattle ), maiz, ric, vegetables ( cabbages )",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rice plantation farms on both side, Rukomo and Bushari market ( Community 4,5); Bushari primary and secondary school ( Community 1,2,3); Bushari health center ( Community 1,2,3); Communities 4,5 don't have access to Protestants, Anglican, Adventist of Seven days and Runyinya Catholic Parish Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuziAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabeza",
  //       "bridge_opportunity_project_code": "1014394",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.40815,
  //       "bridge_opportunity_gps_longitude": 30.189856,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2054,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.40815,
  //       "proposed_bridge_location_gps_longitude": 30.189856,
  //       "current_crossing_method": "Small logs in timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Both community don't have access to Rice plantation farms on one side, Communities 2 don't have access to Buguma market",
  //       "education_access_blocked_by_river": "Communities1 don't have access to Rwesheke Primary school and Rwebare secondary school",
  //       "health_access_blocked_by_river": "Communities 2don't have access to Nyarurema health center",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to Churches services , Gatunda sector office and Gatunda Saving and Credit cooperative",
  //       "primary_occupations": "Rice Farmers , Traders at Buguma markets",
  //       "primary_crops_grown": "bean, maiz, rice plantation farm, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rice plantation farms on either side ; Buguma market ( Community ); Rwebare secondary school ( Community ); Rwesheke Primary school ( Community ); Nyarurema health center ( Community ), Gatunda sector office and Gatunda Saving and Credit cooperative Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018. This crossing will mostly serve those riding bikes and motorcycles because are the ones with diffults to cross during rain season",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuznAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabwongoroka",
  //       "bridge_opportunity_project_code": "1014395",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.432879,
  //       "bridge_opportunity_gps_longitude": 30.133993,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1076,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.432879,
  //       "proposed_bridge_location_gps_longitude": 30.133993,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 1,2 don't have access to Karujumba markets",
  //       "education_access_blocked_by_river": "Communities1,2 don't have access to Kabare II primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2 don't have access to Condo health center",
  //       "other_access_blocked_by_river": "Communities 1,2 don't have access to Kabare Catholic church",
  //       "primary_occupations": "Farmers and traders at Karujumba market",
  //       "primary_crops_grown": "beans maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Three people were injured when trying to cross the river fortunately none died , but two were seriously injured",
  //       "notes_on_social_information": "Karujumba markets ( Community 1,2); Kabare II Primary and secondary school ( Community 1,2); Cyondo Health center ( Community 1,2); Kabare Catholic church ( Community 1,2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 46,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuzsAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kavumu",
  //       "bridge_opportunity_project_code": "1014396",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.391233,
  //       "bridge_opportunity_gps_longitude": 30.171654,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1942,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.391233,
  //       "proposed_bridge_location_gps_longitude": 30.171654,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 3,4don't have access to Buguma and Karama markets and Nyakiga Dairy",
  //       "education_access_blocked_by_river": "Communities 3,4don't have access to Mutumba primary and secondary , communities 1,2 don't have access to Gikagati Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 3,4 don't have access to Nyarurema health center",
  //       "other_access_blocked_by_river": "Communities don't have access churches on both sides",
  //       "primary_occupations": "Farmers on both side and traders at Buguma And Karama markets",
  //       "primary_crops_grown": "banana, bean, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Karama and Buguma markets which are open weekly ( Community 3,4), Nyakiga Dairy/milk collection zone ( Community 3,4), Mutumba primary and secondary school ( Community 3,4), Gikagati Primary and secondary school ( Community 1,2). This crossing will especially help motorcycles to cross. Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eeuzxAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabaya",
  //       "bridge_opportunity_project_code": "1014397",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.436156,
  //       "bridge_opportunity_gps_longitude": 30.307663,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1405,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.436156,
  //       "proposed_bridge_location_gps_longitude": 30.307663,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "2days",
  //       "market_access_blocked_by_river": "Communities 1,2don't have access to Mimuli markets and Rice plantation farms, communities 3 don't have access to Nyakigondo Market",
  //       "education_access_blocked_by_river": "Communities1,2 don't have access to Rutoma primary and secondary school and communities 3 don't have access to Nyakigondo secondary school",
  //       "health_access_blocked_by_river": "Communities 3 don't have access to Nyakigondo health center",
  //       "other_access_blocked_by_river": "Communities1,2 don't have access to Anglican church and communities 3 don't have access to Katabagema sector office",
  //       "primary_occupations": "Rice Farmers and local farmers,",
  //       "primary_crops_grown": "bean, maiz, rice plantation, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Mimuli market which is open every week( communities 1,2), Nyakigondo market ( Community 3); Rice plantations farms on both side; Nyakigondo secondary school ( Community 3); Rutoma primary and secondary school ( Community 1,2); Nyakigondo Health center ( Community3 ); Katabagemu Saving and Credit cooperative and sector office ( Community 3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Planing to extend the road by January 2019 and communities needs a vehicular bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev02AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kajevuba",
  //       "bridge_opportunity_project_code": "1014398",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.442804,
  //       "bridge_opportunity_gps_longitude": 30.274319,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.442804,
  //       "proposed_bridge_location_gps_longitude": 30.274319,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Communities needs a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev07AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagogo",
  //       "bridge_opportunity_project_code": "1014399",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.471113,
  //       "bridge_opportunity_gps_longitude": 30.285693,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.471113,
  //       "proposed_bridge_location_gps_longitude": 30.285693,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehecular bridge , need maintenance",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0CAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akindege",
  //       "bridge_opportunity_project_code": "1014400",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.461997,
  //       "bridge_opportunity_gps_longitude": 30.264872,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7353,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.461997,
  //       "proposed_bridge_location_gps_longitude": 30.264872,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "2 day",
  //       "market_access_blocked_by_river": "Communities 1 don't have access to Mimuli markets and Rice farms on both side",
  //       "education_access_blocked_by_river": "Communities 1don't have access to Mimuli secondary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Katabagemu health center",
  //       "other_access_blocked_by_river": "Communities1 don't have access to Mimuli Catholic and communities 2 don't have access to Protestants and Adventist of Seven days church",
  //       "primary_occupations": "Rice plantation farms and local farmers, traders at Mimuli market",
  //       "primary_crops_grown": "bean, livestock ( cattle ), maiz, rice plantation, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Mimuli market ( Community 1); Rice plantation farms on both side ; Mimuli secondary school ( Community 1); Katabagemu Health center ( Community 2 ); Mimuli Catholic church ( Community 1); Katabagemu Protestants and Adventist of Seven days church ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0HAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasasa",
  //       "bridge_opportunity_project_code": "1014401",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.456525,
  //       "bridge_opportunity_gps_longitude": 30.280659,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.456525,
  //       "proposed_bridge_location_gps_longitude": 30.280659,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Communities needs a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0RAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Byimana",
  //       "bridge_opportunity_project_code": "1014402",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.066787,
  //       "bridge_opportunity_gps_longitude": 30.432849,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.066787,
  //       "proposed_bridge_location_gps_longitude": 30.432849,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is road drainage channel that's get widened and it is in the junction of two roads",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0WAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Fotorero",
  //       "bridge_opportunity_project_code": "1014404",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.163172,
  //       "bridge_opportunity_gps_longitude": 30.476046,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9631,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.163172,
  //       "proposed_bridge_location_gps_longitude": 30.476046,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 31,
  //       "flood_duration_during_rainy_season": "1hour",
  //       "market_access_blocked_by_river": "Communities4,5 don't have access to Farms and Pastures on both sides and communities 1,2,3 don't have access to Rwimiyaga market",
  //       "education_access_blocked_by_river": "Communities1,2,3 don't have access to Bwera primary school",
  //       "health_access_blocked_by_river": "Communities1,2 3 don't have access to Rwimiyaga health center",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to Rutungu cell office, Rwimiyaga sector office and Rwimiyaga Saving and Credit cooperative ( SACCO)",
  //       "primary_occupations": "Farmers (crops and livestock on large scale);",
  //       "primary_crops_grown": "bean, livestock ( cattle ); crops: maiz, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Farms and Pastures , Rwimiyaga market which is open weekly ( Community 1,2,3); Bwera Primary school ( Community 1,2,3); Rwimiyaga health center ( Community 1,2,3); Rutungu cell office, Rwimiyaga sector office and SACCO head quarter ( Community1,2 3 ). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0gAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyenjojo",
  //       "bridge_opportunity_project_code": "1014405",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.239774,
  //       "bridge_opportunity_gps_longitude": 30.344471,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6055,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.239774,
  //       "proposed_bridge_location_gps_longitude": 30.344471,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "7 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Rice plantation farms and store , communities 1 don't have access to Kabare and Rwimiyaga market.",
  //       "education_access_blocked_by_river": "Communities 2 don't have access to Rwempasha primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Rwempasha health center",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to Rwempasha sector office",
  //       "primary_occupations": "Rice Farmers on large scale and cattle keepers",
  //       "primary_crops_grown": "beans ;livestock ( cattle ), maiz, rice plantation farm",
  //       "river_crossing_deaths_in_last_3_years": 4,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Almost Four people fell into the river and drowned trying to cross the river using trees",
  //       "notes_on_social_information": "Rice plantation farms and store ( Community 2), Kabare and Rwimiyaga market which are open weekly( community 1); Rwempasha primary and secondary school ( Community 2); Rwempasha sector office ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0lAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akagera",
  //       "bridge_opportunity_project_code": "1014407",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.286986,
  //       "bridge_opportunity_gps_longitude": 30.550523,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1820,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.286986,
  //       "proposed_bridge_location_gps_longitude": 30.550523,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "Never",
  //       "market_access_blocked_by_river": "Communities 1,2 don't have access to Farms and Pastures and Rwimiyaga market",
  //       "education_access_blocked_by_river": "Communities1 don't have access to Karushuga primary school and Gatebe secondary school and communities 1,2 don't have access to Akagera Nursery school",
  //       "health_access_blocked_by_river": "Communities 1 don't have access to Karushuga health Post",
  //       "other_access_blocked_by_river": "Communities1 don't have access to Karushuga cell office and Rwimiyaga sector",
  //       "primary_occupations": "Farmers (crops and livestock)",
  //       "primary_crops_grown": "bean, livestock ( cattle ), maiz, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Three people fell in the channel and died due to slipping logs.",
  //       "notes_on_social_information": "Farms and Pastures ( Community 1), Rwimiyaga market ( Community 1) ; Karushuga primary and Gatebe secondary school ( Community 1); Akagera Nursery school ( Community 1,2); Karushuga health Post ( Community 1), Rwimiyaga health center ( Community 1). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev0vAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakagezi",
  //       "bridge_opportunity_project_code": "1014408",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.229162,
  //       "bridge_opportunity_gps_longitude": 30.514947,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 15602,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.229162,
  //       "proposed_bridge_location_gps_longitude": 30.514947,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "25times in March, April, May, October November and December and it lasts 2days after rainfall",
  //       "market_access_blocked_by_river": "Gahurire cell doesn't have access to Kazo market Gahurire cell doesn't have access to Mutenderi market",
  //       "education_access_blocked_by_river": "Kinyonzo cell doesn't have access to Rugenge primary school",
  //       "health_access_blocked_by_river": "Gahurire cell doesn't have access to Kazo health post",
  //       "other_access_blocked_by_river": "Church",
  //       "primary_occupations": "Farming of rice, sweet potatoes, cassava, banana",
  //       "primary_crops_grown": "banana, cassava, ric, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 59.8,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev10AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bitaba",
  //       "bridge_opportunity_project_code": "1014409",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.530688,
  //       "bridge_opportunity_gps_longitude": 30.210441,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5779,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.530688,
  //       "proposed_bridge_location_gps_longitude": 30.210441,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "Never",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Ngarama market",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Karama secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3don't have access to Ngarama health center and Nyamikamba health Post",
  //       "other_access_blocked_by_river": "Communities 4,5 don't have access to Anglican church , communities 1,2,3 don't have access to Nyagihinga sector office",
  //       "primary_occupations": "Farmers on both side and traders at Ngarama market",
  //       "primary_crops_grown": "bean, maiz, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ngarama market which is open weekly ( Community 1,2,3 ), Farmers on both side, Karama primary and secondary school ( Community1,2,3 ); Ngarama health center and Nyamikamba health Post (Community 1,2,3); Nyagihinga sector office ( Community 1,2,3). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev15AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kadogo",
  //       "bridge_opportunity_project_code": "1014410",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.660292,
  //       "bridge_opportunity_gps_longitude": 30.461698,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.660292,
  //       "proposed_bridge_location_gps_longitude": 30.461698,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "This is a small with a bridge at the junction with the main earth road and no other alternative",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1AAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisharara",
  //       "bridge_opportunity_project_code": "1014411",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.633869,
  //       "bridge_opportunity_gps_longitude": 30.338833,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5381,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.633869,
  //       "proposed_bridge_location_gps_longitude": 30.338833,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "1hour",
  //       "market_access_blocked_by_river": "Communities don't have access to 1 Rwagitima and Kinteko markets and communities 2 don't have access to Karubungo market , communities don't have access to farms",
  //       "education_access_blocked_by_river": "Communities 1don't have access to Nyamirama primary and secondary school",
  //       "health_access_blocked_by_river": "Communities don't have access to Karubungo health center and Pharmacy",
  //       "other_access_blocked_by_river": "Communities don't have access to Churches",
  //       "primary_occupations": "Farmers and traders at Rwagitima, Kinteko and Karubungo market",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rwagitima and Kinteko markets which are open weekly ( Community 1) and Karubungo market which is open weekly ( Community 2); Nyamirama primary and secondary school ( Community 2); Karubungo health center and Pharmacy ( Community 2); Farms( bananas) . Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1FAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kivuba",
  //       "bridge_opportunity_project_code": "1014412",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.684211,
  //       "bridge_opportunity_gps_longitude": 30.350028,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5838,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.684211,
  //       "proposed_bridge_location_gps_longitude": 30.350028,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 96,
  //       "flood_duration_during_rainy_season": "5 hours",
  //       "market_access_blocked_by_river": "Communities 2 don't have access to Mugera market and communities 1 don't have access to Gikoma market;",
  //       "education_access_blocked_by_river": "Communities 1 don't have access to Remera Primary and Nyagasiga Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 2 don't have access to Cyabusheshe and Humure Health Post",
  //       "other_access_blocked_by_river": "Communities 2 don't have access to Churches services",
  //       "primary_occupations": "Farmers and traders Mugera and Gikoma markets",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Four people were injured when trying to cross the river",
  //       "notes_on_social_information": "Mugera market which is open weekly ( Community 2); Gikoma market which is open weekly ( Community 1); Cyabusheshe primary and secondary school ( Community 2); and Remera Primary and Nyagasiga secondary school ( Community 1); Cyabusheshe Health Post ( Community 2); Protestants church ( Community 2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1KAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Byimana",
  //       "bridge_opportunity_project_code": "1014413",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.658066,
  //       "bridge_opportunity_gps_longitude": 30.462945,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.658066,
  //       "proposed_bridge_location_gps_longitude": 30.462945,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Small Pond of water in a junction of two small pathways",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1PAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagacyamo",
  //       "bridge_opportunity_project_code": "1014414",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.6296,
  //       "bridge_opportunity_gps_longitude": 30.343077,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3242,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.6296,
  //       "proposed_bridge_location_gps_longitude": 30.343077,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Kinteko, Kabarore and Rwagitima markets, communities 4,5 don't have access to Karubungu market and farms",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Communities 4,5 don't have access to Karubungu health Post and Pharmacy",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers and traders at Kinteko, Kabarore and Rwagitima markets",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Four motorcycle drivers fell down in water",
  //       "notes_on_social_information": "Kinteko, Kabarore and Rwagitima markets which are open weekly ( Community 1,2,3); Karubungu market which is open twice a week ( Community 4,5 ); Karubungu health Post and Pharmacy ( Community 4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1UAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Matereza",
  //       "bridge_opportunity_project_code": "1014415",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.36087,
  //       "bridge_opportunity_gps_longitude": 30.181669,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6782,
  //       "bridge_opportunity_comments": "ARK set stage as REJECTED due to an active upstream project involving an extensive dam for irrigation control. This will no doubt impact the river and potential river migration and we should hold off on progress until more understanding of the dam design and implementation is understood.",
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.36087,
  //       "proposed_bridge_location_gps_longitude": 30.181669,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 87,
  //       "flood_duration_during_rainy_season": "3 days",
  //       "market_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Kabuga and Gikoba markets , communities 5 don't have access to Karama and Buguma markets , communities don't have access to farms on both side",
  //       "education_access_blocked_by_river": "Communities 5 don't have access to Ndego and Gikagati Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Kabuga health center",
  //       "other_access_blocked_by_river": "Communities 5 don't have access to Karama sector office and Karama police station",
  //       "primary_occupations": "Local Farmers ,Traders at Karama, kabuga and Buguma market",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 7,
  //       "incident_descriptions": "Seven people fell into the river but fortunately none died",
  //       "notes_on_social_information": "Kabuga and Gikoba markets which are open weekly ( Community 1,2,3,4), Karama and Buguma markets which are open weekly ( Community 5), Ndego and Gikagati Primary and secondary school ( Community 5), kabuga health center ( Community 1,2,3,4), Karama sector office, police station and SACCO ( Community 5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 64,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1ZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakirage",
  //       "bridge_opportunity_project_code": "1014416",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.365045,
  //       "bridge_opportunity_gps_longitude": 30.148672,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2813,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.365045,
  //       "proposed_bridge_location_gps_longitude": 30.148672,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 48,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 1 don't have access to Kabuga and Gikoba markets, communities 2,3,4,5 don't have access to Karama and Buguma markets",
  //       "education_access_blocked_by_river": "Communities 1don't have access to Ndego and and communities 2,3,4,5 don't have access to Gikagati Primary and secondary school",
  //       "health_access_blocked_by_river": "Communities1 don't have access to Kabuga health center",
  //       "other_access_blocked_by_river": "Communities2,3,4,5 don't have access to a road connecting to Uganda and, communities 2 3,4,5 don't have access to Karama SACCO, sector and police station office",
  //       "primary_occupations": "Farmers and traders at Kabuga, Gikoba, Buguma and Karama markets",
  //       "primary_crops_grown": "banana, bean, cattl, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One person fell into the river but fortunately none died",
  //       "notes_on_social_information": "Kabuga and Gikoba market which are open weekly ( Community 1), Karama and Buguma markets which are open weekly ( Community 2,3,4,5), Ndego Primary and secondary school ( Community1 ), Gikagati Primary and secondary ( Community2,3,4,5 ), Kabuga health center ( Community 1), Karama SACCO, sector and police station office , Road to Uganda ( Community 2,3,4,5). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1eAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murujanjara",
  //       "bridge_opportunity_project_code": "1014417",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.397253,
  //       "bridge_opportunity_gps_longitude": 30.163373,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2898,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.397253,
  //       "proposed_bridge_location_gps_longitude": 30.163373,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 5 don't have access to Karama market, communities 1,2,3,4 don't have access to Buguma market , communities5 don't have access to Nyakiga diary z( milk collection zone ),",
  //       "education_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Mutumba primary and secondary school, communities 5 don't have access to Gikagati Primary and secondary",
  //       "health_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Nyarurema health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers and traders at Karama and Buguma markets",
  //       "primary_crops_grown": "banana, bean, livestock ( cattle ), maize vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Karama market which is open weekly ( Community5 ), Buguma market ( Community1,2,3,4 ), Nyakiga diary ( Community 5), Mutumba primary and secondary school ( Community 1,2,3,4 ), Gikagati Primary and secondary school ( Community 5 ), Nyarurema health center ( Community1,2,3,4 ). Population information for each village was provided by Muhindakazi Daria, Nyakiga cell leader population information was sourced from village census data collected in October 2018",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 52,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1jAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bwicaro",
  //       "bridge_opportunity_project_code": "1014418",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.564462,
  //       "bridge_opportunity_gps_longitude": 30.194624,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.564462,
  //       "proposed_bridge_location_gps_longitude": 30.194624,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Communities need a vehecular bridge and Currently, it is being used by light weight vehicles",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1oAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigobe",
  //       "bridge_opportunity_project_code": "1014419",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.576221,
  //       "bridge_opportunity_gps_longitude": 30.201582,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3740,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.576221,
  //       "proposed_bridge_location_gps_longitude": 30.201582,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "Vehecular bridge in timber",
  //       "days_per_year_river_is_flooded": 61,
  //       "flood_duration_during_rainy_season": "Never",
  //       "market_access_blocked_by_river": "Communities don't have access to Shyondo, Ngarama and Nyangihanga markets",
  //       "education_access_blocked_by_river": "Communities don't have access to Kagera primary and secondary school , Gatsibo and Nyagahanga secondary school",
  //       "health_access_blocked_by_river": "Communities don't have access to Shyondo health Post",
  //       "other_access_blocked_by_river": "Communities don't have access to Churches services",
  //       "primary_occupations": "Farmers on both side and traders Shyondo, Ngarama and Nyagahanga markets",
  //       "primary_crops_grown": "ana, b, bean, coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Almost three people fell into the river",
  //       "notes_on_social_information": "The proposed bridge is within Nyamirama cell and the communities are blocked through their fourth and back movements . Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018 .",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1tAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakiri",
  //       "bridge_opportunity_project_code": "1014420",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.629849,
  //       "bridge_opportunity_gps_longitude": 30.379612,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8255,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.629849,
  //       "proposed_bridge_location_gps_longitude": 30.379612,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "4 hour",
  //       "market_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Kabarore market",
  //       "education_access_blocked_by_river": "Communities don't have access to 1,2,3,4 don't have access to Kabarore TVET school and Buhinga primary and secondary school, communities 5 don't have access to Gakiri primary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Kabarore health center",
  //       "other_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Kabarore Bus station",
  //       "primary_occupations": "Farmers, workers in Kabarore center ( AGAKIRIRO) and Traders Kabarore market",
  //       "primary_crops_grown": "banana, bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kabarore market which open every day ( Community 1,2,3,4); Kabarore business center/AGAKIRIRO( Community 1,2,3,4); Kabarore TVET school and Buhinga primary and secondary ( Community 1,2,3,4); Gakiri primary school ( Community 5); Kabarore Bus station ( Community 1,2,3,4). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Road is blocked during rain season , but currently is used by vehicles",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev1yAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugenge",
  //       "bridge_opportunity_project_code": "1014421",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.234163,
  //       "bridge_opportunity_gps_longitude": 30.513445,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11799,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.234163,
  //       "proposed_bridge_location_gps_longitude": 30.513445,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "20times in March, April, May, October November and December and it lasts 3days after rainfall",
  //       "market_access_blocked_by_river": "Gahuriro Cell doesn't have access to Mutenderi market Gahuriro Cell doesn't have access to Kazo market",
  //       "education_access_blocked_by_river": "Kiyonzo cell doesn't have access to Rugenge Primary school",
  //       "health_access_blocked_by_river": "gahuriro, Kiyonzo cell don't have access to Kazo health Post",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming of sweet potatoes, banana, beans",
  //       "primary_crops_grown": "banana, bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30.8,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev28AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibimba",
  //       "bridge_opportunity_project_code": "1014422",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.238133,
  //       "bridge_opportunity_gps_longitude": 30.513978,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11799,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.238133,
  //       "proposed_bridge_location_gps_longitude": 30.513978,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "20times in March, April, May October November and December and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Gahuriro cell doesn't have access to Mutenderi market Gahuriro Cell doesn't have access to Kazo",
  //       "education_access_blocked_by_river": "Kinyonzo cell doesn't have access to Rugenge primary school",
  //       "health_access_blocked_by_river": "Kiyonzo cell doesn't have access to Kazo health post",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, cassava, banana",
  //       "primary_crops_grown": "banana, cassava, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 33.8,
  //       "height_differential_between_banks": 0.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev2DAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rebero",
  //       "bridge_opportunity_project_code": "1014423",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.1342683,
  //       "bridge_opportunity_gps_longitude": 30.533528,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11791,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1342683,
  //       "proposed_bridge_location_gps_longitude": 30.533528,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "30times in March, April, May, October November and December and it lasts 3days after rainfall",
  //       "market_access_blocked_by_river": "Musya cell doesn't have access to Kibungo market Nyamagana cell doesn't have access to Musya local market",
  //       "education_access_blocked_by_river": "Musya cell doesn't have access to Kabare primary and secondary school",
  //       "health_access_blocked_by_river": "Musya cell doesn't have access to Remera health center Musya cell doesn't have access to Kibungo health center and Referral Hospital",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of sweet potatoes, beans, sugar cane",
  //       "primary_crops_grown": "bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev2NAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Umukamba",
  //       "bridge_opportunity_project_code": "1014424",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.170028,
  //       "bridge_opportunity_gps_longitude": 30.497287,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4146,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.170028,
  //       "proposed_bridge_location_gps_longitude": 30.497287,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 56,
  //       "flood_duration_during_rainy_season": "28times in March, April, May, October November and December and it lasts 2days after rainfall",
  //       "market_access_blocked_by_river": "Umukamba cell doesn't have access to Karuberwa Coffee washing station",
  //       "education_access_blocked_by_river": "Umukamba cell doesn't have access to Kansana secondary school",
  //       "health_access_blocked_by_river": "Umukamba cell doesn't have access to Kansana health post",
  //       "other_access_blocked_by_river": "Churches,",
  //       "primary_occupations": "Farming of maize, banana, cassava",
  //       "primary_crops_grown": "banana, cassava, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He (little boy) slipped on trees and fall down in the river for crossing.",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36.8,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev44AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukibara",
  //       "bridge_opportunity_project_code": "1014425",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.229075,
  //       "bridge_opportunity_gps_longitude": 30.526267,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10899,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.229075,
  //       "proposed_bridge_location_gps_longitude": 30.526267,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "30times in April, May, October November and December and it lasts 3days after rainfall",
  //       "market_access_blocked_by_river": "Sakara cell doesn't have access to Giturusu and Kibungo market Gahurire cell doesn't have access to to Sakara market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Sakara cell doesn't have access to Kibungo health center and Referral Hospital",
  //       "other_access_blocked_by_river": "District office",
  //       "primary_occupations": "Rice plantation, cassava, coffee",
  //       "primary_crops_grown": "cassava, coffe, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "The motocycle slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 47.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev4EAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakirehe",
  //       "bridge_opportunity_project_code": "1014448",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.836888,
  //       "bridge_opportunity_gps_longitude": 30.07574,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 819,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.836888,
  //       "proposed_bridge_location_gps_longitude": 30.07574,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "Unpaved road on kilometer away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Agasharu Business center, Nyacyonga Market ( part of Nyakirehe and Rwanyanza)",
  //       "education_access_blocked_by_river": "Agasharu primary school ( part of Nyakirehe and Rwanyanza)",
  //       "health_access_blocked_by_river": "Juru post health center ( part of Nyakirehe and Rwanyanza)",
  //       "other_access_blocked_by_river": "Churches and cell office ( part of Nyakirehe and Rwanyanza)",
  //       "primary_occupations": "School, Market, Farms",
  //       "primary_crops_grown": "beam, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Ngiryi",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Gatuna",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It doesn't flooded",
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevNxAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyeru",
  //       "bridge_opportunity_project_code": "1014426",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.201705,
  //       "bridge_opportunity_gps_longitude": 30.60411,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7812,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.201705,
  //       "proposed_bridge_location_gps_longitude": 30.60411,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "30times, March, April, May, October November and December and it lasts 4days after rainfall",
  //       "market_access_blocked_by_river": "Kigabiro cell doesn't have access to Nyakarambi market Mushikiri sector doesn't have access to Rukira market",
  //       "education_access_blocked_by_river": "Mushikiri sector doesn't have access to Rurama secondary school",
  //       "health_access_blocked_by_river": "Mushikiri sector doesn't have access to Rukira health center",
  //       "other_access_blocked_by_river": "Sacco",
  //       "primary_occupations": "Farming of rice, banana",
  //       "primary_crops_grown": "banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 36.8,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev4OAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabahushi",
  //       "bridge_opportunity_project_code": "1014427",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.235312,
  //       "bridge_opportunity_gps_longitude": 30.552363,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10530,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.235312,
  //       "proposed_bridge_location_gps_longitude": 30.552363,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 75,
  //       "flood_duration_during_rainy_season": "The 25times in March, April, May, October, and November and December and it lasts for 3days after rainfall",
  //       "market_access_blocked_by_river": "Sakara cell doesn't have access to Rukizi market",
  //       "education_access_blocked_by_river": "Gitaraga cell doesn't have access to Sakara primary school",
  //       "health_access_blocked_by_river": "Sakara cell doesn't have access to Kibungo Referral Hospital",
  //       "other_access_blocked_by_river": "The paved road in 400m from the proposed footbridge",
  //       "primary_occupations": "Large rice plantation",
  //       "primary_crops_grown": ", banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He was drawn when it was flooded",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 77,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev4dAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gashekasheke",
  //       "bridge_opportunity_project_code": "1014428",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.085295,
  //       "bridge_opportunity_gps_longitude": 30.445293,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6325,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.085295,
  //       "proposed_bridge_location_gps_longitude": 30.445293,
  //       "current_crossing_method": "Small timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "The crossing is in the vicinity of the lake, when the lake is flooded, water in current pathway can lasts for one month, but for the normal rain it last for 1day after rainfall",
  //       "market_access_blocked_by_river": "Gashekasheke village doesn't have access to Nyamirambo market Nyamirambo cell doesn't have access to Ngoma market",
  //       "education_access_blocked_by_river": "Nyamirambo cell doesn't have access to Kabirizi A Primary and Secondary school.",
  //       "health_access_blocked_by_river": "Nyamirambo cell doesn't have access to Kirwa health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice farming, tomatoes and maize farms",
  //       "primary_crops_grown": "maiz, ric, tomato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45.4,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev5AAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanama",
  //       "bridge_opportunity_project_code": "1014429",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.106907,
  //       "bridge_opportunity_gps_longitude": 30.42817,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12427,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.106907,
  //       "proposed_bridge_location_gps_longitude": 30.42817,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "40times in April, May, October, and November and December and it lasts for 2days after rainfall",
  //       "market_access_blocked_by_river": "Nyamirambo cell doesn't have access to Ngoma market Nyagasozi cell doesn't have access to Nyamirambo market",
  //       "education_access_blocked_by_river": "Nyamirambo cell doesn't have access to Shywa primary and secondary school",
  //       "health_access_blocked_by_river": "Nyamirambo cell doesn't have access to Zaza health center Nyagasozi cell doesn't have access to Nyamirambo health post",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice farming, banana",
  //       "primary_crops_grown": "banana, bean, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 66.4,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev5KAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwakayango",
  //       "bridge_opportunity_project_code": "1014430",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.101273,
  //       "bridge_opportunity_gps_longitude": 30.426758,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12427,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.101273,
  //       "proposed_bridge_location_gps_longitude": 30.426758,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 120,
  //       "flood_duration_during_rainy_season": "4times and it can last for 1 month each time",
  //       "market_access_blocked_by_river": "Nyamirambo cell doesn't have access to Ngoma market Nyagasozi cell doesn't have access to Nyamirambo market",
  //       "education_access_blocked_by_river": "Nyamirambo cell doesn't have access to Zaza secondary school",
  //       "health_access_blocked_by_river": "Nyamirambo cell doesn't have access to Zaza health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They are drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 69.4,
  //       "height_differential_between_banks": 0.4,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev5PAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahondo",
  //       "bridge_opportunity_project_code": "1014431",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.195678,
  //       "bridge_opportunity_gps_longitude": 30.476143,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5899,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.195678,
  //       "proposed_bridge_location_gps_longitude": 30.476143,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 140,
  //       "flood_duration_during_rainy_season": "20times in March, April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Munege Cell doesn't have access to Mutenderi, Kibungo markets Birenga cell doesn't have access to Kibimba market",
  //       "education_access_blocked_by_river": "Birenga cell doesn't have access to Munege primary Munege Cell doesn't have access to Murinja secondary school",
  //       "health_access_blocked_by_river": "Birenga cell doesn't have access to Gashanda health center",
  //       "other_access_blocked_by_river": "Gashanda Sacco( local savings bank)",
  //       "primary_occupations": "Rice farming, maize farm",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev5UAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gakuto",
  //       "bridge_opportunity_project_code": "1014432",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.195243,
  //       "bridge_opportunity_gps_longitude": 30.475603,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6709,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.195243,
  //       "proposed_bridge_location_gps_longitude": 30.475603,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 140,
  //       "flood_duration_during_rainy_season": "20times in March, April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Munege Cell doesn't have access to Mutenderi, Kibungo markets Birenga cell doesn't have access to Kibimba market",
  //       "education_access_blocked_by_river": "Birenga cell doesn't have access to Munege primary school Munege Cell doesn't have access to Murinja secondary school",
  //       "health_access_blocked_by_river": "Birenga cell doesn't have access to Gashanda health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice farming, maize farming",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev5ZAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyerwa",
  //       "bridge_opportunity_project_code": "1014433",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.182108,
  //       "bridge_opportunity_gps_longitude": 30.453907,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10926,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.182108,
  //       "proposed_bridge_location_gps_longitude": 30.453907,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 105,
  //       "flood_duration_during_rainy_season": "15times in April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Akaziba cell doesn't have access to to Gafunzo, Rukumberi and Jarama markets Cyerwa cell doesn't have access to Karembo, Ngoma, Zaza and Kirwa markets",
  //       "education_access_blocked_by_river": "Akaziba cell doesn't have access to Bitare primary school Cyerwa cell doesn't have access to Zaza vocational training center",
  //       "health_access_blocked_by_river": "Cyerwa cell doesn't have access to Zaza health center Akaziba cell doesn't have access to Rukoma health center",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming of sweet potatoes, maize, beans, banana",
  //       "primary_crops_grown": "banana, bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down in the river for materials delivery, and motorcycles slips a lot of times",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 48,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev5eAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rukizi",
  //       "bridge_opportunity_project_code": "1014434",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.166942,
  //       "bridge_opportunity_gps_longitude": 30.441723,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10847,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.166942,
  //       "proposed_bridge_location_gps_longitude": 30.441723,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 140,
  //       "flood_duration_during_rainy_season": "20times in March, April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Ruhembe cell doesn't have access to karembo and Kibimba markets Akaziba cell doesn't have access to Zaza and Ngoma markets",
  //       "education_access_blocked_by_river": "Akaziba cell doesn't have access to Zaza Primary and Secondary schools",
  //       "health_access_blocked_by_river": "Akaziba cell doesn't have access to Zaza health center",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Rice farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Sometimes the women give birth at this crossing when they are delayed to reach the health center",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30.8,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev5jAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kanege",
  //       "bridge_opportunity_project_code": "1014435",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.20317,
  //       "bridge_opportunity_gps_longitude": 30.464068,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2906,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.18",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20317,
  //       "proposed_bridge_location_gps_longitude": 30.464068,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "40times in March, April, May, October November and December and it lasts 3hours after rainfall",
  //       "market_access_blocked_by_river": "Kanege village doesn't have access to their farms Kagarama village doesn't have access to Munege local commercial center",
  //       "education_access_blocked_by_river": "Rugarama village doesn't have access to Munege primary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Cell office",
  //       "primary_occupations": "Farming of banana",
  //       "primary_crops_grown": ", banana, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eev5oAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bamporeze 1",
  //       "bridge_opportunity_project_code": "1014436",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.9919444,
  //       "bridge_opportunity_gps_longitude": 30.14638889,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4607,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9919444,
  //       "proposed_bridge_location_gps_longitude": 30.14638889,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who live closer to bridge",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need slap (les dallettes).",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 2,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevL3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Indatwa",
  //       "bridge_opportunity_project_code": "1014437",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.965987,
  //       "bridge_opportunity_gps_longitude": 30.110639,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4750,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.965987,
  //       "proposed_bridge_location_gps_longitude": 30.110639,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Nyakabanda",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "For vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevL8AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ruhihi/Nyakabungo",
  //       "bridge_opportunity_project_code": "1014438",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.878459,
  //       "bridge_opportunity_gps_longitude": 30.035062,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4952,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.878459,
  //       "proposed_bridge_location_gps_longitude": 30.035062,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "6 kilometers",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "One hour",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Need the road and vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevLDAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Antenna 2",
  //       "bridge_opportunity_project_code": "1014439",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.98388889,
  //       "bridge_opportunity_gps_longitude": 30.13861111,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7864,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.98388889,
  //       "proposed_bridge_location_gps_longitude": 30.13861111,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 86,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Kabeza Market (Gashyushya, Antene, Amahoro)",
  //       "education_access_blocked_by_river": "Kabeza primary schools and Secondary schools (Gashyushya, Antene, Amahoro)",
  //       "health_access_blocked_by_river": "Kanombe hospital ( abarezi, susuruka,...)",
  //       "other_access_blocked_by_river": "Taxi park remera(Gashyushya, Antene, Amahoro)",
  //       "primary_occupations": "School, Market, health center, ...",
  //       "primary_crops_grown": "sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge in",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Kanombe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 63,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevLSAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Antenne",
  //       "bridge_opportunity_project_code": "1014440",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.9761111,
  //       "bridge_opportunity_gps_longitude": 30.1425,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7894,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9761111,
  //       "proposed_bridge_location_gps_longitude": 30.1425,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 86,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Kabeza Market (Gashyushya, Kamahoro, antene)",
  //       "education_access_blocked_by_river": "Kabeza Primary and secondary schools (Gashyushya, Kamahoro, antene)",
  //       "health_access_blocked_by_river": "Kanombe hospital (Abarezi, Sususruka, umunara,,...)",
  //       "other_access_blocked_by_river": "Taxi park remera (Gashyushya, Kamahoro, antene)",
  //       "primary_occupations": "Schools, farm, market,..",
  //       "primary_crops_grown": "sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge in",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Remera Kanombe or Remera Kabeza Rubirizi Kanombe",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevLXAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Abarezi",
  //       "bridge_opportunity_project_code": "1014441",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.97972222,
  //       "bridge_opportunity_gps_longitude": 30.14083333,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6542,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.97972222,
  //       "proposed_bridge_location_gps_longitude": 30.14083333,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 86,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Kabeza Market ( Gashyushya, Antenne, )",
  //       "education_access_blocked_by_river": "Kabeza primary and secondary schools (Gashyushya and Antenne)",
  //       "health_access_blocked_by_river": "Kanombe hospital ( Abarezi)",
  //       "other_access_blocked_by_river": "Taxi park remera (Gashyushya and Antenne)",
  //       "primary_occupations": "School, Market, ..",
  //       "primary_crops_grown": "bean, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Remera Kabeza Rubirizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevLhAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gitare",
  //       "bridge_opportunity_project_code": "1014442",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.986291,
  //       "bridge_opportunity_gps_longitude": 30.115909,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 28178,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.986291,
  //       "proposed_bridge_location_gps_longitude": 30.115909,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Gatare cell",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "For vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 17,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevLrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Byimana",
  //       "bridge_opportunity_project_code": "1014443",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.988027,
  //       "bridge_opportunity_gps_longitude": 30.117593,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 28178,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.988027,
  //       "proposed_bridge_location_gps_longitude": 30.117593,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 kilometers",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kicukiro center (Byimana of Kanserege) ,",
  //       "education_access_blocked_by_river": "gatare Nusery (Byimana of Kanserege) primary and secondary school on Gatare Side (Byimana of Kanserege)",
  //       "health_access_blocked_by_river": "Kicukiro health center (Byimana of Kanserege)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Market, school special nusery,",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Gatare",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Sonatube Kicukiro",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Closer to unpaved road and not flooded",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevM6AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarurembo",
  //       "bridge_opportunity_project_code": "1014444",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.969082,
  //       "bridge_opportunity_gps_longitude": 30.115851,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 20855,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.969082,
  //       "proposed_bridge_location_gps_longitude": 30.115851,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "2 days",
  //       "market_access_blocked_by_river": "Kabeza Market, ( Niboye), Kicukiro center ( Kabeza )",
  //       "education_access_blocked_by_river": "Primary and secondary school on Kabeza side ( Niboyi)",
  //       "health_access_blocked_by_river": "Kicukiro health center ( Kabeza)",
  //       "other_access_blocked_by_river": "Taxi park remera ( niboye)",
  //       "primary_occupations": "Schools, Market, work,",
  //       "primary_crops_grown": "sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "SEDO OF Niboye",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Sonatube Kicukiro Nyamata",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 41,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevMaAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyarubande",
  //       "bridge_opportunity_project_code": "1014445",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.968372,
  //       "bridge_opportunity_gps_longitude": 30.112113,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 18340,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.968372,
  //       "proposed_bridge_location_gps_longitude": 30.112113,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "Two days",
  //       "market_access_blocked_by_river": "Not used to go to market",
  //       "education_access_blocked_by_river": "Nyakabanda primary school (Niboye)",
  //       "health_access_blocked_by_river": "Kicukiro health center (Nyakabanda)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Schools and farms",
  //       "primary_crops_grown": "vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Students who work closer to bridge and fell down",
  //       "notes_on_social_information": "SEDO OF Niboye",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Sonatube Kicukiro Nyamata",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 77,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevMuAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akanyaru",
  //       "bridge_opportunity_project_code": "1014446",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.14197,
  //       "bridge_opportunity_gps_longitude": 29.98984,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1506,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14197,
  //       "proposed_bridge_location_gps_longitude": 29.98984,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": "Mugina",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Mugina",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevN9AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ntasi",
  //       "bridge_opportunity_project_code": "1014447",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Kamonyi",
  //       "bridge_opportunity_gps_latitude": -2.09453,
  //       "bridge_opportunity_gps_longitude": 29.9943,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1850,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.19",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.09453,
  //       "proposed_bridge_location_gps_longitude": 29.9943,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Mugina",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community always cross the river",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000eevNEAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rugobagoba",
  //       "bridge_opportunity_project_code": "1014461",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.02333,
  //       "bridge_opportunity_gps_longitude": 30.43209,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3468,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.02333,
  //       "proposed_bridge_location_gps_longitude": 30.43209,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometers away.",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "April , May, 48 hours",
  //       "market_access_blocked_by_river": "Rwamagana market ( 4,5), Mubuga market ( 1,2,3), farming ( 1,2,3,4,5).",
  //       "education_access_blocked_by_river": "Sovu primary and secondary school ( 4,5), nkungu secondary school ( 1,2).",
  //       "health_access_blocked_by_river": "Kugitariyani health center ( 1,2,3), Rwamagana hospital ( 4,5).",
  //       "other_access_blocked_by_river": "Churches ( 4,5), potable water ( 1).",
  //       "primary_occupations": "Farming and livestock",
  //       "primary_crops_grown": "banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Population information of each village was provided by cell leader , vestine who sourced the population information from cell register cell register book. Population of all adjacent communities includes the following villages: Rugobagoba, Nyabishunzi, Ryaruhogo, kabazeye,and kiganzwa Population from kabazeye and kiganzwa use the bridge to visit Rwamagana city to find different services there including market , district office, bus stops , etc...",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6xdAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kizoke",
  //       "bridge_opportunity_project_code": "1014462",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.184027,
  //       "bridge_opportunity_gps_longitude": 30.767541,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2099,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.184027,
  //       "proposed_bridge_location_gps_longitude": 30.767541,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two month",
  //       "market_access_blocked_by_river": "Munanda market and nyarutunga market",
  //       "education_access_blocked_by_river": "Migongo high school",
  //       "health_access_blocked_by_river": "Nyarutunga health center",
  //       "other_access_blocked_by_river": "Nyarubuye parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by the cell leader , Emmanuel who sourced the population information from cell register.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6xiAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwanyiramanyana",
  //       "bridge_opportunity_project_code": "1014463",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.009512,
  //       "bridge_opportunity_gps_longitude": 30.421038,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1851,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.009512,
  //       "proposed_bridge_location_gps_longitude": 30.421038,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "1.5 kilometers",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "April and May, 24 hours",
  //       "market_access_blocked_by_river": "Rwamagana market ( 3), Rubona market ( 1,2), farming activities ( 1,2,3).",
  //       "education_access_blocked_by_river": "Sovu primary school and secondary school( 3).",
  //       "health_access_blocked_by_river": "Rwamagana hospital ( 3).",
  //       "other_access_blocked_by_river": "Churches ( 3 ).",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Kayonza~ kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 75,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6xnAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugatare",
  //       "bridge_opportunity_project_code": "1014464",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.296406,
  //       "bridge_opportunity_gps_longitude": 30.52359,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.296406,
  //       "proposed_bridge_location_gps_longitude": 30.52359,
  //       "current_crossing_method": "Boat",
  //       "nearest_all_weather_crossing_point": "3 kilometers",
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The span( 290 m) is beyond the current engineering scope",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 290,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6xsAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Murama",
  //       "bridge_opportunity_project_code": "1014465",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.3152,
  //       "bridge_opportunity_gps_longitude": 30.470953,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 857,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3152,
  //       "proposed_bridge_location_gps_longitude": 30.470953,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The span is beyond the existing engineering scope, the valley is over 400m span",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6xxAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwabiyombi~ kijumbura 2",
  //       "bridge_opportunity_project_code": "1014466",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.365716,
  //       "bridge_opportunity_gps_longitude": 30.542117,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.365716,
  //       "proposed_bridge_location_gps_longitude": 30.542117,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a repair of a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6y2AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Butezi",
  //       "bridge_opportunity_project_code": "1014467",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.371645,
  //       "bridge_opportunity_gps_longitude": 30.539508,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.371645,
  //       "proposed_bridge_location_gps_longitude": 30.539508,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a repair of existing vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6y7AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabigembe 2",
  //       "bridge_opportunity_project_code": "1014468",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.09732,
  //       "bridge_opportunity_gps_longitude": 30.701159,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 480,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.09732,
  //       "proposed_bridge_location_gps_longitude": 30.701159,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": "April to May, 8 hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6yCAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Barisuka",
  //       "bridge_opportunity_project_code": "1014469",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.208786,
  //       "bridge_opportunity_gps_longitude": 30.695041,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4243,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.208786,
  //       "proposed_bridge_location_gps_longitude": 30.695041,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 28,
  //       "flood_duration_during_rainy_season": "April and May, December, 24 hours",
  //       "market_access_blocked_by_river": "Nyakarambi market ( 1,2,3), murindi market ( 4,5), farms ( 1,4).",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "Post de Sante rugarama( 1,4)",
  //       "other_access_blocked_by_river": "Churches ( 1,4,5)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by the villages leader. Population of all adjacent communities includes the following villages: barisuka, kabeza, sangano , kwakanyambo, kagega 1 and 2. Population members from barisuka, kabeza and sangano uses the bridge more than others to visit the market in nyakarambi and the bus stop and district office.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali ~ Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 51,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6yHAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Tomi",
  //       "bridge_opportunity_project_code": "1014470",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.1496,
  //       "bridge_opportunity_gps_longitude": 30.66541,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 320,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1496,
  //       "proposed_bridge_location_gps_longitude": 30.66541,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is 0 days in years when people cant cross",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6yRAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karuruma",
  //       "bridge_opportunity_project_code": "1014472",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.18715,
  //       "bridge_opportunity_gps_longitude": 30.62265,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.18715,
  //       "proposed_bridge_location_gps_longitude": 30.62265,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 36,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Nkoyoyo market",
  //       "education_access_blocked_by_river": "Rwamukobwa high school",
  //       "health_access_blocked_by_river": "Cyamigurwa health center",
  //       "other_access_blocked_by_river": "Rugaragara parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Bingaro village dont have access to rwamukobwa Rwamukobwa dont have access to nkoyoyo market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nkoyoyo",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 39,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6ybAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiyanja",
  //       "bridge_opportunity_project_code": "1014473",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.17478,
  //       "bridge_opportunity_gps_longitude": 30.76704,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1750,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.17478,
  //       "proposed_bridge_location_gps_longitude": 30.76704,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 76,
  //       "flood_duration_during_rainy_season": "Two month",
  //       "market_access_blocked_by_river": "Nyarutunga market and rushonga market",
  //       "education_access_blocked_by_river": "Nyarubuye high school",
  //       "health_access_blocked_by_river": "Nyarubuye health center",
  //       "other_access_blocked_by_river": "Nyarubuye parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Old people has fallen trying to cross",
  //       "notes_on_social_information": "Bugarura village dont have acces to rushanga market while remera village dont have access to ngarutunga market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyajarambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 73,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6ygAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwayikona",
  //       "bridge_opportunity_project_code": "1014474",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.164154,
  //       "bridge_opportunity_gps_longitude": 30.695954,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4730,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.164154,
  //       "proposed_bridge_location_gps_longitude": 30.695954,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 10,
  //       "flood_duration_during_rainy_season": "April to May, October to November, 24 hours",
  //       "market_access_blocked_by_river": "Murindi market ( 1,2,3), nyakarambi market ( 4), farms ( 1,2,3,4 ).",
  //       "education_access_blocked_by_river": "Mushikiri secondary school ( 4 ), ntaruka primary school ( 1,2,3).",
  //       "health_access_blocked_by_river": "Ntaruka health center ( 1,2,3)",
  //       "other_access_blocked_by_river": "Churches ( 1,2,3), district office ( 4 )",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Population information of each village was provided by village leader , habarugira who sourced the population information from cell register in Ubudehe program. Community 1,2 and 3 are blocked to the market twice a week. Students from villages : gasheshe and karenge 1and 2 uses the bridge every day to go to school especially secondary school students.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali ~ Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.5,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6ylAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatari",
  //       "bridge_opportunity_project_code": "1014475",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.3592,
  //       "bridge_opportunity_gps_longitude": 30.677613,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.3592,
  //       "proposed_bridge_location_gps_longitude": 30.677613,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community can cross year round there is no need of a footbridge.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6yqAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "kadigadiga",
  //       "bridge_opportunity_project_code": "1014477",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.99173,
  //       "bridge_opportunity_gps_longitude": 30.448175,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2006,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.99173,
  //       "proposed_bridge_location_gps_longitude": 30.448175,
  //       "current_crossing_method": "Concrete",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 20,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Rwamagana market",
  //       "education_access_blocked_by_river": "Zinga high school",
  //       "health_access_blocked_by_river": "Munyaga health center and rwamagana health center",
  //       "other_access_blocked_by_river": "They are Churches at karambo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident yet happened",
  //       "notes_on_social_information": "Munini village don't have access to rwamagana market Information gathered from local people",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Kigaki-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6z0AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutaka",
  //       "bridge_opportunity_project_code": "1014478",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.99518,
  //       "bridge_opportunity_gps_longitude": 30.47381,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 16196,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.99518,
  //       "proposed_bridge_location_gps_longitude": 30.47381,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Five days",
  //       "market_access_blocked_by_river": "Nkamba market and munyaga market",
  //       "education_access_blocked_by_river": "Rutonde high school",
  //       "health_access_blocked_by_river": "Rujira post center and bwiza post center",
  //       "other_access_blocked_by_river": "Churches at Ruramira",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "rid",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "The children died trying to cross when it was flooded",
  //       "notes_on_social_information": "Rutaka village village don't have access to nkamba market while kabrima village don't have access to munyaga market",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Kigalu_rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6z5AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahama ya nyagasenyi",
  //       "bridge_opportunity_project_code": "1014479",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.2136,
  //       "bridge_opportunity_gps_longitude": 30.77847,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1046,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2136,
  //       "proposed_bridge_location_gps_longitude": 30.77847,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Rugarama market and nyamisagara market",
  //       "education_access_blocked_by_river": "Nyabitare high school",
  //       "health_access_blocked_by_river": "None",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Not yet occured",
  //       "notes_on_social_information": "Nyagasenyi village dont have access to nyabitare school Information gathered from nyabayamo village sibo leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 68,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6zAAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mitsindo",
  //       "bridge_opportunity_project_code": "1014480",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.7278,
  //       "bridge_opportunity_gps_longitude": 30.72778,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1576,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.7278,
  //       "proposed_bridge_location_gps_longitude": 30.72778,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "3 km",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Four hours",
  //       "market_access_blocked_by_river": "Birembo market and kagese market",
  //       "education_access_blocked_by_river": "Cyambwe high school",
  //       "health_access_blocked_by_river": "Murindi health center",
  //       "other_access_blocked_by_river": "Mitzindo parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Not yet occured",
  //       "notes_on_social_information": "Nyabiharo villzge dont have access to kagese market and mitsindo village don't have access to birembo village Information gathered from mitsindo village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 63,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6zFAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mitsindo-nyabihara",
  //       "bridge_opportunity_project_code": "1014481",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.1403,
  //       "bridge_opportunity_gps_longitude": 30.72741,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 696,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1403,
  //       "proposed_bridge_location_gps_longitude": 30.72741,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Twoo hours",
  //       "market_access_blocked_by_river": "Murindi market",
  //       "education_access_blocked_by_river": "Nyagatemere primary school",
  //       "health_access_blocked_by_river": "Kagese post center",
  //       "other_access_blocked_by_river": "Mitsindo parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyabihara dont have access to kagese school, kagese market and mitsindo village dont have access to murindi market Information gathered from both village leaders",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": "K8gali-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 56,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef6zPAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatabura",
  //       "bridge_opportunity_project_code": "1014482",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.1486,
  //       "bridge_opportunity_gps_longitude": 30.72617,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 700,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1486,
  //       "proposed_bridge_location_gps_longitude": 30.72617,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "One week",
  //       "market_access_blocked_by_river": "Kagese market",
  //       "education_access_blocked_by_river": "None",
  //       "health_access_blocked_by_river": "Kagese health center and ntaruka health center",
  //       "other_access_blocked_by_river": "None",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Not yet occured",
  //       "notes_on_social_information": "Nyabihara villave dont have access to birembo market Information gathered from nyabihara village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 58,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef70hAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwamaziba",
  //       "bridge_opportunity_project_code": "1014483",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.2318,
  //       "bridge_opportunity_gps_longitude": 30.8131,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 612,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2318,
  //       "proposed_bridge_location_gps_longitude": 30.8131,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The is zero days when people cant cross",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef70mAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagasenyi kwa mbaraga",
  //       "bridge_opportunity_project_code": "1014484",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.2073,
  //       "bridge_opportunity_gps_longitude": 30.79185,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 456,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2073,
  //       "proposed_bridge_location_gps_longitude": 30.79185,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rusumo",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community always cross the bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef70rAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mareba",
  //       "bridge_opportunity_project_code": "1014485",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.21079,
  //       "bridge_opportunity_gps_longitude": 30.73431,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 560,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.21079,
  //       "proposed_bridge_location_gps_longitude": 30.73431,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-kirehe",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The is no water flow and th community can always cross",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef70wAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwanyagatamu",
  //       "bridge_opportunity_project_code": "1014486",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.2099,
  //       "bridge_opportunity_gps_longitude": 30.78795,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.2099,
  //       "proposed_bridge_location_gps_longitude": 30.78795,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "People always cross",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef711AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kereta",
  //       "bridge_opportunity_project_code": "1014487",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Kirehe",
  //       "bridge_opportunity_gps_latitude": -2.1664,
  //       "bridge_opportunity_gps_longitude": 30.78863,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10098,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.24",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.1664,
  //       "proposed_bridge_location_gps_longitude": 30.78863,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 46,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Rushonga market",
  //       "education_access_blocked_by_river": "Kankobwa high school",
  //       "health_access_blocked_by_river": "Nyarubuye health center",
  //       "other_access_blocked_by_river": "Nyarubuye parish",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "Not yet occured",
  //       "notes_on_social_information": "Nyakanazi village dont have access to rushonga market Information gathered from kankobwa leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyakarambi",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 53,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef71BAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyagatovu",
  //       "bridge_opportunity_project_code": "1014490",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.117773,
  //       "bridge_opportunity_gps_longitude": 30.607615,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10639,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.117773,
  //       "proposed_bridge_location_gps_longitude": 30.607615,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "35times in March, April and May and it lasts for 2hours after rainfall",
  //       "market_access_blocked_by_river": "Gatonde cell doesn't have access to Gahushi mini-market Gatonde cell doesn't have access to Gituku market Kibatsi cell doesn't have access to Kibungo market",
  //       "education_access_blocked_by_river": "Gatonde cell doesn't have access to Gahushi primary school",
  //       "health_access_blocked_by_river": "Kibatsi cell doesn't have access to Rubona health center",
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming of beans, sweet potatoes, maize",
  //       "primary_crops_grown": "bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 65.8,
  //       "height_differential_between_banks": 2.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7XtAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mukomango",
  //       "bridge_opportunity_project_code": "1014491",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.206378,
  //       "bridge_opportunity_gps_longitude": 30.521405,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5065,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.206378,
  //       "proposed_bridge_location_gps_longitude": 30.521405,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "700 m",
  //       "days_per_year_river_is_flooded": 45,
  //       "flood_duration_during_rainy_season": "45times in March, April, May, October November and December and it lasts 6hours after rainfall",
  //       "market_access_blocked_by_river": "Gahurire cell doesn't have access to Birenga market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": "Gahuriro Cell doesn't have access to Birenga health center",
  //       "other_access_blocked_by_river": "Cell office",
  //       "primary_occupations": "Farming of sweet potatoes, Potatoes, banana, cassava",
  //       "primary_crops_grown": "banana, cassava, potato, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 31.4,
  //       "height_differential_between_banks": 1.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7Y3AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bigo2",
  //       "bridge_opportunity_project_code": "1014507",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.011603,
  //       "bridge_opportunity_gps_longitude": 30.082825,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 13756,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.011603,
  //       "proposed_bridge_location_gps_longitude": 30.082825,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": "Gahanga Market, Karembure Market and business center (Nyarurama)",
  //       "education_access_blocked_by_river": "Primary and secondary of Karembure ( Nyarurama)",
  //       "health_access_blocked_by_river": "Gahanga health center (Nyarurama)",
  //       "other_access_blocked_by_river": "Cell of Nyarurama ( part of Bigo)",
  //       "primary_occupations": "Job, schools, market,..",
  //       "primary_crops_grown": "banana plantain, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Committee members of the Bigo of Nyarurama",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kicukiro Nyanza Bugesera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7jJAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigobe",
  //       "bridge_opportunity_project_code": "1014492",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.137525,
  //       "bridge_opportunity_gps_longitude": 30.459055,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9363,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.137525,
  //       "proposed_bridge_location_gps_longitude": 30.459055,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "40times in April, May, October, November and December and it lasts for 2days after rainfall",
  //       "market_access_blocked_by_river": "Akaziba cell doesn't have access to Karaba market",
  //       "education_access_blocked_by_river": "Akaziba cell doesn't have access to Kabirizi Primary and Secondary school",
  //       "health_access_blocked_by_river": "Akaziba cell doesn't have access to Kabirizi health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice farming, sweet potatoes",
  //       "primary_crops_grown": "ric, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 71.4,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7abAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagoma",
  //       "bridge_opportunity_project_code": "1014493",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.271583,
  //       "bridge_opportunity_gps_longitude": 30.334962,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 55,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.271583,
  //       "proposed_bridge_location_gps_longitude": 30.334962,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Too long span greater than 500m",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7agAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Meraneza",
  //       "bridge_opportunity_project_code": "1014494",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.267435,
  //       "bridge_opportunity_gps_longitude": 30.545003,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10803,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.267435,
  //       "proposed_bridge_location_gps_longitude": 30.545003,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "30times in April and May and it lasts for 2days after rainfall",
  //       "market_access_blocked_by_river": "Nyagasozi cell doesn't have access to Rurama market Nyagasozi cell doesn't have access to Gatore , Nyakarambi, and Kibungo markets",
  //       "education_access_blocked_by_river": "Rurenge cell doesn't have access to Kibara primary and secondary school",
  //       "health_access_blocked_by_river": "Nyagasozi cell doesn't have access to Kibungo, and Kirehe health center Rurenge cell doesn't have access to Mutenderi health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of banana, beans,",
  //       "primary_crops_grown": "banana, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They slipped down during the flooding while trying to walk in water",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 62.4,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7alAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Musenyi",
  //       "bridge_opportunity_project_code": "1014495",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.256448,
  //       "bridge_opportunity_gps_longitude": 30.484267,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 555,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.256448,
  //       "proposed_bridge_location_gps_longitude": 30.484267,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is in the vehicular road, therefore, the vehicular bridge is needed",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7b0AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisasa",
  //       "bridge_opportunity_project_code": "1014497",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.9020028,
  //       "bridge_opportunity_gps_longitude": 30.12219,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4860,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.9020028,
  //       "proposed_bridge_location_gps_longitude": 30.12219,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "3 kilometers",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "They were trying to cross the bridge and as the timber were old they felt in small river",
  //       "notes_on_social_information": "Village leader of Gisasa",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge and it is unpaved road",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 8,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7dzAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akigabiro",
  //       "bridge_opportunity_project_code": "1014498",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.822718,
  //       "bridge_opportunity_gps_longitude": 30.146343,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1845,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.822718,
  //       "proposed_bridge_location_gps_longitude": 30.146343,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Village leader of Akagabiro",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is unpaved road and need the concrete bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 13,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7e4AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Barage",
  //       "bridge_opportunity_project_code": "1014499",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.829462,
  //       "bridge_opportunity_gps_longitude": 30.158647,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1726,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.829462,
  //       "proposed_bridge_location_gps_longitude": 30.158647,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Nyagasambu village leader",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 10,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7e9AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyacyonga Kigasa",
  //       "bridge_opportunity_project_code": "1014500",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.000188,
  //       "bridge_opportunity_gps_longitude": 30.112183,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3868,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.000188,
  //       "proposed_bridge_location_gps_longitude": 30.112183,
  //       "current_crossing_method": "Culvert",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who were using the bridge and SEDO OF Kagasa",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "KIgali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It is already constructed last week and it is vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 6,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7eEAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bigo1",
  //       "bridge_opportunity_project_code": "1014502",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.012684,
  //       "bridge_opportunity_gps_longitude": 30.087223,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8759,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.012684,
  //       "proposed_bridge_location_gps_longitude": 30.087223,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "One of them, She was trying to cross the bridge when she was on the phone and felt down and became handicapped",
  //       "notes_on_social_information": "Chief of Security of Karembure",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 5,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7eOAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bigo 2",
  //       "bridge_opportunity_project_code": "1014503",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.01259,
  //       "bridge_opportunity_gps_longitude": 30.08668,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8759,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01259,
  //       "proposed_bridge_location_gps_longitude": 30.08668,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None because it doesn't flooded",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Chief of Security of Karembure",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 11,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7eTAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sabaganga",
  //       "bridge_opportunity_project_code": "1014504",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.992257,
  //       "bridge_opportunity_gps_longitude": 30.085447,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1925,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.992257,
  //       "proposed_bridge_location_gps_longitude": 30.085447,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Business center Murambi (Umukoke of Karambo)",
  //       "education_access_blocked_by_river": "Gatenga primary school and secondary school (Umukoke)",
  //       "health_access_blocked_by_river": "Health center Murambi (umukoke)",
  //       "other_access_blocked_by_river": "Taxi park Nyanza (umukoke), churches (umukoke) fetching water(umukoke)",
  //       "primary_occupations": "For Job, school, Market, it is only way for people of umukoke to go to the different place",
  //       "primary_crops_grown": "plantain banana",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None but during rain season there is a man died in his house due to that place which is high zone risk",
  //       "notes_on_social_information": "One in charge of social in Sabaganga village",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Sonatube Kicukiro or Kicukiro-Gatenga",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It has three channel and it can have span more than 165 m, it served small number of population which lived in unauthorized place",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 170,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7eYAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karwa",
  //       "bridge_opportunity_project_code": "1014505",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.998487,
  //       "bridge_opportunity_gps_longitude": 30.107728,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3071,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.998487,
  //       "proposed_bridge_location_gps_longitude": 30.107728,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Rukatsi market, business center and all bank (Karwa and Nyacyonga of Kagasa)",
  //       "education_access_blocked_by_river": "Kagarama primary and secondary school (Karwa and Nyacyonga of Kagasa)",
  //       "health_access_blocked_by_river": "Kicukiro health center ( (Karwa and Nyacyonga of Kagasa)",
  //       "other_access_blocked_by_river": "Fetching water (Karwa l",
  //       "primary_occupations": "School, farms, jobs, health center, ...",
  //       "primary_crops_grown": "non",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who were crossing the bridge and live in Karwa and in charge of security of Nyacyonga",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kicukiro Bugesera",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 42,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7enAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bigo-Nyarurama",
  //       "bridge_opportunity_project_code": "1014506",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.007747,
  //       "bridge_opportunity_gps_longitude": 30.079832,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 13584,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.007747,
  //       "proposed_bridge_location_gps_longitude": 30.079832,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "800 m",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "12 hours",
  //       "market_access_blocked_by_river": "Karembure Market and business center , Gahanga Market (Nyarurama),",
  //       "education_access_blocked_by_river": "Kabeza primary and nursery school ( part of Bigo, Karembure)",
  //       "health_access_blocked_by_river": "Gahanga health center (Nyarurama)",
  //       "other_access_blocked_by_river": "Cell of Nyarurama (Part of Bigo)",
  //       "primary_occupations": "School, Market, cell, health center",
  //       "primary_crops_grown": "banana plantain, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They were trying to cross the bridge when it was flooded and fell into channel",
  //       "notes_on_social_information": "Committee members of the Bigo of Nyarurama",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Sonatube Nyanza bugesera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7jEAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Buranga",
  //       "bridge_opportunity_project_code": "1014508",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.94362,
  //       "bridge_opportunity_gps_longitude": 30.121686,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 36450,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.94362,
  //       "proposed_bridge_location_gps_longitude": 30.121686,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Kimironko Market , all bank in Kimironko (Kibagabaga special Buranga village),",
  //       "education_access_blocked_by_river": "Nyagasambu primary school and Bibare secondary school (Kibagabaga special Buranga village)",
  //       "health_access_blocked_by_river": "Remera health center (Kibagabaga special Buranga village), kibagabaga hospital (Nyagatovu village)",
  //       "other_access_blocked_by_river": "Churches are on both side,",
  //       "primary_occupations": "School, health center and Hospital, Market, ...",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Cell leader of Nyagatovu",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kibagabaga kimironko",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7jOAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gisera",
  //       "bridge_opportunity_project_code": "1014509",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.21354,
  //       "bridge_opportunity_gps_longitude": 30.437908,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11068,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.25",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.21354,
  //       "proposed_bridge_location_gps_longitude": 30.437908,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "5times in the whole year and it can last for 7days after rainfall",
  //       "market_access_blocked_by_river": "Nkanga cell doesn't have access to Kinihira market Cyerwa cell doesn't have access to their farms",
  //       "education_access_blocked_by_river": "Nkanga cell doesn't have access to Bitare primary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Churches",
  //       "primary_occupations": "Farming of beans, maize",
  //       "primary_crops_grown": "bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rusumo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30.4,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7jTAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gaseke",
  //       "bridge_opportunity_project_code": "1014511",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.008345,
  //       "bridge_opportunity_gps_longitude": 30.412562,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7563,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.008345,
  //       "proposed_bridge_location_gps_longitude": 30.412562,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 80,
  //       "flood_duration_during_rainy_season": "40times in April, May, October November and December and it lasts 2days after rainfall",
  //       "market_access_blocked_by_river": "Nawe cell doesn't have access to Rwamagana market Mwurire cell doesn't have access to Rubona market",
  //       "education_access_blocked_by_river": "Mwurire cell doesn't have access to Nawe primary and secondary school",
  //       "health_access_blocked_by_river": "Mwurire cell doesn't have access to Nawe health post",
  //       "other_access_blocked_by_river": "Nawe cell doesn't have access to Mwurire water point",
  //       "primary_occupations": "Large rice plantation, maize",
  //       "primary_crops_grown": "maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 39.4,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7oOAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mataba",
  //       "bridge_opportunity_project_code": "1014512",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.025878,
  //       "bridge_opportunity_gps_longitude": 30.360528,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 8093,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.025878,
  //       "proposed_bridge_location_gps_longitude": 30.360528,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "7 km",
  //       "days_per_year_river_is_flooded": 56,
  //       "flood_duration_during_rainy_season": "56times in April, May, October November and December and it lasts 1day after rainfall",
  //       "market_access_blocked_by_river": "Kigarama cell doesn't have access to Ntunga, Rubona markets Karambi cell doesn't have access to Nzige market",
  //       "education_access_blocked_by_river": "Karambi cell doesn't have access to Kigarama primary school Karambi cell doesn't have access to Nzige primary and secondary school",
  //       "health_access_blocked_by_river": "Karambi cell doesn't have access to Nzige health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farming of legumes, cassava, maize",
  //       "primary_crops_grown": "bean, cassava, legum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "They slipped on trees and fall down in the river",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 41.4,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef7oTAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ryabugenge",
  //       "bridge_opportunity_project_code": "1014532",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.65754,
  //       "bridge_opportunity_gps_longitude": 30.2992,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1510,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65754,
  //       "proposed_bridge_location_gps_longitude": 30.2992,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Mugera market (Community 3), Remera market (Community 1,2), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Tsima Primary School (Community 3)",
  //       "health_access_blocked_by_river": "No Health access blocked",
  //       "other_access_blocked_by_river": "Nyarubuye Catholic, Anglican and Baptist churches (Community 3), potable water (Community 3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people were injured at this crossing point.",
  //       "notes_on_social_information": "Ryabugenge, Tsima and Byimana villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Mpondwa Cell Leader, Bizumuremyi Gaspard, from the data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR24 (Kigali - Kabitumba)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef84WAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kigaga",
  //       "bridge_opportunity_project_code": "1014533",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.65055,
  //       "bridge_opportunity_gps_longitude": 30.30473,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1542,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.65055,
  //       "proposed_bridge_location_gps_longitude": 30.30473,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Mugera market (Community 3), Farms (1,2,3)",
  //       "education_access_blocked_by_river": "Tsima Primary School (Community 3)",
  //       "health_access_blocked_by_river": "No health access blocked",
  //       "other_access_blocked_by_river": "Kanyinya Baptist church (Community 1,2), Nyarubuye Catholic Church (Community 3)",
  //       "primary_occupations": "Agriculture and Brick making",
  //       "primary_crops_grown": "banana plantation, bean, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Ryabugenge, Tsima and Kanyinya villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Mpondwa Cell Leader, Bizumuremyi Gaspard, from the data collected in 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR24 (Kigali - Kagitumba)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef84gAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahama",
  //       "bridge_opportunity_project_code": "1014534",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.665,
  //       "bridge_opportunity_gps_longitude": 30.29284,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1972,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.665,
  //       "proposed_bridge_location_gps_longitude": 30.29284,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "No floods at this crossing point.",
  //       "market_access_blocked_by_river": "Mugera market (Community 1,4), Kageyo, Muhura and Gisiza markets (Community 1,2,3), Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Tsima Primary School (1,4), Byimana nursery school (Community 1)",
  //       "health_access_blocked_by_river": "Nyarubuye and Gitoki health centers (Community 1)",
  //       "other_access_blocked_by_river": "Mpondwa Cell Office, Gitoki Sector Office (Community 1), ADEPR and Catholic churches (Community 1,4)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, coffee., maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "4 people were seriously injured at this crossing point.",
  //       "notes_on_social_information": "Gahama, Ryabugenge, Tsima and Byimana villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Mpondwa Cell Leader, Bizumuremyi Gaspard, from the data collected in 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR24 (Kigali - Kagitumba)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.8,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef84lAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagarama",
  //       "bridge_opportunity_project_code": "1014542",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.99723,
  //       "bridge_opportunity_gps_longitude": 30.24595,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4092,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.99723,
  //       "proposed_bridge_location_gps_longitude": 30.24595,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "6 km",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Kabuga Market (Community 3), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Bujyejye Primary School (Community 1,2)",
  //       "health_access_blocked_by_river": "No health access blocked",
  //       "other_access_blocked_by_river": "Kagarama Catholic Church (Community 3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kagarama, Gishore and Rubaza villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Gishore Cell Leader, Felicité Musanayo, from the data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "NR4 (Kigali-Rwamagana)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef88TAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakabungo",
  //       "bridge_opportunity_project_code": "1014535",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.57761,
  //       "bridge_opportunity_gps_longitude": 30.20642,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2140,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.57761,
  //       "proposed_bridge_location_gps_longitude": 30.20642,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 6 hours",
  //       "market_access_blocked_by_river": "Shyondo market (Community 4), Gatsibo and Mugera markets (Community 1,2,3), Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Kagera Primary and Secondary School (Community 4), Gatsibo Primary and Secondary School (Community 1,2,3)",
  //       "health_access_blocked_by_river": "Akagera Health Post (Community 4), Gatsibo health center (Community 1,2,3)",
  //       "other_access_blocked_by_river": "Gatsibo District and Gatsibo Catholic Parish (Community 1,2,3)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "5 people were seriously injured trying to cross the river.",
  //       "notes_on_social_information": "Nyakabungo, Rugarama, Nyamiyaga and Munini villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Nyamirama Cell Leader, Jeremy Ndahimana, from the data collected in 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR24 (Kigali - Kagitumba)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef84qAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kacyiru",
  //       "bridge_opportunity_project_code": "1014536",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.59976,
  //       "bridge_opportunity_gps_longitude": 30.20891,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2173,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.59976,
  //       "proposed_bridge_location_gps_longitude": 30.20891,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "No floods",
  //       "market_access_blocked_by_river": "Nyagahanga and Gatsibo markets (Community 2,3,4,5), Farms (Community 1,2,3,4 5)",
  //       "education_access_blocked_by_river": "Gishiki Primary and Rugogwe Primary and Secondary School (Community 1), Nyagahanga Primary and Secondary School (Community 2,3,4,5)",
  //       "health_access_blocked_by_river": "Nyagahanga Health Center (Community 2,3,4,5)",
  //       "other_access_blocked_by_river": "Nyamirama Cell Office (Community 1), Nyagahanga Catholic Parish, Adventist ADEPR Churches (Community 2,3,4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "2 people have been injured at this crossing point.",
  //       "notes_on_social_information": "Karama, Burembo, Butumba, Rugogwe and Kabuba villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Nyamirama Cell Leader, Jeremy Ndahimana, from the data collected in 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR24 (Kigali- Kagitumba)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef87LAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Bitumba",
  //       "bridge_opportunity_project_code": "1014537",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.60164,
  //       "bridge_opportunity_gps_longitude": 30.19772,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2173,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.60164,
  //       "proposed_bridge_location_gps_longitude": 30.19772,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 15,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Nyagahanga and Gatsibo markets (Community 1), Farms (Community 1,2)",
  //       "education_access_blocked_by_river": "Rugogwe Primary and Secondary School (Community 2,3,4,5), Nyagahanga Primary and Secondary School (Community 1)",
  //       "health_access_blocked_by_river": "Nyagahanga Health Center (Community 1)",
  //       "other_access_blocked_by_river": "Nyamirama Cell Office (Community 2,3,4,5), Nyagahanga Catholic Parish, ADEPR and Adventist Churches (Community 1)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Karama, Bitumba, Rugigwe, Burembo and Kabuga villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Nyamirama Cell Leader, Jeremy Ndahimana, from the data collected in 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyagatare town",
  //       "name_of_nearest_paved_or_sealed_road": "NR24 (Kigali-Kagitumba)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef87aAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kiyovu",
  //       "bridge_opportunity_project_code": "1014538",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.8953,
  //       "bridge_opportunity_gps_longitude": 30.30129,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1825,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.8953,
  //       "proposed_bridge_location_gps_longitude": 30.30129,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 hours",
  //       "market_access_blocked_by_river": "Nyagasambu and Ntunga markets (Community 1,2), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Nyagasambu and Rutoma Primary and Secondary Schools (Community 1,2)",
  //       "health_access_blocked_by_river": "Nyagasambu Health Center (Community 1,2)",
  //       "other_access_blocked_by_river": "Rwamagana District Office (Community 1,2), Kigali (Community 1,2), Nyagasambu Catholic and Methodist churches (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kiyovu, Nyarucyamo and Ruhita villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Runyinya Cell Leader, Odette Mukankusi, from the data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "NR4 (Kigali-Rwamagana)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef87pAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kirehe",
  //       "bridge_opportunity_project_code": "1014539",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.88269,
  //       "bridge_opportunity_gps_longitude": 30.26579,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1512,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.88269,
  //       "proposed_bridge_location_gps_longitude": 30.26579,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "No floods",
  //       "market_access_blocked_by_river": "Ntunga and Nyagasambu markets (Community 1,2)",
  //       "education_access_blocked_by_river": "Nyakagunga Primary and Secondary School (Community 1,2)",
  //       "health_access_blocked_by_river": "Nyagasambu Health Center (Community 1,2)",
  //       "other_access_blocked_by_river": "Kigali, Nyakagunga Cell Office and Fumbwe Sector Office (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "4 people were seriously injured and one died on this crossing point.",
  //       "notes_on_social_information": "Kirehe, Rugarama and Cyarutabana villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Nyakagunga Cell Leader, Janvier Niyongiriye, from the data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "NR4 (Kigali-Rwamagana)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 1,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef884AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibaza",
  //       "bridge_opportunity_project_code": "1014540",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.86879,
  //       "bridge_opportunity_gps_longitude": 30.28184,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2834,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.86879,
  //       "proposed_bridge_location_gps_longitude": 30.28184,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "No floods",
  //       "market_access_blocked_by_river": "Nyagasambu and Ntunga markets (Community 4,5), Gatare market (Community 1,2,3), Farms (Community 1,3,4)",
  //       "education_access_blocked_by_river": "Janjagiro Primary and Secondary School (Community 1,3)",
  //       "health_access_blocked_by_river": "Nyagasambu Health Center (4,5)",
  //       "other_access_blocked_by_river": "Gicumbi town, Janjagiro Catholic Church (Community 1,2,3), Kigali, Nyagasambu Catholic Church, Kibaza Anglican and ADEPR Churches (Community 4,5)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kibaza, Kirehe, Rugarama, Kagarama and Gatare villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Nyakagunga Cell Leader, Janvier Niyongiriye, from the data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "NR4 (Kigali-Rwamagana)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef889AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rususa",
  //       "bridge_opportunity_project_code": "1014541",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.01494,
  //       "bridge_opportunity_gps_longitude": 30.2304,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4600,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.01494,
  //       "proposed_bridge_location_gps_longitude": 30.2304,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 2 days",
  //       "market_access_blocked_by_river": "Ayabaraya market (Community 1,2), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Ayabaraya Primary and Secondary School (Community 1,2)",
  //       "health_access_blocked_by_river": "Masaka Hospital (Community 1,2)",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rususa (Nyakariro), Rususa (Masaka) and Gishore villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Gishore Cell Leader, Felicité Musanayo, from the data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "NR4 (Kigali-Rwamagana)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef88JAAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabere",
  //       "bridge_opportunity_project_code": "1014543",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.04377,
  //       "bridge_opportunity_gps_longitude": 30.29442,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1395,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.26",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.04377,
  //       "proposed_bridge_location_gps_longitude": 30.29442,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 14,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 60min",
  //       "market_access_blocked_by_river": "Nzige market (Community 1,2), Kabuga and Karenge markets (Community 3,4), Farms (Community 1,2,3,4)",
  //       "education_access_blocked_by_river": "Rugarama Primary and Secondary School (Community 1,2), Muhumbwe Primary and Secondary School (Community 3,4)",
  //       "health_access_blocked_by_river": "Nzige Health Center (Community 1,2), Nyakariro Health Center (Community 3,4)",
  //       "other_access_blocked_by_river": "Nzige Catholic, ADEPR and Methodist churches (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "banana plantation, bean, cassava, maiz, potato, tomato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Kabere, Kanyangese, Ruvomo (Nzige Sector) and Ruvomo (Muyumbu Sector)villages were included in Individuals Directly Served, because their community members use the crossing point to go to markets, schools, health centers, churches and farms. The population information for each village was provided by the Bihembe Cell Leader, Jean Paul, from the data collected in 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "NR4 (Kigali-Rwamagana)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.6,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000ef88sAAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kamabuye",
  //       "bridge_opportunity_project_code": "1014550",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.989435,
  //       "bridge_opportunity_gps_longitude": 30.055679,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2195,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Pre-Assessment - 2018.11.29",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.989435,
  //       "proposed_bridge_location_gps_longitude": 30.055679,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Three hours",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Land manager of Kigarama",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigale",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "They need vehicular bridge",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 13,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEeNAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gihene",
  //       "bridge_opportunity_project_code": "1014551",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.995001,
  //       "bridge_opportunity_gps_longitude": 30.061769,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10131,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.995001,
  //       "proposed_bridge_location_gps_longitude": 30.061769,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded",
  //       "market_access_blocked_by_river": "Nyamirambo Market( Nyenyeri of part) Gikondo Market (part of Nyenyeri and part of Nyarurama cell)",
  //       "education_access_blocked_by_river": "Kimisange primary and secondary school (one part of Nyenyeri and part of Nyarurama cell)",
  //       "health_access_blocked_by_river": "Post health center of Kimisange (one part of Nyenyeri and part of Nyarurama cell)",
  //       "other_access_blocked_by_river": "Fetching water (one part of Nyenyeri), kigarama sector office (one part of Nyenyeri and part of Nyarurama cell)",
  //       "primary_occupations": "Market, job, school, ..",
  //       "primary_crops_grown": "bean",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "He was tried to cross the bridge and felt in to channel and found died",
  //       "notes_on_social_information": "Land manager of Kigarama sector",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamirambo Kigarama",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 31,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEeXAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gikombe",
  //       "bridge_opportunity_project_code": "1014552",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -2.003541,
  //       "bridge_opportunity_gps_longitude": 30.055354,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1162,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.003541,
  //       "proposed_bridge_location_gps_longitude": 30.055354,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "It doesn't flooded but it is deepest channel",
  //       "market_access_blocked_by_river": "Kimisange Market, Miduga business center ( Nyarufuzo side of Rubete)",
  //       "education_access_blocked_by_river": "Kimisange secondary school (Nyarufuzo side of Rubete)",
  //       "health_access_blocked_by_river": "Butamwa Health center (iRebero)",
  //       "other_access_blocked_by_river": "Fetching water (Nyarufuzo side of Rubete)",
  //       "primary_occupations": "Farms, Market, health center, fetching water",
  //       "primary_crops_grown": "banana plantain, bean",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Land manager",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Nyamirambo to Kigarama",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEehAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Amajyambere",
  //       "bridge_opportunity_project_code": "1014553",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.970697,
  //       "bridge_opportunity_gps_longitude": 30.067016,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4348,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.970697,
  //       "proposed_bridge_location_gps_longitude": 30.067016,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away",
  //       "days_per_year_river_is_flooded": 30,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Biryogo Market, Nyarugenge Market (Imena and twishorezo) Gikondo Market and segem business center (Agatare cell)",
  //       "education_access_blocked_by_river": "Rwampara primary school, nursery of agatare (Imena and twishorezo) , Bwerankori primary school (Amajyambere)",
  //       "health_access_blocked_by_river": "Health center Nyiranuma and Gitega (Imena and twishorezo)",
  //       "other_access_blocked_by_river": "Foot ball terrain (Imena and twishorezo)",
  //       "primary_occupations": "School, health center, market,...",
  //       "primary_crops_grown": "maiz, soja",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Amajyambere village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Biryogo -Kiyovu",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEemAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Urugwiro",
  //       "bridge_opportunity_project_code": "1014557",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.06377,
  //       "bridge_opportunity_gps_longitude": 30.40876,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9967,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06377,
  //       "proposed_bridge_location_gps_longitude": 30.40876,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "No flood",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Mubuga village is the one who provided information about directly individual served by refering to the population census 2018",
  //       "cell_service_quality": "Nonexistent",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Rwamagana - Kayonza",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "It's A small channel which needs a vehicle bridge and people & local authorities wants a vehicle bridge to be constructed",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEf6AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu",
  //       "bridge_opportunity_project_code": "1014558",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.04879,
  //       "bridge_opportunity_gps_longitude": 30.42496,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9967,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.04879,
  //       "proposed_bridge_location_gps_longitude": 30.42496,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "No flood",
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Mubuga village leader was there to provide information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Rwamagana- Kayonza",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Only Vehicle bridge is needed as the car passing carrying sand from mabare",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfBAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kijyambere",
  //       "bridge_opportunity_project_code": "1014559",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.04417,
  //       "bridge_opportunity_gps_longitude": 30.42529,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10017,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.04417,
  //       "proposed_bridge_location_gps_longitude": 30.42529,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 224,
  //       "flood_duration_during_rainy_season": "2 days of flood",
  //       "market_access_blocked_by_river": "Nkungu cell don't have access to Rubona market",
  //       "education_access_blocked_by_river": "Nkungu cell don't have access to GS Rubona",
  //       "health_access_blocked_by_river": "Nkungu cell don't have access to Rubona health center",
  //       "other_access_blocked_by_river": "Nkungu cell don't have access to to Rubona church",
  //       "primary_occupations": "Rice farmers",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One old injured here ,",
  //       "notes_on_social_information": "Mubuga village leader was there to provide information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfGAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gati",
  //       "bridge_opportunity_project_code": "1014560",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.90335,
  //       "bridge_opportunity_gps_longitude": 30.39168,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11983,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.90335,
  //       "proposed_bridge_location_gps_longitude": 30.39168,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Rwamagana - Kigali",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "An existing concrete bridge, and no flood",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfLAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akinteko",
  //       "bridge_opportunity_project_code": "1014561",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Ngoma",
  //       "bridge_opportunity_gps_latitude": -2.10599,
  //       "bridge_opportunity_gps_longitude": 30.37534,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10258,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10599,
  //       "proposed_bridge_location_gps_longitude": 30.37534,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "12 hours of flood",
  //       "market_access_blocked_by_river": "Nyange cell don't have access to kiyovu market, whereas ntaga cell don't have access to Nyange market",
  //       "education_access_blocked_by_river": "Nyange cell don't have access to EP Ntaga , whereas ntaga cell don't have access to ES Nyange",
  //       "health_access_blocked_by_river": "Ntaga cell don't have access to Nyange health center",
  //       "other_access_blocked_by_river": "Ntaga cell don't have access to Nyange church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "One person got injured here ,",
  //       "notes_on_social_information": "Ntaga cell leader and Akinteko village were there to give some information about directly individual served by refering to the population census of 2017",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Ngoma",
  //       "name_of_nearest_paved_or_sealed_road": "Ngoma - Kayonza",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 34,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfQAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nkomangwa",
  //       "bridge_opportunity_project_code": "1014562",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.90335,
  //       "bridge_opportunity_gps_longitude": 30.39168,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 9572,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.90335,
  //       "proposed_bridge_location_gps_longitude": 30.39168,
  //       "current_crossing_method": "Concrete",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 84,
  //       "flood_duration_during_rainy_season": "3 hours of flood",
  //       "market_access_blocked_by_river": "Nkomangwa cell don't have access to Ruhunda market",
  //       "education_access_blocked_by_river": "No education is blocked by the river",
  //       "health_access_blocked_by_river": "Nkomangwa cell don't have access to Ruhunda health center",
  //       "other_access_blocked_by_river": "Nkomangwa cell don't have access to Ruhunda church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "No incident",
  //       "notes_on_social_information": "Gahoshyi village leader is the one who provided information about directly individual served by refering to the population census 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Rwamagana - Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfVAAU",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinosho",
  //       "bridge_opportunity_project_code": "1014563",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.93773,
  //       "bridge_opportunity_gps_longitude": 30.37988,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 10351,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.93773,
  //       "proposed_bridge_location_gps_longitude": 30.37988,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 300,
  //       "flood_duration_during_rainy_season": "5 hours of flood",
  //       "market_access_blocked_by_river": "Bwana cell don't have access to Ntunga market",
  //       "education_access_blocked_by_river": "Cyarukamba cell don't have access to GS Munyiginya",
  //       "health_access_blocked_by_river": "Bwana cell don't have access to Mwurire health center ,Cyarukamba cell don't have access to nkomangwa health center",
  //       "other_access_blocked_by_river": "Cyarukamba cell don't have access to Munyiginya Adventist church",
  //       "primary_occupations": "Farming, steel industry workers",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "2 injuries across this river",
  //       "notes_on_social_information": "Akabuye village leader is the one who provided information about directly individual served by refering to the population census of 2018",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Rwamagana - Kigali",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfaAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kwaroje",
  //       "bridge_opportunity_project_code": "1014564",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.92899,
  //       "bridge_opportunity_gps_longitude": 30.36272,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 11788,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.92899,
  //       "proposed_bridge_location_gps_longitude": 30.36272,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Rwamagana- Kigali",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehicle bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEffAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwampara-Imena",
  //       "bridge_opportunity_project_code": "1014565",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.971782,
  //       "bridge_opportunity_gps_longitude": 30.063077,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3913,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.971782,
  //       "proposed_bridge_location_gps_longitude": 30.063077,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge two kilometer away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Biryogo Market and Nyarugenge Market (Bwerankori special Imena and Twishorezo), Gikondo Market and Segem business center (Rwampara)",
  //       "education_access_blocked_by_river": "Rwampara nusery and primary school , secondary school (Imena and twishorezo),",
  //       "health_access_blocked_by_river": "Nyiranuma and Gitega health center (Imena and twishorezo)",
  //       "other_access_blocked_by_river": "Fetching water (Imena and twishorezo)",
  //       "primary_occupations": "School, health center, job, Market",
  //       "primary_crops_grown": "sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "People who work closer to bridge and Village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamirambo Biryogo Kiyovu",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 61,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfpAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyumbati",
  //       "bridge_opportunity_project_code": "1014566",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Kicukiro",
  //       "bridge_opportunity_gps_latitude": -1.98426,
  //       "bridge_opportunity_gps_longitude": 30.06329,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2110,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.98426,
  //       "proposed_bridge_location_gps_longitude": 30.06329,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "Vehicular bridge one kilometer away",
  //       "days_per_year_river_is_flooded": 0,
  //       "flood_duration_during_rainy_season": "Two hours",
  //       "market_access_blocked_by_river": "Biryogo Market and Sagem business center , Gikondo Market (one part of Kivu)",
  //       "education_access_blocked_by_river": "Primary and secondary school which are on part of Nyarugenge and Rwampara , University of Rwanda Mburabuturo (one part of Kivu)",
  //       "health_access_blocked_by_river": "Health center Gitega and Nyiranuma (one part of Kivu)",
  //       "other_access_blocked_by_river": "Bwerankori cell office (one part of Kivu)",
  //       "primary_occupations": "Job, Market, school, ...",
  //       "primary_crops_grown": "banana plantain",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": "Land manager of Kigarama",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Nyamirambo",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Closer to the fence of house and this last has gate used by car",
  //       "bridge_type": "Other",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfuAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cercle sportif",
  //       "bridge_opportunity_project_code": "1014567",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Nyarugenge",
  //       "bridge_opportunity_gps_latitude": -1.965138,
  //       "bridge_opportunity_gps_longitude": 30.071417,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3045,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "graceumumararungu taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.965138,
  //       "proposed_bridge_location_gps_longitude": 30.071417,
  //       "current_crossing_method": "There are three streams, and one have timber, the one in between have old timber the last they pass through water",
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "One day",
  //       "market_access_blocked_by_river": "Segem business center, Gikondo Market (cercle sportif)",
  //       "education_access_blocked_by_river": "Ape Rugunga primary and secondary, LDK secondary school (Mburabuturo and Bwiza), nusery (cercle sportif)",
  //       "health_access_blocked_by_river": "Gikondo health center (cercle sportif ) Biryogo and Nyiranuma health center (Mburabuturo and Bwiza)",
  //       "other_access_blocked_by_river": "Fetching water (cercle sportif )",
  //       "primary_occupations": "Job, school",
  //       "primary_crops_grown": "sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "None",
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali Kiyovu to Gikondo Bwerankori",
  //       "bridge_classification": "Outside of current engineering scope",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The long span of 158 meter but the bridge is needed",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 158,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEfzAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyirarukobwa",
  //       "bridge_opportunity_project_code": "1014568",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.10574,
  //       "bridge_opportunity_gps_longitude": 30.087112,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 12700,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.10574,
  //       "proposed_bridge_location_gps_longitude": 30.087112,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "10 km",
  //       "days_per_year_river_is_flooded": 105,
  //       "flood_duration_during_rainy_season": "15times in April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Kanzenze cell doesn't have access to Nyamata market",
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Kanzenze cell doesn't have access to Asphalt road",
  //       "primary_occupations": "Farming of sorghum, maize, sweet potatoes",
  //       "primary_crops_grown": "bean, maiz, sorghum, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyamata",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 209,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEkkAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibaza",
  //       "bridge_opportunity_project_code": "1014569",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.335418,
  //       "bridge_opportunity_gps_longitude": 30.05721,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 55,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.335418,
  //       "proposed_bridge_location_gps_longitude": 30.05721,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "There is a vehicular bridge",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEkpAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatovu",
  //       "bridge_opportunity_project_code": "1014570",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.335818,
  //       "bridge_opportunity_gps_longitude": 30.075542,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 7226,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.335818,
  //       "proposed_bridge_location_gps_longitude": 30.075542,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 70,
  //       "flood_duration_during_rainy_season": "10times in April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Kindama cell doesn't have access to Ruhuha market",
  //       "education_access_blocked_by_river": "Kindama cell doesn't have access to Munazi primary school",
  //       "health_access_blocked_by_river": "Kindama cell doesn't have access to Ruhuha health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice farming, beans, maize",
  //       "primary_crops_grown": "bean, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "They are drawn during the rain season in April",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Bugesera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": 0,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEkzAAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gatanga",
  //       "bridge_opportunity_project_code": "1014571",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.32955,
  //       "bridge_opportunity_gps_longitude": 30.056882,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 13804,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.29",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.32955,
  //       "proposed_bridge_location_gps_longitude": 30.056882,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 105,
  //       "flood_duration_during_rainy_season": "15times in April, May, October November and December and it lasts 7days after rainfall",
  //       "market_access_blocked_by_river": "Kindama cell doesn't have access to their farms, Kindama cell doesn't have access to Ruhuha market",
  //       "education_access_blocked_by_river": "Kindama cell doesn't have access to Butereri Primary and Secondary school",
  //       "health_access_blocked_by_river": "Kindama cell doesn't have access to Ruhuha health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Rice farming, beans",
  //       "primary_crops_grown": "bean, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "They are drawn while trying to walk in the current crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Bugesera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 63.8,
  //       "height_differential_between_banks": 1.7,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efEl9AAE",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Irayirayi",
  //       "bridge_opportunity_project_code": "1014594",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.78019,
  //       "bridge_opportunity_gps_longitude": 30.14043,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 19000,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.78019,
  //       "proposed_bridge_location_gps_longitude": 30.14043,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Two month",
  //       "market_access_blocked_by_river": "Gaseke market",
  //       "education_access_blocked_by_river": "Nyagatoma high school",
  //       "health_access_blocked_by_river": "Rwesero health center",
  //       "other_access_blocked_by_river": "Churches at gicumbi",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "sugarcan",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Aman has died in past five years trying to cross when it was flooded",
  //       "notes_on_social_information": "Rutunga sector dont have access to gaseke market and rutare sector don't have access to murindi farms Information gathered from village leader",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHACAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabarebe",
  //       "bridge_opportunity_project_code": "1014595",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.79011,
  //       "bridge_opportunity_gps_longitude": 30.13083,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 14380,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "cesarngenzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.79011,
  //       "proposed_bridge_location_gps_longitude": 30.13083,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": "Three days",
  //       "market_access_blocked_by_river": "Gaseke market and rusine market",
  //       "education_access_blocked_by_river": "Gitambi primary school and rusasa high school",
  //       "health_access_blocked_by_river": "Kajevuba health center",
  //       "other_access_blocked_by_river": "Kajevuba churches",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "sugar can",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "The river is dangerous to cross so people slided and fell",
  //       "notes_on_social_information": "Murindi village dont have access to gaseke market information gathered from cell informant",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-gatuna",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "The community requests avehicular bridge",
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 74,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHAHAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagogo",
  //       "bridge_opportunity_project_code": "1014602",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.758415,
  //       "bridge_opportunity_gps_longitude": 30.255139,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6902,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.758415,
  //       "proposed_bridge_location_gps_longitude": 30.255139,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 61,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Communities 4,5 don't have access to Muhura and Gasange markets , communities 1,2,3 don't have access to Murehe coffee washing station",
  //       "education_access_blocked_by_river": "Communities1,2,3 don't have access to Kagogo primary and secondary school",
  //       "health_access_blocked_by_river": "Communities1,2,3 don't have access to Kagogo health Post, communities 4,5 don't have access to Muhura health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Churches services",
  //       "primary_occupations": "Farmers on both side and traders",
  //       "primary_crops_grown": "bean, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people fell into the river but fortunately none died",
  //       "notes_on_social_information": "Muhura and Gasange markets which are open weekly( community 4,5); Kagogo primary and secondary school ( Community 1,2 3) ; Kagogo health Post ( Community 1,2,3) and Muhura health center ( Community 4,5); Population information for each village was provided by Kimanuka Jean Bosco; cell leader and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 45,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHAvAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Akamabuye",
  //       "bridge_opportunity_project_code": "1014603",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.713697,
  //       "bridge_opportunity_gps_longitude": 30.358427,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2573,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.713697,
  //       "proposed_bridge_location_gps_longitude": 30.358427,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities1,2 don't have access to Gikoma market, communities 3 don't have access to Bugarura market",
  //       "education_access_blocked_by_river": "Communities1,2 don't have access to Gikoma primary and secondary school and communities 3 don't have access to Bugarura primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 3 don't have access to Bugarura health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Churches services",
  //       "primary_occupations": "Farmers in the wetland and traders at Gikoma and Bugarura markets",
  //       "primary_crops_grown": "banana, bean, maiz, potato, sorghum",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gikoma market which is open weekly ( Community 1,2); Bugarura market which is open weekly ( Community 3); Gikoma primary and secondary school ( Community 1,2 ); Bugarura primary and secondary school ( Community 3); Bugarura health center ( Community 3); Farms on both sides . Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHB0AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kagarama2",
  //       "bridge_opportunity_project_code": "1014604",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Gatsibo",
  //       "bridge_opportunity_gps_latitude": -1.719635,
  //       "bridge_opportunity_gps_longitude": 30.366374,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1650,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.719635,
  //       "proposed_bridge_location_gps_longitude": 30.366374,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kayonza",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Vehecular bridge in, planed to be rebuilt by Minagri, and river has been deviated to facilitate construction works",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHB5AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rebero",
  //       "bridge_opportunity_project_code": "1014605",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.893193,
  //       "bridge_opportunity_gps_longitude": 30.280679,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.893193,
  //       "proposed_bridge_location_gps_longitude": 30.280679,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamaga",
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Over this road drainage chanel, there was a small bridge connecting to the main paved road",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHBAAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinunga",
  //       "bridge_opportunity_project_code": "1014606",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.989138,
  //       "bridge_opportunity_gps_longitude": 30.263844,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.989138,
  //       "proposed_bridge_location_gps_longitude": 30.263844,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": 12,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community needs a vehecular bridge, recently truck loaded with stones passed here.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHBFAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karambo",
  //       "bridge_opportunity_project_code": "1014607",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.926646,
  //       "bridge_opportunity_gps_longitude": 30.276659,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3857,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.926646,
  //       "proposed_bridge_location_gps_longitude": 30.276659,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Nyagasambu market, farms on both sides",
  //       "education_access_blocked_by_river": "Communities 1,2,3 ,4 don't have access to Nyagasambu primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Nyagasambu health center",
  //       "other_access_blocked_by_river": "Communities 5 don't have access to Protestants church services",
  //       "primary_occupations": "Farmers on both side and traders",
  //       "primary_crops_grown": "banana, bean, maize vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyagasambu market ( Community 1,2,3,4 ); Nyagasambu primary and secondary school ( 1,2,3,4); Nyagasambu health center ( Community 1,2,3,4); Farms on both sides. Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamaga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHBKAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabarore",
  //       "bridge_opportunity_project_code": "1014608",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.918336,
  //       "bridge_opportunity_gps_longitude": 30.273599,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4096,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.918336,
  //       "proposed_bridge_location_gps_longitude": 30.273599,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 31,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Nyagasambu market, communities don't have access to farms",
  //       "education_access_blocked_by_river": "Communities 1,2,3,4 don't have access to Nyagasambu primary and secondary school",
  //       "health_access_blocked_by_river": "Communities1,2,3,4 don't have access to Nyagasambu health center",
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": "Farmers and traders at Nyagasambu market",
  //       "primary_crops_grown": "banana, bean, maiz, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Nyagasambu market ( Community 1,2,3,4); Farms on Right side of the river ( Community 5); Nyagasambu primary and secondary school ( Community 1,2,3,4); Nyagasambu health center ( Community 1,2,3,4 ) . Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in August 2018",
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHBUAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rusave",
  //       "bridge_opportunity_project_code": "1014609",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.013575,
  //       "bridge_opportunity_gps_longitude": 30.254667,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4522,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.013575,
  //       "proposed_bridge_location_gps_longitude": 30.254667,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 21,
  //       "flood_duration_during_rainy_season": "Never",
  //       "market_access_blocked_by_river": "Communities1,2, don't have access to Kabuga market and communities 3,4,5 don't have access to Murehe market and Rusave coffee washing stations ;",
  //       "education_access_blocked_by_river": "Communities3,4,5 don't have access to Bujyujyu primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2 don't have access to Nyakariro health center",
  //       "other_access_blocked_by_river": "Communities don't have access to Churches services",
  //       "primary_occupations": "Farmers on both side and traders at Kabuga market",
  //       "primary_crops_grown": "banana, bean, coffe, maiz",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 10,
  //       "incident_descriptions": "Peaple and motorcyclists fell in the channel due to its bad condition but fortunately none died",
  //       "notes_on_social_information": "Kabuga market which is open every day ( Community 1,2); Murehe market which is open weekly ( Community 3,4,5); Rusave coffee washing station( community 3,4,5); Bujyujyu primary and secondary school ( Community 3,4,5); Nyakariro health center ( Community 1,2); Kabuga Catholic Parish ( Community 1,2). Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHBZAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rwarugaju",
  //       "bridge_opportunity_project_code": "1014610",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.98212,
  //       "bridge_opportunity_gps_longitude": 30.343604,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 4233,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.98212,
  //       "proposed_bridge_location_gps_longitude": 30.343604,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 43,
  //       "flood_duration_during_rainy_season": "3days",
  //       "market_access_blocked_by_river": "Communities1,2,3 don't have access to Ntunga market and farms",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Mwurire secondary school and communities 4,5 don't have access to Gihumuza primary and secondary school",
  //       "health_access_blocked_by_river": "Communities don't have access to Gahengeri health center and kagezi health Post ( To be constructed soon).",
  //       "other_access_blocked_by_river": "Communities 1,2,3don't have access to Rwamagana district headquarters and Churches services",
  //       "primary_occupations": "Farmers on both side , Traders at Ntunga market",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 6,
  //       "incident_descriptions": "Six people fell into the river but fortunately none died because the river depth is not high",
  //       "notes_on_social_information": "Ntunga market which is open weekly ( Community 1,2,3); Mwurire secondary school ( Community 1,2,3); Gihumuza primary school ( Community 4,5); Gahengeri health center ( Community 4,5); Rwamagana district headquarters and church services ( 1,2,3).",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHBeAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kabonero",
  //       "bridge_opportunity_project_code": "1014611",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.965611,
  //       "bridge_opportunity_gps_longitude": 30.337764,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3209,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.965611,
  //       "proposed_bridge_location_gps_longitude": 30.337764,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 23,
  //       "flood_duration_during_rainy_season": "4 hours",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Ntunga market and farms",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Rusisiro Primary school, communities 4,5 don't have access to Gihumuza primary and secondary school , communities 1,2,3 don't have access to Ntunga nursery school school",
  //       "health_access_blocked_by_river": "Communities 4,5 don't have access to Gahengeri health center and Kagezi health Post ( To be constructed soon)",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to Rwamagana district headquarters and church services",
  //       "primary_occupations": "Farmers on both side and traders at Ntunga market",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 4,
  //       "incident_descriptions": "Four people fell into the river but fortunately none died because the river depth is not deeper",
  //       "notes_on_social_information": "Ntunga market which is open weekly ( community 1,2,3); Ntunga Nursery school, Rusisiro Primary school ( Community 1,2,3); Gihumuza primary and secondary school ( Community 4,5); Gahengeri health center ( Community 4,5); Rwamagana district headquarters and church services. Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 35,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHBoAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyeru",
  //       "bridge_opportunity_project_code": "1014612",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.896111,
  //       "bridge_opportunity_gps_longitude": 30.278146,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 6352,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.896111,
  //       "proposed_bridge_location_gps_longitude": 30.278146,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "1.5 km",
  //       "days_per_year_river_is_flooded": 40,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Communities1,2,3 don't have access to Nyagasambu market and pastures farms , communities 4,5 don't have access to Farms",
  //       "education_access_blocked_by_river": "Communities 1,2,3 don't have access to Nyagasambu and Nyakagungu primary and secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3 don't have access to Nyagasambu health center",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to Churches services",
  //       "primary_occupations": "Farmers on both side and traders at Nyagasambu market",
  //       "primary_crops_grown": "banana, bean, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people fell into the water but fortunately none died, river has a shallow depth",
  //       "notes_on_social_information": "Nyagasambu market ( Community 1,2,3 ); Nyagasambu and Nyakagunga primary and secondary school; Nyagasambu health center ( Community 1,2,3); Farms and Pastures ( Community 4,5); Church services ( Community 1,2,3). Population information for each village was provided by Mukankusi Odette , Runyinya cell leader and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Rwamagana",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 40,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHC3AAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kibobo-Rwingeyo",
  //       "bridge_opportunity_project_code": "1014613",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.864099,
  //       "bridge_opportunity_gps_longitude": 30.23329,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3218,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.864099,
  //       "proposed_bridge_location_gps_longitude": 30.23329,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "1 km",
  //       "days_per_year_river_is_flooded": 124,
  //       "flood_duration_during_rainy_season": "Never",
  //       "market_access_blocked_by_river": "Communities1,2,3 don't have access to Gikomero market, communities 4,5 don't have access to Kibara coffee washing station,",
  //       "education_access_blocked_by_river": "Communities4,5 don't have access to Kibara primary school, communities 1,2,3 don't have access to Gikomero primary and secondary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Communities don't have access to Churches services",
  //       "primary_occupations": "Farmers on both side, suppliers at Kibara coffee washing stations, traders to markets",
  //       "primary_crops_grown": "bean, maiz, sweet potato, vegetabl",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Gikomero market which is open weekly ( Community 1,2,3); Kibara coffee washing stations ( Community 4,5); Gikomero primary and secondary school ( Community 1,2,3); Kibara primary school ( Community 4,5 Population information for each village wasprovided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Ndera",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 55,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHCDAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kajevuba",
  //       "bridge_opportunity_project_code": "1014614",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.84731,
  //       "bridge_opportunity_gps_longitude": 29.99128,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 5983,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.84731,
  //       "proposed_bridge_location_gps_longitude": 29.99128,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "3 hours",
  //       "market_access_blocked_by_river": "Communities 1 ,3 don't have access to Shyorongi market, communities 1 don't have access to to Akabasaza market , communities 2,3 don't have access to Rubingo market, communities 1,3 don't have access to Shyorongi cassetarite mine sites and communities 2,3 don't have access to Rubingo walfram mines.",
  //       "education_access_blocked_by_river": "Communities1 don't have access to Yanza primary school and communities 1,3 don't have access to Shyorongi secondary schools",
  //       "health_access_blocked_by_river": "Communities 2,3 don't have access to Kajevuba health Post, and communities 1,3 don't have access to Shyorongi health center",
  //       "other_access_blocked_by_river": "Communities 2,3 don't have access to Rubingo church, and communities 1,3 don't have access to Shyorongi Catholic Parish",
  //       "primary_occupations": "Farmers on both side, workers in Mines at Rubingo and Shyorongi and traders",
  //       "primary_crops_grown": "banana, bean, flowers plantation, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 15,
  //       "incident_descriptions": "Fifteen people fell into the river but fortunately none died",
  //       "notes_on_social_information": "Shyorongi market which is open twice a week ( Community 1,3); Rubingo market which is open weekly ( Community 2,3 ); Akabahinzi market which is open weekly ( Community 2,3 ); Shyorongi cassetarite mine sites ( Community 1,3 ); Rubingo mines( community 2,3) ; Shyorongi secondary school( community 1,3) ; Yanza primary school and Ngoma secondary schools ( Community 1); Kajevuba health Post ( Community 2,3); Shyorongi health center ( Community 1,3); Nkusi protestant church ( Community 2,3 ) and Shyorongi Catholic Parish. Population information for each village was provided by the village leader of each village respectively and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Musanze",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHCIAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Marembo",
  //       "bridge_opportunity_project_code": "1014616",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -1.970761,
  //       "bridge_opportunity_gps_longitude": 30.232989,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 3815,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.970761,
  //       "proposed_bridge_location_gps_longitude": 30.232989,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "4 km",
  //       "days_per_year_river_is_flooded": 37,
  //       "flood_duration_during_rainy_season": "6 hours",
  //       "market_access_blocked_by_river": "Communities don't have access to Kabuga market and Rice farms",
  //       "education_access_blocked_by_river": "Communities don't have access to Kabuga [primary and secondary school",
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": "Communities don't have access to Kabuga Catholic Parish",
  //       "primary_occupations": "Rice Farmers and traders at Kabuga market",
  //       "primary_crops_grown": "bean, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": "Two people were injured when trying to cross the river, fortunately none died",
  //       "notes_on_social_information": "Kabuga market ( Nyarukombe cell ); Rice farms, ; Kabuga primary and secondary school ( Nyarukombe cell ) Kabuga Parish ( Nyarukombe cell ). Population information for each village was provided by the Cell leader, Nikuze Sandrine and population information was sourced from village census data collected in September 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Year Round",
  //       "name_of_nearest_city": "Kabuga",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Rwamagana",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 54,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHCcAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gahosha",
  //       "bridge_opportunity_project_code": "1014618",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.248912,
  //       "bridge_opportunity_gps_longitude": 30.019451,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 550,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.248912,
  //       "proposed_bridge_location_gps_longitude": 30.019451,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "Yes",
  //       "rejection_reason": "Community need a vehicular bridge.",
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHHSAA2",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Kinteko",
  //       "bridge_opportunity_project_code": "1014619",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Bugesera",
  //       "bridge_opportunity_gps_latitude": -2.261622,
  //       "bridge_opportunity_gps_longitude": 29.988408,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 1885,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.11.30",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.261622,
  //       "proposed_bridge_location_gps_longitude": 29.988408,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 32,
  //       "flood_duration_during_rainy_season": "April, May , September to December, 48 hours",
  //       "market_access_blocked_by_river": "Ruhuha market ( 1,2), Rutare market ( 1,2), farms ( 1,2,3).",
  //       "education_access_blocked_by_river": "Rwamanyoni primary school( 1,2), Gihinga secondary school ( 1,2).",
  //       "health_access_blocked_by_river": "Gihinga health center ( 1,2).",
  //       "other_access_blocked_by_river": "Cell office ( 1,2), kabagugu churches ( 1,2), potable water ( 3,4)",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "bean, gronut, maiz, ric",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "Population information of each village was provided by Kabagugu cell leader , Iyakaremye Jean Pierre who sourced the population information from cell register which was updated in October 2018.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyamata",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamata",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 59,
  //       "height_differential_between_banks": 0.9,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efHIuAAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Rutete",
  //       "bridge_opportunity_project_code": "1014792",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Nyagatare",
  //       "bridge_opportunity_gps_latitude": -1.419195,
  //       "bridge_opportunity_gps_longitude": 30.104228,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2995,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "theodornishimwe taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.419195,
  //       "proposed_bridge_location_gps_longitude": 30.104228,
  //       "current_crossing_method": "Timber Bridge",
  //       "nearest_all_weather_crossing_point": "2 km",
  //       "days_per_year_river_is_flooded": 60,
  //       "flood_duration_during_rainy_season": "1 hour",
  //       "market_access_blocked_by_river": "Communities 1,2,3 don't have access to Rushaki market ,communities on both sides don't have access to their farms",
  //       "education_access_blocked_by_river": "Communities 1,2,3don't have access to Kiyombe primary and Cyondo secondary school",
  //       "health_access_blocked_by_river": "Communities 1,2,3 don't have access to Cyondo Health center and Gataba health Post",
  //       "other_access_blocked_by_river": "Communities 1,2,3 don't have access to Churches services and communities 4,5 don't have access to Potable water",
  //       "primary_occupations": "Farmer, Traders at Rushaki market",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Rushaki market which is open twice a week ( Community 1,2,3); Kiyombe primary and Cyondo secondary school ( Community 1,2,3); Cyondo Health center and Gataba health Post ( Community 1,2,3); Church service ( Community 1,2,3); Potable water ( Community 4,5). Population information for each village was provided by Dusabimana Evarist; Kabungo cell leader and population information was sourced from village census data collected in September 2017",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Nyagatare",
  //       "name_of_nearest_paved_or_sealed_road": "Kigali-Nyagatare",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 38,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efhn7AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Cyerwa",
  //       "bridge_opportunity_project_code": "1014793",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Eastern Province",
  //       "bridge_opportunity_level2_government": "Rwamagana",
  //       "bridge_opportunity_gps_latitude": -2.06596,
  //       "bridge_opportunity_gps_longitude": 30.31733,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 2306,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.12.12",
  //       "form_created_by": "emileritararenga taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.06596,
  //       "proposed_bridge_location_gps_longitude": 30.31733,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "7 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "In March, April and May it last for 3 hours",
  //       "market_access_blocked_by_river": "Karenge market (Community 1,2), Farms (Community 1,2,3)",
  //       "education_access_blocked_by_river": "Karenge",
  //       "health_access_blocked_by_river": "Karenge health center (Community 1,2)",
  //       "other_access_blocked_by_river": "Karenge Sector Office and Karenge Catholic Church (Community 1,2)",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "avocado, banana plantation, bean, cassava, coffe, maiz, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": "Cyerwa, Nyamatete and Nyabugondo villages were included in Individuals Directly Served because their community members use the crossing point to go to markets, health center, churches and farms. The population information for each village was provided by the Nyamatete Cell Leader, Pacific Gatete, Vedaste Habimana, from the population data collected in 2018",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": "NR4 (Kigali-Rwamagana)",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000efho5AAA",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Uwinyana",
  //       "bridge_opportunity_project_code": "1021924",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyaruguru",
  //       "bridge_opportunity_gps_latitude": -2.76129167,
  //       "bridge_opportunity_gps_longitude": 29.47527778,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 112,
  //       "bridge_opportunity_individuals_directly_served": 695,
  //       "bridge_opportunity_comments": "ARK - Rejecting bridge due to worsening upstream landslide with unknown future impact on river or entire stability of right side. Open for selected a new CL and re-prospecting the site.",
  //       "form_form_name": "Project Assessment - 2019.11.26",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": null,
  //       "proposed_bridge_location_gps_longitude": null,
  //       "current_crossing_method": "Fording",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 365,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": 2,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Huhe",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000hv17UQAQ",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Sector 3 bridge",
  //       "bridge_opportunity_project_code": "1022386",
  //       "bridge_opportunity_needs_assessment": null,
  //       "bridge_opportunity_level1_government": "Kigali",
  //       "bridge_opportunity_level2_government": "Gasabo",
  //       "bridge_opportunity_gps_latitude": -1.952646,
  //       "bridge_opportunity_gps_longitude": 30.139628,
  //       "bridge_opportunity_bridge_type": null,
  //       "bridge_opportunity_span_m": null,
  //       "bridge_opportunity_individuals_directly_served": 500,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2019.12.23",
  //       "form_created_by": "solangeyandereye taroworks",
  //       "proposed_bridge_location_gps_latitude": -1.952646,
  //       "proposed_bridge_location_gps_longitude": 30.139628,
  //       "current_crossing_method": null,
  //       "nearest_all_weather_crossing_point": null,
  //       "days_per_year_river_is_flooded": null,
  //       "flood_duration_during_rainy_season": null,
  //       "market_access_blocked_by_river": null,
  //       "education_access_blocked_by_river": null,
  //       "health_access_blocked_by_river": null,
  //       "other_access_blocked_by_river": null,
  //       "primary_occupations": null,
  //       "primary_crops_grown": null,
  //       "river_crossing_deaths_in_last_3_years": null,
  //       "river_crossing_injuries_in_last_3_years": null,
  //       "incident_descriptions": null,
  //       "notes_on_social_information": null,
  //       "cell_service_quality": null,
  //       "four_wd _accessibility": null,
  //       "name_of_nearest_city": "Kigali",
  //       "name_of_nearest_paved_or_sealed_road": null,
  //       "bridge_classification": null,
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": null,
  //       "estimated_span_m": null,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "0063Z00000hwQZ7QAM",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Karama",
  //       "bridge_opportunity_project_code": "1007400",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.07322294,
  //       "bridge_opportunity_gps_longitude": 29.71500053,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 52,
  //       "bridge_opportunity_individuals_directly_served": 1820,
  //       "bridge_opportunity_comments": "500-1000 people directly served, Elevation:1741m, Cell:Nganzo-Kanyinya, Injuries/Death-No person injured while trying to cross the river./ No person died while try to cross the river. Cross river on a normal day-50-150 people, Nearby city centers--Muhanga, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-1-3 months / Hagati y?ukwezi natatu,Travel to nearest safe bridge/river crossing-1-2 hours / Hagati y?isaha 1 n?amasaha 2,Hours walking to reach the Hospital-2-6 hours,Hours walking to reach the Health Center-0.5-1 hours,Hours of walking to reach the market-1-2 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 6m.-The proposed bridge span is approximately 30m.-The level difference between two banks is 0.02m.-The space for foundation is sufficient-The free board between the lowest point of the proposed bridge and the highest flood level is not sufficient-There is no confluence area near the place.-The river bed at the site is not stable, there is a possibility of erosion.-The river bank of the site is showing a sign of erosion and it is located between flat areas-The soil from the site is silt for both sides.",
  //       "form_form_name": "Project Assessment - 2018.8.10",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.07322294,
  //       "proposed_bridge_location_gps_longitude": 29.71500053,
  //       "current_crossing_method": "Timber",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 1,
  //       "flood_duration_during_rainy_season": "1 day",
  //       "market_access_blocked_by_river": "Muhanga Market",
  //       "education_access_blocked_by_river": "Muhazi primary school",
  //       "health_access_blocked_by_river": "Mata health center",
  //       "other_access_blocked_by_river": "Muhanga sector",
  //       "primary_occupations": "Agriculture",
  //       "primary_crops_grown": "cassava, coffe",
  //       "river_crossing_deaths_in_last_3_years": 2,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Two persons died while crossing",
  //       "notes_on_social_information": "This bridge is between two village and all people within those villages are not using this bridges",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": null,
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000a86E0AAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mutiwingoma",
  //       "bridge_opportunity_project_code": "1007481",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Nyamagabe",
  //       "bridge_opportunity_gps_latitude": -2.363733,
  //       "bridge_opportunity_gps_longitude": 29.55353,
  //       "bridge_opportunity_bridge_type": "Suspension Bridge",
  //       "bridge_opportunity_span_m": 120,
  //       "bridge_opportunity_individuals_directly_served": 2601,
  //       "bridge_opportunity_comments": "3000-6000 people directly served, Elevation:1556m, Cell:Mutiwingoma-Mukongoro, Injuries/Death--Many peoples were injured while trying to cross/ -4peoples died while trying to cross Cross river on a normal day-300-600 people, Nearby city centers--Cyeru -Gatwa, Crossing River now-Simple timber bridge / hari uduti, Impossible/Dangerous to cross the river-6-9 months / Hagati y?amezi atandatu n?icyenda,Travel to nearest safe bridge/river crossing->3 hours / Hejuru y?amasaha 3,Hours walking to reach the Hospital->6 hours,Hours walking to reach the Health Center-1-2 hours,Hours of walking to reach the market-0.5-1 hours,Hours walking to reach Primary School-0.5 hours,Hours walking to reach Secondary School-0.5-1 hours,Hours walking to reach the Church-0.5 hours,Land within 50m of river bank-flat (flood plain) / ikibaya,Soil-Silt,Sand-Available / birahaboneka,Gravel-Not available on site, but local government can provide/ Ntibihaboneka ariko inzego z?ubuyobozi zabitanga,Stone-Available / birahaboneka,Timber-Available / birahaboneka,Stone provided by-Sector/ umurenge,Sand Provided by-Sector/ umurenge,Gravel provided by-District/ Akarere,Timber provided by-District/ Akarere,Cement provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Reinforcement steel provided by-Can not be provided at the time / Ntaruhare rwamenyekana muri aka kanya.,Land ownership-Government of Rwanda / Guverinoma y? u RwandaPrivate landowner/ Umuturage, Land ownership permission-Yes / Yego, General Comments-The proposed bridge location is near the traditional crossing point at a distance of approximately 10m.-The proposed bridge span is approximately 45m.-The level difference between two banks is 7m.-The space for foundation is not sufficient for one side and sufficient for the other side.-The free board between the lowest point of the proposed bridge and the highest flood level is sufficient-There is no confluence area near the place.-The river bed at the site is stable, there is no possibility of erosion.-The river bank of the site is not showing any sign of erosion and it is located between a hill and a flood area.-The soil from the site is silt for one side and a rock for the other side. The district suggested to have MUTIWINGOMA replacing Kanserege that's why this project is moved to B2P FY20. Done by Etienne.",
  //       "form_form_name": "Project Assessment - 2018.9.4",
  //       "form_created_by": "dominiquehabimana taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.364085,
  //       "proposed_bridge_location_gps_longitude": 29.553359,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "5 km",
  //       "days_per_year_river_is_flooded": 90,
  //       "flood_duration_during_rainy_season": "April to May, September to November, 5 hours after rain they can cross",
  //       "market_access_blocked_by_river": "Miko market (villages 1,2,3), kaduha market (villages 4,5), roof tile factory(villlages4,5)",
  //       "education_access_blocked_by_river": "Mutiwingoma primary school and 0'level secondary school (villages 1,2,3)",
  //       "health_access_blocked_by_river": "Kaduha Health center and hospital (villages 4,5)",
  //       "other_access_blocked_by_river": "District officials services (villages 1,2 3)",
  //       "primary_occupations": "Farming, roof tile making",
  //       "primary_crops_grown": "bean, maiz, sorghum, sweet potato, tre",
  //       "river_crossing_deaths_in_last_3_years": 3,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "Fell down and drowned",
  //       "notes_on_social_information": "The population information of each village was provided by nyabisindu cell leader, Chantal Mujawamariya who sourced the population from the cell record in 2015.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Nyanza",
  //       "name_of_nearest_paved_or_sealed_road": "Nyamagabe",
  //       "bridge_classification": "Requires additional engineering",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 115,
  //       "height_differential_between_banks": 0.3,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157715087907948",
  //       "bridge_opportunity_casesafeid": "006f100000a86FJAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Ngoma",
  //       "bridge_opportunity_project_code": "1012951",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Southern Province",
  //       "bridge_opportunity_level2_government": "Muhanga",
  //       "bridge_opportunity_gps_latitude": -2.04935967,
  //       "bridge_opportunity_gps_longitude": 29.70709763,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 135,
  //       "bridge_opportunity_individuals_directly_served": 3542,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.8.25",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.04935967,
  //       "proposed_bridge_location_gps_longitude": 29.70709763,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 35,
  //       "flood_duration_during_rainy_season": "Floods takes 7 hours",
  //       "market_access_blocked_by_river": "Muhanga and Rutaka market",
  //       "education_access_blocked_by_river": "Rutaka ps",
  //       "health_access_blocked_by_river": "Mata health center , gikomero health center",
  //       "other_access_blocked_by_river": "Muhanga district office",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 5,
  //       "incident_descriptions": "No death",
  //       "notes_on_social_information": "Rutaka( Cyurutare village ), Mata health center ( Mataba Village, Kanyungura village ), Rutaka ps( Mataba Village). The census 2018 is the last census to which village leader obtained the information of individual served.",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Muhanga",
  //       "name_of_nearest_paved_or_sealed_road": "Ngororero-Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 60,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": null,
  //       "bridge_opportunity_casesafeid": "006f100000d6wBoAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyabikeri",
  //       "bridge_opportunity_project_code": "1014031",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.209275,
  //       "bridge_opportunity_gps_longitude": 29.47145,
  //       "bridge_opportunity_bridge_type": "Other",
  //       "bridge_opportunity_span_m": 90,
  //       "bridge_opportunity_individuals_directly_served": 4001,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "aimablengirabakunzi taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.20900667,
  //       "proposed_bridge_location_gps_longitude": 29.47158,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "700 m",
  //       "days_per_year_river_is_flooded": 50,
  //       "flood_duration_during_rainy_season": "50times in April, May, October November and December and it lasts 1hour after rainfall",
  //       "market_access_blocked_by_river": "Gahororo, Musongati, Kibingo villages don't have access to Ruganda market Nyabikeri, Muciro villages don't have access to Gasenyi market",
  //       "education_access_blocked_by_river": "Gahororo, Musongati, Kibingo villages don't have access to Nyabikeri primary and secondary schools",
  //       "health_access_blocked_by_river": "Gahororo, Musongati, Kibingo villages don't have access to Biguhu health center",
  //       "other_access_blocked_by_river": "Cell office",
  //       "primary_occupations": "Farming of sweet potatoes, cassava, beans, maize",
  //       "primary_crops_grown": "bean, cassava, maiz, sweet potato",
  //       "river_crossing_deaths_in_last_3_years": 0,
  //       "river_crossing_injuries_in_last_3_years": 1,
  //       "incident_descriptions": "He drawn while trying to walk in the river for crossing",
  //       "notes_on_social_information": "The social survey information were given by the local people and their leaders based on the monthly census which is done in every cell",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Seasonally",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi-Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 50.8,
  //       "height_differential_between_banks": 0.2,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157715367918771",
  //       "bridge_opportunity_casesafeid": "006f100000d1fMsAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Mugonero",
  //       "bridge_opportunity_project_code": "1014056",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.14763,
  //       "bridge_opportunity_gps_longitude": 29.34468,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 104,
  //       "bridge_opportunity_individuals_directly_served": 540,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.14763,
  //       "proposed_bridge_location_gps_longitude": 29.34468,
  //       "current_crossing_method": "None",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 280,
  //       "flood_duration_during_rainy_season": "5 days of flood , this kiraro is very dangerous",
  //       "market_access_blocked_by_river": "Rwankuba sector population don't have acess to Mubuga market, whereas Mubuga sector ,twumba sector ,Gishyita sector population don't have acess to Kiziba refugees camp market",
  //       "education_access_blocked_by_river": "Mubuga sector ,twumba sector ,Gishyita sector population don't have acess to GS Rubazo",
  //       "health_access_blocked_by_river": "Mubuga sector ,twumba sector ,Gishyita sector population don't have acess to Rubazo health center and Kiziba refugees camp health center",
  //       "other_access_blocked_by_river": "Mubuga sector ,twumba sector ,Gishyita sector population don't have acess to ADEPR Rubazo",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, bean, maiz",
  //       "river_crossing_deaths_in_last_3_years": 20,
  //       "river_crossing_injuries_in_last_3_years": 30,
  //       "incident_descriptions": "Many people died across this kiraro river , numbers are not accurate but , so many people died",
  //       "notes_on_social_information": "Rubumba cell leader provided all info about individual served by refering to population census of 2018 , and he also called other village leaders to confirm their population who are crossing the bridge in different activities.",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspension",
  //       "estimated_span_m": 80,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157715212285868",
  //       "bridge_opportunity_casesafeid": "006f100000d1fPrAAI",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Gasharu",
  //       "bridge_opportunity_project_code": "1014069",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.13333,
  //       "bridge_opportunity_gps_longitude": 29.3625,
  //       "bridge_opportunity_bridge_type": "Suspended Bridge",
  //       "bridge_opportunity_span_m": 46,
  //       "bridge_opportunity_individuals_directly_served": 3021,
  //       "bridge_opportunity_comments": null,
  //       "form_form_name": "Project Assessment - 2018.10.28",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.13333,
  //       "proposed_bridge_location_gps_longitude": 29.3625,
  //       "current_crossing_method": "None , people here are crossing the river by jumping on rocks and Stones",
  //       "nearest_all_weather_crossing_point": "None",
  //       "days_per_year_river_is_flooded": 270,
  //       "flood_duration_during_rainy_season": "1 day of flood",
  //       "market_access_blocked_by_river": "Wingwa village & Kigogwe village &Karambo village &bucyurabuhoro village don't have access to Kiziba refugees champ market",
  //       "education_access_blocked_by_river": "Gasharu village people and some people from Kiziba refugees camp don't have access to GS Rubazo and GS Kiziba",
  //       "health_access_blocked_by_river": "Wingwa village & Kigogwe village &Karambo village &bucyurabuhoro village don't have access to Kiziba refugees camp health center",
  //       "other_access_blocked_by_river": "Wingwa village & Kigogwe village &Karambo village &bucyurabuhoro village don't have access to Kiziba refugees camp church",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, potato",
  //       "river_crossing_deaths_in_last_3_years": 1,
  //       "river_crossing_injuries_in_last_3_years": 0,
  //       "incident_descriptions": "A cow died to this river , people get scared of the river, they are not crossing during heavy rain season",
  //       "notes_on_social_information": "Gasharu village provided info about directly individual served by calling other village leaders on phone to confirm their population, they referred to 2108 population census",
  //       "cell_service_quality": "Fair",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi- Muhanga",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 32,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157715287763796",
  //       "bridge_opportunity_casesafeid": "006f100000d1fTFAAY",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     },
  //     {
  //       "bridge_name": "Nyakabande-Bitaba",
  //       "bridge_opportunity_project_code": "1015561",
  //       "bridge_opportunity_needs_assessment": "Rwanda Needs Assessment 2018",
  //       "bridge_opportunity_level1_government": "Western Province",
  //       "bridge_opportunity_level2_government": "Karongi",
  //       "bridge_opportunity_gps_latitude": -2.109525,
  //       "bridge_opportunity_gps_longitude": 29.314058,
  //       "bridge_opportunity_bridge_type": "Other",
  //       "bridge_opportunity_span_m": 97,
  //       "bridge_opportunity_individuals_directly_served": 1945,
  //       "bridge_opportunity_comments": "Was a duplicate site (specifically, an alternative centerline) of Nyakabande - 1013866. Records merged in Salesforce on May 20, 2020. Project originally confirmed by Hannis Whittam on February 21, 2020.",
  //       "form_form_name": "Project Assessment - 2018.10.14",
  //       "form_created_by": "edouardumwanzuro taroworks",
  //       "proposed_bridge_location_gps_latitude": -2.11713,
  //       "proposed_bridge_location_gps_longitude": 29.31672,
  //       "current_crossing_method": "None , people jump on stones to cross",
  //       "nearest_all_weather_crossing_point": "No point",
  //       "days_per_year_river_is_flooded": 240,
  //       "flood_duration_during_rainy_season": "4 hours of flood",
  //       "market_access_blocked_by_river": "Nyakabande village , kigabiro village , and Nyabikenke village don't have access to Mubuga market",
  //       "education_access_blocked_by_river": "Nyakabande village , kigabiro village , and Nyabikenke village don't have access to GS Kinama",
  //       "health_access_blocked_by_river": "Nyakabande village , kigabiro village , and Nyabikenke village don't have access to Mubuga health center",
  //       "other_access_blocked_by_river": "Nyakabande village , kigabiro village , and Nyabikenke village don't have access to Mubuga Catholic church & Mubuga sector office HQ , whereas Bikenke village, rwamiko village, murangara village don't have access to public water source & EAR Gataka",
  //       "primary_occupations": "Farming",
  //       "primary_crops_grown": "banana, cassava, potato",
  //       "river_crossing_deaths_in_last_3_years": 6,
  //       "river_crossing_injuries_in_last_3_years": 3,
  //       "incident_descriptions": "3 injuries , some people who were crossing , a cow died within this area due to water flood",
  //       "notes_on_social_information": "Nyakabande village leader gave info about directly individual served by referring to 2018 population census",
  //       "cell_service_quality": "Good",
  //       "four_wd _accessibility": "Never",
  //       "name_of_nearest_city": "Karongi",
  //       "name_of_nearest_paved_or_sealed_road": "Karongi - Rusizi",
  //       "bridge_classification": "Standard",
  //       "flag_for_rejection": "No",
  //       "rejection_reason": null,
  //       "bridge_type": "Suspended",
  //       "estimated_span_m": 30,
  //       "height_differential_between_banks": null,
  //       "bridge_opportunity_general_project_photos": "https://www.flickr.com/photos/bridgestoprosperity/albums/72157715612437621",
  //       "bridge_opportunity_casesafeid": "006f100000fHAHXAA4",
  //       "country": "Rwanda",
  //       "good_site": -1
  //     }
];

export default VillagesDummyData;
